/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Array: { input: any; output: any; }
  Date: { input: any; output: any; }
  Double: { input: any; output: any; }
  FileUpload: { input: any; output: any; }
  Filter: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LoginUrl: { input: any; output: any; }
  Media: { input: any; output: any; }
  Number: { input: any; output: any; }
  Object: { input: any; output: any; }
  StringOrIntOrBoolean: { input: any; output: any; }
};

export type AiAutoClose = {
  __typename?: 'AIAutoClose';
  actionMessage?: Maybe<Scalars['String']['output']>;
  waitTimeInSecond: Scalars['Float']['output'];
};

export type AiAutoCloseInput = {
  actionMessage?: InputMaybe<Scalars['String']['input']>;
  waitTimeInSecond: Scalars['Float']['input'];
};

export type AiFollowUp = {
  __typename?: 'AIFollowUp';
  mode?: Maybe<AiFollowUpModeEnum>;
  waitTimeInSecond?: Maybe<Scalars['Float']['output']>;
};

/** What the AI sends after the customer goes quiet, before the auto-close wait starts. */
export type AiFollowUpInput = {
  mode: AiFollowUpModeEnum;
  waitTimeInSecond: Scalars['Float']['input'];
};

export type AiReplyAiHelpedButton = {
  __typename?: 'AIReplyAiHelpedButton';
  action: AiProfileReplyButtonActionEnum;
  actionMessage?: Maybe<Scalars['String']['output']>;
  actionValue?: Maybe<Scalars['String']['output']>;
  addClosingNote?: Maybe<Scalars['Boolean']['output']>;
  addClosingTag?: Maybe<Scalars['Boolean']['output']>;
  buttonTitle: Scalars['String']['output'];
  isButtonEnabled: Scalars['Boolean']['output'];
  sendSurvey?: Maybe<Scalars['String']['output']>;
};

export type AiReplyButton = {
  __typename?: 'AIReplyButton';
  action: AiProfileReplyButtonActionEnum;
  actionMessage?: Maybe<Scalars['String']['output']>;
  actionValue?: Maybe<Scalars['String']['output']>;
  buttonTitle: Scalars['String']['output'];
  isButtonEnabled: Scalars['Boolean']['output'];
};

export type AiReplyButtonAiHelpedInput = {
  action: AiProfileReplyButtonActionEnum;
  actionMessage?: InputMaybe<Scalars['String']['input']>;
  actionValue?: InputMaybe<Scalars['String']['input']>;
  addClosingNote?: InputMaybe<Scalars['Boolean']['input']>;
  addClosingTag?: InputMaybe<Scalars['Boolean']['input']>;
  buttonTitle: Scalars['String']['input'];
  isButtonEnabled: Scalars['Boolean']['input'];
  sendSurvey?: InputMaybe<Scalars['String']['input']>;
};

export type AiReplyButtonInput = {
  action: AiProfileReplyButtonActionEnum;
  actionMessage?: InputMaybe<Scalars['String']['input']>;
  actionValue?: InputMaybe<Scalars['String']['input']>;
  buttonTitle: Scalars['String']['input'];
  isButtonEnabled: Scalars['Boolean']['input'];
};

export type AiReplyButtons = {
  __typename?: 'AIReplyButtons';
  aiHelped?: Maybe<AiReplyAiHelpedButton>;
  humanSupport?: Maybe<AiReplyButton>;
};

export type AiReplyButtonsInput = {
  aiHelped?: InputMaybe<AiReplyButtonAiHelpedInput>;
  humanSupport?: InputMaybe<AiReplyButtonInput>;
};

export type AiReplyNonChatAiHelpedButton = {
  __typename?: 'AIReplyNonChatAiHelpedButton';
  action: AiProfileReplyButtonActionEnum;
  actionValue?: Maybe<Scalars['String']['output']>;
  addClosingNote?: Maybe<Scalars['Boolean']['output']>;
  addClosingTag?: Maybe<Scalars['Boolean']['output']>;
};

export type AiReplyNonChatAiHelpedButtonInput = {
  action: AiProfileReplyButtonActionEnum;
  actionValue?: InputMaybe<Scalars['String']['input']>;
  addClosingNote?: InputMaybe<Scalars['Boolean']['input']>;
  addClosingTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiReplyNonChatButton = {
  __typename?: 'AIReplyNonChatButton';
  action: AiProfileReplyButtonActionEnum;
  actionValue?: Maybe<Scalars['String']['output']>;
};

export type AiReplyNonChatButtonInput = {
  action: AiProfileReplyButtonActionEnum;
  actionValue?: InputMaybe<Scalars['String']['input']>;
};

export type AiReplyNonChatButtons = {
  __typename?: 'AIReplyNonChatButtons';
  aiHelped?: Maybe<AiReplyNonChatAiHelpedButton>;
  humanSupport?: Maybe<AiReplyNonChatButton>;
};

export type AiReplyNonChatButtonsInput = {
  aiHelped?: InputMaybe<AiReplyNonChatAiHelpedButtonInput>;
  humanSupport?: InputMaybe<AiReplyNonChatButtonInput>;
};

export enum AiWorkingHoursEnum {
  AlwaysActive = 'ALWAYS_ACTIVE',
  DuringBusinessHours = 'DURING_BUSINESS_HOURS',
  OutsideBusinessHours = 'OUTSIDE_BUSINESS_HOURS'
}

export enum AckType {
  Answered = 'ANSWERED',
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  Edited = 'EDITED',
  Failed = 'FAILED',
  PlatformConnectionError = 'PLATFORM_CONNECTION_ERROR',
  Read = 'READ',
  Sending = 'SENDING',
  Sent = 'SENT',
  Unread = 'UNREAD'
}

export type Action = {
  __typename?: 'Action';
  _id: Scalars['ID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  channelIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  collectInfo?: Maybe<Array<Maybe<ActionCustomFieldOutput>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customFieldInfo?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  customer: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Array<Maybe<ActionFormDataOutput>>>;
  formDataUrlEncoded?: Maybe<Array<Maybe<ActionFormDataOutput>>>;
  headers: Array<Maybe<ActionHeaderOutput>>;
  instructions?: Maybe<Scalars['String']['output']>;
  method: ActionMethod;
  name: Scalars['String']['output'];
  platformAction?: Maybe<PlatformActionMethodOutput>;
  /**
   * Whether the AI must read the values back and wait for the customer's yes before running this
   * action. Null: decided by the method — GET and GraphQL query bodies run at once, everything else asks.
   */
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  responseMapping?: Maybe<Array<Maybe<ActionResponseMappingOutput>>>;
  type?: Maybe<ActionTypeEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
};

export type ActionCustomField = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCustomFieldOutput = {
  __typename?: 'ActionCustomFieldOutput';
  _id: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * One alternative an action may match. Groups are OR'ed, fields inside a group are AND'ed,
 * so a caller that accepts several unrelated action shapes (e.g. custom GET calls OR the
 * read-only commerce templates) can express it in a single paginated query.
 */
export type ActionFilterInput = {
  method?: InputMaybe<ActionMethod>;
  platformMethods?: InputMaybe<Array<PlatformActionType>>;
  type?: InputMaybe<ActionTypeEnum>;
};

export type ActionFormData = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ActionFormDataOutput = {
  __typename?: 'ActionFormDataOutput';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ActionHeader = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ActionHeaderOutput = {
  __typename?: 'ActionHeaderOutput';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ActionMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type ActionParamInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ActionResponse = {
  __typename?: 'ActionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Action;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActionResponseMapping = {
  fieldId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type ActionResponseMappingOutput = {
  __typename?: 'ActionResponseMappingOutput';
  fieldId: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ActionSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export enum ActionTypeEnum {
  Custom = 'CUSTOM',
  Template = 'TEMPLATE'
}

export type ActionsPaginatedData = {
  __typename?: 'ActionsPaginatedData';
  docs: Array<Maybe<Action>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type ActionsPaginatedResponse = {
  __typename?: 'ActionsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ActionsPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ActivityType {
  ArchiveCustomerPerson = 'ARCHIVE_CUSTOMER_PERSON',
  CreateContact = 'CREATE_CONTACT',
  CreateCustomerPerson = 'CREATE_CUSTOMER_PERSON',
  CreateMultipleCustomerPerson = 'CREATE_MULTIPLE_CUSTOMER_PERSON',
  DeleteContact = 'DELETE_CONTACT',
  DeleteMultipleContact = 'DELETE_MULTIPLE_CONTACT',
  ExportContact = 'EXPORT_CONTACT',
  ImportContact = 'IMPORT_CONTACT',
  LogIn = 'LOG_IN',
  LogOut = 'LOG_OUT',
  ResetPassword = 'RESET_PASSWORD',
  UnarchiveCustomerPerson = 'UNARCHIVE_CUSTOMER_PERSON',
  UpdateContact = 'UPDATE_CONTACT',
  UpdateCustomerPerson = 'UPDATE_CUSTOMER_PERSON'
}

export type AdReferralDataType = {
  __typename?: 'AdReferralDataType';
  adId?: Maybe<Scalars['String']['output']>;
  adReferral?: Maybe<Scalars['ID']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<Scalars['String']['output']>;
  clickedAt?: Maybe<Scalars['Date']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export enum AdReferralPlatform {
  Instagram = 'INSTAGRAM',
  Messenger = 'MESSENGER',
  Whatsapp = 'WHATSAPP'
}

export type AddCouponCodeToCustomerInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  isYearly: Scalars['Boolean']['input'];
};

export type AddFlowBlockInput = {
  channelType?: InputMaybe<FlowMessageChannel>;
  customerId: Scalars['ID']['input'];
  fields?: InputMaybe<Array<InputMaybe<BlockFieldInput>>>;
  fieldsIndex?: InputMaybe<Scalars['Int']['input']>;
  flowBlockTemplateId: Scalars['String']['input'];
  media?: InputMaybe<Scalars['FileUpload']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetNode: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddFlowBlockResponse = {
  __typename?: 'AddFlowBlockResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddOn = {
  __typename?: 'AddOn';
  _id?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type AddOnResponse = {
  __typename?: 'AddOnResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AddOn;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddOnsResponse = {
  __typename?: 'AddOnsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<AddOn>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTagPersonInput = {
  customerId: Scalars['ID']['input'];
  personIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddTrackingDomainInput = {
  customerId: Scalars['ID']['input'];
  hostname: Scalars['String']['input'];
};

export type AdminCampaignLinkRow = {
  __typename?: 'AdminCampaignLinkRow';
  _id: Scalars['ID']['output'];
  clicked: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  destinationUrl?: Maybe<Scalars['String']['output']>;
  links: TrackingLinksStatus;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: CampaignStatusEnum;
  statusReason?: Maybe<CampaignStatusReason>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdminCampaignLinkToggle = {
  __typename?: 'AdminCampaignLinkToggle';
  campaign: AdminCampaignLinkRow;
  paused: Scalars['Boolean']['output'];
};

export type AdminCampaignLinkToggleResponse = {
  __typename?: 'AdminCampaignLinkToggleResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AdminCampaignLinkToggle>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminCampaignLinks = {
  __typename?: 'AdminCampaignLinks';
  campaigns: Array<AdminCampaignLinkRow>;
  customerId: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  links: TrackingLinksStatus;
  pausedCampaigns?: Maybe<Scalars['Int']['output']>;
};

export type AdminCampaignLinksResponse = {
  __typename?: 'AdminCampaignLinksResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AdminCampaignLinks>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminCustomerPaymentData = {
  __typename?: 'AdminCustomerPaymentData';
  customer?: Maybe<Customer>;
  customerPerson?: Maybe<CustomerPerson>;
  latestInvoice?: Maybe<CustomerInvoice>;
};

export enum AdminCustomerPaymentFilter {
  All = 'ALL',
  Customer = 'CUSTOMER',
  InvoiceInfo = 'INVOICE_INFO',
  PaidThisWeek = 'PAID_THIS_WEEK',
  PaidToday = 'PAID_TODAY',
  ProblematicAccounts = 'PROBLEMATIC_ACCOUNTS',
  UpcomingEndDate = 'UPCOMING_END_DATE',
  UpcomingRefreshDate = 'UPCOMING_REFRESH_DATE'
}

export type AdminCustomerPaymentPaginate = {
  __typename?: 'AdminCustomerPaymentPaginate';
  docs: Array<AdminCustomerPaymentData>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type AdminCustomerPaymentPaginatedResponse = {
  __typename?: 'AdminCustomerPaymentPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AdminCustomerPaymentPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminOperatorRun = {
  __typename?: 'AdminOperatorRun';
  cPersonId: Scalars['ID']['output'];
  chatId: Scalars['ID']['output'];
  context?: Maybe<Scalars['JSON']['output']>;
  costUsd: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  customerId: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Float']['output']>;
  engine?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  models: Array<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcomeReason?: Maybe<Scalars['String']['output']>;
  request: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tools: Scalars['JSON']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type AdminOperatorRunHealthInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
};

export type AdminOperatorRunInput = {
  runId: Scalars['ID']['input'];
};

export type AdminOperatorRunsInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type AdminOperatorRunsPage = {
  __typename?: 'AdminOperatorRunsPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<AdminOperatorRun>;
};

export type AdminOperatorRunsResponse = {
  __typename?: 'AdminOperatorRunsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AdminOperatorRunsPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiAnalysis = {
  __typename?: 'AiAnalysis';
  _id: Scalars['ID']['output'];
  analyseType?: Maybe<Scalars['String']['output']>;
  analysedOn?: Maybe<Scalars['String']['output']>;
  cPersonId?: Maybe<Scalars['ID']['output']>;
  callSid?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<Scalars['String']['output']>;
  convId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  sentiment?: Maybe<IAiAnalysisSentiment>;
  summary?: Maybe<Scalars['String']['output']>;
  talkListenRatio?: Maybe<AiAnalysisTalkListenRatio>;
  topics?: Maybe<Array<Maybe<IAiAnalysisTopic>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum AiAnalysisCallAnalysedOn {
  Ended = 'ENDED'
}

export enum AiAnalysisConversationAnalysedOn {
  Closed = 'CLOSED',
  Open = 'OPEN',
  OpenReopen = 'OPEN_REOPEN'
}

export type AiAnalysisResponse = {
  __typename?: 'AiAnalysisResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiAnalysis>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiAnalysisSentimentType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type AiAnalysisSettings = {
  __typename?: 'AiAnalysisSettings';
  _id: Scalars['ID']['output'];
  analyseCall?: Maybe<AnalyseCallSettings>;
  analyseConversation?: Maybe<AnalyseConversationSettings>;
  analyseTicket?: Maybe<AnalyseTicketSettings>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AiAnalysisSettingsInput = {
  analyseCall?: InputMaybe<AnalyseCallSettingsInput>;
  analyseConversation?: InputMaybe<AnalyseConversationSettingsInput>;
  analyseTicket?: InputMaybe<AnalyseTicketSettingsInput>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiAnalysisSettingsResponse = {
  __typename?: 'AiAnalysisSettingsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiAnalysisSettings>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiAnalysisTalkListenRatio = {
  __typename?: 'AiAnalysisTalkListenRatio';
  agentSeconds?: Maybe<Scalars['Int']['output']>;
  customerSeconds?: Maybe<Scalars['Int']['output']>;
  totalSeconds?: Maybe<Scalars['Int']['output']>;
};

export enum AiAnalysisTicketAnalysedOn {
  Created = 'CREATED',
  CreatedReopened = 'CREATED_REOPENED',
  Resolved = 'RESOLVED'
}

export type AiAnswerComplianceViolation = {
  __typename?: 'AiAnswerComplianceViolation';
  code: Scalars['String']['output'];
  surface?: Maybe<Scalars['String']['output']>;
};

export type AiAnswerData = {
  __typename?: 'AiAnswerData';
  actions?: Maybe<AnswerActions>;
  aiAction?: Maybe<Scalars['String']['output']>;
  /** The audit run behind this answer — pass it to listAiMessageSources to show its sources. */
  aiMessageId?: Maybe<Scalars['ID']['output']>;
  aiPersonMemoryId?: Maybe<Scalars['ID']['output']>;
  aiProfileId?: Maybe<Scalars['ID']['output']>;
  /** Which AI role actually answered this turn (a multi-role tenant may switch mid-thread). */
  aiRole?: Maybe<AiRoleEnum>;
  /** AI Test only: the approve button a button channel would show under this answer. */
  commerceApproval?: Maybe<AiTestCommerceApproval>;
  /**
   * AI Test only: the url buttons (checkout, cart) a button channel shows under this answer; the
   * answer text leaves their links out.
   */
  commerceLinks?: Maybe<Array<AiTestCommerceLink>>;
  /** Product options returned by the commerce agent for this test turn. */
  commerceProductCards?: Maybe<Array<AiCommerceProductCard>>;
  content?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  detailedMessage?: Maybe<Scalars['String']['output']>;
  /**
   * AI Test only: the writes this turn reached with actions off. None of them happened; the answer
   * was written as if they had.
   */
  dryRunSkipped?: Maybe<Array<AiTestDryRunSkip>>;
  media?: Maybe<Array<AiAnswerMedia>>;
  noNeedInfoContent?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['ID']['output']>;
  /**
   * Comment turns only: the auto-private-reply Qpien would send alongside (or instead of) the
   * public reply, when the role has sendPrivateReply on. Null when the tenant sends none.
   */
  privateReply?: Maybe<AiPrivateReplyAnswer>;
  /** Why this test turn did not create a customer reply, based on the actual run. */
  responseExplanation?: Maybe<AiTestResponseExplanation>;
  /**
   * What Qpien would do to the conversation for this answer, beyond the reply text — close it,
   * tag it, hand it to a team. Only the AI Test page fills this in; it reports, never acts.
   */
  sideEffects?: Maybe<Array<AiSideEffect>>;
  /** Meaningful actions performed by a Skill outside of the reply text. */
  skillActions?: Maybe<Array<AiTestSkillAction>>;
  summary?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AiAnswerExplanation = {
  __typename?: 'AiAnswerExplanation';
  activeSkill?: Maybe<Scalars['String']['output']>;
  agentAction?: Maybe<Scalars['String']['output']>;
  agentNote?: Maybe<Scalars['String']['output']>;
  complianceViolations: Array<AiAnswerComplianceViolation>;
  confidence?: Maybe<Scalars['String']['output']>;
  dmSent: Scalars['Boolean']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  engineVersion?: Maybe<Scalars['String']['output']>;
  groupedIntoRunId?: Maybe<Scalars['ID']['output']>;
  handedOff: Scalars['Boolean']['output'];
  handoffDisabled: Scalars['Boolean']['output'];
  handoffReason?: Maybe<Scalars['String']['output']>;
  hasCitations: Scalars['Boolean']['output'];
  knowledgeGap?: Maybe<Scalars['String']['output']>;
  knowledgeSearches: Array<AiAnswerKnowledgeSearch>;
  outcome: AiAnswerOutcome;
  reason?: Maybe<AiAnswerReason>;
  role?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  runId?: Maybe<Scalars['ID']['output']>;
  sources: Array<AiMessageSource>;
  suggestions: Array<AiAnswerSuggestionEntry>;
  surface?: Maybe<Scalars['String']['output']>;
};

export type AiAnswerExplanationResponse = {
  __typename?: 'AiAnswerExplanationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiAnswerExplanation>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiAnswerKnowledgeSearch = {
  __typename?: 'AiAnswerKnowledgeSearch';
  hits: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum AiAnswerLengthEnum {
  Concise = 'CONCISE',
  Standard = 'STANDARD',
  Thorough = 'THOROUGH'
}

export type AiAnswerMedia = {
  __typename?: 'AiAnswerMedia';
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum AiAnswerOutcome {
  Answered = 'ANSWERED',
  AnsweredAndHandedOff = 'ANSWERED_AND_HANDED_OFF',
  Failed = 'FAILED',
  HandedOff = 'HANDED_OFF',
  InProgress = 'IN_PROGRESS',
  MarkedSpam = 'MARKED_SPAM',
  NotAnswered = 'NOT_ANSWERED',
  NotRun = 'NOT_RUN',
  Unknown = 'UNKNOWN'
}

export enum AiAnswerReason {
  BudgetExceeded = 'BUDGET_EXCEEDED',
  ClarifyWithheld = 'CLARIFY_WITHHELD',
  CommentDeleted = 'COMMENT_DELETED',
  EmptyReply = 'EMPTY_REPLY',
  HandoffDisabledLine = 'HANDOFF_DISABLED_LINE',
  HandoffRequested = 'HANDOFF_REQUESTED',
  HumanTookOver = 'HUMAN_TOOK_OVER',
  MarketplaceCompliance = 'MARKETPLACE_COMPLIANCE',
  NoEligibleAiRole = 'NO_ELIGIBLE_AI_ROLE',
  NoReplyNeeded = 'NO_REPLY_NEEDED',
  PublicReplyOff = 'PUBLIC_REPLY_OFF',
  QuotaExhausted = 'QUOTA_EXHAUSTED',
  Spam = 'SPAM',
  SpamNotConfigured = 'SPAM_NOT_CONFIGURED',
  Superseded = 'SUPERSEDED',
  SurfaceNotSupported = 'SURFACE_NOT_SUPPORTED',
  UnexpectedError = 'UNEXPECTED_ERROR'
}

export enum AiAnswerSuggestion {
  AddGuidance = 'ADD_GUIDANCE',
  AddKnowledge = 'ADD_KNOWLEDGE',
  AddSpamGuidance = 'ADD_SPAM_GUIDANCE',
  ContactSupport = 'CONTACT_SUPPORT',
  ReplyManually = 'REPLY_MANUALLY',
  ReviewAiProfile = 'REVIEW_AI_PROFILE',
  ReviewAiRoles = 'REVIEW_AI_ROLES',
  ReviewCitedKnowledge = 'REVIEW_CITED_KNOWLEDGE',
  ReviewCommentSettings = 'REVIEW_COMMENT_SETTINGS',
  ReviewGuidance = 'REVIEW_GUIDANCE',
  ReviewKnowledgeSuggestions = 'REVIEW_KNOWLEDGE_SUGGESTIONS',
  ReviewMarketplaceSettings = 'REVIEW_MARKETPLACE_SETTINGS',
  ReviewSkill = 'REVIEW_SKILL',
  TopUpBalance = 'TOP_UP_BALANCE'
}

export type AiAnswerSuggestionEntry = {
  __typename?: 'AiAnswerSuggestionEntry';
  code: AiAnswerSuggestion;
  question?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['ID']['output']>;
};

export enum AiAskQuestionTypeEnum {
  ActionDetection = 'ACTION_DETECTION',
  AgentContext = 'AGENT_CONTEXT',
  AgentModelCall = 'AGENT_MODEL_CALL',
  AgentOutput = 'AGENT_OUTPUT',
  AgentToolCall = 'AGENT_TOOL_CALL',
  AiRoleResolution = 'AI_ROLE_RESOLUTION',
  AiSuggestedMacros = 'AI_SUGGESTED_MACROS',
  AnswerByActionChat = 'ANSWER_BY_ACTION_CHAT',
  AnswerByActionComment = 'ANSWER_BY_ACTION_COMMENT',
  AnswerByActionPrivateReply = 'ANSWER_BY_ACTION_PRIVATE_REPLY',
  AnswerByInstruction = 'ANSWER_BY_INSTRUCTION',
  AnswerByMarketplaceListing = 'ANSWER_BY_MARKETPLACE_LISTING',
  AnswerByRagChat = 'ANSWER_BY_RAG_CHAT',
  AnswerByRagComment = 'ANSWER_BY_RAG_COMMENT',
  AnswerByRagPrivateReply = 'ANSWER_BY_RAG_PRIVATE_REPLY',
  AnswerByRagQuestion = 'ANSWER_BY_RAG_QUESTION',
  AnswerByRagTicket = 'ANSWER_BY_RAG_TICKET',
  AnswerQuestion = 'ANSWER_QUESTION',
  AudioTranscription = 'AUDIO_TRANSCRIPTION',
  AutoClose = 'AUTO_CLOSE',
  BarcodeToText = 'BARCODE_TO_TEXT',
  CheckImagePinecone = 'CHECK_IMAGE_PINECONE',
  CloseConversation = 'CLOSE_CONVERSATION',
  ClosingNote = 'CLOSING_NOTE',
  CommerceAgentRound = 'COMMERCE_AGENT_ROUND',
  CommerceError = 'COMMERCE_ERROR',
  CommerceGuidanceEnforcement = 'COMMERCE_GUIDANCE_ENFORCEMENT',
  CommerceImageProductResolve = 'COMMERCE_IMAGE_PRODUCT_RESOLVE',
  CommerceMarketplaceProductResolve = 'COMMERCE_MARKETPLACE_PRODUCT_RESOLVE',
  CommerceMcpListTools = 'COMMERCE_MCP_LIST_TOOLS',
  CommerceMcpToolCall = 'COMMERCE_MCP_TOOL_CALL',
  CommercePageProductResolve = 'COMMERCE_PAGE_PRODUCT_RESOLVE',
  CommerceProductRerank = 'COMMERCE_PRODUCT_RERANK',
  CommerceSlotExtraction = 'COMMERCE_SLOT_EXTRACTION',
  CommerceWorkflowResume = 'COMMERCE_WORKFLOW_RESUME',
  CommerceWorkflowStart = 'COMMERCE_WORKFLOW_START',
  ContextResolution = 'CONTEXT_RESOLUTION',
  DeliveryGate = 'DELIVERY_GATE',
  EnrichUserQuery = 'ENRICH_USER_QUERY',
  Expand = 'EXPAND',
  FinalizeAiContent = 'FINALIZE_AI_CONTENT',
  FixSpelling = 'FIX_SPELLING',
  FollowUp = 'FOLLOW_UP',
  FuseRagResults = 'FUSE_RAG_RESULTS',
  GetActionsInfo = 'GET_ACTIONS_INFO',
  GetElasticBm25Data = 'GET_ELASTIC_BM25_DATA',
  GetPineconeData = 'GET_PINECONE_DATA',
  GetProductId = 'GET_PRODUCT_ID',
  GetQpienShopOrderDetails = 'GET_QPIEN_SHOP_ORDER_DETAILS',
  GetQpienShopProductDetails = 'GET_QPIEN_SHOP_PRODUCT_DETAILS',
  GuardStage = 'GUARD_STAGE',
  GuidanceSelection = 'GUIDANCE_SELECTION',
  HttpRequest = 'HTTP_REQUEST',
  ImageProductVerify = 'IMAGE_PRODUCT_VERIFY',
  IntentDetectionChat = 'INTENT_DETECTION_CHAT',
  IntentDetectionComment = 'INTENT_DETECTION_COMMENT',
  IntentDetectionPrivateReply = 'INTENT_DETECTION_PRIVATE_REPLY',
  IntentDetectionQuestion = 'INTENT_DETECTION_QUESTION',
  IntentDetectionTicket = 'INTENT_DETECTION_TICKET',
  KnowledgeSearch = 'KNOWLEDGE_SEARCH',
  MakeFormal = 'MAKE_FORMAL',
  MakeFriendly = 'MAKE_FRIENDLY',
  MarketplaceComplianceGate = 'MARKETPLACE_COMPLIANCE_GATE',
  MarketplaceRequest = 'MARKETPLACE_REQUEST',
  PostImageSummary = 'POST_IMAGE_SUMMARY',
  RagV2Fallback = 'RAG_V2_FALLBACK',
  RerankChunks = 'RERANK_CHUNKS',
  RoleSelection = 'ROLE_SELECTION',
  SessionCompaction = 'SESSION_COMPACTION',
  SkillAgent = 'SKILL_AGENT',
  SkillRouting = 'SKILL_ROUTING',
  SummarizeTag = 'SUMMARIZE_TAG',
  SummaryTagAnswerData = 'SUMMARY_TAG_ANSWER_DATA',
  Translate = 'TRANSLATE',
  TurnCoordination = 'TURN_COORDINATION',
  WriteResponse = 'WRITE_RESPONSE'
}

export type AiAssistantMediaInput = {
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type AiAssistantResponse = {
  __typename?: 'AiAssistantResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiAssistantSettings>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiAssistantSettings = {
  __typename?: 'AiAssistantSettings';
  _id: Scalars['ID']['output'];
  aiSuggestedAnswers?: Maybe<Scalars['Boolean']['output']>;
  aiSuggestedMacros?: Maybe<Scalars['Boolean']['output']>;
  answerOnlyFromKnowledgeSources?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  expand?: Maybe<Scalars['Boolean']['output']>;
  fixGrammar?: Maybe<Scalars['Boolean']['output']>;
  inboxAutoTranslate?: Maybe<Scalars['Boolean']['output']>;
  makeFormal?: Maybe<Scalars['Boolean']['output']>;
  makeFriendly?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  translate?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  writeResponse?: Maybe<Scalars['Boolean']['output']>;
};

export type AiAssistantSettingsInput = {
  aiSuggestedAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  aiSuggestedMacros?: InputMaybe<Scalars['Boolean']['input']>;
  answerOnlyFromKnowledgeSources?: InputMaybe<Scalars['Boolean']['input']>;
  expand?: InputMaybe<Scalars['Boolean']['input']>;
  fixGrammar?: InputMaybe<Scalars['Boolean']['input']>;
  inboxAutoTranslate?: InputMaybe<Scalars['Boolean']['input']>;
  makeFormal?: InputMaybe<Scalars['Boolean']['input']>;
  makeFriendly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  translate?: InputMaybe<Scalars['Boolean']['input']>;
  writeResponse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiBankAccount = {
  __typename?: 'AiBankAccount';
  accountHolder: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

export type AiBankAccountInput = {
  accountHolder: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
};

export type AiCommerceProductCard = {
  __typename?: 'AiCommerceProductCard';
  optionsSummary?: Maybe<Scalars['String']['output']>;
  price?: Maybe<AiCommerceProductPrice>;
  productId: Scalars['ID']['output'];
  productUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AiCommerceProductPrice = {
  __typename?: 'AiCommerceProductPrice';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export type AiConnectableStore = {
  __typename?: 'AiConnectableStore';
  _id: Scalars['ID']['output'];
  /** True for the store this role currently shops from. */
  isConnectedToAi: Scalars['Boolean']['output'];
  /** False for an integration qpien-shop-v2 has no adapter for — it cannot back the AI. */
  isSupported: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storeUrl?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AiConnectableStoresResponse = {
  __typename?: 'AiConnectableStoresResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiConnectableStore>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiConversationStatistics = {
  __typename?: 'AiConversationStatistics';
  assignedCount?: Maybe<Scalars['Int']['output']>;
  avgFirstResponseTime?: Maybe<Scalars['Float']['output']>;
  avgResolutionTime?: Maybe<Scalars['Float']['output']>;
  channelId?: Maybe<Scalars['ID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  resolutionCount?: Maybe<Scalars['Int']['output']>;
  totalAssignCount?: Maybe<Scalars['Int']['output']>;
  totalAvgFirstResponseTime?: Maybe<Scalars['Float']['output']>;
  totalAvgResolutionTime?: Maybe<Scalars['Float']['output']>;
  totalMessageCount?: Maybe<Scalars['Int']['output']>;
  totalResolutionCount?: Maybe<Scalars['Int']['output']>;
};

export type AiConversationStatisticsInput = {
  channelGroup?: InputMaybe<ChannelGroup>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type AiConversationStatisticsResult = {
  __typename?: 'AiConversationStatisticsResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<AiConversationStatistics>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiEngineDefault = {
  __typename?: 'AiEngineDefault';
  capability: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AiEngineDefaultInput = {
  capability: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type AiEngineDisabled = {
  __typename?: 'AiEngineDisabled';
  capability: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AiEnginePin = {
  __typename?: 'AiEnginePin';
  /** Null means the pin covers every capability. */
  capability?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type AiEnginePinInput = {
  capability?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type AiEngineRollbackInput = {
  historyIndex: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type AiEngineRouting = {
  __typename?: 'AiEngineRouting';
  defaults: Array<AiEngineDefault>;
  disabled: Array<AiEngineDisabled>;
  history: Array<AiEngineRoutingHistoryEntry>;
  pins: Array<AiEnginePin>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AiEngineRoutingHistoryEntry = {
  __typename?: 'AiEngineRoutingHistoryEntry';
  at: Scalars['String']['output'];
  by: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  snapshot: AiEngineRoutingSnapshot;
};

export type AiEngineRoutingOverview = {
  __typename?: 'AiEngineRoutingOverview';
  capabilities: Array<Scalars['String']['output']>;
  engines: Array<AiEngineSummary>;
  routing: AiEngineRouting;
};

export type AiEngineRoutingResponse = {
  __typename?: 'AiEngineRoutingResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiEngineRoutingOverview>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiEngineRoutingSnapshot = {
  __typename?: 'AiEngineRoutingSnapshot';
  defaults: Array<AiEngineDefault>;
  disabled: Array<AiEngineDisabled>;
  pins: Array<AiEnginePin>;
};

/**
 * Which AI engine version answers whom. Lives in qpien-ai's AiEngineRouting document; api-v2
 * only forwards the admin panel's reads and writes (engine:admin scope).
 */
export type AiEngineSummary = {
  __typename?: 'AiEngineSummary';
  capabilities: Array<Scalars['String']['output']>;
  /** A frozen version is a rollback target: its code no longer changes. */
  frozen: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type AiEngineUnpinInput = {
  capability?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type AiEngineVersionInput = {
  capability: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export enum AiEvalExecutionStatus {
  Failed = 'FAILED',
  NoAiRun = 'NO_AI_RUN',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type AiEvalMessageInput = {
  channelId: Scalars['String']['input'];
  channelPersonId: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  dbDriverId: Scalars['ID']['input'];
  medias?: InputMaybe<Array<MediaInput>>;
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformType: PlatformType;
  questionId: Scalars['ID']['input'];
};

export type AiEvalMessageReceipt = {
  __typename?: 'AiEvalMessageReceipt';
  accepted: Scalars['Boolean']['output'];
  alreadyExists: Scalars['Boolean']['output'];
  questionId: Scalars['ID']['output'];
  status: AiEvalExecutionStatus;
};

export type AiEvalMessageReceiptResponse = {
  __typename?: 'AiEvalMessageReceiptResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiEvalMessageReceipt>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiEvalMessageResult = {
  __typename?: 'AiEvalMessageResult';
  aiMessageId?: Maybe<Scalars['ID']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerId?: Maybe<Scalars['ID']['output']>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  durationMs: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  isTest: Scalars['Boolean']['output'];
  question?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['ID']['output'];
  status: AiEvalExecutionStatus;
  steps: Array<AiMessageSteps>;
};

export type AiEvalMessageResultResponse = {
  __typename?: 'AiEvalMessageResultResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiEvalMessageResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiFollowUpModeEnum {
  AskIfNeedsHelp = 'ASK_IF_NEEDS_HELP',
  None = 'NONE',
  OfferHumanHandoff = 'OFFER_HUMAN_HANDOFF'
}

export type AiGuidance = {
  __typename?: 'AiGuidance';
  _id: Scalars['ID']['output'];
  category: AiGuidanceCategoryEnum;
  channel?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  messageTypes?: Maybe<Array<Maybe<AiGuidanceMessageTypeEnum>>>;
  roles?: Maybe<Array<AiRoleEnum>>;
  status: AiGuidanceStatusEnum;
  title: Scalars['String']['output'];
  toneOfVoice?: Maybe<AiProfileToneOfVoiceEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum AiGuidanceCategoryEnum {
  CommunicationStyle = 'COMMUNICATION_STYLE',
  ContextAndClarification = 'CONTEXT_AND_CLARIFICATION',
  HandoverAndEscalation = 'HANDOVER_AND_ESCALATION',
  Others = 'OTHERS',
  Spam = 'SPAM'
}

export enum AiGuidanceMessageTypeEnum {
  Comment = 'COMMENT',
  PrivateReply = 'PRIVATE_REPLY',
  Question = 'QUESTION'
}

export type AiGuidancePaginatedResponse = {
  __typename?: 'AiGuidancePaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiGuidancePaginatedResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiGuidancePaginatedResult = {
  __typename?: 'AiGuidancePaginatedResult';
  docs?: Maybe<Array<Maybe<AiGuidance>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type AiGuidanceResponse = {
  __typename?: 'AiGuidanceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiGuidance>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiGuidanceStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type AiHelpArticle = {
  __typename?: 'AiHelpArticle';
  _id: Scalars['ID']['output'];
  author?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  chunkCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  faqs: Array<AiHelpFaq>;
  fileName?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  /** Where the Operator's "Evet, git" button opens in the user panel. */
  panelPath?: Maybe<Scalars['String']['output']>;
  /** The user panel RolePermissions panelPath needs, all of them; without one the button is not offered. */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  related?: Maybe<Scalars['String']['output']>;
  sections: Array<AiHelpSection>;
  slug: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceDate?: Maybe<Scalars['String']['output']>;
  /** INDEXING, READY, FAILED or ARCHIVED. */
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  useCount?: Maybe<Scalars['Int']['output']>;
};

export type AiHelpArticleInput = {
  _id: Scalars['ID']['input'];
};

export type AiHelpArticleResponse = {
  __typename?: 'AiHelpArticleResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiHelpArticle>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiHelpArticlesResponse = {
  __typename?: 'AiHelpArticlesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiHelpArticle>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiHelpDeleteResponse = {
  __typename?: 'AiHelpDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiHelpFaq = {
  __typename?: 'AiHelpFaq';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type AiHelpFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type AiHelpGap = {
  __typename?: 'AiHelpGap';
  _id: Scalars['ID']['output'];
  article?: Maybe<Scalars['ID']['output']>;
  cPerson: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  customer: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['String']['output']>;
};

export type AiHelpGapsInput = {
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiHelpGapsResponse = {
  __typename?: 'AiHelpGapsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiHelpGap>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Qpien's own help content, the Operator's how-to source. Lives in qpien-ai (AiHelpArticles); api-v2
 * stores the uploaded PDF and its screenshots and forwards the admin panel's calls.
 */
export type AiHelpImage = {
  __typename?: 'AiHelpImage';
  caption?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AiHelpImportPdfInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  panelPath?: InputMaybe<Scalars['String']['input']>;
  pdf: Scalars['FileUpload']['input'];
};

export type AiHelpResolveGapsInput = {
  articleId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

export type AiHelpResolveGapsResponse = {
  __typename?: 'AiHelpResolveGapsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Writes a new article (slug required) or corrects an existing one (_id); the slug of an existing article never changes. */
export type AiHelpSaveArticleInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  faqs?: InputMaybe<Array<AiHelpFaqInput>>;
  panelPath?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  sections: Array<AiHelpSectionInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AiHelpSearchInput = {
  query: Scalars['String']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AiHelpSearchResponse = {
  __typename?: 'AiHelpSearchResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiHelpSectionHit>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiHelpSection = {
  __typename?: 'AiHelpSection';
  heading: Scalars['String']['output'];
  images: Array<AiHelpImage>;
  key: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type AiHelpSectionHit = {
  __typename?: 'AiHelpSectionHit';
  articleId: Scalars['ID']['output'];
  contentId: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  images: Array<AiHelpImage>;
  panelPath?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  score: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AiHelpSectionInput = {
  heading: Scalars['String']['input'];
  /** An existing section's key keeps its screenshots; a new section has none. */
  key?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type AiHelpUpdateArticleInput = {
  _id: Scalars['ID']['input'];
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  panelPath?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AiKnowledgeScopeEnum {
  General = 'GENERAL',
  ItemSpecific = 'ITEM_SPECIFIC'
}

export enum AiKnowledgeScopeTypeEnum {
  Post = 'POST',
  Product = 'PRODUCT'
}

export type AiKnowledgeSource = {
  __typename?: 'AiKnowledgeSource';
  _id: Scalars['ID']['output'];
  aiProfile: Scalars['ID']['output'];
  answer?: Maybe<Scalars['String']['output']>;
  /** Channel ids this source answers on; empty means every channel. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  chunkNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customer: Scalars['ID']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  isSinglePage?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<AiKnowledgeSourcesSourceTypes>;
  status?: Maybe<AiKnowledgeSourcesStatus>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AiKnowledgeSourceContent = {
  __typename?: 'AiKnowledgeSourceContent';
  _id: Scalars['ID']['output'];
  aiKnowledgeSource: Scalars['ID']['output'];
  aiProfile: Scalars['ID']['output'];
  chunkNumber?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  knowledgeScope?: Maybe<AiKnowledgeScopeEnum>;
  language?: Maybe<Scalars['String']['output']>;
  questionHash?: Maybe<Scalars['String']['output']>;
  scopeRef?: Maybe<Scalars['String']['output']>;
  scopeType?: Maybe<AiKnowledgeScopeTypeEnum>;
  source?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<AiKnowledgeSourcesSourceTypes>;
  status?: Maybe<AiKnowledgeSourcesStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AiKnowledgeSourceContentDeleteResponse = {
  __typename?: 'AiKnowledgeSourceContentDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiKnowledgeSourceContentPaginatedResult = {
  __typename?: 'AiKnowledgeSourceContentPaginatedResult';
  code?: Maybe<Scalars['String']['output']>;
  data: AiKnowledgeSourceContentsResponse;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiKnowledgeSourceContentResponse = {
  __typename?: 'AiKnowledgeSourceContentResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiKnowledgeSourceContent>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiKnowledgeSourceContentsResponse = {
  __typename?: 'AiKnowledgeSourceContentsResponse';
  docs?: Maybe<Array<Maybe<AiKnowledgeSourceContent>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type AiKnowledgeSourceDeleteResponse = {
  __typename?: 'AiKnowledgeSourceDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiKnowledgeSourceFilterConditionInput = {
  field: AiKnowledgeSourceFilterField;
  operator: AiKnowledgeSourceFilterOperator;
  /** Enum names for SOURCE_TYPE / STATUS, user ids for CREATED_BY. An empty list matches nothing out. */
  values: Array<Scalars['String']['input']>;
};

export enum AiKnowledgeSourceFilterField {
  CreatedBy = 'CREATED_BY',
  SourceType = 'SOURCE_TYPE',
  Status = 'STATUS'
}

export type AiKnowledgeSourceFilterInput = {
  conditions: Array<AiKnowledgeSourceFilterConditionInput>;
  join: AiKnowledgeSourceFilterJoin;
};

export enum AiKnowledgeSourceFilterJoin {
  And = 'AND',
  Or = 'OR'
}

export enum AiKnowledgeSourceFilterOperator {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export type AiKnowledgeSourcePaginatedResponse = {
  __typename?: 'AiKnowledgeSourcePaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiKnowledgeSourcePaginatedResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiKnowledgeSourcePaginatedResult = {
  __typename?: 'AiKnowledgeSourcePaginatedResult';
  docs?: Maybe<Array<Maybe<AiKnowledgeSource>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type AiKnowledgeSourceResponse = {
  __typename?: 'AiKnowledgeSourceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AiKnowledgeSource;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiKnowledgeSourcesSourceTypes {
  HumanAgent = 'HUMAN_AGENT',
  Manual = 'MANUAL',
  Pdf = 'PDF',
  Url = 'URL'
}

export enum AiKnowledgeSourcesStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type AiMessageAnswer = {
  __typename?: 'AiMessageAnswer';
  content?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['ID']['output']>;
  messageType?: Maybe<MessageType>;
  productCards?: Maybe<Array<AiMessageAnswerProductCard>>;
};

export type AiMessageAnswerProductCard = {
  __typename?: 'AiMessageAnswerProductCard';
  optionsSummary?: Maybe<Scalars['String']['output']>;
  price?: Maybe<AiMessageAnswerProductCardPrice>;
  productId?: Maybe<Scalars['String']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AiMessageAnswerProductCardPrice = {
  __typename?: 'AiMessageAnswerProductCardPrice';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type AiMessageEventResponse = {
  __typename?: 'AiMessageEventResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiMessages>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiMessageQuestionContext = {
  __typename?: 'AiMessageQuestionContext';
  postImageUrl?: Maybe<Scalars['String']['output']>;
  postUrl?: Maybe<Scalars['String']['output']>;
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productLink?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type AiMessageSource = {
  __typename?: 'AiMessageSource';
  cited?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  group?: Maybe<StepSourceGroup>;
  id: Scalars['ID']['output'];
  knowledgeSourceContentId?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  request?: Maybe<Scalars['JSON']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
  subTopic?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StepType>;
};

export type AiMessageSourcesResponse = {
  __typename?: 'AiMessageSourcesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<AiMessageSource>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiMessageStatusEnum {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export enum AiMessageStepStatusEnum {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type AiMessageSteps = {
  __typename?: 'AiMessageSteps';
  _id: Scalars['ID']['output'];
  aiMessageId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  durationMs: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['JSON']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status: AiMessageStepStatusEnum;
  step?: Maybe<AiAskQuestionTypeEnum>;
  stepList: Scalars['Int']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type AiMessageStepsResponse = {
  __typename?: 'AiMessageStepsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<AiMessageSteps>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiMessageSubscriptionInput = {
  customer?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type AiMessages = {
  __typename?: 'AiMessages';
  _id: Scalars['ID']['output'];
  answer?: Maybe<Scalars['String']['output']>;
  answerId?: Maybe<Scalars['ID']['output']>;
  answers?: Maybe<Array<AiMessageAnswer>>;
  channelType?: Maybe<ChannelType>;
  conversationId?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Date']['output'];
  customerId: Scalars['ID']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  failedStepCount?: Maybe<Scalars['Int']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<AiRunKindEnum>;
  outcome?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  questionContext?: Maybe<AiMessageQuestionContext>;
  questionId: Scalars['ID']['output'];
  questionMedia?: Maybe<Array<Maybe<ImageMedia>>>;
  status?: Maybe<AiMessageStatusEnum>;
  updatedAt: Scalars['Date']['output'];
  usage?: Maybe<AiRunUsage>;
};

export type AiMessagesPaginate = {
  __typename?: 'AiMessagesPaginate';
  docs?: Maybe<Array<Maybe<AiMessages>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type AiMessagesResponse = {
  __typename?: 'AiMessagesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AiMessagesPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The DM side of a comment turn, reported by the AI Test page next to the public reply. It shares
 * the comment's audit run, exactly as the live coordinated call does.
 */
export type AiPrivateReplyAnswer = {
  __typename?: 'AiPrivateReplyAnswer';
  aiAction?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  /** True when the tenant posts no public reply and this DM is the whole answer. */
  isOnlyReply?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiProductFaqAnswerLengthEnum {
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT'
}

export type AiProductFaqData = {
  __typename?: 'AiProductFaqData';
  /**
   * The tenant's saved block appearance, sent with the questions so the widget styles the block
   * from one request. Null only when the feature is off, and then nothing is rendered anyway.
   */
  design?: Maybe<AiProductFaqDesign>;
  generating?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<AiProductFaqItem>>>;
};

/**
 * The storefront FAQ block's appearance. Always complete — a profile that never saved one
 * is served the defaults.
 */
export type AiProductFaqDesign = {
  __typename?: 'AiProductFaqDesign';
  /**
   * How long the generated answers are. Nullable, unlike the appearance fields: a design saved
   * before this field existed comes back from Mongo without it, and the panel defaults it to MEDIUM.
   */
  answerLength?: Maybe<AiProductFaqAnswerLengthEnum>;
  borderColor: Scalars['String']['output'];
  borderRadius: Scalars['Int']['output'];
  borderWidth: Scalars['Int']['output'];
  fontFamily: AiProductFaqFontFamilyEnum;
  fontSize: Scalars['Int']['output'];
  fontWeight: AiProductFaqFontWeightEnum;
  iconColor: Scalars['String']['output'];
  showIcons: Scalars['Boolean']['output'];
  textColor: Scalars['String']['output'];
};

export type AiProductFaqDesignInput = {
  answerLength?: InputMaybe<AiProductFaqAnswerLengthEnum>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderRadius?: InputMaybe<Scalars['Int']['input']>;
  borderWidth?: InputMaybe<Scalars['Int']['input']>;
  fontFamily?: InputMaybe<AiProductFaqFontFamilyEnum>;
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  fontWeight?: InputMaybe<AiProductFaqFontWeightEnum>;
  iconColor?: InputMaybe<Scalars['String']['input']>;
  showIcons?: InputMaybe<Scalars['Boolean']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

/** SYSTEM inherits the storefront's own font; every other value is loaded by the widget. */
export enum AiProductFaqFontFamilyEnum {
  DmSans = 'DM_SANS',
  Inter = 'INTER',
  Lato = 'LATO',
  Manrope = 'MANROPE',
  Montserrat = 'MONTSERRAT',
  Nunito = 'NUNITO',
  OpenSans = 'OPEN_SANS',
  Poppins = 'POPPINS',
  Roboto = 'ROBOTO',
  System = 'SYSTEM'
}

export enum AiProductFaqFontWeightEnum {
  Bold = 'BOLD',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
  Regular = 'REGULAR',
  Semibold = 'SEMIBOLD'
}

export type AiProductFaqItem = {
  __typename?: 'AiProductFaqItem';
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type AiProductFaqResponse = {
  __typename?: 'AiProductFaqResponse';
  data?: Maybe<AiProductFaqData>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Switching it off is refused while the state is PREPARING or RUNNING. */
export type AiProductImageIndex = {
  __typename?: 'AiProductImageIndex';
  counts: AiProductImageIndexCounts;
  enabled: Scalars['Boolean']['output'];
  progressPercent: Scalars['Float']['output'];
  state: AiProductImageIndexState;
};

export type AiProductImageIndexCounts = {
  __typename?: 'AiProductImageIndexCounts';
  images: AiProductImageIndexImageCounts;
  lastIndexedAt?: Maybe<Scalars['String']['output']>;
  /** Listings (per-shop sellable pages) and master products the pictures cover. */
  listings: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
};

export type AiProductImageIndexDetails = {
  __typename?: 'AiProductImageIndexDetails';
  counts: AiProductImageIndexCounts;
  enabled: Scalars['Boolean']['output'];
  errors: Array<AiProductImageIndexError>;
  plannedAt?: Maybe<Scalars['String']['output']>;
  progressPercent: Scalars['Float']['output'];
  shops: Array<AiProductImageIndexShop>;
  state: AiProductImageIndexState;
  usage: AiProductImageIndexUsagePeriods;
};

export type AiProductImageIndexError = {
  __typename?: 'AiProductImageIndexError';
  images: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * Progress counts distinct PICTURES per shop: one picture shared by several listings of an article
 * is embedded once. `failed` = pictures that could not be read after every retry; they count as done.
 */
export type AiProductImageIndexImageCounts = {
  __typename?: 'AiProductImageIndexImageCounts';
  failed: Scalars['Int']['output'];
  indexed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AiProductImageIndexResponse = {
  __typename?: 'AiProductImageIndexResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiProductImageIndex>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiProductImageIndexShop = {
  __typename?: 'AiProductImageIndexShop';
  connectionStatus: Scalars['String']['output'];
  images: AiProductImageIndexImageCounts;
  listings: Scalars['Int']['output'];
  shopId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum AiProductImageIndexState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  /** Switched on, first shop not planned yet: there is nothing to count so far. */
  Preparing = 'PREPARING',
  Running = 'RUNNING'
}

export type AiProductImageIndexTenant = {
  __typename?: 'AiProductImageIndexTenant';
  customerId: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  /** Set when the tenant's index could not be read (qpien-shop's own error code when it gave one). */
  error?: Maybe<Scalars['String']['output']>;
  index?: Maybe<AiProductImageIndexDetails>;
};

/**
 * Embedding calls, priced at the configured per-image rate — an estimate, not a bill. Query images
 * are the pictures customers sent that were looked up; the visual verification LLM call is billed
 * separately and appears in the AI run cost.
 */
export type AiProductImageIndexUsage = {
  __typename?: 'AiProductImageIndexUsage';
  estimatedCostUsd: Scalars['Float']['output'];
  indexedImages: Scalars['Int']['output'];
  queryImages: Scalars['Int']['output'];
};

export type AiProductImageIndexUsagePeriods = {
  __typename?: 'AiProductImageIndexUsagePeriods';
  last30Days: AiProductImageIndexUsage;
  total: AiProductImageIndexUsage;
};

export type AiProductImageIndexesResponse = {
  __typename?: 'AiProductImageIndexesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiProductImageIndexTenant>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiProfile = {
  __typename?: 'AiProfile';
  _id: Scalars['ID']['output'];
  /** Deprecated: image understanding is always on and this field is ignored. */
  aiImageRecognition?: Maybe<Scalars['Boolean']['output']>;
  answerLength?: Maybe<AiAnswerLengthEnum>;
  avatar?: Maybe<Scalars['String']['output']>;
  chatSettings?: Maybe<ChatSettings>;
  commentSettings?: Maybe<CommentSettings>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  /** Service and E-commerce: non-ticket e-mail, configured apart from chat. */
  emailSettings?: Maybe<EmailSettings>;
  humanReplyLearningJobId?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastSelectedAt?: Maybe<Scalars['Date']['output']>;
  learnFromHumanReplies?: Maybe<Scalars['Boolean']['output']>;
  marketPlaceSettings?: Maybe<MarketPlaceSettings>;
  name: Scalars['String']['output'];
  persona?: Maybe<Scalars['String']['output']>;
  role: AiRoleEnum;
  /** E-commerce role only — the connected store and shopping-assistant behaviour. */
  storeSettings?: Maybe<AiStoreSettings>;
  ticketSettings?: Maybe<TicketSettings>;
  toneOfVoice: AiProfileToneOfVoiceEnum;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useEmoji?: Maybe<Scalars['Boolean']['output']>;
  useMacrosAsKnowledgeSource?: Maybe<Scalars['Boolean']['output']>;
};

export type AiProfilePayload = {
  file?: InputMaybe<Scalars['Media']['input']>;
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export enum AiProfileReplyButtonActionEnum {
  CloseConversation = 'CloseConversation',
  StartFlow = 'StartFlow',
  TransferAgent = 'TransferAgent',
  TransferTeam = 'TransferTeam'
}

export enum AiProfileReplyModeEnum {
  Automatic = 'AUTOMATIC',
  Hybrid = 'HYBRID'
}

export type AiProfileResponse = {
  __typename?: 'AiProfileResponse';
  code?: Maybe<Scalars['String']['output']>;
  /** Null when the customer has not set up any AI role yet. */
  data?: Maybe<AiProfile>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiProfileSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum AiProfileToneOfVoiceEnum {
  Formal = 'Formal',
  Friendly = 'Friendly',
  Neutral = 'Neutral'
}

export enum AiRoleEnum {
  Ecommerce = 'ECOMMERCE',
  Marketplace = 'MARKETPLACE',
  Service = 'SERVICE'
}

export type AiRoleSummary = {
  __typename?: 'AiRoleSummary';
  aiProfileId?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isConfigured: Scalars['Boolean']['output'];
  lastSelectedAt?: Maybe<Scalars['Date']['output']>;
  role: AiRoleEnum;
};

export type AiRolesResponse = {
  __typename?: 'AiRolesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiRoleSummary>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiRunKindEnum {
  AutoClose = 'AUTO_CLOSE',
  FollowUp = 'FOLLOW_UP'
}

export enum AiRunKindFilterEnum {
  AutoClose = 'AUTO_CLOSE',
  FollowUp = 'FOLLOW_UP',
  Turn = 'TURN'
}

export type AiRunUsage = {
  __typename?: 'AiRunUsage';
  amount?: Maybe<Scalars['Float']['output']>;
  cachedInputToken?: Maybe<Scalars['Int']['output']>;
  inputToken?: Maybe<Scalars['Int']['output']>;
  llmCalls?: Maybe<Scalars['Int']['output']>;
  outputToken?: Maybe<Scalars['Int']['output']>;
};

export type AiShoppingAssistantInput = {
  /** Live chat only: the AI may put products into the shopper's own storefront cart and show a go-to-cart button. */
  addToCart?: InputMaybe<Scalars['Boolean']['input']>;
  /** Replaces the whole list when sent. Each IBAN is checked (mod-97) before it is saved. */
  bankAccounts?: InputMaybe<Array<AiBankAccountInput>>;
  /** With takeOrders: the order is placed and paid by bank transfer. Needs at least one bank account. */
  bankTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The AI may cancel a shopper's unfulfilled order once the shopper confirms it. */
  cancelOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** With takeOrders: the same, paid by card at the door. */
  cardOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** With takeOrders: the AI may place an order paid in cash at the door once the shopper confirms it. */
  cashOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** With takeOrders: the AI takes the delivery address in chat and puts it on the order before sending the checkout link. Forced false when takeOrders is off. */
  collectAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Drives the storefront AI Product FAQs block — see modules/AiProductFaqs. */
  productFaqs?: InputMaybe<Scalars['Boolean']['input']>;
  /** When off the AI states a product is unavailable instead of offering alternatives. */
  recommendSimilarProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The AI may file a return request for delivered items once the shopper confirms it; the merchant accepts or declines it. */
  returnOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** The AI may put a cart together and send the shop's checkout link. */
  takeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** The AI may change a placed order's delivery address, phone or e-mail once the shopper confirms it. */
  updateOrders?: InputMaybe<Scalars['Boolean']['input']>;
  useProductImagesForRag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiShoppingAssistantSettings = {
  __typename?: 'AiShoppingAssistantSettings';
  /** Live chat only: the AI may put products into the shopper's own storefront cart. */
  addToCart?: Maybe<Scalars['Boolean']['output']>;
  /** Sent to the shopper by the platform, never written by the AI, once a bank-transfer order is placed. */
  bankAccounts?: Maybe<Array<AiBankAccount>>;
  /** With takeOrders: the order is placed and paid by bank transfer. */
  bankTransfer?: Maybe<Scalars['Boolean']['output']>;
  /** The AI may cancel a shopper's unfulfilled order once the shopper confirms it. */
  cancelOrders?: Maybe<Scalars['Boolean']['output']>;
  /** With takeOrders: the same, paid by card at the door. */
  cardOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** With takeOrders: the AI may place an order paid in cash at the door once the shopper confirms it. */
  cashOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** With takeOrders: the AI takes the delivery address in chat and puts it on the order before sending the checkout link. */
  collectAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Drives the storefront AI Product FAQs block — see modules/AiProductFaqs. */
  productFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Second phase — shown as "coming soon" and never enabled in this release. */
  promoteProducts?: Maybe<Scalars['Boolean']['output']>;
  recommendSimilarProducts?: Maybe<Scalars['Boolean']['output']>;
  /** The AI may file a return request for delivered items once the shopper confirms it. */
  returnOrders?: Maybe<Scalars['Boolean']['output']>;
  /** The AI may put a cart together and send the shop's checkout link. */
  takeOrders?: Maybe<Scalars['Boolean']['output']>;
  /** The AI may change a placed order's delivery address, phone or e-mail once the shopper confirms it. */
  updateOrders?: Maybe<Scalars['Boolean']['output']>;
};

/** One Qpien-side outcome of an answered turn. */
export type AiSideEffect = {
  __typename?: 'AiSideEffect';
  /** True when the tester ran with side effects off, so nothing was carried out. */
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  kind: AiSideEffectKind;
  /** The team, agent or flow the effect targets, when it has one. */
  targetId?: Maybe<Scalars['ID']['output']>;
  /** Resolved display name for targetId, when it could be looked up. */
  targetName?: Maybe<Scalars['String']['output']>;
};

export enum AiSideEffectKind {
  CloseConversation = 'CLOSE_CONVERSATION',
  ClosingNote = 'CLOSING_NOTE',
  ClosingTags = 'CLOSING_TAGS',
  MainTeamFallback = 'MAIN_TEAM_FALLBACK',
  MarkSpam = 'MARK_SPAM',
  NoAction = 'NO_ACTION',
  ReplySent = 'REPLY_SENT',
  ResolveTicket = 'RESOLVE_TICKET',
  StartFlow = 'START_FLOW',
  SurveySent = 'SURVEY_SENT',
  TransferAgent = 'TRANSFER_AGENT',
  TransferTeam = 'TRANSFER_TEAM',
  TransferUnassigned = 'TRANSFER_UNASSIGNED'
}

export type AiSizeChart = {
  __typename?: 'AiSizeChart';
  conditions: Array<AiSizeChartCondition>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  measurements: Array<AiSizeChartMeasurement>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sizes: Array<AiSizeChartSize>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AiSizeChartAttribute = {
  __typename?: 'AiSizeChartAttribute';
  key: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
};

export type AiSizeChartAttributeValue = {
  __typename?: 'AiSizeChartAttributeValue';
  productCount: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type AiSizeChartAttributeValuesResponse = {
  __typename?: 'AiSizeChartAttributeValuesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiSizeChartAttributeValue>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartAttributesResponse = {
  __typename?: 'AiSizeChartAttributesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiSizeChartAttribute>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartCategoriesResponse = {
  __typename?: 'AiSizeChartCategoriesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiSizeChartCategory>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartCategory = {
  __typename?: 'AiSizeChartCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  productCount: Scalars['Int']['output'];
};

export type AiSizeChartCondition = {
  __typename?: 'AiSizeChartCondition';
  key?: Maybe<Scalars['String']['output']>;
  type: AiSizeChartConditionType;
  values: Array<Scalars['String']['output']>;
};

export type AiSizeChartConditionInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  type: AiSizeChartConditionType;
  values: Array<Scalars['String']['input']>;
};

/**
 * A chart covers a product listed under PRODUCT, or one that matches every filter: GROUP (size chart
 * group ids), CATEGORY (category ids, subcategories included) and ATTRIBUTE (`key` = attribute name,
 * values = attribute values). At least one of these four is required. GENDER (MALE, FEMALE, UNISEX),
 * FIT (SLIM, REGULAR, OVERSIZE), MATERIAL (COTTON, LINEN, WOOL, LEATHER) and AGE_GROUP (ADULT, CHILD)
 * say who the chart is for; the AI uses them to pick between the charts of one product. Each type
 * (ATTRIBUTE: each key) appears once; its values are alternatives.
 */
export enum AiSizeChartConditionType {
  AgeGroup = 'AGE_GROUP',
  Attribute = 'ATTRIBUTE',
  Category = 'CATEGORY',
  Fit = 'FIT',
  Gender = 'GENDER',
  Group = 'GROUP',
  Material = 'MATERIAL',
  Product = 'PRODUCT'
}

export type AiSizeChartDeleteResponse = {
  __typename?: 'AiSizeChartDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * CATEGORY: values are category ids (subcategories included). ATTRIBUTE: `key` is the attribute name,
 * values are attribute values. Values of one filter are alternatives.
 */
export type AiSizeChartFilter = {
  __typename?: 'AiSizeChartFilter';
  key?: Maybe<Scalars['String']['output']>;
  type: AiSizeChartFilterType;
  values: Array<Scalars['String']['output']>;
};

export type AiSizeChartFilterInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  type: AiSizeChartFilterType;
  values: Array<Scalars['String']['input']>;
};

export enum AiSizeChartFilterType {
  Attribute = 'ATTRIBUTE',
  Category = 'CATEGORY'
}

/**
 * Covers its listed products plus, when it has filters, every product matching all of them, so new
 * products join on their own. `productCount` is computed on read (active products).
 */
export type AiSizeChartGroup = {
  __typename?: 'AiSizeChartGroup';
  chartCount: Scalars['Int']['output'];
  filters?: Maybe<Array<AiSizeChartFilter>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  /** Only on a single-group read: the products listed by hand, not the filter matches. */
  productIds?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AiSizeChartGroupDeleteResponse = {
  __typename?: 'AiSizeChartGroupDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Needs at least one product or one filter. */
export type AiSizeChartGroupInput = {
  filters?: InputMaybe<Array<AiSizeChartFilterInput>>;
  name: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AiSizeChartGroupPreview = {
  __typename?: 'AiSizeChartGroupPreview';
  coveredIds: Array<Scalars['ID']['output']>;
  productCount: Scalars['Int']['output'];
  products: Array<AiSizeChartProductOption>;
};

export type AiSizeChartGroupPreviewInput = {
  checkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filters?: InputMaybe<Array<AiSizeChartFilterInput>>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AiSizeChartGroupPreviewResponse = {
  __typename?: 'AiSizeChartGroupPreviewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiSizeChartGroupPreview>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartGroupResponse = {
  __typename?: 'AiSizeChartGroupResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiSizeChartGroup>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartGroupsResponse = {
  __typename?: 'AiSizeChartGroupsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiSizeChartGroup>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartInput = {
  conditions: Array<AiSizeChartConditionInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  measurements: Array<AiSizeChartMeasurementInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sizes: Array<AiSizeChartSizeInput>;
};

/**
 * Standard keys: HEIGHT, WEIGHT, CHEST, WAIST, HIP, FOOT_LENGTH. Any other key is a custom measurement
 * and needs a `label`.
 */
export type AiSizeChartMeasurement = {
  __typename?: 'AiSizeChartMeasurement';
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  unit: AiSizeChartUnit;
};

export type AiSizeChartMeasurementInput = {
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  unit: AiSizeChartUnit;
};

export type AiSizeChartProductOption = {
  __typename?: 'AiSizeChartProductOption';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AiSizeChartProductsResponse = {
  __typename?: 'AiSizeChartProductsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiSizeChartProductOption>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartRange = {
  __typename?: 'AiSizeChartRange';
  max?: Maybe<Scalars['Float']['output']>;
  measurement: Scalars['String']['output'];
  min?: Maybe<Scalars['Float']['output']>;
};

export type AiSizeChartRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  measurement: Scalars['String']['input'];
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type AiSizeChartResponse = {
  __typename?: 'AiSizeChartResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiSizeChart>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSizeChartSize = {
  __typename?: 'AiSizeChartSize';
  ranges: Array<AiSizeChartRange>;
  size: Scalars['String']['output'];
};

export type AiSizeChartSizeInput = {
  ranges: Array<AiSizeChartRangeInput>;
  size: Scalars['String']['input'];
};

export enum AiSizeChartUnit {
  Cm = 'CM',
  In = 'IN',
  Kg = 'KG',
  Lb = 'LB',
  Mm = 'MM'
}

export type AiSizeChartsResponse = {
  __typename?: 'AiSizeChartsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiSizeChart>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** `null` on a feature means the shop's platform support could not be read; `false` means its platform cannot do it. */
export type AiStoreOrderingOptions = {
  __typename?: 'AiStoreOrderingOptions';
  addToCart?: Maybe<Scalars['Boolean']['output']>;
  bankTransfer?: Maybe<Scalars['Boolean']['output']>;
  bankTransferSeen?: Maybe<Scalars['Boolean']['output']>;
  campaignsApplied?: Maybe<Scalars['Boolean']['output']>;
  cancelOrders?: Maybe<Scalars['Boolean']['output']>;
  cardOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  cardOnDeliverySeen?: Maybe<Scalars['Boolean']['output']>;
  cashOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set only where the platform publishes no payment methods (Shopify): whether a store order of
   * the last 60 days was paid this way. A hint beside the merchant's switch, never a lock.
   */
  cashOnDeliverySeen?: Maybe<Scalars['Boolean']['output']>;
  checkoutLink: Scalars['Boolean']['output'];
  returnOrders?: Maybe<Scalars['Boolean']['output']>;
  takeOrders?: Maybe<Scalars['Boolean']['output']>;
  updatableFields?: Maybe<Array<Scalars['String']['output']>>;
  updateOrders?: Maybe<Scalars['Boolean']['output']>;
};

export type AiStoreOrderingOptionsResponse = {
  __typename?: 'AiStoreOrderingOptionsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiStoreOrderingOptions>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiStoreProduct = {
  __typename?: 'AiStoreProduct';
  /** Tenant-authored notes; survives every integration sync. */
  customAiInfo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The product's page on the store or marketplace it is sold on, taken from the first
   * variant that has a listing. Null when the platform gave us none — the panel then shows
   * no link at all rather than a dead one.
   */
  productUrl?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Derived: the catalogue would actually return this product to a shopper. */
  usedByAiAgent: Scalars['Boolean']['output'];
  variants?: Maybe<Array<AiStoreProductVariant>>;
};

export type AiStoreProductOption = {
  __typename?: 'AiStoreProductOption';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AiStoreProductResponse = {
  __typename?: 'AiStoreProductResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiStoreProduct>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AiStoreProductSort {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type AiStoreProductVariant = {
  __typename?: 'AiStoreProductVariant';
  barcode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  /**
   * The platform product id this variant belongs to (Trendyol's seller product code,
   * Hepsiburada's variantGroupId parent). One master can hold several of them.
   */
  externalProductId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  isTaxIncluded?: Maybe<Scalars['Boolean']['output']>;
  /** The listing's own product page on the platform. */
  itemUrl?: Maybe<Scalars['String']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * The LISTING this variant is sold on — Trendyol's productContentId, the id its own
   * product URL is built from. This, not `externalProductId`, is what a Trendyol question
   * carries as `productMainId`.
   */
  listingKey?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<AiStoreProductOption>>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  /**
   * Tax facts for the prices above: `taxRate` is a fraction (0.20), `isTaxIncluded` says
   * whether they already include it. Platforms that list ex-VAT (T-Soft) need both for the
   * panel to show what the shopper pays.
   */
  taxRate?: Maybe<Scalars['Float']['output']>;
  /** This variant's own image, which on a marketplace differs per colour listing. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AiStoreProductsResponse = {
  __typename?: 'AiStoreProductsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiStoreProductsResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiStoreProductsResult = {
  __typename?: 'AiStoreProductsResult';
  count?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<AiStoreProduct>>;
};

export type AiStoreSettings = {
  __typename?: 'AiStoreSettings';
  integrationStore?: Maybe<Scalars['ID']['output']>;
  /** Appearance of the storefront AI Product FAQs block. */
  productFaqDesign?: Maybe<AiProductFaqDesign>;
  shoppingAssistant?: Maybe<AiShoppingAssistantSettings>;
  useProductImagesForRag?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSuggestion = {
  __typename?: 'AiSuggestion';
  _id: Scalars['ID']['output'];
  conversationIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  suggestion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AiSuggestionDeleteResponse = {
  __typename?: 'AiSuggestionDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSuggestionPaginatedResponse = {
  __typename?: 'AiSuggestionPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AiSuggestionPaginatedResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSuggestionPaginatedResult = {
  __typename?: 'AiSuggestionPaginatedResult';
  docs?: Maybe<Array<Maybe<AiSuggestion>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type AiTestCommerceApproval = {
  __typename?: 'AiTestCommerceApproval';
  buttonId: Scalars['ID']['output'];
  /**
   * Set when the button goes out on a message of its own after the answer, because the answer was
   * too long to carry it.
   */
  content?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AiTestCommerceLink = {
  __typename?: 'AiTestCommerceLink';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AiTestDryRunSkip = {
  __typename?: 'AiTestDryRunSkip';
  kind: AiTestDryRunSkipKind;
  /** The tenant action's or skill step's own name, for ACTION, SKILL_ACTION and SKILL_ATTRIBUTE. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum AiTestDryRunSkipKind {
  Action = 'ACTION',
  Cancel = 'CANCEL',
  CheckoutLink = 'CHECKOUT_LINK',
  DeleteComment = 'DELETE_COMMENT',
  Order = 'ORDER',
  Return = 'RETURN',
  SkillAction = 'SKILL_ACTION',
  SkillAttribute = 'SKILL_ATTRIBUTE',
  Update = 'UPDATE'
}

export type AiTestMediaInput = {
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type AiTestPreviousQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  askedAt?: InputMaybe<Scalars['Date']['input']>;
  productMainId?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productUrl?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** A translated explanation key plus the stage and detail captured from this run. */
export type AiTestResponseExplanation = {
  __typename?: 'AiTestResponseExplanation';
  code: Scalars['String']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type AiTestSkillAction = {
  __typename?: 'AiTestSkillAction';
  command: Scalars['String']['output'];
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AiTtsModel = {
  __typename?: 'AiTtsModel';
  languageCount?: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  supportsTurkish?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTtsModelSettings = {
  __typename?: 'AiTtsModelSettings';
  activeModelId: Scalars['String']['output'];
  defaultModelId: Scalars['String']['output'];
  models: Array<AiTtsModel>;
};

export type AiTtsModelSettingsResponse = {
  __typename?: 'AiTtsModelSettingsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiTtsModelSettings>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTtsPreview = {
  __typename?: 'AiTtsPreview';
  audioUrl: Scalars['String']['output'];
};

export type AiTtsPreviewInput = {
  customerId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  voiceId: Scalars['String']['input'];
};

export type AiTtsPreviewResponse = {
  __typename?: 'AiTtsPreviewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiTtsPreview>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTtsVoice = {
  __typename?: 'AiTtsVoice';
  label: Scalars['String']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  voiceId: Scalars['String']['output'];
};

export type AiTtsVoicesResponse = {
  __typename?: 'AiTtsVoicesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AiTtsVoice>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AllCPersonType = {
  __typename?: 'AllCPersonType';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AllChannelTypeResponse = {
  __typename?: 'AllChannelTypeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ChannelCommonTypes>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AllTemplatesPaginatedCountInput = {
  customer: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

export type AllTemplatesPaginatedInput = {
  allStatus?: InputMaybe<Scalars['Boolean']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryTypes>;
  customerId: Scalars['ID']['input'];
  eCommerceCart?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Number']['input'];
  pageSize: Scalars['Number']['input'];
  qpienFields?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<WhatsAppTemplateSort>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<TemplateTypes>;
};

export type AllTemplatesPaginatedResponse = {
  __typename?: 'AllTemplatesPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PaginatedTemplate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AllWabaTemplatesPaginatedResponse = {
  __typename?: 'AllWabaTemplatesPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PaginatedWabaTemplate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AllowDigitsInput = {
  digit?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
};

export type AllowDigitsOutput = {
  __typename?: 'AllowDigitsOutput';
  digit?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type AnalyseCallSettings = {
  __typename?: 'AnalyseCallSettings';
  analyseOn?: Maybe<AiAnalysisCallAnalysedOn>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalyseCallSettingsInput = {
  analyseOn?: InputMaybe<AiAnalysisCallAnalysedOn>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyseConversationSettings = {
  __typename?: 'AnalyseConversationSettings';
  analyseOn?: Maybe<AiAnalysisConversationAnalysedOn>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalyseConversationSettingsInput = {
  analyseOn?: InputMaybe<AiAnalysisConversationAnalysedOn>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyseTicketSettings = {
  __typename?: 'AnalyseTicketSettings';
  analyseOn?: Maybe<AiAnalysisTicketAnalysedOn>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalyseTicketSettingsInput = {
  analyseOn?: InputMaybe<AiAnalysisTicketAnalysedOn>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalysisData = {
  __typename?: 'AnalysisData';
  _id?: Maybe<Scalars['ID']['output']>;
  sentiment?: Maybe<IAiAnalysisSentiment>;
  topics?: Maybe<Array<Maybe<IAiAnalysisTopic>>>;
};

export type AnalyzeAiMessageRunInput = {
  aiMessageId?: InputMaybe<Scalars['ID']['input']>;
  answerId?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyzeAiMessageRunResponse = {
  __typename?: 'AnalyzeAiMessageRunResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalyzeCampaignInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyzeCampaignResponse = {
  __typename?: 'AnalyzeCampaignResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignAnalysis>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AnswerActions = {
  __typename?: 'AnswerActions';
  isHumanSupport: Scalars['Boolean']['output'];
  isNegative: Scalars['Boolean']['output'];
  isPositive: Scalars['Boolean']['output'];
};

export type AppSettings = {
  __typename?: 'AppSettings';
  _id: Scalars['ID']['output'];
  cPerson: Scalars['ID']['output'];
  conversation: Array<ConversationSettingsItem>;
  conversationDetails: Array<ConversationDetailsSettingsItem>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  homeDashboardStats?: Maybe<Array<HomeDashboardStatSettingsItem>>;
  homeWidgets?: Maybe<Array<HomeWidgetSettingsItem>>;
  updatedAt: Scalars['Date']['output'];
  viewFolders: Array<ViewFoldersSettingsItem>;
};

export type AppSettingsItemInput = {
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type AppSettingsResponse = {
  __typename?: 'AppSettingsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AppSettings>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ArchiveCustomerPersonInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type ArchiveSlaPolicyInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type ArchiveStatusResponse = {
  __typename?: 'ArchiveStatusResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchiveTopicInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type AskQuestionEvalAssertionInput = {
  expectedAiAction?: InputMaybe<Scalars['String']['input']>;
  expectedContentIncludes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedStatus?: InputMaybe<Scalars['String']['input']>;
  forbiddenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredSteps?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AskQuestionEvalCaseResult = {
  __typename?: 'AskQuestionEvalCaseResult';
  actual?: Maybe<Scalars['JSON']['output']>;
  aiAction?: Maybe<Scalars['String']['output']>;
  aiMessageId?: Maybe<Scalars['ID']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  durationMs: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  expected?: Maybe<Scalars['JSON']['output']>;
  failures: Array<Maybe<Scalars['String']['output']>>;
  question: Scalars['String']['output'];
  scenarioId: Scalars['String']['output'];
  status: AskQuestionEvalCaseStatus;
  title: Scalars['String']['output'];
};

export enum AskQuestionEvalCaseStatus {
  Failed = 'FAILED',
  Passed = 'PASSED'
}

export type AskQuestionEvalDeleteResponse = {
  __typename?: 'AskQuestionEvalDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AskQuestionEvalMock = {
  __typename?: 'AskQuestionEvalMock';
  _id: Scalars['ID']['output'];
  cases: Array<AskQuestionEvalMockCase>;
  channelType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AskQuestionEvalMockAssertionsInput = {
  expectedAiAction?: InputMaybe<Scalars['String']['input']>;
  expectedContentIncludes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedStatus?: InputMaybe<Scalars['String']['input']>;
  forbiddenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredSteps?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AskQuestionEvalMockCase = {
  __typename?: 'AskQuestionEvalMockCase';
  assertions?: Maybe<Scalars['JSON']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  turns?: Maybe<Scalars['JSON']['output']>;
};

export type AskQuestionEvalMockCaseInput = {
  assertions?: InputMaybe<AskQuestionEvalMockAssertionsInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  turns?: InputMaybe<Array<AskQuestionEvalTurnInput>>;
};

export type AskQuestionEvalMockDeleteResponse = {
  __typename?: 'AskQuestionEvalMockDeleteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AskQuestionEvalMockInput = {
  cases: Array<AskQuestionEvalMockCaseInput>;
  channelType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AskQuestionEvalMockListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<AskQuestionEvalMockTemplate>;
};

export type AskQuestionEvalMockListResponse = {
  __typename?: 'AskQuestionEvalMockListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AskQuestionEvalMockPaginate>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AskQuestionEvalMockPaginate = {
  __typename?: 'AskQuestionEvalMockPaginate';
  docs: Array<AskQuestionEvalMock>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type AskQuestionEvalMockResponse = {
  __typename?: 'AskQuestionEvalMockResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AskQuestionEvalMock>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AskQuestionEvalMockTemplate {
  ActionPipeline = 'ACTION_PIPELINE',
  FullFlow = 'FULL_FLOW',
  IntentPipeline = 'INTENT_PIPELINE',
  RagPipeline = 'RAG_PIPELINE'
}

export type AskQuestionEvalMockTemplateInfo = {
  __typename?: 'AskQuestionEvalMockTemplateInfo';
  defaultRequiredSteps: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: AskQuestionEvalMockTemplate;
  label: Scalars['String']['output'];
  requiresMsgType: Scalars['Boolean']['output'];
};

export type AskQuestionEvalMockTemplateInputsInput = {
  msgType?: InputMaybe<Scalars['String']['input']>;
};

export type AskQuestionEvalMockTemplatesResponse = {
  __typename?: 'AskQuestionEvalMockTemplatesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<AskQuestionEvalMockTemplateInfo>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum AskQuestionEvalMode {
  Live = 'LIVE',
  Mock = 'MOCK'
}

export type AskQuestionEvalRun = {
  __typename?: 'AskQuestionEvalRun';
  _id: Scalars['ID']['output'];
  cases: Array<Maybe<AskQuestionEvalCaseResult>>;
  createdAt: Scalars['Date']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  durationMs: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  mode: AskQuestionEvalMode;
  passed: Scalars['Int']['output'];
  status: AskQuestionEvalCaseStatus;
  suiteId: Scalars['String']['output'];
  suiteTitle: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AskQuestionEvalRunListInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<AskQuestionEvalMode>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AskQuestionEvalRunListResponse = {
  __typename?: 'AskQuestionEvalRunListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AskQuestionEvalRunPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AskQuestionEvalRunPaginate = {
  __typename?: 'AskQuestionEvalRunPaginate';
  docs?: Maybe<Array<Maybe<AskQuestionEvalRun>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type AskQuestionEvalRunResponse = {
  __typename?: 'AskQuestionEvalRunResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AskQuestionEvalRun>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AskQuestionEvalScenarioInput = {
  assertions?: InputMaybe<AskQuestionEvalAssertionInput>;
  channelType?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  mock?: InputMaybe<AskQuestionEvalScenarioMockInput>;
  query: Scalars['String']['input'];
  stepTest?: InputMaybe<AskQuestionEvalStepTestInput>;
  title: Scalars['String']['input'];
  turns?: InputMaybe<Array<AskQuestionEvalScenarioTurnInput>>;
};

export type AskQuestionEvalScenarioMockAnswerInput = {
  aiAction?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
};

export type AskQuestionEvalScenarioMockInput = {
  answer?: InputMaybe<AskQuestionEvalScenarioMockAnswerInput>;
};

export type AskQuestionEvalScenarioTurnInput = {
  assertions?: InputMaybe<AskQuestionEvalAssertionInput>;
  query: Scalars['String']['input'];
};

export type AskQuestionEvalStepTestInput = {
  msgType?: InputMaybe<Scalars['String']['input']>;
  step: Scalars['String']['input'];
};

export type AskQuestionEvalSuiteInfo = {
  __typename?: 'AskQuestionEvalSuiteInfo';
  id: Scalars['String']['output'];
  scenarioCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AskQuestionEvalSuiteInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mockId?: InputMaybe<Scalars['ID']['input']>;
  mode: AskQuestionEvalMode;
  msgType?: InputMaybe<Scalars['String']['input']>;
  scenarios?: InputMaybe<Array<AskQuestionEvalScenarioInput>>;
  suiteId: Scalars['String']['input'];
  template?: InputMaybe<AskQuestionEvalMockTemplate>;
};

export type AskQuestionEvalSuitesResponse = {
  __typename?: 'AskQuestionEvalSuitesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<AskQuestionEvalSuiteInfo>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AskQuestionEvalTurnInput = {
  assertions?: InputMaybe<AskQuestionEvalMockAssertionsInput>;
  query: Scalars['String']['input'];
};

export type AssignChannelOwnerInput = {
  accountId: Scalars['ID']['input'];
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  platformType: PlatformType;
};

export type AttachmentRecord = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
};

export enum AudioFormat {
  Aac = 'aac',
  M4a = 'm4a',
  Mp3 = 'mp3',
  Ogg = 'ogg',
  Wav = 'wav'
}

export type AuthInput = {
  pass?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type Authentication = {
  __typename?: 'Authentication';
  _id: Scalars['ID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Array<Maybe<AuthenticationFormDataOutput>>>;
  formDataUrlEncoded?: Maybe<Array<Maybe<AuthenticationFormDataOutput>>>;
  headers?: Maybe<Array<Maybe<AuthenticationHeaderOutput>>>;
  method?: Maybe<AuthenticationMethod>;
  name: Scalars['String']['output'];
  oauthConsumerKey?: Maybe<Scalars['String']['output']>;
  oauthConsumerSecret?: Maybe<Scalars['String']['output']>;
  oauthRealm?: Maybe<Scalars['String']['output']>;
  oauthSignatureMethod?: Maybe<Scalars['String']['output']>;
  oauthToken?: Maybe<Scalars['String']['output']>;
  oauthTokenSecret?: Maybe<Scalars['String']['output']>;
  oauthVersion?: Maybe<Scalars['String']['output']>;
  refreshTokenTime?: Maybe<Scalars['Int']['output']>;
  responseMapping?: Maybe<Array<AuthenticationResponseMappingOutput>>;
  tokenKey?: Maybe<Scalars['String']['output']>;
  tokenPrefix?: Maybe<Scalars['String']['output']>;
  tokenValue?: Maybe<Scalars['String']['output']>;
  type: AuthenticationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AuthenticationFormData = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticationFormDataOutput = {
  __typename?: 'AuthenticationFormDataOutput';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AuthenticationHeader = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticationHeaderOutput = {
  __typename?: 'AuthenticationHeaderOutput';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AuthenticationMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type AuthenticationResponse = {
  __typename?: 'AuthenticationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Authentication;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthenticationResponseMapping = {
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export type AuthenticationResponseMappingOutput = {
  __typename?: 'AuthenticationResponseMappingOutput';
  fieldId?: Maybe<Scalars['ID']['output']>;
  value: Scalars['String']['output'];
};

export type AuthenticationSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export enum AuthenticationType {
  HttpRequest = 'HttpRequest',
  OauthToken = 'OauthToken',
  StaticToken = 'StaticToken'
}

export type AuthenticationsPaginatedData = {
  __typename?: 'AuthenticationsPaginatedData';
  docs: Array<Maybe<Authentication>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type AuthenticationsPaginatedResponse = {
  __typename?: 'AuthenticationsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AuthenticationsPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AutoCloseSettingsInput = {
  status: Scalars['String']['input'];
  time: Scalars['Int']['input'];
};

export enum AutoFormalizeInvoicesPreference {
  No = 'no',
  Yes = 'yes',
  YesOnlyNotTr = 'yesOnlyNotTr',
  YesOnlyTr = 'yesOnlyTr'
}

export type AutoLogoutSubscriptionInput = {
  _id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AvailableCallCustomerPersonsListResponse = {
  __typename?: 'AvailableCallCustomerPersonsListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<CustomerPerson>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BalanceUsageResponse = {
  __typename?: 'BalanceUsageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<CustomerBalanceHistory>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BalanceUsageStatisticRes = {
  __typename?: 'BalanceUsageStatisticRes';
  aiResponse?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  call?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  campaignWhatsAppBusiness?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  campaignWhatsAppWeb?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  extraPerson?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  operator?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  totalWhatsAppUsage?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  whatsAppBusiness?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
  whatsAppWeb?: Maybe<Array<Maybe<BalanceUsageStatisticsData>>>;
};

export type BalanceUsageStatisticsData = {
  __typename?: 'BalanceUsageStatisticsData';
  count?: Maybe<Scalars['Double']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  usageType?: Maybe<Scalars['String']['output']>;
};

export type BalanceUsageStatisticsResponse = {
  __typename?: 'BalanceUsageStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: BalanceUsageStatisticRes;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum BalanceUsageTypeEnum {
  AiResponse = 'AI_RESPONSE',
  Call = 'CALL',
  CampaignWhatsAppBusiness = 'CAMPAIGN_WHATS_APP_BUSINESS',
  CampaignWhatsAppWeb = 'CAMPAIGN_WHATS_APP_WEB',
  ExtraPerson = 'EXTRA_PERSON',
  Operator = 'OPERATOR',
  WhatsAppBusiness = 'WHATS_APP_BUSINESS'
}

export type BarcodeField = {
  __typename?: 'BarcodeField';
  location: Array<Scalars['Float']['output']>;
  selectedField: CollageFields;
  value: Scalars['String']['output'];
};

export type BarcodeFieldInput = {
  location: Array<Scalars['Float']['input']>;
  selectedField: CollageFields;
  value: Scalars['String']['input'];
};

export type BlockFieldInput = {
  adIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiInstruction?: InputMaybe<Scalars['String']['input']>;
  aiResponseLanguage?: InputMaybe<Scalars['String']['input']>;
  aiResponseMappingFieldId?: InputMaybe<Scalars['ID']['input']>;
  allowed_digits?: InputMaybe<Array<InputMaybe<AllowDigitsInput>>>;
  assignAgentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  buttonParams?: InputMaybe<Array<InputMaybe<FlowTemplateParamInput>>>;
  canResponseTimeOut?: InputMaybe<Scalars['Boolean']['input']>;
  catalogMessage?: InputMaybe<CatalogInteractiveInput>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channelType?: InputMaybe<PlatformType>;
  comparison_field?: InputMaybe<Scalars['String']['input']>;
  condition_field?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  continueAsMainFlow?: InputMaybe<Scalars['Boolean']['input']>;
  conversationChannel?: InputMaybe<Scalars['String']['input']>;
  conversationFieldMappings?: InputMaybe<Array<InputMaybe<ConversationFieldMappingInput>>>;
  conversationSearchBy?: InputMaybe<ConversationSearchBy>;
  conversationSearchValue?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<FlowBlockFieldCustomFieldsInput>>>;
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  delay_time?: InputMaybe<Scalars['Int']['input']>;
  delay_time_unit?: InputMaybe<FlowBlockFieldTimeoutUnits>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  every?: InputMaybe<Scalars['Int']['input']>;
  footer?: InputMaybe<Scalars['ID']['input']>;
  formFieldMappings?: InputMaybe<Array<InputMaybe<FormFieldMappingInput>>>;
  frequencyMode?: InputMaybe<FlowTimeFrequencyMode>;
  from?: InputMaybe<Scalars['String']['input']>;
  globalButtons?: InputMaybe<Array<InputMaybe<FlowBlockFieldGlobalButtonsInput>>>;
  informativeButtons?: InputMaybe<Array<InputMaybe<FlowBlockFieldOptionInput>>>;
  isAiReply?: InputMaybe<Scalars['Boolean']['input']>;
  isButtonRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivateReply?: InputMaybe<Scalars['Boolean']['input']>;
  ivr_collect_multi_digits_target?: InputMaybe<Scalars['String']['input']>;
  ivr_input_mode?: InputMaybe<Scalars['String']['input']>;
  ivr_not_allowed_digits_target?: InputMaybe<Scalars['String']['input']>;
  ivr_num_digits?: InputMaybe<Scalars['Int']['input']>;
  ivr_response_timeout_second?: InputMaybe<Scalars['String']['input']>;
  ivr_response_timeout_target?: InputMaybe<Scalars['String']['input']>;
  ivr_speech_language?: InputMaybe<Scalars['String']['input']>;
  ivr_speech_target?: InputMaybe<Scalars['String']['input']>;
  keepRunningUntilComplete?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listMessage?: InputMaybe<Array<InputMaybe<FlowBlockFieldSectionInput>>>;
  liveChatVisitFrequencyUnit?: InputMaybe<FlowBlockFieldLiveChatVisitFrequencyUnits>;
  localizedMessages?: InputMaybe<Array<InputMaybe<LocalizedMessageInput>>>;
  metaEventCurrency?: InputMaybe<Scalars['String']['input']>;
  metaEventName?: InputMaybe<Scalars['String']['input']>;
  metaEventValue?: InputMaybe<Scalars['String']['input']>;
  musicUrl?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  onExistingOwner?: InputMaybe<Scalars['String']['input']>;
  onlyFromAds?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<Scalars['String']['input']>;
  qpienModule?: InputMaybe<QpienActionModule>;
  qpienOperation?: InputMaybe<QpienActionOperation>;
  qpienShopFieldMappings?: InputMaybe<Array<InputMaybe<QpienShopFieldMappingInput>>>;
  qpienShopSearchBy?: InputMaybe<QpienShopSearchBy>;
  qpienShopSearchValue?: InputMaybe<Scalars['String']['input']>;
  qpienShopSearchValueSecondary?: InputMaybe<Scalars['String']['input']>;
  qpienShopUpdateFields?: InputMaybe<Array<InputMaybe<QpienShopUpdateFieldInput>>>;
  question_answer_timeout?: InputMaybe<Scalars['Int']['input']>;
  question_answer_timeout_unit?: InputMaybe<FlowBlockFieldTimeoutUnits>;
  quickReplies?: InputMaybe<Array<InputMaybe<FlowBlockFieldOptionInput>>>;
  receiverPhone?: InputMaybe<Scalars['String']['input']>;
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestBodyFormData?: InputMaybe<Array<InputMaybe<FlowBlockFieldHttpRequestFormDataEntryInput>>>;
  requestBodyFormDataUrlEncoded?: InputMaybe<Array<InputMaybe<FlowBlockFieldHttpRequestFormDataEntryInput>>>;
  requestHeaders?: InputMaybe<Array<InputMaybe<FlowBlockFieldHttpRequestHeaderInput>>>;
  requestMethod?: InputMaybe<FlowBlockFieldRequestMethod>;
  requestUrl?: InputMaybe<Scalars['String']['input']>;
  requiredButtonMessage?: InputMaybe<Scalars['String']['input']>;
  responseDotNotation?: InputMaybe<Array<InputMaybe<FlowBlockFieldHttpRequestDotNotationInput>>>;
  rule?: InputMaybe<FlowBlockFieldRules>;
  save_response_to_contact_field?: InputMaybe<Scalars['String']['input']>;
  save_response_to_ivr_field?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<FlowBlockFieldSectionInput>>>;
  should_delay_continue?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  startFlowNodeStep?: InputMaybe<Scalars['ID']['input']>;
  startFlowTargetedBot?: InputMaybe<Scalars['ID']['input']>;
  startMode?: InputMaybe<FlowTimeStartMode>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetMode?: InputMaybe<FlowTimeTargetMode>;
  targetOnFailure?: InputMaybe<Scalars['ID']['input']>;
  targetOnFound?: InputMaybe<Scalars['ID']['input']>;
  targetOnNotFound?: InputMaybe<Scalars['ID']['input']>;
  targetOnSuccess?: InputMaybe<Scalars['ID']['input']>;
  target_on_invalid_input?: InputMaybe<Scalars['ID']['input']>;
  target_on_not_reply?: InputMaybe<Scalars['ID']['input']>;
  target_on_reply?: InputMaybe<Scalars['ID']['input']>;
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  taskDueOperator?: InputMaybe<Scalars['String']['input']>;
  taskDueReference?: InputMaybe<Scalars['String']['input']>;
  taskDueUnit?: InputMaybe<Scalars['String']['input']>;
  taskDueValue?: InputMaybe<Scalars['String']['input']>;
  taskOperation?: InputMaybe<TaskActionOperation>;
  taskOwnerId?: InputMaybe<Scalars['ID']['input']>;
  taskPriority?: InputMaybe<Scalars['String']['input']>;
  taskReminderOffset?: InputMaybe<Scalars['String']['input']>;
  taskReminderTime?: InputMaybe<Scalars['String']['input']>;
  taskSearchBy?: InputMaybe<TaskActionSearchBy>;
  taskSearchId?: InputMaybe<Scalars['String']['input']>;
  taskStatus?: InputMaybe<Scalars['String']['input']>;
  taskTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskTitle?: InputMaybe<Scalars['String']['input']>;
  templateConditions?: InputMaybe<Array<InputMaybe<QpienActionTemplateConditionInput>>>;
  templateParams?: InputMaybe<Array<InputMaybe<FlowTemplateParamInput>>>;
  ticketState?: InputMaybe<Scalars['String']['input']>;
  ticketType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  ttsLanguage?: InputMaybe<Scalars['String']['input']>;
  ttsVoice?: InputMaybe<Scalars['String']['input']>;
  type: FlowBlockFieldTypes;
  unanswered_timeout_minute?: InputMaybe<Scalars['String']['input']>;
  unanswered_timeout_target?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<FlowTimeUnit>;
  useDynamicRoute?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  voiceType?: InputMaybe<PhoneNumberSoundType>;
  zohoBlueprintData?: InputMaybe<Array<InputMaybe<ZohoRecordFieldInput>>>;
  zohoConvertMappings?: InputMaybe<Array<InputMaybe<ZohoConvertMappingInput>>>;
  zohoDealStage?: InputMaybe<Scalars['String']['input']>;
  zohoFieldMappings?: InputMaybe<Array<InputMaybe<ZohoFieldMappingInput>>>;
  zohoModule?: InputMaybe<Scalars['String']['input']>;
  zohoNoteContent?: InputMaybe<Scalars['String']['input']>;
  zohoNoteTitle?: InputMaybe<Scalars['String']['input']>;
  zohoOperation?: InputMaybe<ZohoActionOperation>;
  zohoOwnerId?: InputMaybe<Scalars['String']['input']>;
  zohoRecordFields?: InputMaybe<Array<InputMaybe<ZohoRecordFieldInput>>>;
  zohoSearchBy?: InputMaybe<ZohoActionSearchBy>;
  zohoSearchEmail?: InputMaybe<Scalars['String']['input']>;
  zohoSearchId?: InputMaybe<Scalars['String']['input']>;
  zohoSearchOwnerId?: InputMaybe<Scalars['String']['input']>;
  zohoSearchPhone?: InputMaybe<Scalars['String']['input']>;
  zohoStoreCustomFieldId?: InputMaybe<Scalars['ID']['input']>;
  zohoTagsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zohoTagsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zohoTargetModule?: InputMaybe<Scalars['String']['input']>;
  zohoTransitionName?: InputMaybe<Scalars['String']['input']>;
};

export type BlockFieldType = {
  __typename?: 'BlockFieldType';
  adIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aiInstruction?: Maybe<Scalars['String']['output']>;
  aiResponseLanguage?: Maybe<Scalars['String']['output']>;
  aiResponseMappingFieldId?: Maybe<Scalars['ID']['output']>;
  allowed_digits?: Maybe<Array<Maybe<AllowDigitsOutput>>>;
  assignAgentIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  assignee?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  buttonParams?: Maybe<Array<Maybe<FlowTemplateParamType>>>;
  canResponseTimeOut?: Maybe<Scalars['Boolean']['output']>;
  catalogMessage?: Maybe<CatalogInteractiveType>;
  channelId?: Maybe<Scalars['String']['output']>;
  channelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelType?: Maybe<PlatformType>;
  comparison_field?: Maybe<Scalars['String']['output']>;
  condition_field?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  continueAsMainFlow?: Maybe<Scalars['Boolean']['output']>;
  conversationChannel?: Maybe<Scalars['String']['output']>;
  conversationFieldMappings?: Maybe<Array<Maybe<ConversationFieldMappingType>>>;
  conversationSearchBy?: Maybe<ConversationSearchBy>;
  conversationSearchValue?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<FlowBlockFieldCustomFieldsType>>>;
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  delay_time?: Maybe<Scalars['Int']['output']>;
  delay_time_unit?: Maybe<FlowBlockFieldTimeoutUnits>;
  endAt?: Maybe<Scalars['Date']['output']>;
  every?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['ID']['output']>;
  formFieldMappings?: Maybe<Array<Maybe<FormFieldMappingType>>>;
  frequencyMode?: Maybe<FlowTimeFrequencyMode>;
  from?: Maybe<Scalars['String']['output']>;
  globalButtons?: Maybe<Array<Maybe<FlowBlockFieldGlobalButtonsType>>>;
  informativeButtons?: Maybe<Array<Maybe<FlowBlockFieldOptionType>>>;
  isAiReply?: Maybe<Scalars['Boolean']['output']>;
  isButtonRequired?: Maybe<Scalars['Boolean']['output']>;
  isPrivateReply?: Maybe<Scalars['Boolean']['output']>;
  ivr_collect_multi_digits_target?: Maybe<Scalars['String']['output']>;
  ivr_input_mode?: Maybe<Scalars['String']['output']>;
  ivr_not_allowed_digits_target?: Maybe<Scalars['String']['output']>;
  ivr_num_digits?: Maybe<Scalars['Int']['output']>;
  ivr_response_timeout_second?: Maybe<Scalars['String']['output']>;
  ivr_response_timeout_target?: Maybe<Scalars['String']['output']>;
  ivr_speech_language?: Maybe<Scalars['String']['output']>;
  ivr_speech_target?: Maybe<Scalars['String']['output']>;
  keepRunningUntilComplete?: Maybe<Scalars['Boolean']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listMessage?: Maybe<Array<Maybe<FlowBlockFieldSectionType>>>;
  liveChatVisitFrequencyUnit?: Maybe<FlowBlockFieldLiveChatVisitFrequencyUnits>;
  localizedMessages?: Maybe<Array<Maybe<LocalizedMessageType>>>;
  metaEventCurrency?: Maybe<Scalars['String']['output']>;
  metaEventName?: Maybe<Scalars['String']['output']>;
  metaEventValue?: Maybe<Scalars['String']['output']>;
  musicUrl?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  onExistingOwner?: Maybe<Scalars['String']['output']>;
  onlyFromAds?: Maybe<Scalars['Boolean']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  platformIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority?: Maybe<Scalars['String']['output']>;
  qpienModule?: Maybe<QpienActionModule>;
  qpienOperation?: Maybe<QpienActionOperation>;
  qpienShopFieldMappings?: Maybe<Array<Maybe<QpienShopFieldMappingType>>>;
  qpienShopSearchBy?: Maybe<QpienShopSearchBy>;
  qpienShopSearchValue?: Maybe<Scalars['String']['output']>;
  qpienShopSearchValueSecondary?: Maybe<Scalars['String']['output']>;
  qpienShopUpdateFields?: Maybe<Array<Maybe<QpienShopUpdateFieldType>>>;
  question_answer_timeout?: Maybe<Scalars['Int']['output']>;
  question_answer_timeout_unit?: Maybe<FlowBlockFieldTimeoutUnits>;
  quickReplies?: Maybe<Array<Maybe<FlowBlockFieldOptionType>>>;
  receiverPhone?: Maybe<Scalars['String']['output']>;
  requestBody?: Maybe<Scalars['String']['output']>;
  requestBodyFormData?: Maybe<Array<Maybe<FlowBlockFieldHttpRequestFormDataEntryType>>>;
  requestBodyFormDataUrlEncoded?: Maybe<Array<Maybe<FlowBlockFieldHttpRequestFormDataEntryType>>>;
  requestHeaders?: Maybe<Array<Maybe<FlowBlockFieldHttpRequestHeaderType>>>;
  requestMethod?: Maybe<FlowBlockFieldRequestMethod>;
  requestUrl?: Maybe<Scalars['String']['output']>;
  requiredButtonMessage?: Maybe<Scalars['String']['output']>;
  responseDotNotation?: Maybe<Array<Maybe<FlowBlockFieldHttpRequestDotNotationType>>>;
  rule?: Maybe<FlowBlockFieldRules>;
  save_response_to_contact_field?: Maybe<Scalars['String']['output']>;
  save_response_to_ivr_field?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<FlowBlockFieldSectionType>>>;
  should_delay_continue?: Maybe<Scalars['Boolean']['output']>;
  startAt?: Maybe<Scalars['Date']['output']>;
  startFlowNodeStep?: Maybe<Scalars['ID']['output']>;
  startFlowTargetedBot?: Maybe<Scalars['ID']['output']>;
  startMode?: Maybe<FlowTimeStartMode>;
  subject?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetMode?: Maybe<FlowTimeTargetMode>;
  targetOnFailure?: Maybe<Scalars['ID']['output']>;
  targetOnFound?: Maybe<Scalars['ID']['output']>;
  targetOnNotFound?: Maybe<Scalars['ID']['output']>;
  targetOnSuccess?: Maybe<Scalars['ID']['output']>;
  target_on_invalid_input?: Maybe<Scalars['ID']['output']>;
  target_on_not_reply?: Maybe<Scalars['ID']['output']>;
  target_on_reply?: Maybe<Scalars['ID']['output']>;
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueOperator?: Maybe<Scalars['String']['output']>;
  taskDueReference?: Maybe<Scalars['String']['output']>;
  taskDueUnit?: Maybe<Scalars['String']['output']>;
  taskDueValue?: Maybe<Scalars['String']['output']>;
  taskOperation?: Maybe<TaskActionOperation>;
  taskOwnerId?: Maybe<Scalars['ID']['output']>;
  taskPriority?: Maybe<Scalars['String']['output']>;
  taskReminderOffset?: Maybe<Scalars['String']['output']>;
  taskReminderTime?: Maybe<Scalars['String']['output']>;
  taskSearchBy?: Maybe<TaskActionSearchBy>;
  taskSearchId?: Maybe<Scalars['String']['output']>;
  taskStatus?: Maybe<Scalars['String']['output']>;
  taskTagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taskTitle?: Maybe<Scalars['String']['output']>;
  templateConditions?: Maybe<Array<Maybe<QpienActionTemplateConditionType>>>;
  templateParams?: Maybe<Array<Maybe<FlowTemplateParamType>>>;
  ticketState?: Maybe<Scalars['String']['output']>;
  ticketType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  ttsLanguage?: Maybe<Scalars['String']['output']>;
  ttsVoice?: Maybe<Scalars['String']['output']>;
  type: FlowBlockFieldTypes;
  unanswered_timeout_minute?: Maybe<Scalars['String']['output']>;
  unanswered_timeout_target?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<FlowTimeUnit>;
  useDynamicRoute?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  voiceType?: Maybe<PhoneNumberSoundType>;
  zohoBlueprintData?: Maybe<Array<Maybe<ZohoRecordFieldType>>>;
  zohoConvertMappings?: Maybe<Array<Maybe<ZohoConvertMappingType>>>;
  zohoDealStage?: Maybe<Scalars['String']['output']>;
  zohoFieldMappings?: Maybe<Array<Maybe<ZohoFieldMappingType>>>;
  zohoModule?: Maybe<Scalars['String']['output']>;
  zohoNoteContent?: Maybe<Scalars['String']['output']>;
  zohoNoteTitle?: Maybe<Scalars['String']['output']>;
  zohoOperation?: Maybe<ZohoActionOperation>;
  zohoOwnerId?: Maybe<Scalars['String']['output']>;
  zohoRecordFields?: Maybe<Array<Maybe<ZohoRecordFieldType>>>;
  zohoSearchBy?: Maybe<ZohoActionSearchBy>;
  zohoSearchEmail?: Maybe<Scalars['String']['output']>;
  zohoSearchId?: Maybe<Scalars['String']['output']>;
  zohoSearchOwnerId?: Maybe<Scalars['String']['output']>;
  zohoSearchPhone?: Maybe<Scalars['String']['output']>;
  zohoStoreCustomFieldId?: Maybe<Scalars['ID']['output']>;
  zohoTagsToAdd?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zohoTagsToRemove?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zohoTargetModule?: Maybe<Scalars['String']['output']>;
  zohoTransitionName?: Maybe<Scalars['String']['output']>;
};

export type BlockReplaceIndexInput = {
  newIndex: Scalars['Number']['input'];
  node: Scalars['String']['input'];
  targetIndex: Scalars['Number']['input'];
};

export type BlockReplaceIndexResponse = {
  __typename?: 'BlockReplaceIndexResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BodyHeaderInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanResponse = {
  __typename?: 'BooleanResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum BulkAction {
  Copy = 'COPY',
  Delete = 'DELETE',
  Move = 'MOVE'
}

export type BulkSharing = {
  __typename?: 'BulkSharing';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  folders?: Maybe<Array<Maybe<OFolderRes>>>;
  name?: Maybe<Scalars['String']['output']>;
  qpienPersonGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telegramChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telegramSendFileNames?: Maybe<Scalars['Boolean']['output']>;
  telegramSendFolderNames?: Maybe<Scalars['Boolean']['output']>;
  telegramSendingType?: Maybe<Scalars['String']['output']>;
  telegramStatus?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  whatsAppGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  whatsAppSendFileNames?: Maybe<Scalars['Boolean']['output']>;
  whatsAppSendFolderNames?: Maybe<Scalars['Boolean']['output']>;
  whatsAppStatus?: Maybe<Scalars['String']['output']>;
};

export type BulkSharingPage = {
  __typename?: 'BulkSharingPage';
  docs: Array<Maybe<BulkSharing>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type BulkSharingPaginateRes = {
  __typename?: 'BulkSharingPaginateRes';
  code?: Maybe<Scalars['String']['output']>;
  data: BulkSharingPage;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkSharingProcessRes = {
  __typename?: 'BulkSharingProcessRes';
  code?: Maybe<Scalars['String']['output']>;
  data: OBulkSharingProcessType;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkSharingProcessSubscriptionInput = {
  customer?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type BulkSharingResponse = {
  __typename?: 'BulkSharingResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: BulkSharing;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkTagCampaignContactsData = {
  __typename?: 'BulkTagCampaignContactsData';
  matchedContacts: Scalars['Int']['output'];
  modifiedContacts: Scalars['Int']['output'];
};

export type BulkTagCampaignContactsInput = {
  action: CampaignContactTagAction;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isAllSelected?: InputMaybe<Scalars['Boolean']['input']>;
  personIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<AckType>;
  tagId: Scalars['ID']['input'];
};

export type BulkTagCampaignContactsResponse = {
  __typename?: 'BulkTagCampaignContactsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<BulkTagCampaignContactsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkUpdateCollageProductsInput = {
  action: BulkAction;
  collageProducts: Array<InputMaybe<Scalars['ID']['input']>>;
  customerId: Scalars['ID']['input'];
  destinationFolder?: InputMaybe<Scalars['ID']['input']>;
  sourceFolders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type BulkUpdateCollageProductsResponse = {
  __typename?: 'BulkUpdateCollageProductsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessHoursHoliday = {
  __typename?: 'BusinessHoursHoliday';
  closed: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ranges: Array<BusinessHoursRange>;
  repeatYearly: Scalars['Boolean']['output'];
};

export type BusinessHoursHolidayInput = {
  closed: Scalars['Boolean']['input'];
  date: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ranges?: InputMaybe<Array<BusinessHoursRangeInput>>;
  repeatYearly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusinessHoursRange = {
  __typename?: 'BusinessHoursRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type BusinessHoursRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type BusinessHoursSchedule = {
  __typename?: 'BusinessHoursSchedule';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  days: Array<WorkingHour>;
  holidays: Array<BusinessHoursHoliday>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  teams: Array<Scalars['ID']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BusinessHoursScheduleResponse = {
  __typename?: 'BusinessHoursScheduleResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<BusinessHoursSchedule>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessHoursSchedulesResponse = {
  __typename?: 'BusinessHoursSchedulesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<BusinessHoursSchedule>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CBillingContacts = {
  __typename?: 'CBillingContacts';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isEmailEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMobileEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CHistoryStatisticPaginateTypes = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<AckType>;
};

export type CHistoryStatisticTypes = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CMsgStatusStatistics = {
  __typename?: 'CMsgStatusStatistics';
  date?: Maybe<Scalars['String']['output']>;
  statuses?: Maybe<StatusesType>;
};

export type CPersonLogOut = {
  cPersonId: Scalars['ID']['input'];
  deviceType: CustomerPersonDeviceType;
};

export type CPersonNotification = {
  __typename?: 'CPersonNotification';
  _id: Scalars['ID']['output'];
  cPerson: Scalars['ID']['output'];
  category: CPersonNotificationCategory;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Object']['output']>;
  readAt?: Maybe<Scalars['Date']['output']>;
  type: NotificationsType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum CPersonNotificationCategory {
  Announcement = 'ANNOUNCEMENT',
  Contact = 'CONTACT',
  Conversation = 'CONVERSATION',
  Report = 'REPORT',
  Table = 'TABLE',
  Task = 'TASK',
  TeamChat = 'TEAM_CHAT'
}

export type CPersonNotificationMarkReadResponse = {
  __typename?: 'CPersonNotificationMarkReadResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CPersonNotificationMarkUnreadResponse = {
  __typename?: 'CPersonNotificationMarkUnreadResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CPersonNotificationReceivedPayload = {
  __typename?: 'CPersonNotificationReceivedPayload';
  notification: CPersonNotification;
  unreadCount: Scalars['Int']['output'];
};

export type CPersonNotificationReceivedSubInput = {
  cPersonId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type CPersonNotificationResponse = {
  __typename?: 'CPersonNotificationResponse';
  cPersonId: Scalars['ID']['output'];
  type?: Maybe<NotificationsType>;
};

export type CPersonNotificationSubscriptionInput = {
  cPersonId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type CPersonNotificationUnreadInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type CPersonNotificationUnreadResponse = {
  __typename?: 'CPersonNotificationUnreadResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CPersonNotificationsPage = {
  __typename?: 'CPersonNotificationsPage';
  docs: Array<CPersonNotification>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type CPersonNotificationsResponse = {
  __typename?: 'CPersonNotificationsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CPersonNotificationsPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CPersonRole = {
  __typename?: 'CPersonRole';
  _id: Scalars['ID']['output'];
  cPersons: Array<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<RolePermission>;
  status?: Maybe<RoleStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CPersonRoleListPaginatedData = {
  __typename?: 'CPersonRoleListPaginatedData';
  docs: Array<CPersonRole>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type CPersonRoleListResponse = {
  __typename?: 'CPersonRoleListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CPersonRoleListPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CPersonRoleResponse = {
  __typename?: 'CPersonRoleResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CPersonRole>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CPersonStatus {
  Away = 'AWAY',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type CPersonStatusInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  status: CPersonStatus;
};

export type CPersonSubscriptionInput = {
  customer?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type CalculateBalanceUsageInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type CalculatedBalance = {
  __typename?: 'CalculatedBalance';
  balance: Scalars['Float']['output'];
  recipient_count: Scalars['Int']['output'];
  required_balance: Scalars['Float']['output'];
  sufficient: Scalars['Boolean']['output'];
};

export type CallAdminLog = {
  __typename?: 'CallAdminLog';
  _id: Scalars['ID']['output'];
  callSid: Scalars['String']['output'];
  callType?: Maybe<CallAdminLogType>;
  calleeCPersonId?: Maybe<Scalars['ID']['output']>;
  calleeName?: Maybe<Scalars['String']['output']>;
  callerCPersonId?: Maybe<Scalars['ID']['output']>;
  callerName?: Maybe<Scalars['String']['output']>;
  callerNumber?: Maybe<Scalars['String']['output']>;
  childCallSids?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  logs: Array<CallAdminLogStep>;
  parentCallSid?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type CallAdminLogDetailResponse = {
  __typename?: 'CallAdminLogDetailResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallAdminLog>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallAdminLogStep = {
  __typename?: 'CallAdminLogStep';
  correlationId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stepName: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export enum CallAdminLogType {
  Customer = 'CUSTOMER',
  Team = 'TEAM'
}

export type CallAdminLogsData = {
  __typename?: 'CallAdminLogsData';
  logs: Array<CallAdminLog>;
  total: Scalars['Int']['output'];
};

export type CallAdminLogsResponse = {
  __typename?: 'CallAdminLogsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallAdminLogsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallDashboardStatistics = {
  __typename?: 'CallDashboardStatistics';
  avgTalkingTime: Scalars['Int']['output'];
  avgWaitingTime: Scalars['Int']['output'];
  inboundCalls: CallStatusCounts;
  outboundCalls: CallStatusCounts;
  satisfaction: Array<SatisfactionByScore>;
  sentiment: SentimentStats;
  sla: CallSlaStats;
  talkListenRatio?: Maybe<CallDashboardTalkListenRatio>;
  topAgents: Array<TopAgent>;
  topTopics: Array<TopTopic>;
  totalCalls: TotalCalls;
  totalTalkingTime: Scalars['Int']['output'];
};

export type CallDashboardStatisticsResult = {
  __typename?: 'CallDashboardStatisticsResult';
  code?: Maybe<Scalars['String']['output']>;
  data: CallDashboardStatistics;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CallDashboardTalkListenRatio = {
  __typename?: 'CallDashboardTalkListenRatio';
  listen?: Maybe<Scalars['Int']['output']>;
  talk?: Maybe<Scalars['Int']['output']>;
};

export type CallDataType = {
  __typename?: 'CallDataType';
  accountSubSid?: Maybe<Scalars['String']['output']>;
  accountSubToken?: Maybe<Scalars['String']['output']>;
  attemptCount?: Maybe<Scalars['Int']['output']>;
  callDuration?: Maybe<Scalars['Int']['output']>;
  callId?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  hangupBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum CallDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type CallHistoryActiveCPersons = {
  __typename?: 'CallHistoryActiveCPersons';
  cPersonId?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
};

export type CallHistoryActiveCPersonsResult = {
  __typename?: 'CallHistoryActiveCPersonsResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CallHistoryActiveCPersons>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryAverageTimeChartData = {
  __typename?: 'CallHistoryAverageTimeChartData';
  averageTime?: Maybe<Scalars['Number']['output']>;
  date: Scalars['String']['output'];
};

export type CallHistoryAverageTimeChartDataResult = {
  __typename?: 'CallHistoryAverageTimeChartDataResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CallHistoryAverageTimeChartData>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryAverageTimeChartDataType = {
  __typename?: 'CallHistoryAverageTimeChartDataType';
  averageTime?: Maybe<Scalars['Number']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CallHistoryByDirectionCount = {
  __typename?: 'CallHistoryByDirectionCount';
  date?: Maybe<Scalars['String']['output']>;
  inbound?: Maybe<Scalars['Number']['output']>;
  outbound?: Maybe<Scalars['Number']['output']>;
};

export type CallHistoryCountByDirectionResult = {
  __typename?: 'CallHistoryCountByDirectionResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CallHistoryByDirectionCount>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryCountChartData = {
  __typename?: 'CallHistoryCountChartData';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  status: CallHistoryStatus;
};

export type CallHistoryCountChartDataResult = {
  __typename?: 'CallHistoryCountChartDataResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CallHistoryCountChartData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryCountChartDataType = {
  __typename?: 'CallHistoryCountChartDataType';
  abandoned?: Maybe<Scalars['Number']['output']>;
  answered?: Maybe<Scalars['Number']['output']>;
  cancelled?: Maybe<Scalars['Number']['output']>;
  declined?: Maybe<Scalars['Number']['output']>;
  failed?: Maybe<Scalars['Number']['output']>;
  in_progress?: Maybe<Scalars['Number']['output']>;
  in_queue?: Maybe<Scalars['Number']['output']>;
  ivr_abandoned?: Maybe<Scalars['Number']['output']>;
  missed?: Maybe<Scalars['Number']['output']>;
  no_answer?: Maybe<Scalars['Number']['output']>;
  queue_abandoned?: Maybe<Scalars['Number']['output']>;
  rejected?: Maybe<Scalars['Number']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unreachable?: Maybe<Scalars['Number']['output']>;
};

export type CallHistoryCustomerPersons = {
  __typename?: 'CallHistoryCustomerPersons';
  _id: Scalars['ID']['output'];
  abandoned?: Maybe<Scalars['Number']['output']>;
  answered?: Maybe<Scalars['Number']['output']>;
  averageTime?: Maybe<Scalars['Number']['output']>;
  declined?: Maybe<Scalars['Number']['output']>;
  inbound?: Maybe<Scalars['Number']['output']>;
  missed?: Maybe<Scalars['Number']['output']>;
  outbound?: Maybe<Scalars['Number']['output']>;
  transfer?: Maybe<Scalars['Number']['output']>;
};

export type CallHistoryCustomerPersonsResult = {
  __typename?: 'CallHistoryCustomerPersonsResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CallHistoryCustomerPersons>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistorySatisfactionChartDataResult = {
  __typename?: 'CallHistorySatisfactionChartDataResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SatisfactionChartData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistorySentimentChartData = {
  __typename?: 'CallHistorySentimentChartData';
  byAgent: Array<SentimentByAgent>;
  byTime: Array<SentimentByTime>;
  byTopic: Array<SentimentByTopic>;
};

export type CallHistorySentimentChartDataResult = {
  __typename?: 'CallHistorySentimentChartDataResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallHistorySentimentChartData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistorySlaAgentStatistics = {
  __typename?: 'CallHistorySlaAgentStatistics';
  averageSeconds: Scalars['Float']['output'];
  breached: Scalars['Int']['output'];
  cPersonId: Scalars['String']['output'];
  met: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CallHistorySlaAgentStatisticsData = {
  __typename?: 'CallHistorySlaAgentStatisticsData';
  agents: Array<CallHistorySlaAgentStatistics>;
  metric: CallHistorySlaMetric;
};

export type CallHistorySlaAgentStatisticsResult = {
  __typename?: 'CallHistorySlaAgentStatisticsResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallHistorySlaAgentStatisticsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistorySlaAvgPoint = {
  __typename?: 'CallHistorySlaAvgPoint';
  averageSeconds: Scalars['Float']['output'];
  averageTargetSeconds: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type CallHistorySlaAvgSeries = {
  __typename?: 'CallHistorySlaAvgSeries';
  byTime: Array<CallHistorySlaAvgPoint>;
  totals: CallHistorySlaAvgTotal;
};

export type CallHistorySlaAvgTotal = {
  __typename?: 'CallHistorySlaAvgTotal';
  averageSeconds: Scalars['Float']['output'];
  averageTargetSeconds: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
};

export type CallHistorySlaComparisonPoint = {
  __typename?: 'CallHistorySlaComparisonPoint';
  date: Scalars['String']['output'];
  resolutionAverageSeconds: Scalars['Float']['output'];
  responseAverageSeconds: Scalars['Float']['output'];
};

export enum CallHistorySlaMetric {
  Resolution = 'resolution',
  Response = 'response'
}

export type CallHistorySlaMetricSummary = {
  __typename?: 'CallHistorySlaMetricSummary';
  avg: CallHistorySlaAvgTotal;
  statusTotals: Array<CallHistorySlaStatusTotal>;
};

export enum CallHistorySlaStatus {
  Breached = 'breached',
  Met = 'met'
}

export type CallHistorySlaStatusPoint = {
  __typename?: 'CallHistorySlaStatusPoint';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type CallHistorySlaStatusSeries = {
  __typename?: 'CallHistorySlaStatusSeries';
  byTime: Array<CallHistorySlaStatusPoint>;
  totals: CallHistorySlaStatusTotal;
};

export type CallHistorySlaStatusStatistics = {
  __typename?: 'CallHistorySlaStatusStatistics';
  byTime: Array<CallHistorySlaStatusPoint>;
  metric: CallHistorySlaMetric;
  selectedStatus: CallHistorySlaStatus;
  totals: Array<CallHistorySlaStatusTotal>;
};

export type CallHistorySlaStatusStatisticsResult = {
  __typename?: 'CallHistorySlaStatusStatisticsResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallHistorySlaStatusStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistorySlaStatusTotal = {
  __typename?: 'CallHistorySlaStatusTotal';
  count: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
  status: Scalars['String']['output'];
};

export type CallHistorySlaSummaryStatistics = {
  __typename?: 'CallHistorySlaSummaryStatistics';
  resolution: CallHistorySlaMetricSummary;
  response: CallHistorySlaMetricSummary;
};

export type CallHistorySlaSummaryStatisticsResult = {
  __typename?: 'CallHistorySlaSummaryStatisticsResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallHistorySlaSummaryStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistorySlaTimeStatistics = {
  __typename?: 'CallHistorySlaTimeStatistics';
  byTime: Array<CallHistorySlaAvgPoint>;
  metric: CallHistorySlaMetric;
  totals: CallHistorySlaAvgTotal;
};

export type CallHistorySlaTimeStatisticsResult = {
  __typename?: 'CallHistorySlaTimeStatisticsResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallHistorySlaTimeStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryStatus = {
  __typename?: 'CallHistoryStatus';
  abandoned?: Maybe<Scalars['Int']['output']>;
  answered?: Maybe<Scalars['Int']['output']>;
  cancelled?: Maybe<Scalars['Int']['output']>;
  declined?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  in_progress?: Maybe<Scalars['Int']['output']>;
  in_queue?: Maybe<Scalars['Int']['output']>;
  ivr_abandoned?: Maybe<Scalars['Int']['output']>;
  missed?: Maybe<Scalars['Int']['output']>;
  no_answer?: Maybe<Scalars['Int']['output']>;
  queue_abandoned?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  unreachable?: Maybe<Scalars['Int']['output']>;
};

export type CallHistoryTalkListenChartData = {
  __typename?: 'CallHistoryTalkListenChartData';
  byAgent: Array<TalkListenByAgent>;
  byTime: Array<TalkListenByTime>;
  byTopic: Array<TalkListenByTopic>;
};

export type CallHistoryTalkListenChartDataResult = {
  __typename?: 'CallHistoryTalkListenChartDataResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallHistoryTalkListenChartData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryTopicsChartData = {
  __typename?: 'CallHistoryTopicsChartData';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
  topicId: Scalars['ID']['output'];
};

export type CallHistoryTopicsChartDataResult = {
  __typename?: 'CallHistoryTopicsChartDataResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<CallHistoryTopicsChartData>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryTotalCostChartData = {
  __typename?: 'CallHistoryTotalCostChartData';
  date: Scalars['String']['output'];
  inbound?: Maybe<Scalars['Int']['output']>;
  outbound?: Maybe<Scalars['Int']['output']>;
};

export type CallHistoryTotalCostChartDataResult = {
  __typename?: 'CallHistoryTotalCostChartDataResult';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CallHistoryTotalCostChartData>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallLog = {
  __typename?: 'CallLog';
  _id: Scalars['ID']['output'];
  aiAnalysis?: Maybe<CallLogAiAnalysis>;
  attemptCount?: Maybe<Scalars['Int']['output']>;
  callSid: Scalars['String']['output'];
  calledNumber?: Maybe<Scalars['String']['output']>;
  callerNumber?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  customerPersonId?: Maybe<CustomerPerson>;
  direction: Scalars['String']['output'];
  duration?: Maybe<Scalars['Double']['output']>;
  hangsUpBy?: Maybe<Scalars['String']['output']>;
  inProgressTime?: Maybe<Scalars['Double']['output']>;
  inQueueTime?: Maybe<Scalars['Double']['output']>;
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['ID']['output']>;
  platformId: Scalars['ID']['output'];
  recordUrl?: Maybe<Scalars['String']['output']>;
  satisfactionRate?: Maybe<Scalars['Int']['output']>;
  sla?: Maybe<CallSla>;
  status?: Maybe<Scalars['String']['output']>;
  talkListenRatio?: Maybe<TalkListenRatio>;
  talkTime?: Maybe<Scalars['Double']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CallLogAiAnalysis = {
  __typename?: 'CallLogAiAnalysis';
  _id: Scalars['ID']['output'];
  callSid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  sentiment?: Maybe<IAiAnalysisSentiment>;
  summary?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<IAiAnalysisTopic>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CallLogResponse = {
  __typename?: 'CallLogResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallLog>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallLogsData = {
  __typename?: 'CallLogsData';
  logs: Array<CallLog>;
  total: Scalars['Int']['output'];
};

export type CallLogsResponse = {
  __typename?: 'CallLogsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CallLogsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSla = {
  __typename?: 'CallSla';
  excludedReasons?: Maybe<Array<Scalars['String']['output']>>;
  resolutionTime?: Maybe<CallSlaMetric>;
  responseTime?: Maybe<CallSlaMetric>;
};

export type CallSlaMetric = {
  __typename?: 'CallSlaMetric';
  status?: Maybe<Scalars['String']['output']>;
  targetSeconds?: Maybe<Scalars['Int']['output']>;
};

export type CallSlaStats = {
  __typename?: 'CallSlaStats';
  breached: Scalars['Int']['output'];
  met: Scalars['Int']['output'];
};

export enum CallSnapshotStatisticsAggregation {
  Avg = 'avg',
  Count = 'count',
  Max = 'max',
  Min = 'min',
  Rate = 'rate',
  Sum = 'sum'
}

export type CallSnapshotStatisticsAppliedFilter = {
  __typename?: 'CallSnapshotStatisticsAppliedFilter';
  field: Scalars['String']['output'];
  operator: CallSnapshotStatisticsFilterOperator;
  value: Scalars['Object']['output'];
};

export enum CallSnapshotStatisticsCountTarget {
  Snapshot = 'snapshot'
}

export type CallSnapshotStatisticsDataPoint = {
  __typename?: 'CallSnapshotStatisticsDataPoint';
  segment?: Maybe<Scalars['Object']['output']>;
  value: Scalars['Double']['output'];
};

export enum CallSnapshotStatisticsDateField {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export enum CallSnapshotStatisticsDatePreset {
  Last7days = 'last7days',
  Last30days = 'last30days',
  Last90days = 'last90days',
  LastMonth = 'lastMonth',
  ThisMonth = 'thisMonth',
  Today = 'today',
  Yesterday = 'yesterday'
}

export type CallSnapshotStatisticsDateRangeInput = {
  field?: InputMaybe<CallSnapshotStatisticsDateField>;
  from?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<CallSnapshotStatisticsDatePreset>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type CallSnapshotStatisticsFilterInput = {
  field: Scalars['String']['input'];
  operator: CallSnapshotStatisticsFilterOperator;
  value: Scalars['Object']['input'];
};

export enum CallSnapshotStatisticsFilterOperator {
  Eq = 'eq',
  In = 'in'
}

export enum CallSnapshotStatisticsGranularity {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week'
}

export type CallSnapshotStatisticsMeta = {
  __typename?: 'CallSnapshotStatisticsMeta';
  appliedFilters: Array<CallSnapshotStatisticsAppliedFilter>;
  dateRange?: Maybe<CallSnapshotStatisticsResolvedDateRange>;
  segmentBy?: Maybe<CallSnapshotStatisticsSegmentByMeta>;
  viewBy: CallSnapshotStatisticsViewByMeta;
};

export type CallSnapshotStatisticsResolvedDateRange = {
  __typename?: 'CallSnapshotStatisticsResolvedDateRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type CallSnapshotStatisticsResponse = {
  __typename?: 'CallSnapshotStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CallSnapshotStatisticsResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CallSnapshotStatisticsResult = {
  __typename?: 'CallSnapshotStatisticsResult';
  data: Array<CallSnapshotStatisticsDataPoint>;
  meta: CallSnapshotStatisticsMeta;
};

export type CallSnapshotStatisticsSegmentByInput = {
  field: Scalars['String']['input'];
  granularity?: InputMaybe<CallSnapshotStatisticsGranularity>;
};

export type CallSnapshotStatisticsSegmentByMeta = {
  __typename?: 'CallSnapshotStatisticsSegmentByMeta';
  field: Scalars['String']['output'];
  granularity?: Maybe<Scalars['String']['output']>;
};

export type CallSnapshotStatisticsViewByInput = {
  aggregation: CallSnapshotStatisticsAggregation;
  countTarget?: InputMaybe<CallSnapshotStatisticsCountTarget>;
  field: Scalars['String']['input'];
};

export type CallSnapshotStatisticsViewByMeta = {
  __typename?: 'CallSnapshotStatisticsViewByMeta';
  aggregation: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export enum CallStatus {
  Abandoned = 'abandoned',
  Answered = 'answered',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Failed = 'failed',
  InProgress = 'in_progress',
  InQueue = 'in_queue',
  IvrAbandoned = 'ivr_abandoned',
  Missed = 'missed',
  NoAnswer = 'no_answer',
  QueueAbandoned = 'queue_abandoned',
  Rejected = 'rejected',
  Unreachable = 'unreachable'
}

export type CallStatusCounts = {
  __typename?: 'CallStatusCounts';
  answered: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  _id: Scalars['ID']['output'];
  abTest?: Maybe<CampaignAbTest>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  attribution?: Maybe<CampaignAttribution>;
  audienceSummary?: Maybe<CampaignAudienceSummary>;
  cPerson: Scalars['ID']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  duplicatedFrom?: Maybe<Scalars['ID']['output']>;
  dynamicGroupRecipients?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  engineVersion?: Maybe<Scalars['Int']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  platformInfo?: Maybe<CampaignPlatformInfoType>;
  runtime?: Maybe<CampaignRuntime>;
  scheduleDate?: Maybe<Scalars['Date']['output']>;
  sendingPlan?: Maybe<CampaignSendingPlan>;
  smartSending?: Maybe<CampaignSmartSending>;
  stats?: Maybe<CampaignStats>;
  status: CampaignStatusEnum;
  statusReason?: Maybe<CampaignStatusReason>;
  survey?: Maybe<Scalars['ID']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalRecipientCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  variationStats?: Maybe<CampaignVariationStats>;
  variations?: Maybe<Array<Maybe<CampaignVariation>>>;
};

export type CampaignAbTest = {
  __typename?: 'CampaignAbTest';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  holdoutReleased?: Maybe<Scalars['Int']['output']>;
  holdoutReleasedAt?: Maybe<Scalars['Date']['output']>;
  holdoutSize?: Maybe<Scalars['Int']['output']>;
  minSamplePerVariation?: Maybe<Scalars['Int']['output']>;
  testCohortSize?: Maybe<Scalars['Int']['output']>;
  testCompletedAt?: Maybe<Scalars['Date']['output']>;
  testSizePercent?: Maybe<Scalars['Int']['output']>;
  winnerConfidence?: Maybe<Scalars['Float']['output']>;
  winnerDecidedAt?: Maybe<Scalars['Date']['output']>;
  winnerKey?: Maybe<Scalars['String']['output']>;
  winnerMetric?: Maybe<CampaignWinnerMetric>;
  winnerReason?: Maybe<CampaignWinnerReason>;
  winnerWaitMinutes?: Maybe<Scalars['Int']['output']>;
};

export type CampaignAbTestInput = {
  minSamplePerVariation?: InputMaybe<Scalars['Int']['input']>;
  testSizePercent?: InputMaybe<Scalars['Int']['input']>;
  winnerMetric?: InputMaybe<CampaignWinnerMetric>;
  winnerWaitMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignAnalysis = {
  __typename?: 'CampaignAnalysis';
  generatedAt?: Maybe<Scalars['Date']['output']>;
  issues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  language?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strengths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type CampaignAttribution = {
  __typename?: 'CampaignAttribution';
  conversionWindowDays?: Maybe<Scalars['Int']['output']>;
  destinationUrl?: Maybe<Scalars['String']['output']>;
  engagementWindowDays?: Maybe<Scalars['Int']['output']>;
  utm?: Maybe<CampaignUtm>;
};

export type CampaignAttributionInput = {
  conversionWindowDays?: InputMaybe<Scalars['Int']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  engagementWindowDays?: InputMaybe<Scalars['Int']['input']>;
  utm?: InputMaybe<CampaignUtmInput>;
};

export type CampaignAudienceMeasure = {
  __typename?: 'CampaignAudienceMeasure';
  costSampled?: Maybe<Scalars['Boolean']['output']>;
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  segments?: Maybe<Array<Maybe<CampaignAudienceSegmentSize>>>;
  sendable?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<CampaignSkippedBreakdown>;
  totalTargeted?: Maybe<Scalars['Int']['output']>;
  uniqueTargeted?: Maybe<Scalars['Int']['output']>;
};

export type CampaignAudienceSegmentSize = {
  __typename?: 'CampaignAudienceSegmentSize';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type CampaignAudienceSummary = {
  __typename?: 'CampaignAudienceSummary';
  computedAt?: Maybe<Scalars['Date']['output']>;
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  estimatedDurationMinutes?: Maybe<Scalars['Int']['output']>;
  sendable?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<CampaignSkippedBreakdown>;
  totalTargeted?: Maybe<Scalars['Int']['output']>;
  uniqueTargeted?: Maybe<Scalars['Int']['output']>;
};

export type CampaignBalanceStatus = {
  __typename?: 'CampaignBalanceStatus';
  available?: Maybe<Scalars['Float']['output']>;
  charged?: Maybe<Scalars['Boolean']['output']>;
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  sufficient?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignBatch = {
  __typename?: 'CampaignBatch';
  chunks?: Maybe<Scalars['Int']['output']>;
  gapMinutes?: Maybe<Scalars['Int']['output']>;
};

export type CampaignBatchInput = {
  chunks: Scalars['Int']['input'];
  gapMinutes: Scalars['Int']['input'];
};

export type CampaignCalendarInput = {
  abTest?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelTypes?: InputMaybe<Array<CampaignPlatformType>>;
  customerId: Scalars['ID']['input'];
  displayStatuses?: InputMaybe<Array<CampaignDisplayStatus>>;
  from: Scalars['Date']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statusGroup?: InputMaybe<CampaignStatusGroup>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to: Scalars['Date']['input'];
};

export type CampaignCalendarResponse = {
  __typename?: 'CampaignCalendarResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CampaignListRow>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CampaignCheckCode {
  Audience = 'AUDIENCE',
  Balance = 'BALANCE',
  BatchPlan = 'BATCH_PLAN',
  Category = 'CATEGORY',
  Channel = 'CHANNEL',
  ChannelQuality = 'CHANNEL_QUALITY',
  MissingValues = 'MISSING_VALUES',
  NoSendable = 'NO_SENDABLE',
  RateClamped = 'RATE_CLAMPED',
  SkipRatio = 'SKIP_RATIO',
  Template = 'TEMPLATE',
  Tier = 'TIER',
  Tracking = 'TRACKING',
  Variable = 'VARIABLE',
  Variation = 'VARIATION',
  Weights = 'WEIGHTS',
  WinnerMetric = 'WINNER_METRIC'
}

export enum CampaignCheckSeverity {
  Blocker = 'BLOCKER',
  Warning = 'WARNING'
}

export type CampaignComparisonRow = {
  __typename?: 'CampaignComparisonRow';
  _id: Scalars['ID']['output'];
  platform?: Maybe<CampaignPlatformType>;
  rates?: Maybe<CampaignRates>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  stats?: Maybe<CampaignStats>;
  status?: Maybe<CampaignStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  variations?: Maybe<Array<Maybe<CampaignVariationReport>>>;
};

export enum CampaignContactTagAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type CampaignConversionListInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  recipientId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CampaignConversionMatchType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type CampaignConversionPage = {
  __typename?: 'CampaignConversionPage';
  nextCursor?: Maybe<Scalars['ID']['output']>;
  rows?: Maybe<Array<Maybe<CampaignConversionRow>>>;
};

export type CampaignConversionPageResponse = {
  __typename?: 'CampaignConversionPageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignConversionPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignConversionRow = {
  __typename?: 'CampaignConversionRow';
  _id?: Maybe<Scalars['ID']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  holdout?: Maybe<Scalars['Boolean']['output']>;
  matchType?: Maybe<CampaignConversionMatchType>;
  order?: Maybe<Scalars['ID']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  placedAt?: Maybe<Scalars['Date']['output']>;
  recipient?: Maybe<Scalars['ID']['output']>;
  reversedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CampaignConversionStatus>;
  touchAt?: Maybe<Scalars['Date']['output']>;
  variationKey?: Maybe<Scalars['String']['output']>;
};

export enum CampaignConversionStatus {
  Active = 'ACTIVE',
  Reversed = 'REVERSED'
}

export type CampaignCost = {
  __typename?: 'CampaignCost';
  billed?: Maybe<Scalars['Float']['output']>;
  charged?: Maybe<Scalars['Boolean']['output']>;
  estimated?: Maybe<Scalars['Float']['output']>;
};

export enum CampaignDisplayStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Paused = 'PAUSED',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING'
}

export enum CampaignErrorClass {
  AccountFatal = 'ACCOUNT_FATAL',
  MessagingLimit = 'MESSAGING_LIMIT',
  OptOut = 'OPT_OUT',
  Permanent = 'PERMANENT',
  Quality = 'QUALITY',
  RateLimit = 'RATE_LIMIT',
  RecipientLimit = 'RECIPIENT_LIMIT',
  Template = 'TEMPLATE',
  Transient = 'TRANSIENT',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN'
}

export type CampaignEventPricing = {
  __typename?: 'CampaignEventPricing';
  billable?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
};

export type CampaignEventRow = {
  __typename?: 'CampaignEventRow';
  _id?: Maybe<Scalars['ID']['output']>;
  attemptN?: Maybe<Scalars['Int']['output']>;
  delayed?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<CampaignRecipientError>;
  late?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['ID']['output']>;
  occurredAt?: Maybe<Scalars['Date']['output']>;
  occurredAtSource?: Maybe<Scalars['String']['output']>;
  outOfWindow?: Maybe<Scalars['Boolean']['output']>;
  pricing?: Maybe<CampaignEventPricing>;
  receivedAt?: Maybe<Scalars['Date']['output']>;
  repeatCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CampaignEventType>;
};

export enum CampaignEventType {
  Clicked = 'CLICKED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Read = 'READ',
  Replied = 'REPLIED',
  Sent = 'SENT'
}

export type CampaignFailureGroup = {
  __typename?: 'CampaignFailureGroup';
  autoRetried?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  errorClass?: Maybe<CampaignErrorClass>;
  message?: Maybe<Scalars['String']['output']>;
  retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignHistory = {
  __typename?: 'CampaignHistory';
  _id: Scalars['ID']['output'];
  campaign: Scalars['ID']['output'];
  cost?: Maybe<Scalars['Double']['output']>;
  customer: Scalars['ID']['output'];
  messageDetails?: Maybe<MsgDetailsType>;
  messageId: Scalars['ID']['output'];
  personInfo?: Maybe<CampaignPersonInfoType>;
};

export type CampaignHourlyPoint = {
  __typename?: 'CampaignHourlyPoint';
  counts?: Maybe<CampaignMetricCounts>;
  hour?: Maybe<Scalars['Date']['output']>;
  variations?: Maybe<CampaignMetricCountsByVariation>;
};

export type CampaignLaunchCheck = {
  __typename?: 'CampaignLaunchCheck';
  code?: Maybe<CampaignCheckCode>;
  message?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<CampaignCheckSeverity>;
  variation?: Maybe<Scalars['String']['output']>;
};

export type CampaignLifecycleInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type CampaignListChannel = {
  __typename?: 'CampaignListChannel';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  senderPhone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CampaignPlatformType>;
};

export type CampaignListCountResponse = {
  __typename?: 'CampaignListCountResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignListPage = {
  __typename?: 'CampaignListPage';
  conversionMeasured?: Maybe<Scalars['Boolean']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<CampaignListRow>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CampaignListResponse = {
  __typename?: 'CampaignListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignPaginateResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignListRow = {
  __typename?: 'CampaignListRow';
  _id?: Maybe<Scalars['ID']['output']>;
  abTest?: Maybe<Scalars['Boolean']['output']>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  channel?: Maybe<CampaignListChannel>;
  clicked?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  converted?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  displayStatus?: Maybe<CampaignDisplayStatus>;
  engineVersion?: Maybe<Scalars['Int']['output']>;
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  rates?: Maybe<CampaignRates>;
  read?: Maybe<Scalars['Int']['output']>;
  recipients?: Maybe<Scalars['Int']['output']>;
  replied?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueByCurrency?: Maybe<Array<Maybe<CampaignRevenue>>>;
  scheduleDate?: Maybe<Scalars['Date']['output']>;
  segmentIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  sendDate?: Maybe<Scalars['Date']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CampaignStatusEnum>;
  statusReason?: Maybe<CampaignStatusReason>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum CampaignListSort {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type CampaignMedia = {
  __typename?: 'CampaignMedia';
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CampaignMediaInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type CampaignMediaResponse = {
  __typename?: 'CampaignMediaResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignMedia>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignMetricCounts = {
  __typename?: 'CampaignMetricCounts';
  clicked?: Maybe<Scalars['Int']['output']>;
  converted?: Maybe<Scalars['Int']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  read?: Maybe<Scalars['Int']['output']>;
  replied?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type CampaignMetricCountsByVariation = {
  __typename?: 'CampaignMetricCountsByVariation';
  A?: Maybe<CampaignMetricCounts>;
  B?: Maybe<CampaignMetricCounts>;
  C?: Maybe<CampaignMetricCounts>;
  D?: Maybe<CampaignMetricCounts>;
  E?: Maybe<CampaignMetricCounts>;
};

export type CampaignMissingValueCount = {
  __typename?: 'CampaignMissingValueCount';
  count?: Maybe<Scalars['Int']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['Int']['output']>;
  variation?: Maybe<Scalars['String']['output']>;
};

export type CampaignPaginateResponse = {
  __typename?: 'CampaignPaginateResponse';
  docs?: Maybe<Array<Maybe<Campaign>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type CampaignPlatformInfoInput = {
  _id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  senderPhone?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateParams?: InputMaybe<Array<InputMaybe<WpTemplateParams>>>;
  type?: InputMaybe<CampaignPlatformType>;
};

export type CampaignPlatformInfoType = {
  __typename?: 'CampaignPlatformInfoType';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  senderPhone?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateParams?: Maybe<Array<Maybe<WpTemplateType>>>;
  type?: Maybe<CampaignPlatformType>;
};

export enum CampaignPlatformType {
  Email = 'EMAIL',
  MetaWhatsAppBusiness = 'META_WHATS_APP_BUSINESS',
  Sms = 'SMS',
  WhatsAppBusiness = 'WHATS_APP_BUSINESS',
  WhatsAppWeb = 'WHATS_APP_WEB'
}

export type CampaignProgress = {
  __typename?: 'CampaignProgress';
  batchChunks?: Maybe<Scalars['Int']['output']>;
  batchIndex?: Maybe<Scalars['Int']['output']>;
  done?: Maybe<Scalars['Int']['output']>;
  estimatedEndAt?: Maybe<Scalars['Date']['output']>;
  estimatedRemainingMinutes?: Maybe<Scalars['Int']['output']>;
  heldOut?: Maybe<Scalars['Int']['output']>;
  inFlight?: Maybe<Scalars['Int']['output']>;
  nextBatchAt?: Maybe<Scalars['Date']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  ratePerMinute?: Maybe<Scalars['Float']['output']>;
  retrying?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  waitingTemplate?: Maybe<Scalars['Int']['output']>;
};

export type CampaignRate = {
  __typename?: 'CampaignRate';
  count?: Maybe<Scalars['Int']['output']>;
  per?: Maybe<CampaignRatePer>;
};

export type CampaignRateInput = {
  count: Scalars['Int']['input'];
  per: CampaignRatePer;
};

export enum CampaignRatePer {
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

export type CampaignRates = {
  __typename?: 'CampaignRates';
  clickRate?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  deliveryRate?: Maybe<Scalars['Float']['output']>;
  failureRate?: Maybe<Scalars['Float']['output']>;
  readRate?: Maybe<Scalars['Float']['output']>;
  replyRate?: Maybe<Scalars['Float']['output']>;
  skipRate?: Maybe<Scalars['Float']['output']>;
};

export type CampaignRecipientAttempt = {
  __typename?: 'CampaignRecipientAttempt';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  error?: Maybe<CampaignRecipientError>;
  message?: Maybe<Scalars['ID']['output']>;
  n?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
};

export type CampaignRecipientError = {
  __typename?: 'CampaignRecipientError';
  at?: Maybe<Scalars['Date']['output']>;
  class?: Maybe<CampaignErrorClass>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CampaignRecipientFilter {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Clicked = 'CLICKED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  HeldOut = 'HELD_OUT',
  Pending = 'PENDING',
  Read = 'READ',
  Replied = 'REPLIED',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

export type CampaignRecipientListInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  errorClass?: InputMaybe<CampaignErrorClass>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CampaignRecipientFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skipReason?: InputMaybe<Scalars['String']['input']>;
  variationKey?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignRecipientPage = {
  __typename?: 'CampaignRecipientPage';
  nextCursor?: Maybe<Scalars['ID']['output']>;
  rows?: Maybe<Array<Maybe<CampaignRecipientRow>>>;
};

export type CampaignRecipientPageResponse = {
  __typename?: 'CampaignRecipientPageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignRecipientPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignRecipientRow = {
  __typename?: 'CampaignRecipientRow';
  _id?: Maybe<Scalars['ID']['output']>;
  attempt?: Maybe<Scalars['Int']['output']>;
  attempts?: Maybe<Array<Maybe<CampaignRecipientAttempt>>>;
  autoRetries?: Maybe<Scalars['Int']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  convertedAt?: Maybe<Scalars['Date']['output']>;
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  firstClickedAt?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  holdout?: Maybe<Scalars['Boolean']['output']>;
  lastError?: Maybe<CampaignRecipientError>;
  message?: Maybe<Scalars['ID']['output']>;
  nextAttemptAt?: Maybe<Scalars['Date']['output']>;
  person?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['Date']['output']>;
  repliedAt?: Maybe<Scalars['Date']['output']>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CampaignRecipientStatus>;
  variationKey?: Maybe<Scalars['String']['output']>;
};

export enum CampaignRecipientStatus {
  Cancelled = 'CANCELLED',
  Claimed = 'CLAIMED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  PendingWinner = 'PENDING_WINNER',
  Queued = 'QUEUED',
  Read = 'READ',
  RetryWait = 'RETRY_WAIT',
  Sending = 'SENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED',
  TemplateWait = 'TEMPLATE_WAIT'
}

export type CampaignRecipientTimeline = {
  __typename?: 'CampaignRecipientTimeline';
  events?: Maybe<Array<Maybe<CampaignEventRow>>>;
  recipient?: Maybe<CampaignRecipientRow>;
};

export type CampaignRecipientTimelineInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  recipientId: Scalars['ID']['input'];
};

export type CampaignRecipientTimelineResponse = {
  __typename?: 'CampaignRecipientTimelineResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignRecipientTimeline>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignReport = {
  __typename?: 'CampaignReport';
  abTest?: Maybe<CampaignAbTest>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  conversionMeasured?: Maybe<Scalars['Boolean']['output']>;
  cost?: Maybe<CampaignCost>;
  failures?: Maybe<Array<Maybe<CampaignFailureGroup>>>;
  hourly?: Maybe<Array<Maybe<CampaignHourlyPoint>>>;
  progress?: Maybe<CampaignProgress>;
  rates?: Maybe<CampaignRates>;
  skipped?: Maybe<Array<Maybe<CampaignSkipGroup>>>;
  stats?: Maybe<CampaignStats>;
  status?: Maybe<CampaignStatusEnum>;
  statusReason?: Maybe<CampaignStatusReason>;
  timeZone?: Maybe<Scalars['String']['output']>;
  variations?: Maybe<Array<Maybe<CampaignVariationReportRow>>>;
};

export type CampaignReportInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type CampaignReportResponse = {
  __typename?: 'CampaignReportResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignReport>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignResponse = {
  __typename?: 'CampaignResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Campaign;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignRevenue = {
  __typename?: 'CampaignRevenue';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
};

export type CampaignRuntime = {
  __typename?: 'CampaignRuntime';
  batchIndex?: Maybe<Scalars['Int']['output']>;
  batchSentCount?: Maybe<Scalars['Int']['output']>;
  billedAt?: Maybe<Scalars['Date']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastTickAt?: Maybe<Scalars['Date']['output']>;
  nextBatchAt?: Maybe<Scalars['Date']['output']>;
  pausedAt?: Maybe<Scalars['Date']['output']>;
  resumeAt?: Maybe<Scalars['Date']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
};

export type CampaignSendTimeline = {
  __typename?: 'CampaignSendTimeline';
  batches?: Maybe<Array<Maybe<CampaignSendTimelineBatch>>>;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['Date']['output']>;
  holdout?: Maybe<Scalars['Int']['output']>;
  ratePerMinute?: Maybe<Scalars['Float']['output']>;
  startAt?: Maybe<Scalars['Date']['output']>;
  testCohort?: Maybe<Scalars['Int']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  winnerAt?: Maybe<Scalars['Date']['output']>;
};

export type CampaignSendTimelineBatch = {
  __typename?: 'CampaignSendTimelineBatch';
  endAt?: Maybe<Scalars['Date']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['Date']['output']>;
};

export enum CampaignSendingMode {
  Fastest = 'FASTEST',
  RateLimited = 'RATE_LIMITED'
}

export type CampaignSendingPlan = {
  __typename?: 'CampaignSendingPlan';
  batch?: Maybe<CampaignBatch>;
  mode?: Maybe<CampaignSendingMode>;
  rate?: Maybe<CampaignRate>;
};

export type CampaignSendingPlanInput = {
  batch?: InputMaybe<CampaignBatchInput>;
  mode: CampaignSendingMode;
  rate?: InputMaybe<CampaignRateInput>;
};

export type CampaignSkipGroup = {
  __typename?: 'CampaignSkipGroup';
  count?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type CampaignSkippedBreakdown = {
  __typename?: 'CampaignSkippedBreakdown';
  DUPLICATE?: Maybe<Scalars['Int']['output']>;
  INVALID_PHONE?: Maybe<Scalars['Int']['output']>;
  MISSING_VARIABLE?: Maybe<Scalars['Int']['output']>;
  NO_PERMISSION?: Maybe<Scalars['Int']['output']>;
  NO_PHONE?: Maybe<Scalars['Int']['output']>;
  OPT_OUT?: Maybe<Scalars['Int']['output']>;
  SMART_SENDING?: Maybe<Scalars['Int']['output']>;
};

export type CampaignSmartSending = {
  __typename?: 'CampaignSmartSending';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  windowHours?: Maybe<Scalars['Int']['output']>;
};

export type CampaignSmartSendingInput = {
  enabled: Scalars['Boolean']['input'];
  windowHours: Scalars['Int']['input'];
};

export type CampaignStatistics = {
  __typename?: 'CampaignStatistics';
  campaignCount?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
};

export type CampaignStats = {
  __typename?: 'CampaignStats';
  cancelled?: Maybe<Scalars['Int']['output']>;
  clicked?: Maybe<Scalars['Int']['output']>;
  converted?: Maybe<Scalars['Int']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  read?: Maybe<Scalars['Int']['output']>;
  recipients?: Maybe<Scalars['Int']['output']>;
  replied?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueByCurrency?: Maybe<Array<Maybe<CampaignRevenue>>>;
  sent?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
};

export enum CampaignStatusEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Paused = 'PAUSED',
  Preparing = 'PREPARING',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT',
  Stopped = 'STOPPED'
}

export enum CampaignStatusGroup {
  Active = 'ACTIVE',
  All = 'ALL',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Problem = 'PROBLEM'
}

export enum CampaignStatusReason {
  AccountFatal = 'ACCOUNT_FATAL',
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  LinksDisabled = 'LINKS_DISABLED',
  MessagingLimitReached = 'MESSAGING_LIMIT_REACHED',
  PrepareFailed = 'PREPARE_FAILED',
  QualityLimit = 'QUALITY_LIMIT',
  ScheduleMissed = 'SCHEDULE_MISSED',
  TemplateUnavailable = 'TEMPLATE_UNAVAILABLE',
  TrackingDestinationMissing = 'TRACKING_DESTINATION_MISSING',
  UserPaused = 'USER_PAUSED',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type CampaignTagsInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type CampaignTagsResponse = {
  __typename?: 'CampaignTagsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignTemplateParam = {
  __typename?: 'CampaignTemplateParam';
  fallback?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['Int']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CampaignTemplateParamInput = {
  fallback?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['Int']['input'];
  ref: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignTestSendResponse = {
  __typename?: 'CampaignTestSendResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignTestSendResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignTestSendResult = {
  __typename?: 'CampaignTestSendResult';
  conversationId?: Maybe<Scalars['ID']['output']>;
  legacy?: Maybe<Scalars['Boolean']['output']>;
  messageId?: Maybe<Scalars['ID']['output']>;
  missingVariables?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  phone?: Maybe<Scalars['String']['output']>;
  variationKey?: Maybe<Scalars['String']['output']>;
};

export type CampaignTierStatus = {
  __typename?: 'CampaignTierStatus';
  dailyLimit?: Maybe<Scalars['Int']['output']>;
  messageLimit?: Maybe<Scalars['String']['output']>;
  qualityRating?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  usedLast24h?: Maybe<Scalars['Int']['output']>;
};

export type CampaignTitleInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CampaignTrackingBase = {
  __typename?: 'CampaignTrackingBase';
  baseUrl?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
};

export type CampaignTrackingBaseResponse = {
  __typename?: 'CampaignTrackingBaseResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignTrackingBase>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignTrackingLink = {
  __typename?: 'CampaignTrackingLink';
  campaign?: Maybe<AdminCampaignLinkRow>;
  customerId: Scalars['ID']['output'];
  customerLinks: TrackingLinksStatus;
  customerName?: Maybe<Scalars['String']['output']>;
  destinationUrl?: Maybe<Scalars['String']['output']>;
  kind: CampaignTrackingLinkKind;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export enum CampaignTrackingLinkKind {
  Campaign = 'CAMPAIGN',
  Template = 'TEMPLATE'
}

export type CampaignTrackingLinkResponse = {
  __typename?: 'CampaignTrackingLinkResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignTrackingLink>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignUtm = {
  __typename?: 'CampaignUtm';
  campaign?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type CampaignUtmInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignValidationReport = {
  __typename?: 'CampaignValidationReport';
  audience?: Maybe<CampaignAudienceMeasure>;
  balance?: Maybe<CampaignBalanceStatus>;
  canLaunch?: Maybe<Scalars['Boolean']['output']>;
  checks?: Maybe<Array<Maybe<CampaignLaunchCheck>>>;
  hasWarnings?: Maybe<Scalars['Boolean']['output']>;
  missingValues?: Maybe<Array<Maybe<CampaignMissingValueCount>>>;
  tier?: Maybe<CampaignTierStatus>;
  timeline?: Maybe<CampaignSendTimeline>;
  variables?: Maybe<Array<Maybe<CampaignVariableStatus>>>;
};

export enum CampaignVariableState {
  Fallback = 'FALLBACK',
  Invalid = 'INVALID',
  Mapped = 'MAPPED',
  Missing = 'MISSING'
}

export type CampaignVariableStatus = {
  __typename?: 'CampaignVariableStatus';
  fallback?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['Int']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CampaignVariableState>;
  value?: Maybe<Scalars['String']['output']>;
  variation?: Maybe<Scalars['String']['output']>;
};

export type CampaignVariation = {
  __typename?: 'CampaignVariation';
  categoryType?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  destinationUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  template?: Maybe<MiniTemplateData>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateParams?: Maybe<Array<Maybe<CampaignTemplateParam>>>;
  templateUnavailableAt?: Maybe<Scalars['Date']['output']>;
  weightPercent?: Maybe<Scalars['Int']['output']>;
};

export type CampaignVariationCounters = {
  __typename?: 'CampaignVariationCounters';
  clicked?: Maybe<Scalars['Int']['output']>;
  converted?: Maybe<Scalars['Int']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  read?: Maybe<Scalars['Int']['output']>;
  recipients?: Maybe<Scalars['Int']['output']>;
  replied?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type CampaignVariationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  media?: InputMaybe<Array<CampaignMediaInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateParams?: InputMaybe<Array<CampaignTemplateParamInput>>;
  weightPercent?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignVariationReport = {
  __typename?: 'CampaignVariationReport';
  clicked?: Maybe<Scalars['Int']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  rates?: Maybe<CampaignRates>;
  read?: Maybe<Scalars['Int']['output']>;
  replied?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
  variationKey?: Maybe<Scalars['String']['output']>;
};

export type CampaignVariationReportRow = {
  __typename?: 'CampaignVariationReportRow';
  counters?: Maybe<CampaignVariationCounters>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rates?: Maybe<CampaignRates>;
  weightPercent?: Maybe<Scalars['Int']['output']>;
};

export type CampaignVariationStats = {
  __typename?: 'CampaignVariationStats';
  A?: Maybe<CampaignVariationCounters>;
  B?: Maybe<CampaignVariationCounters>;
  C?: Maybe<CampaignVariationCounters>;
  D?: Maybe<CampaignVariationCounters>;
  E?: Maybe<CampaignVariationCounters>;
};

export enum CampaignWinnerMetric {
  ClickRate = 'CLICK_RATE',
  ConversionRate = 'CONVERSION_RATE',
  ReadRate = 'READ_RATE',
  ReplyRate = 'REPLY_RATE'
}

export enum CampaignWinnerReason {
  InsufficientSample = 'INSUFFICIENT_SAMPLE',
  LowConfidence = 'LOW_CONFIDENCE',
  Manual = 'MANUAL',
  Metric = 'METRIC',
  Tie = 'TIE'
}

export enum CardType {
  Detail = 'DETAIL',
  List = 'LIST'
}

export type CargoCompanies = {
  __typename?: 'CargoCompanies';
  id?: Maybe<Scalars['String']['output']>;
  internatiolPrice?: Maybe<Scalars['String']['output']>;
  maxPrice?: Maybe<Scalars['String']['output']>;
  minPrice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
};

export type CargoCompaniesInputType = {
  id?: InputMaybe<Scalars['String']['input']>;
  internatiolPrice?: InputMaybe<Scalars['String']['input']>;
  maxPrice?: InputMaybe<Scalars['String']['input']>;
  minPrice?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
};

export type CargoCompaniesResponse = {
  __typename?: 'CargoCompaniesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<CargoCompanies>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CarouselCardInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<ButtonType>>>;
  sampleMedia?: InputMaybe<Scalars['Media']['input']>;
};

export type CatalogBodyFooterInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogBodyFooterType = {
  __typename?: 'CatalogBodyFooterType';
  text?: Maybe<Scalars['String']['output']>;
};

export type CatalogBodyHeaderType = {
  __typename?: 'CatalogBodyHeaderType';
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CatalogCatalogOrderDataType = {
  __typename?: 'CatalogCatalogOrderDataType';
  id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<CatalogOrderOrderType>;
};

export type CatalogInteractiveInput = {
  body: CatalogBodyFooterInput;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<CatalogBodyFooterInput>;
  header?: InputMaybe<BodyHeaderInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<FlowCatalogSectionInput>>>;
  subType: InteractiveTypeEnum;
};

export type CatalogInteractiveType = {
  __typename?: 'CatalogInteractiveType';
  body?: Maybe<CatalogBodyFooterType>;
  catalogId?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<CatalogBodyFooterType>;
  header?: Maybe<CatalogBodyHeaderType>;
  productId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<FlowCatalogSectionType>>>;
  subType?: Maybe<InteractiveTypeEnum>;
};

export type CatalogOrderDataType = {
  __typename?: 'CatalogOrderDataType';
  catalog?: Maybe<CatalogCatalogOrderDataType>;
};

export type CatalogOrderItemType = {
  __typename?: 'CatalogOrderItemType';
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
};

export type CatalogOrderOrderType = {
  __typename?: 'CatalogOrderOrderType';
  items?: Maybe<Array<Maybe<CatalogOrderItemType>>>;
};

export type ChangeAccountStatusInput = {
  customerId: Scalars['ID']['input'];
  deactivate: Scalars['Boolean']['input'];
};

export type ChangeCPersonPasswordInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  /** Required unless the person has no password yet (hasPassword false: Google sign-up). */
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeCPersonPhotoInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  photo?: InputMaybe<Scalars['FileUpload']['input']>;
};

export type ChangeCustomerPhotoInput = {
  _id: Scalars['ID']['input'];
  photo?: InputMaybe<Scalars['FileUpload']['input']>;
};

export type ChangeCustomerProductInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  ipAdress: Scalars['String']['input'];
  isYearly: Scalars['Boolean']['input'];
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  productId: Scalars['ID']['input'];
  userCount: Scalars['Int']['input'];
};

export type Changelog = {
  __typename?: 'Changelog';
  _id: Scalars['ID']['output'];
  category?: Maybe<ChangelogCategory>;
  categoryId: Scalars['ID']['output'];
  channels?: Maybe<Array<Maybe<ChangelogChannel>>>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  myReaction?: Maybe<Scalars['Int']['output']>;
  myReactionComment?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  reactionAvg?: Maybe<Scalars['Float']['output']>;
  reactionCount?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  sendStats?: Maybe<Scalars['Object']['output']>;
  status: ChangelogStatus;
  translations?: Maybe<Scalars['Object']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ChangelogCategory = {
  __typename?: 'ChangelogCategory';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  translations?: Maybe<Scalars['Object']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChangelogCategoryListResponse = {
  __typename?: 'ChangelogCategoryListResponse';
  data?: Maybe<Array<Maybe<ChangelogCategory>>>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogCategoryResponse = {
  __typename?: 'ChangelogCategoryResponse';
  data?: Maybe<ChangelogCategory>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ChangelogChannel {
  Email = 'EMAIL',
  Push = 'PUSH',
  Whatsapp = 'WHATSAPP'
}

export type ChangelogDelivery = {
  __typename?: 'ChangelogDelivery';
  _id: Scalars['ID']['output'];
  announcement?: Maybe<Scalars['Object']['output']>;
  cPerson?: Maybe<Scalars['Object']['output']>;
  channels?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['Object']['output']>;
  reaction?: Maybe<Scalars['Int']['output']>;
  readAt?: Maybe<Scalars['Date']['output']>;
};

export type ChangelogDeliveryListResponse = {
  __typename?: 'ChangelogDeliveryListResponse';
  data?: Maybe<ChangelogDeliveryPaginate>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogDeliveryPaginate = {
  __typename?: 'ChangelogDeliveryPaginate';
  docs?: Maybe<Array<Maybe<ChangelogDelivery>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum ChangelogDeliveryStatus {
  Failed = 'FAILED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type ChangelogListResponse = {
  __typename?: 'ChangelogListResponse';
  data?: Maybe<ChangelogPaginate>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogMedia = {
  __typename?: 'ChangelogMedia';
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ChangelogMediaResponse = {
  __typename?: 'ChangelogMediaResponse';
  data?: Maybe<ChangelogMedia>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogObjectListResponse = {
  __typename?: 'ChangelogObjectListResponse';
  data?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogPaginate = {
  __typename?: 'ChangelogPaginate';
  docs?: Maybe<Array<Maybe<Changelog>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type ChangelogPrefs = {
  __typename?: 'ChangelogPrefs';
  email?: Maybe<Scalars['Boolean']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  web?: Maybe<Scalars['Boolean']['output']>;
  whatsapp?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogPrefsInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
  whatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangelogPrefsResponse = {
  __typename?: 'ChangelogPrefsResponse';
  data?: Maybe<ChangelogPrefs>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogReaction = {
  __typename?: 'ChangelogReaction';
  _id: Scalars['ID']['output'];
  announcement: Scalars['ID']['output'];
  cPerson: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  reaction?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChangelogReadResponse = {
  __typename?: 'ChangelogReadResponse';
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogResponse = {
  __typename?: 'ChangelogResponse';
  data?: Maybe<Changelog>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogSenderEmailInput = {
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
};

export type ChangelogSenderWhatsappInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  templates?: InputMaybe<Array<ChangelogWhatsappTemplateEntryInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  webImageType?: InputMaybe<Scalars['String']['input']>;
  webImageUrl?: InputMaybe<Scalars['String']['input']>;
  webMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ChangelogSettings = {
  __typename?: 'ChangelogSettings';
  _id?: Maybe<Scalars['ID']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  defaultTimezone?: Maybe<Scalars['String']['output']>;
  includeArchivedPersons?: Maybe<Scalars['Boolean']['output']>;
  includeInactiveCustomers?: Maybe<Scalars['Boolean']['output']>;
  recipientAudience?: Maybe<Scalars['String']['output']>;
  senderCustomerId?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['Object']['output']>;
  senderWhatsapp?: Maybe<Scalars['Object']['output']>;
  supportedLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChangelogSettingsResponse = {
  __typename?: 'ChangelogSettingsResponse';
  data?: Maybe<ChangelogSettings>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ChangelogStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export type ChangelogSubscriber = {
  __typename?: 'ChangelogSubscriber';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['Object']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  prefs?: Maybe<ChangelogPrefs>;
};

export type ChangelogSubscriberListResponse = {
  __typename?: 'ChangelogSubscriberListResponse';
  data?: Maybe<ChangelogSubscriberPaginate>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogSubscriberPaginate = {
  __typename?: 'ChangelogSubscriberPaginate';
  docs?: Maybe<Array<Maybe<ChangelogSubscriber>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type ChangelogSubscriptionInput = {
  token: Scalars['String']['input'];
};

export type ChangelogTranslateResponse = {
  __typename?: 'ChangelogTranslateResponse';
  data?: Maybe<Scalars['Object']['output']>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogUnreadResponse = {
  __typename?: 'ChangelogUnreadResponse';
  data?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangelogWhatsAppTemplatesInput = {
  accountId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type ChangelogWhatsappParamMapInput = {
  key: Scalars['Int']['input'];
  source: Scalars['String']['input'];
};

export type ChangelogWhatsappTemplateEntryInput = {
  languageCode: Scalars['String']['input'];
  paramMap: Array<ChangelogWhatsappParamMapInput>;
  templateId: Scalars['String']['input'];
};

export type ChannelCommonTypes = {
  __typename?: 'ChannelCommonTypes';
  _id?: Maybe<Scalars['ID']['output']>;
  appId?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  channelOwner?: Maybe<CustomerPerson>;
  channelType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  senderEmailAddress?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum ChannelGroup {
  Chat = 'CHAT',
  Comment = 'COMMENT',
  Marketplace = 'MARKETPLACE'
}

export type ChannelInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChannelOwnerTemplate = {
  __typename?: 'ChannelOwnerTemplate';
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

export type ChannelOwnerTemplatesResponse = {
  __typename?: 'ChannelOwnerTemplatesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ChannelOwnerTemplate>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ChannelType {
  Amazon = 'AMAZON',
  CustomChannel = 'CUSTOM_CHANNEL',
  Ebay = 'EBAY',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  GoogleBusiness = 'GOOGLE_BUSINESS',
  Hepsiburada = 'HEPSIBURADA',
  Instagram = 'INSTAGRAM',
  Kaufland = 'KAUFLAND',
  LiveChat = 'LIVE_CHAT',
  MetaWhatsAppBusiness = 'META_WHATS_APP_BUSINESS',
  N11 = 'N11',
  Note = 'NOTE',
  Pazarama = 'PAZARAMA',
  Phone = 'PHONE',
  Survey = 'SURVEY',
  Telegram = 'TELEGRAM',
  Tiktok = 'TIKTOK',
  Trendyol = 'TRENDYOL',
  Walmart = 'WALMART',
  WhatsAppBusiness = 'WHATS_APP_BUSINESS',
  WhatsAppWeb = 'WHATS_APP_WEB'
}

export type ChannelTypeOutput = {
  __typename?: 'ChannelTypeOutput';
  lastReceivedMessageTime?: Maybe<Scalars['Date']['output']>;
  pChannelId?: Maybe<Scalars['ID']['output']>;
  platformId?: Maybe<Scalars['ID']['output']>;
  platformType?: Maybe<PlatformType>;
};

export type ChartReportCustomerPersonHistories = {
  __typename?: 'ChartReportCustomerPersonHistories';
  away: Scalars['Double']['output'];
  date?: Maybe<Scalars['String']['output']>;
  online: Scalars['Double']['output'];
};

export type ChartSurveyReport = {
  __typename?: 'ChartSurveyReport';
  date?: Maybe<Scalars['String']['output']>;
  dissatisfied: Scalars['Double']['output'];
  neutral: Scalars['Double']['output'];
  responded: Scalars['Double']['output'];
  satisfied: Scalars['Double']['output'];
  sent: Scalars['Double']['output'];
};

export type ChatSettings = {
  __typename?: 'ChatSettings';
  aiAgentWorkingHours?: Maybe<AiWorkingHoursEnum>;
  aiAutoClose?: Maybe<AiAutoClose>;
  aiFollowUp?: Maybe<AiFollowUp>;
  aiIntroducesItself?: Maybe<Scalars['String']['output']>;
  aiReplyButtons?: Maybe<AiReplyButtons>;
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  humanHandoff?: Maybe<HumanHandoff>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatSettingsInput = {
  aiAgentWorkingHours?: InputMaybe<AiWorkingHoursEnum>;
  aiAutoClose?: InputMaybe<AiAutoCloseInput>;
  aiFollowUp?: InputMaybe<AiFollowUpInput>;
  aiIntroducesItself?: InputMaybe<Scalars['String']['input']>;
  aiReplyButtons?: InputMaybe<AiReplyButtonsInput>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  humanHandoff?: InputMaybe<HumanHandoffInput>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckSelectedTargetsInput = {
  customer: Scalars['ID']['input'];
  qpienPersonGroups: Array<InputMaybe<Scalars['ID']['input']>>;
  telegramChannels: Array<InputMaybe<Scalars['ID']['input']>>;
  whatsAppGroups: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type CheckSelectedTargetsOutput = {
  __typename?: 'CheckSelectedTargetsOutput';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<Scalars['ID']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckStatusDomainInput = {
  _id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
};

export type CheckoutsResponse = {
  __typename?: 'CheckoutsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Object']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ClearChannelOwnerInput = {
  accountId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  platformType: PlatformType;
};

export enum ClientOnboardingStep {
  IntroVideoWatched = 'introVideoWatched',
  MobileAppDownloaded = 'mobileAppDownloaded'
}

export type ClosingNoteCustomField = {
  __typename?: 'ClosingNoteCustomField';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ClosingNoteCustomFieldInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ClosingNoteData = {
  __typename?: 'ClosingNoteData';
  _id?: Maybe<Scalars['ID']['output']>;
  customFields?: Maybe<Array<ClosingNoteCustomField>>;
  summary?: Maybe<Scalars['String']['output']>;
  topicId?: Maybe<Scalars['ID']['output']>;
  topicName?: Maybe<Scalars['String']['output']>;
};

export type ClosingNoteDetail = {
  __typename?: 'ClosingNoteDetail';
  autoFillWithAi?: Maybe<Scalars['Boolean']['output']>;
  customFields: Array<CustomField>;
  isCompletionRequired?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ClosingNoteDetailInput = {
  autoFillWithAi?: InputMaybe<Scalars['Boolean']['input']>;
  customFields: Array<Scalars['ID']['input']>;
  isCompletionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClosingTopicCustomField = {
  __typename?: 'ClosingTopicCustomField';
  _id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollageBarcode = {
  __typename?: 'CollageBarcode';
  _id: Scalars['ID']['output'];
  barcode?: Maybe<ImageMedia>;
  customer: Scalars['ID']['output'];
  fields?: Maybe<Array<Maybe<BarcodeField>>>;
};

export type CollageBarcodeResponse = {
  __typename?: 'CollageBarcodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CollageBarcode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageBulkSettings = {
  __typename?: 'CollageBulkSettings';
  qpienPersonGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telegramChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telegramSendFolderName: Scalars['Boolean']['output'];
  telegramSendImageName: Scalars['Boolean']['output'];
  telegramSendingType: Scalars['String']['output'];
  whatsAppGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  whatsappSendFolderName: Scalars['Boolean']['output'];
  whatsappSendImageName: Scalars['Boolean']['output'];
};

export type CollageBulkSettingsInput = {
  qpienPersonGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telegramChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telegramSendFolderName?: InputMaybe<Scalars['Boolean']['input']>;
  telegramSendImageName?: InputMaybe<Scalars['Boolean']['input']>;
  telegramSendingType?: InputMaybe<Scalars['String']['input']>;
  whatsAppGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whatsappSendFolderName?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappSendImageName?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollageBulkSharing = {
  __typename?: 'CollageBulkSharing';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  folders?: Maybe<Array<Maybe<OFolderRes>>>;
  name?: Maybe<Scalars['String']['output']>;
  qpienPersonGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telegramChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telegramSendFileNames?: Maybe<Scalars['Boolean']['output']>;
  telegramSendFolderNames?: Maybe<Scalars['Boolean']['output']>;
  telegramSendingType?: Maybe<Scalars['String']['output']>;
  telegramStatus?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  whatsAppGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  whatsAppSendFileNames?: Maybe<Scalars['Boolean']['output']>;
  whatsAppSendFolderNames?: Maybe<Scalars['Boolean']['output']>;
  whatsAppStatus?: Maybe<Scalars['String']['output']>;
};

export type CollageBulkSharingResponse = {
  __typename?: 'CollageBulkSharingResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageBulkSharing;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CollageFields {
  BarcodeNumber = 'BARCODE_NUMBER',
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Color = 'COLOR',
  DiscountedPrice = 'DISCOUNTED_PRICE',
  Price = 'PRICE',
  ProductCode = 'PRODUCT_CODE',
  ProductName = 'PRODUCT_NAME',
  RegisteredBy = 'REGISTERED_BY',
  Size = 'SIZE'
}

export type CollageFolder = {
  __typename?: 'CollageFolder';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentFolder?: Maybe<Scalars['ID']['output']>;
  selectedCPersons?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visibleTo?: Maybe<VisibleTo>;
};

export type CollageFolderPaginatedData = {
  __typename?: 'CollageFolderPaginatedData';
  docs: Array<Maybe<CollageFolder>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type CollageFolderPaginatedResponse = {
  __typename?: 'CollageFolderPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageFolderPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageFolderResponse = {
  __typename?: 'CollageFolderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageFolder;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageFooterFieldOffset = {
  __typename?: 'CollageFooterFieldOffset';
  field: Scalars['String']['output'];
  offset: Scalars['Float']['output'];
  row: Scalars['Int']['output'];
};

export type CollageFooterFieldOffsetInput = {
  /** productCategory | productCode | productSize | color */
  field: Scalars['String']['input'];
  offset: Scalars['Float']['input'];
  /** Footer satırı: barkod listesindeki sıra, manuel şablonda 0. */
  row: Scalars['Int']['input'];
};

export type CollageImageTransform = {
  __typename?: 'CollageImageTransform';
  rotation: Scalars['Float']['output'];
  scale: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CollageImageTransformInput = {
  rotation: Scalars['Float']['input'];
  scale: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CollageLayoutState = {
  __typename?: 'CollageLayoutState';
  footerOffsets?: Maybe<Array<Maybe<CollageFooterFieldOffset>>>;
  images?: Maybe<Array<Maybe<CollageImageTransform>>>;
  previewWidth?: Maybe<Scalars['Float']['output']>;
};

/**
 * Kolaj düzenleyicisinin yerleşimi. Değerler kaydı yapan cihazın önizleme dp'si cinsindendir;
 * farklı genişlikte bir ekran bunları previewWidth oranıyla ölçekler.
 */
export type CollageLayoutStateInput = {
  footerOffsets?: InputMaybe<Array<InputMaybe<CollageFooterFieldOffsetInput>>>;
  /** Slot sırasıyla; boş slotlar null. */
  images?: InputMaybe<Array<InputMaybe<CollageImageTransformInput>>>;
  previewWidth?: InputMaybe<Scalars['Float']['input']>;
};

export type CollageMedia = {
  __typename?: 'CollageMedia';
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CollageProduct = {
  __typename?: 'CollageProduct';
  _id: Scalars['ID']['output'];
  barcode?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  collageImage?: Maybe<CollageMedia>;
  collageTemplate?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  discountedPrice?: Maybe<Scalars['Number']['output']>;
  folders: Array<Maybe<Scalars['ID']['output']>>;
  kayitEdenKullanici?: Maybe<Scalars['String']['output']>;
  layoutState?: Maybe<CollageLayoutState>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Number']['output']>;
  productImages?: Maybe<Array<Maybe<CollageMedia>>>;
  size?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CollageProductPaginatedData = {
  __typename?: 'CollageProductPaginatedData';
  docs: Array<Maybe<CollageProduct>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type CollageProductPaginatedResponse = {
  __typename?: 'CollageProductPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageProductPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageProductResponse = {
  __typename?: 'CollageProductResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageProduct;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageProductSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type CollageSettings = {
  __typename?: 'CollageSettings';
  _id: Scalars['ID']['output'];
  barcodeCustomExtension?: Maybe<Scalars['ID']['output']>;
  bulkSettings: CollageBulkSettings;
  customer: Scalars['ID']['output'];
  sqlConfig?: Maybe<CollageSqlConfig>;
};

export type CollageSettingsResponse = {
  __typename?: 'CollageSettingsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CollageSettings>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageSharing = {
  __typename?: 'CollageSharing';
  _id: Scalars['ID']['output'];
  cPerson: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  folderLength?: Maybe<Scalars['Int']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<CollageProduct>>>;
  status?: Maybe<SharingStatus>;
  type?: Maybe<SharingType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CollageSharingPaginatedData = {
  __typename?: 'CollageSharingPaginatedData';
  docs: Array<Maybe<CollageSharing>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type CollageSharingPaginatedResponse = {
  __typename?: 'CollageSharingPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageSharingPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageSharingResponse = {
  __typename?: 'CollageSharingResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageSharing;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageSharingSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type CollageSqlConfig = {
  __typename?: 'CollageSqlConfig';
  colorImageViewName?: Maybe<Scalars['String']['output']>;
  database: Scalars['String']['output'];
  host: Scalars['String']['output'];
  password: Scalars['String']['output'];
  port?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  user: Scalars['String']['output'];
  viewName?: Maybe<Scalars['String']['output']>;
};

export type CollageSqlConfigInput = {
  colorImageViewName?: InputMaybe<Scalars['String']['input']>;
  database: Scalars['String']['input'];
  host: Scalars['String']['input'];
  password: Scalars['String']['input'];
  port?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  user: Scalars['String']['input'];
  viewName?: InputMaybe<Scalars['String']['input']>;
};

export type CollageTemplate = {
  __typename?: 'CollageTemplate';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  collage?: Maybe<TemplateLayout>;
  coverImage?: Maybe<ImageMedia>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  discountLabel?: Maybe<Scalars['String']['output']>;
  discountStyle?: Maybe<TemplateDiscountStyle>;
  footer?: Maybe<TemplateFooter>;
  footerCodeSizeDelta?: Maybe<Scalars['Int']['output']>;
  footerFontWeight?: Maybe<TemplateFooterFontWeight>;
  footerPriceSizeDelta?: Maybe<Scalars['Int']['output']>;
  frame?: Maybe<FrameRatio>;
  header?: Maybe<TemplateHeader>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  mainLogo?: Maybe<ImageMedia>;
  name?: Maybe<Scalars['String']['output']>;
  priceTextColor?: Maybe<Scalars['String']['output']>;
  productDataSource?: Maybe<ProductDataSource>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  secondaryLogo?: Maybe<ImageMedia>;
  selectedCPersons?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  textColor?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visibleTo?: Maybe<VisibleTo>;
};

export type CollageTemplatePaginatedData = {
  __typename?: 'CollageTemplatePaginatedData';
  docs: Array<Maybe<CollageTemplate>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type CollageTemplatePaginatedResponse = {
  __typename?: 'CollageTemplatePaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageTemplatePaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageTemplateResponse = {
  __typename?: 'CollageTemplateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CollageTemplate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollageTemplateSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type CommentDataInput = {
  postDescription?: InputMaybe<Scalars['String']['input']>;
  postImageUrl?: InputMaybe<Scalars['String']['input']>;
  postUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CommentDataType = {
  __typename?: 'CommentDataType';
  aiNotResponseReason?: Maybe<Scalars['String']['output']>;
  externalStatus?: Maybe<Scalars['String']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  parentComment?: Maybe<Scalars['String']['output']>;
  parentCommentId?: Maybe<Scalars['ID']['output']>;
  policyViolation?: Maybe<Scalars['String']['output']>;
  postDescription?: Maybe<Scalars['String']['output']>;
  postImageUrl?: Maybe<Scalars['String']['output']>;
  postUrl?: Maybe<Scalars['String']['output']>;
  privateReply?: Maybe<Scalars['String']['output']>;
  privateReplyAiNotResponseReason?: Maybe<Scalars['String']['output']>;
  privateReplyId?: Maybe<Scalars['ID']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  reaction?: Maybe<Scalars['String']['output']>;
  repliedCPerson?: Maybe<Scalars['ID']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
  replyDate?: Maybe<Scalars['Date']['output']>;
  replyState?: Maybe<Scalars['String']['output']>;
  reviewUpdateTime?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temporaryReply?: Maybe<Scalars['String']['output']>;
};

export type CommentSettings = {
  __typename?: 'CommentSettings';
  aiAgentWorkingHours?: Maybe<AiWorkingHoursEnum>;
  aiReplyButtons?: Maybe<AiReplyNonChatButtons>;
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  replyToComment?: Maybe<Scalars['Boolean']['output']>;
  sendPrivateReply?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CommentSettingsInput = {
  aiAgentWorkingHours?: InputMaybe<AiWorkingHoursEnum>;
  aiReplyButtons?: InputMaybe<AiReplyNonChatButtonsInput>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  replyToComment?: InputMaybe<Scalars['Boolean']['input']>;
  sendPrivateReply?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompareCampaignsInput = {
  campaignIds: Array<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
};

export type CompareCampaignsResponse = {
  __typename?: 'CompareCampaignsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CampaignComparisonRow>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ComparisonData = {
  __typename?: 'ComparisonData';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Conditions = {
  __typename?: 'Conditions';
  rule?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ConnectMetaBusinessInput = {
  code: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};

export type ConnectTabButton = {
  __typename?: 'ConnectTabButton';
  label?: Maybe<Scalars['String']['output']>;
  targetTab?: Maybe<Scalars['ID']['output']>;
};

export type ConnectTabButtonInput = {
  label: Scalars['String']['input'];
  targetTab: Scalars['ID']['input'];
};

export type ConnectedPlatformResponse = {
  __typename?: 'ConnectedPlatformResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ConnectedPlatforms>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConnectedPlatforms = {
  __typename?: 'ConnectedPlatforms';
  amazon?: Maybe<Scalars['Boolean']['output']>;
  ebay?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<Scalars['Boolean']['output']>;
  googleBusiness?: Maybe<Scalars['Boolean']['output']>;
  hepsiburada?: Maybe<Scalars['Boolean']['output']>;
  instagram?: Maybe<Scalars['Boolean']['output']>;
  kaufland?: Maybe<Scalars['Boolean']['output']>;
  metaWhatsAppBusiness?: Maybe<Scalars['Boolean']['output']>;
  n11?: Maybe<Scalars['Boolean']['output']>;
  pazarama?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['Boolean']['output']>;
  telegram?: Maybe<Scalars['Boolean']['output']>;
  tiktok?: Maybe<Scalars['Boolean']['output']>;
  trendyol?: Maybe<Scalars['Boolean']['output']>;
  walmart?: Maybe<Scalars['Boolean']['output']>;
  whatsappBusiness?: Maybe<Scalars['Boolean']['output']>;
  whatsappWeb?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactOrderStatsStatus = {
  __typename?: 'ContactOrderStatsStatus';
  available: Scalars['Boolean']['output'];
  refreshedAt?: Maybe<Scalars['String']['output']>;
};

export type ContactOrderStatsStatusResponse = {
  __typename?: 'ContactOrderStatsStatusResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ContactOrderStatsStatus>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvCounType = {
  __typename?: 'ConvCounType';
  all?: Maybe<Scalars['Int']['output']>;
  allCPerson?: Maybe<Array<Maybe<AllCPersonType>>>;
  mine?: Maybe<Scalars['Int']['output']>;
  teamsCount?: Maybe<Array<Maybe<AllCPersonType>>>;
  unassigned?: Maybe<Scalars['Int']['output']>;
  viewsCount?: Maybe<Array<Maybe<AllCPersonType>>>;
};

export type ConvCountInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  allCPerson?: InputMaybe<Scalars['Boolean']['input']>;
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  teams?: InputMaybe<Scalars['Boolean']['input']>;
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  views?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConvNotificationsInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  /** Scope for a long (loop) sound: "livechat" (only live chat conversations) or "all". Only meaningful for loop-capable types. */
  loopScope?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  sound?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConvNotificationstype = {
  __typename?: 'ConvNotificationstype';
  email?: Maybe<Scalars['Boolean']['output']>;
  /** Scope for a long (loop) sound: "livechat" (only live chat conversations) or "all". Only meaningful for loop-capable types. */
  loopScope?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  sound?: Maybe<Scalars['String']['output']>;
  web?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvSidebarResponse = {
  __typename?: 'ConvSidebarResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationSidebar;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvSidebarSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type ConvStatusInput = {
  allCPersons?: InputMaybe<Scalars['Boolean']['input']>;
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  conversationType?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  isAssign?: InputMaybe<Scalars['Boolean']['input']>;
  isAverage?: InputMaybe<Scalars['Boolean']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isOpenAndReOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isReOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isSentNumber?: InputMaybe<Scalars['Boolean']['input']>;
  isTotalClose?: InputMaybe<Scalars['Boolean']['input']>;
  isTotalReOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isTransferred?: InputMaybe<Scalars['Boolean']['input']>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
};

export type ConvTagHistoryStatisticInput = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<Scalars['String']['input']>;
  conversationType?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tagType?: InputMaybe<TagType>;
};

export type ConvViewResponse = {
  __typename?: 'ConvViewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationView;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvViewSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type ConvViewsConditionsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConvViewsConditionsType = {
  __typename?: 'ConvViewsConditionsType';
  group?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  _id?: Maybe<Scalars['ID']['output']>;
  activeFlowInstance?: Maybe<Scalars['ID']['output']>;
  aiPersonMemory?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Maybe<ChannelTypes>>>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  isDummy?: Maybe<Scalars['Boolean']['output']>;
  isGroupOrChannel?: Maybe<Scalars['Boolean']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  isStarred?: Maybe<Scalars['Boolean']['output']>;
  joinTime?: Maybe<Scalars['Double']['output']>;
  joinedCPerson?: Maybe<CustomerPerson>;
  joinedPerson?: Maybe<Person>;
  lastJoinedCPerson?: Maybe<Scalars['ID']['output']>;
  lastMessage?: Maybe<LastMessageType>;
  lastReceivedMessageChannel?: Maybe<Scalars['ID']['output']>;
  mergedFrom?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  mergedTo?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Message>;
  openTime?: Maybe<Scalars['Double']['output']>;
  priority?: Maybe<TicketPriority>;
  slaInstance?: Maybe<Scalars['ID']['output']>;
  slaInstanceData?: Maybe<SlaInstance>;
  slaPolicy?: Maybe<Scalars['ID']['output']>;
  sourceFormId?: Maybe<Scalars['ID']['output']>;
  sourcePlatformType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConversationStatusEnum>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  ticketCustomFields?: Maybe<Array<Maybe<TicketCustomFieldOutput>>>;
  ticketId?: Maybe<Scalars['Number']['output']>;
  ticketState?: Maybe<Scalars['ID']['output']>;
  ticketStateCategory?: Maybe<TicketStateCategoryType>;
  ticketStateTime?: Maybe<Scalars['Object']['output']>;
  ticketType?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ConversationTypeEnum>;
  unAnsweredMessageCount?: Maybe<Scalars['Int']['output']>;
  waitingSince?: Maybe<Scalars['Date']['output']>;
};

export type ConversationAdAttribution = {
  __typename?: 'ConversationAdAttribution';
  clicks?: Maybe<Array<Maybe<MetaAdClickType>>>;
  events?: Maybe<Array<Maybe<MetaConversionEventType>>>;
};

export type ConversationAdAttributionInput = {
  conversationId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type ConversationAdAttributionResponse = {
  __typename?: 'ConversationAdAttributionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ConversationAdAttribution>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationAdReferral = {
  __typename?: 'ConversationAdReferral';
  body?: Maybe<Scalars['String']['output']>;
  clickedAt?: Maybe<Scalars['Date']['output']>;
  ctwaClid?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['ID']['output'];
  platform?: Maybe<AdReferralPlatform>;
  ref?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type ConversationAdReferralsResponse = {
  __typename?: 'ConversationAdReferralsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<ConversationAdReferral>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationByPerson = {
  __typename?: 'ConversationByPerson';
  _id?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Maybe<ChannelTypes>>>;
  customer?: Maybe<Scalars['ID']['output']>;
  hasRateUs?: Maybe<Scalars['Boolean']['output']>;
  isGroupOrChannel?: Maybe<Scalars['Boolean']['output']>;
  joinTime?: Maybe<Scalars['Double']['output']>;
  joinedCPerson?: Maybe<Scalars['ID']['output']>;
  joinedPerson?: Maybe<Scalars['ID']['output']>;
  lastJoinedCPerson?: Maybe<Scalars['ID']['output']>;
  lastMessage?: Maybe<LastMessageType>;
  lastReceivedMessageChannel?: Maybe<Scalars['ID']['output']>;
  mergedFrom?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  mergedTo?: Maybe<Scalars['ID']['output']>;
  openTime?: Maybe<Scalars['Double']['output']>;
  sourceFormId?: Maybe<Scalars['ID']['output']>;
  sourcePlatformType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConversationStatusEnum>;
  ticketState?: Maybe<Scalars['ID']['output']>;
  ticketStateCategory?: Maybe<TicketStateCategoryType>;
  ticketStateTime?: Maybe<Scalars['Object']['output']>;
  ticketType?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ConversationTypeEnum>;
  unAnsweredMessageCount?: Maybe<Scalars['Int']['output']>;
  waitingSince?: Maybe<Scalars['Date']['output']>;
};

export type ConversationByPersonData = {
  __typename?: 'ConversationByPersonData';
  _id?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Maybe<ChannelTypes>>>;
  customer?: Maybe<Scalars['ID']['output']>;
  isGroupOrChannel?: Maybe<Scalars['Boolean']['output']>;
  joinTime?: Maybe<Scalars['Double']['output']>;
  joinedCPerson?: Maybe<Scalars['ID']['output']>;
  joinedPerson?: Maybe<Person>;
  lastMessage?: Maybe<LastMessageType>;
  lastReceivedMessageChannel?: Maybe<Scalars['ID']['output']>;
  mergedFrom?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  mergedTo?: Maybe<Scalars['ID']['output']>;
  openTime?: Maybe<Scalars['Double']['output']>;
  status?: Maybe<ConversationStatusEnum>;
  type?: Maybe<ConversationTypeEnum>;
  unAnsweredMessageCount?: Maybe<Scalars['Int']['output']>;
  waitingSince?: Maybe<Scalars['Date']['output']>;
};

export type ConversationByPersonPage = {
  __typename?: 'ConversationByPersonPage';
  docs?: Maybe<Array<Maybe<ConversationByPerson>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type ConversationClosingNoteInput = {
  customFields?: InputMaybe<Array<InputMaybe<ClosingNoteCustomFieldInput>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  topicId: Scalars['ID']['input'];
};

export type ConversationDashboardAllConversations = {
  __typename?: 'ConversationDashboardAllConversations';
  closed: Scalars['Int']['output'];
  opened: Scalars['Int']['output'];
};

export type ConversationDashboardMessages = {
  __typename?: 'ConversationDashboardMessages';
  received: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type ConversationDashboardOpenedConversations = {
  __typename?: 'ConversationDashboardOpenedConversations';
  new: Scalars['Int']['output'];
  returning: Scalars['Int']['output'];
};

export type ConversationDashboardSlaStats = {
  __typename?: 'ConversationDashboardSlaStats';
  breached: Scalars['Int']['output'];
  met: Scalars['Int']['output'];
};

export type ConversationDashboardStatisticsData = {
  __typename?: 'ConversationDashboardStatisticsData';
  allConversations: ConversationDashboardAllConversations;
  avgFirstResponseTime: Scalars['Double']['output'];
  avgResolutionTime: Scalars['Double']['output'];
  firstResponseSla: ConversationDashboardSlaStats;
  messages: ConversationDashboardMessages;
  openedConversations: ConversationDashboardOpenedConversations;
  resolutionSla: ConversationDashboardSlaStats;
  sentiment: SentimentStats;
  topAgents: Array<TopAgent>;
  topTopics: Array<TopTopic>;
};

export enum ConversationDetailsName {
  Integrations = 'Integrations',
  QpienShop = 'QpienShop',
  Contact = 'contact',
  CustomExtension = 'customExtension',
  Marketplace = 'marketplace',
  Media = 'media',
  Notes = 'notes',
  ScheduledMessages = 'scheduledMessages',
  SimilarContacts = 'similarContacts',
  SimilarConversations = 'similarConversations',
  Tasks = 'tasks',
  Ticket = 'ticket'
}

export type ConversationDetailsSettingsItem = {
  __typename?: 'ConversationDetailsSettingsItem';
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  name: ConversationDetailsName;
  order?: Maybe<Scalars['Int']['output']>;
};

export enum ConversationExportJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export type ConversationFieldMappingInput = {
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  field: Scalars['String']['input'];
  personField?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationFieldMappingType = {
  __typename?: 'ConversationFieldMappingType';
  customFieldId?: Maybe<Scalars['ID']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  personField?: Maybe<Scalars['String']['output']>;
};

export type ConversationHistorySentimentData = {
  __typename?: 'ConversationHistorySentimentData';
  byAgent: Array<SentimentByAgent>;
  byTime: Array<SentimentByTime>;
  byTopic: Array<SentimentByTopic>;
};

export type ConversationHistorySentimentInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  customer: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type ConversationHistoryTopicData = {
  __typename?: 'ConversationHistoryTopicData';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
  topicId: Scalars['ID']['output'];
};

export type ConversationHistoryTopicsInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  customer: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  sentiment?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type ConversationIntegrationRecordInput = {
  moduleName: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
  sinceReOpen?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConversationName {
  AiAsistant = 'aiAsistant',
  Assign = 'assign',
  Attechment = 'attechment',
  Audio = 'audio',
  Call = 'call',
  ConvertTicket = 'convertTicket',
  EditImagesBeforeSend = 'editImagesBeforeSend',
  Emoji = 'emoji',
  ExportToPdf = 'exportToPdf',
  MergeContacts = 'mergeContacts',
  MergeConversation = 'mergeConversation',
  MessageSchedule = 'messageSchedule',
  QuickReplySlashTrigger = 'quickReplySlashTrigger',
  SendAndClose = 'sendAndClose',
  SendMail = 'sendMail',
  SendMessageOnEnter = 'sendMessageOnEnter',
  SendWhatsappMessage = 'sendWhatsappMessage',
  ShowActivityLogs = 'showActivityLogs',
  Snooze = 'snooze',
  Spam = 'spam',
  Starred = 'starred',
  Tags = 'tags',
  TranslateConversation = 'translateConversation',
  TriggerFlow = 'triggerFlow'
}

export type ConversationPage = {
  __typename?: 'ConversationPage';
  docs?: Maybe<Array<Maybe<Conversation>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type ConversationResponse = {
  __typename?: 'ConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Conversation;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ConversationSearchBy {
  Email = 'email',
  Phone = 'phone'
}

export type ConversationSettingsItem = {
  __typename?: 'ConversationSettingsItem';
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  name: ConversationName;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ConversationSidebar = {
  __typename?: 'ConversationSidebar';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Date']['output']>;
  cPerson: Scalars['ID']['output'];
  customer: Scalars['ID']['output'];
  views?: Maybe<Array<Maybe<SidebarView>>>;
};

export enum ConversationSnapshotStatisticsAggregation {
  Avg = 'avg',
  Count = 'count',
  Max = 'max',
  Min = 'min',
  Rate = 'rate',
  Sum = 'sum'
}

export type ConversationSnapshotStatisticsAppliedFilter = {
  __typename?: 'ConversationSnapshotStatisticsAppliedFilter';
  field: Scalars['String']['output'];
  operator: ConversationSnapshotStatisticsFilterOperator;
  value: Scalars['Object']['output'];
};

export enum ConversationSnapshotStatisticsCountTarget {
  Conversation = 'conversation',
  Snapshot = 'snapshot'
}

export type ConversationSnapshotStatisticsDataPoint = {
  __typename?: 'ConversationSnapshotStatisticsDataPoint';
  segment?: Maybe<Scalars['Object']['output']>;
  value: Scalars['Double']['output'];
};

export enum ConversationSnapshotStatisticsDateField {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export enum ConversationSnapshotStatisticsDatePreset {
  Last7days = 'last7days',
  Last30days = 'last30days',
  Last90days = 'last90days',
  LastMonth = 'lastMonth',
  ThisMonth = 'thisMonth',
  Today = 'today',
  Yesterday = 'yesterday'
}

export type ConversationSnapshotStatisticsDateRangeInput = {
  field?: InputMaybe<ConversationSnapshotStatisticsDateField>;
  from?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<ConversationSnapshotStatisticsDatePreset>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationSnapshotStatisticsFilterInput = {
  field: Scalars['String']['input'];
  operator: ConversationSnapshotStatisticsFilterOperator;
  value: Scalars['Object']['input'];
};

export enum ConversationSnapshotStatisticsFilterOperator {
  Eq = 'eq',
  In = 'in'
}

export enum ConversationSnapshotStatisticsGranularity {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week'
}

export type ConversationSnapshotStatisticsMeta = {
  __typename?: 'ConversationSnapshotStatisticsMeta';
  appliedFilters: Array<ConversationSnapshotStatisticsAppliedFilter>;
  dateRange?: Maybe<ConversationSnapshotStatisticsResolvedDateRange>;
  segmentBy?: Maybe<ConversationSnapshotStatisticsSegmentByMeta>;
  viewBy: ConversationSnapshotStatisticsViewByMeta;
};

export type ConversationSnapshotStatisticsResolvedDateRange = {
  __typename?: 'ConversationSnapshotStatisticsResolvedDateRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type ConversationSnapshotStatisticsResponse = {
  __typename?: 'ConversationSnapshotStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationSnapshotStatisticsResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationSnapshotStatisticsResult = {
  __typename?: 'ConversationSnapshotStatisticsResult';
  data: Array<ConversationSnapshotStatisticsDataPoint>;
  meta: ConversationSnapshotStatisticsMeta;
};

export type ConversationSnapshotStatisticsSegmentByInput = {
  field: Scalars['String']['input'];
  granularity?: InputMaybe<ConversationSnapshotStatisticsGranularity>;
};

export type ConversationSnapshotStatisticsSegmentByMeta = {
  __typename?: 'ConversationSnapshotStatisticsSegmentByMeta';
  field: Scalars['String']['output'];
  granularity?: Maybe<Scalars['String']['output']>;
};

export type ConversationSnapshotStatisticsViewByInput = {
  aggregation: ConversationSnapshotStatisticsAggregation;
  countTarget?: InputMaybe<ConversationSnapshotStatisticsCountTarget>;
  field: Scalars['String']['input'];
};

export type ConversationSnapshotStatisticsViewByMeta = {
  __typename?: 'ConversationSnapshotStatisticsViewByMeta';
  aggregation: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export enum ConversationSortOrder {
  Newest = 'NEWEST',
  NewestUnanswered = 'NEWEST_UNANSWERED',
  Oldest = 'OLDEST',
  OldestUnanswered = 'OLDEST_UNANSWERED',
  Starred = 'STARRED',
  WaitingTime = 'WAITING_TIME'
}

export type ConversationSourcesAd = {
  __typename?: 'ConversationSourcesAd';
  adClicks?: Maybe<Scalars['Int']['output']>;
  adId?: Maybe<Scalars['String']['output']>;
  adName?: Maybe<Scalars['String']['output']>;
  adsetId?: Maybe<Scalars['String']['output']>;
  adsetName?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<ChannelType>;
  conversionValues?: Maybe<Array<Maybe<ConversationSourcesMoney>>>;
  conversionsSent?: Maybe<Scalars['Int']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  starts?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type ConversationSourcesAdset = {
  __typename?: 'ConversationSourcesAdset';
  adClicks?: Maybe<Scalars['Int']['output']>;
  adsetId?: Maybe<Scalars['String']['output']>;
  adsetName?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  conversionValues?: Maybe<Array<Maybe<ConversationSourcesMoney>>>;
  conversionsSent?: Maybe<Scalars['Int']['output']>;
  starts?: Maybe<Scalars['Int']['output']>;
};

export type ConversationSourcesCampaign = {
  __typename?: 'ConversationSourcesCampaign';
  adClicks?: Maybe<Scalars['Int']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  conversionValues?: Maybe<Array<Maybe<ConversationSourcesMoney>>>;
  conversionsSent?: Maybe<Scalars['Int']['output']>;
  starts?: Maybe<Scalars['Int']['output']>;
};

export type ConversationSourcesDateRange = {
  __typename?: 'ConversationSourcesDateRange';
  from?: Maybe<Scalars['Date']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
};

export type ConversationSourcesDay = {
  __typename?: 'ConversationSourcesDay';
  adStarts?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  organicStarts?: Maybe<Scalars['Int']['output']>;
  starts?: Maybe<Scalars['Int']['output']>;
  unknownStarts?: Maybe<Scalars['Int']['output']>;
};

export type ConversationSourcesMoney = {
  __typename?: 'ConversationSourcesMoney';
  currency?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ConversationSourcesPlatform = {
  __typename?: 'ConversationSourcesPlatform';
  adStarts?: Maybe<Scalars['Int']['output']>;
  channelType?: Maybe<ChannelType>;
  organicStarts?: Maybe<Scalars['Int']['output']>;
  starts?: Maybe<Scalars['Int']['output']>;
  unknownStarts?: Maybe<Scalars['Int']['output']>;
};

export type ConversationSourcesReport = {
  __typename?: 'ConversationSourcesReport';
  adsTotal?: Maybe<Scalars['Int']['output']>;
  byAd?: Maybe<Array<Maybe<ConversationSourcesAd>>>;
  byAdset?: Maybe<Array<Maybe<ConversationSourcesAdset>>>;
  byCampaign?: Maybe<Array<Maybe<ConversationSourcesCampaign>>>;
  byDay?: Maybe<Array<Maybe<ConversationSourcesDay>>>;
  byPlatform?: Maybe<Array<Maybe<ConversationSourcesPlatform>>>;
  dateRange?: Maybe<ConversationSourcesDateRange>;
  timeZone?: Maybe<Scalars['String']['output']>;
  totals?: Maybe<ConversationSourcesTotals>;
  trackingSince?: Maybe<Scalars['Date']['output']>;
};

export type ConversationSourcesReportInput = {
  adsLimit?: InputMaybe<Scalars['Int']['input']>;
  adsOffset?: InputMaybe<Scalars['Int']['input']>;
  adsetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<ChannelType>;
  customerId: Scalars['ID']['input'];
  dateRange: ConversationSnapshotStatisticsDateRangeInput;
  eventNames?: InputMaybe<Array<Scalars['String']['input']>>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ConversationSourcesReportResponse = {
  __typename?: 'ConversationSourcesReportResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ConversationSourcesReport>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationSourcesTotals = {
  __typename?: 'ConversationSourcesTotals';
  adClicks?: Maybe<Scalars['Int']['output']>;
  adStarts?: Maybe<Scalars['Int']['output']>;
  adUniqueContacts?: Maybe<Scalars['Int']['output']>;
  conversionValues?: Maybe<Array<Maybe<ConversationSourcesMoney>>>;
  conversionsSent?: Maybe<Scalars['Int']['output']>;
  organicStarts?: Maybe<Scalars['Int']['output']>;
  starts?: Maybe<Scalars['Int']['output']>;
  uniqueContacts?: Maybe<Scalars['Int']['output']>;
  unknownStarts?: Maybe<Scalars['Int']['output']>;
};

export enum ConversationStatusEnum {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Snoozed = 'SNOOZED',
  Spam = 'SPAM'
}

export type ConversationSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type ConversationSubscriptionType = {
  __typename?: 'ConversationSubscriptionType';
  _id?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Maybe<ChannelTypes>>>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  isGroupOrChannel?: Maybe<Scalars['Boolean']['output']>;
  isStarSubscription?: Maybe<Scalars['Boolean']['output']>;
  isStarred?: Maybe<Scalars['Boolean']['output']>;
  joinedCPerson?: Maybe<Scalars['ID']['output']>;
  joinedPerson?: Maybe<Person>;
  lastJoinedCPerson?: Maybe<Scalars['ID']['output']>;
  lastMessage?: Maybe<LastMessageType>;
  lastReceivedMessageChannel?: Maybe<Scalars['ID']['output']>;
  previousParticipant?: Maybe<Scalars['ID']['output']>;
  previousStatus?: Maybe<ConversationStatusEnum>;
  priority?: Maybe<TicketPriority>;
  slaInstance?: Maybe<Scalars['ID']['output']>;
  slaInstanceData?: Maybe<SlaInstance>;
  sourceFormId?: Maybe<Scalars['ID']['output']>;
  sourcePlatformType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConversationStatusEnum>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  ticketCustomFields?: Maybe<Array<Maybe<TicketCustomFieldOutput>>>;
  ticketId?: Maybe<Scalars['Number']['output']>;
  ticketState?: Maybe<Scalars['ID']['output']>;
  ticketStateCategory?: Maybe<TicketStateCategoryType>;
  ticketStateTime?: Maybe<Scalars['Object']['output']>;
  ticketType?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ConversationTypeEnum>;
  unAnsweredMessageCount?: Maybe<Scalars['Int']['output']>;
  waitingSince?: Maybe<Scalars['Date']['output']>;
};

export enum ConversationTypeEnum {
  Conversation = 'CONVERSATION',
  Ticket = 'TICKET'
}

export type ConversationView = {
  __typename?: 'ConversationView';
  _id: Scalars['ID']['output'];
  conditions?: Maybe<Array<Maybe<ConvViewsConditionsType>>>;
  createdBy: Scalars['ID']['output'];
  customer: Scalars['ID']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isVisibleToAllCPerson?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  selectedCPersons?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  shouldMatchAllConditions?: Maybe<Scalars['Boolean']['output']>;
};

/** One agent's order and visibility for the inbox custom views. `views` order is the display order. */
export type ConversationViewPreference = {
  __typename?: 'ConversationViewPreference';
  _id: Scalars['ID']['output'];
  cPerson: Scalars['ID']['output'];
  customer: Scalars['ID']['output'];
  views: Array<ConversationViewPreferenceItem>;
};

export type ConversationViewPreferenceItem = {
  __typename?: 'ConversationViewPreferenceItem';
  isVisible: Scalars['Boolean']['output'];
  view: Scalars['ID']['output'];
};

export type ConversationViewPreferenceItemInput = {
  isVisible: Scalars['Boolean']['input'];
  view: Scalars['ID']['input'];
};

export type ConversationViewPreferenceResponse = {
  __typename?: 'ConversationViewPreferenceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ConversationViewPreference>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationsByPersoResponse = {
  __typename?: 'ConversationsByPersoResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationByPersonPage;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationsByPersonIdResponse = {
  __typename?: 'ConversationsByPersonIdResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationByPersonData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationsResponse = {
  __typename?: 'ConversationsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationPage;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvertedFileResponse = {
  __typename?: 'ConvertedFileResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvsUpdateInput = {
  convId: Scalars['ID']['input'];
  joinedPerson?: InputMaybe<JoinedPersonInput>;
};

export type CostResponse = {
  __typename?: 'CostResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CostDataType;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Country = {
  __typename?: 'Country';
  _id?: Maybe<Scalars['ID']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  hasCity?: Maybe<Scalars['Boolean']['output']>;
  hasProvince?: Maybe<Scalars['Boolean']['output']>;
  hasState?: Maybe<Scalars['Boolean']['output']>;
  iso2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  native?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<Translations>;
};

export type CountryResponse = {
  __typename?: 'CountryResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PaginatedCountry;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CouponCode = {
  __typename?: 'CouponCode';
  _id?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  maxRedemptions?: Maybe<Scalars['Number']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timesRedeemed?: Maybe<Scalars['Number']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  usageCount?: Maybe<Scalars['Number']['output']>;
  usageLimit?: Maybe<Scalars['Number']['output']>;
  usageType?: Maybe<CouponUsageType>;
  value?: Maybe<Scalars['Number']['output']>;
  valueType?: Maybe<CouponValueType>;
};

export type CouponCodeResponse = {
  __typename?: 'CouponCodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CouponCode;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CouponCodeSubscriptionInput = {
  token: Scalars['String']['input'];
};

export type CouponCodesResponse = {
  __typename?: 'CouponCodesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CouponCode>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CouponStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Used = 'USED'
}

export enum CouponUsageType {
  Aiassistant = 'AIASSISTANT',
  Monthly = 'MONTHLY',
  Monthlyandyearly = 'MONTHLYANDYEARLY',
  Yearly = 'YEARLY'
}

export enum CouponValueType {
  Amount = 'AMOUNT',
  Percent = 'PERCENT'
}

export type CreateActionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collectInfo?: InputMaybe<Array<InputMaybe<ActionCustomField>>>;
  customFieldInfo?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Array<InputMaybe<ActionFormData>>>;
  formDataUrlEncoded?: InputMaybe<Array<InputMaybe<ActionFormData>>>;
  headers: Array<InputMaybe<ActionHeader>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  method: ActionMethod;
  name: Scalars['String']['input'];
  platformAction?: InputMaybe<PlatformActionMethod>;
  requiresConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  responseMapping?: InputMaybe<Array<InputMaybe<ActionResponseMapping>>>;
  type?: InputMaybe<ActionTypeEnum>;
  url: Scalars['String']['input'];
};

export type CreateAddOnInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateAiGuidanceInput = {
  category: AiGuidanceCategoryEnum;
  channel?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  messageTypes?: InputMaybe<Array<InputMaybe<AiGuidanceMessageTypeEnum>>>;
  /** AI roles this guidance applies to. Empty means every role. */
  roles?: InputMaybe<Array<AiRoleEnum>>;
  status?: InputMaybe<AiGuidanceStatusEnum>;
  title: Scalars['String']['input'];
  toneOfVoice?: InputMaybe<AiProfileToneOfVoiceEnum>;
};

export type CreateAiKnowledgeSourceInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Leave empty for every channel. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdBy: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  failedReason?: InputMaybe<Scalars['String']['input']>;
  isSinglePage?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['FileUpload']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<AiKnowledgeSourcesSourceTypes>;
  title: Scalars['String']['input'];
};

export type CreateAuthenticationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Array<InputMaybe<AuthenticationFormData>>>;
  formDataUrlEncoded?: InputMaybe<Array<InputMaybe<AuthenticationFormData>>>;
  headers?: InputMaybe<Array<InputMaybe<AuthenticationHeader>>>;
  method?: InputMaybe<AuthenticationMethod>;
  name: Scalars['String']['input'];
  oauthConsumerKey?: InputMaybe<Scalars['String']['input']>;
  oauthConsumerSecret?: InputMaybe<Scalars['String']['input']>;
  oauthRealm?: InputMaybe<Scalars['String']['input']>;
  oauthSignatureMethod?: InputMaybe<Scalars['String']['input']>;
  oauthToken?: InputMaybe<Scalars['String']['input']>;
  oauthTokenSecret?: InputMaybe<Scalars['String']['input']>;
  oauthVersion?: InputMaybe<Scalars['String']['input']>;
  refreshTokenTime?: InputMaybe<Scalars['Int']['input']>;
  responseMapping?: InputMaybe<Array<AuthenticationResponseMapping>>;
  tokenKey?: InputMaybe<Scalars['String']['input']>;
  tokenPrefix?: InputMaybe<Scalars['String']['input']>;
  tokenValue?: InputMaybe<Scalars['String']['input']>;
  type: AuthenticationType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBulkCollageSharingInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  qpienPersonGroups: Array<InputMaybe<Scalars['String']['input']>>;
  telegramChannels: Array<InputMaybe<Scalars['String']['input']>>;
  telegramSendFileNames: Scalars['Boolean']['input'];
  telegramSendFolderNames: Scalars['Boolean']['input'];
  telegramSendingType: Scalars['String']['input'];
  whatsAppGroups: Array<InputMaybe<Scalars['String']['input']>>;
  whatsAppSendFileNames: Scalars['Boolean']['input'];
  whatsAppSendFolderNames: Scalars['Boolean']['input'];
};

export type CreateBulkSharingInput = {
  customerId: Scalars['ID']['input'];
  qpienPersonGroups: Array<InputMaybe<Scalars['String']['input']>>;
  telegramChannels: Array<InputMaybe<Scalars['String']['input']>>;
  telegramSendFileNames: Scalars['Boolean']['input'];
  telegramSendFolderNames: Scalars['Boolean']['input'];
  telegramSendingType: Scalars['String']['input'];
  whatsAppGroups: Array<InputMaybe<Scalars['String']['input']>>;
  whatsAppSendFileNames: Scalars['Boolean']['input'];
  whatsAppSendFolderNames: Scalars['Boolean']['input'];
};

export type CreateBusinessHoursScheduleInput = {
  customerId: Scalars['ID']['input'];
  days: Array<WorkingHourInput>;
  holidays?: InputMaybe<Array<BusinessHoursHolidayInput>>;
  name: Scalars['String']['input'];
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCPersonRoleInput = {
  cPersons: Array<Scalars['ID']['input']>;
  customer: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<RolePermission>>>;
  status?: InputMaybe<RoleStatus>;
};

export type CreateCampaignInput = {
  customerId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateChangelogCategoryInput = {
  color: Scalars['String']['input'];
  translations: Scalars['Object']['input'];
};

export type CreateChangelogInput = {
  categoryId: Scalars['ID']['input'];
  channels: Array<ChangelogChannel>;
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  translations: Scalars['Object']['input'];
};

export type CreateCityInput = {
  name: Scalars['String']['input'];
  stateProvinceId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type CreateCollageBarcodeInput = {
  barcode: Scalars['FileUpload']['input'];
  customerId: Scalars['ID']['input'];
  fields: Array<BarcodeFieldInput>;
};

export type CreateCollageFolderInput = {
  customerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentFolder?: InputMaybe<Scalars['ID']['input']>;
  selectedCPersons: Array<InputMaybe<Scalars['ID']['input']>>;
  visibleTo: VisibleTo;
};

export type CreateCollageProductInput = {
  barcode: Scalars['String']['input'];
  brand: Scalars['String']['input'];
  category: Scalars['String']['input'];
  code: Scalars['String']['input'];
  collageImage: Scalars['FileUpload']['input'];
  collageTemplate?: InputMaybe<Scalars['ID']['input']>;
  color: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  discountedPrice?: InputMaybe<Scalars['Number']['input']>;
  folders: Array<InputMaybe<Scalars['ID']['input']>>;
  layoutState?: InputMaybe<CollageLayoutStateInput>;
  modalName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Number']['input'];
  productImages: Array<InputMaybe<Scalars['FileUpload']['input']>>;
  size: Scalars['String']['input'];
};

export type CreateCollageSettingsInput = {
  barcodeCustomExtension?: InputMaybe<Scalars['ID']['input']>;
  bulkSettings?: InputMaybe<CollageBulkSettingsInput>;
  customerId: Scalars['ID']['input'];
  sqlConfig?: InputMaybe<CollageSqlConfigInput>;
};

export type CreateCollageSharingInput = {
  cPerson: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  folderLength: Scalars['Int']['input'];
  folderName: Scalars['String']['input'];
  medias: Array<InputMaybe<Scalars['ID']['input']>>;
  status: SharingStatus;
  type: SharingType;
};

export type CreateCollageTemplateInput = {
  backgroundColor: Scalars['String']['input'];
  collage: TemplateLayout;
  coverImage?: InputMaybe<Scalars['FileUpload']['input']>;
  customerId: Scalars['ID']['input'];
  discountLabel?: InputMaybe<Scalars['String']['input']>;
  discountStyle?: InputMaybe<TemplateDiscountStyle>;
  footer: TemplateFooter;
  footerCodeSizeDelta?: InputMaybe<Scalars['Int']['input']>;
  footerFontWeight?: InputMaybe<TemplateFooterFontWeight>;
  footerPriceSizeDelta?: InputMaybe<Scalars['Int']['input']>;
  frame: FrameRatio;
  header: TemplateHeader;
  isDefault: Scalars['Boolean']['input'];
  mainColor: Scalars['String']['input'];
  mainLogo?: InputMaybe<Scalars['FileUpload']['input']>;
  name: Scalars['String']['input'];
  priceTextColor?: InputMaybe<Scalars['String']['input']>;
  productDataSource: ProductDataSource;
  secondaryColor: Scalars['String']['input'];
  secondaryLogo?: InputMaybe<Scalars['FileUpload']['input']>;
  selectedCPersons: Array<InputMaybe<Scalars['ID']['input']>>;
  textColor: Scalars['String']['input'];
  visibleTo: VisibleTo;
};

export type CreateCollageTemplateSetData = {
  __typename?: 'CreateCollageTemplateSetData';
  folder: CollageFolder;
  templates: Array<Maybe<CollageTemplate>>;
};

export type CreateCollageTemplateSetInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  folderName: Scalars['String']['input'];
  secondaryLogo: Scalars['FileUpload']['input'];
};

export type CreateCollageTemplateSetResponse = {
  __typename?: 'CreateCollageTemplateSetResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CreateCollageTemplateSetData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateConvSidebarInput = {
  cPerson: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  views: Array<InputMaybe<CreateSidebarViewInput>>;
};

export type CreateConvViewInput = {
  conditions: Array<ConvViewsConditionsInput>;
  createdBy: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisibleToAllCPerson: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  selectedCPersons: Array<InputMaybe<Scalars['String']['input']>>;
  shouldMatchAllConditions: Scalars['Boolean']['input'];
};

export type CreateCountryInput = {
  emoji: Scalars['String']['input'];
  iso2: Scalars['String']['input'];
  name: Scalars['String']['input'];
  native: Scalars['String']['input'];
  translations: TranslationsInput;
};

export type CreateCouponCodeInput = {
  customer?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['Date']['input']>;
  maxRedemptions: Scalars['Number']['input'];
  name: Scalars['String']['input'];
  usageLimit: Scalars['Number']['input'];
  usageType: CouponUsageType;
  value: Scalars['Number']['input'];
  valueType: CouponValueType;
};

export type CreateCustomExtensionInput = {
  connectedAction?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  status: CustomExtensionStatus;
  tabsConfig?: InputMaybe<CreateCustomExtensionTabsInput>;
};

export type CreateCustomExtensionTabsInput = {
  mainTab?: InputMaybe<TabConfigInput>;
  otherTabs?: InputMaybe<Array<InputMaybe<TabConfigInput>>>;
};

export type CreateCustomFieldInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['String']['input'];
  decimal?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  listValues?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<EnumCustomFieldMediaType>;
  multiSelect?: InputMaybe<Scalars['Boolean']['input']>;
  multiline?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameVisibleToCustomers?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<EnumCustomFieldScope>;
  status?: InputMaybe<EnumCustomFieldStatus>;
  type: EnumCustomFieldsType;
  usage?: InputMaybe<EnumCustomFieldUsageField>;
  visibleToCustomers?: InputMaybe<EnumCustomFieldCustomerVisibility>;
  visibleToUsers?: InputMaybe<EnumCustomFieldUserVisibility>;
  withTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCustomerInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerFromChannel?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  language: Language;
  name: Scalars['String']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  personCount?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['FileUpload']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  surname?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerPersonInput = {
  canAccessPhoneCalls?: InputMaybe<Scalars['Boolean']['input']>;
  customer: Scalars['ID']['input'];
  dateFormat?: InputMaybe<CustomerDateFormat>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  hasAiAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  isAcceptingCalls?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  joinedConvCount?: InputMaybe<Scalars['Int']['input']>;
  joinedConvLimit?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Language>;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  signedTeams: Scalars['Array']['input'];
  status?: InputMaybe<CPersonStatus>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: CustomerType;
};

export type CreateDefaultCPersonRolesInput = {
  customer: Scalars['String']['input'];
};

export type CreateDefaultTicketInput = {
  customer: Scalars['String']['input'];
};

export type CreateECommerceIntegrationCustomerAddressInput = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  cityCode?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  district: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
  townCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateECommerceIntegrationCustomerAddressOutput = {
  __typename?: 'CreateECommerceIntegrationCustomerAddressOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CreateECommerceIntegrationCustomerAddressOutputData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateECommerceIntegrationCustomerAddressOutputData = {
  __typename?: 'CreateECommerceIntegrationCustomerAddressOutputData';
  data?: Maybe<EcommerceCustomerAddressData>;
};

export type CreateECommerceIntegrationCustomerInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type CreateECommerceIntegrationCustomerOutput = {
  __typename?: 'CreateECommerceIntegrationCustomerOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CreateECommerceIntegrationCustomerOutputData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateECommerceIntegrationCustomerOutputData = {
  __typename?: 'CreateECommerceIntegrationCustomerOutputData';
  data?: Maybe<EcommerceCustomerData>;
};

export type CreateECommerceIntegrationInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailOrPhone?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  storeUrl?: InputMaybe<Scalars['String']['input']>;
  tsoftServicePassword?: InputMaybe<Scalars['String']['input']>;
  tsoftServiceUsername?: InputMaybe<Scalars['String']['input']>;
  tsoftStorefrontClientId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateECommerceIntegrationOrderInput = {
  cargoCode?: InputMaybe<Scalars['String']['input']>;
  cargoCompanyId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  deliveryAddressId: Scalars['String']['input'];
  invoiceAddressId: Scalars['String']['input'];
  orderStatusId?: InputMaybe<Scalars['String']['input']>;
  paymentOptionId?: InputMaybe<Scalars['String']['input']>;
  paymentStatusId?: InputMaybe<Scalars['String']['input']>;
  paymentTypeId: Scalars['String']['input'];
  products: Array<CreateECommerceIntegrationOrderProductInput>;
};

export type CreateECommerceIntegrationOrderOutput = {
  __typename?: 'CreateECommerceIntegrationOrderOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CreateECommerceIntegrationOrderOutputData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateECommerceIntegrationOrderOutputData = {
  __typename?: 'CreateECommerceIntegrationOrderOutputData';
  order?: Maybe<CreateECommerceIntegrationOrderOutputDataItem>;
};

export type CreateECommerceIntegrationOrderOutputDataItem = {
  __typename?: 'CreateECommerceIntegrationOrderOutputDataItem';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateECommerceIntegrationOrderProductInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateECommerceIntegrationOutput = {
  __typename?: 'CreateECommerceIntegrationOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CreateECommerceIntegrationOutputData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateECommerceIntegrationOutputData = {
  __typename?: 'CreateECommerceIntegrationOutputData';
  _id: Scalars['ID']['output'];
  accessToken?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ECommerceIntegrationTypes>;
};

export type CreateECommerceRulesInput = {
  customer: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: EcommerceRulesEnum;
};

export type CreateExternalApiInput = {
  customerId: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFlowBotInput = {
  customer: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateFlowBotResponse = {
  __typename?: 'CreateFlowBotResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowBot>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateFlowNodeFlowBlock = {
  channelType?: InputMaybe<FlowMessageChannel>;
  fields?: InputMaybe<Array<InputMaybe<BlockFieldInput>>>;
  fieldsIndex?: InputMaybe<Scalars['Int']['input']>;
  flowBlockTemplateId: Scalars['String']['input'];
  media?: InputMaybe<Scalars['FileUpload']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateFlowNodeInput = {
  coordinates: FlowNodeCoordinateInput;
  customer: Scalars['String']['input'];
  flowBlocksToBeCreated?: InputMaybe<Array<InputMaybe<CreateFlowNodeFlowBlock>>>;
  flowBot: Scalars['ID']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateFlowNodeResponse = {
  __typename?: 'CreateFlowNodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateInboundWebhookInput = {
  defaults?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['ID']['input']>;
  mapping?: InputMaybe<Array<InboundWebhookMappingRuleInput>>;
  name: Scalars['String']['input'];
  sourceConfig?: InputMaybe<InboundWebhookSourceConfigInput>;
  triggerType: InboundWebhookTriggerType;
};

export type CreateIntegrationInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  isConnected: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type: IntegrationType;
};

export type CreateMailResponse = {
  __typename?: 'CreateMailResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerPerson>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMessageInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<ChannelType>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  convId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  emailData?: InputMaybe<MailInfoInput>;
  flowBotQuickReply?: InputMaybe<Array<InputMaybe<FlowBotQuickReplyInput>>>;
  flowBotQuickReplyButtonsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  flowBotQuickReplyResponseId?: InputMaybe<Scalars['String']['input']>;
  fromLiveChat?: InputMaybe<Scalars['Boolean']['input']>;
  frontMsgId?: InputMaybe<Scalars['String']['input']>;
  isAcceptedTemporaryReply?: InputMaybe<Scalars['Boolean']['input']>;
  isTicket?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['Media']['input']>>>;
  mentions?: InputMaybe<Array<Scalars['ID']['input']>>;
  msgId?: InputMaybe<Scalars['String']['input']>;
  msgType: MessageType;
  newTicketState?: InputMaybe<Scalars['String']['input']>;
  pChannelId?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  product_cards?: InputMaybe<Scalars['Object']['input']>;
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sender: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  surveyData?: InputMaybe<SurveyDataInputForLivechat>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  template_cards?: InputMaybe<Scalars['Object']['input']>;
  ticketAssigneeId?: InputMaybe<Scalars['String']['input']>;
  ticketCustomFieldInput?: InputMaybe<Array<InputMaybe<TicketCustomFieldInput>>>;
  ticketPriority?: InputMaybe<TicketPriority>;
  ticketStateId?: InputMaybe<Scalars['String']['input']>;
  ticketType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewConversationInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  fromLiveChat?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
};

export type CreatePGroupResponse = {
  __typename?: 'CreatePGroupResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PersonGroup>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreatePasswordInput = {
  customerId: Scalars['ID']['input'];
  emailVerificationId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CreatePersonCustomFieldInput = {
  fieldId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CreatePersonGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<InputConditions>>>;
  customer: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shouldMatchAllConditions?: InputMaybe<Scalars['Boolean']['input']>;
  whatsAppSenderPlatformId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonInput = {
  cPersonData: Array<CPersonData>;
  customerId: Scalars['ID']['input'];
  signedTeams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreatePersonNoteInput = {
  customerId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CreatePlatformInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  authenticationUrl?: InputMaybe<Scalars['String']['input']>;
  autoCloseConversationOnCallEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clientKey?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  connectVia?: InputMaybe<Scalars['String']['input']>;
  connectedEmailChannel?: InputMaybe<Scalars['String']['input']>;
  createNewChatPerMessage?: InputMaybe<Scalars['Boolean']['input']>;
  customer: Scalars['ID']['input'];
  emailSignature?: InputMaybe<Scalars['String']['input']>;
  groupChats?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiCallAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  hasCallTranscripts?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ignoredTickets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inboundWebhookId?: InputMaybe<Scalars['String']['input']>;
  ipAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  markOffline?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  outboundWebhookId?: InputMaybe<Scalars['String']['input']>;
  outgoingWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<Scalars['String']['input']>;
  satisfaction?: InputMaybe<SatisfactionInput>;
  senderEmailAddress?: InputMaybe<Scalars['String']['input']>;
  sipDomain?: InputMaybe<Scalars['String']['input']>;
  sla?: InputMaybe<SlaInput>;
  smtpConfig?: InputMaybe<SmtpConfigInput>;
  teams: Array<InputMaybe<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductInput = {
  features?: InputMaybe<ProductFeatureInput>;
  limits?: InputMaybe<ProductLimitsInput>;
  monthlyPrice: Scalars['Double']['input'];
  name: Scalars['String']['input'];
  yearlyPrice: Scalars['Double']['input'];
};

export type CreateQpienShopCustomerAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  qpienShopCustomerId: Scalars['String']['input'];
};

export type CreateQpienShopCustomerAddressResponse = {
  __typename?: 'CreateQpienShopCustomerAddressResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: QpienShopCustomerAddressData;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateQpienShopCustomerData = {
  __typename?: 'CreateQpienShopCustomerData';
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type CreateQpienShopCustomerInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQpienShopCustomerResponse = {
  __typename?: 'CreateQpienShopCustomerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CreateQpienShopCustomerData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateQpienShopOrderInput = {
  billingAddress?: InputMaybe<QpienShopDraftOrderAddressInput>;
  billing_address_id: Scalars['String']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currentTotal?: InputMaybe<Scalars['Float']['input']>;
  customerId: Scalars['String']['input'];
  discountTotal?: InputMaybe<Scalars['Float']['input']>;
  draftItems: Array<QpienShopDraftOrderItemInput>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<QpienShopOrderItemInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<OrderPaymentType>;
  platformType: ECommerceIntegrationTypes;
  qpienShopCustomerId: Scalars['String']['input'];
  region_id: Scalars['String']['input'];
  sales_channel_id: Scalars['String']['input'];
  shippingAddress?: InputMaybe<QpienShopDraftOrderAddressInput>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingTotal?: InputMaybe<Scalars['Float']['input']>;
  shipping_address_id: Scalars['String']['input'];
  shipping_methods: QpienShopShippingMethodInput;
};

export type CreateQpienShopOrderResponse = {
  __typename?: 'CreateQpienShopOrderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Object']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateQpienShopStoreData = {
  __typename?: 'CreateQpienShopStoreData';
  _id: Scalars['ID']['output'];
  apiKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
  storeOwnerId: Scalars['String']['output'];
};

export type CreateQpienShopStoreInput = {
  customerId: Scalars['String']['input'];
  defaultCurrency: Scalars['String']['input'];
  defaultRegionCountry: Scalars['String']['input'];
  defaultSalesChannelName: Scalars['String']['input'];
  defaultTaxRate: Scalars['Number']['input'];
  storeName: Scalars['String']['input'];
  storeOwnerEmail: Scalars['String']['input'];
  storeOwnerFirstName: Scalars['String']['input'];
  storeOwnerLastName: Scalars['String']['input'];
  storeOwnerPassword: Scalars['String']['input'];
};

export type CreateQpienShopStoreResponse = {
  __typename?: 'CreateQpienShopStoreResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CreateQpienShopStoreData;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateQuickAnswerInput = {
  actions?: InputMaybe<Array<InputMaybe<QuickAnswerActionInput>>>;
  answer: Scalars['String']['input'];
  channels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customer: Scalars['ID']['input'];
  customerPersons?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  payload: Array<InputMaybe<QuickAnswerPayload>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateRecordInput = {
  customerId: Scalars['ID']['input'];
  data?: InputMaybe<RecordData>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IntegrationType>;
};

export type CreateRecordNoteInput = {
  customerId: Scalars['ID']['input'];
  data?: InputMaybe<NoteRecord>;
  type?: InputMaybe<IntegrationType>;
};

export type CreateReportInput = {
  customerId: Scalars['ID']['input'];
  dateRange?: InputMaybe<ReportDateRangeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  hasAccess?: InputMaybe<ReportAccess>;
  name: Scalars['String']['input'];
  refreshInterval?: InputMaybe<Scalars['Int']['input']>;
  selectedCPersons?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedTeams?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateReportWidgetInput = {
  chartType?: InputMaybe<Scalars['String']['input']>;
  dateRangeOverride?: InputMaybe<ReportDateRangeInput>;
  layout?: InputMaybe<LayoutInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  segmentBy?: InputMaybe<ReportWidgetSegmentByInput>;
  templateId: Scalars['ID']['input'];
};

export type CreateReportWidgetMetricInput = {
  metricTemplateId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  widgetId: Scalars['ID']['input'];
};

export type CreateScheduleMessageInput = {
  actionDate: Scalars['Date']['input'];
  cPerson: Scalars['ID']['input'];
  conversation: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type CreateSidebarViewInput = {
  isPinned: Scalars['Boolean']['input'];
  view: Scalars['String']['input'];
};

export type CreateSkillInput = {
  customerId: Scalars['ID']['input'];
  definition: SkillDefinitionInput;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** AI roles this skill belongs to. Empty means every role. */
  roles?: InputMaybe<Array<AiRoleEnum>>;
};

export type CreateSlaPolicyInput = {
  conditions?: InputMaybe<Array<SlaPolicyConditionInput>>;
  customerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  rules?: InputMaybe<SlaPolicyRulesInput>;
  targets?: InputMaybe<SlaPolicyTargetsInput>;
  type: SlaPolicyType;
};

export type CreateSnoozeInput = {
  actionDate: Scalars['Date']['input'];
  cPerson: Scalars['ID']['input'];
  conversation: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type CreateStateProvinceInput = {
  countryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateSurveyHistoryInput = {
  channel: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  chat: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  customerPerson: Scalars['ID']['input'];
  person: Scalars['ID']['input'];
  survey: Scalars['ID']['input'];
  surveyName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSurveysInput = {
  commentInputTitle?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['Media']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  submitButtonText?: InputMaybe<Scalars['String']['input']>;
  thankYouMessage?: InputMaybe<Scalars['String']['input']>;
  themeMainColor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTableFieldInput = {
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  listOptions?: InputMaybe<Array<TableListOptionInput>>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<TableFieldSettingsInput>;
  tableId: Scalars['ID']['input'];
  type: TableFieldType;
};

export type CreateTableFolderInput = {
  customerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateTableInput = {
  customerId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rowHeight?: InputMaybe<TableRowHeight>;
  teamIds: Array<Scalars['ID']['input']>;
};

export type CreateTableRecordActivityInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  media?: InputMaybe<Array<InputMaybe<Scalars['Object']['input']>>>;
  recordId: Scalars['ID']['input'];
};

export type CreateTableRecordInput = {
  customerId: Scalars['ID']['input'];
  kanbanOrder?: InputMaybe<Scalars['Object']['input']>;
  tableId: Scalars['ID']['input'];
  values?: InputMaybe<Scalars['Object']['input']>;
};

export type CreateTableViewInput = {
  customerId: Scalars['ID']['input'];
  groupByFieldId?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  tableId: Scalars['ID']['input'];
  type: TableViewType;
};

export type CreateTagInput = {
  color: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: TagType;
};

export type CreateTaskCommentInput = {
  mentions?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CreateTaskInput = {
  cPerson?: InputMaybe<Scalars['ID']['input']>;
  createdBy: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt: Scalars['Date']['input'];
  media?: InputMaybe<Array<MediaInput>>;
  priority?: InputMaybe<TaskPriority>;
  remindeAt?: InputMaybe<Scalars['Date']['input']>;
  repeat?: InputMaybe<RepeatInput>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType: TaskSourceType;
  status?: InputMaybe<TaskStatus>;
  tag?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateTaskLogInput = {
  cPerson: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  task: Scalars['ID']['input'];
  type: TaskLogType;
  value: Scalars['String']['input'];
};

export type CreateTeamGroupChatInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  memberUserIds: Array<Scalars['ID']['input']>;
  permissions?: InputMaybe<TeamChatPermissionsInput>;
  title: Scalars['String']['input'];
};

export type CreateTicketCustomFieldInput = {
  customFieldId: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTicketStateInput = {
  category: TicketStateCategoryType;
  customer: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameVisibleToCustomers?: InputMaybe<Scalars['String']['input']>;
  status: TicketStatusType;
};

export type CreateTicketTypeInput = {
  customFields?: InputMaybe<Array<Scalars['ID']['input']>>;
  customer: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emoji: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameVisibleToCustomers?: InputMaybe<Scalars['String']['input']>;
  shareStagesWithCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<Scalars['ID']['input']>>;
  status: TicketStatusType;
  usage?: InputMaybe<TicketTypeUsage>;
};

export type CreateTopicInput = {
  customerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  role?: InputMaybe<RoleTypes>;
  surname: Scalars['String']['input'];
};

export type CreateWabaTemplateInput = {
  appId: Scalars['String']['input'];
  buttons?: InputMaybe<Array<InputMaybe<ButtonType>>>;
  cards?: InputMaybe<Array<CarouselCardInput>>;
  category: CategoryTypes;
  customer: Scalars['ID']['input'];
  eCommerceCart?: InputMaybe<Scalars['Boolean']['input']>;
  enableExpirationTime?: InputMaybe<Scalars['Boolean']['input']>;
  enableSecurityRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  example?: InputMaybe<Scalars['String']['input']>;
  exampleMedia?: InputMaybe<Scalars['String']['input']>;
  expirationTime?: InputMaybe<Scalars['Number']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  qpienFields?: InputMaybe<Array<InputMaybe<QpienFields>>>;
  sampleMedia?: InputMaybe<Scalars['Media']['input']>;
  survey?: InputMaybe<Scalars['String']['input']>;
  templateType: TemplateTypes;
  vertical: Scalars['String']['input'];
};

export type CreateWebhookInput = {
  customerId: Scalars['ID']['input'];
  endpointUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatedByPerson = {
  __typename?: 'CreatedByPerson';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreatedExternalApiResponse = {
  __typename?: 'CreatedExternalApiResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: NewExternalApi;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreatedWebhookResponse = {
  __typename?: 'CreatedWebhookResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: NewWebhook;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomConversationsQueryData = {
  __typename?: 'CustomConversationsQueryData';
  docs: Array<Maybe<Conversation>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type CustomConversationsQueryOutput = {
  __typename?: 'CustomConversationsQueryOutput';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomConversationsQueryData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomDataType = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Int']['input']>;
  periodMode?: InputMaybe<ProductPeriodMode>;
  productName?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  shop?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CustomECommerceIntegrationResponse = {
  __typename?: 'CustomECommerceIntegrationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomExtension = {
  __typename?: 'CustomExtension';
  _id?: Maybe<Scalars['ID']['output']>;
  connectedAction?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomExtensionStatus>;
  tabsConfig?: Maybe<CustomExtensionTabs>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CustomExtensionFieldsResponse = {
  __typename?: 'CustomExtensionFieldsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CustomFields>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomExtensionResponse = {
  __typename?: 'CustomExtensionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomExtension;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CustomExtensionStatus {
  Active = 'ACTIVE',
  Passive = 'PASSIVE'
}

export type CustomExtensionTabActionData = {
  __typename?: 'CustomExtensionTabActionData';
  httpResponse?: Maybe<HttpTestResponseType>;
  sections?: Maybe<Array<Maybe<ParsedSection>>>;
};

export type CustomExtensionTabs = {
  __typename?: 'CustomExtensionTabs';
  mainTab?: Maybe<TabConfig>;
  otherTabs?: Maybe<Array<Maybe<TabConfig>>>;
};

export type CustomField = {
  __typename?: 'CustomField';
  _id?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Maybe<CustomFieldCondition>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  listValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mediaType?: Maybe<EnumCustomFieldMediaType>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumCustomFieldStatus>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visibleToCustomers?: Maybe<EnumCustomFieldCustomerVisibility>;
  visibleToUsers?: Maybe<EnumCustomFieldUserVisibility>;
};

export type CustomFieldCondition = {
  __typename?: 'CustomFieldCondition';
  parentField: Scalars['ID']['output'];
  parentValues: Array<Scalars['String']['output']>;
};

export type CustomFieldConditionInput = {
  customFieldId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CustomFieldResponse = {
  __typename?: 'CustomFieldResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomFields>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomFields = {
  __typename?: 'CustomFields';
  _id: Scalars['ID']['output'];
  conditions?: Maybe<Array<Maybe<CustomFieldCondition>>>;
  createdAt: Scalars['Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer: Scalars['ID']['output'];
  decimal?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  listValues?: Maybe<Array<Scalars['String']['output']>>;
  mediaType?: Maybe<EnumCustomFieldMediaType>;
  multiSelect?: Maybe<Scalars['Boolean']['output']>;
  multiline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nameVisibleToCustomers?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<EnumCustomFieldScope>;
  status?: Maybe<EnumCustomFieldStatus>;
  type: EnumCustomFieldsType;
  updatedAt: Scalars['Date']['output'];
  usage?: Maybe<EnumCustomFieldUsageField>;
  visibleToCustomers?: Maybe<EnumCustomFieldCustomerVisibility>;
  visibleToUsers?: Maybe<EnumCustomFieldUserVisibility>;
  withTime?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFieldsAllResponse = {
  __typename?: 'CustomFieldsAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<CustomFields>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomIntegrationResponse = {
  __typename?: 'CustomIntegrationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomModuleField = {
  api_name?: InputMaybe<Scalars['String']['input']>;
  data_type?: InputMaybe<Scalars['String']['input']>;
  field_label?: InputMaybe<Scalars['String']['input']>;
  pick_list_values?: InputMaybe<Array<InputMaybe<PickListValue>>>;
};

export type CustomModuleFieldOutput = {
  __typename?: 'CustomModuleFieldOutput';
  api_name?: Maybe<Scalars['String']['output']>;
  data_type?: Maybe<Scalars['String']['output']>;
  field_label?: Maybe<Scalars['String']['output']>;
  pick_list_values?: Maybe<Array<Maybe<PickListValueOutput>>>;
};

export type CustomPlatformInput = {
  customerId: Scalars['ID']['input'];
  metaData: Scalars['Object']['input'];
  type: Scalars['String']['input'];
};

export type CustomPlatformsResponse = {
  __typename?: 'CustomPlatformsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CustomQueryOperationsType {
  GetConfirmationUrl = 'GET_CONFIRMATION_URL',
  GetLoginUrl = 'GET_LOGIN_URL'
}

export type Customer = {
  __typename?: 'Customer';
  _id?: Maybe<Scalars['ID']['output']>;
  accountConfirmation?: Maybe<Scalars['String']['output']>;
  accountStatus?: Maybe<Scalars['String']['output']>;
  allowConnect?: Maybe<Scalars['Boolean']['output']>;
  allowUnassignedTicket?: Maybe<Scalars['Boolean']['output']>;
  appStatus?: Maybe<Scalars['String']['output']>;
  autoApproveSharingRequests?: Maybe<Scalars['Boolean']['output']>;
  autoAssignmentType?: Maybe<AutoAssignmentTypeEnum>;
  autoConversationAssignment?: Maybe<Scalars['Boolean']['output']>;
  autoConversationAssignmentTime?: Maybe<Scalars['Int']['output']>;
  autoConversationAssignmentTimeUnit?: Maybe<Scalars['String']['output']>;
  cPersonsAutoAwayTime?: Maybe<Scalars['Int']['output']>;
  canManageOtherUserConversation?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closingNote?: Maybe<ClosingNoteDetail>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerFromChannel?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is2FARequired?: Maybe<Scalars['Boolean']['output']>;
  isANewCustomer?: Maybe<Scalars['Boolean']['output']>;
  isDummy?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Language>;
  onboarding?: Maybe<CustomerOnboarding>;
  package?: Maybe<CustomerProduct>;
  partnerCode?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  sendAutoSurvey?: Maybe<SendAutoSurveyType>;
  signUpMethod?: Maybe<SignUpMethod>;
  teamFirstResponseGoalTime?: Maybe<Scalars['Int']['output']>;
  teamGoalTime?: Maybe<Scalars['Int']['output']>;
  teamOnlineGoalTime?: Maybe<Scalars['Int']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  twSubAccount?: Maybe<TwSubAccount>;
};

export type CustomerAbandonedOrder = {
  __typename?: 'CustomerAbandonedOrder';
  available: Scalars['Boolean']['output'];
  data?: Maybe<Scalars['Object']['output']>;
};

export type CustomerAbandonedOrderResponse = {
  __typename?: 'CustomerAbandonedOrderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerAbandonedOrder;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerBalanceHistory = {
  __typename?: 'CustomerBalanceHistory';
  _id: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  usageType: BalanceUsageTypeEnum;
};

export type CustomerBillingAddresses = {
  __typename?: 'CustomerBillingAddresses';
  _id: Scalars['ID']['output'];
  accountingContactId?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customer: Scalars['ID']['output'];
  isCompany?: Maybe<Scalars['Boolean']['output']>;
  legalCompanyName?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  taxOffice?: Maybe<Scalars['String']['output']>;
};

export type CustomerBillingAddressesInput = {
  accountingContactId?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  legalCompanyName?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  taxOffice?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerBillingAddressesOutput = {
  __typename?: 'CustomerBillingAddressesOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerBillingAddresses>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerBillingContactsInput = {
  customer: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  isEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerBillingContactsResponse = {
  __typename?: 'CustomerBillingContactsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CBillingContacts>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CustomerDateFormat {
  DayMonthYear12hour = 'DayMonthYear12hour',
  DayMonthYear24hour = 'DayMonthYear24hour',
  MonthDayYear12hour = 'MonthDayYear12hour',
  MonthDayYear24hour = 'MonthDayYear24hour'
}

export type CustomerInvoice = {
  __typename?: 'CustomerInvoice';
  _id: Scalars['ID']['output'];
  accountingInfo?: Maybe<CustomerInvoiceAccountingInfo>;
  accountingInvoiceId?: Maybe<Scalars['String']['output']>;
  amountPaid?: Maybe<Scalars['Double']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  invoiceNo?: Maybe<Scalars['String']['output']>;
  isDefaultInvoice?: Maybe<Scalars['Boolean']['output']>;
  paymentInvoice?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  paymentType: PaymentType;
  products: Array<Maybe<Product>>;
};

export type CustomerInvoiceAccountingInfo = {
  __typename?: 'CustomerInvoiceAccountingInfo';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CustomerInvoicePaginatedResponse = {
  __typename?: 'CustomerInvoicePaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerInvoicesPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerInvoiceResponse = {
  __typename?: 'CustomerInvoiceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<CustomerInvoice>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerInvoicesPaginatedData = {
  __typename?: 'CustomerInvoicesPaginatedData';
  docs: Array<Maybe<CustomerInvoice>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type CustomerOnboarding = {
  __typename?: 'CustomerOnboarding';
  accountCustomized?: Maybe<Scalars['Boolean']['output']>;
  aiAgentTrained?: Maybe<Scalars['Boolean']['output']>;
  channelConnected?: Maybe<Scalars['Boolean']['output']>;
  completedCount?: Maybe<Scalars['Int']['output']>;
  introVideoWatched?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  mobileAppDownloaded?: Maybe<Scalars['Boolean']['output']>;
  teamInvited?: Maybe<Scalars['Boolean']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerOnboardingInfo = {
  __typename?: 'CustomerOnboardingInfo';
  _id: Scalars['ID']['output'];
  aiInterest?: Maybe<OnboardingAiInterest>;
  channels?: Maybe<Array<OnboardingChannel>>;
  companyIndustry?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customer: Scalars['ID']['output'];
  favouriteProducts?: Maybe<Scalars['String']['output']>;
  howBuiltWebsite?: Maybe<Scalars['String']['output']>;
  howYouHearAboutUs?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  monthlyVolume?: Maybe<OnboardingMonthlyVolume>;
  ownerRole?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<OnboardingPlatform>;
  platformOther?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<OnboardingSector>;
  sectorOther?: Maybe<Scalars['String']['output']>;
  source?: Maybe<OnboardingSource>;
  sourceOther?: Maybe<Scalars['String']['output']>;
  teamSize?: Maybe<OnboardingTeamSize>;
};

export type CustomerOnboardingInfoInput = {
  aiInterest?: InputMaybe<OnboardingAiInterest>;
  channels?: InputMaybe<Array<OnboardingChannel>>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  favouriteProducts?: InputMaybe<Scalars['String']['input']>;
  howBuiltWebsite?: InputMaybe<Scalars['String']['input']>;
  howYouHearAboutUs?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  monthlyVolume?: InputMaybe<OnboardingMonthlyVolume>;
  ownerRole?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<OnboardingPlatform>;
  platformOther?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<OnboardingSector>;
  sectorOther?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OnboardingSource>;
  sourceOther?: InputMaybe<Scalars['String']['input']>;
  teamSize?: InputMaybe<OnboardingTeamSize>;
};

export type CustomerOnboardingInfoOutput = {
  __typename?: 'CustomerOnboardingInfoOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerOnboardingInfo>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPaymentCard = {
  __typename?: 'CustomerPaymentCard';
  _id?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  cards?: Maybe<Array<Maybe<PaymentCardInfo>>>;
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  requiresAction?: Maybe<Scalars['Boolean']['output']>;
  threeDSConversationId?: Maybe<Scalars['String']['output']>;
  threeDSHtmlContent?: Maybe<Scalars['String']['output']>;
  threeDSPaymentId?: Maybe<Scalars['String']['output']>;
  threeDSPaymentPageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CustomerPaymentCardInput = {
  cardAlias: Scalars['String']['input'];
  cardHolderName: Scalars['String']['input'];
  cardNumber: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  cvc: Scalars['String']['input'];
  expireMonth: Scalars['String']['input'];
  expireYear: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
};

export type CustomerPaymentCardOutput = {
  __typename?: 'CustomerPaymentCardOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerPaymentCard>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPerson = {
  __typename?: 'CustomerPerson';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Date']['output']>;
  canAccessPhoneCalls?: Maybe<Scalars['Boolean']['output']>;
  customer: Scalars['ID']['output'];
  dateFormat?: Maybe<CustomerDateFormat>;
  devices?: Maybe<Array<Maybe<CustomerPersonDevice>>>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  hasAiAssistant?: Maybe<Scalars['Boolean']['output']>;
  /** false = signed up with Google and has not set a password yet (no current password to ask). */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  is2FAEnabled?: Maybe<Scalars['Boolean']['output']>;
  isAcceptingCalls?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified: Scalars['Boolean']['output'];
  isInCall?: Maybe<Scalars['Boolean']['output']>;
  joinedConvCount?: Maybe<Scalars['Int']['output']>;
  joinedConvLimit?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Language>;
  lastName: Scalars['String']['output'];
  notificationSettings?: Maybe<NotificationSettings>;
  phone?: Maybe<Scalars['String']['output']>;
  productTour?: Maybe<ProductTour>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  signedTeams?: Maybe<Scalars['Array']['output']>;
  status: CPersonStatus;
  timeZone?: Maybe<Scalars['String']['output']>;
  type: CustomerType;
};

export type CustomerPersonActivityLog = {
  __typename?: 'CustomerPersonActivityLog';
  _id: Scalars['ID']['output'];
  activity?: Maybe<Scalars['String']['output']>;
  activityType?: Maybe<ActivityType>;
  cPerson?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  externalClientId?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CustomerPersonActivityLogResponse = {
  __typename?: 'CustomerPersonActivityLogResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerPersonActivityLog;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPersonActivityLogSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type CustomerPersonActivityLogsPaginatedData = {
  __typename?: 'CustomerPersonActivityLogsPaginatedData';
  docs: Array<Maybe<CustomerPersonActivityLog>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type CustomerPersonActivityLogsPaginatedResponse = {
  __typename?: 'CustomerPersonActivityLogsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerPersonActivityLogsPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPersonDevice = {
  __typename?: 'CustomerPersonDevice';
  lastLoginTime?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CustomerPersonDeviceStatus>;
  statusAwayTime?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<CustomerPersonDeviceType>;
};

export enum CustomerPersonDeviceStatus {
  Active = 'ACTIVE',
  Away = 'AWAY',
  Passive = 'PASSIVE'
}

export enum CustomerPersonDeviceType {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type CustomerPersonHistories = {
  __typename?: 'CustomerPersonHistories';
  cPersonId?: Maybe<Scalars['ID']['output']>;
  chartData: Array<Maybe<ChartReportCustomerPersonHistories>>;
};

export type CustomerPersonHistoriesResponse = {
  __typename?: 'CustomerPersonHistoriesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CustomerPersonHistories>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPersonPicked = {
  __typename?: 'CustomerPersonPicked';
  _id?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type CustomerPersonResponse = {
  __typename?: 'CustomerPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerPerson;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPersonToken = {
  __typename?: 'CustomerPersonToken';
  cPerson: CustomerPerson;
  is2FAEnabled?: Maybe<Scalars['Boolean']['output']>;
  permissions: Array<RolePermission>;
  token: Scalars['String']['output'];
};

export type CustomerPersonTokenForAdmin = {
  __typename?: 'CustomerPersonTokenForAdmin';
  cPerson: CustomerPerson;
  token: Scalars['String']['output'];
};

export type CustomerPersonTokenResponse = {
  __typename?: 'CustomerPersonTokenResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerPersonToken;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPersonTypingInput = {
  conversationId: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type CustomerPersonTypingResponse = {
  __typename?: 'CustomerPersonTypingResponse';
  conversationId: Scalars['ID']['output'];
  customer: Scalars['ID']['output'];
  isTyping: Scalars['Boolean']['output'];
  typingUserId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CustomerPersonsListResponse = {
  __typename?: 'CustomerPersonsListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerPersonsPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerPersonsPaginate = {
  __typename?: 'CustomerPersonsPaginate';
  docs?: Maybe<Array<Maybe<CustomerPerson>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type CustomerPersonsResponse = {
  __typename?: 'CustomerPersonsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<CustomerPerson>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerProduct = {
  __typename?: 'CustomerProduct';
  _id?: Maybe<Scalars['ID']['output']>;
  accountBalance?: Maybe<Scalars['Float']['output']>;
  addOns: Array<CustomerProductAddOn>;
  couponCode?: Maybe<CouponCode>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  features?: Maybe<Features>;
  feeCharged?: Maybe<Scalars['Double']['output']>;
  freeTrialExpiringDate?: Maybe<Scalars['Date']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  limits?: Maybe<LimitsAndUsages>;
  name?: Maybe<Scalars['String']['output']>;
  paymentFromOtherChannel?: Maybe<Scalars['Object']['output']>;
  paymentStatus?: Maybe<Scalars['Boolean']['output']>;
  periodCount?: Maybe<Scalars['Int']['output']>;
  periodMode?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Double']['output']>;
  reChargeSettings?: Maybe<NeedChargeLimitType>;
  refreshDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  usages?: Maybe<LimitsAndUsages>;
};

export type CustomerProductAddOn = {
  __typename?: 'CustomerProductAddOn';
  _id?: Maybe<Scalars['ID']['output']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextCredits?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Double']['output']>;
  renewalType?: Maybe<Scalars['String']['output']>;
};

export type CustomerProductAddOnResponse = {
  __typename?: 'CustomerProductAddOnResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerProduct;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerProductAddOnSubscriptionInput = {
  customerId: Scalars['ID']['input'];
};

export type CustomerProductResponse = {
  __typename?: 'CustomerProductResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerProduct;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerProductSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type CustomerResponse = {
  __typename?: 'CustomerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Customer;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerSessionInput = {
  customerId: Scalars['String']['input'];
};

export type CustomerSpecialPackageSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type CustomerSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export enum CustomerType {
  Admin = 'ADMIN',
  Ai = 'AI',
  Custom = 'CUSTOM',
  JrAgent = 'JR_AGENT',
  Owner = 'OWNER',
  Personel = 'PERSONEL',
  Robot = 'ROBOT'
}

export type CustomerWorkingHours = {
  __typename?: 'CustomerWorkingHours';
  _id: Scalars['ID']['output'];
  customer: Scalars['ID']['output'];
  days: Array<WorkingHour>;
};

export type CustomersResponse = {
  __typename?: 'CustomersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Customer>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum DayNamesEnum {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DealFields = {
  __typename?: 'DealFields';
  Stage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DefaultCPersonRolesResponse = {
  __typename?: 'DefaultCPersonRolesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum DelayTimeUnitEnum {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES'
}

export type DelayedAction = {
  __typename?: 'DelayedAction';
  _id?: Maybe<Scalars['ID']['output']>;
  actionDate?: Maybe<Scalars['Date']['output']>;
  cPerson?: Maybe<Scalars['ID']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DelayedActionType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DelayedActionResponse = {
  __typename?: 'DelayedActionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: DelayedAction;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DelayedActionSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum DelayedActionType {
  AutoSurveyMessage = 'AUTO_SURVEY_MESSAGE',
  ScheduleMessage = 'SCHEDULE_MESSAGE',
  SnoozeConversation = 'SNOOZE_CONVERSATION'
}

export type DeleteActionInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteAddOnInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteAiGuidanceInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteAiKnowledgeSourceInput = {
  customer: Scalars['ID']['input'];
  multipleIds?: InputMaybe<Scalars['Array']['input']>;
};

export type DeleteAuthenticationInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteBusinessHoursSchedulesInput = {
  customerId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteBusinessHoursSchedulesResponse = {
  __typename?: 'DeleteBusinessHoursSchedulesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteByDateRangeParams = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type DeleteCPersonRoleInput = {
  _id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
};

export type DeleteCallAdminLogsData = {
  __typename?: 'DeleteCallAdminLogsData';
  deletedCount: Scalars['Int']['output'];
};

export type DeleteCallAdminLogsInput = {
  callSid?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
};

export type DeleteCallAdminLogsResponse = {
  __typename?: 'DeleteCallAdminLogsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<DeleteCallAdminLogsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteChangelogCategoryInput = {
  _id: Scalars['ID']['input'];
  reassignToCategoryId: Scalars['ID']['input'];
};

export type DeleteChangelogInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteCollageBarcodeInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCollageFolderInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCollageProductInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCollageSettingsInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCollageSharingInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCollageTemplateInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCommentTypeResponse = {
  __typename?: 'DeleteCommentTypeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteConvSidebarInput = {
  customerId: Scalars['ID']['input'];
  sidebarId: Scalars['ID']['input'];
};

export type DeleteConvViewInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCouponCodeInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteCustomExtensionInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteCustomerInput = {
  customerId: Scalars['ID']['input'];
};

export type DeleteCustomerPersonInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteDelayedActionInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteECommerceIntegrationInput = {
  _id: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type DeleteECommerceIntegrationOutput = {
  __typename?: 'DeleteECommerceIntegrationOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteECommerceRulesInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type DeleteEmailAdminLogsData = {
  __typename?: 'DeleteEmailAdminLogsData';
  deletedCount: Scalars['Int']['output'];
};

export type DeleteEmailAdminLogsInput = {
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
};

export type DeleteEmailAdminLogsResponse = {
  __typename?: 'DeleteEmailAdminLogsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<DeleteEmailAdminLogsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteExternalApiInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteFlowBotInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteFlowBotResponse = {
  __typename?: 'DeleteFlowBotResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowBot>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteFlowNodeInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteFlowNodeResponse = {
  __typename?: 'DeleteFlowNodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteInboundWebhookInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteIntegrationInput = {
  _id: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteManyAiSuggestionInput = {
  _ids: Array<InputMaybe<Scalars['ID']['input']>>;
  customer: Scalars['ID']['input'];
};

export type DeleteMultiplePersonInput = {
  customerId: Scalars['ID']['input'];
  multipleIds?: InputMaybe<Scalars['Array']['input']>;
};

export type DeletePersonNoteInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeletePersonResponse = {
  __typename?: 'DeletePersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePlatformInput = {
  _id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type DeletePlatformTypeInput = {
  customerId: Scalars['String']['input'];
  deleteConvAndMsg: Scalars['Boolean']['input'];
  platformId: Scalars['String']['input'];
};

export type DeleteProductInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteQpienShopStoreInput = {
  customerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type DeleteQpienShopStoreResponse = {
  __typename?: 'DeleteQpienShopStoreResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteQuickAnswerInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteRandomMessageTestContactInput = {
  channelId: Scalars['String']['input'];
  channelPersonId: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  platformType: PlatformType;
};

export type DeleteReportInput = {
  reportId: Scalars['ID']['input'];
};

export type DeleteReportWidgetInput = {
  widgetId: Scalars['ID']['input'];
};

export type DeleteReportWidgetMetricInput = {
  metricId: Scalars['ID']['input'];
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  deletedCount: Scalars['Int']['output'];
  deletedSteps: Scalars['Int']['output'];
};

export type DeleteResultResponse = {
  __typename?: 'DeleteResultResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: DeleteResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSurveysInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type DeleteTableFieldInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteTableFolderInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteTableInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteTableRecordInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteTableRecordsInput = {
  customerId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteTableViewInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteTagInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteTaskBySourceIdInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};

export type DeleteTaskCommentInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteTaskInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteTeamsInput = {
  _id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  selectedTeam?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteTemplateInput = {
  customerId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
};

export type DeleteTestConversationInput = {
  aiPersonMemoryId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteTestConversationResponse = {
  __typename?: 'DeleteTestConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTopicInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeleteUserInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteWabaTemplateInput = {
  customerId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
};

export type DeleteWebhookInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type DeletedCollageFolderResponse = {
  __typename?: 'DeletedCollageFolderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletedCustomerResponse = {
  __typename?: 'DeletedCustomerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DestroyData = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  platfromId?: InputMaybe<Scalars['String']['input']>;
};

export type DetailCardConfig = {
  __typename?: 'DetailCardConfig';
  action?: Maybe<Scalars['ID']['output']>;
  connectAnotherTabButton?: Maybe<ConnectTabButton>;
  sections?: Maybe<Array<Maybe<SectionConfig>>>;
};

export type DetailCardConfigInput = {
  action?: InputMaybe<Scalars['ID']['input']>;
  connectAnotherTabButton?: InputMaybe<ConnectTabButtonInput>;
  sections?: InputMaybe<Array<InputMaybe<SectionConfigInput>>>;
};

export type DeviceStatusInput = {
  cPersonId: Scalars['ID']['input'];
  deviceType: CustomerPersonDeviceType;
  status: CustomerPersonDeviceStatus;
};

export type Domain = {
  __typename?: 'Domain';
  _id?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  dns: StatusDns;
  domain?: Maybe<Scalars['String']['output']>;
  valid: Scalars['String']['output'];
};

export type DomainResponse = {
  __typename?: 'DomainResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Domain>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DomainSubscriptionInput = {
  customer: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type DomainsResponse = {
  __typename?: 'DomainsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<Domain>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DrillDownReportWidgetDataInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
};

export type DrillDownReportWidgetDataResultResponse = {
  __typename?: 'DrillDownReportWidgetDataResultResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<DrillDownWidgetDataResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DrillDownWidgetDataResult = {
  __typename?: 'DrillDownWidgetDataResult';
  chartType: Scalars['String']['output'];
  conversations: Array<ReportWidgetDrillDownConversation>;
  effectiveDateRange: ReportDateRange;
  effectiveFilters: Array<WidgetFilter>;
  /**
   * Which list to read: "PERSON" for a `person_live` widget, "CONVERSATION" for every other
   * dataSource. The other list is empty. `pageInfo` describes whichever list is populated.
   */
  entityType: Scalars['String']['output'];
  error?: Maybe<WidgetDataError>;
  metricResults: Array<WidgetMetricDrillDownResult>;
  pageInfo: ReportWidgetDrillDownPageInfo;
  persons: Array<ReportWidgetDrillDownPerson>;
  reportId: Scalars['ID']['output'];
  segmentBy?: Maybe<ReportWidgetSegmentBy>;
  success: Scalars['Boolean']['output'];
  widgetId: Scalars['ID']['output'];
};

export type DuplicateCampaignInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateFlowBotInput = {
  channelType: FlowMessageChannel;
  customerId: Scalars['ID']['input'];
  targetedFlowBot: Scalars['String']['input'];
};

export type DuplicateFlowBotResponse = {
  __typename?: 'DuplicateFlowBotResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowBot>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DuplicateReportInput = {
  reportId: Scalars['ID']['input'];
};

export type DuplicateTableInput = {
  customerId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type ECommerceCustomPlatformDataResponse = {
  __typename?: 'ECommerceCustomPlatformDataResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type ECommerceCustomPlatformsResponse = {
  __typename?: 'ECommerceCustomPlatformsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ECommerceCustomPlatformDataResponse;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommerceCustomersResponse = {
  __typename?: 'ECommerceCustomersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GetCustomerListResponse;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommerceIntegrationLog = {
  __typename?: 'ECommerceIntegrationLog';
  durationMs?: Maybe<Scalars['Int']['output']>;
  errors: Array<ECommerceIntegrationLogError>;
  event: ECommerceIntegrationLogEvent;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['String']['output'];
  stats?: Maybe<ECommerceIntegrationLogStats>;
  status: ECommerceIntegrationLogStatus;
  trigger: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ECommerceIntegrationLogError = {
  __typename?: 'ECommerceIntegrationLogError';
  error: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

export enum ECommerceIntegrationLogEvent {
  CustomerSync = 'CUSTOMER_SYNC',
  InventoryPush = 'INVENTORY_PUSH',
  OrderPush = 'ORDER_PUSH',
  OrderSync = 'ORDER_SYNC',
  PolicySync = 'POLICY_SYNC',
  ProductSync = 'PRODUCT_SYNC',
  ProductWebhook = 'PRODUCT_WEBHOOK'
}

export enum ECommerceIntegrationLogSort {
  Duration = 'DURATION',
  Event = 'EVENT',
  Status = 'STATUS',
  Time = 'TIME'
}

export type ECommerceIntegrationLogStats = {
  __typename?: 'ECommerceIntegrationLogStats';
  created?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export enum ECommerceIntegrationLogStatus {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type ECommerceIntegrationLogsPage = {
  __typename?: 'ECommerceIntegrationLogsPage';
  count: Scalars['Int']['output'];
  items: Array<ECommerceIntegrationLog>;
};

export type ECommerceIntegrationPaymentMethod = {
  __typename?: 'ECommerceIntegrationPaymentMethod';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ECommerceIntegrationShippingMethod = {
  __typename?: 'ECommerceIntegrationShippingMethod';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ECommerceIntegrationTypes {
  Faprika = 'FAPRIKA',
  Hepsiburada = 'HEPSIBURADA',
  Ideasoft = 'IDEASOFT',
  Ikas = 'IKAS',
  Shopify = 'SHOPIFY',
  Ticimax = 'TICIMAX',
  Trendyol = 'TRENDYOL',
  Tsoft = 'TSOFT'
}

export type ECommerceLinkedCustomerResponse = {
  __typename?: 'ECommerceLinkedCustomerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommercePlatformInputType = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  connection_progress?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  ideasoftScriptId?: InputMaybe<Scalars['String']['input']>;
  isConnected?: InputMaybe<Scalars['Boolean']['input']>;
  partnerDomain?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  storeName?: InputMaybe<Scalars['String']['input']>;
  tokenExpressEndDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  websiteDomain?: InputMaybe<Scalars['String']['input']>;
};

export type ECommercePlatformSettingsInputType = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  orderConfirmationLabel?: InputMaybe<OrderConfirmationLabelInputType>;
  orderConfirmationMessage?: InputMaybe<OrderConfirmationMessageInputType>;
  paymentTypes?: InputMaybe<Scalars['Object']['input']>;
};

export type ECommercePlatformType = {
  __typename?: 'ECommercePlatformType';
  accessToken?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  cargoCompanies?: Maybe<Array<Maybe<CargoCompanies>>>;
  code?: Maybe<Scalars['String']['output']>;
  connection_progress?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['Object']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  ideasoftScriptId?: Maybe<Scalars['String']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  liveChatScriptTagId?: Maybe<Scalars['String']['output']>;
  orderConfirmationLabel?: Maybe<OrderConfirmationLabelType>;
  orderConfirmationMessage?: Maybe<OrderConfirmationMessageType>;
  partnerDomain?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  paymentTypes?: Maybe<Array<Maybe<PaymentTypesType>>>;
  phone?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
  should_reconnect?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['String']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
  tokenExpressEndDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  websiteDomain?: Maybe<Scalars['String']['output']>;
};

export type ECommercePlatforms = {
  __typename?: 'ECommercePlatforms';
  platformId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  platformType?: Maybe<EcommerceRulesPlatformEnum>;
};

export type ECommercePlatformsInput = {
  platformId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  platformType?: InputMaybe<EcommerceRulesPlatformEnum>;
};

export type ECommercePlatformsResponse = {
  __typename?: 'ECommercePlatformsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<Scalars['Object']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommerceProductsResponse = {
  __typename?: 'ECommerceProductsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GetProductListResponse;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommerceRules = {
  __typename?: 'ECommerceRules';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  message1?: Maybe<EcommerceRuleMessage>;
  message2?: Maybe<EcommerceRuleMessage>;
  platforms?: Maybe<Array<Maybe<ECommercePlatforms>>>;
  ruleTemplate?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EcommerceRulesEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ECommerceRulesHistoryChartData = {
  __typename?: 'ECommerceRulesHistoryChartData';
  abandonedCart?: Maybe<Scalars['Int']['output']>;
  cartCurrency?: Maybe<Scalars['String']['output']>;
  cartStatus?: Maybe<Scalars['String']['output']>;
  cartValue?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  costCurrency?: Maybe<Scalars['String']['output']>;
  recoveredCart?: Maybe<Scalars['Int']['output']>;
  recoveredValue?: Maybe<Scalars['Float']['output']>;
  recoveryRate?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ECommerceRulesHistoryStatistic = {
  __typename?: 'ECommerceRulesHistoryStatistic';
  chartData?: Maybe<Array<Maybe<ECommerceRulesHistoryChartData>>>;
  totalAbandonedCart?: Maybe<Scalars['Int']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalRecoveredCart?: Maybe<Scalars['Int']['output']>;
  totalRecoveredValue?: Maybe<Scalars['Float']['output']>;
  totalRecoveryRate?: Maybe<Scalars['Float']['output']>;
};

export type ECommerceRulesHistoryStatisticResponse = {
  __typename?: 'ECommerceRulesHistoryStatisticResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ECommerceRulesHistoryStatistic>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommerceRulesPaginatedResponse = {
  __typename?: 'ECommerceRulesPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ECommerceRulesPaginationResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommerceRulesPaginationResponse = {
  __typename?: 'ECommerceRulesPaginationResponse';
  docs: Array<Maybe<ECommerceRules>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type ECommerceRulesResponse = {
  __typename?: 'ECommerceRulesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ECommerceRules;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ECommerceVariantsResponse = {
  __typename?: 'ECommerceVariantsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<GetVariantListResponse>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EIntegrationResponse = {
  __typename?: 'EIntegrationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum EIntegrationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Processing = 'PROCESSING'
}

export type EcommerceCustomerAddressData = {
  __typename?: 'EcommerceCustomerAddressData';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityCode?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  district?: Maybe<Scalars['String']['output']>;
  districtCode?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasEInvoice?: Maybe<Scalars['Int']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identityNumber?: Maybe<Scalars['String']['output']>;
  isCompanyActive?: Maybe<Scalars['Int']['output']>;
  isDefaultInvoice?: Maybe<Scalars['Int']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  partnerParams?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  provinceCode?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  taxOffice?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  townCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  wsAddressCode?: Maybe<Scalars['String']['output']>;
};

export type EcommerceCustomerData = {
  __typename?: 'EcommerceCustomerData';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type EcommerceRuleAction = {
  __typename?: 'EcommerceRuleAction';
  rule?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['ID']['output']>;
};

export type EcommerceRuleActionInput = {
  rule?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['ID']['input']>;
};

export type EcommerceRuleDelay = {
  __typename?: 'EcommerceRuleDelay';
  delayTime?: Maybe<Scalars['Int']['output']>;
  delayTimeUnit?: Maybe<Scalars['String']['output']>;
};

export type EcommerceRuleDelayInput = {
  delayTime: Scalars['Int']['input'];
  delayTimeUnit: DelayTimeUnitEnum;
};

export type EcommerceRuleMessage = {
  __typename?: 'EcommerceRuleMessage';
  action?: Maybe<EcommerceRuleAction>;
  delay?: Maybe<EcommerceRuleDelay>;
  sendMessage?: Maybe<EcommerceRuleSendMessage>;
};

export type EcommerceRuleMessageInput = {
  action?: InputMaybe<EcommerceRuleActionInput>;
  delay?: InputMaybe<EcommerceRuleDelayInput>;
  sendMessage?: InputMaybe<EcommerceRuleSendMessageInput>;
};

export type EcommerceRuleSendMessage = {
  __typename?: 'EcommerceRuleSendMessage';
  messageTemplateId?: Maybe<Scalars['Object']['output']>;
};

export type EcommerceRuleSendMessageInput = {
  messageTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EcommerceRulesEnum {
  AbandonedCheckout = 'ABANDONED_CHECKOUT'
}

export enum EcommerceRulesPlatformEnum {
  WhatsAppBusiness = 'WHATS_APP_BUSINESS'
}

export type EditCPersonData = {
  __typename?: 'EditCPersonData';
  cPersonId: Scalars['ID']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type EditCPersonResponse = {
  __typename?: 'EditCPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: EditCPersonData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EditTeamMessageInput = {
  content: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type EditWabaTemplateInput = {
  _id: Scalars['ID']['input'];
  buttons?: InputMaybe<Array<InputMaybe<ButtonType>>>;
  customerId: Scalars['ID']['input'];
  footer?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  qpienFields?: InputMaybe<Array<InputMaybe<QpienFields>>>;
};

export type EmailAccount = {
  __typename?: 'EmailAccount';
  _id?: Maybe<Scalars['ID']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  connectedEmailAddress?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  emailSignature?: Maybe<Scalars['String']['output']>;
  getImageFilesFromLinks?: Maybe<Scalars['Boolean']['output']>;
  ignoredEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ignoredTickets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  providerType?: Maybe<Scalars['String']['output']>;
  senderEmailAddress: Scalars['String']['output'];
  senderName?: Maybe<Scalars['String']['output']>;
  smtpValid?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailAdminLog = {
  __typename?: 'EmailAdminLog';
  _id: Scalars['ID']['output'];
  attachments?: Maybe<Array<Maybe<EmailAttachmentLog>>>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorStack?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  from: Scalars['String']['output'];
  html?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<EmailMetadata>;
  provider?: Maybe<EmailLogProvider>;
  providerStatusCode?: Maybe<Scalars['Number']['output']>;
  recipients: EmailRecipientGroup;
  status?: Maybe<EmailLogStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  templateData?: Maybe<Scalars['Object']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  transportMessageId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type EmailAdminLogsData = {
  __typename?: 'EmailAdminLogsData';
  logs: Array<EmailAdminLog>;
  total: Scalars['Int']['output'];
};

export type EmailAdminLogsResponse = {
  __typename?: 'EmailAdminLogsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<EmailAdminLogsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailAttachmentLog = {
  __typename?: 'EmailAttachmentLog';
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Number']['output']>;
};

export type EmailDataType = {
  __typename?: 'EmailDataType';
  bcc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  envelope?: Maybe<EnvelopeType>;
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum EmailLogProvider {
  Delete = 'DELETE',
  Put = 'PUT',
  Sendgrid = 'SENDGRID',
  Smtp = 'SMTP'
}

export enum EmailLogStatus {
  Failed = 'FAILED',
  Sent = 'SENT'
}

export type EmailMetadata = {
  __typename?: 'EmailMetadata';
  mailType?: Maybe<Scalars['String']['output']>;
};

export type EmailRecipientGroup = {
  __typename?: 'EmailRecipientGroup';
  bcc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  replyTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  to?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EmailResponse = {
  __typename?: 'EmailResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailSettings = {
  __typename?: 'EmailSettings';
  aiAgentWorkingHours?: Maybe<AiWorkingHoursEnum>;
  aiAutoClose?: Maybe<AiAutoClose>;
  aiFollowUp?: Maybe<AiFollowUp>;
  aiIntroducesItself?: Maybe<Scalars['String']['output']>;
  aiReplyButtons?: Maybe<AiReplyButtons>;
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** The chat block without the handover switch: an e-mail always reaches a person when it escalates. */
export type EmailSettingsInput = {
  aiAgentWorkingHours?: InputMaybe<AiWorkingHoursEnum>;
  aiAutoClose?: InputMaybe<AiAutoCloseInput>;
  aiFollowUp?: InputMaybe<AiFollowUpInput>;
  aiIntroducesItself?: InputMaybe<Scalars['String']['input']>;
  aiReplyButtons?: InputMaybe<AiReplyButtonsInput>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnableTwoFactorAuthenticationInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export enum EntityAction {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type EntityChanged = {
  __typename?: 'EntityChanged';
  action: EntityAction;
  customer: Scalars['ID']['output'];
  entity: EntityType;
  ids: Array<Scalars['ID']['output']>;
};

export type EntityChangedResponse = {
  __typename?: 'EntityChangedResponse';
  data?: Maybe<EntityChanged>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EntityChangedSubscriptionInput = {
  token: Scalars['String']['input'];
};

export enum EntityType {
  ConversationView = 'CONVERSATION_VIEW',
  CpersonRole = 'CPERSON_ROLE',
  CustomField = 'CUSTOM_FIELD',
  QuickAnswer = 'QUICK_ANSWER',
  Tag = 'TAG',
  Team = 'TEAM',
  Topic = 'TOPIC'
}

export enum EnumCustomFieldCustomerVisibility {
  NotVisible = 'NOT_VISIBLE',
  Optional = 'OPTIONAL',
  ReadOnly = 'READ_ONLY',
  Required = 'REQUIRED'
}

export enum EnumCustomFieldMediaType {
  File = 'FILE',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export enum EnumCustomFieldScope {
  Person = 'PERSON',
  Workflow = 'WORKFLOW'
}

export enum EnumCustomFieldScopeFilter {
  All = 'ALL',
  Person = 'PERSON',
  Workflow = 'WORKFLOW'
}

export enum EnumCustomFieldStatus {
  Active = 'ACTIVE',
  Archive = 'ARCHIVE'
}

export enum EnumCustomFieldUsageField {
  Contact = 'CONTACT',
  Conversation = 'CONVERSATION',
  Form = 'FORM',
  Ticket = 'TICKET'
}

export enum EnumCustomFieldUserVisibility {
  NotVisible = 'NOT_VISIBLE',
  Optional = 'OPTIONAL',
  ReadOnly = 'READ_ONLY',
  Required = 'REQUIRED'
}

export enum EnumCustomFieldsType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Email = 'EMAIL',
  List = 'LIST',
  Media = 'MEDIA',
  Number = 'NUMBER',
  OrderItems = 'ORDER_ITEMS',
  Phone = 'PHONE',
  Price = 'PRICE',
  Rating = 'RATING',
  Text = 'TEXT',
  Time = 'TIME',
  Url = 'URL'
}

export type EnvelopeInput = {
  from: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type EnvelopeType = {
  __typename?: 'EnvelopeType';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExplainAiMessageStepInput = {
  question?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['JSON']['input']>;
  response?: InputMaybe<Scalars['JSON']['input']>;
};

export type ExplainAiMessageStepResponse = {
  __typename?: 'ExplainAiMessageStepResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportConvTagHistoryStatisticInput = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<Scalars['String']['input']>;
  conversationType?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tagType?: InputMaybe<TagType>;
};

export type ExportConvTagHistoryStatisticResponse = {
  __typename?: 'ExportConvTagHistoryStatisticResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ExportConversationStatisticsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportConversationAllMessagesData = {
  __typename?: 'ExportConversationAllMessagesData';
  url: Scalars['String']['output'];
};

export type ExportConversationAllMessagesInput = {
  convId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  exportType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sinceReOpen?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ExportConversationAllMessagesResponse = {
  __typename?: 'ExportConversationAllMessagesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExportConversationAllMessagesData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportConversationDashboardStatisticsInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type ExportConversationStatisticsData = {
  __typename?: 'ExportConversationStatisticsData';
  url: Scalars['String']['output'];
};

export type ExportMsgStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channelType?: InputMaybe<PlatformType>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type ExportMsgStatisticsRes = {
  __typename?: 'ExportMsgStatisticsRes';
  code?: Maybe<Scalars['String']['output']>;
  data: ExportedMsgStatisticsData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ExportPFileTypeInput {
  Csv = 'csv',
  Xlsx = 'xlsx'
}

export type ExportPersonsInput = {
  conditions?: InputMaybe<Array<InputConditions>>;
  customer: Scalars['ID']['input'];
  emailTo?: InputMaybe<Scalars['String']['input']>;
  fileType: ExportPFileTypeInput;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  shouldMatchAllConditions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportReportInput = {
  customerId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type ExportReportResponse = {
  __typename?: 'ExportReportResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ExportReportResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportReportResult = {
  __typename?: 'ExportReportResult';
  queued: Scalars['Boolean']['output'];
};

export type ExportTableRecordsData = {
  __typename?: 'ExportTableRecordsData';
  queued?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportTableRecordsInput = {
  customerId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<TableRecordFilterInput>>;
  format?: InputMaybe<TableExportFormat>;
  search?: InputMaybe<Scalars['String']['input']>;
  tableId: Scalars['ID']['input'];
};

export type ExportTableRecordsResponse = {
  __typename?: 'ExportTableRecordsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ExportTableRecordsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportTopicComparisonStatisticsData = {
  __typename?: 'ExportTopicComparisonStatisticsData';
  url: Scalars['String']['output'];
};

export type ExportTopicStatisticsData = {
  __typename?: 'ExportTopicStatisticsData';
  url: Scalars['String']['output'];
};

export type ExportTopicStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  column: Scalars['String']['input'];
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  customFieldId2?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  row: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
  upperCustomFieldId?: InputMaybe<Scalars['ID']['input']>;
};

export type ExportedConversationDashboardStatisticsData = {
  __typename?: 'ExportedConversationDashboardStatisticsData';
  url: Scalars['String']['output'];
};

export type ExportedConversationDashboardStatisticsResponse = {
  __typename?: 'ExportedConversationDashboardStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExportedConversationDashboardStatisticsData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportedMsgStatisticsData = {
  __typename?: 'ExportedMsgStatisticsData';
  url: Scalars['String']['output'];
};

export type ExportedTopicStatisticsResponse = {
  __typename?: 'ExportedTopicStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ExportTopicStatisticsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ExtendOrReduce {
  Extend = 'EXTEND',
  Reduce = 'REDUCE'
}

export type ExternalAllConnectedPlatformsResponse = {
  __typename?: 'ExternalAllConnectedPlatformsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ExternalConnectedPlatform>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalApi = {
  __typename?: 'ExternalApi';
  _id: Scalars['ID']['output'];
  clientId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  scopes: Array<Maybe<PermissionScopeOutput>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ExternalApiResponse = {
  __typename?: 'ExternalApiResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalApi;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalApiSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type ExternalApisPaginatedData = {
  __typename?: 'ExternalApisPaginatedData';
  docs: Array<Maybe<ExternalApi>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type ExternalApisPaginatedResponse = {
  __typename?: 'ExternalApisPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalApisPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalConnectedPlatform = {
  __typename?: 'ExternalConnectedPlatform';
  _id?: Maybe<Scalars['ID']['output']>;
  appId?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  senderEmailAddress?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalContact = {
  __typename?: 'ExternalContact';
  _id: Scalars['ID']['output'];
  avatar: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailUsagePermission?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneUsagePermission?: Maybe<Scalars['Boolean']['output']>;
  platforms?: Maybe<Array<Maybe<PPlatformsType>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ExternalContactsPaginate = {
  __typename?: 'ExternalContactsPaginate';
  docs: Array<Maybe<ExternalContact>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type ExternalContactsPaginatedResponse = {
  __typename?: 'ExternalContactsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalContactsPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalConversation = {
  __typename?: 'ExternalConversation';
  _id?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Maybe<ChannelTypeOutput>>>;
  customer?: Maybe<Scalars['ID']['output']>;
  isGroupOrChannel?: Maybe<Scalars['Boolean']['output']>;
  isStarred?: Maybe<Scalars['Boolean']['output']>;
  joinedCPerson?: Maybe<Scalars['ID']['output']>;
  joinedPerson?: Maybe<Scalars['ID']['output']>;
  lastMessage?: Maybe<LastMessageType>;
  lastReceivedMessageChannel?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<TicketPriority>;
  status?: Maybe<ConversationStatusEnum>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  type?: Maybe<ConversationTypeEnum>;
};

export type ExternalConversationResponse = {
  __typename?: 'ExternalConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalConversation;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalConversationsPaginate = {
  __typename?: 'ExternalConversationsPaginate';
  docs: Array<Maybe<ExternalConversation>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type ExternalConversationsPaginatedResponse = {
  __typename?: 'ExternalConversationsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalConversationsPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalCreateContactInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalCreateMessageByWhatsappTemplateParam = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalCreateMessageInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<ChannelType>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  convId?: InputMaybe<Scalars['ID']['input']>;
  emailData?: InputMaybe<MailInfoInput>;
  frontMsgId?: InputMaybe<Scalars['String']['input']>;
  isAcceptedTemporaryReply?: InputMaybe<Scalars['Boolean']['input']>;
  isTicket?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['Media']['input']>>>;
  msgId?: InputMaybe<Scalars['String']['input']>;
  msgType: MessageType;
  newTicketState?: InputMaybe<Scalars['String']['input']>;
  pChannelId?: InputMaybe<Scalars['String']['input']>;
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sender: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  template_cards?: InputMaybe<TemplateCardInput>;
};

export type ExternalCreatedContactResponse = {
  __typename?: 'ExternalCreatedContactResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalContact;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalCreatedMessageResponse = {
  __typename?: 'ExternalCreatedMessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalMessage;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalCustomerPerson = {
  __typename?: 'ExternalCustomerPerson';
  _id: Scalars['ID']['output'];
  customer: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  language?: Maybe<Language>;
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  status: CPersonStatus;
  type: CustomerType;
};

export type ExternalCustomerPersonResponse = {
  __typename?: 'ExternalCustomerPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalCustomerPerson;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalCustomerPersonsPaginate = {
  __typename?: 'ExternalCustomerPersonsPaginate';
  docs: Array<Maybe<ExternalCustomerPerson>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type ExternalCustomerPersonsPaginatedResponse = {
  __typename?: 'ExternalCustomerPersonsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalCustomerPersonsPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalDeleteContactInput = {
  _id: Scalars['ID']['input'];
};

export type ExternalDeleteCustomerPersonInput = {
  _id: Scalars['ID']['input'];
};

export type ExternalDeleteWhatsappBusinessTemplateInput = {
  templateId: Scalars['ID']['input'];
};

export type ExternalDeletedContactResponse = {
  __typename?: 'ExternalDeletedContactResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalDeletedCustomerPersonResponse = {
  __typename?: 'ExternalDeletedCustomerPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalDeletedWhatsappBusinessTemplateResponse = {
  __typename?: 'ExternalDeletedWhatsappBusinessTemplateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalGetContactsInput = {
  emailUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  phoneUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExternalGetConversationInput = {
  conversationId: Scalars['ID']['input'];
};

export type ExternalGetConversationListInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  convViewId?: InputMaybe<Scalars['ID']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  /** ISO-8601 date string, e.g. 2026-10-06T00:00:00.000Z. Inclusive upper bound. */
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  isLastMessagePerson?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamCheck?: InputMaybe<Scalars['Boolean']['input']>;
  isUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Filter']['input']>;
  sortOrder?: InputMaybe<ConversationSortOrder>;
  /** ISO-8601 date string, e.g. 2026-10-01T00:00:00.000Z. Inclusive lower bound. */
  startDate?: InputMaybe<Scalars['Filter']['input']>;
  status?: InputMaybe<ConversationStatusEnum>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['Filter']['input']>;
  ticketStateStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalGetCustomerPersonInput = {
  cPersonId: Scalars['ID']['input'];
};

export type ExternalGetCustomerPersonListInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalGetMessageInput = {
  messageId: Scalars['ID']['input'];
};

export type ExternalGetMessageListInput = {
  conversationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MessageSearchType>;
};

export type ExternalGetWhatsappBusinessTemplateInput = {
  templateId: Scalars['ID']['input'];
};

export type ExternalGetWhatsappBusinessTemplateListInput = {
  allStatus?: InputMaybe<Scalars['Boolean']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Number']['input'];
  pageSize: Scalars['Number']['input'];
  qpienFields?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExternalMessage = {
  __typename?: 'ExternalMessage';
  _id?: Maybe<Scalars['ID']['output']>;
  ackStatus?: Maybe<AckType>;
  autoCreate?: Maybe<Scalars['Boolean']['output']>;
  autoEmailMessage?: Maybe<Scalars['Boolean']['output']>;
  catalogMessage?: Maybe<CatalogInteractiveType>;
  catalogOrderData?: Maybe<CatalogOrderDataType>;
  channelMessageId?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<ChannelType>;
  commentData?: Maybe<CommentDataType>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  emailData?: Maybe<EmailDataType>;
  failedReason?: Maybe<FailedReasonType>;
  flowBotQuickReply?: Maybe<Array<Maybe<FlowBotQuickReplyType>>>;
  flowBotQuickReplyButtonsRequired?: Maybe<Scalars['Boolean']['output']>;
  flowBotQuickReplyResponseId?: Maybe<Scalars['String']['output']>;
  frontMsgId?: Maybe<Scalars['String']['output']>;
  informativeButtons?: Maybe<InformativeButtonsType>;
  listMessage?: Maybe<ListMessageType>;
  media?: Maybe<Array<Maybe<Scalars['Media']['output']>>>;
  messageType?: Maybe<MessageType>;
  product_cards?: Maybe<Scalars['Object']['output']>;
  questionData?: Maybe<QuestionDataType>;
  quotedMessage?: Maybe<QuotedMessageType>;
  reactions?: Maybe<ReactionEnum>;
  sender?: Maybe<SenderData>;
  senderType?: Maybe<SenderType>;
  subject?: Maybe<Scalars['String']['output']>;
  surveyData?: Maybe<SurveyDataForLivechat>;
  template_cards?: Maybe<Scalars['Object']['output']>;
};

export type ExternalMessageResponse = {
  __typename?: 'ExternalMessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalMessage;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalMessagesPaginate = {
  __typename?: 'ExternalMessagesPaginate';
  docs: Array<Maybe<ExternalMessage>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type ExternalMessagesPaginatedResponse = {
  __typename?: 'ExternalMessagesPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalMessagesPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalSendMessageInput = {
  channelType?: InputMaybe<ChannelType>;
  content?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['Media']['input']>>>;
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  senderChannelId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateParams?: InputMaybe<Array<InputMaybe<ExternalCreateMessageByWhatsappTemplateParam>>>;
};

export type ExternalSentMessageResponse = {
  __typename?: 'ExternalSentMessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalUpdateContactInput = {
  _id: Scalars['ID']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalUpdateConversationInput = {
  _id: Scalars['ID']['input'];
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  joinedCPerson?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ConversationStatusEnum>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ExternalUpdateCustomerPersonInput = {
  _id: Scalars['ID']['input'];
  canAccessPhoneCalls?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasAiAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  isAcceptingCalls?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  joinedConvCount?: InputMaybe<Scalars['Int']['input']>;
  joinedConvLimit?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  signedTeams?: InputMaybe<Scalars['Array']['input']>;
  status?: InputMaybe<CPersonStatus>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomerType>;
};

export type ExternalUpdatedContactResponse = {
  __typename?: 'ExternalUpdatedContactResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalContact;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalUpdatedConversationResponse = {
  __typename?: 'ExternalUpdatedConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalConversation;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalUpdatedCustomerPersonResponse = {
  __typename?: 'ExternalUpdatedCustomerPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalCustomerPerson;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalWhatsappBusinessTemplate = {
  __typename?: 'ExternalWhatsappBusinessTemplate';
  _id: Scalars['ID']['output'];
  buttons: Array<WhatsAppBusinessTemplateButton>;
  createdAt: Scalars['Date']['output'];
  example?: Maybe<Scalars['String']['output']>;
  exampleMedia?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  qpienFields: Array<WhatsAppBusinessTemplateQpienField>;
  reason?: Maybe<Scalars['String']['output']>;
  sampleMedia?: Maybe<WhatsAppBusinessTemplateSampleMedia>;
  status: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
};

export type ExternalWhatsappBusinessTemplateResponse = {
  __typename?: 'ExternalWhatsappBusinessTemplateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalWhatsappBusinessTemplate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalWhatsappBusinessTemplatesPaginate = {
  __typename?: 'ExternalWhatsappBusinessTemplatesPaginate';
  docs: Array<Maybe<ExternalWhatsappBusinessTemplate>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs: Scalars['Int']['output'];
};

export type ExternalWhatsappBusinessTemplatesPaginatedResponse = {
  __typename?: 'ExternalWhatsappBusinessTemplatesPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ExternalWhatsappBusinessTemplatesPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FacebookAccount = {
  __typename?: 'FacebookAccount';
  _id?: Maybe<Scalars['ID']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type FacebookPage = {
  __typename?: 'FacebookPage';
  _id?: Maybe<Scalars['ID']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  facebookAccount?: Maybe<FacebookAccount>;
  facebookPageId?: Maybe<Scalars['String']['output']>;
  failedMessage?: Maybe<Scalars['Boolean']['output']>;
  isCommentEnable?: Maybe<Scalars['Boolean']['output']>;
  isMessageEnable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type FailedReasonType = {
  __typename?: 'FailedReasonType';
  attempt?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Features = {
  __typename?: 'Features';
  AiAgent?: Maybe<Scalars['Boolean']['output']>;
  AiAssistant?: Maybe<Scalars['Boolean']['output']>;
  AiClosingNote?: Maybe<Scalars['Boolean']['output']>;
  AiClosingSurvey?: Maybe<Scalars['Boolean']['output']>;
  AiClosingTag?: Maybe<Scalars['Boolean']['output']>;
  AiStartFlow?: Maybe<Scalars['Boolean']['output']>;
  AiStatistics?: Maybe<Scalars['Boolean']['output']>;
  ai?: Maybe<Scalars['Boolean']['output']>;
  aiAnalysis?: Maybe<Scalars['Boolean']['output']>;
  aiHumanReplyLearning?: Maybe<Scalars['Boolean']['output']>;
  aiImageRecognition?: Maybe<Scalars['Boolean']['output']>;
  autoAway?: Maybe<Scalars['Boolean']['output']>;
  automation?: Maybe<Scalars['Boolean']['output']>;
  automationEcommerce?: Maybe<Scalars['Boolean']['output']>;
  automationFlowBots?: Maybe<Scalars['Boolean']['output']>;
  automationFlowBotsHttpRequest?: Maybe<Scalars['Boolean']['output']>;
  automationFlowBotsStartFlow?: Maybe<Scalars['Boolean']['output']>;
  bulkSharing?: Maybe<Scalars['Boolean']['output']>;
  campaignEngineV2?: Maybe<Scalars['Boolean']['output']>;
  channelOwner?: Maybe<Scalars['Boolean']['output']>;
  channels?: Maybe<Scalars['Boolean']['output']>;
  channelsCustomChannel?: Maybe<Scalars['Boolean']['output']>;
  channelsEcommerce?: Maybe<Scalars['Boolean']['output']>;
  channelsEmail?: Maybe<Scalars['Boolean']['output']>;
  channelsFacebookComment?: Maybe<Scalars['Boolean']['output']>;
  channelsFacebookDm?: Maybe<Scalars['Boolean']['output']>;
  channelsForm?: Maybe<Scalars['Boolean']['output']>;
  channelsInstagramComment?: Maybe<Scalars['Boolean']['output']>;
  channelsInstagramDm?: Maybe<Scalars['Boolean']['output']>;
  channelsLiveChat?: Maybe<Scalars['Boolean']['output']>;
  channelsLiveChatRemoveQpienLogo?: Maybe<Scalars['Boolean']['output']>;
  channelsMarketplace?: Maybe<Scalars['Boolean']['output']>;
  channelsMetaWhatsAppBusinessApi?: Maybe<Scalars['Boolean']['output']>;
  channelsPhone?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneCallAiAnalysis?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneCallRecord?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneCallTranscripts?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneInboundCalls?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneOutboundCalls?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneSurvey?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneTestToSpeech?: Maybe<Scalars['Boolean']['output']>;
  channelsPhonelVR?: Maybe<Scalars['Boolean']['output']>;
  channelsSms?: Maybe<Scalars['Boolean']['output']>;
  channelsTelegram?: Maybe<Scalars['Boolean']['output']>;
  channelsTiktokComment?: Maybe<Scalars['Boolean']['output']>;
  channelsTiktokDm?: Maybe<Scalars['Boolean']['output']>;
  channelsWhatsAppBusinessApi?: Maybe<Scalars['Boolean']['output']>;
  channelsWhatsAppWeb?: Maybe<Scalars['Boolean']['output']>;
  collageSharing?: Maybe<Scalars['Boolean']['output']>;
  contacts?: Maybe<Scalars['Boolean']['output']>;
  contactsDynamicGroups?: Maybe<Scalars['Boolean']['output']>;
  contactsExport?: Maybe<Scalars['Boolean']['output']>;
  contactsImport?: Maybe<Scalars['Boolean']['output']>;
  contactsMergeContacts?: Maybe<Scalars['Boolean']['output']>;
  customReports?: Maybe<Scalars['Boolean']['output']>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  inbox?: Maybe<Scalars['Boolean']['output']>;
  inboxBulkActions?: Maybe<Scalars['Boolean']['output']>;
  inboxCustomViews?: Maybe<Scalars['Boolean']['output']>;
  inboxMessageTranslation?: Maybe<Scalars['Boolean']['output']>;
  inboxPrivateMessage?: Maybe<Scalars['Boolean']['output']>;
  messageSchedule?: Maybe<Scalars['Boolean']['output']>;
  removeEmailQpienLogo?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<Scalars['Boolean']['output']>;
  settingsActions?: Maybe<Scalars['Boolean']['output']>;
  settingsApiKeys?: Maybe<Scalars['Boolean']['output']>;
  settingsAuthentications?: Maybe<Scalars['Boolean']['output']>;
  settingsAutoAssignment?: Maybe<Scalars['Boolean']['output']>;
  settingsCustomFields?: Maybe<Scalars['Boolean']['output']>;
  settingsQuickAnswers?: Maybe<Scalars['Boolean']['output']>;
  settingsSlaPolicies?: Maybe<Scalars['Boolean']['output']>;
  settingsSurveys?: Maybe<Scalars['Boolean']['output']>;
  settingsTags?: Maybe<Scalars['Boolean']['output']>;
  settingsTeamGoals?: Maybe<Scalars['Boolean']['output']>;
  settingsTeams?: Maybe<Scalars['Boolean']['output']>;
  settingsTopics?: Maybe<Scalars['Boolean']['output']>;
  settingsTopicsAutoFill?: Maybe<Scalars['Boolean']['output']>;
  settingsUserRoles?: Maybe<Scalars['Boolean']['output']>;
  settingsUsers?: Maybe<Scalars['Boolean']['output']>;
  settingsWebhooks?: Maybe<Scalars['Boolean']['output']>;
  snooze?: Maybe<Scalars['Boolean']['output']>;
  statistics?: Maybe<Scalars['Boolean']['output']>;
  statisticsAbandonedCarts?: Maybe<Scalars['Boolean']['output']>;
  statisticsCampaign?: Maybe<Scalars['Boolean']['output']>;
  statisticsConversationTags?: Maybe<Scalars['Boolean']['output']>;
  statisticsConversations?: Maybe<Scalars['Boolean']['output']>;
  statisticsMessages?: Maybe<Scalars['Boolean']['output']>;
  statisticsPerformance?: Maybe<Scalars['Boolean']['output']>;
  statisticsSatisfactions?: Maybe<Scalars['Boolean']['output']>;
  statisticsUsers?: Maybe<Scalars['Boolean']['output']>;
  tables?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  teamChat?: Maybe<Scalars['Boolean']['output']>;
  userActivity?: Maybe<Scalars['Boolean']['output']>;
  zohoIntegration?: Maybe<Scalars['Boolean']['output']>;
};

export type FeaturesInput = {
  AiAgent?: InputMaybe<Scalars['Boolean']['input']>;
  AiAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  AiClosingNote?: InputMaybe<Scalars['Boolean']['input']>;
  AiClosingSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  AiClosingTag?: InputMaybe<Scalars['Boolean']['input']>;
  AiStartFlow?: InputMaybe<Scalars['Boolean']['input']>;
  AiStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  ai?: InputMaybe<Scalars['Boolean']['input']>;
  aiAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  aiHumanReplyLearning?: InputMaybe<Scalars['Boolean']['input']>;
  aiImageRecognition?: InputMaybe<Scalars['Boolean']['input']>;
  autoAway?: InputMaybe<Scalars['Boolean']['input']>;
  automation?: InputMaybe<Scalars['Boolean']['input']>;
  automationEcommerce?: InputMaybe<Scalars['Boolean']['input']>;
  automationFlowBots?: InputMaybe<Scalars['Boolean']['input']>;
  automationFlowBotsHttpRequest?: InputMaybe<Scalars['Boolean']['input']>;
  automationFlowBotsStartFlow?: InputMaybe<Scalars['Boolean']['input']>;
  bulkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  campaignEngineV2?: InputMaybe<Scalars['Boolean']['input']>;
  channelOwner?: InputMaybe<Scalars['Boolean']['input']>;
  channels?: InputMaybe<Scalars['Boolean']['input']>;
  channelsCustomChannel?: InputMaybe<Scalars['Boolean']['input']>;
  channelsEcommerce?: InputMaybe<Scalars['Boolean']['input']>;
  channelsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  channelsFacebookComment?: InputMaybe<Scalars['Boolean']['input']>;
  channelsFacebookDm?: InputMaybe<Scalars['Boolean']['input']>;
  channelsForm?: InputMaybe<Scalars['Boolean']['input']>;
  channelsInstagramComment?: InputMaybe<Scalars['Boolean']['input']>;
  channelsInstagramDm?: InputMaybe<Scalars['Boolean']['input']>;
  channelsLiveChat?: InputMaybe<Scalars['Boolean']['input']>;
  channelsLiveChatRemoveQpienLogo?: InputMaybe<Scalars['Boolean']['input']>;
  channelsMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  channelsMetaWhatsAppBusinessApi?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhone?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneCallAiAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneCallRecord?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneCallTranscripts?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneInboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneOutboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneTestToSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhonelVR?: InputMaybe<Scalars['Boolean']['input']>;
  channelsSms?: InputMaybe<Scalars['Boolean']['input']>;
  channelsTelegram?: InputMaybe<Scalars['Boolean']['input']>;
  channelsTiktokComment?: InputMaybe<Scalars['Boolean']['input']>;
  channelsTiktokDm?: InputMaybe<Scalars['Boolean']['input']>;
  channelsWhatsAppBusinessApi?: InputMaybe<Scalars['Boolean']['input']>;
  channelsWhatsAppWeb?: InputMaybe<Scalars['Boolean']['input']>;
  collageSharing?: InputMaybe<Scalars['Boolean']['input']>;
  contacts?: InputMaybe<Scalars['Boolean']['input']>;
  contactsDynamicGroups?: InputMaybe<Scalars['Boolean']['input']>;
  contactsExport?: InputMaybe<Scalars['Boolean']['input']>;
  contactsImport?: InputMaybe<Scalars['Boolean']['input']>;
  contactsMergeContacts?: InputMaybe<Scalars['Boolean']['input']>;
  customReports?: InputMaybe<Scalars['Boolean']['input']>;
  dashboard?: InputMaybe<Scalars['Boolean']['input']>;
  inbox?: InputMaybe<Scalars['Boolean']['input']>;
  inboxBulkActions?: InputMaybe<Scalars['Boolean']['input']>;
  inboxCustomViews?: InputMaybe<Scalars['Boolean']['input']>;
  inboxMessageTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  inboxPrivateMessage?: InputMaybe<Scalars['Boolean']['input']>;
  messageSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  removeEmailQpienLogo?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['Boolean']['input']>;
  settingsActions?: InputMaybe<Scalars['Boolean']['input']>;
  settingsApiKeys?: InputMaybe<Scalars['Boolean']['input']>;
  settingsAuthentications?: InputMaybe<Scalars['Boolean']['input']>;
  settingsAutoAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  settingsCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  settingsQuickAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  settingsSlaPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  settingsSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTags?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTeamGoals?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTeams?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTopics?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTopicsAutoFill?: InputMaybe<Scalars['Boolean']['input']>;
  settingsUserRoles?: InputMaybe<Scalars['Boolean']['input']>;
  settingsUsers?: InputMaybe<Scalars['Boolean']['input']>;
  settingsWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  snooze?: InputMaybe<Scalars['Boolean']['input']>;
  statistics?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsAbandonedCarts?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsConversationTags?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsConversations?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsMessages?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsPerformance?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsSatisfactions?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsUsers?: InputMaybe<Scalars['Boolean']['input']>;
  tables?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  teamChat?: InputMaybe<Scalars['Boolean']['input']>;
  userActivity?: InputMaybe<Scalars['Boolean']['input']>;
  zohoIntegration?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FieldFormatType {
  Date = 'DATE',
  Number = 'NUMBER',
  Price = 'PRICE'
}

export type FileRecord = {
  fileFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
};

export type FinalizeBulkSharingInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type FlowBlock = {
  __typename?: 'FlowBlock';
  _id: Scalars['ID']['output'];
  category: FlowNodeType;
  channelType?: Maybe<FlowMessageChannel>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  fields: Array<Maybe<BlockFieldType>>;
  flowBot: Scalars['ID']['output'];
  flowNode: Scalars['ID']['output'];
  target?: Maybe<Scalars['ID']['output']>;
  templateId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: FlowBlockType;
  updatedAt: Scalars['Date']['output'];
};

export type FlowBlockFieldCatalogProductInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type FlowBlockFieldCatalogProductType = {
  __typename?: 'FlowBlockFieldCatalogProductType';
  _id?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
};

export type FlowBlockFieldCustomFieldsInput = {
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlowBlockFieldCustomFieldsType = {
  __typename?: 'FlowBlockFieldCustomFieldsType';
  customFieldId?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FlowBlockFieldGlobalButtonsInput = {
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FlowBlockFieldGlobalButtonsType = {
  __typename?: 'FlowBlockFieldGlobalButtonsType';
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FlowBlockFieldHttpRequestDotNotationInput = {
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  personField?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type FlowBlockFieldHttpRequestDotNotationType = {
  __typename?: 'FlowBlockFieldHttpRequestDotNotationType';
  fieldId?: Maybe<Scalars['ID']['output']>;
  personField?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type FlowBlockFieldHttpRequestFormDataEntryInput = {
  key: Scalars['String']['input'];
  value: Scalars['Object']['input'];
};

export type FlowBlockFieldHttpRequestFormDataEntryType = {
  __typename?: 'FlowBlockFieldHttpRequestFormDataEntryType';
  key: Scalars['String']['output'];
  value: Scalars['Object']['output'];
};

export type FlowBlockFieldHttpRequestHeaderInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FlowBlockFieldHttpRequestHeaderType = {
  __typename?: 'FlowBlockFieldHttpRequestHeaderType';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FlowBlockFieldItemType = {
  __typename?: 'FlowBlockFieldItemType';
  _id?: Maybe<Scalars['ID']['output']>;
  options: Array<Maybe<FlowBlockFieldSectionOptionType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum FlowBlockFieldLiveChatVisitFrequencyUnits {
  SendOnEveryVisit = 'send_on_every_visit',
  SendOnceForAUniqueVisitor = 'send_once_for_a_unique_visitor',
  SendOncePer_24Hours = 'send_once_per_24_hours'
}

export type FlowBlockFieldOptionInput = {
  hideTheEdge?: InputMaybe<Scalars['Boolean']['input']>;
  postbackText?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FlowBlockFieldOptionType = {
  __typename?: 'FlowBlockFieldOptionType';
  _id?: Maybe<Scalars['ID']['output']>;
  hideTheEdge?: Maybe<Scalars['Boolean']['output']>;
  postbackText?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum FlowBlockFieldRequestMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export enum FlowBlockFieldRules {
  AllMessages = 'all_messages',
  Contains = 'contains',
  EndsWith = 'ends_with',
  Equal = 'equal',
  GreaterThan = 'greater_than',
  HasAnyValue = 'has_any_value',
  LessThan = 'less_than',
  NotContains = 'not_contains',
  NotEqual = 'not_equal',
  StartsWith = 'starts_with',
  Unknown = 'unknown'
}

export type FlowBlockFieldSectionInput = {
  options: Array<InputMaybe<FlowBlockFieldSectionOptionInput>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type FlowBlockFieldSectionOptionInput = {
  description: Scalars['String']['input'];
  postbackText?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FlowBlockFieldSectionOptionType = {
  __typename?: 'FlowBlockFieldSectionOptionType';
  _id?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  postbackText?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FlowBlockFieldSectionType = {
  __typename?: 'FlowBlockFieldSectionType';
  _id?: Maybe<Scalars['ID']['output']>;
  options: Array<Maybe<FlowBlockFieldSectionOptionType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum FlowBlockFieldTimeoutUnits {
  Days = 'days',
  Hours = 'hours',
  Minutes = 'minutes',
  Seconds = 'seconds'
}

export enum FlowBlockFieldTypes {
  AddChatTag = 'add_chat_tag',
  AddConvTag = 'add_conv_tag',
  AiResponse = 'ai_response',
  AllMessageReceived = 'all_message_received',
  AssignOwnerRoundRobin = 'assign_owner_round_robin',
  AssignToAgent = 'assign_to_agent',
  AssignToTeam = 'assign_to_team',
  BrowserCountryCheck = 'browser_country_check',
  BrowserLanguageCheck = 'browser_language_check',
  CPersonWaitingReply = 'cPersonWaitingReply',
  CatalogOrderMessageReceived = 'catalog_order_message_received',
  ChangeConversationStatus = 'change_conversation_status',
  ChangeEmailConsent = 'change_email_consent',
  ChangePhoneConsent = 'change_phone_consent',
  ChangeTicketPriority = 'change_ticket_priority',
  ChangeTicketState = 'change_ticket_state',
  ClearCustomField = 'clear_custom_field',
  ContactCreated = 'contact_created',
  ContactUpdated = 'contact_updated',
  ConversationClosed = 'conversation_closed',
  ConversationFromAd = 'conversation_from_ad',
  ConversationTagAdded = 'conversation_tag_added',
  CustomerUnassigned = 'customer_unassigned',
  Date = 'date',
  Email = 'email',
  ExtractContactInfo = 'extract_contact_info',
  FileUrl = 'file_url',
  HangUpCall = 'hang_up_call',
  HttpRequest = 'http_request',
  ImageUrl = 'image_url',
  KeywordCommentReceived = 'keyword_comment_received',
  KeywordMessageReceived = 'keyword_message_received',
  KeywordQuestionReceived = 'keyword_question_received',
  List = 'list',
  MetaConversionEvent = 'meta_conversion_event',
  NewIncomingCall = 'new_incoming_call',
  Note = 'note',
  Number = 'number',
  PageUrlCheck = 'page_url_check',
  PersonWaitingReply = 'personWaitingReply',
  Phone = 'phone',
  QpienAction = 'qpien_action',
  QuestionTextInput = 'question_text_input',
  RemoveChatTag = 'remove_chat_tag',
  RemoveConvTag = 'remove_conv_tag',
  Reusable = 'reusable',
  SendMessage = 'send_message',
  SetCustomField = 'set_custom_field',
  SetOwner = 'set_owner',
  StartFlow = 'start_flow',
  TaskAction = 'task_action',
  Text = 'text',
  TimeBased = 'time_based',
  Url = 'url',
  VideoUrl = 'video_url',
  WebhookTriggered = 'webhook_triggered',
  ZohoAction = 'zoho_action'
}

export enum FlowBlockType {
  Action = 'action',
  AiResponse = 'ai_response',
  AllMessageRecevied = 'all_message_recevied',
  AssignCall = 'assign_call',
  CPersonWaitingReply = 'cPersonWaitingReply',
  CatalogOrderMessageReceived = 'catalog_order_message_received',
  Condition = 'condition',
  ContactCreated = 'contact_created',
  ContactUpdated = 'contact_updated',
  ConversationClosed = 'conversation_closed',
  ConversationFromAd = 'conversation_from_ad',
  ConversationTagAdded = 'conversation_tag_added',
  CreateTicket = 'create_ticket',
  CustomerUnassigned = 'customer_unassigned',
  Delay = 'delay',
  ExtractContactInfo = 'extract_contact_info',
  ForwardCall = 'forward_call',
  HttpRequest = 'http_request',
  IvrMenu = 'ivr_menu',
  KeywordCommentReceived = 'keyword_comment_received',
  KeywordMessageRecevied = 'keyword_message_recevied',
  KeywordQuestionReceived = 'keyword_question_received',
  LetAiAnswer = 'let_ai_answer',
  MetaConversionEvent = 'meta_conversion_event',
  NewIncomingCall = 'new_incoming_call',
  Note = 'note',
  PersonWaitingReply = 'personWaitingReply',
  PlayVoice = 'play_voice',
  QpienAction = 'qpien_action',
  Question = 'question',
  Reusable = 'reusable',
  SendCommentReply = 'send_comment_reply',
  SendMedia = 'send_media',
  SendMessage = 'send_message',
  SendMessageConnector = 'send_message_connector',
  SendMessageWithInformativeButtons = 'send_message_with_informative_buttons',
  SendMessageWithList = 'send_message_with_list',
  SendProductCatalog = 'send_product_catalog',
  SendQuestionReply = 'send_question_reply',
  SendQuickReplyMessage = 'send_quick_reply_message',
  SendWhatsappMessage = 'send_whatsapp_message',
  StartFlow = 'start_flow',
  TaskAction = 'task_action',
  TimeBased = 'time_based',
  UserVisitsPage = 'user_visits_page',
  WebhookTriggered = 'webhook_triggered',
  ZohoAction = 'zoho_action'
}

export type FlowBot = {
  __typename?: 'FlowBot';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  customer: Scalars['String']['output'];
  /** First activation; null while the flow was never published (paused vs draft). */
  publishedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  triggerFields?: Maybe<Array<Maybe<TriggerFields>>>;
  updatedAt: Scalars['Date']['output'];
  valid: Scalars['Boolean']['output'];
};

export type FlowBotPaginationResponse = {
  __typename?: 'FlowBotPaginationResponse';
  docs: Array<Maybe<FlowBot>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type FlowBotQuickReplyInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  flowBot?: InputMaybe<Scalars['ID']['input']>;
  postbackText?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FlowBotQuickReplyType = {
  __typename?: 'FlowBotQuickReplyType';
  _id?: Maybe<Scalars['ID']['output']>;
  flowBot?: Maybe<Scalars['ID']['output']>;
  postbackText?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FlowBotSubResponse = {
  __typename?: 'FlowBotSubResponse';
  customer: Scalars['ID']['output'];
  flowBotData?: Maybe<FlowBot>;
  operationType: Scalars['String']['output'];
};

export type FlowCatalogSectionInput = {
  productList?: InputMaybe<Array<InputMaybe<FlowBlockFieldCatalogProductInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FlowCatalogSectionType = {
  __typename?: 'FlowCatalogSectionType';
  productList?: Maybe<Array<Maybe<FlowBlockFieldCatalogProductType>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FlowConversationPreviewInput = {
  channel: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  searchBy: Scalars['String']['input'];
  searchValue: Scalars['String']['input'];
};

export type FlowConversationPreviewResponse = {
  __typename?: 'FlowConversationPreviewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum FlowMessageChannel {
  Amazon = 'Amazon',
  Ebay = 'Ebay',
  Email = 'Email',
  Facebook = 'Facebook',
  Hepsiburada = 'Hepsiburada',
  Instagram = 'Instagram',
  Kaufland = 'Kaufland',
  LiveChat = 'LiveChat',
  MetaWhatsappBusiness = 'MetaWhatsappBusiness',
  N11 = 'N11',
  Pazarama = 'Pazarama',
  Phone = 'Phone',
  QpienContact = 'QpienContact',
  Telegram = 'Telegram',
  Ticket = 'Ticket',
  Tiktok = 'Tiktok',
  Trendyol = 'Trendyol',
  Walmart = 'Walmart',
  WhatsappBusiness = 'WhatsappBusiness',
  WhatsappWeb = 'WhatsappWeb'
}

export type FlowNode = {
  __typename?: 'FlowNode';
  _id: Scalars['ID']['output'];
  coordinates: FlowNodeCoordinateType;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  flowBlocks: Array<Maybe<FlowBlock>>;
  flowBot: Scalars['ID']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  isSystemLocked?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  templateId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type FlowNodeCoordinateInput = {
  x: Scalars['Number']['input'];
  y: Scalars['Number']['input'];
};

export type FlowNodeCoordinateType = {
  __typename?: 'FlowNodeCoordinateType';
  x: Scalars['Number']['output'];
  y: Scalars['Number']['output'];
};

export type FlowNodePaginationResponse = {
  __typename?: 'FlowNodePaginationResponse';
  docs: Array<Maybe<FlowNode>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalRecords: Scalars['Number']['output'];
};

export type FlowNodeSubResponse = {
  __typename?: 'FlowNodeSubResponse';
  customer: Scalars['ID']['output'];
  flowNodeData?: Maybe<FlowNode>;
  operationType: Scalars['String']['output'];
};

export enum FlowNodeType {
  Actions = 'actions',
  AiResponse = 'ai_response',
  AskQuestion = 'ask_question',
  AssignCall = 'assign_call',
  CommentReply = 'comment_reply',
  Conditions = 'conditions',
  CreateTicket = 'create_ticket',
  Delay = 'delay',
  ExtractContactInfo = 'extract_contact_info',
  ForwardCall = 'forward_call',
  HttpRequest = 'http_request',
  IvrMenu = 'ivr_menu',
  LetAiAnswer = 'let_ai_answer',
  MetaConversionEvent = 'meta_conversion_event',
  Note = 'note',
  PlayVoice = 'play_voice',
  QpienAction = 'qpien_action',
  QuestionReply = 'question_reply',
  SendMessage = 'send_message',
  SendMessageButtons = 'send_message_buttons',
  SendNote = 'send_note',
  SendProductCatalog = 'send_product_catalog',
  StartFlow = 'start_flow',
  TaskAction = 'task_action',
  Trigger = 'trigger',
  WelcomeMessage = 'welcome_message',
  WhatsappMessage = 'whatsapp_message',
  ZohoAction = 'zoho_action'
}

export type FlowRun = {
  __typename?: 'FlowRun';
  _id: Scalars['ID']['output'];
  conversation?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  flowBot?: Maybe<Scalars['ID']['output']>;
  flowBotInstance?: Maybe<Scalars['ID']['output']>;
  flowBotName?: Maybe<Scalars['String']['output']>;
  lastNodeType?: Maybe<Scalars['String']['output']>;
  messageChannelName?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Scalars['ID']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: FlowRunStatus;
  stepCount?: Maybe<Scalars['Int']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FlowRunPaginationResponse = {
  __typename?: 'FlowRunPaginationResponse';
  docs: Array<Maybe<FlowRun>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalRecords: Scalars['Int']['output'];
};

export enum FlowRunStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Interrupted = 'Interrupted',
  Running = 'Running'
}

export type FlowRunStep = {
  __typename?: 'FlowRunStep';
  _id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  detail?: Maybe<Scalars['Object']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  flowRun: Scalars['ID']['output'];
  http?: Maybe<FlowRunStepHttp>;
  nextNodeId?: Maybe<Scalars['ID']['output']>;
  nodeId?: Maybe<Scalars['ID']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  nodeType: Scalars['String']['output'];
  resultStatus?: Maybe<Scalars['String']['output']>;
  sequence: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
};

export type FlowRunStepHttp = {
  __typename?: 'FlowRunStepHttp';
  branch?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  requestBody?: Maybe<Scalars['String']['output']>;
  requestHeaders?: Maybe<Array<Maybe<FlowRunStepHttpHeader>>>;
  responseSnippet?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FlowRunStepHttpHeader = {
  __typename?: 'FlowRunStepHttpHeader';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FlowTemplateParamInput = {
  key: Scalars['Int']['input'];
  templateKey?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlowTemplateParamType = {
  __typename?: 'FlowTemplateParamType';
  key: Scalars['Int']['output'];
  templateKey?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum FlowTimeFrequencyMode {
  Interval = 'interval',
  Once = 'once'
}

export type FlowTimeSchedule = {
  __typename?: 'FlowTimeSchedule';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['Date']['output']>;
  every?: Maybe<Scalars['Int']['output']>;
  frequencyMode?: Maybe<FlowTimeFrequencyMode>;
  lastFiredAt?: Maybe<Scalars['Date']['output']>;
  startAt?: Maybe<Scalars['Date']['output']>;
  startMode?: Maybe<FlowTimeStartMode>;
  unit?: Maybe<FlowTimeUnit>;
};

export enum FlowTimeStartMode {
  Immediate = 'immediate',
  On = 'on'
}

export enum FlowTimeTargetMode {
  Conversation = 'conversation',
  Person = 'person'
}

export enum FlowTimeUnit {
  Days = 'days',
  Hours = 'hours',
  Months = 'months',
  Weeks = 'weeks'
}

export type FlowWebhookContactIdentifier = {
  __typename?: 'FlowWebhookContactIdentifier';
  field: FlowWebhookIdentityField;
  jsonKey: Scalars['String']['output'];
};

export type FlowWebhookContactIdentifierInput = {
  field: FlowWebhookIdentityField;
  jsonKey: Scalars['String']['input'];
};

export enum FlowWebhookIdentityField {
  Email = 'email',
  Phone = 'phone'
}

export type FlowWebhookTrigger = {
  __typename?: 'FlowWebhookTrigger';
  contactIdentifier?: Maybe<FlowWebhookContactIdentifier>;
  flowId: Scalars['ID']['output'];
  publicKey: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  status: InboundWebhookStatus;
  url: Scalars['String']['output'];
  urlId: Scalars['String']['output'];
  variables: Array<FlowWebhookVariable>;
  webhookId: Scalars['ID']['output'];
};

export type FlowWebhookTriggerResponse = {
  __typename?: 'FlowWebhookTriggerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowWebhookTrigger>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FlowWebhookVariable = {
  __typename?: 'FlowWebhookVariable';
  jsonKey: Scalars['String']['output'];
  targetField: Scalars['String']['output'];
};

export type FlowWebhookVariableInput = {
  jsonKey: Scalars['String']['input'];
  targetField: Scalars['String']['input'];
};

export type FoldersResponse = {
  __typename?: 'FoldersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<TableFolder>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export type FormDataEntry = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FormFieldMappingInput = {
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  field: Scalars['String']['input'];
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  personField?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldMappingType = {
  __typename?: 'FormFieldMappingType';
  customFieldId?: Maybe<Scalars['ID']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  overwrite?: Maybe<Scalars['Boolean']['output']>;
  personField?: Maybe<Scalars['String']['output']>;
};

export type FormMessageFieldType = {
  __typename?: 'FormMessageFieldType';
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum FrameRatio {
  Landscape = 'Landscape',
  Square = 'Square',
  Vertical = 'Vertical'
}

export type FreeTrialData = {
  __typename?: 'FreeTrialData';
  cProduct: CustomerProduct;
  token: Scalars['String']['output'];
};

export type FreeTrialResponse = {
  __typename?: 'FreeTrialResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: FreeTrialData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum GenerateAiAssistantAnswerTypeEnum {
  AiSuggestedMacros = 'AI_SUGGESTED_MACROS',
  AnswerQuestion = 'ANSWER_QUESTION',
  BarcodeToText = 'BARCODE_TO_TEXT',
  Expand = 'EXPAND',
  FixSpelling = 'FIX_SPELLING',
  MakeFormal = 'MAKE_FORMAL',
  MakeFriendly = 'MAKE_FRIENDLY',
  NormalizeTurkishCharacter = 'NORMALIZE_TURKISH_CHARACTER',
  Translate = 'TRANSLATE',
  WriteResponse = 'WRITE_RESPONSE'
}

export type GenerateAiAssistantContent = {
  __typename?: 'GenerateAiAssistantContent';
  content?: Maybe<Scalars['String']['output']>;
  dynamicData?: Maybe<Scalars['JSON']['output']>;
  infoNotFound?: Maybe<Scalars['Boolean']['output']>;
  /** DRAFT or MACRO. Absent on engines that predate it, which return a macro's id in `content`. */
  kind?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  macroId?: Maybe<Scalars['ID']['output']>;
  /** What the agent must fill in or check before sending, in the panel language. */
  missingFacts?: Maybe<Array<Scalars['String']['output']>>;
  /** Platform rules the draft would break if sent as is, in the panel language. */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateAiAssistantContentInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Array<InputMaybe<PreviousMessagesType>>>;
  /** The conversation and the message being answered; the AI service reads the rest itself. */
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  /** What the agent typed before asking: an instruction or a rough reply. */
  instruction?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['FileUpload']['input']>;
  medias?: InputMaybe<Array<AiAssistantMediaInput>>;
  query: Scalars['String']['input'];
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetMessageId?: InputMaybe<Scalars['ID']['input']>;
  type: GenerateAiAssistantAnswerTypeEnum;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAiAssistantContentResponse = {
  __typename?: 'GenerateAiAssistantContentResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GenerateAiAssistantContent;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateClosingTopicContentInput = {
  conversation: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GenerateClosingTopicContentResponse = {
  __typename?: 'GenerateClosingTopicContentResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<GenerateClosingTopicContentResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateClosingTopicContentResult = {
  __typename?: 'GenerateClosingTopicContentResult';
  customFields?: Maybe<Array<Maybe<ClosingTopicCustomField>>>;
  summary?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type GenerateOAuthTokenInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type GenerateSkillDraftInput = {
  customerId: Scalars['ID']['input'];
  /**
   * The editor's current document and scope, unsaved edits included. When absent the stored
   * draft is used. The scope decides which delivery markers the draft may carry.
   */
  definition?: InputMaybe<SkillDefinitionInput>;
  /** Defaults to DRAFT. OPTIMIZE needs a skillId and answers over that draft alone. */
  mode?: InputMaybe<SkillDraftGenerationMode>;
  /** The author's own request. Required for DRAFT, ignored by OPTIMIZE, which carries no request. */
  prompt?: InputMaybe<Scalars['String']['input']>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateSkillDraftResponse = {
  __typename?: 'GenerateSkillDraftResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<GenerateSkillDraftResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateSkillDraftResult = {
  __typename?: 'GenerateSkillDraftResult';
  /** OPTIMIZE only: the draft already reads clearly and comes back untouched. */
  alreadyOptimized: Scalars['Boolean']['output'];
  definition: SkillDefinition;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type GeneratedOAuthTokenResponse = {
  __typename?: 'GeneratedOAuthTokenResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: OAuthToken;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetActionInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetActionsInput = {
  anyOf?: InputMaybe<Array<ActionFilterInput>>;
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Column sort; fields: name, description, source (type), updatedAt. */
  sort?: InputMaybe<ListSortInput>;
};

export type GetAddOnInput = {
  name: Scalars['String']['input'];
};

export type GetAdminCustomerPaymentsInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AdminCustomerPaymentFilter>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  paymentDateEnd?: InputMaybe<Scalars['Date']['input']>;
  paymentDateStart?: InputMaybe<Scalars['Date']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAiGuidanceInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetAiGuidanceListInput = {
  category?: InputMaybe<AiGuidanceCategoryEnum>;
  channel?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Omit for "all roles" — role-specific and shared guidance are then listed together. */
  role?: InputMaybe<AiRoleEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AiGuidanceStatusEnum>;
};

export type GetAiKnowledgeSourceContentInput = {
  aiKnowledgeSourceId: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AiKnowledgeSourcesStatus>;
};

export type GetAiKnowledgeSourceInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  contentSearch?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  /**
   * The list page's filter bar: type / status / added-by, each "is" or "is not" one or more values,
   * joined with AND or OR. Applied on top of `status` / `sourceType` when both are sent.
   */
  filter?: InputMaybe<AiKnowledgeSourceFilterInput>;
  includeHumanAgent?: InputMaybe<Scalars['Boolean']['input']>;
  isSinglePage?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<AiKnowledgeSourcesSourceTypes>;
  status?: InputMaybe<AiKnowledgeSourcesStatus>;
};

export type GetAiProductFaqsInput = {
  customerId: Scalars['ID']['input'];
  liveChatId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  pageUrl: Scalars['String']['input'];
};

export type GetAiStoreProductsInput = {
  customerId: Scalars['ID']['input'];
  /**
   * Read exactly this e-commerce integration's catalogue. Wins over `platformType`, and is the
   * only way to tell two sellers of the SAME marketplace apart — which is what the marketplace
   * product screens need. Always resolved within the caller's own customer.
   */
  integrationStoreId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** When set, read this tenant's matching marketplace catalogue instead of the role default. */
  platformType?: InputMaybe<ECommerceIntegrationTypes>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AiStoreProductSort>;
};

export type GetAllAiSuggestionInput = {
  customer: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAllBalanceHistoryInput = {
  customerId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAllCouponCodesInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Number']['input']>;
  page?: InputMaybe<Scalars['Number']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllWabaTemplatesPaginateInput = {
  allStatus?: InputMaybe<Scalars['Boolean']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryTypes>;
  customerId: Scalars['ID']['input'];
  eCommerceCart?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Number']['input'];
  pageSize: Scalars['Number']['input'];
  qpienFields?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<WhatsAppTemplateSort>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<TemplateTypes>;
};

export type GetAlreadyConnectedStoreResponse = {
  __typename?: 'GetAlreadyConnectedStoreResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetAppSettingsInput = {
  cPerson: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetAuthenticationInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetAuthenticationsInput = {
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Column sort; fields: name, type, updatedAt. */
  sort?: InputMaybe<ListSortInput>;
};

export type GetBalanceUsageStatisticsInput = {
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  usageType?: InputMaybe<BalanceUsageTypeEnum>;
};

export type GetBarcodeCustomExtensionActionInput = {
  _id: Scalars['ID']['input'];
  barcode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
};

export type GetBulkSharingInput = {
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Filter']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GetCPersonNotificationsInput = {
  cPersonId: Scalars['ID']['input'];
  category?: InputMaybe<CPersonNotificationCategory>;
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCPersonRoleInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type GetCPersonRoleListInput = {
  cPersons?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RoleStatus>;
};

export type GetCallAdminLogsInput = {
  callType?: InputMaybe<CallAdminLogType>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCallDashboardStatisticsInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
};

export type GetCallHistoryActiveCPersonsInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type GetCallHistoryAverageTimeInput = {
  customer: Scalars['ID']['input'];
  direction?: InputMaybe<CallDirection>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  time?: InputMaybe<GetCallHistoryAverageTimeType>;
};

export enum GetCallHistoryAverageTimeType {
  InProgressTime = 'inProgressTime',
  InQueueTime = 'inQueueTime'
}

export type GetCallHistoryCountByDirectionInput = {
  customer: Scalars['ID']['input'];
  direction?: InputMaybe<CallDirection>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistoryCountInput = {
  customer: Scalars['ID']['input'];
  direction?: InputMaybe<CallDirection>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  status: Array<InputMaybe<CallStatus>>;
};

export type GetCallHistoryCustomerPersonsInput = {
  customer: Scalars['ID']['input'];
  customerPersons?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistorySatisfactionInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistorySentimentInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  customer: Scalars['ID']['input'];
  direction?: InputMaybe<CallDirection>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCallHistorySlaAgentStatisticsInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  metric: CallHistorySlaMetric;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistorySlaStatisticsInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistorySlaStatusStatisticsInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  metric: CallHistorySlaMetric;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  status: CallHistorySlaStatus;
};

export type GetCallHistorySlaTimeStatisticsInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  metric: CallHistorySlaMetric;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistoryTalkListenInput = {
  customer: Scalars['ID']['input'];
  direction?: InputMaybe<CallDirection>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistoryTopicsInput = {
  customer: Scalars['ID']['input'];
  direction?: InputMaybe<CallDirection>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  sentiment?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallHistoryTotalCostInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  customer: Scalars['ID']['input'];
  direction?: InputMaybe<CallDirection>;
  endDate: Scalars['Date']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetCallLogsInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerPersonId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCallSnapshotCrossStatisticsInput = {
  dateRange: CallSnapshotStatisticsDateRangeInput;
  filters: Array<CallSnapshotStatisticsFilterInput>;
};

export type GetCallSnapshotStatisticsInput = {
  dateRange: CallSnapshotStatisticsDateRangeInput;
  filters: Array<CallSnapshotStatisticsFilterInput>;
  segmentBy?: InputMaybe<CallSnapshotStatisticsSegmentByInput>;
  viewBy: CallSnapshotStatisticsViewByInput;
};

export type GetCampaignForSelect = {
  __typename?: 'GetCampaignForSelect';
  _id?: Maybe<Scalars['ID']['output']>;
  abTest?: Maybe<CampaignAbTest>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  attribution?: Maybe<CampaignAttribution>;
  audienceSummary?: Maybe<CampaignAudienceSummary>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  duplicatedFrom?: Maybe<Scalars['ID']['output']>;
  dynamicGroupRecipients?: Maybe<Array<Maybe<GetRecipientsFormat>>>;
  engineVersion?: Maybe<Scalars['Int']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Scalars['Object']['output']>;
  platform?: Maybe<MiniPlatformData>;
  platformInfo?: Maybe<CampaignPlatformInfoType>;
  runtime?: Maybe<CampaignRuntime>;
  scheduleDate?: Maybe<Scalars['Date']['output']>;
  sendingPlan?: Maybe<CampaignSendingPlan>;
  smartSending?: Maybe<CampaignSmartSending>;
  stats?: Maybe<CampaignStats>;
  status?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<CampaignStatusReason>;
  survey?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  template?: Maybe<MiniTemplateData>;
  title?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalRecipientCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  variationStats?: Maybe<CampaignVariationStats>;
  variations?: Maybe<Array<Maybe<CampaignVariation>>>;
};

export type GetCampaignInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCampaignResponse = {
  __typename?: 'GetCampaignResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GetCampaignForSelect;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetCampaignsInput = {
  _id: Scalars['ID']['input'];
};

export type GetChannelOwnerTemplatesInput = {
  channelOwner: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCitiesInput = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  stateProvinceId: Scalars['ID']['input'];
};

export type GetCollageBarcodeInput = {
  customerId: Scalars['ID']['input'];
};

export type GetCollageFolderInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCollageFoldersInput = {
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Filter']['input']>;
};

export type GetCollageProductInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCollageProductsInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Filter']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCollageSettingsInput = {
  customerId: Scalars['ID']['input'];
};

export type GetCollageSharingInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCollageSharingsInput = {
  cPerson?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Filter']['input']>;
  type: SharingType;
};

export type GetCollageTemplateInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCollageTemplatesInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Filter']['input']>;
};

export type GetConvByPersonInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  senderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetConvSidebarByIdInput = {
  sidebarId: Scalars['ID']['input'];
};

export type GetConvSidebarInput = {
  cPerson: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetConvViewInput = {
  _id: Scalars['ID']['input'];
};

export type GetConvViewsInput = {
  customerId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetConversationCrossSnapshotStatisticsInput = {
  dateRange: ConversationSnapshotStatisticsDateRangeInput;
  filters: Array<ConversationSnapshotStatisticsFilterInput>;
};

export type GetConversationDashboardStatisticsInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetConversationResponse = {
  __typename?: 'GetConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SingleConversation>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetConversationSideBarInput = {
  customerId: Scalars['ID']['input'];
  sidebarId: Scalars['String']['input'];
};

export type GetConversationSnapshotStatisticsInput = {
  dateRange: ConversationSnapshotStatisticsDateRangeInput;
  filters: Array<ConversationSnapshotStatisticsFilterInput>;
  segmentBy?: InputMaybe<ConversationSnapshotStatisticsSegmentByInput>;
  viewBy: ConversationSnapshotStatisticsViewByInput;
};

export type GetConversationViewPreferenceInput = {
  customerId: Scalars['ID']['input'];
};

export type GetConversationsInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  convViewId?: InputMaybe<Scalars['ID']['input']>;
  conversationType?: InputMaybe<ConversationTypeEnum>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  isLastMessagePerson?: InputMaybe<Scalars['Boolean']['input']>;
  isMessageSearch?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamCheck?: InputMaybe<Scalars['Boolean']['input']>;
  isUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  lastAssigneeId?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedEndDate?: InputMaybe<Scalars['Filter']['input']>;
  lastUpdatedStartDate?: InputMaybe<Scalars['Filter']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageChannelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  messageChannelType?: InputMaybe<PlatformType>;
  messageEndDate?: InputMaybe<Scalars['String']['input']>;
  messageSenderId?: InputMaybe<Scalars['ID']['input']>;
  messageSenderType?: InputMaybe<SenderType>;
  messageStartDate?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  platform?: InputMaybe<Scalars['Filter']['input']>;
  platformIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  priority?: InputMaybe<TicketPriority>;
  sortOrder?: InputMaybe<ConversationSortOrder>;
  startDate?: InputMaybe<Scalars['Filter']['input']>;
  status?: InputMaybe<ConversationStatusEnum>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['Filter']['input']>;
  ticketCustomFieldId?: InputMaybe<Scalars['ID']['input']>;
  ticketCustomFieldValue?: InputMaybe<Scalars['String']['input']>;
  ticketStateStatus?: InputMaybe<Scalars['String']['input']>;
  ticketType?: InputMaybe<Scalars['ID']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
  topicIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type GetCountriesInput = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomExtensionActionInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCustomExtensionFieldsInput = {
  cardType?: InputMaybe<CardType>;
  customExtensionId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  tabId: Scalars['ID']['input'];
};

export type GetCustomExtensionInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCustomExtensionTabActionInput = {
  cardType?: InputMaybe<CardType>;
  customExtensionId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  params?: InputMaybe<Array<InputMaybe<ActionParamInput>>>;
  tabId: Scalars['ID']['input'];
};

export type GetCustomExtensionsInput = {
  customerId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomFieldsInput = {
  customer: Scalars['String']['input'];
  isOnlyParent?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<EnumCustomFieldScopeFilter>;
  usage?: InputMaybe<EnumCustomFieldUsageField>;
};

export type GetCustomerInvoicesInput = {
  customerId: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  /** Column sort; fields: invoiceNo, amount, status, method, date (createdAt). */
  sort?: InputMaybe<ListSortInput>;
};

export type GetCustomerListResponse = {
  __typename?: 'GetCustomerListResponse';
  customerList: Array<Maybe<Scalars['Object']['output']>>;
  hasNextPage: Scalars['Boolean']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  totalCustomerCount: Scalars['Int']['output'];
};

export type GetCustomerOwnersCountResponse = {
  __typename?: 'GetCustomerOwnersCountResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetCustomerOwnersData = {
  __typename?: 'GetCustomerOwnersData';
  customer?: Maybe<Customer>;
  customerPerson?: Maybe<CustomerPerson>;
};

export type GetCustomerOwnersPaginate = {
  __typename?: 'GetCustomerOwnersPaginate';
  docs: Array<GetCustomerOwnersData>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type GetCustomerOwnersResponse = {
  __typename?: 'GetCustomerOwnersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GetCustomerOwnersPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetCustomerPersonActivityLogInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCustomerPersonActivityLogsInput = {
  activityType?: InputMaybe<ActivityType>;
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Filter']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Column sort; fields: act (activity), ip (ipAddress), date (createdAt). */
  sort?: InputMaybe<ListSortInput>;
  startDate?: InputMaybe<Scalars['Filter']['input']>;
};

export type GetCustomerPersonHistoriesByStatusInput = {
  allCPersons?: InputMaybe<Scalars['Boolean']['input']>;
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type GetDelayedActionInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetDelayedActionsInput = {
  conversation?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DelayedActionType>;
};

export type GetDomainInput = {
  _id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
};

export type GetECommerceIntegrationLogsInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  integrationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchEvents?: InputMaybe<Array<ECommerceIntegrationLogEvent>>;
  searchStatuses?: InputMaybe<Array<ECommerceIntegrationLogStatus>>;
  sortBy?: InputMaybe<ECommerceIntegrationLogSort>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<ECommerceIntegrationLogStatus>>;
};

export type GetECommerceIntegrationLogsOutput = {
  __typename?: 'GetECommerceIntegrationLogsOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ECommerceIntegrationLogsPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetECommerceIntegrationsInput = {
  customerId: Scalars['String']['input'];
  isNeedShopRequest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetECommerceIntegrationsOutput = {
  __typename?: 'GetECommerceIntegrationsOutput';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<GetECommerceIntegrationsOutputData>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetECommerceIntegrationsOutputData = {
  __typename?: 'GetECommerceIntegrationsOutputData';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  customer: Scalars['String']['output'];
  hasSyncLogs?: Maybe<Scalars['Boolean']['output']>;
  lastSyncTime: Scalars['String']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<Maybe<ECommerceIntegrationPaymentMethod>>>;
  productCardSettings?: Maybe<ProductCardSettings>;
  shippingMethods?: Maybe<Array<Maybe<ECommerceIntegrationShippingMethod>>>;
  status: EIntegrationStatus;
  storeUrl?: Maybe<Scalars['String']['output']>;
  supportsCheckoutLink?: Maybe<Scalars['Boolean']['output']>;
  supportsLinePriceOverride?: Maybe<Scalars['Boolean']['output']>;
  supportsOrderNote?: Maybe<Scalars['Boolean']['output']>;
  type: ECommerceIntegrationTypes;
};

export type GetECommerceRulesInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type GetEmailAdminLogsInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
};

export type GetExternalApiInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetExternalApisInput = {
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetFeedbackSurveyInput = {
  _id: Scalars['String']['input'];
};

export type GetFlowBotInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetFlowBotPaginatedInput = {
  channelTypeFilter?: InputMaybe<FlowMessageChannel>;
  customer: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  /** Active (true) / passive (false) bots only; omitted = both. */
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetFlowBotPaginatedResponse = {
  __typename?: 'GetFlowBotPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowBotPaginationResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetFlowBotResponse = {
  __typename?: 'GetFlowBotResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowBot>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetFlowNodeInput = {
  _id: Scalars['ID']['input'];
};

export type GetFlowNodePaginatedInput = {
  customer: Scalars['String']['input'];
  flowBotId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GetFlowNodePaginatedResponse = {
  __typename?: 'GetFlowNodePaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNodePaginationResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetFlowNodeResponse = {
  __typename?: 'GetFlowNodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetFlowRunStepsInput = {
  customer: Scalars['String']['input'];
  flowRunId: Scalars['ID']['input'];
};

export type GetFlowRunStepsResponse = {
  __typename?: 'GetFlowRunStepsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<FlowRunStep>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetFlowRunsInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  customer: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  flowBotId?: InputMaybe<Scalars['ID']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FlowRunStatus>;
  /** Any of these statuses (the builder's Durum filter); combined with `status` when both are set. */
  statuses?: InputMaybe<Array<FlowRunStatus>>;
};

export type GetFlowRunsResponse = {
  __typename?: 'GetFlowRunsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowRunPaginationResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetFlowWebhookTriggerInput = {
  flowId: Scalars['ID']['input'];
};

export type GetGroupsListResponse = {
  __typename?: 'GetGroupsListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GroupsAndCount;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetHomeDashboardStatisticsInput = {
  customerId: Scalars['ID']['input'];
  /**
   * Defaults to `today`. Ignored by the LIVE tab, which has no window — LIVE echoes the value
   * back but reports granularity "live" and bucketCount 0.
   */
  dateRange?: InputMaybe<HomeDashboardStatisticsDateRange>;
  /**
   * Which metric the chart draws. Ignored if it is not one of the tab's metrics, in
   * which case the tab's first metric is used.
   */
  selectedMetricType?: InputMaybe<Scalars['String']['input']>;
  tab: HomeDashboardStatisticsTab;
};

export type GetInboundWebhookInput = {
  _id: Scalars['ID']['input'];
};

export type GetInboundWebhookLogsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InboundWebhookLogStatus>;
  webhookId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetInboundWebhooksInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InboundWebhookStatus>;
  triggerType?: InputMaybe<InboundWebhookTriggerType>;
};

export type GetIntegrationFieldsInput = {
  customerId: Scalars['ID']['input'];
  modules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<IntegrationType>;
};

export type GetIntegrationsInput = {
  customerId: Scalars['String']['input'];
};

export type GetJoinedGroupsInput = {
  customer: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

export type GetMarketplaceOrdersInput = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MarketplaceType>;
};

export type GetMessageCrossSnapshotStatisticsInput = {
  dateRange: MessageSnapshotStatisticsDateRangeInput;
  filters: Array<MessageSnapshotStatisticsFilterInput>;
  viewBy?: InputMaybe<MessageSnapshotStatisticsViewByInput>;
};

export type GetMessageSnapshotStatisticsInput = {
  dateRange: MessageSnapshotStatisticsDateRangeInput;
  filters: Array<MessageSnapshotStatisticsFilterInput>;
  segmentBy?: InputMaybe<MessageSnapshotStatisticsSegmentByInput>;
  viewBy: MessageSnapshotStatisticsViewByInput;
};

export type GetMobileAppVersionInput = {
  buildNumber?: InputMaybe<Scalars['Int']['input']>;
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  platform: MobilePlatform;
};

export type GetMsgStatistics = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channelType?: InputMaybe<PlatformType>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<MessageType>;
  startDate: Scalars['String']['input'];
};

export type GetMsgStatisticsRes = {
  __typename?: 'GetMsgStatisticsRes';
  code?: Maybe<Scalars['String']['output']>;
  data: GetMsgSDataRes;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetOperatorChatInput = {
  chatId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetOperatorChatsInput = {
  customerId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetOperatorRunsInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrdersListResponse = {
  __typename?: 'GetOrdersListResponse';
  hasNextPage: Scalars['Boolean']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  orders: Array<Maybe<Scalars['Object']['output']>>;
  totalOrders: Scalars['Int']['output'];
};

export type GetPaginatedECommerceRulesInput = {
  customer: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetPersonActivityLogsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
  types?: InputMaybe<Array<PersonActivityLogType>>;
};

export type GetPersonConversationsInput = {
  customerId: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['String']['input'];
  status?: InputMaybe<ConversationStatusEnum>;
};

export type GetPersonInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type GetPersonNotesInput = {
  customerId: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  personId: Scalars['ID']['input'];
};

export type GetPersonTimelineInput = {
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};

export type GetPlatformsPaginatedInput = {
  customer: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  platformType: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetPlatformsPaginatedOutput = {
  __typename?: 'GetPlatformsPaginatedOutput';
  code?: Maybe<Scalars['String']['output']>;
  data: GetPlatformsResponse;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPlatformsResponse = {
  __typename?: 'GetPlatformsResponse';
  data: Array<Maybe<Scalars['Object']['output']>>;
  hasNextPage: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type GetProductListResponse = {
  __typename?: 'GetProductListResponse';
  hasNextPage: Scalars['Boolean']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  products: Array<Maybe<Scalars['Object']['output']>>;
  totalProducts: Scalars['Int']['output'];
};

export type GetQpienShopCustomer = {
  __typename?: 'GetQpienShopCustomer';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type GetQpienShopCustomerAddressesInput = {
  customerId: Scalars['String']['input'];
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  qpienShopCustomerId: Scalars['String']['input'];
};

export type GetQpienShopCustomerAddressesResponse = {
  __typename?: 'GetQpienShopCustomerAddressesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<QpienShopCustomerAddressData>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetQpienShopCustomersData = {
  __typename?: 'GetQpienShopCustomersData';
  count: Scalars['Int']['output'];
  customers: Array<Maybe<GetQpienShopCustomer>>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type GetQpienShopCustomersInput = {
  customerId: Scalars['String']['input'];
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  platformType?: InputMaybe<ECommerceIntegrationTypes>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetQpienShopCustomersResponse = {
  __typename?: 'GetQpienShopCustomersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GetQpienShopCustomersData;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetQpienShopOrderInput = {
  customerId: Scalars['String']['input'];
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['String']['input'];
};

export type GetQpienShopOrderResponse = {
  __typename?: 'GetQpienShopOrderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: QpienShopOrderDetail;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetQpienShopOrdersInput = {
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerExternalId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  platformType?: InputMaybe<ECommerceIntegrationTypes>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetQpienShopOrdersResponse = {
  __typename?: 'GetQpienShopOrdersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<QpienShopOrdersData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetQpienShopProductsInput = {
  customerId: Scalars['String']['input'];
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  platformType?: InputMaybe<ECommerceIntegrationTypes>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetQpienShopProductsResponse = {
  __typename?: 'GetQpienShopProductsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: QpienShopProducts;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetQpienShopStoreData = {
  __typename?: 'GetQpienShopStoreData';
  _id: Scalars['ID']['output'];
  customer: Scalars['String']['output'];
  status: QpienShopStoreStoreStatus;
  storeId: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
};

export type GetQpienShopStoreResponse = {
  __typename?: 'GetQpienShopStoreResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<GetQpienShopStoreData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetRecipientsFormat = {
  __typename?: 'GetRecipientsFormat';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GetRecordAttachmentInput = {
  customerId: Scalars['ID']['input'];
  data?: InputMaybe<AttachmentRecord>;
  type?: InputMaybe<IntegrationType>;
};

export type GetRecordNotesInput = {
  customerId: Scalars['ID']['input'];
  data?: InputMaybe<NoteRecord>;
  type?: InputMaybe<IntegrationType>;
};

export type GetReportInput = {
  reportId: Scalars['ID']['input'];
};

export type GetReportWidgetDataInput = {
  /** Record-list widgets only. Opaque keyset cursor from a previous page's `pageInfo.endCursor`. */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Record-list (`list` chart) widgets only — page size, clamped server-side. Ignored by every
   * aggregate chart, which answers in a single shot.
   */
  first?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
};

export type GetReportWidgetMetricTemplatesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetReportWidgetTemplatesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetReportWidgetsInput = {
  reportId: Scalars['ID']['input'];
};

export type GetReportsInput = {
  customerId: Scalars['ID']['input'];
};

export type GetSimilarContactsInput = {
  customerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GetSkillRunInput = {
  customerId: Scalars['ID']['input'];
  runId: Scalars['ID']['input'];
};

export type GetSlaHistoryInput = {
  assignedAgentId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  historyType?: InputMaybe<SlaStageName>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  slaInstanceId?: InputMaybe<Scalars['ID']['input']>;
  slaPolicyId?: InputMaybe<Scalars['ID']['input']>;
  slaStatus?: InputMaybe<SlaStageStatus>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetSlaInstanceInput = {
  instanceId: Scalars['ID']['input'];
};

export type GetSlaPoliciesInput = {
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SlaPolicyStatus>;
};

export type GetSlaPolicyInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetSlaReportInput = {
  assignedAgentId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  customerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  historyType?: InputMaybe<SlaStageName>;
  slaPolicyId?: InputMaybe<Scalars['ID']['input']>;
  slaStatus?: InputMaybe<SlaStageStatus>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetSlaStageTimeStatisticsInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  slaPolicy?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<SlaStageName>;
  startDate: Scalars['Date']['input'];
};

export type GetSlaStatisticsInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  slaPolicy?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<SlaStageName>;
  startDate: Scalars['Date']['input'];
  status?: InputMaybe<SlaStageStatus>;
};

export type GetSlaStatusStatisticsInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  slaPolicy?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<SlaStageName>;
  startDate: Scalars['Date']['input'];
  status?: InputMaybe<SlaStageStatus>;
};

export type GetStatesProvincesCitiesInput = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  stateProvinceId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GetSurveyCrossSnapshotStatisticsInput = {
  dateRange: SurveySnapshotStatisticsDateRangeInput;
  filters: Array<SurveySnapshotStatisticsFilterInput>;
  viewBy?: InputMaybe<SurveySnapshotStatisticsViewByInput>;
};

export type GetSurveyHistoryStatisticInput = {
  conversationType?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  customerPerson?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  pageNumber?: InputMaybe<Scalars['Number']['input']>;
  pageSize?: InputMaybe<Scalars['Number']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  surveyId?: InputMaybe<Scalars['String']['input']>;
};

export type GetSurveyHistoryStatisticPersonInput = {
  conversationType?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  customerPerson?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  pageNumber?: InputMaybe<Scalars['Number']['input']>;
  pageSize?: InputMaybe<Scalars['Number']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<RatingType>;
  startDate: Scalars['Date']['input'];
  surveyId?: InputMaybe<Scalars['String']['input']>;
};

export type GetSurveyHistoryStatisticsInput = {
  customer: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type GetSurveyInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetSurveySnapshotStatisticsInput = {
  dateRange: SurveySnapshotStatisticsDateRangeInput;
  filters: Array<SurveySnapshotStatisticsFilterInput>;
  segmentBy?: InputMaybe<SurveySnapshotStatisticsSegmentByInput>;
  viewBy: SurveySnapshotStatisticsViewByInput;
};

export type GetSurveysInput = {
  customer: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  /** Column sort; fields: name, status, createdAt. */
  sort?: InputMaybe<ListSortInput>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetTableFieldsInput = {
  customerId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type GetTableFoldersInput = {
  customerId: Scalars['ID']['input'];
};

export type GetTableRecordActivitiesInput = {
  customerId: Scalars['ID']['input'];
  pagination?: InputMaybe<TableRecordPaginationInput>;
  recordId: Scalars['ID']['input'];
  type?: InputMaybe<TableRecordActivityType>;
};

export type GetTableRecordInput = {
  customerId: Scalars['ID']['input'];
  recordId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type GetTableRecordsInput = {
  customerId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<TableRecordFilterInput>>;
  pagination?: InputMaybe<TableRecordPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  tableId: Scalars['ID']['input'];
};

export type GetTableViewsInput = {
  customerId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type GetTablesInput = {
  customerId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
};

export type GetTagInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetTagsInput = {
  customerId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  /** Column sort; fields: name, createdAt. */
  sort?: InputMaybe<ListSortInput>;
  type?: InputMaybe<TagType>;
};

export type GetTaskByIdInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetTaskBySourceIdInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetTaskCommentsInput = {
  taskId: Scalars['ID']['input'];
};

export type GetTaskLogsInput = {
  customerId: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  taskId: Scalars['ID']['input'];
};

export type GetTasksInput = {
  cPerson?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  filter?: InputMaybe<TaskFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTeamChatsInput = {
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TeamChatState>;
  type?: InputMaybe<TeamChatType>;
};

export type GetTeamConvMembersInput = {
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teamConversationId: Scalars['ID']['input'];
};

export type GetTeamMessagesInput = {
  before?: InputMaybe<Scalars['Date']['input']>;
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  teamConversationId: Scalars['ID']['input'];
};

export type GetTicketPriorityStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
  ticketType?: InputMaybe<Scalars['String']['input']>;
};

export type GetTicketStateStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
};

export type GetTicketStatesInput = {
  customer: Scalars['String']['input'];
};

export type GetTicketStatisticsInput = {
  allCPersons?: InputMaybe<Scalars['Boolean']['input']>;
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  isAssign?: InputMaybe<Scalars['Boolean']['input']>;
  isAverage?: InputMaybe<Scalars['Boolean']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isOpenAndReOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isReOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  isStateCategoriesIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  isTotalClose?: InputMaybe<Scalars['Boolean']['input']>;
  isTotalReOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isTransferred?: InputMaybe<Scalars['Boolean']['input']>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<TicketPriority>;
  startDate: Scalars['String']['input'];
  ticketType?: InputMaybe<Scalars['String']['input']>;
};

export type GetTicketTypeInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type GetTicketTypeStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
};

export type GetTicketTypesInput = {
  customer: Scalars['String']['input'];
  status?: InputMaybe<TicketStatusType>;
};

export type GetTimeBasedAudienceCountInput = {
  customer: Scalars['String']['input'];
  flowBotId: Scalars['String']['input'];
};

export type GetTimeBasedAudienceCountResponse = {
  __typename?: 'GetTimeBasedAudienceCountResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TimeBasedAudienceCountResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetTopicComparisonStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  column: Scalars['String']['input'];
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  row: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
  upperCustomFieldId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTopicCustomFieldsComparisonStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  column: Scalars['String']['input'];
  columnCustomFieldId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  row: Scalars['String']['input'];
  rowCustomFieldId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
  upperCustomFieldId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTopicStatisticsInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<PlatformType>;
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTopicsInput = {
  customerId: Scalars['ID']['input'];
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetVariantListResponse = {
  __typename?: 'GetVariantListResponse';
  currency?: Maybe<Scalars['String']['output']>;
  discountedPrice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  salesPrice?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  variantId?: Maybe<Scalars['Int']['output']>;
  variantsType1?: Maybe<Scalars['String']['output']>;
  variantsType2?: Maybe<Scalars['String']['output']>;
  variantsType3?: Maybe<Scalars['String']['output']>;
};

export type GetWabaTemplateInput = {
  customerId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
};

export type GetWebhookInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetWebhooksInput = {
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetWorkflowStatusCountsInput = {
  customer: Scalars['ID']['input'];
};

export type GetWorkflowStatusCountsResponse = {
  __typename?: 'GetWorkflowStatusCountsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<WorkflowStatusCounts>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetWorkflowsPaginatedInput = {
  /** FlowMessageChannel values; a workflow matches when any of its channels does. */
  channels?: InputMaybe<Array<FlowMessageChannel>>;
  customer: Scalars['ID']['input'];
  excludeChannels?: InputMaybe<Array<FlowMessageChannel>>;
  excludeStates?: InputMaybe<Array<WorkflowState>>;
  /** Only these workflows (flow bot or e-commerce rule ids). */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  /** Default UPDATED_AT DESC. */
  sortBy?: InputMaybe<WorkflowSortField>;
  sortOrder?: InputMaybe<WorkflowSortOrder>;
  states?: InputMaybe<Array<WorkflowState>>;
};

export type GetWorkflowsPaginatedResponse = {
  __typename?: 'GetWorkflowsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<WorkflowPaginationData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetZohoBlueprintTransitionsInput = {
  customerId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};

export type GetZohoModuleFieldsInput = {
  customerId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
};

export type GetZohoTestRecordInput = {
  customerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  moduleName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
};

export type GetZohoUsersInput = {
  customerId: Scalars['ID']['input'];
};

export type GoogleAuthData = {
  __typename?: 'GoogleAuthData';
  customer: Scalars['ID']['output'];
  is2FAEnabled: Scalars['Boolean']['output'];
  isNewCustomer: Scalars['Boolean']['output'];
  person: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

export type GoogleAuthInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<CustomerPersonDeviceType>;
  idToken: Scalars['String']['input'];
  language: Language;
  partner?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleAuthResponse = {
  __typename?: 'GoogleAuthResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<GoogleAuthData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Group = {
  __typename?: 'Group';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GroupWithCount = {
  __typename?: 'GroupWithCount';
  _id?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Maybe<Conditions>>>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shouldMatchAllConditions?: Maybe<Scalars['Boolean']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
  whatsAppSenderPlatformId?: Maybe<Scalars['String']['output']>;
};

export type GroupsAndCount = {
  __typename?: 'GroupsAndCount';
  docs?: Maybe<Array<Maybe<GroupWithCount>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export enum HomeDashboardStatName {
  Ai = 'ai',
  Call = 'call',
  Conversations = 'conversations',
  Live = 'live',
  Tickets = 'tickets'
}

export type HomeDashboardStatSettingsItem = {
  __typename?: 'HomeDashboardStatSettingsItem';
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  name: HomeDashboardStatName;
  order?: Maybe<Scalars['Int']['output']>;
};

export enum HomeDashboardStatisticsDateRange {
  Last7days = 'last7days',
  Last30days = 'last30days',
  ThisMonth = 'thisMonth',
  ThisWeek = 'thisWeek',
  Today = 'today',
  Yesterday = 'yesterday'
}

export enum HomeDashboardStatisticsDeltaDirection {
  Down = 'DOWN',
  Flat = 'FLAT',
  New = 'NEW',
  Up = 'UP'
}

export type HomeDashboardStatisticsError = {
  __typename?: 'HomeDashboardStatisticsError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type HomeDashboardStatisticsMetricCard = {
  __typename?: 'HomeDashboardStatisticsMetricCard';
  currentValue?: Maybe<Scalars['Double']['output']>;
  deltaDirection?: Maybe<HomeDashboardStatisticsDeltaDirection>;
  deltaPercent?: Maybe<Scalars['Double']['output']>;
  /**
   * Absolute change. For percentage metrics this is the point difference (37% → 42% is
   * 5 points, not 13.5%); the client picks whichever reading the card should show.
   */
  deltaPoints?: Maybe<Scalars['Double']['output']>;
  error?: Maybe<HomeDashboardStatisticsError>;
  format?: Maybe<Scalars['String']['output']>;
  isSelected: Scalars['Boolean']['output'];
  measureKey: Scalars['String']['output'];
  metricTemplateId: Scalars['ID']['output'];
  metricType: Scalars['String']['output'];
  previousValue?: Maybe<Scalars['Double']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type HomeDashboardStatisticsPeriod = {
  __typename?: 'HomeDashboardStatisticsPeriod';
  from: Scalars['Date']['output'];
  /**
   * IANA zone every boundary and bucket label resolved in: the REQUESTING AGENT's
   * `CustomerPersons.timeZone`, falling back to the tenant's `Customers.timeZone` and then to
   * "Europe/Istanbul". The same zone the snapshot layer buckets in, so the labels below always line
   * up with it.
   *
   * Two agents in one tenant with different profile zones therefore get DIFFERENT numbers from the
   * same request — that is intended. Use this field, never the browser zone, to format any date you
   * render next to this data.
   */
  timezone: Scalars['String']['output'];
  to: Scalars['Date']['output'];
};

export type HomeDashboardStatisticsResponse = {
  __typename?: 'HomeDashboardStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<HomeDashboardStatisticsResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HomeDashboardStatisticsResult = {
  __typename?: 'HomeDashboardStatisticsResult';
  bucketCount: Scalars['Int']['output'];
  currentPeriod: HomeDashboardStatisticsPeriod;
  /**
   * The range that was applied. Echoed so a client can discard an out-of-order response after a
   * fast range toggle. LIVE echoes what was asked without applying it (granularity "live").
   */
  dateRange: HomeDashboardStatisticsDateRange;
  /**
   * Whole days spanned by `currentPeriod`. LEGACY — it is no longer the series length (`today` is
   * 1 day but 24 points). Use `bucketCount`.
   */
  dayCount: Scalars['Int']['output'];
  granularity: Scalars['String']['output'];
  /**
   * True only when there is genuinely nothing to show. A card in `error` keeps this
   * false — broken is not the same as empty, and the UI should offer a retry rather than
   * an empty state.
   */
  isEmpty: Scalars['Boolean']['output'];
  metrics: Array<HomeDashboardStatisticsMetricCard>;
  previousBucketCount: Scalars['Int']['output'];
  previousPeriod: HomeDashboardStatisticsPeriod;
  series?: Maybe<HomeDashboardStatisticsSeries>;
  tab: HomeDashboardStatisticsTab;
};

export type HomeDashboardStatisticsSeries = {
  __typename?: 'HomeDashboardStatisticsSeries';
  /**
   * Index-aligned: current[i] and previous[i] are the same ordinal bucket of their respective
   * periods. `current` is `bucketCount` long, `previous` is `previousBucketCount` long — equal
   * except for `thisMonth` at month-end, where `previous` is shorter because the earlier month
   * has fewer days (Mar 1-31 vs Feb 1-28). Draw the dashed line only as far as it goes.
   */
  current: Array<HomeDashboardStatisticsSeriesPoint>;
  metricType: Scalars['String']['output'];
  previous: Array<HomeDashboardStatisticsSeriesPoint>;
};

export type HomeDashboardStatisticsSeriesPoint = {
  __typename?: 'HomeDashboardStatisticsSeriesPoint';
  /**
   * Gap-filled bucket label: "YYYY-MM-DD" at day granularity, "YYYY-MM-DDTHH:00" at hour.
   *
   * ⚠️ A DISPLAY LABEL, not an instant. It is wall clock in `currentPeriod.timezone` and carries
   * no offset, so `new Date(bucket)` parses it in the BROWSER's zone and shifts every bucket for
   * any agent whose profile zone differs from their browser zone. Format it as text; read the grain
   * from `granularity`.
   */
  bucket: Scalars['String']['output'];
  value: Scalars['Double']['output'];
};

export enum HomeDashboardStatisticsTab {
  AiAgent = 'AI_AGENT',
  Calls = 'CALLS',
  Conversations = 'CONVERSATIONS',
  Live = 'LIVE',
  Tickets = 'TICKETS'
}

export enum HomeWidgetName {
  DashboardStats = 'dashboardStats',
  Notifications = 'notifications',
  Tasks = 'tasks',
  TeamMembers = 'teamMembers',
  WhatsNew = 'whatsNew'
}

export type HomeWidgetSettingsItem = {
  __typename?: 'HomeWidgetSettingsItem';
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  name: HomeWidgetName;
  order?: Maybe<Scalars['Int']['output']>;
};

export type HttpTestHeaderInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type HttpTestHeaderType = {
  __typename?: 'HttpTestHeaderType';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type HttpTestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  formData?: InputMaybe<Array<InputMaybe<FormDataEntry>>>;
  formDataUrlEncoded?: InputMaybe<Array<InputMaybe<FormDataEntry>>>;
  headers?: InputMaybe<Array<InputMaybe<HttpTestHeaderInput>>>;
  method: HttpTestMethod;
  url: Scalars['String']['input'];
};

export enum HttpTestMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type HttpTestResponse = {
  __typename?: 'HttpTestResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<HttpTestResponseType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HttpTestResponseType = {
  __typename?: 'HttpTestResponseType';
  body: Scalars['String']['output'];
  headers?: Maybe<Array<Maybe<HttpTestHeaderType>>>;
  requestFailed: Scalars['Boolean']['output'];
  statusCode: Scalars['Int']['output'];
};

export type HumanHandoff = {
  __typename?: 'HumanHandoff';
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type HumanHandoffInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type HumanReplyLearningCostBreakdown = {
  __typename?: 'HumanReplyLearningCostBreakdown';
  estimatedCost: Scalars['Float']['output'];
  inputTokens: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
};

export type HumanReplyLearningFailure = {
  __typename?: 'HumanReplyLearningFailure';
  conversationId?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type HumanReplyLearningJob = {
  __typename?: 'HumanReplyLearningJob';
  cancelRequestedAt?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  costBreakdown: Array<HumanReplyLearningCostBreakdown>;
  countedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentConversationId?: Maybe<Scalars['ID']['output']>;
  customerId: Scalars['ID']['output'];
  duplicatePairs: Scalars['Int']['output'];
  extractedPairs: Scalars['Int']['output'];
  failedConversations: Scalars['Int']['output'];
  failures?: Maybe<Array<HumanReplyLearningFailure>>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  mode: Scalars['String']['output'];
  modelsUsed: Array<Scalars['String']['output']>;
  processedConversations: Scalars['Int']['output'];
  progressPercent: Scalars['Float']['output'];
  rateLimitResumeAt?: Maybe<Scalars['String']['output']>;
  rateLimitRetryCount?: Maybe<Scalars['Int']['output']>;
  rateLimitedAt?: Maybe<Scalars['String']['output']>;
  remainingConversations: Scalars['Int']['output'];
  resolvedConflictPairs: Scalars['Int']['output'];
  resolvedConflicts?: Maybe<Array<HumanReplyLearningResolvedConflict>>;
  savedPairs: Scalars['Int']['output'];
  skippedConversations: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  status: HumanReplyLearningJobStatus;
  totalConversations: Scalars['Int']['output'];
  totalEstimatedCost: Scalars['Float']['output'];
  totalInputTokens: Scalars['Int']['output'];
  totalOutputTokens: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  usageByModel: Array<HumanReplyLearningModelUsage>;
};

export type HumanReplyLearningJobResponse = {
  __typename?: 'HumanReplyLearningJobResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<HumanReplyLearningJob>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum HumanReplyLearningJobStatus {
  Cancelled = 'cancelled',
  Cancelling = 'cancelling',
  Completed = 'completed',
  Failed = 'failed',
  Queued = 'queued',
  Running = 'running'
}

export type HumanReplyLearningJobsResponse = {
  __typename?: 'HumanReplyLearningJobsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<HumanReplyLearningJob>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HumanReplyLearningModelUsage = {
  __typename?: 'HumanReplyLearningModelUsage';
  estimatedCost: Scalars['Float']['output'];
  inputTokens: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
};

export type HumanReplyLearningResolvedConflict = {
  __typename?: 'HumanReplyLearningResolvedConflict';
  conversationId: Scalars['ID']['output'];
  existingAiKnowledgeSourceContentId: Scalars['ID']['output'];
  existingAnswer: Scalars['String']['output'];
  existingQuestion: Scalars['String']['output'];
  newAnswer: Scalars['String']['output'];
  newQuestion: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type IAiAnalysisSentiment = {
  __typename?: 'IAiAnalysisSentiment';
  confidence?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AiAnalysisSentimentType>;
};

export type IAiAnalysisTopic = {
  __typename?: 'IAiAnalysisTopic';
  confidence?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IPersonActicityResponse = {
  __typename?: 'IPersonActicityResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IPhoneNumberSoundInput = {
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  totalTimeout?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PhoneNumberSoundType>;
  value?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<Scalars['String']['input']>;
};

export type ImageMedia = {
  __typename?: 'ImageMedia';
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ImapServerInput = {
  host?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportPersonsInput = {
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldsType>>>;
  customer: Scalars['ID']['input'];
  fields: Array<InputMaybe<Scalars['Int']['input']>>;
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  isDublicateWillUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  user_tagId?: InputMaybe<Scalars['ID']['input']>;
};

export type ImportPersonsPreview = {
  __typename?: 'ImportPersonsPreview';
  invalid: Scalars['Int']['output'];
  matching: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ImportPersonsPreviewResponse = {
  __typename?: 'ImportPersonsPreviewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ImportPersonsPreview>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportPersonsResponse = {
  __typename?: 'ImportPersonsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ImportPersonsStatus;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportPersonsStatus = {
  __typename?: 'ImportPersonsStatus';
  errorsLink?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type ImportRecordsToTableInput = {
  customerId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  duplicateHandling?: InputMaybe<TableImportDuplicateHandling>;
  fieldMapping: Scalars['Object']['input'];
  file: Scalars['FileUpload']['input'];
  matchFieldKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  tableId: Scalars['ID']['input'];
};

export type ImportRecordsToTableResponse = {
  __typename?: 'ImportRecordsToTableResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ImportRecordsToTableResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportRecordsToTableResult = {
  __typename?: 'ImportRecordsToTableResult';
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  duplicateSkippedCount?: Maybe<Scalars['Int']['output']>;
  hasMoreSkippedRows?: Maybe<Scalars['Boolean']['output']>;
  importedCount?: Maybe<Scalars['Int']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
  skippedRows?: Maybe<Array<Maybe<ImportRecordsToTableSkippedRow>>>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type ImportRecordsToTableSkippedRow = {
  __typename?: 'ImportRecordsToTableSkippedRow';
  fieldName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonCode?: Maybe<TableImportSkipReason>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InboundWebhook = {
  __typename?: 'InboundWebhook';
  _id: Scalars['ID']['output'];
  authMode: InboundWebhookAuthMode;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  defaults?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flowId?: Maybe<Scalars['ID']['output']>;
  mapping: Array<InboundWebhookMappingRule>;
  name: Scalars['String']['output'];
  plainSecret?: Maybe<Scalars['String']['output']>;
  provider: InboundWebhookProvider;
  publicKey: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  sourceConfig?: Maybe<InboundWebhookSourceConfig>;
  status: InboundWebhookStatus;
  triggerType: InboundWebhookTriggerType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  urlId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum InboundWebhookAuthMode {
  Hmac = 'HMAC'
}

export type InboundWebhookLog = {
  __typename?: 'InboundWebhookLog';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  status: InboundWebhookLogStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  webhookId: Scalars['ID']['output'];
};

export enum InboundWebhookLogStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type InboundWebhookLogsPaginatedData = {
  __typename?: 'InboundWebhookLogsPaginatedData';
  docs: Array<Maybe<InboundWebhookLog>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pagingCounter?: Maybe<Scalars['Int']['output']>;
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type InboundWebhookLogsPaginatedResponse = {
  __typename?: 'InboundWebhookLogsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: InboundWebhookLogsPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InboundWebhookMappingRule = {
  __typename?: 'InboundWebhookMappingRule';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sourcePath: Scalars['String']['output'];
  sourceType?: Maybe<InboundWebhookSourceType>;
  targetField: Scalars['String']['output'];
  transforms?: Maybe<Array<InboundWebhookTransform>>;
};

export type InboundWebhookMappingRuleInput = {
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sourcePath: Scalars['String']['input'];
  sourceType?: InputMaybe<InboundWebhookSourceType>;
  targetField: Scalars['String']['input'];
  transforms?: InputMaybe<Array<InboundWebhookTransform>>;
};

export enum InboundWebhookProvider {
  Other = 'OTHER',
  Zoho = 'ZOHO'
}

export type InboundWebhookResponse = {
  __typename?: 'InboundWebhookResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: InboundWebhook;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InboundWebhookSourceConfig = {
  __typename?: 'InboundWebhookSourceConfig';
  captureUnmappedBodyAsCustomFields?: Maybe<Scalars['Boolean']['output']>;
  customFieldExcludePaths?: Maybe<Array<Scalars['String']['output']>>;
  customFieldSourceType?: Maybe<InboundWebhookSourceType>;
  enabledSources?: Maybe<Array<InboundWebhookSourceType>>;
};

export type InboundWebhookSourceConfigInput = {
  captureUnmappedBodyAsCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  customFieldExcludePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  customFieldSourceType?: InputMaybe<InboundWebhookSourceType>;
  enabledSources?: InputMaybe<Array<InboundWebhookSourceType>>;
};

export enum InboundWebhookSourceType {
  Body = 'body',
  Headers = 'headers',
  Query = 'query'
}

export enum InboundWebhookStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum InboundWebhookTransform {
  Lowercase = 'lowercase',
  PhoneNormalize = 'phoneNormalize',
  SplitFullName = 'splitFullName',
  Trim = 'trim'
}

export enum InboundWebhookTriggerType {
  CreatedContact = 'CREATED_CONTACT',
  CreatedLead = 'CREATED_LEAD',
  MessageReceived = 'MESSAGE_RECEIVED',
  WebhookTriggered = 'WEBHOOK_TRIGGERED'
}

export type InboundWebhooksPaginatedData = {
  __typename?: 'InboundWebhooksPaginatedData';
  docs: Array<Maybe<InboundWebhook>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pagingCounter?: Maybe<Scalars['Int']['output']>;
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type InboundWebhooksPaginatedResponse = {
  __typename?: 'InboundWebhooksPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: InboundWebhooksPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IncomingFile = {
  file: Scalars['Media']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type IncomingFolder = {
  files: Array<IncomingFile>;
  name: Scalars['String']['input'];
};

export type InformativeButtonsButtonsType = {
  __typename?: 'InformativeButtonsButtonsType';
  _id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InformativeButtonsContentType = {
  __typename?: 'InformativeButtonsContentType';
  caption?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InformativeButtonsType = {
  __typename?: 'InformativeButtonsType';
  buttons?: Maybe<Array<Maybe<InformativeButtonsButtonsType>>>;
  content?: Maybe<InformativeButtonsContentType>;
};

export type InputConditions = {
  rule?: InputMaybe<PersonFilterRuleType>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InsertedRecord = {
  __typename?: 'InsertedRecord';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<ZohoPerson>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type InspectCollectionInput = {
  collection: Scalars['String']['input'];
  counts?: InputMaybe<Array<InspectCountInput>>;
  /** Collection size from metadata; a count with an empty filter scans every document. */
  estimatedTotal?: InputMaybe<Scalars['Boolean']['input']>;
  sample?: InputMaybe<InspectSampleInput>;
  withIndexes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InspectCollectionResponse = {
  __typename?: 'InspectCollectionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<InspectCollectionResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InspectCollectionResult = {
  __typename?: 'InspectCollectionResult';
  collection: Scalars['String']['output'];
  counts: Array<InspectCount>;
  estimatedTotal?: Maybe<Scalars['Int']['output']>;
  indexes: Array<InspectIndex>;
  /** Projected documents, JSON-stringified. */
  samples: Array<Scalars['String']['output']>;
};

export type InspectCount = {
  __typename?: 'InspectCount';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type InspectCountInput = {
  filter?: InputMaybe<Scalars['Object']['input']>;
  key: Scalars['String']['input'];
};

export type InspectIndex = {
  __typename?: 'InspectIndex';
  /** Serialised key spec, e.g. {"customer":1,"role":1}. */
  keys: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unique: Scalars['Boolean']['output'];
};

export type InspectSampleInput = {
  /** Required — a probe never pulls whole documents into a browser. */
  fields: Array<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['Object']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type InstagramAccount = {
  __typename?: 'InstagramAccount';
  _id?: Maybe<Scalars['ID']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  instagramId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type InstagramPage = {
  __typename?: 'InstagramPage';
  _id?: Maybe<Scalars['ID']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  failedMessage?: Maybe<Scalars['Boolean']['output']>;
  fbChannelId?: Maybe<Scalars['String']['output']>;
  instagramAccount?: Maybe<InstagramAccount>;
  isCommentEnable?: Maybe<Scalars['Boolean']['output']>;
  isMessageEnable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type Integration = {
  __typename?: 'Integration';
  _id?: Maybe<Scalars['ID']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  checkPersonOwner?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  domainName?: Maybe<Scalars['String']['output']>;
  fieldMapping?: Maybe<Scalars['JSON']['output']>;
  hasSubscribed?: Maybe<Scalars['Boolean']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  modules?: Maybe<Array<Maybe<IntegrationModule>>>;
  name?: Maybe<Scalars['String']['output']>;
  noPersonOwner?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  ownerSource?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sendHistoryToZoho?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type IntegrationFieldsResponse = {
  __typename?: 'IntegrationFieldsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ModuleField>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationInsertedRecordResponse = {
  __typename?: 'IntegrationInsertedRecordResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: InsertedRecord;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationModule = {
  __typename?: 'IntegrationModule';
  api_name?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<CustomModuleFieldOutput>>>;
  generated_type?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  module_fields?: Maybe<Array<Maybe<IntegrationModuleField>>>;
  module_name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Number']['output']>;
};

export type IntegrationModuleField = {
  __typename?: 'IntegrationModuleField';
  apiCreate?: Maybe<Scalars['Boolean']['output']>;
  apiName?: Maybe<Scalars['String']['output']>;
  apiUpdate?: Maybe<Scalars['Boolean']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  jsonType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  pickListValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  sortOrder?: Maybe<Scalars['Number']['output']>;
  systemMandatory?: Maybe<Scalars['Boolean']['output']>;
  virtualField?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationModuleFieldInput = {
  apiCreate?: InputMaybe<Scalars['Boolean']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  apiUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  dataType?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  jsonType?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pickListValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Number']['input']>;
  systemMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  virtualField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationModuleInput = {
  api_name?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<CustomModuleField>>>;
  generated_type?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  module_fields?: InputMaybe<Array<InputMaybe<IntegrationModuleFieldInput>>>;
  module_name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Number']['input']>;
};

export type IntegrationRecord = {
  fields: Scalars['Object']['input'];
  moduleName: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};

export type IntegrationRecordAttachmentResponse = {
  __typename?: 'IntegrationRecordAttachmentResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<RecordAttachment>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationRecordAttachmentsListResponse = {
  __typename?: 'IntegrationRecordAttachmentsListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<RecordAttachmentsList>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationRecordNoteResponse = {
  __typename?: 'IntegrationRecordNoteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<RecordNote>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationRecordNotesResponse = {
  __typename?: 'IntegrationRecordNotesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<RecordNote>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationRecordResponse = {
  __typename?: 'IntegrationRecordResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<UpdatedRecord>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationResponse = {
  __typename?: 'IntegrationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Integration;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum IntegrationType {
  Zoho = 'ZOHO'
}

export type IntegrationUploadResponse = {
  __typename?: 'IntegrationUploadResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<UploadedAttachment>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationsResponse = {
  __typename?: 'IntegrationsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<Integration>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type JoinConversationInput = {
  _id: Scalars['ID']['input'];
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  joinedPerson?: InputMaybe<JoinedPersonInput>;
};

export type JoinedGroup = {
  __typename?: 'JoinedGroup';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type JoinedGroupsResponse = {
  __typename?: 'JoinedGroupsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<JoinedGroup>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum Live_Chat_Icon {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export enum Live_Chat_Icon_Position {
  Left = 'LEFT',
  Right = 'RIGHT',
  TopLeft = 'TOP_LEFT',
  TopRight = 'TOP_RIGHT'
}

export enum Language {
  Ar = 'ar',
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Tr = 'tr'
}

export type LastMessageType = {
  __typename?: 'LastMessageType';
  ackStatus?: Maybe<AckType>;
  channelType?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customFields?: Maybe<Array<Maybe<ClosingNoteCustomField>>>;
  hasMedia?: Maybe<Scalars['Boolean']['output']>;
  isRobot?: Maybe<Scalars['Boolean']['output']>;
  senderType?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<IAiAnalysisSentiment>;
  subject?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  topicName?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<IAiAnalysisTopic>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LayoutInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type LeadFields = {
  __typename?: 'LeadFields';
  Lead_Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LeaveTeamGroupChatInput = {
  customerId: Scalars['ID']['input'];
  reassignAdminToUserId?: InputMaybe<Scalars['ID']['input']>;
  teamConversationId: Scalars['ID']['input'];
};

export type LimitsAndUsages = {
  __typename?: 'LimitsAndUsages';
  aiAnswers?: Maybe<Scalars['Int']['output']>;
  aiAssistant?: Maybe<Scalars['Int']['output']>;
  amazon?: Maybe<Scalars['Int']['output']>;
  apiKeys?: Maybe<Scalars['Int']['output']>;
  cPerson?: Maybe<Scalars['Int']['output']>;
  cPersonRoles?: Maybe<Scalars['Int']['output']>;
  callMinutes?: Maybe<Scalars['Int']['output']>;
  customChannel?: Maybe<Scalars['Int']['output']>;
  customReports?: Maybe<Scalars['Int']['output']>;
  ebay?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Int']['output']>;
  facebook?: Maybe<Scalars['Int']['output']>;
  faprika?: Maybe<Scalars['Int']['output']>;
  flowBots?: Maybe<Scalars['Int']['output']>;
  form?: Maybe<Scalars['Int']['output']>;
  googleBusiness?: Maybe<Scalars['Int']['output']>;
  hepsiburada?: Maybe<Scalars['Int']['output']>;
  ideasoft?: Maybe<Scalars['Int']['output']>;
  ikas?: Maybe<Scalars['Int']['output']>;
  inboxRules?: Maybe<Scalars['Int']['output']>;
  instagram?: Maybe<Scalars['Int']['output']>;
  kaufland?: Maybe<Scalars['Int']['output']>;
  liveChat?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metaWhatsAppBusiness?: Maybe<Scalars['Int']['output']>;
  n11?: Maybe<Scalars['Int']['output']>;
  operatorCredits?: Maybe<Scalars['Float']['output']>;
  pazarama?: Maybe<Scalars['Int']['output']>;
  person?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['Int']['output']>;
  qpienShop?: Maybe<Scalars['Int']['output']>;
  shopify?: Maybe<Scalars['Int']['output']>;
  slaPolicies?: Maybe<Scalars['Int']['output']>;
  survey?: Maybe<Scalars['Int']['output']>;
  tableRecords?: Maybe<Scalars['Int']['output']>;
  tables?: Maybe<Scalars['Int']['output']>;
  teams?: Maybe<Scalars['Int']['output']>;
  telegram?: Maybe<Scalars['Int']['output']>;
  ticimax?: Maybe<Scalars['Int']['output']>;
  ticket?: Maybe<Scalars['Int']['output']>;
  tiktok?: Maybe<Scalars['Int']['output']>;
  trendyol?: Maybe<Scalars['Int']['output']>;
  tsoft?: Maybe<Scalars['Int']['output']>;
  walmart?: Maybe<Scalars['Int']['output']>;
  webhooks?: Maybe<Scalars['Int']['output']>;
  whatsAppBusiness?: Maybe<Scalars['Int']['output']>;
  whatsAppWeb?: Maybe<Scalars['Int']['output']>;
  zoho?: Maybe<Scalars['Int']['output']>;
};

export type LimitsAndUsagesInput = {
  aiAnswers?: InputMaybe<Scalars['Int']['input']>;
  aiAssistant?: InputMaybe<Scalars['Int']['input']>;
  amazon?: InputMaybe<Scalars['Int']['input']>;
  apiKeys?: InputMaybe<Scalars['Int']['input']>;
  cPerson?: InputMaybe<Scalars['Int']['input']>;
  cPersonRoles?: InputMaybe<Scalars['Int']['input']>;
  callMinutes?: InputMaybe<Scalars['Int']['input']>;
  customChannel?: InputMaybe<Scalars['Int']['input']>;
  customReports?: InputMaybe<Scalars['Int']['input']>;
  ebay?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['Int']['input']>;
  facebook?: InputMaybe<Scalars['Int']['input']>;
  faprika?: InputMaybe<Scalars['Int']['input']>;
  flowBots?: InputMaybe<Scalars['Int']['input']>;
  form?: InputMaybe<Scalars['Int']['input']>;
  googleBusiness?: InputMaybe<Scalars['Int']['input']>;
  hepsiburada?: InputMaybe<Scalars['Int']['input']>;
  ideasoft?: InputMaybe<Scalars['Int']['input']>;
  ikas?: InputMaybe<Scalars['Int']['input']>;
  inboxRules?: InputMaybe<Scalars['Int']['input']>;
  instagram?: InputMaybe<Scalars['Int']['input']>;
  kaufland?: InputMaybe<Scalars['Int']['input']>;
  liveChat?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metaWhatsAppBusiness?: InputMaybe<Scalars['Int']['input']>;
  n11?: InputMaybe<Scalars['Int']['input']>;
  operatorCredits?: InputMaybe<Scalars['Float']['input']>;
  pazarama?: InputMaybe<Scalars['Int']['input']>;
  person?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['Int']['input']>;
  qpienShop?: InputMaybe<Scalars['Int']['input']>;
  shopify?: InputMaybe<Scalars['Int']['input']>;
  slaPolicies?: InputMaybe<Scalars['Int']['input']>;
  survey?: InputMaybe<Scalars['Int']['input']>;
  tableRecords?: InputMaybe<Scalars['Int']['input']>;
  tables?: InputMaybe<Scalars['Int']['input']>;
  teams?: InputMaybe<Scalars['Int']['input']>;
  telegram?: InputMaybe<Scalars['Int']['input']>;
  ticimax?: InputMaybe<Scalars['Int']['input']>;
  ticket?: InputMaybe<Scalars['Int']['input']>;
  tiktok?: InputMaybe<Scalars['Int']['input']>;
  trendyol?: InputMaybe<Scalars['Int']['input']>;
  tsoft?: InputMaybe<Scalars['Int']['input']>;
  walmart?: InputMaybe<Scalars['Int']['input']>;
  webhooks?: InputMaybe<Scalars['Int']['input']>;
  whatsAppBusiness?: InputMaybe<Scalars['Int']['input']>;
  whatsAppWeb?: InputMaybe<Scalars['Int']['input']>;
  zoho?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkECommerceCustomerInputType = {
  customerId: Scalars['String']['input'];
  eCommerceCustomer: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  person: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type LinkMetaDatasetInput = {
  assetId: Scalars['String']['input'];
  channelType: ChannelType;
  customerId: Scalars['ID']['input'];
};

export type ListBlockTemplatesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
};

export type ListBlockTemplatesOutput = {
  __typename?: 'ListBlockTemplatesOutput';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<TemplateBlock>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListCampaignsInput = {
  abTest?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelTypes?: InputMaybe<Array<CampaignPlatformType>>;
  customerId: Scalars['ID']['input'];
  displayStatuses?: InputMaybe<Array<CampaignDisplayStatus>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sort?: InputMaybe<CampaignListSort>;
  statusGroup?: InputMaybe<CampaignStatusGroup>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type ListCampaignsResponse = {
  __typename?: 'ListCampaignsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignListPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListCardConfig = {
  __typename?: 'ListCardConfig';
  action?: Maybe<Scalars['ID']['output']>;
  connectedTab?: Maybe<Scalars['ID']['output']>;
  sections?: Maybe<Array<Maybe<SectionConfig>>>;
};

export type ListCardConfigInput = {
  action?: InputMaybe<Scalars['ID']['input']>;
  connectedTab?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<InputMaybe<SectionConfigInput>>>;
};

export type ListChangelogInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChangelogStatus>;
};

export type ListChangelogSubscribersInput = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListDeliveriesInput = {
  announcementId?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<ChangelogChannel>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  hasFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ChangelogDeliveryStatus>;
};

export type ListFlowNodeInput = {
  customer: Scalars['String']['input'];
  flowBot: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListFlowNodeResponse = {
  __typename?: 'ListFlowNodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<FlowNode>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListGlobalBtnType = {
  __typename?: 'ListGlobalBtnType';
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ListInfiniteParams = {
  channelType?: InputMaybe<ChannelType>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  kind?: InputMaybe<AiRunKindFilterEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<AiMessageStatusEnum>;
};

export type ListItemOptionType = {
  __typename?: 'ListItemOptionType';
  _id?: Maybe<Scalars['String']['output']>;
  postbackText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ListMessageItemType = {
  __typename?: 'ListMessageItemType';
  options?: Maybe<Array<Maybe<ListItemOptionType>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ListMessageType = {
  __typename?: 'ListMessageType';
  body?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  globalButtons?: Maybe<Array<Maybe<ListGlobalBtnType>>>;
  items?: Maybe<Array<Maybe<ListMessageItemType>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ListNodeTemplatesOutput = {
  __typename?: 'ListNodeTemplatesOutput';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<TemplateNode>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListReusableFlowsInput = {
  customer: Scalars['String']['input'];
};

export type ListReusableFlowsResponse = {
  __typename?: 'ListReusableFlowsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<FlowBot>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListSkillRunsInput = {
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<SkillRunStatus>>;
};

export type ListSkillVersionsInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ListSkillsInput = {
  customerId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Omit for "all roles" — role-specific and shared skills are then listed together. */
  role?: InputMaybe<AiRoleEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SkillStatus>>;
};

export enum ListSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/**
 * Data table column sort (user-panel DataTable header click). Each list query
 * whitelists the `field` values it accepts; unknown fields keep its default order.
 */
export type ListSortInput = {
  direction: ListSortDirection;
  field: Scalars['String']['input'];
};

export type LiveChatAccount = {
  __typename?: 'LiveChatAccount';
  _id: Scalars['ID']['output'];
  appearance?: Maybe<LiveChatAccountApperance>;
  channelsLiveChatRemoveQpienLogo?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  getStartedInfo?: Maybe<LiveChatAccountGetStartedInfo>;
  settings?: Maybe<LiveChatAccountSettings>;
  status?: Maybe<Scalars['Boolean']['output']>;
  websiteDomain?: Maybe<Scalars['String']['output']>;
};

export type LiveChatAccountApperance = {
  __typename?: 'LiveChatAccountApperance';
  greeting: Scalars['String']['output'];
  greetingContent: Scalars['String']['output'];
  liveChatIcon: Live_Chat_Icon;
  liveChatIconPosition: Live_Chat_Icon_Position;
  liveChatIconType: Selected_Live_Chat_Icon;
  logo: Scalars['String']['output'];
  newChatSubtitle: Scalars['String']['output'];
  newChatTitle: Scalars['String']['output'];
  oldChatsTitle: Scalars['String']['output'];
  removeLiveChatLogo?: Maybe<Scalars['Boolean']['output']>;
  secondaryTextColor: Scalars['String']['output'];
  spaceBottom?: Maybe<Scalars['Int']['output']>;
  spaceSide?: Maybe<Scalars['Int']['output']>;
  textColor: Scalars['String']['output'];
  themeColor: Scalars['String']['output'];
  uploadedLiveChatIcon?: Maybe<Scalars['String']['output']>;
};

export type LiveChatAccountFacebookMessangerSettings = {
  __typename?: 'LiveChatAccountFacebookMessangerSettings';
  account: Scalars['String']['output'];
  buttonTitle: Scalars['String']['output'];
  content: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type LiveChatAccountGetStartedInfo = {
  __typename?: 'LiveChatAccountGetStartedInfo';
  minutesToClose: Scalars['String']['output'];
  visitorContactInfo: LiveChatAccountVisitorContactInfo;
};

export type LiveChatAccountInstagramSettings = {
  __typename?: 'LiveChatAccountInstagramSettings';
  account: Scalars['String']['output'];
  buttonTitle: Scalars['String']['output'];
  content: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type LiveChatAccountLiveChatSettings = {
  __typename?: 'LiveChatAccountLiveChatSettings';
  visibility?: Maybe<LiveChatAccountVisibility>;
};

export type LiveChatAccountPhoneCallSettings = {
  __typename?: 'LiveChatAccountPhoneCallSettings';
  buttonTitle: Scalars['String']['output'];
  content: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type LiveChatAccountSettings = {
  __typename?: 'LiveChatAccountSettings';
  facebookMessanger?: Maybe<LiveChatAccountFacebookMessangerSettings>;
  instagram?: Maybe<LiveChatAccountInstagramSettings>;
  liveChat?: Maybe<LiveChatAccountLiveChatSettings>;
  notificationSound: Scalars['Boolean']['output'];
  phoneCall?: Maybe<LiveChatAccountPhoneCallSettings>;
  showAgentProfiles: Scalars['Boolean']['output'];
  showOnlineStatus: Scalars['Boolean']['output'];
  tiktok?: Maybe<LiveChatAccountTiktokSettings>;
  visitorRateUs?: Maybe<LiveChatAccountVisitorRateUs>;
  whatsApp?: Maybe<LiveChatAccountWhatsappSettings>;
};

export type LiveChatAccountTiktokSettings = {
  __typename?: 'LiveChatAccountTiktokSettings';
  account: Scalars['String']['output'];
  buttonTitle: Scalars['String']['output'];
  content: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export enum LiveChatAccountVisibility {
  NotVisible = 'NOT_VISIBLE',
  OnlyInsideWorkingHours = 'ONLY_INSIDE_WORKING_HOURS',
  OnlyOutsideWorkingHours = 'ONLY_OUTSIDE_WORKING_HOURS',
  Visible = 'VISIBLE'
}

export type LiveChatAccountVisitorContactInfo = {
  __typename?: 'LiveChatAccountVisitorContactInfo';
  address?: Maybe<Scalars['String']['output']>;
  addressRequired?: Maybe<Scalars['String']['output']>;
  contactInformationPermission?: Maybe<Scalars['Boolean']['output']>;
  contactInformationPermissionContent?: Maybe<Scalars['String']['output']>;
  contactInformationPermissionLinkText?: Maybe<Scalars['String']['output']>;
  contactInformationPermissionLinkUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  emailAddressRequired: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  fullNameRequired: Scalars['String']['output'];
  message: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberRequired?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  thankYouMessage?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  value?: Maybe<Visitor_Contact_Info_Value>;
};

export type LiveChatAccountVisitorRateUs = {
  __typename?: 'LiveChatAccountVisitorRateUs';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  thankYouMessage?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type LiveChatAccountWhatsappSettings = {
  __typename?: 'LiveChatAccountWhatsappSettings';
  account: Scalars['String']['output'];
  buttonTitle: Scalars['String']['output'];
  content: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type LiveChatMessageResponse = {
  __typename?: 'LiveChatMessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveChatReceiveMessageInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  browserLanguage?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  convId: Scalars['ID']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  flowBotQuickReply?: InputMaybe<Array<InputMaybe<FlowBotQuickReplyInput>>>;
  flowBotQuickReplyButtonsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  flowBotQuickReplyResponseId?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  liveChatAccountId: Scalars['ID']['input'];
  media?: InputMaybe<Array<InputMaybe<Scalars['Media']['input']>>>;
  messageId: Scalars['String']['input'];
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  productFaqSelected?: InputMaybe<Scalars['Boolean']['input']>;
  qpnuid: Scalars['String']['input'];
  siteUrl?: InputMaybe<Scalars['String']['input']>;
  type: MessageType;
  username?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageFlowBot?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageTarget?: InputMaybe<Scalars['String']['input']>;
};

export type LiveChatWidgetCdnConfig = {
  __typename?: 'LiveChatWidgetCdnConfig';
  bucket?: Maybe<Scalars['String']['output']>;
  cacheControl?: Maybe<Scalars['String']['output']>;
  cdnUrl?: Maybe<Scalars['String']['output']>;
  distributionId?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type LiveChatWidgetCdnObject = {
  __typename?: 'LiveChatWidgetCdnObject';
  etag?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['Date']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

export type LiveChatWidgetFile = {
  __typename?: 'LiveChatWidgetFile';
  contentType?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

export type LiveChatWidgetInvalidation = {
  __typename?: 'LiveChatWidgetInvalidation';
  createTime?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LiveChatWidgetInvalidationResponse = {
  __typename?: 'LiveChatWidgetInvalidationResponse';
  data?: Maybe<LiveChatWidgetInvalidation>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveChatWidgetOverview = {
  __typename?: 'LiveChatWidgetOverview';
  activeRelease?: Maybe<LiveChatWidgetRelease>;
  config?: Maybe<LiveChatWidgetCdnConfig>;
  liveFiles?: Maybe<Array<Maybe<LiveChatWidgetCdnObject>>>;
  liveTotalBytes?: Maybe<Scalars['Float']['output']>;
};

export type LiveChatWidgetOverviewResponse = {
  __typename?: 'LiveChatWidgetOverviewResponse';
  data?: Maybe<LiveChatWidgetOverview>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveChatWidgetRelease = {
  __typename?: 'LiveChatWidgetRelease';
  _id?: Maybe<Scalars['ID']['output']>;
  archivePrefix?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  cdnUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  distributionId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<LiveChatWidgetFile>>>;
  healthCheckStatus?: Maybe<Scalars['Int']['output']>;
  healthCheckUrl?: Maybe<Scalars['String']['output']>;
  invalidationId?: Maybe<Scalars['String']['output']>;
  invalidationStatus?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  removedKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  restoredFrom?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<LiveChatWidgetReleaseSource>;
  status?: Maybe<LiveChatWidgetReleaseStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type LiveChatWidgetReleaseListResponse = {
  __typename?: 'LiveChatWidgetReleaseListResponse';
  data?: Maybe<Array<Maybe<LiveChatWidgetRelease>>>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveChatWidgetReleaseResponse = {
  __typename?: 'LiveChatWidgetReleaseResponse';
  data?: Maybe<LiveChatWidgetRelease>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum LiveChatWidgetReleaseSource {
  Rollback = 'ROLLBACK',
  Upload = 'UPLOAD'
}

export enum LiveChatWidgetReleaseStatus {
  Active = 'ACTIVE',
  Failed = 'FAILED',
  Invalidating = 'INVALIDATING',
  InvalidationFailed = 'INVALIDATION_FAILED',
  Superseded = 'SUPERSEDED',
  Uploading = 'UPLOADING'
}

export type LocalizedMessageButtonInput = {
  title: Scalars['String']['input'];
};

export type LocalizedMessageButtonType = {
  __typename?: 'LocalizedMessageButtonType';
  title?: Maybe<Scalars['String']['output']>;
};

export type LocalizedMessageInput = {
  buttonParams?: InputMaybe<Array<InputMaybe<FlowTemplateParamInput>>>;
  buttons?: InputMaybe<Array<InputMaybe<LocalizedMessageButtonInput>>>;
  language: Scalars['String']['input'];
  templateParams?: InputMaybe<Array<InputMaybe<FlowTemplateParamInput>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedMessageType = {
  __typename?: 'LocalizedMessageType';
  buttonParams?: Maybe<Array<Maybe<FlowTemplateParamType>>>;
  buttons?: Maybe<Array<Maybe<LocalizedMessageButtonType>>>;
  language?: Maybe<Scalars['String']['output']>;
  templateParams?: Maybe<Array<Maybe<FlowTemplateParamType>>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LocationsResponse = {
  __typename?: 'LocationsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MailInfoInput = {
  bcc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  envelope?: InputMaybe<EnvelopeInput>;
  from: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type MakePlatformReactionResponse = {
  __typename?: 'MakePlatformReactionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkAnnouncementReadInput = {
  announcementId: Scalars['ID']['input'];
};

export type MarkCPersonNotificationsReadInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MarkCPersonNotificationsUnreadInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MarkOnboardingStepInput = {
  customerId: Scalars['ID']['input'];
  step: ClientOnboardingStep;
};

export type MarkTeamChatReadInput = {
  customerId: Scalars['ID']['input'];
  lastReadMessageId: Scalars['ID']['input'];
  teamConversationId: Scalars['ID']['input'];
};

export type MarketPlaceSettings = {
  __typename?: 'MarketPlaceSettings';
  aiAgentWorkingHours?: Maybe<AiWorkingHoursEnum>;
  aiReplyButtons?: Maybe<AiReplyNonChatButtons>;
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  replyMode?: Maybe<AiProfileReplyModeEnum>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MarketPlaceSettingsInput = {
  aiAgentWorkingHours?: InputMaybe<AiWorkingHoursEnum>;
  aiReplyButtons?: InputMaybe<AiReplyNonChatButtonsInput>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  replyMode?: InputMaybe<AiProfileReplyModeEnum>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketplaceBuyer = {
  __typename?: 'MarketplaceBuyer';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type MarketplaceOrder = {
  __typename?: 'MarketplaceOrder';
  _id: Scalars['ID']['output'];
  amountPaid: Scalars['String']['output'];
  buyer: MarketplaceBuyer;
  cancelStatus: Scalars['String']['output'];
  checkoutStatus: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdTime: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  customer: Scalars['ID']['output'];
  displayOrderId?: Maybe<Scalars['String']['output']>;
  isTaxIncluded: Scalars['Boolean']['output'];
  items: Array<MarketplaceOrderItem>;
  marketplace: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  orderStatus: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  refundStatus: Scalars['String']['output'];
  returnStatus: Scalars['String']['output'];
  seller: MarketplaceSeller;
  shipmentTracking?: Maybe<MarketplaceOrderShipmentTracking>;
  shippingAddress: MarketplaceOrderShippingAdress;
  shippingService: MarketplaceOrderShippingService;
  subTotal: Scalars['String']['output'];
  taxRate: Scalars['String']['output'];
  total: Scalars['String']['output'];
  type: MarketplaceType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MarketplaceOrderItem = {
  __typename?: 'MarketplaceOrderItem';
  id: Scalars['String']['output'];
  location: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  site: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MarketplaceOrderShipmentTracking = {
  __typename?: 'MarketplaceOrderShipmentTracking';
  shippingCareer?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrderShippingAdress = {
  __typename?: 'MarketplaceOrderShippingAdress';
  addressId: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  stateOrProvince: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrderShippingService = {
  __typename?: 'MarketplaceOrderShippingService';
  cost: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MarketplaceOrdersPaginated = {
  __typename?: 'MarketplaceOrdersPaginated';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  orders: Array<MarketplaceOrder>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceOrdersResponse = {
  __typename?: 'MarketplaceOrdersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MarketplaceOrdersPaginated>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarketplaceSeller = {
  __typename?: 'MarketplaceSeller';
  userId: Scalars['String']['output'];
};

export enum MarketplaceType {
  Amazon = 'AMAZON',
  Ebay = 'EBAY',
  Kaufland = 'KAUFLAND',
  Pazarama = 'PAZARAMA',
  Walmart = 'WALMART'
}

export type MediaInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type MergeContactsInput = {
  cPersonId: Scalars['ID']['input'];
  contactInfo: ContactInfoInput;
  customerId: Scalars['ID']['input'];
  destinationConversation?: InputMaybe<Scalars['ID']['input']>;
  fromId: Scalars['ID']['input'];
  isMergeConversations: Scalars['Boolean']['input'];
  sourceConversations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toId: Scalars['ID']['input'];
};

export type MergeConversationsInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};

export type MergedContactResponse = {
  __typename?: 'MergedContactResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MergedConversationResponse = {
  __typename?: 'MergedConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Message = {
  __typename?: 'Message';
  _id?: Maybe<Scalars['ID']['output']>;
  ackStatus?: Maybe<AckType>;
  adReferral?: Maybe<MessageAdReferral>;
  adReferralData?: Maybe<AdReferralDataType>;
  aiNotResponseReason?: Maybe<Scalars['String']['output']>;
  analysisData?: Maybe<AnalysisData>;
  autoCreate?: Maybe<Scalars['Boolean']['output']>;
  autoEmailMessage?: Maybe<Scalars['Boolean']['output']>;
  callData?: Maybe<CallDataType>;
  cartAction?: Maybe<MessageCartActionType>;
  catalogMessage?: Maybe<CatalogInteractiveType>;
  catalogOrderData?: Maybe<CatalogOrderDataType>;
  channelMessageId?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<ChannelType>;
  closingNoteData?: Maybe<ClosingNoteData>;
  commentData?: Maybe<CommentDataType>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  emailData?: Maybe<EmailDataType>;
  failedReason?: Maybe<FailedReasonType>;
  flowBotQuickReply?: Maybe<Array<Maybe<FlowBotQuickReplyType>>>;
  flowBotQuickReplyButtonsRequired?: Maybe<Scalars['Boolean']['output']>;
  flowBotQuickReplyResponseId?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Array<Maybe<FormMessageFieldType>>>;
  frontMsgId?: Maybe<Scalars['String']['output']>;
  informativeButtons?: Maybe<InformativeButtonsType>;
  isViewOnce?: Maybe<Scalars['Boolean']['output']>;
  listMessage?: Maybe<ListMessageType>;
  media?: Maybe<Array<Maybe<Scalars['Media']['output']>>>;
  mentions?: Maybe<Array<Scalars['ID']['output']>>;
  messageReactions?: Maybe<Array<MessageReactionType>>;
  messageType?: Maybe<MessageType>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  product_cards?: Maybe<Scalars['Object']['output']>;
  questionData?: Maybe<QuestionDataType>;
  quotedMessage?: Maybe<QuotedMessageType>;
  reactions?: Maybe<ReactionEnum>;
  sender?: Maybe<SenderData>;
  senderType?: Maybe<SenderType>;
  subject?: Maybe<Scalars['String']['output']>;
  surveyData?: Maybe<SurveyDataForLivechat>;
  template_cards?: Maybe<Scalars['Object']['output']>;
};

export type MessageAckData = {
  __typename?: 'MessageAckData';
  _id?: Maybe<Scalars['ID']['output']>;
  ackStatus?: Maybe<AckType>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  messageReactions?: Maybe<Array<MessageReactionType>>;
};

export type MessageAckSubscriptionInput = {
  convId: Scalars['ID']['input'];
  me: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type MessageAdReferral = {
  __typename?: 'MessageAdReferral';
  body?: Maybe<Scalars['String']['output']>;
  clickedAt?: Maybe<Scalars['Date']['output']>;
  ctwaClid?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<AdReferralPlatform>;
  ref?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type MessageCartActionLineType = {
  __typename?: 'MessageCartActionLineType';
  cartItemId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type MessageCartActionType = {
  __typename?: 'MessageCartActionType';
  cartUrl?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Array<Maybe<MessageCartActionLineType>>>;
  platform?: Maybe<Scalars['String']['output']>;
  storefrontHost?: Maybe<Scalars['String']['output']>;
};

export type MessageForAiSimulationData = {
  __typename?: 'MessageForAiSimulationData';
  _id: Scalars['ID']['output'];
  channel?: Maybe<Scalars['ID']['output']>;
  channelType?: Maybe<PlatformType>;
  commentData?: Maybe<CommentDataType>;
  content?: Maybe<Scalars['String']['output']>;
  messageType: MessageType;
  previousMessages?: Maybe<Array<Maybe<PreviousMessagePreview>>>;
  questionData?: Maybe<QuestionDataType>;
};

export type MessageForAiSimulationResponse = {
  __typename?: 'MessageForAiSimulationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MessageForAiSimulationData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MessagePaginationInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  convId: Scalars['ID']['input'];
  convStartDate?: InputMaybe<Scalars['Date']['input']>;
  customerId: Scalars['ID']['input'];
  fromLiveChat?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  liveChatId?: InputMaybe<Scalars['ID']['input']>;
  me?: InputMaybe<Scalars['String']['input']>;
  msgCount?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MessageSearchType>;
  uniqId?: InputMaybe<Scalars['ID']['input']>;
};

export type MessageReactionType = {
  __typename?: 'MessageReactionType';
  createdAt?: Maybe<Scalars['Date']['output']>;
  emoji: Scalars['String']['output'];
  fromCustomer: Scalars['Boolean']['output'];
  personId?: Maybe<Scalars['ID']['output']>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Message;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum MessageSearchType {
  Media = 'MEDIA',
  Note = 'NOTE'
}

export enum MessageSnapshotStatisticsAggregation {
  AvgPerConversation = 'avgPerConversation',
  Count = 'count',
  Rate = 'rate'
}

export type MessageSnapshotStatisticsAppliedFilter = {
  __typename?: 'MessageSnapshotStatisticsAppliedFilter';
  field: Scalars['String']['output'];
  operator: MessageSnapshotStatisticsFilterOperator;
  value: Scalars['Object']['output'];
};

export enum MessageSnapshotStatisticsCountTarget {
  Snapshot = 'snapshot'
}

export type MessageSnapshotStatisticsDataPoint = {
  __typename?: 'MessageSnapshotStatisticsDataPoint';
  segment?: Maybe<Scalars['Object']['output']>;
  value: Scalars['Double']['output'];
};

export enum MessageSnapshotStatisticsDateField {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export enum MessageSnapshotStatisticsDatePreset {
  Last7days = 'last7days',
  Last30days = 'last30days',
  Last90days = 'last90days',
  LastMonth = 'lastMonth',
  ThisMonth = 'thisMonth',
  Today = 'today',
  Yesterday = 'yesterday'
}

export type MessageSnapshotStatisticsDateRangeInput = {
  field?: InputMaybe<MessageSnapshotStatisticsDateField>;
  from?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<MessageSnapshotStatisticsDatePreset>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type MessageSnapshotStatisticsFilterInput = {
  field: Scalars['String']['input'];
  operator: MessageSnapshotStatisticsFilterOperator;
  value: Scalars['Object']['input'];
};

export enum MessageSnapshotStatisticsFilterOperator {
  Eq = 'eq',
  In = 'in'
}

export enum MessageSnapshotStatisticsGranularity {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week'
}

export type MessageSnapshotStatisticsMeta = {
  __typename?: 'MessageSnapshotStatisticsMeta';
  appliedFilters: Array<MessageSnapshotStatisticsAppliedFilter>;
  dateRange?: Maybe<MessageSnapshotStatisticsResolvedDateRange>;
  segmentBy?: Maybe<MessageSnapshotStatisticsSegmentByMeta>;
  viewBy: MessageSnapshotStatisticsViewByMeta;
};

export type MessageSnapshotStatisticsResolvedDateRange = {
  __typename?: 'MessageSnapshotStatisticsResolvedDateRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type MessageSnapshotStatisticsResponse = {
  __typename?: 'MessageSnapshotStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: MessageSnapshotStatisticsResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MessageSnapshotStatisticsResult = {
  __typename?: 'MessageSnapshotStatisticsResult';
  data: Array<MessageSnapshotStatisticsDataPoint>;
  meta: MessageSnapshotStatisticsMeta;
};

export type MessageSnapshotStatisticsSegmentByInput = {
  field: Scalars['String']['input'];
  granularity?: InputMaybe<MessageSnapshotStatisticsGranularity>;
};

export type MessageSnapshotStatisticsSegmentByMeta = {
  __typename?: 'MessageSnapshotStatisticsSegmentByMeta';
  field: Scalars['String']['output'];
  granularity?: Maybe<Scalars['String']['output']>;
};

export type MessageSnapshotStatisticsViewByInput = {
  aggregation: MessageSnapshotStatisticsAggregation;
  countTarget?: InputMaybe<MessageSnapshotStatisticsCountTarget>;
  field: Scalars['String']['input'];
};

export type MessageSnapshotStatisticsViewByMeta = {
  __typename?: 'MessageSnapshotStatisticsViewByMeta';
  aggregation: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export type MessageSubscriptionInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type MessageToMeConversationType = {
  __typename?: 'MessageToMeConversationType';
  _id?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Maybe<ChannelTypes>>>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  isGroupOrChannel?: Maybe<Scalars['Boolean']['output']>;
  isStarred?: Maybe<Scalars['Boolean']['output']>;
  joinedCPerson?: Maybe<Scalars['ID']['output']>;
  joinedPerson?: Maybe<Person>;
  lastMessage?: Maybe<LastMessageType>;
  lastReceivedMessageChannel?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<TicketPriority>;
  slaInstance?: Maybe<Scalars['ID']['output']>;
  slaInstanceData?: Maybe<SlaInstance>;
  slaPolicy?: Maybe<Scalars['ID']['output']>;
  sourceFormId?: Maybe<Scalars['ID']['output']>;
  sourcePlatformType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConversationStatusEnum>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  ticketCustomFields?: Maybe<Array<Maybe<TicketCustomFieldOutput>>>;
  ticketId?: Maybe<Scalars['ID']['output']>;
  ticketState?: Maybe<Scalars['ID']['output']>;
  ticketType?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ConversationTypeEnum>;
  unAnsweredMessageCount?: Maybe<Scalars['Int']['output']>;
  waitingSince?: Maybe<Scalars['Date']['output']>;
};

export type MessageToMeSubscriptionInput = {
  client?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  me: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type MessageToMeSubscriptionInputType = {
  __typename?: 'MessageToMeSubscriptionInputType';
  _id?: Maybe<Scalars['ID']['output']>;
  ackStatus?: Maybe<AckType>;
  adReferral?: Maybe<MessageAdReferral>;
  adReferralData?: Maybe<AdReferralDataType>;
  aiNotResponseReason?: Maybe<Scalars['String']['output']>;
  autoCreate?: Maybe<Scalars['Boolean']['output']>;
  autoEmailMessage?: Maybe<Scalars['Boolean']['output']>;
  callData?: Maybe<CallDataType>;
  cartAction?: Maybe<MessageCartActionType>;
  channel?: Maybe<Scalars['ID']['output']>;
  channelMessageId?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<ChannelType>;
  commentData?: Maybe<CommentDataType>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<MessageToMeConversationType>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  emailData?: Maybe<EmailDataType>;
  failedReason?: Maybe<FailedReasonType>;
  flowBotQuickReply?: Maybe<Array<Maybe<FlowBotQuickReplyType>>>;
  flowBotQuickReplyButtonsRequired?: Maybe<Scalars['Boolean']['output']>;
  flowBotQuickReplyResponseId?: Maybe<Scalars['String']['output']>;
  informativeButtons?: Maybe<InformativeButtonsType>;
  isViewOnce?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<Maybe<Scalars['Media']['output']>>>;
  messageReactions?: Maybe<Array<MessageReactionType>>;
  messageType?: Maybe<MessageType>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<ConversationStatusEnum>;
  product_cards?: Maybe<Scalars['Object']['output']>;
  questionData?: Maybe<QuestionDataType>;
  quotedMessage?: Maybe<QuotedMessageType>;
  reactions?: Maybe<ReactionEnum>;
  sender?: Maybe<SenderData>;
  senderType?: Maybe<SenderType>;
  subject?: Maybe<Scalars['String']['output']>;
  surveyData?: Maybe<SurveyDataForLivechat>;
  template_cards?: Maybe<Scalars['Object']['output']>;
};

export enum MessageType {
  Analysis = 'ANALYSIS',
  AssignToAgentTimeout = 'ASSIGN_TO_AGENT_TIMEOUT',
  BroadcastMessage = 'BROADCAST_MESSAGE',
  BulkMessage = 'BULK_MESSAGE',
  CallLog = 'CALL_LOG',
  CatalogOrder = 'CATALOG_ORDER',
  ClosingNote = 'CLOSING_NOTE',
  Comment = 'COMMENT',
  ContactInfo = 'CONTACT_INFO',
  Email = 'EMAIL',
  EmbeddedMessage = 'EMBEDDED_MESSAGE',
  FlowBotCatalogMessage = 'FLOW_BOT_CATALOG_MESSAGE',
  FlowBotInformativeMessage = 'FLOW_BOT_INFORMATIVE_MESSAGE',
  FlowBotListMessage = 'FLOW_BOT_LIST_MESSAGE',
  FlowBotQuickReply = 'FLOW_BOT_QUICK_REPLY',
  Form = 'FORM',
  ForwardCallTimeout = 'FORWARD_CALL_TIMEOUT',
  IvrDigits = 'IVR_DIGITS',
  IvrTimeout = 'IVR_TIMEOUT',
  Log = 'LOG',
  Note = 'NOTE',
  PrivateReply = 'PRIVATE_REPLY',
  ProductCard = 'PRODUCT_CARD',
  Question = 'QUESTION',
  QuotedMessage = 'QUOTED_MESSAGE',
  RateUs = 'RATE_US',
  Robot = 'ROBOT',
  SurveyLog = 'SURVEY_LOG',
  SurveyMessage = 'SURVEY_MESSAGE',
  TemplateCard = 'TEMPLATE_CARD',
  TextMessage = 'TEXT_MESSAGE',
  TicketState = 'TICKET_STATE'
}

export type MessagesPages = {
  __typename?: 'MessagesPages';
  docs?: Maybe<Array<Maybe<Message>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type MessagesResponse = {
  __typename?: 'MessagesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MessagesPages>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaAdAccountType = {
  __typename?: 'MetaAdAccountType';
  accountStatus?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MetaAdCatalogType = {
  __typename?: 'MetaAdCatalogType';
  adName?: Maybe<Scalars['String']['output']>;
  adsetName?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  effectiveStatus?: Maybe<Scalars['String']['output']>;
};

export type MetaAdClickType = {
  __typename?: 'MetaAdClickType';
  _id?: Maybe<Scalars['ID']['output']>;
  adId?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  catalog?: Maybe<MetaAdCatalogType>;
  channelType?: Maybe<ChannelType>;
  clickedAt?: Maybe<Scalars['Date']['output']>;
  conversationEvent?: Maybe<Scalars['String']['output']>;
  hasClickId?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type MetaAdsAdset = {
  __typename?: 'MetaAdsAdset';
  adsetId?: Maybe<Scalars['String']['output']>;
  adsetName?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
};

export type MetaAdsAdsets = {
  __typename?: 'MetaAdsAdsets';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<MetaAdsAdset>>>;
};

export type MetaAdsAdsetsInput = {
  adsetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAdsAdsetsResponse = {
  __typename?: 'MetaAdsAdsetsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MetaAdsAdsets>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaAdsAuthUrlResponse = {
  __typename?: 'MetaAdsAuthUrlResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaAdsCampaign = {
  __typename?: 'MetaAdsCampaign';
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
};

export type MetaAdsCampaigns = {
  __typename?: 'MetaAdsCampaigns';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<MetaAdsCampaign>>>;
};

export type MetaAdsCampaignsInput = {
  campaignIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAdsCampaignsResponse = {
  __typename?: 'MetaAdsCampaignsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MetaAdsCampaigns>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaAdsCustomerInput = {
  customerId: Scalars['ID']['input'];
};

export type MetaAdsSearch = {
  __typename?: 'MetaAdsSearch';
  failedAccountCount?: Maybe<Scalars['Int']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  isTruncated?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<MetaAdsSearchAd>>>;
  scannedAccountCount?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<Array<Maybe<MetaAdsSearchAd>>>;
};

export type MetaAdsSearchAd = {
  __typename?: 'MetaAdsSearchAd';
  adAccountId?: Maybe<Scalars['String']['output']>;
  adAccountName?: Maybe<Scalars['String']['output']>;
  adId?: Maybe<Scalars['String']['output']>;
  adName?: Maybe<Scalars['String']['output']>;
  adsetId?: Maybe<Scalars['String']['output']>;
  adsetName?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  destinationType?: Maybe<Scalars['String']['output']>;
  effectiveStatus?: Maybe<Scalars['String']['output']>;
  matchesChannel?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaAdsSearchResponse = {
  __typename?: 'MetaAdsSearchResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MetaAdsSearch>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaAssetDatasetType = {
  __typename?: 'MetaAssetDatasetType';
  datasetId?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaAssetType = {
  __typename?: 'MetaAssetType';
  accessible?: Maybe<Scalars['Boolean']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<ChannelType>;
  dataset?: Maybe<MetaAssetDatasetType>;
  name?: Maybe<Scalars['String']['output']>;
  qpienChannelIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type MetaBusinessConnectionType = {
  __typename?: 'MetaBusinessConnectionType';
  adAccounts?: Maybe<Array<Maybe<MetaAdAccountType>>>;
  connectedAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  grantedScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  lastError?: Maybe<MetaConnectionErrorType>;
  metaUserId?: Maybe<Scalars['String']['output']>;
  metaUserName?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
};

export type MetaBusinessOverview = {
  __typename?: 'MetaBusinessOverview';
  assets?: Maybe<Array<Maybe<MetaAssetType>>>;
  connection?: Maybe<MetaBusinessConnectionType>;
  missingScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MetaBusinessOverviewResponse = {
  __typename?: 'MetaBusinessOverviewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MetaBusinessOverview>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaConnectionErrorType = {
  __typename?: 'MetaConnectionErrorType';
  at?: Maybe<Scalars['Date']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MetaConversionErrorType = {
  __typename?: 'MetaConversionErrorType';
  code?: Maybe<Scalars['Int']['output']>;
  fbtraceId?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  subcode?: Maybe<Scalars['Int']['output']>;
};

export type MetaConversionEventType = {
  __typename?: 'MetaConversionEventType';
  _id?: Maybe<Scalars['ID']['output']>;
  adReferral?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  error?: Maybe<MetaConversionErrorType>;
  eventName?: Maybe<Scalars['String']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type MetaConversionOutcome = {
  __typename?: 'MetaConversionOutcome';
  eventId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MetaConversionOutcomeResponse = {
  __typename?: 'MetaConversionOutcomeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MetaConversionOutcome>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetaWhatsAppBusinessTemplate = {
  __typename?: 'MetaWhatsAppBusinessTemplate';
  _id: Scalars['ID']['output'];
  appId: Scalars['String']['output'];
  appToken?: Maybe<Scalars['String']['output']>;
  buttons: Array<MetaWhatsAppBusinessTemplateButton>;
  cards?: Maybe<Array<MetaWhatsAppBusinessTemplateCard>>;
  category: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdAtTemplate: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  eCommerceCart?: Maybe<Scalars['Boolean']['output']>;
  enableExpirationTime?: Maybe<Scalars['Boolean']['output']>;
  enableSecurityRecommendation?: Maybe<Scalars['Boolean']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  exampleMedia?: Maybe<Scalars['String']['output']>;
  expirationTime?: Maybe<Scalars['Number']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  isCreatedOnQpien: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  metaNamedParams?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  qpienFields: Array<MetaWhatsAppBusinessTemplateQpienField>;
  reason?: Maybe<Scalars['String']['output']>;
  sampleMedia?: Maybe<MetaWhatsAppBusinessTemplateSampleMedia>;
  status: Scalars['String']['output'];
  survey?: Maybe<Scalars['ID']['output']>;
  templateId: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
  vertical?: Maybe<Scalars['String']['output']>;
};

export type MetaWhatsAppBusinessTemplateButton = {
  __typename?: 'MetaWhatsAppBusinessTemplateButton';
  destinationUrl?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Array<Scalars['String']['output']>>;
  phone_number?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  trackClicks?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlVariable?: Maybe<TemplateButtonUrlVariable>;
};

export type MetaWhatsAppBusinessTemplateCard = {
  __typename?: 'MetaWhatsAppBusinessTemplateCard';
  body?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<MetaWhatsAppBusinessTemplateButton>>;
  sampleMedia?: Maybe<MetaWhatsAppBusinessTemplateSampleMedia>;
};

export type MetaWhatsAppBusinessTemplateQpienField = {
  __typename?: 'MetaWhatsAppBusinessTemplateQpienField';
  exampleData: Scalars['String']['output'];
  key: Scalars['Int']['output'];
  ref: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MetaWhatsAppBusinessTemplateSampleMedia = {
  __typename?: 'MetaWhatsAppBusinessTemplateSampleMedia';
  file: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MigrationRun = {
  __typename?: 'MigrationRun';
  _id: Scalars['ID']['output'];
  countsAfter?: Maybe<Scalars['String']['output']>;
  countsBefore?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  heartbeatAt?: Maybe<Scalars['Date']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['Date']['output'];
  status: MigrationRunStatus;
  /** Null while RUNNING. */
  succeeded?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

export type MigrationRunListResponse = {
  __typename?: 'MigrationRunListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<MigrationRun>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MigrationRunResponse = {
  __typename?: 'MigrationRunResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MigrationRunResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MigrationRunResult = {
  __typename?: 'MigrationRunResult';
  after?: Maybe<InspectCollectionResult>;
  before?: Maybe<InspectCollectionResult>;
  run: MigrationRun;
};

export type MigrationRunStartResponse = {
  __typename?: 'MigrationRunStartResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MigrationRun>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum MigrationRunStatus {
  Failed = 'FAILED',
  /** Its process died mid-run (a deploy, a crash); running it again resumes it. */
  Interrupted = 'INTERRUPTED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type MiniPlatformData = {
  __typename?: 'MiniPlatformData';
  _id?: Maybe<Scalars['ID']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MiniTemplateData = {
  __typename?: 'MiniTemplateData';
  _id?: Maybe<Scalars['ID']['output']>;
  buttons?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  category?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qpienFields?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
};

export type MobileAppVersionCheck = {
  __typename?: 'MobileAppVersionCheck';
  currentVersion?: Maybe<Scalars['String']['output']>;
  latestVersion?: Maybe<Scalars['String']['output']>;
  minSupportedVersion?: Maybe<Scalars['String']['output']>;
  platform: MobilePlatform;
  releaseNotes?: Maybe<MobileReleaseNotes>;
  storeUrl?: Maybe<Scalars['String']['output']>;
  updateType: MobileUpdateType;
};

export type MobileAppVersionCheckResponse = {
  __typename?: 'MobileAppVersionCheckResponse';
  data?: Maybe<MobileAppVersionCheck>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileAppVersionConfig = {
  __typename?: 'MobileAppVersionConfig';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  latestVersion?: Maybe<Scalars['String']['output']>;
  minSupportedVersion?: Maybe<Scalars['String']['output']>;
  platform: MobilePlatform;
  releaseNotes?: Maybe<MobileReleaseNotes>;
  storeUrl?: Maybe<Scalars['String']['output']>;
  updateType?: Maybe<MobileUpdateType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MobileAppVersionConfigListResponse = {
  __typename?: 'MobileAppVersionConfigListResponse';
  data?: Maybe<Array<Maybe<MobileAppVersionConfig>>>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileAppVersionConfigResponse = {
  __typename?: 'MobileAppVersionConfigResponse';
  data?: Maybe<MobileAppVersionConfig>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum MobilePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export enum MobilePushNotificationsEnum {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  IfNotActiveOnWeb = 'IfNotActiveOnWeb'
}

export type MobileReleaseNote = {
  __typename?: 'MobileReleaseNote';
  body?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MobileReleaseNoteInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MobileReleaseNotes = {
  __typename?: 'MobileReleaseNotes';
  ar?: Maybe<MobileReleaseNote>;
  en?: Maybe<MobileReleaseNote>;
  tr?: Maybe<MobileReleaseNote>;
};

export type MobileReleaseNotesInput = {
  ar?: InputMaybe<MobileReleaseNoteInput>;
  en?: InputMaybe<MobileReleaseNoteInput>;
  tr?: InputMaybe<MobileReleaseNoteInput>;
};

export enum MobileUpdateType {
  Forced = 'FORCED',
  None = 'NONE',
  Optional = 'OPTIONAL'
}

export type ModuleField = {
  __typename?: 'ModuleField';
  deals?: Maybe<DealFields>;
  leads?: Maybe<LeadFields>;
  tasks?: Maybe<TaskFields>;
};

export type MoveTableInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  targetFolderId: Scalars['ID']['input'];
};

export enum MsgTypeForReaction {
  Comment = 'COMMENT',
  Message = 'MESSAGE'
}

export type Mutation = {
  __typename?: 'Mutation';
  addCity: StateProvinceCityResponse;
  addCountry: CountryResponse;
  addCouponCodeToCustomer: CustomerProductResponse;
  addFlowBlock: AddFlowBlockResponse;
  addMoreUserAddOn: CustomerProductAddOnResponse;
  addStateProvince: StateProvinceCityResponse;
  addTagToPersons?: Maybe<BooleanResponse>;
  addTrackingDomain: TrackingDomainResponse;
  adminSignIn: UserTokenResponse;
  archiveAnnouncement?: Maybe<ChangelogResponse>;
  archiveCampaign?: Maybe<CampaignResponse>;
  archiveCustomerPerson: ArchiveStatusResponse;
  archiveSlaPolicy: SlaPolicyResponse;
  archiveTeamChat: TeamConversationResponse;
  archiveTopic: TopicResponse;
  assignChannelOwner: OPlatformResponse;
  blockReplaceIndex: BlockReplaceIndexResponse;
  bulkTagCampaignContacts: BulkTagCampaignContactsResponse;
  bulkUpdateCollageProducts: BulkUpdateCollageProductsResponse;
  buyCustomerProductAddOn: CustomerProductAddOnResponse;
  cancelCampaign?: Maybe<CampaignResponse>;
  cancelCustomerProductAddOn: CustomerProductAddOnResponse;
  cancelHumanReplyLearningJob: HumanReplyLearningJobResponse;
  cancelOperatorQuery: OperatorBlockResponse;
  cancelSpecialOfferPackage: ProductResponse;
  changeAccountStatus: CustomerResponse;
  changeCustomerPersonPassword: CustomerPersonResponse;
  changeCustomerPersonPhoto: OCustomerPersonStringResponse;
  changeCustomerPhoto: OCustomerPhotoResponse;
  changeCustomerProduct: CustomerProductResponse;
  changePersonOwner: BooleanResponse;
  checkDomainStatus: DomainResponse;
  checkECommerceCustomerAddresses: OeCommerceCustomerResponse;
  checkSmtpDomainStatus: BooleanResponse;
  checkTrackingDomain: TrackingDomainResponse;
  clearChannelOwner: OPlatformResponse;
  confirmAccount: CustomerResponse;
  /** Binds a connected store to the E-commerce AI role. Pass a null store to unbind. */
  connectAiStore: AiProfileResponse;
  connectECommercePlatform?: Maybe<OPlatformResponse>;
  connectMetaBusiness: MetaBusinessOverviewResponse;
  convertMediaLinkToLink: ConvertedFileResponse;
  createAction: ActionResponse;
  createAddOn: AddOnResponse;
  createAiGuidance: AiGuidanceResponse;
  createAiKnowledgeSource: AiKnowledgeSourceResponse;
  createAiSizeChart: AiSizeChartResponse;
  createAiSizeChartGroup: AiSizeChartGroupResponse;
  createAiTtsPreview: AiTtsPreviewResponse;
  createAnnouncement?: Maybe<ChangelogResponse>;
  createAnnouncementCategory?: Maybe<ChangelogCategoryResponse>;
  createAskQuestionEvalMock: AskQuestionEvalMockResponse;
  createAuthentication: AuthenticationResponse;
  createBulkCollageSharing: CollageBulkSharingResponse;
  createBulkSharing: BulkSharingResponse;
  createBusinessHoursSchedule: BusinessHoursScheduleResponse;
  createCPersonRole: CPersonRoleResponse;
  createCampaign?: Maybe<CampaignResponse>;
  createCollageBarcode: CollageBarcodeResponse;
  createCollageFolder: CollageFolderResponse;
  createCollageProduct: CollageProductResponse;
  createCollageSettings: CollageSettingsResponse;
  createCollageSharing: CollageSharingResponse;
  createCollageTemplate: CollageTemplateResponse;
  createCollageTemplateSet: CreateCollageTemplateSetResponse;
  createConversationSidebar: ConvSidebarResponse;
  createConversationView: ConvViewResponse;
  createCouponCode: OCouponCodeResponse;
  createCustomExtension: OCustomExtensionResponse;
  createCustomField: CustomFieldResponse;
  createCustomer: CustomerResponse;
  createCustomerBillingAddresses: CustomerBillingAddressesOutput;
  createCustomerBillingContacts: CustomerBillingContactsResponse;
  createCustomerOnboardingInfo: CustomerOnboardingInfoOutput;
  createCustomerPaymentCard: CustomerPaymentCardOutput;
  createCustomerPersons: CustomerPersonsResponse;
  createDefaultCPersonRoles: DefaultCPersonRolesResponse;
  createDefaultTicket: TicketDefaultResponse;
  createECommerceCustomer: OeCommerceCustomerResponse;
  createECommerceIntegration: CreateECommerceIntegrationOutput;
  createECommerceIntegrationCustomer?: Maybe<CreateECommerceIntegrationCustomerOutput>;
  createECommerceIntegrationCustomerAddress: CreateECommerceIntegrationCustomerAddressOutput;
  createECommerceIntegrationOrder: CreateECommerceIntegrationOrderOutput;
  createECommerceOrder: OeCommerceOrderResponse;
  createECommercePlatform?: Maybe<OPlatformResponse>;
  createECommerceRules?: Maybe<ECommerceRulesResponse>;
  createExternalApi: CreatedExternalApiResponse;
  createFlowBot: CreateFlowBotResponse;
  createFlowNode: CreateFlowNodeResponse;
  createFreeTrialPackage: FreeTrialResponse;
  createInboundWebhook: InboundWebhookResponse;
  createIntegration: IntegrationResponse;
  createMessage: MessageResponse;
  createNewConversation: ConversationResponse;
  createPassword: CreateMailResponse;
  createPerson: PersonResponse;
  createPersonGroup: CreatePGroupResponse;
  createPersonNote: PersonNoteResponse;
  createPlatform: OPlatformResponse;
  createQpienShopCustomer: CreateQpienShopCustomerResponse;
  createQpienShopCustomerAddress: CreateQpienShopCustomerAddressResponse;
  createQpienShopOrder: CreateQpienShopOrderResponse;
  createQpienShopStore: CreateQpienShopStoreResponse;
  createQuickAnswer: QuickAnswerResponse;
  createRandomMessage: OCustomerPersonStringResponse;
  createRecord: IntegrationInsertedRecordResponse;
  createRecordNote: IntegrationRecordNoteResponse;
  createReport: ReportResponse;
  createReportWidget: ReportWidgetResponse;
  createReportWidgetMetric: ReportWidgetMetricResponse;
  createScheduleMessage: DelayedActionResponse;
  createSkill: SkillResponse;
  createSlaPolicy: SlaPolicyResponse;
  createSnooze: DelayedActionResponse;
  createSurveyHistory: SurveyHistoryResponse;
  createSurveys: SurveyResponse;
  createTable: TableResponse;
  createTableField: TableFieldResponse;
  createTableFolder: TableFolderResponse;
  createTableRecord: TableRecordResponse;
  createTableRecordActivity: TableRecordActivityResponse;
  createTableView: TableViewResponse;
  createTag: TagResponse;
  createTask: TaskResponse;
  createTaskComment: TaskCommentResponse;
  createTaskLog: TaskLogResponse;
  createTeamGroupChat: TeamConversationResponse;
  createTeamPrivateChat: TeamConversationResponse;
  createTeams?: Maybe<SingleTeamsResponse>;
  createTemplate: WaBaTemplateDataResponse;
  createTicketState: TicketStateResponse;
  createTicketType: TicketTypeResponse;
  createTopics: TopicsResponse;
  createUser: UserResponse;
  createWabaTemplate: WabaTemplateResultResponse;
  createWebhook: CreatedWebhookResponse;
  customerPersonGoogleAuth: GoogleAuthResponse;
  customerPersonLogOut: CustomerPersonResponse;
  customerPersonSignIn: CustomerPersonTokenResponse;
  deleteAction: ActionResponse;
  deleteAddOn: AddOnResponse;
  deleteAiGuidance: AiGuidanceResponse;
  deleteAiHelpArticle: AiHelpDeleteResponse;
  deleteAiKnowledgeSource: AiKnowledgeSourceDeleteResponse;
  deleteAiKnowledgeSourceContent: AiKnowledgeSourceContentDeleteResponse;
  deleteAiMessagesByDateRange: DeleteResultResponse;
  deleteAiSizeChart: AiSizeChartDeleteResponse;
  /** Charts that named only this group are switched off; `data` is how many. */
  deleteAiSizeChartGroup: AiSizeChartGroupDeleteResponse;
  deleteAiSuggestions: AiSuggestionDeleteResponse;
  deleteAllAskQuestionEvalRuns: AskQuestionEvalDeleteResponse;
  deleteAnnouncement?: Maybe<ChangelogResponse>;
  deleteAnnouncementCategory?: Maybe<ChangelogCategoryResponse>;
  deleteAskQuestionEvalMock: AskQuestionEvalMockDeleteResponse;
  deleteAuthentication: AuthenticationResponse;
  deleteBusinessHoursSchedules: DeleteBusinessHoursSchedulesResponse;
  deleteCPersonRole: CPersonRoleResponse;
  deleteCallAdminLogs: DeleteCallAdminLogsResponse;
  deleteCampaign?: Maybe<CampaignResponse>;
  deleteCollageBarcode: CollageBarcodeResponse;
  deleteCollageFolder: DeletedCollageFolderResponse;
  deleteCollageProduct: CollageProductResponse;
  deleteCollageSettings: CollageSettingsResponse;
  deleteCollageSharing: CollageSharingResponse;
  deleteCollageTemplate: CollageTemplateResponse;
  deleteCommentOnPlatform: DeleteCommentTypeResponse;
  deleteConversationSidebar: ConvSidebarResponse;
  deleteConversationView: ConvViewResponse;
  deleteCouponCode: OCouponCodeResponse;
  deleteCustomExtension: CustomExtensionResponse;
  deleteCustomer: DeletedCustomerResponse;
  deleteCustomerPerson: CustomerPersonResponse;
  deleteCustomerProductAddOn: CustomerProductAddOnResponse;
  deleteDelayedAction: DelayedActionResponse;
  deleteECommerceIntegration: DeleteECommerceIntegrationOutput;
  deleteECommercePlatform: OPlatformResponse;
  deleteECommerceRules?: Maybe<ECommerceRulesResponse>;
  deleteEmailAdminLogs: DeleteEmailAdminLogsResponse;
  deleteExternalApi: ExternalApiResponse;
  deleteFlowBot: DeleteFlowBotResponse;
  deleteFlowNode: DeleteFlowNodeResponse;
  deleteInboundWebhook: InboundWebhookResponse;
  deleteIntegration: IntegrationResponse;
  deleteManyAskQuestionEvalMocks: AskQuestionEvalMockDeleteResponse;
  deleteManyAskQuestionEvalRuns: AskQuestionEvalDeleteResponse;
  deleteMultiplePerson?: Maybe<DeletePersonResponse>;
  deleteOperatorJob: OperatorJsonResponse;
  deleteOperatorReport: OperatorJsonResponse;
  deletePersonNote: BooleanResponse;
  deletePlatform: OPlatformResponse;
  deleteQpienShopStore: DeleteQpienShopStoreResponse;
  deleteQuickAnswer: QuickAnswerResponse;
  deleteRandomMessageTestContact: BooleanResponse;
  deleteReport: ReportBooleanResponse;
  deleteReportWidget: ReportWidgetBooleanResponse;
  deleteReportWidgetMetric: ReportWidgetBooleanResponse;
  deleteSkill: SkillResponse;
  deleteSurveys: SurveyResponse;
  deleteTable: TableBooleanResponse;
  deleteTableField: TableBooleanResponse;
  deleteTableFolder: TableBooleanResponse;
  deleteTableRecord: TableBooleanResponse;
  deleteTableRecords: TableBooleanResponse;
  deleteTableView: TableBooleanResponse;
  deleteTag: TagResponse;
  deleteTaskById: TaskResponse;
  deleteTaskBySourceId: TaskResponse;
  deleteTaskComment: TaskCommentResponse;
  deleteTeamGroupChat: TeamChatGenericResponse;
  deleteTeamMessage: TeamMessageResponse;
  deleteTeams?: Maybe<SingleTeamsResponse>;
  deleteTemplate: WaBaTemplateDataResponse;
  deleteTestConversation: DeleteTestConversationResponse;
  deleteTopic: TopicResponse;
  deleteUser: UserResponse;
  deleteWabaTemplate: WabaTemplateResultResponse;
  deleteWebhook: WebhookResponse;
  destroyClient: OPlatformResponse;
  disableAiEngine: AiEngineRoutingResponse;
  disconnectMetaBusiness: MetaBusinessOverviewResponse;
  dismissOperatorInsight: OperatorJsonResponse;
  doCustomPlatformMutation: OPlatformResponse;
  duplicateCampaign?: Maybe<CampaignResponse>;
  duplicateFlowBot: DuplicateFlowBotResponse;
  duplicateReport: ReportResponse;
  duplicateTable: TableResponse;
  editTeamMessage: TeamMessageResponse;
  editWabaTemplate: WabaTemplateResultResponse;
  enableAiEngine: AiEngineRoutingResponse;
  enableTwoFactorAuthentication: TwoFactorAuthenticationResponse;
  enqueueAiEvalMessage: AiEvalMessageReceiptResponse;
  exportPersonExcelSendToMail: BooleanResponse;
  /**
   * Queues an .xlsx export of the report with its saved filters; the file arrives as an
   * `exportReport` notification carrying `metadata.fileUrl`.
   */
  exportReport: ExportReportResponse;
  exportTableRecords: ExportTableRecordsResponse;
  externalCreateContact: ExternalCreatedContactResponse;
  externalCreateMessage: ExternalCreatedMessageResponse;
  externalDeleteContact: ExternalDeletedContactResponse;
  externalSendMessage: ExternalSentMessageResponse;
  externalUpdateContact: ExternalUpdatedContactResponse;
  externalUpdateConversation: ExternalUpdatedConversationResponse;
  finalizeBulkSharing: BulkSharingResponse;
  flagCampaignForSchedule?: Maybe<OSendCampaignResponse>;
  forgotMyPassword: OForgotPasswordResponse;
  generateAiAssistantContent: GenerateAiAssistantContentResponse;
  generateClosingTopicContent: GenerateClosingTopicContentResponse;
  generateOAuthToken: GeneratedOAuthTokenResponse;
  generateSkillDraft: GenerateSkillDraftResponse;
  getCustomerSessionByAdmin?: Maybe<GetCustomerSessionResponse>;
  importAiHelpPdf: AiHelpArticleResponse;
  importPersons: ImportPersonsResponse;
  importRecordsToTable: ImportRecordsToTableResponse;
  /** Creates the customer's profile for this role if it has none, and opens that role. */
  initAiRole: AiProfileResponse;
  invalidateLiveChatWidgetCache?: Maybe<LiveChatWidgetInvalidationResponse>;
  joinConversation: JoinConversationResponse;
  leaveTeamGroupChat: TeamConversationResponse;
  linkECommerceCustomer: OeCommerceCustomerResponse;
  linkMetaDataset: MetaBusinessOverviewResponse;
  liveChatReceiveMessage: LiveChatMessageResponse;
  makePlatformReaction: MakePlatformReactionResponse;
  markAnnouncementRead?: Maybe<ChangelogReadResponse>;
  markCPersonNotificationsAsRead: CPersonNotificationMarkReadResponse;
  markCPersonNotificationsAsUnRead: CPersonNotificationMarkUnreadResponse;
  markOnboardingStep: CustomerResponse;
  markTeamChatRead: TeamConversationResponse;
  mergeContacts: MergedContactResponse;
  mergeConversations: MergedConversationResponse;
  moveTable: TableResponse;
  muteTeamChat: TeamConversationResponse;
  oneTimesUpdateMutation?: Maybe<OPlatformResponse>;
  optimizeAiGuidanceContent: OptimizeAiGuidanceContentResponse;
  pauseCampaign?: Maybe<CampaignResponse>;
  paymentFromOtherChannel: CustomerProductResponse;
  pinAiEngine: AiEngineRoutingResponse;
  previewImportPersons: ImportPersonsPreviewResponse;
  publishAnnouncement?: Maybe<ChangelogResponse>;
  publishLiveChatWidgetRelease?: Maybe<LiveChatWidgetReleaseResponse>;
  publishSkill: SkillResponse;
  reSendMessage: OMessageResponse;
  reactTeamMessage: TeamMessageResponse;
  reactToAnnouncement?: Maybe<ReactionResponse>;
  reactToMessage: MessageResponse;
  readMessage: MessageResponse;
  reembedKnowledgeSourcesToContextualRag: ReembedKnowledgeSourcesToContextualRagResponse;
  refacTorPChannelsAndConvs?: Maybe<OPlatformResponse>;
  refactorConversation?: Maybe<BooleanResponse>;
  refreshWabaTemplates: WabaTemplateResultResponse;
  regenerateFlowWebhookUrl: FlowWebhookTriggerResponse;
  reindexAiHelpArticle: AiHelpArticleResponse;
  removeBlockFromNode: RemoveBlockFromNodeResponse;
  removeBlocksFromNode: RemoveBlockFromNodeResponse;
  removeCampaign?: Maybe<CampaignResponse>;
  removeCouponCodeFromCustomer: CustomerProductResponse;
  removeCustomerBillingContacts: CustomerBillingContactsResponse;
  removeCustomerPaymentCard: CustomerPaymentCardOutput;
  removeDomainFromEmail: RemoveDomainResponse;
  removePersonGroup: PersonGroupResponse;
  removeTrackingDomain: TrackingDomainResponse;
  renameCampaign?: Maybe<CampaignResponse>;
  renameOperatorReport: OperatorJsonResponse;
  reorderReportWidgetMetrics: ReportWidgetBooleanResponse;
  reorderReports: ReportBooleanResponse;
  reorderTableFields: TableBooleanResponse;
  reorderTableFolders: TableBooleanResponse;
  reorderTables: TableBooleanResponse;
  rerunOperatorReport: OperatorTurnResponse;
  resendCreatePasswordMail: ResendCreatePasswordMailResponse;
  resendVerificationEmail: EmailResponse;
  resetMyPassword: OCustomerPersonResponse;
  resolveAiHelpGaps: AiHelpResolveGapsResponse;
  resumeCampaign?: Maybe<CampaignResponse>;
  retryFailedCampaignRecipients?: Maybe<RetryFailedCampaignRecipientsResponse>;
  retryPayment: CustomerProductResponse;
  rollbackAiEngineRouting: AiEngineRoutingResponse;
  rollbackLiveChatWidgetRelease?: Maybe<LiveChatWidgetReleaseResponse>;
  runAskQuestionEvalSuite: AskQuestionEvalRunResponse;
  /**
   * The same run, awaited in the request. Kept for panel builds that predate startMigration; a
   * large collection outlasts the load balancer's timeout here.
   */
  runMigration: MigrationRunResponse;
  runOperatorJobNow: OperatorTurnResponse;
  runOperatorQuery: OperatorTurnResponse;
  saveAiHelpArticle: AiHelpArticleResponse;
  saveConversationViewPreference: ConversationViewPreferenceResponse;
  saveOperatorReport: OperatorJsonResponse;
  saveReportWidgetLayout: ReportWidgetResponse;
  scanModuleForIntegration: IntegrationResponse;
  scheduleAnnouncement?: Maybe<ChangelogResponse>;
  scheduleCampaign?: Maybe<CampaignResponse>;
  searchProductByImage: OeCommerceCustomerResponse;
  /** Records the role the AI area was last opened on. */
  selectAiRole: AiProfileResponse;
  sendCampaign?: Maybe<SendCampaignResponseStatus>;
  sendCampaignTestMessage?: Maybe<CampaignTestSendResponse>;
  sendCampaignWinner?: Maybe<CampaignResponse>;
  sendMetaTestEvent: MetaConversionOutcomeResponse;
  sendOperatorMessage: OperatorTurnResponse;
  sendScheduledMessage: DelayedActionResponse;
  sendSpecialOfferPackage: ProductResponse;
  sendTeamMessage: TeamMessageResponse;
  setAiEngineDefault: AiEngineRoutingResponse;
  setAiSizeChartEnabled: AiSizeChartResponse;
  setCampaignLinksDisabled: AdminCampaignLinkToggleResponse;
  setCampaignTags?: Maybe<CampaignResponse>;
  setConversationTyping: BooleanResponse;
  setCustomerLinksDisabled: AdminCampaignLinksResponse;
  setCustomerPaymentCardAsDefault: CustomerPaymentCardOutput;
  setDefaultTrackingDomain: TrackingDomainSettingsResponse;
  setMetaDatasetEnabled: MetaBusinessOverviewResponse;
  setOperatorAccess: OperatorMembersResponse;
  setSkillStatus: SkillResponse;
  setUpdateNotification: UpdateNotificationResponse;
  /** Development servers only (DEVELOPMENT_MODE=dev_local): replays an ad-click webhook. */
  simulateMetaAdClick: SimulatedMetaAdClickResponse;
  simulateSkill: SkillSimulationResponse;
  startCampaign?: Maybe<CampaignResponse>;
  startConversationSearchExport: StartConversationSearchExportResponse;
  /**
   * Starts a migration and returns its RUNNING row at once; the work continues on the server and
   * the row is polled through getMigrationLatestRuns. One run at a time per environment — a second
   * start while one is live fails with MIGRATION_ALREADY_RUNNING. When `probe` is sent the server
   * runs it either side and stores both, so the row proves the effect instead of asserting it.
   */
  startMigration: MigrationRunStartResponse;
  startReembedKnowledgeSourcesToContextualRag: ReembedKnowledgeSourcesToContextualRagJobResponse;
  subscribeToMobilNotifications: SubscribeResponse;
  subscribeToWebNotifications: SubscribeResponse;
  /**
   * Brings the product image index in line with the store — new pictures embedded, withdrawn ones
   * removed, unchanged ones untouched — without switching "use product images" off and on.
   * Refused while a run is still going or while the setting is off.
   */
  syncAiProductImageIndex: AiProductImageIndexResponse;
  testAiAnalysis: TestAiAnalysisResponse;
  testAiWithConversation: TestAiWithConversationResponse;
  testWebhook: TestWebhookResponse;
  testZohoCreateRecord: ZohoTestRecordResponse;
  testZohoFlowAction: ZohoTestRecordResponse;
  trainModel: OeCommerceCustomerResponse;
  transferConversations: UpdatedConversationsResponse;
  transferConversationsToTeam: UpdatedConversationsResponse;
  translateAnnouncement?: Maybe<ChangelogTranslateResponse>;
  translateInboxMessages: TranslateInboxMessagesResponse;
  triggerReusableFlow: TriggerReusableFlowResponse;
  unArchiveCustomerPerson: ArchiveStatusResponse;
  unArchiveTopic: TopicResponse;
  unSnoozeConversation: DelayedActionResponse;
  unSubscribeToMobilNotifications: SubscribeResponse;
  unSubscribeToWebNotifications: SubscribeResponse;
  unarchiveAnnouncement?: Maybe<ChangelogResponse>;
  unarchiveCampaign?: Maybe<CampaignResponse>;
  unarchiveTeamChat: TeamConversationResponse;
  undoOperatorAction: OperatorTurnResponse;
  unlinkECommerceCustomer: OeCommerceCustomerResponse;
  unpinAiEngine: AiEngineRoutingResponse;
  unpublishAnnouncement?: Maybe<ChangelogResponse>;
  unscheduleCampaign?: Maybe<CampaignResponse>;
  updateAction: ActionResponse;
  updateAddOn: AddOnResponse;
  updateAiAnalysisSettings: AiAnalysisSettingsResponse;
  updateAiAssistant: AiAssistantResponse;
  updateAiGuidance: AiGuidanceResponse;
  updateAiHelpArticle: AiHelpArticleResponse;
  updateAiKnowledgeSourceChannels: AiKnowledgeSourceResponse;
  /**
   * How the storefront AI Product FAQs block looks. Served to the widget with the questions —
   * see modules/AiProductFaqs.
   */
  updateAiProductFaqDesign: AiProfileResponse;
  updateAiProfile: AiProfileResponse;
  updateAiShoppingAssistant: AiProfileResponse;
  /** Replaces the whole chart with `data`. */
  updateAiSizeChart: AiSizeChartResponse;
  updateAiSizeChartGroup: AiSizeChartGroupResponse;
  /**
   * The tenant's own notes about a product. This is the ONLY product field the panel writes —
   * everything else comes from the integration and is read-only here.
   */
  updateAiStoreProductInfo: AiStoreProductResponse;
  updateAiTtsModel: AiTtsModelSettingsResponse;
  updateAnnouncement?: Maybe<ChangelogResponse>;
  updateAnnouncementCategory?: Maybe<ChangelogCategoryResponse>;
  updateAskQuestionEvalMock: AskQuestionEvalMockResponse;
  updateAuthentication: AuthenticationResponse;
  updateAutoFormalizeInvoices: PreferenceResponse;
  updateBlock: UpdateBlockResponse;
  updateBlockField: UpdateBlockResponse;
  updateBusinessHoursSchedule: BusinessHoursScheduleResponse;
  updateCPersonRole: CPersonRoleResponse;
  updateCPersonStatus: CustomerPersonResponse;
  updateCProductCharge: CustomerProductResponse;
  updateCampaign?: Maybe<CampaignResponse>;
  updateChangelogSettings?: Maybe<ChangelogSettingsResponse>;
  updateChatsAndPersonsByDateDbTransfer?: Maybe<OPlatformResponse>;
  updateCollageBarcode: CollageBarcodeResponse;
  updateCollageFolder: CollageFolderResponse;
  updateCollageProduct: CollageProductResponse;
  updateCollageSettings: CollageSettingsResponse;
  updateCollageSharing: CollageSharingResponse;
  updateCollageTemplate: CollageTemplateResponse;
  updateConvTags: UpdatedConversationsResponse;
  updateConversationDetailsSettings: AppSettingsResponse;
  updateConversationSettings: AppSettingsResponse;
  updateConversationSidebar: ConvSidebarResponse;
  updateConversationView: ConvViewResponse;
  updateConversations: UpdatedConversationsResponse;
  updateCustomExtension: CustomExtensionResponse;
  updateCustomField: CustomFieldResponse;
  updateCustomFieldStatus: CustomFieldResponse;
  updateCustomer: CustomerResponse;
  updateCustomerBillingAddresses: CustomerBillingAddressesOutput;
  updateCustomerBillingContacts: CustomerBillingContactsResponse;
  updateCustomerInvoice?: Maybe<UpdateCustomerInvoiceResponse>;
  updateCustomerOnboardingInfo: CustomerOnboardingInfoOutput;
  updateCustomerPaymentCard: CustomerPaymentCardOutput;
  updateCustomerPerson: CustomerPersonResponse;
  updateCustomerProduct: CustomerProductResponse;
  updateCustomerProductPlan: CustomerResponse;
  updateCustomerWorkingHour: UpdateWorkingHourOutput;
  updateDelayedAction: DelayedActionResponse;
  updateDeviceStatus: CustomerPersonResponse;
  updateDomain: DomainResponse;
  updateECommerceCustomer: OeCommerceCustomerResponse;
  updateECommerceIntegration: EIntegrationResponse;
  updateECommerceIntegrationCustomer: UpdateECommerceIntegrationCustomerOutput;
  updateECommerceIntegrationCustomerAddress: UpdateECommerceIntegrationCustomerAddressOutput;
  updateECommerceOrder: OeCommerceOrderResponse;
  updateECommercePlatform: OPlatformResponse;
  updateECommercePlatformSettings: OPlatformResponse;
  updateECommerceRules?: Maybe<ECommerceRulesResponse>;
  updateECommerceRulesStatus?: Maybe<ECommerceRulesResponse>;
  updateExternalApi: ExternalApiResponse;
  updateFlowBot: UpdateFlowBotResponse;
  updateFlowNode: UpdateFlowNodeResponse;
  updateHomeLayoutSettings: AppSettingsResponse;
  updateInboundWebhook: InboundWebhookResponse;
  updateIntegration: IntegrationResponse;
  updateIntegrationRecord: IntegrationRecordResponse;
  updateLocationData?: Maybe<LocationsResponse>;
  updateMobileAppVersionConfig?: Maybe<MobileAppVersionConfigResponse>;
  updateMyChangelogNotificationPrefs?: Maybe<ChangelogPrefsResponse>;
  updateMyProductTour: ProductTourResponse;
  updateOperatorJob: OperatorJsonResponse;
  updateOperatorPreferences: OperatorJsonResponse;
  updateOperatorQuery: OperatorBlockResponse;
  updatePerson: PersonResponse;
  updatePersonChannel: PersonChannelResponse;
  updatePersonGroup: PersonGroupResponse;
  updatePlatform: OPlatformResponse;
  updateQpienShopCustomer: UpdateQpienShopCustomerResponse;
  updateQpienShopCustomerAddress: UpdateQpienShopCustomerAddressResponse;
  updateQpienShopOrder: UpdateQpienShopOrderResponse;
  updateQuickAnswer: QuickAnswerResponse;
  updateReport: ReportResponse;
  updateReportWidget: ReportWidgetResponse;
  updateReportWidgetMetric: ReportWidgetMetricResponse;
  updateRequireAccountApproval: PreferenceResponse;
  updateSingleCustomerProfile: CustomerPersonResponse;
  updateSkillDraft: SkillResponse;
  updateSlaPolicy: SlaPolicyResponse;
  updateSpecialOfferPackage?: Maybe<ProductResponse>;
  updateSurveyHistory: SurveyHistoryResponse;
  updateSurveys: SurveyResponse;
  updateTable: TableResponse;
  updateTableField: TableFieldResponse;
  updateTableFolder: TableFolderResponse;
  updateTableRecord: TableRecordResponse;
  updateTableRecordKanbanOrder: TableRecordResponse;
  updateTableView: TableViewResponse;
  updateTag: TagResponse;
  updateTask: TaskResponse;
  updateTaskComment: TaskCommentResponse;
  updateTasks: UpdateTaskResponse;
  updateTeamChatParticipants: TeamConversationResponse;
  updateTeamGroupChat: TeamConversationResponse;
  updateTeams?: Maybe<SingleTeamsResponse>;
  updateTemplate: WaBaTemplateDataResponse;
  updateTicketState: TicketStateResponse;
  updateTicketType: TicketTypeResponse;
  updateTopic: TopicResponse;
  updateUser: UserResponse;
  updateViewFoldersSettings: AppSettingsResponse;
  updateWabaTemplate: WabaTemplateResultResponse;
  updateWebhook: WebhookResponse;
  uploadAnnouncementMedia?: Maybe<ChangelogMediaResponse>;
  uploadCampaignMedia?: Maybe<CampaignMediaResponse>;
  uploadFilesToRecord: IntegrationRecordResponse;
  uploadRecordAttachment: IntegrationUploadResponse;
  upsertAppSettings: AppSettingsResponse;
  upsertFlowWebhookTrigger: FlowWebhookTriggerResponse;
  verifyEmail: EditCPersonResponse;
  verifyTwoFactorAuthentication: VerifiedTwoFactorAuthenticationResponse;
};


export type MutationAddCityArgs = {
  data: CreateCityInput;
};


export type MutationAddCountryArgs = {
  data: CreateCountryInput;
};


export type MutationAddCouponCodeToCustomerArgs = {
  data: AddCouponCodeToCustomerInput;
};


export type MutationAddFlowBlockArgs = {
  input: AddFlowBlockInput;
};


export type MutationAddMoreUserAddOnArgs = {
  data: UserAddOnInput;
};


export type MutationAddStateProvinceArgs = {
  data: CreateStateProvinceInput;
};


export type MutationAddTagToPersonsArgs = {
  data: AddTagPersonInput;
};


export type MutationAddTrackingDomainArgs = {
  input: AddTrackingDomainInput;
};


export type MutationAdminSignInArgs = {
  data: SignInAdminInput;
};


export type MutationArchiveAnnouncementArgs = {
  input: PublishChangelogInput;
};


export type MutationArchiveCampaignArgs = {
  input: CampaignLifecycleInput;
};


export type MutationArchiveCustomerPersonArgs = {
  input: ArchiveCustomerPersonInput;
};


export type MutationArchiveSlaPolicyArgs = {
  input: ArchiveSlaPolicyInput;
};


export type MutationArchiveTeamChatArgs = {
  customerId: Scalars['ID']['input'];
  teamConversationId: Scalars['ID']['input'];
};


export type MutationArchiveTopicArgs = {
  input: ArchiveTopicInput;
};


export type MutationAssignChannelOwnerArgs = {
  data: AssignChannelOwnerInput;
};


export type MutationBlockReplaceIndexArgs = {
  input: BlockReplaceIndexInput;
};


export type MutationBulkTagCampaignContactsArgs = {
  input: BulkTagCampaignContactsInput;
};


export type MutationBulkUpdateCollageProductsArgs = {
  input: BulkUpdateCollageProductsInput;
};


export type MutationBuyCustomerProductAddOnArgs = {
  data: BuyCustomerProductAddOnInput;
};


export type MutationCancelCampaignArgs = {
  input: CampaignLifecycleInput;
};


export type MutationCancelCustomerProductAddOnArgs = {
  data: CancelCustomerProductAddOnInput;
};


export type MutationCancelHumanReplyLearningJobArgs = {
  customerId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};


export type MutationCancelOperatorQueryArgs = {
  data: OperatorQueryInput;
};


export type MutationCancelSpecialOfferPackageArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationChangeAccountStatusArgs = {
  data: ChangeAccountStatusInput;
};


export type MutationChangeCustomerPersonPasswordArgs = {
  data: ChangeCPersonPasswordInput;
};


export type MutationChangeCustomerPersonPhotoArgs = {
  data: ChangeCPersonPhotoInput;
};


export type MutationChangeCustomerPhotoArgs = {
  data: ChangeCustomerPhotoInput;
};


export type MutationChangeCustomerProductArgs = {
  data: ChangeCustomerProductInput;
};


export type MutationChangePersonOwnerArgs = {
  data: ChangePOwnerInput;
};


export type MutationCheckDomainStatusArgs = {
  input?: InputMaybe<CheckStatusDomainInput>;
};


export type MutationCheckECommerceCustomerAddressesArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCheckSmtpDomainStatusArgs = {
  input?: InputMaybe<CheckStatusDomainInput>;
};


export type MutationCheckTrackingDomainArgs = {
  input: TrackingDomainIdInput;
};


export type MutationClearChannelOwnerArgs = {
  data: ClearChannelOwnerInput;
};


export type MutationConfirmAccountArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationConnectAiStoreArgs = {
  customerId: Scalars['ID']['input'];
  integrationStoreId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationConnectECommercePlatformArgs = {
  customerId: Scalars['String']['input'];
  eCommerceStoreId: Scalars['String']['input'];
  metaData: Scalars['Object']['input'];
  type: Scalars['String']['input'];
};


export type MutationConnectMetaBusinessArgs = {
  input: ConnectMetaBusinessInput;
};


export type MutationConvertMediaLinkToLinkArgs = {
  input: ConvertMediaLinkToLinkInput;
};


export type MutationCreateActionArgs = {
  input: CreateActionInput;
};


export type MutationCreateAddOnArgs = {
  data: CreateAddOnInput;
};


export type MutationCreateAiGuidanceArgs = {
  data: CreateAiGuidanceInput;
};


export type MutationCreateAiKnowledgeSourceArgs = {
  data: CreateAiKnowledgeSourceInput;
};


export type MutationCreateAiSizeChartArgs = {
  customerId: Scalars['ID']['input'];
  data: AiSizeChartInput;
};


export type MutationCreateAiSizeChartGroupArgs = {
  customerId: Scalars['ID']['input'];
  data: AiSizeChartGroupInput;
};


export type MutationCreateAiTtsPreviewArgs = {
  params: AiTtsPreviewInput;
};


export type MutationCreateAnnouncementArgs = {
  input: CreateChangelogInput;
};


export type MutationCreateAnnouncementCategoryArgs = {
  input: CreateChangelogCategoryInput;
};


export type MutationCreateAskQuestionEvalMockArgs = {
  data: AskQuestionEvalMockInput;
};


export type MutationCreateAuthenticationArgs = {
  input: CreateAuthenticationInput;
};


export type MutationCreateBulkCollageSharingArgs = {
  input: CreateBulkCollageSharingInput;
};


export type MutationCreateBulkSharingArgs = {
  input: CreateBulkSharingInput;
};


export type MutationCreateBusinessHoursScheduleArgs = {
  input: CreateBusinessHoursScheduleInput;
};


export type MutationCreateCPersonRoleArgs = {
  input?: InputMaybe<CreateCPersonRoleInput>;
};


export type MutationCreateCampaignArgs = {
  input?: InputMaybe<CreateCampaignInput>;
};


export type MutationCreateCollageBarcodeArgs = {
  input: CreateCollageBarcodeInput;
};


export type MutationCreateCollageFolderArgs = {
  input: CreateCollageFolderInput;
};


export type MutationCreateCollageProductArgs = {
  input: CreateCollageProductInput;
};


export type MutationCreateCollageSettingsArgs = {
  input: CreateCollageSettingsInput;
};


export type MutationCreateCollageSharingArgs = {
  input: CreateCollageSharingInput;
};


export type MutationCreateCollageTemplateArgs = {
  input: CreateCollageTemplateInput;
};


export type MutationCreateCollageTemplateSetArgs = {
  input: CreateCollageTemplateSetInput;
};


export type MutationCreateConversationSidebarArgs = {
  input?: InputMaybe<CreateConvSidebarInput>;
};


export type MutationCreateConversationViewArgs = {
  input?: InputMaybe<CreateConvViewInput>;
};


export type MutationCreateCouponCodeArgs = {
  data: CreateCouponCodeInput;
};


export type MutationCreateCustomExtensionArgs = {
  input?: InputMaybe<CreateCustomExtensionInput>;
};


export type MutationCreateCustomFieldArgs = {
  input?: InputMaybe<CreateCustomFieldInput>;
};


export type MutationCreateCustomerArgs = {
  data: CreateCustomerInput;
};


export type MutationCreateCustomerBillingAddressesArgs = {
  data: CustomerBillingAddressesInput;
};


export type MutationCreateCustomerBillingContactsArgs = {
  data: CustomerBillingContactsInput;
};


export type MutationCreateCustomerOnboardingInfoArgs = {
  data: CustomerOnboardingInfoInput;
};


export type MutationCreateCustomerPaymentCardArgs = {
  data: CustomerPaymentCardInput;
};


export type MutationCreateCustomerPersonsArgs = {
  data: CreatePersonInput;
};


export type MutationCreateDefaultCPersonRolesArgs = {
  input?: InputMaybe<CreateDefaultCPersonRolesInput>;
};


export type MutationCreateDefaultTicketArgs = {
  input?: InputMaybe<CreateDefaultTicketInput>;
};


export type MutationCreateECommerceCustomerArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateECommerceIntegrationArgs = {
  params: CreateECommerceIntegrationInput;
  type: ECommerceIntegrationTypes;
};


export type MutationCreateECommerceIntegrationCustomerArgs = {
  customerId: Scalars['String']['input'];
  params: CreateECommerceIntegrationCustomerInput;
  type: ECommerceIntegrationTypes;
};


export type MutationCreateECommerceIntegrationCustomerAddressArgs = {
  customerId: Scalars['String']['input'];
  integrationCustomerId: Scalars['String']['input'];
  params: CreateECommerceIntegrationCustomerAddressInput;
  type: ECommerceIntegrationTypes;
};


export type MutationCreateECommerceIntegrationOrderArgs = {
  customerId: Scalars['String']['input'];
  params: CreateECommerceIntegrationOrderInput;
  type: ECommerceIntegrationTypes;
};


export type MutationCreateECommerceOrderArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateECommercePlatformArgs = {
  metaData: Scalars['Object']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateECommerceRulesArgs = {
  input?: InputMaybe<CreateECommerceRulesInput>;
};


export type MutationCreateExternalApiArgs = {
  input: CreateExternalApiInput;
};


export type MutationCreateFlowBotArgs = {
  input: CreateFlowBotInput;
};


export type MutationCreateFlowNodeArgs = {
  input: CreateFlowNodeInput;
};


export type MutationCreateFreeTrialPackageArgs = {
  input?: InputMaybe<CreateFreeTrialPackageInput>;
};


export type MutationCreateInboundWebhookArgs = {
  input: CreateInboundWebhookInput;
};


export type MutationCreateIntegrationArgs = {
  input?: InputMaybe<CreateIntegrationInput>;
};


export type MutationCreateMessageArgs = {
  data: CreateMessageInput;
};


export type MutationCreateNewConversationArgs = {
  data: CreateNewConversationInput;
};


export type MutationCreatePasswordArgs = {
  data: CreatePasswordInput;
};


export type MutationCreatePersonArgs = {
  data: PartialPerson;
};


export type MutationCreatePersonGroupArgs = {
  data: CreatePersonGroupInput;
};


export type MutationCreatePersonNoteArgs = {
  input: CreatePersonNoteInput;
};


export type MutationCreatePlatformArgs = {
  metaData: CreatePlatformInput;
  type: PlatformType;
};


export type MutationCreateQpienShopCustomerArgs = {
  metaData: CreateQpienShopCustomerInput;
};


export type MutationCreateQpienShopCustomerAddressArgs = {
  metaData: CreateQpienShopCustomerAddressInput;
};


export type MutationCreateQpienShopOrderArgs = {
  metaData: CreateQpienShopOrderInput;
};


export type MutationCreateQpienShopStoreArgs = {
  metaData: CreateQpienShopStoreInput;
  type: QpienShopStoreType;
};


export type MutationCreateQuickAnswerArgs = {
  data: CreateQuickAnswerInput;
};


export type MutationCreateRandomMessageArgs = {
  data?: InputMaybe<CreateRandomMessageInput>;
};


export type MutationCreateRecordArgs = {
  input?: InputMaybe<CreateRecordInput>;
};


export type MutationCreateRecordNoteArgs = {
  input?: InputMaybe<CreateRecordNoteInput>;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateReportWidgetArgs = {
  input: CreateReportWidgetInput;
};


export type MutationCreateReportWidgetMetricArgs = {
  input: CreateReportWidgetMetricInput;
};


export type MutationCreateScheduleMessageArgs = {
  input?: InputMaybe<CreateScheduleMessageInput>;
};


export type MutationCreateSkillArgs = {
  data: CreateSkillInput;
};


export type MutationCreateSlaPolicyArgs = {
  input: CreateSlaPolicyInput;
};


export type MutationCreateSnoozeArgs = {
  input?: InputMaybe<CreateSnoozeInput>;
};


export type MutationCreateSurveyHistoryArgs = {
  input?: InputMaybe<CreateSurveyHistoryInput>;
};


export type MutationCreateSurveysArgs = {
  input?: InputMaybe<CreateSurveysInput>;
};


export type MutationCreateTableArgs = {
  input: CreateTableInput;
};


export type MutationCreateTableFieldArgs = {
  input: CreateTableFieldInput;
};


export type MutationCreateTableFolderArgs = {
  input: CreateTableFolderInput;
};


export type MutationCreateTableRecordArgs = {
  input: CreateTableRecordInput;
};


export type MutationCreateTableRecordActivityArgs = {
  input: CreateTableRecordActivityInput;
};


export type MutationCreateTableViewArgs = {
  input: CreateTableViewInput;
};


export type MutationCreateTagArgs = {
  input?: InputMaybe<CreateTagInput>;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationCreateTaskLogArgs = {
  input: CreateTaskLogInput;
};


export type MutationCreateTeamGroupChatArgs = {
  data: CreateTeamGroupChatInput;
};


export type MutationCreateTeamPrivateChatArgs = {
  customerId: Scalars['ID']['input'];
  targetCPersonId: Scalars['ID']['input'];
};


export type MutationCreateTeamsArgs = {
  data: TeamsInput;
};


export type MutationCreateTemplateArgs = {
  data: Template;
};


export type MutationCreateTicketStateArgs = {
  input?: InputMaybe<CreateTicketStateInput>;
};


export type MutationCreateTicketTypeArgs = {
  input?: InputMaybe<CreateTicketTypeInput>;
};


export type MutationCreateTopicsArgs = {
  input: Array<CreateTopicInput>;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationCreateWabaTemplateArgs = {
  data: CreateWabaTemplateInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationCustomerPersonGoogleAuthArgs = {
  data: GoogleAuthInput;
};


export type MutationCustomerPersonLogOutArgs = {
  data: CPersonLogOut;
};


export type MutationCustomerPersonSignInArgs = {
  data: SignInUserInput;
};


export type MutationDeleteActionArgs = {
  input: DeleteActionInput;
};


export type MutationDeleteAddOnArgs = {
  data: DeleteAddOnInput;
};


export type MutationDeleteAiGuidanceArgs = {
  data: DeleteAiGuidanceInput;
};


export type MutationDeleteAiHelpArticleArgs = {
  data: AiHelpArticleInput;
};


export type MutationDeleteAiKnowledgeSourceArgs = {
  data?: InputMaybe<DeleteAiKnowledgeSourceInput>;
};


export type MutationDeleteAiKnowledgeSourceContentArgs = {
  data?: InputMaybe<DeleteAiKnowledgeSourceInput>;
};


export type MutationDeleteAiMessagesByDateRangeArgs = {
  data: DeleteByDateRangeParams;
};


export type MutationDeleteAiSizeChartArgs = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteAiSizeChartGroupArgs = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteAiSuggestionsArgs = {
  data?: InputMaybe<DeleteManyAiSuggestionInput>;
};


export type MutationDeleteAllAskQuestionEvalRunsArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAnnouncementArgs = {
  input: DeleteChangelogInput;
};


export type MutationDeleteAnnouncementCategoryArgs = {
  input: DeleteChangelogCategoryInput;
};


export type MutationDeleteAskQuestionEvalMockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAuthenticationArgs = {
  input: DeleteAuthenticationInput;
};


export type MutationDeleteBusinessHoursSchedulesArgs = {
  input: DeleteBusinessHoursSchedulesInput;
};


export type MutationDeleteCPersonRoleArgs = {
  input?: InputMaybe<DeleteCPersonRoleInput>;
};


export type MutationDeleteCallAdminLogsArgs = {
  params: DeleteCallAdminLogsInput;
};


export type MutationDeleteCampaignArgs = {
  input: CampaignLifecycleInput;
};


export type MutationDeleteCollageBarcodeArgs = {
  input: DeleteCollageBarcodeInput;
};


export type MutationDeleteCollageFolderArgs = {
  input: DeleteCollageFolderInput;
};


export type MutationDeleteCollageProductArgs = {
  input: DeleteCollageProductInput;
};


export type MutationDeleteCollageSettingsArgs = {
  input: DeleteCollageSettingsInput;
};


export type MutationDeleteCollageSharingArgs = {
  input: DeleteCollageSharingInput;
};


export type MutationDeleteCollageTemplateArgs = {
  input: DeleteCollageTemplateInput;
};


export type MutationDeleteCommentOnPlatformArgs = {
  input: DeleteCommentOnPlatformInput;
};


export type MutationDeleteConversationSidebarArgs = {
  input?: InputMaybe<DeleteConvSidebarInput>;
};


export type MutationDeleteConversationViewArgs = {
  input?: InputMaybe<DeleteConvViewInput>;
};


export type MutationDeleteCouponCodeArgs = {
  data: DeleteCouponCodeInput;
};


export type MutationDeleteCustomExtensionArgs = {
  input?: InputMaybe<DeleteCustomExtensionInput>;
};


export type MutationDeleteCustomerArgs = {
  data: DeleteCustomerInput;
};


export type MutationDeleteCustomerPersonArgs = {
  input: DeleteCustomerPersonInput;
};


export type MutationDeleteCustomerProductAddOnArgs = {
  data?: InputMaybe<DeleteCustomerProductAddOnInput>;
};


export type MutationDeleteDelayedActionArgs = {
  input?: InputMaybe<DeleteDelayedActionInput>;
};


export type MutationDeleteECommerceIntegrationArgs = {
  params: DeleteECommerceIntegrationInput;
};


export type MutationDeleteECommercePlatformArgs = {
  metaData: Scalars['Object']['input'];
  type: Scalars['String']['input'];
};


export type MutationDeleteECommerceRulesArgs = {
  input?: InputMaybe<DeleteECommerceRulesInput>;
};


export type MutationDeleteEmailAdminLogsArgs = {
  params: DeleteEmailAdminLogsInput;
};


export type MutationDeleteExternalApiArgs = {
  input: DeleteExternalApiInput;
};


export type MutationDeleteFlowBotArgs = {
  input: DeleteFlowBotInput;
};


export type MutationDeleteFlowNodeArgs = {
  input: DeleteFlowNodeInput;
};


export type MutationDeleteInboundWebhookArgs = {
  input: DeleteInboundWebhookInput;
};


export type MutationDeleteIntegrationArgs = {
  input?: InputMaybe<DeleteIntegrationInput>;
};


export type MutationDeleteManyAskQuestionEvalMocksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteManyAskQuestionEvalRunsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteMultiplePersonArgs = {
  data: DeleteMultiplePersonInput;
};


export type MutationDeleteOperatorJobArgs = {
  data: OperatorJobInput;
};


export type MutationDeleteOperatorReportArgs = {
  data: OperatorReportInput;
};


export type MutationDeletePersonNoteArgs = {
  input: DeletePersonNoteInput;
};


export type MutationDeletePlatformArgs = {
  metaData: DeletePlatformTypeInput;
  type: PlatformType;
};


export type MutationDeleteQpienShopStoreArgs = {
  metaData: DeleteQpienShopStoreInput;
  type: QpienShopStoreType;
};


export type MutationDeleteQuickAnswerArgs = {
  data: DeleteQuickAnswerInput;
};


export type MutationDeleteRandomMessageTestContactArgs = {
  data: DeleteRandomMessageTestContactInput;
};


export type MutationDeleteReportArgs = {
  input: DeleteReportInput;
};


export type MutationDeleteReportWidgetArgs = {
  input: DeleteReportWidgetInput;
};


export type MutationDeleteReportWidgetMetricArgs = {
  input: DeleteReportWidgetMetricInput;
};


export type MutationDeleteSkillArgs = {
  data: SkillScopedIdInput;
};


export type MutationDeleteSurveysArgs = {
  input?: InputMaybe<DeleteSurveysInput>;
};


export type MutationDeleteTableArgs = {
  input: DeleteTableInput;
};


export type MutationDeleteTableFieldArgs = {
  input: DeleteTableFieldInput;
};


export type MutationDeleteTableFolderArgs = {
  input: DeleteTableFolderInput;
};


export type MutationDeleteTableRecordArgs = {
  input: DeleteTableRecordInput;
};


export type MutationDeleteTableRecordsArgs = {
  input: DeleteTableRecordsInput;
};


export type MutationDeleteTableViewArgs = {
  input: DeleteTableViewInput;
};


export type MutationDeleteTagArgs = {
  input?: InputMaybe<DeleteTagInput>;
};


export type MutationDeleteTaskByIdArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteTaskBySourceIdArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteTaskCommentArgs = {
  input: DeleteTaskCommentInput;
};


export type MutationDeleteTeamGroupChatArgs = {
  customerId: Scalars['ID']['input'];
  teamConversationId: Scalars['ID']['input'];
};


export type MutationDeleteTeamMessageArgs = {
  customerId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationDeleteTeamsArgs = {
  data: DeleteTeamsInput;
};


export type MutationDeleteTemplateArgs = {
  input: DeleteTemplateInput;
};


export type MutationDeleteTestConversationArgs = {
  data?: InputMaybe<DeleteTestConversationInput>;
};


export type MutationDeleteTopicArgs = {
  input: DeleteTopicInput;
};


export type MutationDeleteUserArgs = {
  data: DeleteUserInput;
};


export type MutationDeleteWabaTemplateArgs = {
  input: DeleteWabaTemplateInput;
};


export type MutationDeleteWebhookArgs = {
  input: DeleteWebhookInput;
};


export type MutationDestroyClientArgs = {
  metaData: DestroyData;
  type: Scalars['String']['input'];
};


export type MutationDisableAiEngineArgs = {
  data: AiEngineVersionInput;
};


export type MutationDisconnectMetaBusinessArgs = {
  input: MetaAdsCustomerInput;
};


export type MutationDismissOperatorInsightArgs = {
  data: OperatorInsightInput;
};


export type MutationDoCustomPlatformMutationArgs = {
  input: CustomPlatformInput;
};


export type MutationDuplicateCampaignArgs = {
  input: DuplicateCampaignInput;
};


export type MutationDuplicateFlowBotArgs = {
  input: DuplicateFlowBotInput;
};


export type MutationDuplicateReportArgs = {
  input: DuplicateReportInput;
};


export type MutationDuplicateTableArgs = {
  input: DuplicateTableInput;
};


export type MutationEditTeamMessageArgs = {
  data: EditTeamMessageInput;
};


export type MutationEditWabaTemplateArgs = {
  data: EditWabaTemplateInput;
};


export type MutationEnableAiEngineArgs = {
  data: AiEngineVersionInput;
};


export type MutationEnableTwoFactorAuthenticationArgs = {
  data: EnableTwoFactorAuthenticationInput;
};


export type MutationEnqueueAiEvalMessageArgs = {
  data: AiEvalMessageInput;
};


export type MutationExportPersonExcelSendToMailArgs = {
  data: ExportPersonsInput;
};


export type MutationExportReportArgs = {
  input: ExportReportInput;
};


export type MutationExportTableRecordsArgs = {
  input: ExportTableRecordsInput;
};


export type MutationExternalCreateContactArgs = {
  input: ExternalCreateContactInput;
};


export type MutationExternalCreateMessageArgs = {
  input: ExternalCreateMessageInput;
};


export type MutationExternalDeleteContactArgs = {
  input: ExternalDeleteContactInput;
};


export type MutationExternalSendMessageArgs = {
  input: ExternalSendMessageInput;
};


export type MutationExternalUpdateContactArgs = {
  input: ExternalUpdateContactInput;
};


export type MutationExternalUpdateConversationArgs = {
  input: ExternalUpdateConversationInput;
};


export type MutationFinalizeBulkSharingArgs = {
  input: FinalizeBulkSharingInput;
};


export type MutationFlagCampaignForScheduleArgs = {
  input?: InputMaybe<SendCampaignInput>;
};


export type MutationForgotMyPasswordArgs = {
  data: ForgotPasswordInput;
};


export type MutationGenerateAiAssistantContentArgs = {
  data: GenerateAiAssistantContentInput;
};


export type MutationGenerateClosingTopicContentArgs = {
  data: GenerateClosingTopicContentInput;
};


export type MutationGenerateOAuthTokenArgs = {
  input: GenerateOAuthTokenInput;
};


export type MutationGenerateSkillDraftArgs = {
  data: GenerateSkillDraftInput;
};


export type MutationGetCustomerSessionByAdminArgs = {
  data?: InputMaybe<CustomerSessionInput>;
};


export type MutationImportAiHelpPdfArgs = {
  data: AiHelpImportPdfInput;
};


export type MutationImportPersonsArgs = {
  data: ImportPersonsInput;
};


export type MutationImportRecordsToTableArgs = {
  input: ImportRecordsToTableInput;
};


export type MutationInitAiRoleArgs = {
  customerId: Scalars['ID']['input'];
  role: AiRoleEnum;
};


export type MutationJoinConversationArgs = {
  data: JoinConversationInput;
};


export type MutationLeaveTeamGroupChatArgs = {
  data: LeaveTeamGroupChatInput;
};


export type MutationLinkECommerceCustomerArgs = {
  metaData: LinkECommerceCustomerInputType;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLinkMetaDatasetArgs = {
  input: LinkMetaDatasetInput;
};


export type MutationLiveChatReceiveMessageArgs = {
  data?: InputMaybe<LiveChatReceiveMessageInput>;
};


export type MutationMakePlatformReactionArgs = {
  input: ReactionPlatformType;
};


export type MutationMarkAnnouncementReadArgs = {
  input: MarkAnnouncementReadInput;
};


export type MutationMarkCPersonNotificationsAsReadArgs = {
  data: MarkCPersonNotificationsReadInput;
};


export type MutationMarkCPersonNotificationsAsUnReadArgs = {
  data: MarkCPersonNotificationsUnreadInput;
};


export type MutationMarkOnboardingStepArgs = {
  data: MarkOnboardingStepInput;
};


export type MutationMarkTeamChatReadArgs = {
  data: MarkTeamChatReadInput;
};


export type MutationMergeContactsArgs = {
  input: MergeContactsInput;
};


export type MutationMergeConversationsArgs = {
  input: MergeConversationsInput;
};


export type MutationMoveTableArgs = {
  input: MoveTableInput;
};


export type MutationMuteTeamChatArgs = {
  data: MuteTeamChatInput;
};


export type MutationOneTimesUpdateMutationArgs = {
  metaData: Scalars['Object']['input'];
  type: OneTimesType;
};


export type MutationOptimizeAiGuidanceContentArgs = {
  data: OptimizeAiGuidanceContentInput;
};


export type MutationPauseCampaignArgs = {
  input: CampaignLifecycleInput;
};


export type MutationPaymentFromOtherChannelArgs = {
  data: Scalars['Object']['input'];
};


export type MutationPinAiEngineArgs = {
  data: AiEnginePinInput;
};


export type MutationPreviewImportPersonsArgs = {
  data: ImportPersonsInput;
};


export type MutationPublishAnnouncementArgs = {
  input: PublishChangelogInput;
};


export type MutationPublishLiveChatWidgetReleaseArgs = {
  input: PublishLiveChatWidgetReleaseInput;
};


export type MutationPublishSkillArgs = {
  data: PublishSkillInput;
};


export type MutationReSendMessageArgs = {
  data: ReSendMessageInput;
};


export type MutationReactTeamMessageArgs = {
  data: ReactTeamMessageInput;
};


export type MutationReactToAnnouncementArgs = {
  input: ReactToChangelogInput;
};


export type MutationReactToMessageArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  emoji: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationReadMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationReembedKnowledgeSourcesToContextualRagArgs = {
  data: ReembedKnowledgeSourcesToContextualRagInput;
};


export type MutationRefacTorPChannelsAndConvsArgs = {
  newMongoAdress?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationRefactorConversationArgs = {
  convId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefreshWabaTemplatesArgs = {
  input: RefreshWabaTemplatesInput;
};


export type MutationRegenerateFlowWebhookUrlArgs = {
  input: RegenerateFlowWebhookUrlInput;
};


export type MutationReindexAiHelpArticleArgs = {
  data: AiHelpArticleInput;
};


export type MutationRemoveBlockFromNodeArgs = {
  input: RemoveBlockFromNodeInput;
};


export type MutationRemoveBlocksFromNodeArgs = {
  input: RemoveBlocksFromNodeInput;
};


export type MutationRemoveCampaignArgs = {
  input: RemoveCampaignInput;
};


export type MutationRemoveCouponCodeFromCustomerArgs = {
  data: RemoveCouponCodeFromCustomerInput;
};


export type MutationRemoveCustomerBillingContactsArgs = {
  data: RemoveCustomerBillingContactsInput;
};


export type MutationRemoveCustomerPaymentCardArgs = {
  input: RemoveCustomerPaymentCardInput;
};


export type MutationRemoveDomainFromEmailArgs = {
  input?: InputMaybe<RemoveDomainFromEmailInput>;
};


export type MutationRemovePersonGroupArgs = {
  data: RemovePersonGroupInput;
};


export type MutationRemoveTrackingDomainArgs = {
  input: TrackingDomainIdInput;
};


export type MutationRenameCampaignArgs = {
  input: CampaignTitleInput;
};


export type MutationRenameOperatorReportArgs = {
  data: RenameOperatorReportInput;
};


export type MutationReorderReportWidgetMetricsArgs = {
  input: Array<ReorderReportWidgetMetricInput>;
};


export type MutationReorderReportsArgs = {
  input: Array<ReorderReportInput>;
};


export type MutationReorderTableFieldsArgs = {
  input: ReorderTableFieldsInput;
};


export type MutationReorderTableFoldersArgs = {
  input: ReorderTableFoldersInput;
};


export type MutationReorderTablesArgs = {
  input: ReorderTablesInput;
};


export type MutationRerunOperatorReportArgs = {
  data: OperatorReportInput;
};


export type MutationResendCreatePasswordMailArgs = {
  data: ResendCreatePasswordMailInput;
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetMyPasswordArgs = {
  data: ResetMyPasswordInput;
};


export type MutationResolveAiHelpGapsArgs = {
  data: AiHelpResolveGapsInput;
};


export type MutationResumeCampaignArgs = {
  input: ResumeCampaignInput;
};


export type MutationRetryFailedCampaignRecipientsArgs = {
  input: RetryFailedCampaignRecipientsInput;
};


export type MutationRetryPaymentArgs = {
  input: RetryPaymentInput;
};


export type MutationRollbackAiEngineRoutingArgs = {
  data: AiEngineRollbackInput;
};


export type MutationRollbackLiveChatWidgetReleaseArgs = {
  input: RollbackLiveChatWidgetReleaseInput;
};


export type MutationRunAskQuestionEvalSuiteArgs = {
  data: AskQuestionEvalSuiteInput;
};


export type MutationRunMigrationArgs = {
  probe?: InputMaybe<InspectCollectionInput>;
  type: OneTimesType;
};


export type MutationRunOperatorJobNowArgs = {
  data: OperatorJobInput;
};


export type MutationRunOperatorQueryArgs = {
  data: OperatorQueryInput;
};


export type MutationSaveAiHelpArticleArgs = {
  data: AiHelpSaveArticleInput;
};


export type MutationSaveConversationViewPreferenceArgs = {
  input: SaveConversationViewPreferenceInput;
};


export type MutationSaveOperatorReportArgs = {
  data: SaveOperatorReportInput;
};


export type MutationSaveReportWidgetLayoutArgs = {
  input: SaveReportWidgetLayoutInput;
};


export type MutationScanModuleForIntegrationArgs = {
  input?: InputMaybe<ScanModuleForIntegrationInput>;
};


export type MutationScheduleAnnouncementArgs = {
  input: ScheduleChangelogInput;
};


export type MutationScheduleCampaignArgs = {
  input: ScheduleCampaignInput;
};


export type MutationSearchProductByImageArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelectAiRoleArgs = {
  customerId: Scalars['ID']['input'];
  role: AiRoleEnum;
};


export type MutationSendCampaignArgs = {
  input?: InputMaybe<SendCampaignInput>;
};


export type MutationSendCampaignTestMessageArgs = {
  input: SendCampaignTestMessageInput;
};


export type MutationSendCampaignWinnerArgs = {
  input: SendCampaignWinnerInput;
};


export type MutationSendMetaTestEventArgs = {
  input: SendMetaTestEventInput;
};


export type MutationSendOperatorMessageArgs = {
  data: SendOperatorMessageInput;
};


export type MutationSendScheduledMessageArgs = {
  input?: InputMaybe<SendScheduledMessageInput>;
};


export type MutationSendSpecialOfferPackageArgs = {
  data: SpecialOfferPackageInput;
};


export type MutationSendTeamMessageArgs = {
  data: SendTeamMessageInput;
};


export type MutationSetAiEngineDefaultArgs = {
  data: AiEngineDefaultInput;
};


export type MutationSetAiSizeChartEnabledArgs = {
  customerId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetCampaignLinksDisabledArgs = {
  input: SetCampaignLinksDisabledInput;
};


export type MutationSetCampaignTagsArgs = {
  input: CampaignTagsInput;
};


export type MutationSetConversationTypingArgs = {
  data: SetConversationTypingInput;
};


export type MutationSetCustomerLinksDisabledArgs = {
  input: SetCustomerLinksDisabledInput;
};


export type MutationSetCustomerPaymentCardAsDefaultArgs = {
  input: SetCustomerPaymentCardAsDefaultInput;
};


export type MutationSetDefaultTrackingDomainArgs = {
  input: SetDefaultTrackingDomainInput;
};


export type MutationSetMetaDatasetEnabledArgs = {
  input: SetMetaDatasetEnabledInput;
};


export type MutationSetOperatorAccessArgs = {
  data: SetOperatorAccessInput;
};


export type MutationSetSkillStatusArgs = {
  data: SetSkillStatusInput;
};


export type MutationSetUpdateNotificationArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSimulateMetaAdClickArgs = {
  input: SimulateMetaAdClickInput;
};


export type MutationSimulateSkillArgs = {
  data: SimulateSkillInput;
};


export type MutationStartCampaignArgs = {
  input: StartCampaignInput;
};


export type MutationStartConversationSearchExportArgs = {
  data: StartConversationSearchExportInput;
};


export type MutationStartMigrationArgs = {
  probe?: InputMaybe<InspectCollectionInput>;
  type: OneTimesType;
};


export type MutationStartReembedKnowledgeSourcesToContextualRagArgs = {
  data: ReembedKnowledgeSourcesToContextualRagInput;
};


export type MutationSubscribeToMobilNotificationsArgs = {
  data?: InputMaybe<SubscribeNotificationInput>;
};


export type MutationSubscribeToWebNotificationsArgs = {
  data?: InputMaybe<SubscribeNotificationInput>;
};


export type MutationSyncAiProductImageIndexArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationTestAiAnalysisArgs = {
  data: TestAiAnalysisInput;
};


export type MutationTestAiWithConversationArgs = {
  data: TestAiWithConversationInput;
};


export type MutationTestWebhookArgs = {
  input: TestWebhookInput;
};


export type MutationTestZohoCreateRecordArgs = {
  input: ZohoTestCreateInput;
};


export type MutationTestZohoFlowActionArgs = {
  input: ZohoFlowTestActionInput;
};


export type MutationTrainModelArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTransferConversationsArgs = {
  data: TransferConversationInput;
};


export type MutationTransferConversationsToTeamArgs = {
  data: TransferConversationsToTeamInput;
};


export type MutationTranslateAnnouncementArgs = {
  input: TranslateChangelogInput;
};


export type MutationTranslateInboxMessagesArgs = {
  data: TranslateInboxMessagesInput;
};


export type MutationTriggerReusableFlowArgs = {
  input: TriggerReusableFlowInput;
};


export type MutationUnArchiveCustomerPersonArgs = {
  input: UnarchiveCustomerPersonInput;
};


export type MutationUnArchiveTopicArgs = {
  input: UnArchiveTopicInput;
};


export type MutationUnSnoozeConversationArgs = {
  input?: InputMaybe<UnSnoozeConversationInput>;
};


export type MutationUnSubscribeToMobilNotificationsArgs = {
  data?: InputMaybe<UnSubscribeNotificationInput>;
};


export type MutationUnSubscribeToWebNotificationsArgs = {
  data?: InputMaybe<UnSubscribeNotificationInput>;
};


export type MutationUnarchiveAnnouncementArgs = {
  input: PublishChangelogInput;
};


export type MutationUnarchiveCampaignArgs = {
  input: CampaignLifecycleInput;
};


export type MutationUnarchiveTeamChatArgs = {
  customerId: Scalars['ID']['input'];
  teamConversationId: Scalars['ID']['input'];
};


export type MutationUndoOperatorActionArgs = {
  data: OperatorQueryInput;
};


export type MutationUnlinkECommerceCustomerArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpinAiEngineArgs = {
  data: AiEngineUnpinInput;
};


export type MutationUnpublishAnnouncementArgs = {
  input: PublishChangelogInput;
};


export type MutationUnscheduleCampaignArgs = {
  input: CampaignLifecycleInput;
};


export type MutationUpdateActionArgs = {
  input: UpdateActionInput;
};


export type MutationUpdateAddOnArgs = {
  data: UpdateAddOnInput;
};


export type MutationUpdateAiAnalysisSettingsArgs = {
  customerId: Scalars['ID']['input'];
  data: AiAnalysisSettingsInput;
};


export type MutationUpdateAiAssistantArgs = {
  customerId: Scalars['ID']['input'];
  data: AiAssistantSettingsInput;
};


export type MutationUpdateAiGuidanceArgs = {
  data: UpdateAiGuidanceInput;
};


export type MutationUpdateAiHelpArticleArgs = {
  data: AiHelpUpdateArticleInput;
};


export type MutationUpdateAiKnowledgeSourceChannelsArgs = {
  data: UpdateAiKnowledgeSourceChannelsInput;
};


export type MutationUpdateAiProductFaqDesignArgs = {
  customerId: Scalars['ID']['input'];
  data: AiProductFaqDesignInput;
};


export type MutationUpdateAiProfileArgs = {
  data: UpdateAiProfileInput;
};


export type MutationUpdateAiShoppingAssistantArgs = {
  customerId: Scalars['ID']['input'];
  data: AiShoppingAssistantInput;
};


export type MutationUpdateAiSizeChartArgs = {
  customerId: Scalars['ID']['input'];
  data: AiSizeChartInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAiSizeChartGroupArgs = {
  customerId: Scalars['ID']['input'];
  data: AiSizeChartGroupInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAiStoreProductInfoArgs = {
  data: UpdateAiStoreProductInfoInput;
};


export type MutationUpdateAiTtsModelArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationUpdateAnnouncementArgs = {
  input: UpdateChangelogInput;
};


export type MutationUpdateAnnouncementCategoryArgs = {
  input: UpdateChangelogCategoryInput;
};


export type MutationUpdateAskQuestionEvalMockArgs = {
  data: AskQuestionEvalMockInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAuthenticationArgs = {
  input: UpdateAuthenticationInput;
};


export type MutationUpdateAutoFormalizeInvoicesArgs = {
  value: AutoFormalizeInvoicesPreference;
};


export type MutationUpdateBlockArgs = {
  input: UpdateBlockInput;
};


export type MutationUpdateBlockFieldArgs = {
  input: UpdateBlockFieldInput;
};


export type MutationUpdateBusinessHoursScheduleArgs = {
  input: UpdateBusinessHoursScheduleInput;
};


export type MutationUpdateCPersonRoleArgs = {
  input?: InputMaybe<UpdateCPersonRoleInput>;
};


export type MutationUpdateCPersonStatusArgs = {
  data: CPersonStatusInput;
};


export type MutationUpdateCProductChargeArgs = {
  data: UpdateCProductChargeInput;
};


export type MutationUpdateCampaignArgs = {
  input?: InputMaybe<UpdateCampaignInput>;
};


export type MutationUpdateChangelogSettingsArgs = {
  input: UpdateChangelogSettingsInput;
};


export type MutationUpdateChatsAndPersonsByDateDbTransferArgs = {
  newMongoAdress?: InputMaybe<Scalars['String']['input']>;
  oldMongoAdress?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateCollageBarcodeArgs = {
  input: UpdateCollageBarcodeInput;
};


export type MutationUpdateCollageFolderArgs = {
  input: UpdateCollageFolderInput;
};


export type MutationUpdateCollageProductArgs = {
  input: UpdateCollageProductInput;
};


export type MutationUpdateCollageSettingsArgs = {
  input: UpdateCollageSettingsInput;
};


export type MutationUpdateCollageSharingArgs = {
  input: UpdateCollageSharingInput;
};


export type MutationUpdateCollageTemplateArgs = {
  input: UpdateCollageTemplateInput;
};


export type MutationUpdateConvTagsArgs = {
  data: UpdateConvTags;
};


export type MutationUpdateConversationDetailsSettingsArgs = {
  input: UpdateConversationDetailsSettingsInput;
};


export type MutationUpdateConversationSettingsArgs = {
  input: UpdateConversationSettingsInput;
};


export type MutationUpdateConversationSidebarArgs = {
  input?: InputMaybe<UpdateConvSidebarInput>;
};


export type MutationUpdateConversationViewArgs = {
  input?: InputMaybe<UpdateConvViewInput>;
};


export type MutationUpdateConversationsArgs = {
  data: UpdateConversationsInput;
};


export type MutationUpdateCustomExtensionArgs = {
  input?: InputMaybe<UpdateCustomExtensionInput>;
};


export type MutationUpdateCustomFieldArgs = {
  input?: InputMaybe<UpdateCustomFieldInput>;
};


export type MutationUpdateCustomFieldStatusArgs = {
  input?: InputMaybe<UpdateCustomFieldStatusInput>;
};


export type MutationUpdateCustomerArgs = {
  data: UpdateCustomerInput;
};


export type MutationUpdateCustomerBillingAddressesArgs = {
  data: CustomerBillingAddressesInput;
};


export type MutationUpdateCustomerBillingContactsArgs = {
  data: UpdateCustomerBillingContactsInput;
};


export type MutationUpdateCustomerInvoiceArgs = {
  data?: InputMaybe<UpdateCustomerInvoiceInput>;
};


export type MutationUpdateCustomerOnboardingInfoArgs = {
  data: UpdateCOnboardingInfoInput;
};


export type MutationUpdateCustomerPaymentCardArgs = {
  data: CustomerPaymentCardInput;
};


export type MutationUpdateCustomerPersonArgs = {
  data: UpdateCustomerPersonInput;
};


export type MutationUpdateCustomerProductArgs = {
  data: UpdateCustomerProductInput;
};


export type MutationUpdateCustomerProductPlanArgs = {
  data: UpdateCustomerProductPlanInput;
};


export type MutationUpdateCustomerWorkingHourArgs = {
  data: UpdateWorkingHourInput;
};


export type MutationUpdateDelayedActionArgs = {
  input?: InputMaybe<UpdateDelayedActionInput>;
};


export type MutationUpdateDeviceStatusArgs = {
  data: DeviceStatusInput;
};


export type MutationUpdateDomainArgs = {
  input?: InputMaybe<UpdateDomainInput>;
};


export type MutationUpdateECommerceCustomerArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateECommerceIntegrationArgs = {
  params: UpdateECommerceIntegrationInput;
};


export type MutationUpdateECommerceIntegrationCustomerArgs = {
  customerId: Scalars['String']['input'];
  integrationCustomerId: Scalars['String']['input'];
  params: UpdateECommerceIntegrationCustomerInput;
  type: ECommerceIntegrationTypes;
};


export type MutationUpdateECommerceIntegrationCustomerAddressArgs = {
  customerId: Scalars['String']['input'];
  integrationAddressId: Scalars['String']['input'];
  integrationCustomerId: Scalars['String']['input'];
  params: UpdateECommerceIntegrationCustomerAddressInput;
  type: ECommerceIntegrationTypes;
};


export type MutationUpdateECommerceOrderArgs = {
  metaData: Scalars['Object']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateECommercePlatformArgs = {
  metaData: Scalars['Object']['input'];
  type: Scalars['String']['input'];
};


export type MutationUpdateECommercePlatformSettingsArgs = {
  metaData: ECommercePlatformSettingsInputType;
  type: Scalars['String']['input'];
};


export type MutationUpdateECommerceRulesArgs = {
  input?: InputMaybe<UpdateECommerceRulesInput>;
};


export type MutationUpdateECommerceRulesStatusArgs = {
  input?: InputMaybe<UpdateECommerceRulesStatusInput>;
};


export type MutationUpdateExternalApiArgs = {
  input: UpdateExternalApiInput;
};


export type MutationUpdateFlowBotArgs = {
  input: UpdateFlowBotInput;
};


export type MutationUpdateFlowNodeArgs = {
  input: UpdateFlowNodeInput;
};


export type MutationUpdateHomeLayoutSettingsArgs = {
  input: UpdateHomeLayoutSettingsInput;
};


export type MutationUpdateInboundWebhookArgs = {
  input: UpdateInboundWebhookInput;
};


export type MutationUpdateIntegrationArgs = {
  input?: InputMaybe<UpdateIntegrationInput>;
};


export type MutationUpdateIntegrationRecordArgs = {
  input?: InputMaybe<UpdateIntegrationRecordInput>;
};


export type MutationUpdateLocationDataArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMobileAppVersionConfigArgs = {
  input: UpdateMobileAppVersionConfigInput;
};


export type MutationUpdateMyChangelogNotificationPrefsArgs = {
  input: ChangelogPrefsInput;
};


export type MutationUpdateMyProductTourArgs = {
  input: UpdateProductTourInput;
};


export type MutationUpdateOperatorJobArgs = {
  data: UpdateOperatorJobInput;
};


export type MutationUpdateOperatorPreferencesArgs = {
  data: UpdateOperatorPreferencesInput;
};


export type MutationUpdateOperatorQueryArgs = {
  data: UpdateOperatorQueryInput;
};


export type MutationUpdatePersonArgs = {
  data: UpdatePersonInput;
};


export type MutationUpdatePersonChannelArgs = {
  data: ChannelInput;
};


export type MutationUpdatePersonGroupArgs = {
  data: UpdatePersonGroupInput;
};


export type MutationUpdatePlatformArgs = {
  metaData: UpdatePlatformInputData;
  type: PlatformType;
};


export type MutationUpdateQpienShopCustomerArgs = {
  metaData: UpdateQpienShopCustomerInput;
};


export type MutationUpdateQpienShopCustomerAddressArgs = {
  metaData: UpdateQpienShopCustomerAddressInput;
};


export type MutationUpdateQpienShopOrderArgs = {
  metaData: UpdateQpienShopOrderInput;
};


export type MutationUpdateQuickAnswerArgs = {
  data: UpdateQuickAnswerInput;
};


export type MutationUpdateReportArgs = {
  input: UpdateReportMutationInput;
};


export type MutationUpdateReportWidgetArgs = {
  input: UpdateReportWidgetMutationInput;
};


export type MutationUpdateReportWidgetMetricArgs = {
  input: UpdateReportWidgetMetricMutationInput;
};


export type MutationUpdateRequireAccountApprovalArgs = {
  approvalRequired: Scalars['Boolean']['input'];
};


export type MutationUpdateSingleCustomerProfileArgs = {
  data: UpdateCustomerPersonInput;
};


export type MutationUpdateSkillDraftArgs = {
  data: UpdateSkillDraftInput;
};


export type MutationUpdateSlaPolicyArgs = {
  input: UpdateSlaPolicyInput;
};


export type MutationUpdateSpecialOfferPackageArgs = {
  data?: InputMaybe<SpecialOfferPackageInput>;
};


export type MutationUpdateSurveyHistoryArgs = {
  input?: InputMaybe<UpdateSurveyHistoryInput>;
};


export type MutationUpdateSurveysArgs = {
  input?: InputMaybe<UpdateSurveysInput>;
};


export type MutationUpdateTableArgs = {
  input: UpdateTableInput;
};


export type MutationUpdateTableFieldArgs = {
  input: UpdateTableFieldInput;
};


export type MutationUpdateTableFolderArgs = {
  input: UpdateTableFolderInput;
};


export type MutationUpdateTableRecordArgs = {
  input: UpdateTableRecordInput;
};


export type MutationUpdateTableRecordKanbanOrderArgs = {
  input: UpdateTableRecordKanbanOrderInput;
};


export type MutationUpdateTableViewArgs = {
  input: UpdateTableViewInput;
};


export type MutationUpdateTagArgs = {
  input?: InputMaybe<UpdateTagInput>;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskCommentArgs = {
  input: UpdateTaskCommentInput;
};


export type MutationUpdateTasksArgs = {
  input: UpdateTasksInput;
};


export type MutationUpdateTeamChatParticipantsArgs = {
  data: UpdateTeamChatParticipantsInput;
};


export type MutationUpdateTeamGroupChatArgs = {
  data: UpdateTeamGroupChatInput;
};


export type MutationUpdateTeamsArgs = {
  data: TeamsInput;
};


export type MutationUpdateTemplateArgs = {
  data: UpdateTemplateFields;
};


export type MutationUpdateTicketStateArgs = {
  input?: InputMaybe<UpdateTicketStateInput>;
};


export type MutationUpdateTicketTypeArgs = {
  input?: InputMaybe<UpdateTicketTypeInput>;
};


export type MutationUpdateTopicArgs = {
  input: UpdateTopicInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateViewFoldersSettingsArgs = {
  input: UpdateViewFoldersSettingsInput;
};


export type MutationUpdateWabaTemplateArgs = {
  data: UpdateWabaTemplateInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationUploadAnnouncementMediaArgs = {
  input: UploadChangelogMediaInput;
};


export type MutationUploadCampaignMediaArgs = {
  input: UploadCampaignMediaInput;
};


export type MutationUploadFilesToRecordArgs = {
  input?: InputMaybe<UploadFileInput>;
};


export type MutationUploadRecordAttachmentArgs = {
  input?: InputMaybe<UploadAttachmentInput>;
};


export type MutationUpsertAppSettingsArgs = {
  input: UpsertAppSettingsInput;
};


export type MutationUpsertFlowWebhookTriggerArgs = {
  input: UpsertFlowWebhookTriggerInput;
};


export type MutationVerifyEmailArgs = {
  data: VerifyEmailInput;
};


export type MutationVerifyTwoFactorAuthenticationArgs = {
  data: VerifyTwoFactorAuthenticationInput;
};

export type MuteTeamChatInput = {
  customerId: Scalars['ID']['input'];
  isMuted: Scalars['Boolean']['input'];
  teamConversationId: Scalars['ID']['input'];
};

export type MyTeamsResponse = {
  __typename?: 'MyTeamsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TeamsAndCPersonsType;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NeedChargeLimitInput = {
  chargeAmount?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type NeedChargeLimitType = {
  __typename?: 'NeedChargeLimitType';
  chargeAmount?: Maybe<Scalars['Int']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type NewExternalApi = {
  __typename?: 'NewExternalApi';
  _id: Scalars['ID']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  privateToken?: Maybe<Scalars['String']['output']>;
  scopes: Array<Maybe<PermissionScopeOutput>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NewWebhook = {
  __typename?: 'NewWebhook';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  endpointUrl: Scalars['String']['output'];
  events: Array<WebhookEventType>;
  name: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  status: WebhookStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NoteRecord = {
  content?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  conversationSound?: Maybe<Scalars['String']['output']>;
  exportContacts?: Maybe<ConvNotificationstype>;
  exportReport?: Maybe<ConvNotificationstype>;
  exportTableRecords?: Maybe<ConvNotificationstype>;
  importContacts?: Maybe<ConvNotificationstype>;
  importRecordsToTable?: Maybe<ConvNotificationstype>;
  messageSound?: Maybe<Scalars['String']['output']>;
  mobilePushNotifications?: Maybe<MobilePushNotificationsEnum>;
  newCommentInAssignedTableRecord?: Maybe<ConvNotificationstype>;
  newConversationAssignedToMe?: Maybe<ConvNotificationstype>;
  newMessagesInConversationsAssignedToMe?: Maybe<ConvNotificationstype>;
  newMessagesInUnassignedConversations?: Maybe<ConvNotificationstype>;
  newPrivateChatMessage?: Maybe<ConvNotificationstype>;
  newTableRecordAssignedToMe?: Maybe<ConvNotificationstype>;
  newTeamChatMessage?: Maybe<ConvNotificationstype>;
  newUnassignedConversation?: Maybe<ConvNotificationstype>;
  noteMention?: Maybe<ConvNotificationstype>;
  notificationCardEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationSoundVolume?: Maybe<Scalars['Int']['output']>;
  qpienAnnouncements?: Maybe<QpienAnnouncementNotificationType>;
  taskCommentMention?: Maybe<ConvNotificationstype>;
  taskReminder?: Maybe<ConvNotificationstype>;
  trackingDomainVerified?: Maybe<ConvNotificationstype>;
};

export type NotificationSettingsInput = {
  conversationSound?: InputMaybe<Scalars['String']['input']>;
  exportContacts?: InputMaybe<ConvNotificationsInput>;
  exportReport?: InputMaybe<ConvNotificationsInput>;
  exportTableRecords?: InputMaybe<ConvNotificationsInput>;
  importContacts?: InputMaybe<ConvNotificationsInput>;
  importRecordsToTable?: InputMaybe<ConvNotificationsInput>;
  messageSound?: InputMaybe<Scalars['String']['input']>;
  mobilePushNotifications?: InputMaybe<MobilePushNotificationsEnum>;
  newCommentInAssignedTableRecord?: InputMaybe<ConvNotificationsInput>;
  newConversationAssignedToMe?: InputMaybe<ConvNotificationsInput>;
  newMessagesInConversationsAssignedToMe?: InputMaybe<ConvNotificationsInput>;
  newMessagesInUnassignedConversations?: InputMaybe<ConvNotificationsInput>;
  newPrivateChatMessage?: InputMaybe<ConvNotificationsInput>;
  newTableRecordAssignedToMe?: InputMaybe<ConvNotificationsInput>;
  newTeamChatMessage?: InputMaybe<ConvNotificationsInput>;
  newUnassignedConversation?: InputMaybe<ConvNotificationsInput>;
  noteMention?: InputMaybe<ConvNotificationsInput>;
  notificationCardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSoundVolume?: InputMaybe<Scalars['Int']['input']>;
  qpienAnnouncements?: InputMaybe<QpienAnnouncementNotificationInput>;
  taskCommentMention?: InputMaybe<ConvNotificationsInput>;
  taskReminder?: InputMaybe<ConvNotificationsInput>;
  trackingDomainVerified?: InputMaybe<ConvNotificationsInput>;
};

export enum NotificationsType {
  ExportContacts = 'exportContacts',
  ExportReport = 'exportReport',
  ExportTableRecords = 'exportTableRecords',
  ImportContacts = 'importContacts',
  ImportRecordsToTable = 'importRecordsToTable',
  NewCommentInAssignedTableRecord = 'newCommentInAssignedTableRecord',
  NewConversationAssignedToMe = 'newConversationAssignedToMe',
  NewMessagesInConversationsAssignedToMe = 'newMessagesInConversationsAssignedToMe',
  NewMessagesInUnassignedConversations = 'newMessagesInUnassignedConversations',
  NewPrivateChatMessage = 'newPrivateChatMessage',
  NewTableRecordAssignedToMe = 'newTableRecordAssignedToMe',
  NewTeamChatMessage = 'newTeamChatMessage',
  NewUnassignedConversation = 'newUnassignedConversation',
  NoteMention = 'noteMention',
  QpienAnnouncements = 'qpienAnnouncements',
  TaskCommentMention = 'taskCommentMention',
  TaskReminder = 'taskReminder',
  TrackingDomainVerified = 'trackingDomainVerified'
}

export type OActionResponse = {
  __typename?: 'OActionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Action>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OAiProfileResponse = {
  __typename?: 'OAiProfileResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<AiProfile>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OAuthToken = {
  __typename?: 'OAuthToken';
  accessToken: Scalars['String']['output'];
  expiresIn?: Maybe<Scalars['String']['output']>;
};

export type OAuthenticationResponse = {
  __typename?: 'OAuthenticationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Authentication>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OBulkSharingProcessType = {
  __typename?: 'OBulkSharingProcessType';
  customer?: Maybe<Scalars['String']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
};

export type OBulkSharingResponse = {
  __typename?: 'OBulkSharingResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<BulkSharing>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OcPersonNotificationReceivedResponse = {
  __typename?: 'OCPersonNotificationReceivedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CPersonNotificationReceivedPayload>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OcPersonNotificationResponse = {
  __typename?: 'OCPersonNotificationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CPersonNotificationResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCampaignCalculateBalanceResponse = {
  __typename?: 'OCampaignCalculateBalanceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CalculatedBalance>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCampaignResponse = {
  __typename?: 'OCampaignResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Campaign>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCollageProductResponse = {
  __typename?: 'OCollageProductResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CollageProduct>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCollageSharingResponse = {
  __typename?: 'OCollageSharingResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CollageSharing>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCollageTemplateResponse = {
  __typename?: 'OCollageTemplateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CollageTemplate>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OContactCountResponse = {
  __typename?: 'OContactCountResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OControlResponse = {
  __typename?: 'OControlResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OConvSidebarAllResponse = {
  __typename?: 'OConvSidebarAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedConvSidebar>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OConvSidebarResponse = {
  __typename?: 'OConvSidebarResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ConversationSidebar>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OConvViewResponse = {
  __typename?: 'OConvViewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ConversationView>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OConvViewsAllResponse = {
  __typename?: 'OConvViewsAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedConvView>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OConversationResponse = {
  __typename?: 'OConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ConversationSubscriptionType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCouponCodeResponse = {
  __typename?: 'OCouponCodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CouponCode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCouponCodesResponse = {
  __typename?: 'OCouponCodesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<CouponCode>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomExtensionActionResponse = {
  __typename?: 'OCustomExtensionActionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<HttpTestResponseType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomExtensionResponse = {
  __typename?: 'OCustomExtensionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomExtension>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomExtensionTabActionResponse = {
  __typename?: 'OCustomExtensionTabActionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomExtensionTabActionData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomExtensionsAllResponse = {
  __typename?: 'OCustomExtensionsAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedCustomExtension>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomerPersonActivityLogResponse = {
  __typename?: 'OCustomerPersonActivityLogResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerPersonActivityLog>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomerPersonResponse = {
  __typename?: 'OCustomerPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerPerson>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomerPersonStringResponse = {
  __typename?: 'OCustomerPersonStringResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomerPersonTypingResponse = {
  __typename?: 'OCustomerPersonTypingResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerPersonTypingResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomerPhotoResponse = {
  __typename?: 'OCustomerPhotoResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OCustomerResponse = {
  __typename?: 'OCustomerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Customer>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ODelayedActionResponse = {
  __typename?: 'ODelayedActionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<DelayedAction>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ODelayedActionsAllResponse = {
  __typename?: 'ODelayedActionsAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedDelayedAction>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OeCommerceCustomerResponse = {
  __typename?: 'OECommerceCustomerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OeCommerceOrderResponse = {
  __typename?: 'OECommerceOrderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OExternalApiResponse = {
  __typename?: 'OExternalApiResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ExternalApi>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OFolderRes = {
  __typename?: 'OFolderRes';
  folderLink?: Maybe<Scalars['String']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  telegramStatus?: Maybe<Scalars['String']['output']>;
  whatsAppStatus?: Maybe<Scalars['String']['output']>;
};

export type OForgotPasswordResponse = {
  __typename?: 'OForgotPasswordResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OImageType = {
  __typename?: 'OImageType';
  height?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OLoginUrlResponse = {
  __typename?: 'OLoginUrlResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['LoginUrl']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OMessageAckResponse = {
  __typename?: 'OMessageAckResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MessageAckData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OMessageResponse = {
  __typename?: 'OMessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Message>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OMessageToMeResponse = {
  __typename?: 'OMessageToMeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MessageToMeSubscriptionInputType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OPersonResponse = {
  __typename?: 'OPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Person>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OPlatformResponse = {
  __typename?: 'OPlatformResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OProductResponse = {
  __typename?: 'OProductResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Product>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OQuickAnswerResponse = {
  __typename?: 'OQuickAnswerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<QuickAnswer>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OResetPasswordTokenResponse = {
  __typename?: 'OResetPasswordTokenResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OSendCampaignResponse = {
  __typename?: 'OSendCampaignResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OTagResponse = {
  __typename?: 'OTagResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Tag>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OTagsAllResponse = {
  __typename?: 'OTagsAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedTag>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OTaskLogsResponse = {
  __typename?: 'OTaskLogsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedTaskLog>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OTaskResponse = {
  __typename?: 'OTaskResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Task>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OTasksAllResponse = {
  __typename?: 'OTasksAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedTask>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OTeamsResponse = {
  __typename?: 'OTeamsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Teams>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OTemplateCardInput = {
  template?: InputMaybe<TemplateIdInput>;
};

export type OTypingStatusUpdatedResponse = {
  __typename?: 'OTypingStatusUpdatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TypingStatusUpdatedSubscriptionResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OUpdatedCampaignResponse = {
  __typename?: 'OUpdatedCampaignResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OUpdatedGroupResponse = {
  __typename?: 'OUpdatedGroupResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OUserResponse = {
  __typename?: 'OUserResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OVideoType = {
  __typename?: 'OVideoType';
  height?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OWaBaTemplateDataResponse = {
  __typename?: 'OWaBaTemplateDataResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OWebhookResponse = {
  __typename?: 'OWebhookResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Webhook>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum OnboardingAiInterest {
  NotNow = 'NOT_NOW',
  SomewhatInterested = 'SOMEWHAT_INTERESTED',
  VeryInterested = 'VERY_INTERESTED'
}

export enum OnboardingChannel {
  CallCenter = 'CALL_CENTER',
  Email = 'EMAIL',
  Instagram = 'INSTAGRAM',
  LiveChat = 'LIVE_CHAT',
  Marketplaces = 'MARKETPLACES',
  Messenger = 'MESSENGER',
  Tiktok = 'TIKTOK',
  Whatsapp = 'WHATSAPP'
}

export enum OnboardingMonthlyVolume {
  Gt_50K = 'GT_50K',
  Lt_1K = 'LT_1K',
  V1K_5K = 'V1K_5K',
  V5K_10K = 'V5K_10K',
  V10K_25K = 'V10K_25K',
  V25K_50K = 'V25K_50K'
}

export enum OnboardingPlatform {
  Agesoft = 'AGESOFT',
  Faprika = 'FAPRIKA',
  Ideasoft = 'IDEASOFT',
  Ikas = 'IKAS',
  NoEcommerce = 'NO_ECOMMERCE',
  Other = 'OTHER',
  Platinmarket = 'PLATINMARKET',
  Qukasoft = 'QUKASOFT',
  Shopify = 'SHOPIFY',
  Ticimax = 'TICIMAX',
  Tsoft = 'TSOFT',
  Woocommerce = 'WOOCOMMERCE'
}

export enum OnboardingSector {
  Automotive = 'AUTOMOTIVE',
  Cosmetics = 'COSMETICS',
  Education = 'EDUCATION',
  Electronics = 'ELECTRONICS',
  Fashion = 'FASHION',
  Finance = 'FINANCE',
  FoodGrocery = 'FOOD_GROCERY',
  Health = 'HEALTH',
  HomeLiving = 'HOME_LIVING',
  Logistics = 'LOGISTICS',
  Other = 'OTHER',
  ServicesSaas = 'SERVICES_SAAS',
  Tourism = 'TOURISM',
  Wholesale = 'WHOLESALE'
}

export enum OnboardingSource {
  AiRecommendation = 'AI_RECOMMENDATION',
  EmailNewsletter = 'EMAIL_NEWSLETTER',
  Event = 'EVENT',
  Friend = 'FRIEND',
  GoogleAds = 'GOOGLE_ADS',
  GoogleSearch = 'GOOGLE_SEARCH',
  Other = 'OTHER',
  Partner = 'PARTNER',
  QpienReachedOut = 'QPIEN_REACHED_OUT',
  SocialMedia = 'SOCIAL_MEDIA',
  SocialMediaAds = 'SOCIAL_MEDIA_ADS',
  Webinar = 'WEBINAR'
}

export enum OnboardingStep {
  AccountCustomized = 'accountCustomized',
  AiAgentTrained = 'aiAgentTrained',
  ChannelConnected = 'channelConnected',
  IntroVideoWatched = 'introVideoWatched',
  MobileAppDownloaded = 'mobileAppDownloaded',
  TeamInvited = 'teamInvited'
}

export enum OnboardingTeamSize {
  Solo = 'SOLO',
  T1_4 = 'T1_4',
  T5_10 = 'T5_10',
  T11_20 = 'T11_20',
  T21_50 = 'T21_50',
  T50Plus = 'T50_PLUS'
}

export type OperatorBlockResponse = {
  __typename?: 'OperatorBlockResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorChat = {
  __typename?: 'OperatorChat';
  id: Scalars['ID']['output'];
  messages: Array<OperatorMessage>;
  title: Scalars['String']['output'];
};

export type OperatorChatResponse = {
  __typename?: 'OperatorChatResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OperatorChat>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorChatSummary = {
  __typename?: 'OperatorChatSummary';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastMessageAt: Scalars['String']['output'];
  lastText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type OperatorChatsResponse = {
  __typename?: 'OperatorChatsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<OperatorChatSummary>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorChoiceInput = {
  clarifyId: Scalars['String']['input'];
  field: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/**
 * What the user is looking at: the open conversation and the rows of their list (at most 1,000 each).
 * qpien-ai turns ids into a card's targets only; api-v2 re-checks every one against the inbox scope.
 */
export type OperatorContextInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  listedContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  listedConversationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['String']['input']>;
  screen?: InputMaybe<Scalars['String']['input']>;
  selectedContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedConversationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OperatorCustomerInput = {
  customerId: Scalars['ID']['input'];
};

export type OperatorImage = {
  __typename?: 'OperatorImage';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type OperatorInsightInput = {
  customerId: Scalars['ID']['input'];
  insightId: Scalars['ID']['input'];
};

export type OperatorJobInput = {
  customerId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};

export type OperatorJsonResponse = {
  __typename?: 'OperatorJsonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorMember = {
  __typename?: 'OperatorMember';
  avatar?: Maybe<Scalars['String']['output']>;
  cPersonId: Scalars['ID']['output'];
  credits: Scalars['Float']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasAccess: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleId?: Maybe<Scalars['ID']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
};

export type OperatorMembersResponse = {
  __typename?: 'OperatorMembersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<OperatorMember>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorMessage = {
  __typename?: 'OperatorMessage';
  blocks: Array<Scalars['JSON']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  credits?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<OperatorImage>>;
  queryId?: Maybe<Scalars['ID']['output']>;
  role: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  work?: Maybe<OperatorWork>;
};

export type OperatorProgress = {
  __typename?: 'OperatorProgress';
  at: Scalars['String']['output'];
  chatId: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export type OperatorQueryInput = {
  chatId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  queryId: Scalars['ID']['input'];
};

export type OperatorReportInput = {
  customerId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type OperatorRun = {
  __typename?: 'OperatorRun';
  cPersonId: Scalars['ID']['output'];
  context?: Maybe<OperatorRunContext>;
  createdAt: Scalars['String']['output'];
  credits: Scalars['Float']['output'];
  decision?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<OperatorRunError>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  request: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tools: Array<OperatorRunTool>;
  userName: Scalars['String']['output'];
};

export type OperatorRunContext = {
  __typename?: 'OperatorRunContext';
  conversationId?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Scalars['Int']['output']>;
  listed?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  screen?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Int']['output']>;
};

export type OperatorRunError = {
  __typename?: 'OperatorRunError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export type OperatorRunProgressInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type OperatorRunProgressResponse = {
  __typename?: 'OperatorRunProgressResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OperatorProgress>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorRunTool = {
  __typename?: 'OperatorRunTool';
  durationMs?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  params?: Maybe<Scalars['JSON']['output']>;
  records?: Maybe<Scalars['Float']['output']>;
};

export type OperatorRunsPage = {
  __typename?: 'OperatorRunsPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<OperatorRun>;
};

export type OperatorRunsResponse = {
  __typename?: 'OperatorRunsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OperatorRunsPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorStatus = {
  __typename?: 'OperatorStatus';
  hasAccess: Scalars['Boolean']['output'];
};

export type OperatorStatusResponse = {
  __typename?: 'OperatorStatusResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OperatorStatus>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorTurn = {
  __typename?: 'OperatorTurn';
  chatId: Scalars['ID']['output'];
  messages: Array<OperatorMessage>;
};

export type OperatorTurnResponse = {
  __typename?: 'OperatorTurnResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OperatorTurn>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorUsage = {
  __typename?: 'OperatorUsage';
  addonCancelAtPeriodEnd: Scalars['Boolean']['output'];
  addonId?: Maybe<Scalars['ID']['output']>;
  addonLimit: Scalars['Float']['output'];
  addonNextCredits?: Maybe<Scalars['Int']['output']>;
  canRun: Scalars['Boolean']['output'];
  freeLimit: Scalars['Float']['output'];
  hasAddon: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  overageUsdPerCredit: Scalars['Float']['output'];
  payingFromBalance: Scalars['Boolean']['output'];
  remaining: Scalars['Float']['output'];
  renewsAt?: Maybe<Scalars['String']['output']>;
  used: Scalars['Float']['output'];
};

export type OperatorUsageDay = {
  __typename?: 'OperatorUsageDay';
  credits: Scalars['Float']['output'];
  date: Scalars['String']['output'];
};

export type OperatorUsageFeature = {
  __typename?: 'OperatorUsageFeature';
  credits: Scalars['Float']['output'];
  feature: Scalars['String']['output'];
  runs: Scalars['Int']['output'];
};

export type OperatorUsageResponse = {
  __typename?: 'OperatorUsageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OperatorUsage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorUsageStats = {
  __typename?: 'OperatorUsageStats';
  byFeature: Array<OperatorUsageFeature>;
  daily: Array<OperatorUsageDay>;
  usage: OperatorUsage;
};

export type OperatorUsageStatsResponse = {
  __typename?: 'OperatorUsageStatsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OperatorUsageStats>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorWork = {
  __typename?: 'OperatorWork';
  durationMs: Scalars['Int']['output'];
  steps: Array<Scalars['String']['output']>;
};

export type OptimizeAiGuidanceContentInput = {
  category: AiGuidanceCategoryEnum;
  content: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type OptimizeAiGuidanceContentResponse = {
  __typename?: 'OptimizeAiGuidanceContentResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OptimizeAiGuidanceContentResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OptimizeAiGuidanceContentResult = {
  __typename?: 'OptimizeAiGuidanceContentResult';
  optimizedContent: Scalars['String']['output'];
  wasImproved: Scalars['Boolean']['output'];
};

export type OrderConfirmationLabelInputType = {
  isOn?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type OrderConfirmationLabelType = {
  __typename?: 'OrderConfirmationLabelType';
  isOn?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type OrderConfirmationMessageInputType = {
  ar?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  isOn?: InputMaybe<Scalars['Boolean']['input']>;
  ru?: InputMaybe<Scalars['String']['input']>;
  tr?: InputMaybe<Scalars['String']['input']>;
};

export type OrderConfirmationMessageType = {
  __typename?: 'OrderConfirmationMessageType';
  ar?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  isOn?: Maybe<Scalars['Boolean']['output']>;
  ru?: Maybe<Scalars['String']['output']>;
  tr?: Maybe<Scalars['String']['output']>;
};

export enum OrderPaymentType {
  BankTransfer = 'BANK_TRANSFER',
  CashOnDelivery = 'CASH_ON_DELIVERY',
  CheckoutLink = 'CHECKOUT_LINK',
  CreditCard = 'CREDIT_CARD',
  CreditCartDelivery = 'CREDIT_CART_DELIVERY'
}

export type OrdersResponse = {
  __typename?: 'OrdersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: GetOrdersListResponse;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PGroupConditionsType = {
  __typename?: 'PGroupConditionsType';
  rule?: Maybe<PersonFilterRuleType>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PPlatformsType = {
  __typename?: 'PPlatformsType';
  channelPersonId?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['ID']['output']>;
  platformType?: Maybe<PlatformType>;
};

export type PaginateCHistory = {
  __typename?: 'PaginateCHistory';
  docs: Array<Maybe<CampaignHistory>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type PaginatedConvSidebar = {
  __typename?: 'PaginatedConvSidebar';
  docs?: Maybe<Array<Maybe<ConversationSidebar>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedConvView = {
  __typename?: 'PaginatedConvView';
  docs?: Maybe<Array<Maybe<ConversationView>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedCountry = {
  __typename?: 'PaginatedCountry';
  docs?: Maybe<Array<Maybe<Country>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedCustomExtension = {
  __typename?: 'PaginatedCustomExtension';
  docs?: Maybe<Array<Maybe<CustomExtension>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedDelayedAction = {
  __typename?: 'PaginatedDelayedAction';
  docs?: Maybe<Array<Maybe<DelayedAction>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedSlaHistory = {
  __typename?: 'PaginatedSlaHistory';
  docs: Array<SlaHistory>;
  hasNextPage: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type PaginatedSlaPolicy = {
  __typename?: 'PaginatedSlaPolicy';
  docs: Array<SlaPolicy>;
  hasNextPage: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type PaginatedStateProvinceCity = {
  __typename?: 'PaginatedStateProvinceCity';
  docs?: Maybe<Array<Maybe<StateProvinceCity>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedTag = {
  __typename?: 'PaginatedTag';
  docs?: Maybe<Array<Maybe<Tag>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedTask = {
  __typename?: 'PaginatedTask';
  docs: Array<Task>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedTaskLog = {
  __typename?: 'PaginatedTaskLog';
  docs?: Maybe<Array<Maybe<TaskLog>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedTemplate = {
  __typename?: 'PaginatedTemplate';
  docs: Array<Maybe<WhatsAppBusinessTemplate>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedWabaTemplate = {
  __typename?: 'PaginatedWabaTemplate';
  docs: Array<Maybe<MetaWhatsAppBusinessTemplate>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type ParsedField = {
  __typename?: 'ParsedField';
  label?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  uiSettings?: Maybe<SectionFieldUiSettings>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ParsedRow = {
  __typename?: 'ParsedRow';
  fields?: Maybe<Array<Maybe<ParsedField>>>;
};

export type ParsedSection = {
  __typename?: 'ParsedSection';
  layout?: Maybe<SectionLayout>;
  rowData?: Maybe<Array<Maybe<ParsedRow>>>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

export type PartialPerson = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['ID']['input']>;
  ownerTeam?: InputMaybe<Scalars['ID']['input']>;
  personCustomFields?: InputMaybe<Array<InputMaybe<PersonCustomFieldsInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPersonCustomFieldsInput = {
  customerId: Scalars['ID']['input'];
  person: Scalars['String']['input'];
};

export type PasswordResetResponse = {
  __typename?: 'PasswordResetResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentCardInfo = {
  __typename?: 'PaymentCardInfo';
  _id?: Maybe<Scalars['ID']['output']>;
  cardAlias?: Maybe<Scalars['String']['output']>;
  cardAssociation?: Maybe<Scalars['String']['output']>;
  cardBankName?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  cvc?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  expireMonth?: Maybe<Scalars['String']['output']>;
  expireYear?: Maybe<Scalars['String']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  systemTime?: Maybe<Scalars['Double']['output']>;
};

export enum PaymentDetailsEnum {
  Charge = 'CHARGE',
  RenewPack = 'RENEW_PACK'
}

export enum PaymentMethodEnum {
  BankTransfer = 'BANK_TRANSFER',
  CreditCard = 'CREDIT_CARD'
}

export enum PaymentStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export enum PaymentType {
  FreeTrial = 'FREE_TRIAL',
  MonthlyRenewalPayment = 'MONTHLY_RENEWAL_PAYMENT',
  OneOffPayment = 'ONE_OFF_PAYMENT',
  YearlyRenewalPayment = 'YEARLY_RENEWAL_PAYMENT'
}

export type PaymentTypesInputType = {
  _id?: InputMaybe<Scalars['String']['input']>;
  isOn?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTypes?: InputMaybe<Scalars['Object']['input']>;
};

export type PaymentTypesResponse = {
  __typename?: 'PaymentTypesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PaymentTypesType;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentTypesType = {
  __typename?: 'PaymentTypesType';
  isOn?: Maybe<Scalars['Boolean']['output']>;
  types?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
};

export type PermissionScopeInput = {
  moduleName: Scalars['String']['input'];
  read: Scalars['Boolean']['input'];
  write: Scalars['Boolean']['input'];
};

export type PermissionScopeOutput = {
  __typename?: 'PermissionScopeOutput';
  moduleName: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

export type Person = {
  __typename?: 'Person';
  _id: Scalars['ID']['output'];
  activePersonCharge24?: Maybe<Scalars['Date']['output']>;
  avatar: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  eCommerceProfileId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailUsagePermission?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['Date']['output']>;
  lastUsedChannel?: Maybe<Scalars['ID']['output']>;
  mergedFrom?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  mergedTo?: Maybe<Scalars['ID']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  ownerTeam?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneUsagePermission?: Maybe<Scalars['Boolean']['output']>;
  platforms?: Maybe<Array<Maybe<PPlatformsType>>>;
  primaryChannel?: Maybe<Scalars['ID']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  username?: Maybe<Scalars['String']['output']>;
  whatsappMarketingOptOut?: Maybe<PersonMarketingOptOut>;
};

export type PersonActicityResponse = {
  __typename?: 'PersonActicityResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Array']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonActivityLog = {
  __typename?: 'PersonActivityLog';
  _id: Scalars['ID']['output'];
  actor?: Maybe<Scalars['ID']['output']>;
  actorType: PersonActivityLogActorType;
  changes?: Maybe<Array<PersonActivityLogChange>>;
  createdAt: Scalars['Date']['output'];
  integration?: Maybe<PersonActivityLogIntegration>;
  note?: Maybe<Scalars['ID']['output']>;
  notePreview?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<PersonActivityLogOwner>;
  person: Scalars['ID']['output'];
  platformId?: Maybe<Scalars['ID']['output']>;
  platformType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<PersonActivityLogTag>;
  type: PersonActivityLogType;
};

export enum PersonActivityLogActorType {
  Ai = 'AI',
  Api = 'API',
  Flow = 'FLOW',
  Import = 'IMPORT',
  Integration = 'INTEGRATION',
  System = 'SYSTEM',
  User = 'USER'
}

export type PersonActivityLogChange = {
  __typename?: 'PersonActivityLogChange';
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type PersonActivityLogIntegration = {
  __typename?: 'PersonActivityLogIntegration';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PersonActivityLogOwner = {
  __typename?: 'PersonActivityLogOwner';
  fromTeam?: Maybe<Scalars['ID']['output']>;
  fromUser?: Maybe<Scalars['ID']['output']>;
  toTeam?: Maybe<Scalars['ID']['output']>;
  toUser?: Maybe<Scalars['ID']['output']>;
};

export type PersonActivityLogPage = {
  __typename?: 'PersonActivityLogPage';
  docs: Array<PersonActivityLog>;
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PersonActivityLogTag = {
  __typename?: 'PersonActivityLogTag';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum PersonActivityLogType {
  Created = 'CREATED',
  NoteAdded = 'NOTE_ADDED',
  NoteDeleted = 'NOTE_DELETED',
  OwnerAssigned = 'OWNER_ASSIGNED',
  TagAdded = 'TAG_ADDED',
  TagRemoved = 'TAG_REMOVED',
  Updated = 'UPDATED'
}

export type PersonActivityLogsResponse = {
  __typename?: 'PersonActivityLogsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PersonActivityLogPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonChannel = {
  __typename?: 'PersonChannel';
  _id: Scalars['ID']['output'];
  channel: Scalars['Object']['output'];
  channelPersonId: Scalars['String']['output'];
  channelType: Scalars['String']['output'];
  conversation: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  customer: Scalars['ID']['output'];
  isSystemSender?: Maybe<Scalars['Boolean']['output']>;
  lastReceivedMessageTime: Scalars['Date']['output'];
  person: Scalars['ID']['output'];
  uniqKey: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PersonChannelResponse = {
  __typename?: 'PersonChannelResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PersonChannel;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonConversationsResponse = {
  __typename?: 'PersonConversationsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<ConversationByPerson>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonCustomFieldResponse = {
  __typename?: 'PersonCustomFieldResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<PersonCustomFields>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonCustomFields = {
  __typename?: 'PersonCustomFields';
  customField?: Maybe<CustomField>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PersonCustomFieldsInput = {
  customField?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonFilterRuleType {
  After = 'AFTER',
  Before = 'BEFORE',
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  Endwith = 'ENDWITH',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  In = 'IN',
  IsEmpty = 'IS_EMPTY',
  IsNotEmpty = 'IS_NOT_EMPTY',
  LessThan = 'LESS_THAN',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  OlderThanDays = 'OLDER_THAN_DAYS',
  Startwith = 'STARTWITH',
  WithinLastDays = 'WITHIN_LAST_DAYS'
}

export type PersonGroup = {
  __typename?: 'PersonGroup';
  _id?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Maybe<PGroupConditionsType>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  users?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type PersonGroupResponse = {
  __typename?: 'PersonGroupResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonGroupsAndCount = {
  __typename?: 'PersonGroupsAndCount';
  docs?: Maybe<Array<Maybe<Group>>>;
  docsCount?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonGroupsCount = {
  __typename?: 'PersonGroupsCount';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonGroupsPaginatedResponse = {
  __typename?: 'PersonGroupsPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<Group>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonMarketingOptOut = {
  __typename?: 'PersonMarketingOptOut';
  at?: Maybe<Scalars['Date']['output']>;
  campaign?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type PersonNote = {
  __typename?: 'PersonNote';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<PersonNoteAuthor>;
  customer: Scalars['ID']['output'];
  person: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PersonNoteAuthor = {
  __typename?: 'PersonNoteAuthor';
  _id: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type PersonNoteResponse = {
  __typename?: 'PersonNoteResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PersonNote>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonNotesPaginate = {
  __typename?: 'PersonNotesPaginate';
  docs: Array<PersonNote>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type PersonNotesPaginateResponse = {
  __typename?: 'PersonNotesPaginateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PersonNotesPaginate>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonPaginate = {
  __typename?: 'PersonPaginate';
  docs: Array<Maybe<Person>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type PersonPicked = {
  __typename?: 'PersonPicked';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type PersonPlatformInput = {
  channelPersonId: Scalars['String']['input'];
  platformId: Scalars['ID']['input'];
  platformType: PlatformType;
};

export enum PersonPlatformtype {
  Amazon = 'AMAZON',
  CustomChannel = 'CUSTOM_CHANNEL',
  Ebay = 'EBAY',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  GoogleBusiness = 'GOOGLE_BUSINESS',
  Hepsiburada = 'HEPSIBURADA',
  Instagram = 'INSTAGRAM',
  Kaufland = 'KAUFLAND',
  LiveChat = 'LIVE_CHAT',
  MetaWhatsAppBusiness = 'META_WHATS_APP_BUSINESS',
  N11 = 'N11',
  Pazarama = 'PAZARAMA',
  Phone = 'PHONE',
  Survey = 'SURVEY',
  Telegram = 'TELEGRAM',
  Tiktok = 'TIKTOK',
  Trendyol = 'TRENDYOL',
  Walmart = 'WALMART',
  WhatsAppBusiness = 'WHATS_APP_BUSINESS',
  WhatsAppWeb = 'WHATS_APP_WEB'
}

export type PersonResponse = {
  __typename?: 'PersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Person;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum PersonSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum PersonSortField {
  Country = 'COUNTRY',
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  Language = 'LANGUAGE',
  LastSeenAt = 'LAST_SEEN_AT',
  Phone = 'PHONE',
  Tags = 'TAGS',
  UpdatedAt = 'UPDATED_AT'
}

export type PersonSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  me?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type PersonSurveyHistory = {
  __typename?: 'PersonSurveyHistory';
  _id?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customerPerson?: Maybe<CustomerPersonPicked>;
  isTicket?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<PersonPicked>;
  rating?: Maybe<RatingType>;
};

export type PersonTimelineEvent = {
  __typename?: 'PersonTimelineEvent';
  _id: Scalars['ID']['output'];
  actor?: Maybe<Scalars['ID']['output']>;
  channelType?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  fromActor?: Maybe<Scalars['ID']['output']>;
  historyType?: Maybe<Scalars['String']['output']>;
  isTicket?: Maybe<Scalars['Boolean']['output']>;
  kind: PersonTimelineKind;
  source?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<PersonTimelineTag>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum PersonTimelineKind {
  AdReferral = 'AD_REFERRAL',
  ConversationEvent = 'CONVERSATION_EVENT',
  ConversationNote = 'CONVERSATION_NOTE',
  TagAdded = 'TAG_ADDED'
}

export type PersonTimelineResponse = {
  __typename?: 'PersonTimelineResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<PersonTimelineEvent>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonTimelineTag = {
  __typename?: 'PersonTimelineTag';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PersonsGroupListResponse = {
  __typename?: 'PersonsGroupListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PersonGroupsAndCount;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonsGroupResponse = {
  __typename?: 'PersonsGroupResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PersonsGroupsForFilterResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonsGroupsForFilterResponse = {
  __typename?: 'PersonsGroupsForFilterResponse';
  docs: Array<Person>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type PersonsPaginateResponse = {
  __typename?: 'PersonsPaginateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PersonPaginate;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PhoneNumberIpAccessInput = {
  ip?: InputMaybe<Scalars['String']['input']>;
  sid?: InputMaybe<Scalars['String']['input']>;
};

export enum PhoneNumberRoutingType {
  AssignToAgent = 'ASSIGN_TO_AGENT',
  AssignToTeam = 'ASSIGN_TO_TEAM'
}

export enum PhoneNumberSoundType {
  AiTts = 'AI_TTS',
  Audio = 'AUDIO',
  System = 'SYSTEM',
  TextToSpeech = 'TEXT_TO_SPEECH'
}

export type PhoneNumberSoundsInput = {
  greeting?: InputMaybe<IPhoneNumberSoundInput>;
  hold?: InputMaybe<IPhoneNumberSoundInput>;
  outsideWorkHours?: InputMaybe<IPhoneNumberSoundInput>;
  queue?: InputMaybe<IPhoneNumberSoundInput>;
  unreachable?: InputMaybe<IPhoneNumberSoundInput>;
};

export type PickListValue = {
  actual_value?: InputMaybe<Scalars['String']['input']>;
};

export type PickListValueOutput = {
  __typename?: 'PickListValueOutput';
  actual_value?: Maybe<Scalars['String']['output']>;
};

export type PlatformActionMethod = {
  method?: InputMaybe<PlatformActionType>;
  type?: InputMaybe<ECommerceIntegrationTypes>;
};

export type PlatformActionMethodOutput = {
  __typename?: 'PlatformActionMethodOutput';
  method?: Maybe<PlatformActionType>;
  type?: Maybe<ECommerceIntegrationTypes>;
};

export enum PlatformActionType {
  CreateNewOrder = 'CREATE_NEW_ORDER',
  GetOrder = 'GET_ORDER',
  GetProduct = 'GET_PRODUCT',
  RecommendProduct = 'RECOMMEND_PRODUCT'
}

export enum PlatformMethodType {
  Custom = 'CUSTOM',
  Template = 'TEMPLATE'
}

export type PlatformResponse = {
  __typename?: 'PlatformResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Object']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlatformSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum PlatformType {
  Amazon = 'AMAZON',
  CustomChannel = 'CUSTOM_CHANNEL',
  Ebay = 'EBAY',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Form = 'FORM',
  GoogleBusiness = 'GOOGLE_BUSINESS',
  Hepsiburada = 'HEPSIBURADA',
  Instagram = 'INSTAGRAM',
  Kaufland = 'KAUFLAND',
  LiveChat = 'LIVE_CHAT',
  MetaWhatsAppBusiness = 'META_WHATS_APP_BUSINESS',
  N11 = 'N11',
  Pazarama = 'PAZARAMA',
  Phone = 'PHONE',
  Survey = 'SURVEY',
  Telegram = 'TELEGRAM',
  Tiktok = 'TIKTOK',
  Trendyol = 'TRENDYOL',
  Walmart = 'WALMART',
  WhatsAppBusiness = 'WHATS_APP_BUSINESS',
  WhatsAppWeb = 'WHATS_APP_WEB'
}

export type PlatformTypeResponse = {
  __typename?: 'PlatformTypeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlatformsResponse = {
  __typename?: 'PlatformsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<Scalars['Object']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Preference = {
  __typename?: 'Preference';
  autoFormalizeInvoices: AutoFormalizeInvoicesPreference;
  requireAccountApproval: Scalars['Boolean']['output'];
};

export type PreferenceResponse = {
  __typename?: 'PreferenceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Preference;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum PreviewAiAnalysisAnalysedOn {
  Closed = 'CLOSED',
  Created = 'CREATED',
  CreatedReopened = 'CREATED_REOPENED',
  Open = 'OPEN',
  OpenReopen = 'OPEN_REOPEN',
  Resolved = 'RESOLVED'
}

export type PreviewAiAnalysisMessageItem = {
  __typename?: 'PreviewAiAnalysisMessageItem';
  _id?: Maybe<Scalars['String']['output']>;
  contentPreview?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  hasReply?: Maybe<Scalars['Boolean']['output']>;
  isCommentOrQuestion?: Maybe<Scalars['Boolean']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  senderType?: Maybe<Scalars['String']['output']>;
};

export type PreviewAiAnalysisMessagesData = {
  __typename?: 'PreviewAiAnalysisMessagesData';
  channelLabel: Scalars['String']['output'];
  channelType?: Maybe<Scalars['String']['output']>;
  formattedPrompt: Array<PreviewAiAnalysisPromptTurn>;
  isAllowedToAnalyze: Scalars['Boolean']['output'];
  isTicket: Scalars['Boolean']['output'];
  promptName: Scalars['String']['output'];
  selectedMessages: Array<PreviewAiAnalysisMessageItem>;
  topicsCount: Scalars['Int']['output'];
  willRunInProduction: Scalars['Boolean']['output'];
};

export type PreviewAiAnalysisMessagesInput = {
  analyseOn: PreviewAiAnalysisAnalysedOn;
  conversationId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type PreviewAiAnalysisMessagesResponse = {
  __typename?: 'PreviewAiAnalysisMessagesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PreviewAiAnalysisMessagesData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PreviewAiAnalysisPromptTurn = {
  __typename?: 'PreviewAiAnalysisPromptTurn';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type PreviousMessagePreview = {
  __typename?: 'PreviousMessagePreview';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  isAiGenerated?: Maybe<Scalars['Boolean']['output']>;
  role: Scalars['String']['output'];
};

export enum PreviousMessagesRole {
  Assistant = 'assistant',
  User = 'user'
}

export type PreviousMessagesType = {
  content: Scalars['String']['input'];
  role: PreviousMessagesRole;
};

export type Product = {
  __typename?: 'Product';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  features?: Maybe<ProductFeatureType>;
  limits?: Maybe<ProductLimitsType>;
  monthlyPrice?: Maybe<Scalars['Double']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  yearlyPrice?: Maybe<Scalars['Double']['output']>;
};

export type ProductCardSettings = {
  __typename?: 'ProductCardSettings';
  discountedPrice: Scalars['Boolean']['output'];
  mainImage: Scalars['Boolean']['output'];
  salePrice: Scalars['Boolean']['output'];
  title: Scalars['Boolean']['output'];
};

export type ProductCardSettingsInput = {
  discountedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  mainImage?: InputMaybe<Scalars['Boolean']['input']>;
  salePrice?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProductDataSource {
  Manual = 'MANUAL',
  ScanBarCode = 'SCAN_BAR_CODE',
  UploadBarCode = 'UPLOAD_BAR_CODE'
}

export type ProductFeatureInput = {
  AiAgent?: InputMaybe<Scalars['Boolean']['input']>;
  AiAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  AiClosingNote?: InputMaybe<Scalars['Boolean']['input']>;
  AiClosingSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  AiClosingTag?: InputMaybe<Scalars['Boolean']['input']>;
  AiStartFlow?: InputMaybe<Scalars['Boolean']['input']>;
  AiStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  ai?: InputMaybe<Scalars['Boolean']['input']>;
  aiAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  aiImageRecognition?: InputMaybe<Scalars['Boolean']['input']>;
  autoAway?: InputMaybe<Scalars['Boolean']['input']>;
  automation?: InputMaybe<Scalars['Boolean']['input']>;
  automationEcommerce?: InputMaybe<Scalars['Boolean']['input']>;
  automationFlowBots?: InputMaybe<Scalars['Boolean']['input']>;
  automationFlowBotsHttpRequest?: InputMaybe<Scalars['Boolean']['input']>;
  automationFlowBotsStartFlow?: InputMaybe<Scalars['Boolean']['input']>;
  bulkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  campaignEngineV2?: InputMaybe<Scalars['Boolean']['input']>;
  channelOwner?: InputMaybe<Scalars['Boolean']['input']>;
  channels?: InputMaybe<Scalars['Boolean']['input']>;
  channelsCustomChannel?: InputMaybe<Scalars['Boolean']['input']>;
  channelsEcommerce?: InputMaybe<Scalars['Boolean']['input']>;
  channelsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  channelsFacebookComment?: InputMaybe<Scalars['Boolean']['input']>;
  channelsFacebookDm?: InputMaybe<Scalars['Boolean']['input']>;
  channelsInstagramComment?: InputMaybe<Scalars['Boolean']['input']>;
  channelsInstagramDm?: InputMaybe<Scalars['Boolean']['input']>;
  channelsLiveChat?: InputMaybe<Scalars['Boolean']['input']>;
  channelsLiveChatRemoveQpienLogo?: InputMaybe<Scalars['Boolean']['input']>;
  channelsMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  channelsMetaWhatsAppBusinessApi?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhone?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneCallAiAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneCallRecord?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneCallTranscripts?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneInboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneOutboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhoneTestToSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  channelsPhonelVR?: InputMaybe<Scalars['Boolean']['input']>;
  channelsSms?: InputMaybe<Scalars['Boolean']['input']>;
  channelsTelegram?: InputMaybe<Scalars['Boolean']['input']>;
  channelsTiktokComment?: InputMaybe<Scalars['Boolean']['input']>;
  channelsTiktokDm?: InputMaybe<Scalars['Boolean']['input']>;
  channelsWhatsAppBusinessApi?: InputMaybe<Scalars['Boolean']['input']>;
  channelsWhatsAppWeb?: InputMaybe<Scalars['Boolean']['input']>;
  collageSharing?: InputMaybe<Scalars['Boolean']['input']>;
  contacts?: InputMaybe<Scalars['Boolean']['input']>;
  contactsDynamicGroups?: InputMaybe<Scalars['Boolean']['input']>;
  contactsExport?: InputMaybe<Scalars['Boolean']['input']>;
  contactsImport?: InputMaybe<Scalars['Boolean']['input']>;
  contactsMergeContacts?: InputMaybe<Scalars['Boolean']['input']>;
  customReports?: InputMaybe<Scalars['Boolean']['input']>;
  dashboard?: InputMaybe<Scalars['Boolean']['input']>;
  inbox?: InputMaybe<Scalars['Boolean']['input']>;
  inboxBulkActions?: InputMaybe<Scalars['Boolean']['input']>;
  inboxCustomViews?: InputMaybe<Scalars['Boolean']['input']>;
  inboxMessageTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  inboxPrivateMessage?: InputMaybe<Scalars['Boolean']['input']>;
  messageSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  removeEmailQpienLogo?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['Boolean']['input']>;
  settingsActions?: InputMaybe<Scalars['Boolean']['input']>;
  settingsApiKeys?: InputMaybe<Scalars['Boolean']['input']>;
  settingsAuthentications?: InputMaybe<Scalars['Boolean']['input']>;
  settingsAutoAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  settingsCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  settingsQuickAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  settingsSlaPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  settingsSurveys?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTags?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTeamGoals?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTeams?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTopics?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTopicsAutoFill?: InputMaybe<Scalars['Boolean']['input']>;
  settingsUserRoles?: InputMaybe<Scalars['Boolean']['input']>;
  settingsUsers?: InputMaybe<Scalars['Boolean']['input']>;
  settingsWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  snooze?: InputMaybe<Scalars['Boolean']['input']>;
  statistics?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsAbandonedCarts?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsConversationTags?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsConversations?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsMessages?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsPerformance?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsSatisfactions?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsUsers?: InputMaybe<Scalars['Boolean']['input']>;
  tables?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  teamChat?: InputMaybe<Scalars['Boolean']['input']>;
  userActivity?: InputMaybe<Scalars['Boolean']['input']>;
  zohoIntegration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFeatureType = {
  __typename?: 'ProductFeatureType';
  AiAgent?: Maybe<Scalars['Boolean']['output']>;
  AiAssistant?: Maybe<Scalars['Boolean']['output']>;
  AiClosingNote?: Maybe<Scalars['Boolean']['output']>;
  AiClosingSurvey?: Maybe<Scalars['Boolean']['output']>;
  AiClosingTag?: Maybe<Scalars['Boolean']['output']>;
  AiStartFlow?: Maybe<Scalars['Boolean']['output']>;
  AiStatistics?: Maybe<Scalars['Boolean']['output']>;
  ai?: Maybe<Scalars['Boolean']['output']>;
  aiAnalysis?: Maybe<Scalars['Boolean']['output']>;
  aiImageRecognition?: Maybe<Scalars['Boolean']['output']>;
  autoAway?: Maybe<Scalars['Boolean']['output']>;
  automation?: Maybe<Scalars['Boolean']['output']>;
  automationEcommerce?: Maybe<Scalars['Boolean']['output']>;
  automationFlowBots?: Maybe<Scalars['Boolean']['output']>;
  automationFlowBotsHttpRequest?: Maybe<Scalars['Boolean']['output']>;
  automationFlowBotsStartFlow?: Maybe<Scalars['Boolean']['output']>;
  bulkSharing?: Maybe<Scalars['Boolean']['output']>;
  campaignEngineV2?: Maybe<Scalars['Boolean']['output']>;
  channelOwner?: Maybe<Scalars['Boolean']['output']>;
  channels?: Maybe<Scalars['Boolean']['output']>;
  channelsCustomChannel?: Maybe<Scalars['Boolean']['output']>;
  channelsEcommerce?: Maybe<Scalars['Boolean']['output']>;
  channelsEmail?: Maybe<Scalars['Boolean']['output']>;
  channelsFacebookComment?: Maybe<Scalars['Boolean']['output']>;
  channelsFacebookDm?: Maybe<Scalars['Boolean']['output']>;
  channelsInstagramComment?: Maybe<Scalars['Boolean']['output']>;
  channelsInstagramDm?: Maybe<Scalars['Boolean']['output']>;
  channelsLiveChat?: Maybe<Scalars['Boolean']['output']>;
  channelsLiveChatRemoveQpienLogo?: Maybe<Scalars['Boolean']['output']>;
  channelsMarketplace?: Maybe<Scalars['Boolean']['output']>;
  channelsMetaWhatsAppBusinessApi?: Maybe<Scalars['Boolean']['output']>;
  channelsPhone?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneCallAiAnalysis?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneCallRecord?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneCallTranscripts?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneInboundCalls?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneOutboundCalls?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneSurvey?: Maybe<Scalars['Boolean']['output']>;
  channelsPhoneTestToSpeech?: Maybe<Scalars['Boolean']['output']>;
  channelsPhonelVR?: Maybe<Scalars['Boolean']['output']>;
  channelsSms?: Maybe<Scalars['Boolean']['output']>;
  channelsTelegram?: Maybe<Scalars['Boolean']['output']>;
  channelsTiktokComment?: Maybe<Scalars['Boolean']['output']>;
  channelsTiktokDm?: Maybe<Scalars['Boolean']['output']>;
  channelsWhatsAppBusinessApi?: Maybe<Scalars['Boolean']['output']>;
  channelsWhatsAppWeb?: Maybe<Scalars['Boolean']['output']>;
  collageSharing?: Maybe<Scalars['Boolean']['output']>;
  contacts?: Maybe<Scalars['Boolean']['output']>;
  contactsDynamicGroups?: Maybe<Scalars['Boolean']['output']>;
  contactsExport?: Maybe<Scalars['Boolean']['output']>;
  contactsImport?: Maybe<Scalars['Boolean']['output']>;
  contactsMergeContacts?: Maybe<Scalars['Boolean']['output']>;
  customReports?: Maybe<Scalars['Boolean']['output']>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  inbox?: Maybe<Scalars['Boolean']['output']>;
  inboxBulkActions?: Maybe<Scalars['Boolean']['output']>;
  inboxCustomViews?: Maybe<Scalars['Boolean']['output']>;
  inboxMessageTranslation?: Maybe<Scalars['Boolean']['output']>;
  inboxPrivateMessage?: Maybe<Scalars['Boolean']['output']>;
  messageSchedule?: Maybe<Scalars['Boolean']['output']>;
  removeEmailQpienLogo?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<Scalars['Boolean']['output']>;
  settingsActions?: Maybe<Scalars['Boolean']['output']>;
  settingsApiKeys?: Maybe<Scalars['Boolean']['output']>;
  settingsAuthentications?: Maybe<Scalars['Boolean']['output']>;
  settingsAutoAssignment?: Maybe<Scalars['Boolean']['output']>;
  settingsCustomFields?: Maybe<Scalars['Boolean']['output']>;
  settingsQuickAnswers?: Maybe<Scalars['Boolean']['output']>;
  settingsSlaPolicies?: Maybe<Scalars['Boolean']['output']>;
  settingsSurveys?: Maybe<Scalars['Boolean']['output']>;
  settingsTags?: Maybe<Scalars['Boolean']['output']>;
  settingsTeamGoals?: Maybe<Scalars['Boolean']['output']>;
  settingsTeams?: Maybe<Scalars['Boolean']['output']>;
  settingsTopics?: Maybe<Scalars['Boolean']['output']>;
  settingsTopicsAutoFill?: Maybe<Scalars['Boolean']['output']>;
  settingsUserRoles?: Maybe<Scalars['Boolean']['output']>;
  settingsUsers?: Maybe<Scalars['Boolean']['output']>;
  settingsWebhooks?: Maybe<Scalars['Boolean']['output']>;
  snooze?: Maybe<Scalars['Boolean']['output']>;
  statistics?: Maybe<Scalars['Boolean']['output']>;
  statisticsAbandonedCarts?: Maybe<Scalars['Boolean']['output']>;
  statisticsCampaign?: Maybe<Scalars['Boolean']['output']>;
  statisticsConversationTags?: Maybe<Scalars['Boolean']['output']>;
  statisticsConversations?: Maybe<Scalars['Boolean']['output']>;
  statisticsMessages?: Maybe<Scalars['Boolean']['output']>;
  statisticsPerformance?: Maybe<Scalars['Boolean']['output']>;
  statisticsSatisfactions?: Maybe<Scalars['Boolean']['output']>;
  statisticsUsers?: Maybe<Scalars['Boolean']['output']>;
  tables?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  teamChat?: Maybe<Scalars['Boolean']['output']>;
  userActivity?: Maybe<Scalars['Boolean']['output']>;
  zohoIntegration?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProductLimitsInput = {
  aiAnswers?: InputMaybe<Scalars['Int']['input']>;
  aiAssistant?: InputMaybe<Scalars['Int']['input']>;
  amazon?: InputMaybe<Scalars['Int']['input']>;
  apiKeys?: InputMaybe<Scalars['Int']['input']>;
  cPerson?: InputMaybe<Scalars['Int']['input']>;
  cPersonRoles?: InputMaybe<Scalars['Int']['input']>;
  callMinutes?: InputMaybe<Scalars['Int']['input']>;
  customChannel?: InputMaybe<Scalars['Int']['input']>;
  customReports?: InputMaybe<Scalars['Int']['input']>;
  ebay?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['Int']['input']>;
  facebook?: InputMaybe<Scalars['Int']['input']>;
  faprika?: InputMaybe<Scalars['Int']['input']>;
  flowBots?: InputMaybe<Scalars['Int']['input']>;
  googleBusiness?: InputMaybe<Scalars['Int']['input']>;
  hepsiburada?: InputMaybe<Scalars['Int']['input']>;
  ideasoft?: InputMaybe<Scalars['Int']['input']>;
  ikas?: InputMaybe<Scalars['Int']['input']>;
  inboxRules?: InputMaybe<Scalars['Int']['input']>;
  instagram?: InputMaybe<Scalars['Int']['input']>;
  kaufland?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metaWhatsAppBusiness?: InputMaybe<Scalars['Int']['input']>;
  n11?: InputMaybe<Scalars['Int']['input']>;
  operatorCredits?: InputMaybe<Scalars['Int']['input']>;
  pazarama?: InputMaybe<Scalars['Int']['input']>;
  person?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['Int']['input']>;
  qpienShop?: InputMaybe<Scalars['Int']['input']>;
  shopify?: InputMaybe<Scalars['Int']['input']>;
  slaPolicies?: InputMaybe<Scalars['Int']['input']>;
  survey?: InputMaybe<Scalars['Int']['input']>;
  tableRecords?: InputMaybe<Scalars['Int']['input']>;
  tables?: InputMaybe<Scalars['Int']['input']>;
  teams?: InputMaybe<Scalars['Int']['input']>;
  telegram?: InputMaybe<Scalars['Int']['input']>;
  ticimax?: InputMaybe<Scalars['Int']['input']>;
  ticket?: InputMaybe<Scalars['Int']['input']>;
  tiktok?: InputMaybe<Scalars['Int']['input']>;
  trendyol?: InputMaybe<Scalars['Int']['input']>;
  tsoft?: InputMaybe<Scalars['Int']['input']>;
  walmart?: InputMaybe<Scalars['Int']['input']>;
  webhooks?: InputMaybe<Scalars['Int']['input']>;
  whatsAppBusiness?: InputMaybe<Scalars['Int']['input']>;
  whatsAppWeb?: InputMaybe<Scalars['Int']['input']>;
  zoho?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductLimitsType = {
  __typename?: 'ProductLimitsType';
  aiAnswers?: Maybe<Scalars['Int']['output']>;
  aiAssistant?: Maybe<Scalars['Int']['output']>;
  amazon?: Maybe<Scalars['Int']['output']>;
  apiKeys?: Maybe<Scalars['Int']['output']>;
  cPerson?: Maybe<Scalars['Int']['output']>;
  cPersonRoles?: Maybe<Scalars['Int']['output']>;
  callMinutes?: Maybe<Scalars['Int']['output']>;
  customChannel?: Maybe<Scalars['Int']['output']>;
  customReports?: Maybe<Scalars['Int']['output']>;
  ebay?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Int']['output']>;
  facebook?: Maybe<Scalars['Int']['output']>;
  faprika?: Maybe<Scalars['Int']['output']>;
  flowBots?: Maybe<Scalars['Int']['output']>;
  googleBusiness?: Maybe<Scalars['Int']['output']>;
  hepsiburada?: Maybe<Scalars['Int']['output']>;
  ideasoft?: Maybe<Scalars['Int']['output']>;
  ikas?: Maybe<Scalars['Int']['output']>;
  inboxRules?: Maybe<Scalars['Int']['output']>;
  instagram?: Maybe<Scalars['Int']['output']>;
  kaufland?: Maybe<Scalars['Int']['output']>;
  liveChat?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metaWhatsAppBusiness?: Maybe<Scalars['Int']['output']>;
  n11?: Maybe<Scalars['Int']['output']>;
  operatorCredits?: Maybe<Scalars['Int']['output']>;
  pazarama?: Maybe<Scalars['Int']['output']>;
  person?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['Int']['output']>;
  qpienShop?: Maybe<Scalars['Int']['output']>;
  shopify?: Maybe<Scalars['Int']['output']>;
  slaPolicies?: Maybe<Scalars['Int']['output']>;
  survey?: Maybe<Scalars['Int']['output']>;
  tableRecords?: Maybe<Scalars['Int']['output']>;
  tables?: Maybe<Scalars['Int']['output']>;
  teams?: Maybe<Scalars['Int']['output']>;
  telegram?: Maybe<Scalars['Int']['output']>;
  ticimax?: Maybe<Scalars['Int']['output']>;
  ticket?: Maybe<Scalars['Int']['output']>;
  tiktok?: Maybe<Scalars['Int']['output']>;
  trendyol?: Maybe<Scalars['Int']['output']>;
  tsoft?: Maybe<Scalars['Int']['output']>;
  walmart?: Maybe<Scalars['Int']['output']>;
  webhooks?: Maybe<Scalars['Int']['output']>;
  whatsAppBusiness?: Maybe<Scalars['Int']['output']>;
  whatsAppWeb?: Maybe<Scalars['Int']['output']>;
  zoho?: Maybe<Scalars['Int']['output']>;
};

export enum ProductPeriodMode {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type ProductResponse = {
  __typename?: 'ProductResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Product;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductSubscriptionInput = {
  token: Scalars['String']['input'];
};

export type ProductTour = {
  __typename?: 'ProductTour';
  boardsCompletedAt?: Maybe<Scalars['Date']['output']>;
  mainCompletedAt?: Maybe<Scalars['Date']['output']>;
  mainSkippedAt?: Maybe<Scalars['Date']['output']>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  welcomeVideoWatchedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProductTourResponse = {
  __typename?: 'ProductTourResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ProductTour>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductsResponse = {
  __typename?: 'ProductsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Product>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgressUpdatePersonResponse = {
  __typename?: 'ProgressUpdatePersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ProgressUpdatePersonType;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgressUpdatePersonType = {
  __typename?: 'ProgressUpdatePersonType';
  message?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Float']['output'];
  taskId: Scalars['ID']['output'];
};

export type PublishChangelogInput = {
  _id: Scalars['ID']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublishLiveChatWidgetReleaseInput = {
  files: Array<Scalars['FileUpload']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type PublishSkillInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  expectedDraftRevision: Scalars['Int']['input'];
};

export type PublishedChangelogResponse = {
  __typename?: 'PublishedChangelogResponse';
  data?: Maybe<Scalars['Object']['output']>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum QpienActionModule {
  Conversation = 'conversation',
  QpienShop = 'qpien_shop',
  Whatsapp = 'whatsapp'
}

export enum QpienActionOperation {
  FindWhatsappTemplate = 'find_whatsapp_template',
  GetConversation = 'get_conversation',
  ShopQueryCustomer = 'shop_query_customer',
  ShopQueryOrder = 'shop_query_order',
  ShopQueryProduct = 'shop_query_product',
  ShopUpdateCustomer = 'shop_update_customer',
  ShopUpdateOrder = 'shop_update_order'
}

export type QpienActionTemplateConditionInput = {
  channelOwner: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type QpienActionTemplateConditionType = {
  __typename?: 'QpienActionTemplateConditionType';
  channelOwner?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateLanguage?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type QpienAnnouncementNotificationInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
  whatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QpienAnnouncementNotificationType = {
  __typename?: 'QpienAnnouncementNotificationType';
  email?: Maybe<Scalars['Boolean']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  web?: Maybe<Scalars['Boolean']['output']>;
  whatsapp?: Maybe<Scalars['Boolean']['output']>;
};

export type QpienFields = {
  exampleData: Scalars['String']['input'];
  key: Scalars['Int']['input'];
  ref: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QpienShopCategories = {
  __typename?: 'QpienShopCategories';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QpienShopCustomerAddressData = {
  __typename?: 'QpienShopCustomerAddressData';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lastName: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type QpienShopDraftOrderAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type QpienShopDraftOrderItemInput = {
  customUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type QpienShopExternalOrder = {
  __typename?: 'QpienShopExternalOrder';
  billingAddress?: Maybe<QpienShopExternalOrderShippingAndBillingAddress>;
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  customer?: Maybe<QpienShopExternalOrderCustomer>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationType: ECommerceIntegrationTypes;
  items?: Maybe<Array<Maybe<QpienShopExternalOrderItem>>>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderPackages?: Maybe<Array<Maybe<QpienShopExternalOrderPackage>>>;
  packageStatus?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<QpienShopExternalOrderShippingAndBillingAddress>;
  shippingLine?: Maybe<QpienShopExternalOrderShippingLine>;
  status: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
  taxTotal?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type QpienShopExternalOrderCustomer = {
  __typename?: 'QpienShopExternalOrderCustomer';
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type QpienShopExternalOrderItem = {
  __typename?: 'QpienShopExternalOrderItem';
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unit_price: Scalars['Float']['output'];
  variant_id: Scalars['String']['output'];
};

export type QpienShopExternalOrderPackage = {
  __typename?: 'QpienShopExternalOrderPackage';
  id?: Maybe<Scalars['ID']['output']>;
  order_line_item_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  order_package_fulfill_status?: Maybe<Scalars['String']['output']>;
  tracking_info?: Maybe<QpienShopExternalOrderPackageTrackingInfo>;
};

export type QpienShopExternalOrderPackageTrackingInfo = {
  __typename?: 'QpienShopExternalOrderPackageTrackingInfo';
  cargo_company?: Maybe<Scalars['String']['output']>;
  tracking_number?: Maybe<Scalars['String']['output']>;
  tracking_url?: Maybe<Scalars['String']['output']>;
};

export type QpienShopExternalOrderShippingAndBillingAddress = {
  __typename?: 'QpienShopExternalOrderShippingAndBillingAddress';
  address_1: Scalars['String']['output'];
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country_code: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type QpienShopExternalOrderShippingLine = {
  __typename?: 'QpienShopExternalOrderShippingLine';
  amount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type QpienShopFieldMappingInput = {
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  field: Scalars['String']['input'];
  personField?: InputMaybe<Scalars['String']['input']>;
};

export type QpienShopFieldMappingType = {
  __typename?: 'QpienShopFieldMappingType';
  customFieldId?: Maybe<Scalars['ID']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  personField?: Maybe<Scalars['String']['output']>;
};

export type QpienShopFlowFieldType = {
  __typename?: 'QpienShopFlowFieldType';
  group?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QpienShopFlowFieldsData = {
  __typename?: 'QpienShopFlowFieldsData';
  connected?: Maybe<Scalars['Boolean']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  resultFields?: Maybe<Array<Maybe<QpienShopFlowFieldType>>>;
  searchFields?: Maybe<Array<Maybe<QpienShopFlowFieldType>>>;
  supported?: Maybe<Scalars['Boolean']['output']>;
  updateFields?: Maybe<Array<Maybe<QpienShopFlowFieldType>>>;
};

export type QpienShopFlowFieldsInput = {
  customerId: Scalars['ID']['input'];
  operation: QpienActionOperation;
};

export type QpienShopFlowFieldsResponse = {
  __typename?: 'QpienShopFlowFieldsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<QpienShopFlowFieldsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QpienShopFlowPreviewInput = {
  customerId: Scalars['ID']['input'];
  operation: QpienActionOperation;
  searchBy: QpienShopSearchBy;
  searchValue: Scalars['String']['input'];
  searchValueSecondary?: InputMaybe<Scalars['String']['input']>;
};

export type QpienShopFlowPreviewResponse = {
  __typename?: 'QpienShopFlowPreviewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QpienShopOptions = {
  __typename?: 'QpienShopOptions';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  values: Array<QpienShopOptionsValue>;
};

export type QpienShopOptionsValue = {
  __typename?: 'QpienShopOptionsValue';
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type QpienShopOrder = {
  __typename?: 'QpienShopOrder';
  createdAt: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  currentTotal: Scalars['Float']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerExternalId?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fulfillmentStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrationType?: Maybe<ECommerceIntegrationTypes>;
  paymentStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type QpienShopOrderAddressInput = {
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type QpienShopOrderDetail = {
  __typename?: 'QpienShopOrderDetail';
  billingAddress?: Maybe<QpienShopOrderShippingAndBillingAddress>;
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  currentTotal: Scalars['Float']['output'];
  customer?: Maybe<GetQpienShopCustomer>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  discountTotal?: Maybe<Scalars['Float']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  fulfillmentStatus?: Maybe<Scalars['String']['output']>;
  fulfillments?: Maybe<Array<QpienShopOrderFulfillment>>;
  id: Scalars['ID']['output'];
  integrationType: ECommerceIntegrationTypes;
  items: Array<QpienShopOrderItemDetail>;
  paymentStatus: Scalars['String']['output'];
  shipping?: Maybe<QpienShopOrderShipping>;
  shippingAddress?: Maybe<QpienShopOrderShippingAndBillingAddress>;
  shippingMethods: Array<QpienShopShippingMethod>;
  shippingTotal: Scalars['Float']['output'];
  status: Scalars['String']['output'];
};

export type QpienShopOrderFulfillment = {
  __typename?: 'QpienShopOrderFulfillment';
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<QpienShopOrderFulfillmentItem>>>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type QpienShopOrderFulfillmentItem = {
  __typename?: 'QpienShopOrderFulfillmentItem';
  itemId: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export enum QpienShopOrderFulfillmentStatus {
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Fulfilled = 'FULFILLED',
  NotFulfilled = 'NOT_FULFILLED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  Shipped = 'SHIPPED'
}

export type QpienShopOrderItemDetail = {
  __typename?: 'QpienShopOrderItemDetail';
  deliveredQuantity?: Maybe<Scalars['Int']['output']>;
  fulfilledQuantity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  returnDismissedQuantity?: Maybe<Scalars['Int']['output']>;
  returnReceivedQuantity?: Maybe<Scalars['Int']['output']>;
  returnRequestedQuantity?: Maybe<Scalars['Int']['output']>;
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  writtenOffQuantity?: Maybe<Scalars['Int']['output']>;
};

export type QpienShopOrderItemInput = {
  quantity: Scalars['Int']['input'];
  unit_price?: InputMaybe<Scalars['Float']['input']>;
  variant_id: Scalars['String']['input'];
};

export enum QpienShopOrderPaymentStatus {
  Authorized = 'AUTHORIZED',
  Awaiting = 'AWAITING',
  Canceled = 'CANCELED',
  Captured = 'CAPTURED',
  NotPaid = 'NOT_PAID',
  PartiallyAuthorized = 'PARTIALLY_AUTHORIZED',
  PartiallyCaptured = 'PARTIALLY_CAPTURED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Refunded = 'REFUNDED',
  RequiresAction = 'REQUIRES_ACTION'
}

export type QpienShopOrderShipping = {
  __typename?: 'QpienShopOrderShipping';
  carrier?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  estimatedDelivery?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  shippedAt?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type QpienShopOrderShippingAndBillingAddress = {
  __typename?: 'QpienShopOrderShippingAndBillingAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export enum QpienShopOrderStatus {
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  RequiresAction = 'REQUIRES_ACTION'
}

export type QpienShopOrdersData = {
  __typename?: 'QpienShopOrdersData';
  count: Scalars['Int']['output'];
  externalOrders?: Maybe<Array<QpienShopExternalOrder>>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  orders: Array<QpienShopOrder>;
};

export type QpienShopPrice = {
  __typename?: 'QpienShopPrice';
  amount: Scalars['Float']['output'];
  currency_code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type QpienShopProduct = {
  __typename?: 'QpienShopProduct';
  categories?: Maybe<Array<QpienShopCategories>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Maybe<Scalars['String']['output']>>;
  metadata?: Maybe<Scalars['Object']['output']>;
  options?: Maybe<Array<QpienShopOptions>>;
  platformProductId?: Maybe<Scalars['String']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  variants: Array<QpienShopProductVariant>;
};

export type QpienShopProductVariant = {
  __typename?: 'QpienShopProductVariant';
  barcode?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  discountedPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inventory_quantity?: Maybe<Scalars['Int']['output']>;
  isTaxIncluded?: Maybe<Scalars['Boolean']['output']>;
  mid_code?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<QpienShopProductVariantOptions>>;
  platformVariantId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  prices?: Maybe<Array<Maybe<QpienShopPrice>>>;
  sku?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  totalStock?: Maybe<Scalars['Number']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<QpienShopWeight>;
};

export type QpienShopProductVariantOption = {
  __typename?: 'QpienShopProductVariantOption';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type QpienShopProductVariantOptions = {
  __typename?: 'QpienShopProductVariantOptions';
  id: Scalars['ID']['output'];
  option: QpienShopProductVariantOption;
  value: Scalars['String']['output'];
};

export type QpienShopProducts = {
  __typename?: 'QpienShopProducts';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  products: Array<Maybe<QpienShopProduct>>;
};

export enum QpienShopSearchBy {
  Brand = 'brand',
  Category = 'category',
  CustomerExternalId = 'customer_external_id',
  Email = 'email',
  Group = 'group',
  Name = 'name',
  OrderNumber = 'order_number',
  OrderNumberAndPhone = 'order_number_and_phone',
  Phone = 'phone',
  Title = 'title'
}

export type QpienShopShippingMethod = {
  __typename?: 'QpienShopShippingMethod';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type QpienShopShippingMethodInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shipping_option_id?: InputMaybe<Scalars['String']['input']>;
};

export enum QpienShopStoreStoreStatus {
  Active = 'ACTIVE',
  Approval = 'APPROVAL',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum QpienShopStoreType {
  Qpienshop = 'QPIENSHOP'
}

export type QpienShopUpdateFieldInput = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QpienShopUpdateFieldType = {
  __typename?: 'QpienShopUpdateFieldType';
  field?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QpienShopWeight = {
  __typename?: 'QpienShopWeight';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  adminGetOperatorRun: OperatorJsonResponse;
  adminListOperatorRuns: AdminOperatorRunsResponse;
  adminOperatorRunHealth: OperatorJsonResponse;
  allAddOns: AddOnsResponse;
  analyzeAiMessageRun: AnalyzeAiMessageRunResponse;
  analyzeCampaign: AnalyzeCampaignResponse;
  availableCallCustomerPersons: AvailableCallCustomerPersonsListResponse;
  calculateAddOnCost: CostResponse;
  calculateBalanceUsage: OCampaignCalculateBalanceResponse;
  checkResetPasswordToken: OResetPasswordTokenResponse;
  checkSelectedTargets: CheckSelectedTargetsOutput;
  compareCampaigns: CompareCampaignsResponse;
  controlPersonToken: OControlResponse;
  couponCode: CouponCodeResponse;
  couponCodes: CouponCodesResponse;
  customConversationsQuery: CustomConversationsQueryOutput;
  customerPersons: CustomerPersonsListResponse;
  customerTeams: CustomerPersonsResponse;
  drillDownReportWidgetData: DrillDownReportWidgetDataResultResponse;
  explainAiMessageStep: ExplainAiMessageStepResponse;
  exportConvTagStatistics: ExportConvTagHistoryStatisticResponse;
  exportConversationAllMessages: ExportConversationAllMessagesResponse;
  exportConversationDashboardStatistics: ExportedConversationDashboardStatisticsResponse;
  exportConversationStatistics: ExportConversationStatisticsResponse;
  exportMsgStatistics: ExportMsgStatisticsRes;
  exportSurveyHistoryPersonStatistics: SurveyHistoryPersonStatisticsExportResponse;
  exportTopicComparisonStatistics: ExportTopicComparisonStatisticsResponse;
  exportTopicStatistics: ExportedTopicStatisticsResponse;
  externalGetAllConnectedPlatformList: ExternalAllConnectedPlatformsResponse;
  externalGetContacts: ExternalContactsPaginatedResponse;
  externalGetConversation: ExternalConversationResponse;
  externalGetConversationList: ExternalConversationsPaginatedResponse;
  externalGetCustomerPerson: ExternalCustomerPersonResponse;
  externalGetCustomerPersonList: ExternalCustomerPersonsPaginatedResponse;
  externalGetMessage: ExternalMessageResponse;
  externalGetMessageList: ExternalMessagesPaginatedResponse;
  externalGetWhatsappBusinessTemplate: ExternalWhatsappBusinessTemplateResponse;
  externalGetWhatsappBusinessTemplateList: ExternalWhatsappBusinessTemplatesPaginatedResponse;
  findAllPlatformQuery: PlatformsResponse;
  getActions: ActionsPaginatedResponse;
  getActiveConvMessages: MessagesResponse;
  getAddOn: AddOnResponse;
  getAdminAnnouncements?: Maybe<ChangelogListResponse>;
  getAdminCampaignLinks: AdminCampaignLinksResponse;
  getAdminCustomerPayments: AdminCustomerPaymentPaginatedResponse;
  getAiAnalysisByCallSid: AiAnalysisResponse;
  getAiAnalysisSettings: AiAnalysisSettingsResponse;
  getAiAnswerExplanation: AiAnswerExplanationResponse;
  getAiAssistant: AiAssistantResponse;
  /**
   * The customer's STOREFRONT e-commerce integrations, marked with which one the E-commerce AI
   * role is currently shopping from. Marketplaces are deliberately absent: they are managed
   * from their own integration settings, where their catalogue is read per seller. Empty when
   * the customer has connected no store yet — the panel then sends them to integration settings.
   */
  getAiConnectableStores: AiConnectableStoresResponse;
  getAiConversationStatistics: AiConversationStatisticsResult;
  getAiEngineRouting: AiEngineRoutingResponse;
  getAiEvalMessage: AiEvalMessageResultResponse;
  getAiGuidance: AiGuidanceResponse;
  getAiGuidanceList: AiGuidancePaginatedResponse;
  getAiHelpArticle: AiHelpArticleResponse;
  getAiHelpArticles: AiHelpArticlesResponse;
  getAiHelpGaps: AiHelpGapsResponse;
  getAiKnowledgeSourceContent: AiKnowledgeSourceContentResponse;
  getAiProductFaqs?: Maybe<AiProductFaqResponse>;
  /**
   * The catalogue's product image index behind "use product images": whether it runs and how far
   * it got. Indexing follows the store's own sync — there is nothing to trigger by hand.
   */
  getAiProductImageIndex: AiProductImageIndexResponse;
  /** Admin panel only: every tenant with "use product images" on, with progress, failures and cost. */
  getAiProductImageIndexes: AiProductImageIndexesResponse;
  /** Omit `role` to get the customer's last-used role. `data` is null when no role is set up yet. */
  getAiProfile: AiProfileResponse;
  getAiRoles: AiRolesResponse;
  getAiSizeChartAttributeValues: AiSizeChartAttributeValuesResponse;
  /** Options for the ATTRIBUTE filter: product attribute names from every connected channel. */
  getAiSizeChartAttributes: AiSizeChartAttributesResponse;
  /** Options for the CATEGORY filter, with how many active products each covers (subcategories included). */
  getAiSizeChartCategories: AiSizeChartCategoriesResponse;
  getAiSizeChartGroup: AiSizeChartGroupResponse;
  /** Named product sets a chart can cover instead of listing products one by one. */
  getAiSizeChartGroups: AiSizeChartGroupsResponse;
  /**
   * AI training > Size charts. Stored in qpien-shop-v2 per tenant (not per store); the AI reads the
   * one(s) that fit a product through the `get_size_guide` commerce tool.
   */
  getAiSizeCharts: AiSizeChartsResponse;
  /**
   * What the store can take an AI order with. A pay-later field is null when the platform publishes
   * no payment methods (Shopify), so the merchant's switch alone decides; false locks it in the panel.
   */
  getAiStoreOrderingOptions: AiStoreOrderingOptionsResponse;
  /**
   * One store's catalogue — the role's bound store (AI > Store > Products), or the integration
   * named by `integrationStoreId`/`platformType` (the marketplace product screens, AI Test).
   */
  getAiStoreProducts: AiStoreProductsResponse;
  getAiTtsModelSettings: AiTtsModelSettingsResponse;
  getAiTtsVoices: AiTtsVoicesResponse;
  getAllAiKnowledgeSourceContent: AiKnowledgeSourceContentPaginatedResult;
  getAllAiKnowledgeSources: AiKnowledgeSourcePaginatedResponse;
  getAllAiSuggestions: AiSuggestionPaginatedResponse;
  getAllBalanceHistory: BalanceUsageResponse;
  getAllConnectedPlatform: AllChannelTypeResponse;
  getAllTaskLogs: Array<Maybe<TaskLog>>;
  getAllTemplatesPaginate: AllTemplatesPaginatedResponse;
  getAllWabaTemplatesPaginate: AllWabaTemplatesPaginatedResponse;
  getAlreadyConnectedStore: GetAlreadyConnectedStoreResponse;
  getAnnouncementCategories?: Maybe<ChangelogCategoryListResponse>;
  getAppSettings: AppSettingsResponse;
  getAskQuestionEvalMock: AskQuestionEvalMockResponse;
  getAskQuestionEvalRun: AskQuestionEvalRunResponse;
  getAuthentications: AuthenticationsPaginatedResponse;
  getBalanceUsageStatistics: BalanceUsageStatisticsResponse;
  getBarcodeCustomExtensionAction: OCustomExtensionActionResponse;
  getBulkSharings: BulkSharingPaginateRes;
  getBusinessHoursSchedules: BusinessHoursSchedulesResponse;
  getCMsgStatusStatistic: CMsgStatusStatisticRes;
  getCPersonNotificationUnreadCount: CPersonNotificationUnreadResponse;
  getCPersonNotifications: CPersonNotificationsResponse;
  getCPersonRole: CPersonRoleResponse;
  getCPersonRoleList: CPersonRoleListResponse;
  getCPersonStatistics?: Maybe<CustomerPersonHistoriesResponse>;
  getCallAdminLogDetail: CallAdminLogDetailResponse;
  getCallAdminLogs: CallAdminLogsResponse;
  getCallDashboardStatistics: CallDashboardStatisticsResult;
  getCallHistoryActiveCPersons: CallHistoryActiveCPersonsResult;
  getCallHistoryAverageTimeChartData: CallHistoryAverageTimeChartDataResult;
  getCallHistoryCountByDirection: CallHistoryCountByDirectionResult;
  getCallHistoryCountChartData: CallHistoryCountChartDataResult;
  getCallHistoryCustomerPersons: CallHistoryCustomerPersonsResult;
  getCallHistorySatisfactionChartData: CallHistorySatisfactionChartDataResult;
  getCallHistorySentimentChartData: CallHistorySentimentChartDataResult;
  getCallHistorySlaAgentStatistics: CallHistorySlaAgentStatisticsResult;
  getCallHistorySlaStatusStatistics: CallHistorySlaStatusStatisticsResult;
  getCallHistorySlaSummaryStatistics: CallHistorySlaSummaryStatisticsResult;
  getCallHistorySlaTimeStatistics: CallHistorySlaTimeStatisticsResult;
  getCallHistoryTalkListenChartData: CallHistoryTalkListenChartDataResult;
  getCallHistoryTopicsChartData: CallHistoryTopicsChartDataResult;
  getCallHistoryTotalCostChartData: CallHistoryTotalCostChartDataResult;
  getCallLogByCallSid: CallLogResponse;
  getCallLogs: CallLogsResponse;
  getCallSnapshotCrossSnapshotsStatistics: CallSnapshotStatisticsResponse;
  getCallSnapshotsStatistics: CallSnapshotStatisticsResponse;
  getCampaign: GetCampaignResponse;
  getCampaignCalendar: CampaignCalendarResponse;
  getCampaignConversions: CampaignConversionPageResponse;
  getCampaignHistoryStatistic: CampaignStatisticRes;
  getCampaignRecipientTimeline: CampaignRecipientTimelineResponse;
  getCampaignRecipients: CampaignRecipientPageResponse;
  getCampaignReport: CampaignReportResponse;
  getCampaignTags: CampaignTagsResponse;
  getCampaignTrackingBase: CampaignTrackingBaseResponse;
  getCampaigns?: Maybe<CampaignListResponse>;
  getChangelogDeliveries?: Maybe<ChangelogDeliveryListResponse>;
  getChangelogSettings?: Maybe<ChangelogSettingsResponse>;
  getChangelogSubscribers?: Maybe<ChangelogSubscriberListResponse>;
  getChangelogWhatsAppAccounts?: Maybe<ChangelogObjectListResponse>;
  getChangelogWhatsAppTemplates?: Maybe<ChangelogObjectListResponse>;
  getChannelOwnerTemplates: ChannelOwnerTemplatesResponse;
  getCollageBarcode: CollageBarcodeResponse;
  getCollageFolders: CollageFolderPaginatedResponse;
  getCollageProducts: CollageProductPaginatedResponse;
  getCollageSettings: CollageSettingsResponse;
  getCollageSharings: CollageSharingPaginatedResponse;
  getCollageTemplates: CollageTemplatePaginatedResponse;
  getConnectedPlatforms: ConnectedPlatformResponse;
  /** Whether segment conditions on orders are available (a store connected through qpien-shop-v2). */
  getContactOrderStatsStatus: ContactOrderStatsStatusResponse;
  getContactsCount: OContactCountResponse;
  getConvCounts: ConvCounResType;
  getConvTagStatistics: ConvTagStatisticsResponse;
  getConversation: GetConversationResponse;
  getConversationAdAttribution: ConversationAdAttributionResponse;
  getConversationAdReferrals: ConversationAdReferralsResponse;
  getConversationByPersonId: ConversationsByPersonIdResponse;
  getConversationCrossSnapshotStatistics: ConversationSnapshotStatisticsResponse;
  getConversationDashboardStatistics: ConversationDashboardStatisticsResponse;
  getConversationHistorySentiment: ConversationHistorySentimentResponse;
  getConversationHistoryTopics: ConversationHistoryTopicsResponse;
  getConversationSidebar: ConvSidebarResponse;
  getConversationSidebarList: OConvSidebarAllResponse;
  getConversationSnapshotStatistics: ConversationSnapshotStatisticsResponse;
  getConversationSourcesReport: ConversationSourcesReportResponse;
  getConversationStatistics: StatisticsResponse;
  getConversationView: ConvViewResponse;
  getConversationViewPreference: ConversationViewPreferenceResponse;
  getConversationViewsList: OConvViewsAllResponse;
  getConversations: ConversationsResponse;
  getConversationsByUniqId: ConversationsByPersoResponse;
  getCustomExtension: CustomExtensionResponse;
  getCustomExtensionAction: OCustomExtensionActionResponse;
  getCustomExtensionFields: CustomExtensionFieldsResponse;
  getCustomExtensionTabAction: OCustomExtensionTabActionResponse;
  getCustomExtensionsList: OCustomExtensionsAllResponse;
  getCustomFields: CustomFieldsAllResponse;
  getCustomerAbandonedOrder: CustomerAbandonedOrderResponse;
  getCustomerBillingAddresses?: Maybe<CustomerBillingAddressesOutput>;
  getCustomerBillingContacts: CustomerBillingContactsResponse;
  getCustomerById: CustomerResponse;
  getCustomerInvoices: CustomerInvoicePaginatedResponse;
  getCustomerOnboardingInfo: CustomerOnboardingInfoOutput;
  getCustomerOwner: PersonResponse;
  getCustomerOwners?: Maybe<GetCustomerOwnersResponse>;
  getCustomerOwnersCount?: Maybe<GetCustomerOwnersCountResponse>;
  getCustomerPaymentCard: CustomerPaymentCardOutput;
  getCustomerPerson: CustomerPersonResponse;
  getCustomerPersonActivityLogs: CustomerPersonActivityLogsPaginatedResponse;
  getCustomerProduct: CustomerProductResponse;
  getCustomerRobot: PersonResponse;
  getCustomerWorkingHours: UpdateWorkingHourOutput;
  getDelayedAction: DelayedActionResponse;
  getDelayedActionsList: ODelayedActionsAllResponse;
  getDomain: DomainResponse;
  getECommerceCheckouts: CheckoutsResponse;
  getECommerceCustomers: ECommerceCustomersResponse;
  getECommerceIntegrationLogs: GetECommerceIntegrationLogsOutput;
  getECommerceIntegrations: GetECommerceIntegrationsOutput;
  getECommerceLinkedCustomer: ECommerceLinkedCustomerResponse;
  getECommerceOrders: OrdersResponse;
  getECommercePlatformType: PlatformTypeResponse;
  getECommercePlatforms: ECommercePlatformsResponse;
  getECommerceProducts: ECommerceProductsResponse;
  getECommerceRules?: Maybe<ECommerceRulesResponse>;
  getECommerceStoreCargoCompanies: CargoCompaniesResponse;
  getECommerceStorePaymentTypes: PaymentTypesResponse;
  getECommerceVariants: ECommerceVariantsResponse;
  getEcommerceRulesHistoryStatistic?: Maybe<ECommerceRulesHistoryStatisticResponse>;
  getEmailAdminLogs: EmailAdminLogsResponse;
  getExternalApis: ExternalApisPaginatedResponse;
  getFeedbackSurvey: SurveyFeedbackResponse;
  getFlowBot: GetFlowBotResponse;
  getFlowBotPaginated: GetFlowBotPaginatedResponse;
  getFlowConversationPreview: FlowConversationPreviewResponse;
  getFlowNode: GetFlowNodeResponse;
  getFlowNodePaginated: GetFlowNodePaginatedResponse;
  getFlowRunSteps: GetFlowRunStepsResponse;
  getFlowRunsPaginated: GetFlowRunsResponse;
  getFlowWebhookTrigger: FlowWebhookTriggerResponse;
  getGroupList: GetGroupsListResponse;
  /**
   * One tab of the Home "Dashboard statistics" widget: every metric card for that tab
   * plus the two-period daily series for the selected metric.
   *
   * Cards and series come back together on purpose — a single request lands on a single
   * pod, which is what lets the snapshot layer's in-flight de-duplication collapse the
   * shared denominators of the AI rates into one query. It also means the card row and
   * the chart paint in the same frame (no reflow).
   *
   * Tabs are lazy: ask for the active tab only.
   *
   * Every window resolves in the REQUESTING AGENT's timezone (`CustomerPersons.timeZone`), not the
   * tenant's; see `dateRange` on the input and `currentPeriod.timezone` on the result.
   */
  getHomeDashboardStatistics: HomeDashboardStatisticsResponse;
  getHumanReplyLearningJob: HumanReplyLearningJobResponse;
  getHumanReplyLearningJobs: HumanReplyLearningJobsResponse;
  getHumanReplyLearningStatus: HumanReplyLearningJobResponse;
  getInboundWebhookLogs: InboundWebhookLogsPaginatedResponse;
  getInboundWebhooks: InboundWebhooksPaginatedResponse;
  getIntegrations: IntegrationsResponse;
  getJoinedGroups: JoinedGroupsResponse;
  getLiveChatWidgetInvalidation?: Maybe<LiveChatWidgetInvalidationResponse>;
  getLiveChatWidgetOverview?: Maybe<LiveChatWidgetOverviewResponse>;
  getLiveChatWidgetRelease?: Maybe<LiveChatWidgetReleaseResponse>;
  getLiveChatWidgetReleases?: Maybe<LiveChatWidgetReleaseListResponse>;
  getLocationCountries?: Maybe<CountryResponse>;
  getLocationStateProvinceCity?: Maybe<StateProvinceCityResponse>;
  getLocationStatesProvincesCities?: Maybe<StatesProvincesCitiesResponse>;
  getLoginUrl: ECommerceCustomPlatformsResponse;
  getMarketplaceOrders: MarketplaceOrdersResponse;
  getMessageCrossSnapshotStatistics: MessageSnapshotStatisticsResponse;
  getMessageForAiSimulation: MessageForAiSimulationResponse;
  getMessageSnapshotStatistics: MessageSnapshotStatisticsResponse;
  getMetaAdsAdsets: MetaAdsAdsetsResponse;
  getMetaAdsAuthUrl: MetaAdsAuthUrlResponse;
  getMetaAdsCampaigns: MetaAdsCampaignsResponse;
  getMetaBusinessConnection: MetaBusinessOverviewResponse;
  /** Run history for one migration, newest first. */
  getMigrationHistory: MigrationRunListResponse;
  /** The newest run per migration type, for the list page's 'last run' column. */
  getMigrationLatestRuns: MigrationRunListResponse;
  getMobileAppVersion: MobileAppVersionCheckResponse;
  getMobileAppVersionConfigs?: Maybe<MobileAppVersionConfigListResponse>;
  getMsgStatistics: GetMsgStatisticsRes;
  getMyChangelogNotificationPrefs?: Maybe<ChangelogPrefsResponse>;
  getMyChangelogUnreadCount?: Maybe<ChangelogUnreadResponse>;
  getMyTeams: MyTeamsResponse;
  getNewPackageCostInfo: GetNewPackageCostInfoResponse;
  getOperatorChat: OperatorChatResponse;
  getOperatorChats: OperatorChatsResponse;
  getOperatorInsights: OperatorJsonResponse;
  getOperatorJobs: OperatorJsonResponse;
  getOperatorMembers: OperatorMembersResponse;
  getOperatorPreferences: OperatorJsonResponse;
  getOperatorRuns: OperatorRunsResponse;
  getOperatorSavedReport: OperatorJsonResponse;
  getOperatorSavedReports: OperatorJsonResponse;
  getOperatorStatus: OperatorStatusResponse;
  getOperatorUsage: OperatorUsageResponse;
  getOperatorUsageStats: OperatorUsageStatsResponse;
  getPChannel: PersonChannelResponse;
  getPaginatedECommerceRules?: Maybe<ECommerceRulesPaginatedResponse>;
  getPerson: PersonResponse;
  getPersonActivity?: Maybe<IPersonActicityResponse>;
  getPersonActivityLogs: PersonActivityLogsResponse;
  getPersonConversations: PersonConversationsResponse;
  getPersonList: PersonsPaginateResponse;
  getPersonNotes: PersonNotesPaginateResponse;
  getPersonTimeline: PersonTimelineResponse;
  getPersonsCHistoryStatistic: GetPersonsCHistoryStatisticRes;
  getPlatformData: PlatformResponse;
  getPlatforms: PlatformsResponse;
  getPlatformsPaginated: GetPlatformsPaginatedOutput;
  getPopulatedTicketType: TicketTypePopulatedResponse;
  getPreference: PreferenceResponse;
  getPublishedAnnouncements?: Maybe<ChangelogListResponse>;
  getQpienShopCustomerAddresses: GetQpienShopCustomerAddressesResponse;
  getQpienShopCustomers: GetQpienShopCustomersResponse;
  getQpienShopFlowFields: QpienShopFlowFieldsResponse;
  getQpienShopFlowPreview: QpienShopFlowPreviewResponse;
  getQpienShopOrder: GetQpienShopOrderResponse;
  getQpienShopOrders: GetQpienShopOrdersResponse;
  getQpienShopProducts: GetQpienShopProductsResponse;
  getQpienShopStore: GetQpienShopStoreResponse;
  getRecordAttachment: IntegrationRecordAttachmentResponse;
  getRecordAttachmentsList: IntegrationRecordAttachmentsListResponse;
  getRecordNotes: IntegrationRecordNotesResponse;
  getRecordsByPerson: ZohoModuleRecordsResponse;
  getReembedKnowledgeSourcesToContextualRagJob: ReembedKnowledgeSourcesToContextualRagJobResponse;
  getReport: ReportResponse;
  getReportWidgetData: ReportWidgetDataResultResponse;
  getReportWidgetMetricTemplates: ReportWidgetMetricTemplatesResponse;
  getReportWidgetTemplates: ReportWidgetTemplatesResponse;
  getReportWidgets: ReportWidgetsResponse;
  getReports: ReportsResponse;
  getSelectableFields: IntegrationFieldsResponse;
  getSimilarContacts: SimilarContactsResponse;
  getSingleAction: ActionResponse;
  getSingleAuthentication: AuthenticationResponse;
  getSingleCollageFolder: CollageFolderResponse;
  getSingleCollageProduct: CollageProductResponse;
  getSingleCollageSharing: CollageSharingResponse;
  getSingleCollageTemplate: CollageTemplateResponse;
  getSingleCustomerPersonActivityLog: CustomerPersonActivityLogResponse;
  getSingleExternalApi: ExternalApiResponse;
  getSingleInboundWebhook: InboundWebhookResponse;
  getSingleTeam?: Maybe<SingleTeamsResponse>;
  getSingleWebhook: WebhookResponse;
  getSkill: SkillResponse;
  getSkillRun: SkillRunDetailResponse;
  getSkillRunView: SkillRunViewResponse;
  getSlaHistory: SlaHistoryListResponse;
  getSlaInstance: SlaInstanceResponse;
  getSlaPolicies: SlaPolicyListResponse;
  getSlaPolicy: SlaPolicyResponse;
  getSlaReport: SlaReportResponse;
  getSlaStageTimeStatistics: SlaStageTimeStatisticsResponse;
  getSlaStatistics: SlaStatisticsResponse;
  getSlaStatusStatistics: SlaStatusStatisticsResponse;
  getSurvey: SurveyResponse;
  getSurveyCrossSnapshotStatistics: SurveySnapshotStatisticsResponse;
  getSurveyHistoryPersonStatistic: SurveyHistoryStatisticPersonResponse;
  getSurveyHistoryStatistic: SurveyHistoryStatisticResponse;
  getSurveySnapshotStatistics: SurveySnapshotStatisticsResponse;
  getSurveys: SurveysAllResponse;
  getTableFields: TableFieldsResponse;
  getTableFolders: FoldersResponse;
  getTableRecord: TableRecordResponse;
  getTableRecordActivities: TableRecordActivitiesConnectionResponse;
  getTableRecords: TableRecordsConnectionResponse;
  getTableViews: TableViewsResponse;
  getTables: TablesResponse;
  getTag: TagResponse;
  getTagsList: OTagsAllResponse;
  getTaskById: TaskResponse;
  getTaskBySourceId: TasksResponse;
  getTaskComments: TaskCommentsResponse;
  getTaskLogs: OTaskLogsResponse;
  getTasksList: OTasksAllResponse;
  getTeamChat: TeamConversationResponse;
  getTeamChats: TeamChatsResponse;
  getTeamConvMembers: TeamConvMembersResponse;
  getTeamMessages: TeamMessagesResponse;
  getTeamOpenConversationCounts: TeamOpenConversationCountsResponse;
  getTeams: TeamsResponse;
  getTemplate?: Maybe<TemplateResponse>;
  getTicketPriorityStatistics: TicketPriorityStatisticsResponse;
  getTicketStateStatistics: TicketStateStatisticsResponse;
  getTicketStates: TicketStateListResponse;
  getTicketStatistics: TicketStatisticsResponse;
  getTicketType: TicketTypeResponse;
  getTicketTypeStatistics: TicketTypeStatisticsResponse;
  getTicketTypes: TicketTypeListResponse;
  getTimeBasedAudienceCount: GetTimeBasedAudienceCountResponse;
  getTopicComparisonStatistics: TopicComparisonStatisticsResponse;
  getTopicCustomFieldsComparisonStatistics: TopicCustomFieldsComparisonStatisticsResponse;
  getTopicCustomFieldsStatistics: TopicCustomFieldsStatisticsResponse;
  getTopicStatistics: TopicStatisticsResponse;
  getTopics: TopicsResponse;
  getTrackingDomainSettings: TrackingDomainSettingsResponse;
  getTrackingDomainUsage: TrackingDomainUsageResponse;
  getTrackingDomains: TrackingDomainsResponse;
  getTranscriptDetails?: Maybe<TranscriptDetailsResponse>;
  getTranscriptsByCallSid?: Maybe<TranscriptPaginatedResponse>;
  getTranslateLanguage: OControlResponse;
  getUpdateNotification: UpdateNotificationResponse;
  getUrlInfo: UrlResponse;
  getWabaTemplate?: Maybe<WabaTemplateResponse>;
  getWebhooks: WebhooksPaginatedResponse;
  /** Per-state totals for the automation panel folders (no filters applied). */
  getWorkflowStatusCounts: GetWorkflowStatusCountsResponse;
  /** Flow bots and e-commerce rules as one workflow list, with their run counts. */
  getWorkflowsPaginated: GetWorkflowsPaginatedResponse;
  getZohoBlueprintTransitions: ZohoBlueprintTransitionsResponse;
  getZohoModuleFields: ZohoModuleFieldsResponse;
  getZohoModuleTags: ZohoModuleTagsResponse;
  getZohoModules: ZohoModulesResponse;
  getZohoTestRecord: ZohoTestRecordResponse;
  getZohoUsers: ZohoUsersResponse;
  httpTest: HttpTestResponse;
  /**
   * Read-only window onto one collection: named counts, the index list, and a few projected
   * documents. The admin panel declares WHICH migrations exist and how to tell whether each is
   * done, so a new migration is a frontend file — this only answers the questions it asks.
   * There is deliberately no write counterpart; a mutation posted from a browser would turn any
   * XSS in the panel into unrestricted data loss.
   */
  inspectCollection: InspectCollectionResponse;
  listAiConversations: AiMessagesResponse;
  listAiMessageSources: AiMessageSourcesResponse;
  listAiMessageSteps: AiMessageStepsResponse;
  listAiMessages: AiMessagesResponse;
  listAskQuestionEvalMockTemplates: AskQuestionEvalMockTemplatesResponse;
  listAskQuestionEvalMocks: AskQuestionEvalMockListResponse;
  listAskQuestionEvalRuns: AskQuestionEvalRunListResponse;
  listAskQuestionEvalSuites: AskQuestionEvalSuitesResponse;
  listBlockTemplates: ListBlockTemplatesOutput;
  listCampaigns: ListCampaignsResponse;
  listFlowNode: ListFlowNodeResponse;
  listNodeTemplates: ListNodeTemplatesOutput;
  listReusableFlows: ListReusableFlowsResponse;
  listSkillRuns: SkillRunListResponse;
  listSkillVersions: SkillVersionListResponse;
  listSkills: SkillListResponse;
  myProductTour: ProductTourResponse;
  personActivities?: Maybe<PersonActicityResponse>;
  personCustomFields: PersonCustomFieldResponse;
  personGroupList: PersonsGroupResponse;
  previewAiAnalysisMessages: PreviewAiAnalysisMessagesResponse;
  /**
   * How many active products a group with these products and filters would cover, with a sample. Also used for a
   * chart's filters (`groupIds` = its GROUP condition). `coveredIds` = the `checkIds` the filters/groups already include,
   * so the product picker shows them as included instead of letting them be picked again.
   */
  previewAiSizeChartGroup: AiSizeChartGroupPreviewResponse;
  product: ProductResponse;
  products: ProductsResponse;
  quickAnswers: QuickAnswersResponse;
  refreshWhatsAppBusinessTemplates: WaBaTemplateDataResponse;
  resolveCampaignTrackingLink: CampaignTrackingLinkResponse;
  runCustomECommerceIntegration: CustomECommerceIntegrationResponse;
  runCustomIntegrationQuery: CustomIntegrationResponse;
  runCustomPlatformQuery: CustomPlatformsResponse;
  searchAiHelp: AiHelpSearchResponse;
  /**
   * Products for a chart's or group's product picker: by title search, or by id to label a saved
   * selection. `limit` (max 1000) lets the picker add every match of a search at once.
   */
  searchAiSizeChartProducts: AiSizeChartProductsResponse;
  /** Live ads of the connected ad accounts, for the FlowBot ad trigger's picker. */
  searchMetaAds: MetaAdsSearchResponse;
  translateMessageText: TranslateMessageTextResponse;
  user: UserResponse;
  users: UsersResponse;
  validateCampaign: ValidateCampaignResponse;
};


export type QueryAdminGetOperatorRunArgs = {
  data: AdminOperatorRunInput;
};


export type QueryAdminListOperatorRunsArgs = {
  data: AdminOperatorRunsInput;
};


export type QueryAdminOperatorRunHealthArgs = {
  data: AdminOperatorRunHealthInput;
};


export type QueryAnalyzeAiMessageRunArgs = {
  data: AnalyzeAiMessageRunInput;
};


export type QueryAnalyzeCampaignArgs = {
  input: AnalyzeCampaignInput;
};


export type QueryAvailableCallCustomerPersonsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCalculateAddOnCostArgs = {
  data: CalculateAddOnCostInput;
};


export type QueryCalculateBalanceUsageArgs = {
  input: CalculateBalanceUsageInput;
};


export type QueryCheckResetPasswordTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryCheckSelectedTargetsArgs = {
  input?: InputMaybe<CheckSelectedTargetsInput>;
};


export type QueryCompareCampaignsArgs = {
  input: CompareCampaignsInput;
};


export type QueryControlPersonTokenArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCouponCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryCouponCodesArgs = {
  args?: InputMaybe<GetAllCouponCodesInput>;
};


export type QueryCustomConversationsQueryArgs = {
  customer: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchGroupConversation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerPersonsArgs = {
  customerId: Scalars['ID']['input'];
  excludeAi?: InputMaybe<Scalars['Boolean']['input']>;
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  fromLiveChat?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  notSelectBot?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ListSortInput>;
};


export type QueryCustomerTeamsArgs = {
  cPerson: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};


export type QueryDrillDownReportWidgetDataArgs = {
  input: DrillDownReportWidgetDataInput;
};


export type QueryExplainAiMessageStepArgs = {
  data: ExplainAiMessageStepInput;
};


export type QueryExportConvTagStatisticsArgs = {
  data: ExportConvTagHistoryStatisticInput;
};


export type QueryExportConversationAllMessagesArgs = {
  input: ExportConversationAllMessagesInput;
};


export type QueryExportConversationDashboardStatisticsArgs = {
  data: ExportConversationDashboardStatisticsInput;
};


export type QueryExportConversationStatisticsArgs = {
  data: ConvStatusInput;
};


export type QueryExportMsgStatisticsArgs = {
  data: ExportMsgStatisticsInput;
};


export type QueryExportSurveyHistoryPersonStatisticsArgs = {
  input?: InputMaybe<GetSurveyHistoryStatisticPersonInput>;
};


export type QueryExportTopicComparisonStatisticsArgs = {
  input: GetTopicComparisonStatisticsInput;
};


export type QueryExportTopicStatisticsArgs = {
  input: ExportTopicStatisticsInput;
};


export type QueryExternalGetContactsArgs = {
  input: ExternalGetContactsInput;
};


export type QueryExternalGetConversationArgs = {
  input?: InputMaybe<ExternalGetConversationInput>;
};


export type QueryExternalGetConversationListArgs = {
  input: ExternalGetConversationListInput;
};


export type QueryExternalGetCustomerPersonArgs = {
  input?: InputMaybe<ExternalGetCustomerPersonInput>;
};


export type QueryExternalGetCustomerPersonListArgs = {
  input: ExternalGetCustomerPersonListInput;
};


export type QueryExternalGetMessageArgs = {
  input?: InputMaybe<ExternalGetMessageInput>;
};


export type QueryExternalGetMessageListArgs = {
  input: ExternalGetMessageListInput;
};


export type QueryExternalGetWhatsappBusinessTemplateArgs = {
  input?: InputMaybe<ExternalGetWhatsappBusinessTemplateInput>;
};


export type QueryExternalGetWhatsappBusinessTemplateListArgs = {
  input: ExternalGetWhatsappBusinessTemplateListInput;
};


export type QueryFindAllPlatformQueryArgs = {
  metaData: Scalars['Object']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetActionsArgs = {
  input?: InputMaybe<GetActionsInput>;
};


export type QueryGetActiveConvMessagesArgs = {
  data: MessagePaginationInput;
};


export type QueryGetAddOnArgs = {
  input: GetAddOnInput;
};


export type QueryGetAdminAnnouncementsArgs = {
  input?: InputMaybe<ListChangelogInput>;
};


export type QueryGetAdminCampaignLinksArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAdminCustomerPaymentsArgs = {
  input: GetAdminCustomerPaymentsInput;
};


export type QueryGetAiAnalysisByCallSidArgs = {
  callSid: Scalars['String']['input'];
};


export type QueryGetAiAnalysisSettingsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiAnswerExplanationArgs = {
  messageId: Scalars['ID']['input'];
};


export type QueryGetAiAssistantArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiConnectableStoresArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiConversationStatisticsArgs = {
  input?: InputMaybe<AiConversationStatisticsInput>;
};


export type QueryGetAiEvalMessageArgs = {
  customerId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type QueryGetAiGuidanceArgs = {
  data: GetAiGuidanceInput;
};


export type QueryGetAiGuidanceListArgs = {
  data: GetAiGuidanceListInput;
};


export type QueryGetAiHelpArticleArgs = {
  data: AiHelpArticleInput;
};


export type QueryGetAiHelpGapsArgs = {
  data?: InputMaybe<AiHelpGapsInput>;
};


export type QueryGetAiKnowledgeSourceContentArgs = {
  input?: InputMaybe<GetAiKnowledgeSourceContentInput>;
};


export type QueryGetAiProductFaqsArgs = {
  input: GetAiProductFaqsInput;
};


export type QueryGetAiProductImageIndexArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiProfileArgs = {
  customerId: Scalars['ID']['input'];
  role?: InputMaybe<AiRoleEnum>;
};


export type QueryGetAiRolesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiSizeChartAttributeValuesArgs = {
  customerId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAiSizeChartAttributesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiSizeChartCategoriesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiSizeChartGroupArgs = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryGetAiSizeChartGroupsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiSizeChartsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAiStoreOrderingOptionsArgs = {
  customerId: Scalars['ID']['input'];
  storeId: Scalars['ID']['input'];
};


export type QueryGetAiStoreProductsArgs = {
  data: GetAiStoreProductsInput;
};


export type QueryGetAiTtsVoicesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAllAiKnowledgeSourceContentArgs = {
  data: GetAiKnowledgeSourceContentInput;
};


export type QueryGetAllAiKnowledgeSourcesArgs = {
  data: GetAiKnowledgeSourceInput;
};


export type QueryGetAllAiSuggestionsArgs = {
  data: GetAllAiSuggestionInput;
};


export type QueryGetAllBalanceHistoryArgs = {
  data: GetAllBalanceHistoryInput;
};


export type QueryGetAllConnectedPlatformArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetAllTaskLogsArgs = {
  customerId: Scalars['ID']['input'];
  task: Scalars['ID']['input'];
};


export type QueryGetAllTemplatesPaginateArgs = {
  input?: InputMaybe<AllTemplatesPaginatedInput>;
};


export type QueryGetAllWabaTemplatesPaginateArgs = {
  input?: InputMaybe<GetAllWabaTemplatesPaginateInput>;
};


export type QueryGetAlreadyConnectedStoreArgs = {
  customer: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetAppSettingsArgs = {
  input: GetAppSettingsInput;
};


export type QueryGetAskQuestionEvalMockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAskQuestionEvalRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAuthenticationsArgs = {
  input?: InputMaybe<GetAuthenticationsInput>;
};


export type QueryGetBalanceUsageStatisticsArgs = {
  input: GetBalanceUsageStatisticsInput;
};


export type QueryGetBarcodeCustomExtensionActionArgs = {
  input?: InputMaybe<GetBarcodeCustomExtensionActionInput>;
};


export type QueryGetBulkSharingsArgs = {
  input?: InputMaybe<GetBulkSharingInput>;
};


export type QueryGetBusinessHoursSchedulesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCMsgStatusStatisticArgs = {
  input?: InputMaybe<CHistoryStatisticTypes>;
};


export type QueryGetCPersonNotificationUnreadCountArgs = {
  data: CPersonNotificationUnreadInput;
};


export type QueryGetCPersonNotificationsArgs = {
  data: GetCPersonNotificationsInput;
};


export type QueryGetCPersonRoleArgs = {
  input?: InputMaybe<GetCPersonRoleInput>;
};


export type QueryGetCPersonRoleListArgs = {
  input?: InputMaybe<GetCPersonRoleListInput>;
};


export type QueryGetCPersonStatisticsArgs = {
  input?: InputMaybe<GetCustomerPersonHistoriesByStatusInput>;
};


export type QueryGetCallAdminLogDetailArgs = {
  callSid: Scalars['String']['input'];
};


export type QueryGetCallAdminLogsArgs = {
  params: GetCallAdminLogsInput;
};


export type QueryGetCallDashboardStatisticsArgs = {
  input: GetCallDashboardStatisticsInput;
};


export type QueryGetCallHistoryActiveCPersonsArgs = {
  input?: InputMaybe<GetCallHistoryActiveCPersonsInput>;
};


export type QueryGetCallHistoryAverageTimeChartDataArgs = {
  input?: InputMaybe<GetCallHistoryAverageTimeInput>;
};


export type QueryGetCallHistoryCountByDirectionArgs = {
  input?: InputMaybe<GetCallHistoryCountByDirectionInput>;
};


export type QueryGetCallHistoryCountChartDataArgs = {
  input?: InputMaybe<GetCallHistoryCountInput>;
};


export type QueryGetCallHistoryCustomerPersonsArgs = {
  input?: InputMaybe<GetCallHistoryCustomerPersonsInput>;
};


export type QueryGetCallHistorySatisfactionChartDataArgs = {
  input?: InputMaybe<GetCallHistorySatisfactionInput>;
};


export type QueryGetCallHistorySentimentChartDataArgs = {
  input: GetCallHistorySentimentInput;
};


export type QueryGetCallHistorySlaAgentStatisticsArgs = {
  input: GetCallHistorySlaAgentStatisticsInput;
};


export type QueryGetCallHistorySlaStatusStatisticsArgs = {
  input: GetCallHistorySlaStatusStatisticsInput;
};


export type QueryGetCallHistorySlaSummaryStatisticsArgs = {
  input: GetCallHistorySlaStatisticsInput;
};


export type QueryGetCallHistorySlaTimeStatisticsArgs = {
  input: GetCallHistorySlaTimeStatisticsInput;
};


export type QueryGetCallHistoryTalkListenChartDataArgs = {
  input: GetCallHistoryTalkListenInput;
};


export type QueryGetCallHistoryTopicsChartDataArgs = {
  input: GetCallHistoryTopicsInput;
};


export type QueryGetCallHistoryTotalCostChartDataArgs = {
  input?: InputMaybe<GetCallHistoryTotalCostInput>;
};


export type QueryGetCallLogByCallSidArgs = {
  callSid: Scalars['String']['input'];
};


export type QueryGetCallLogsArgs = {
  params: GetCallLogsInput;
};


export type QueryGetCallSnapshotCrossSnapshotsStatisticsArgs = {
  data: GetCallSnapshotCrossStatisticsInput;
};


export type QueryGetCallSnapshotsStatisticsArgs = {
  data: GetCallSnapshotStatisticsInput;
};


export type QueryGetCampaignArgs = {
  input?: InputMaybe<GetCampaignInput>;
};


export type QueryGetCampaignCalendarArgs = {
  input: CampaignCalendarInput;
};


export type QueryGetCampaignConversionsArgs = {
  input: CampaignConversionListInput;
};


export type QueryGetCampaignHistoryStatisticArgs = {
  input?: InputMaybe<CHistoryStatisticTypes>;
};


export type QueryGetCampaignRecipientTimelineArgs = {
  input: CampaignRecipientTimelineInput;
};


export type QueryGetCampaignRecipientsArgs = {
  input: CampaignRecipientListInput;
};


export type QueryGetCampaignReportArgs = {
  input: CampaignReportInput;
};


export type QueryGetCampaignTagsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCampaignTrackingBaseArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCampaignsArgs = {
  customer: Scalars['ID']['input'];
  isStatistic?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CampaignStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetChangelogDeliveriesArgs = {
  input?: InputMaybe<ListDeliveriesInput>;
};


export type QueryGetChangelogSubscribersArgs = {
  input?: InputMaybe<ListChangelogSubscribersInput>;
};


export type QueryGetChangelogWhatsAppTemplatesArgs = {
  input: ChangelogWhatsAppTemplatesInput;
};


export type QueryGetChannelOwnerTemplatesArgs = {
  input: GetChannelOwnerTemplatesInput;
};


export type QueryGetCollageBarcodeArgs = {
  input?: InputMaybe<GetCollageBarcodeInput>;
};


export type QueryGetCollageFoldersArgs = {
  input?: InputMaybe<GetCollageFoldersInput>;
};


export type QueryGetCollageProductsArgs = {
  input?: InputMaybe<GetCollageProductsInput>;
};


export type QueryGetCollageSettingsArgs = {
  input: GetCollageSettingsInput;
};


export type QueryGetCollageSharingsArgs = {
  input?: InputMaybe<GetCollageSharingsInput>;
};


export type QueryGetCollageTemplatesArgs = {
  input?: InputMaybe<GetCollageTemplatesInput>;
};


export type QueryGetConnectedPlatformsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetContactOrderStatsStatusArgs = {
  customer: Scalars['ID']['input'];
};


export type QueryGetContactsCountArgs = {
  conditions?: InputMaybe<Array<InputConditions>>;
  customer: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isPhoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  shouldMatchAllConditions?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<PersonPlatformtype>;
};


export type QueryGetConvCountsArgs = {
  data: ConvCountInput;
};


export type QueryGetConvTagStatisticsArgs = {
  data: ConvTagHistoryStatisticInput;
};


export type QueryGetConversationArgs = {
  input: GetConversationInput;
};


export type QueryGetConversationAdAttributionArgs = {
  input: ConversationAdAttributionInput;
};


export type QueryGetConversationAdReferralsArgs = {
  conversationId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetConversationByPersonIdArgs = {
  input: GetConvByPersonInput;
};


export type QueryGetConversationCrossSnapshotStatisticsArgs = {
  data: GetConversationCrossSnapshotStatisticsInput;
};


export type QueryGetConversationDashboardStatisticsArgs = {
  data: GetConversationDashboardStatisticsInput;
};


export type QueryGetConversationHistorySentimentArgs = {
  data: ConversationHistorySentimentInput;
};


export type QueryGetConversationHistoryTopicsArgs = {
  data: ConversationHistoryTopicsInput;
};


export type QueryGetConversationSidebarArgs = {
  input?: InputMaybe<GetConversationSideBarInput>;
};


export type QueryGetConversationSidebarListArgs = {
  input?: InputMaybe<GetConvSidebarInput>;
};


export type QueryGetConversationSnapshotStatisticsArgs = {
  data: GetConversationSnapshotStatisticsInput;
};


export type QueryGetConversationSourcesReportArgs = {
  input: ConversationSourcesReportInput;
};


export type QueryGetConversationStatisticsArgs = {
  data: ConvStatusInput;
};


export type QueryGetConversationViewArgs = {
  convViewId: Scalars['ID']['input'];
};


export type QueryGetConversationViewPreferenceArgs = {
  input: GetConversationViewPreferenceInput;
};


export type QueryGetConversationViewsListArgs = {
  input?: InputMaybe<GetConvViewsInput>;
};


export type QueryGetConversationsArgs = {
  data: GetConversationsInput;
};


export type QueryGetConversationsByUniqIdArgs = {
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  liveChatId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  type: PlatformType;
  uniqId: Scalars['ID']['input'];
};


export type QueryGetCustomExtensionArgs = {
  input?: InputMaybe<GetCustomExtensionInput>;
};


export type QueryGetCustomExtensionActionArgs = {
  input?: InputMaybe<GetCustomExtensionActionInput>;
};


export type QueryGetCustomExtensionFieldsArgs = {
  input?: InputMaybe<GetCustomExtensionFieldsInput>;
};


export type QueryGetCustomExtensionTabActionArgs = {
  input?: InputMaybe<GetCustomExtensionTabActionInput>;
};


export type QueryGetCustomExtensionsListArgs = {
  input?: InputMaybe<GetCustomExtensionsInput>;
};


export type QueryGetCustomFieldsArgs = {
  input?: InputMaybe<GetCustomFieldsInput>;
};


export type QueryGetCustomerAbandonedOrderArgs = {
  customer: Scalars['ID']['input'];
  platformCustomer?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomerBillingAddressesArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerBillingContactsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerByIdArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerInvoicesArgs = {
  input?: InputMaybe<GetCustomerInvoicesInput>;
};


export type QueryGetCustomerOnboardingInfoArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerOwnerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerOwnersArgs = {
  accountStatus?: InputMaybe<Scalars['String']['input']>;
  appStatus?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  periodMode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomerOwnersCountArgs = {
  accountStatus?: InputMaybe<Scalars['String']['input']>;
  appStatus?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  periodMode?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomerPaymentCardArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerPersonArgs = {
  input: GetCustomerPersonInput;
};


export type QueryGetCustomerPersonActivityLogsArgs = {
  input?: InputMaybe<GetCustomerPersonActivityLogsInput>;
};


export type QueryGetCustomerProductArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerRobotArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetCustomerWorkingHoursArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetDelayedActionArgs = {
  input?: InputMaybe<GetDelayedActionInput>;
};


export type QueryGetDelayedActionsListArgs = {
  input?: InputMaybe<GetDelayedActionsInput>;
};


export type QueryGetDomainArgs = {
  input?: InputMaybe<GetDomainInput>;
};


export type QueryGetECommerceCheckoutsArgs = {
  customer: Scalars['ID']['input'];
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetECommerceCustomersArgs = {
  customer: Scalars['ID']['input'];
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetECommerceIntegrationLogsArgs = {
  input: GetECommerceIntegrationLogsInput;
};


export type QueryGetECommerceIntegrationsArgs = {
  params?: InputMaybe<GetECommerceIntegrationsInput>;
  type: ECommerceIntegrationTypes;
};


export type QueryGetECommerceLinkedCustomerArgs = {
  customer: Scalars['ID']['input'];
  person: Scalars['ID']['input'];
};


export type QueryGetECommerceOrdersArgs = {
  customer: Scalars['ID']['input'];
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  platformCustomer?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetECommercePlatformTypeArgs = {
  customer: Scalars['ID']['input'];
};


export type QueryGetECommercePlatformsArgs = {
  customer: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetECommerceProductsArgs = {
  customer: Scalars['ID']['input'];
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetECommerceRulesArgs = {
  input?: InputMaybe<GetECommerceRulesInput>;
};


export type QueryGetECommerceStoreCargoCompaniesArgs = {
  customer: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetECommerceStorePaymentTypesArgs = {
  customer: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetECommerceVariantsArgs = {
  customer: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};


export type QueryGetEcommerceRulesHistoryStatisticArgs = {
  input?: InputMaybe<GetSurveyHistoryStatisticsInput>;
};


export type QueryGetEmailAdminLogsArgs = {
  params: GetEmailAdminLogsInput;
};


export type QueryGetExternalApisArgs = {
  input?: InputMaybe<GetExternalApisInput>;
};


export type QueryGetFeedbackSurveyArgs = {
  input?: InputMaybe<GetFeedbackSurveyInput>;
};


export type QueryGetFlowBotArgs = {
  input: GetFlowBotInput;
};


export type QueryGetFlowBotPaginatedArgs = {
  input: GetFlowBotPaginatedInput;
};


export type QueryGetFlowConversationPreviewArgs = {
  input: FlowConversationPreviewInput;
};


export type QueryGetFlowNodeArgs = {
  input: GetFlowNodeInput;
};


export type QueryGetFlowNodePaginatedArgs = {
  input: GetFlowNodePaginatedInput;
};


export type QueryGetFlowRunStepsArgs = {
  input: GetFlowRunStepsInput;
};


export type QueryGetFlowRunsPaginatedArgs = {
  input: GetFlowRunsInput;
};


export type QueryGetFlowWebhookTriggerArgs = {
  input: GetFlowWebhookTriggerInput;
};


export type QueryGetGroupListArgs = {
  customer: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHomeDashboardStatisticsArgs = {
  data: GetHomeDashboardStatisticsInput;
};


export type QueryGetHumanReplyLearningJobArgs = {
  customerId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};


export type QueryGetHumanReplyLearningJobsArgs = {
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetHumanReplyLearningStatusArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetInboundWebhookLogsArgs = {
  input: GetInboundWebhookLogsInput;
};


export type QueryGetInboundWebhooksArgs = {
  input: GetInboundWebhooksInput;
};


export type QueryGetIntegrationsArgs = {
  input?: InputMaybe<GetIntegrationsInput>;
};


export type QueryGetJoinedGroupsArgs = {
  input: GetJoinedGroupsInput;
};


export type QueryGetLiveChatWidgetInvalidationArgs = {
  invalidationId: Scalars['ID']['input'];
};


export type QueryGetLiveChatWidgetReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};


export type QueryGetLocationCountriesArgs = {
  params: GetCountriesInput;
};


export type QueryGetLocationStateProvinceCityArgs = {
  stateId: Scalars['ID']['input'];
};


export type QueryGetLocationStatesProvincesCitiesArgs = {
  params?: InputMaybe<GetStatesProvincesCitiesInput>;
};


export type QueryGetLoginUrlArgs = {
  customer: Scalars['ID']['input'];
  metaData?: InputMaybe<Scalars['Object']['input']>;
  storeUrl: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetMarketplaceOrdersArgs = {
  input?: InputMaybe<GetMarketplaceOrdersInput>;
};


export type QueryGetMessageCrossSnapshotStatisticsArgs = {
  data: GetMessageCrossSnapshotStatisticsInput;
};


export type QueryGetMessageForAiSimulationArgs = {
  customerId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};


export type QueryGetMessageSnapshotStatisticsArgs = {
  data: GetMessageSnapshotStatisticsInput;
};


export type QueryGetMetaAdsAdsetsArgs = {
  input: MetaAdsAdsetsInput;
};


export type QueryGetMetaAdsAuthUrlArgs = {
  input: MetaAdsCustomerInput;
};


export type QueryGetMetaAdsCampaignsArgs = {
  input: MetaAdsCampaignsInput;
};


export type QueryGetMetaBusinessConnectionArgs = {
  input: MetaAdsCustomerInput;
};


export type QueryGetMigrationHistoryArgs = {
  type: OneTimesType;
};


export type QueryGetMobileAppVersionArgs = {
  input: GetMobileAppVersionInput;
};


export type QueryGetMsgStatisticsArgs = {
  data: GetMsgStatistics;
};


export type QueryGetMyTeamsArgs = {
  cPersonId: Scalars['ID']['input'];
};


export type QueryGetNewPackageCostInfoArgs = {
  data?: InputMaybe<NewPackCostInput>;
};


export type QueryGetOperatorChatArgs = {
  data: GetOperatorChatInput;
};


export type QueryGetOperatorChatsArgs = {
  data: GetOperatorChatsInput;
};


export type QueryGetOperatorInsightsArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetOperatorJobsArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetOperatorMembersArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetOperatorPreferencesArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetOperatorRunsArgs = {
  data: GetOperatorRunsInput;
};


export type QueryGetOperatorSavedReportArgs = {
  data: OperatorReportInput;
};


export type QueryGetOperatorSavedReportsArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetOperatorStatusArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetOperatorUsageArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetOperatorUsageStatsArgs = {
  data: OperatorCustomerInput;
};


export type QueryGetPChannelArgs = {
  input?: InputMaybe<GetPChannelInput>;
};


export type QueryGetPaginatedECommerceRulesArgs = {
  input?: InputMaybe<GetPaginatedECommerceRulesInput>;
};


export type QueryGetPersonArgs = {
  input: GetPersonInput;
};


export type QueryGetPersonActivityArgs = {
  customer: Scalars['ID']['input'];
  person: Scalars['ID']['input'];
};


export type QueryGetPersonActivityLogsArgs = {
  input: GetPersonActivityLogsInput;
};


export type QueryGetPersonConversationsArgs = {
  data: GetPersonConversationsInput;
};


export type QueryGetPersonListArgs = {
  conditions?: InputMaybe<Array<InputConditions>>;
  customer: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isPhoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchKey?: InputMaybe<Scalars['String']['input']>;
  shouldMatchAllConditions?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<PersonSortField>;
  sortDirection?: InputMaybe<PersonSortDirection>;
  team?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<PersonPlatformtype>;
};


export type QueryGetPersonNotesArgs = {
  input: GetPersonNotesInput;
};


export type QueryGetPersonTimelineArgs = {
  input: GetPersonTimelineInput;
};


export type QueryGetPersonsCHistoryStatisticArgs = {
  input?: InputMaybe<CHistoryStatisticPaginateTypes>;
};


export type QueryGetPlatformDataArgs = {
  input: CustomPlatformInput;
};


export type QueryGetPlatformsArgs = {
  customerId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetPlatformsPaginatedArgs = {
  params?: InputMaybe<GetPlatformsPaginatedInput>;
};


export type QueryGetPopulatedTicketTypeArgs = {
  input?: InputMaybe<GetTicketTypeInput>;
};


export type QueryGetPublishedAnnouncementsArgs = {
  input?: InputMaybe<ListChangelogInput>;
};


export type QueryGetQpienShopCustomerAddressesArgs = {
  metaData: GetQpienShopCustomerAddressesInput;
};


export type QueryGetQpienShopCustomersArgs = {
  metaData: GetQpienShopCustomersInput;
};


export type QueryGetQpienShopFlowFieldsArgs = {
  input: QpienShopFlowFieldsInput;
};


export type QueryGetQpienShopFlowPreviewArgs = {
  input: QpienShopFlowPreviewInput;
};


export type QueryGetQpienShopOrderArgs = {
  metaData: GetQpienShopOrderInput;
};


export type QueryGetQpienShopOrdersArgs = {
  metaData: GetQpienShopOrdersInput;
};


export type QueryGetQpienShopProductsArgs = {
  metaData: GetQpienShopProductsInput;
};


export type QueryGetQpienShopStoreArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetRecordAttachmentArgs = {
  input?: InputMaybe<GetRecordAttachmentInput>;
};


export type QueryGetRecordAttachmentsListArgs = {
  input?: InputMaybe<GetRecordAttachmentInput>;
};


export type QueryGetRecordNotesArgs = {
  input?: InputMaybe<GetRecordNotesInput>;
};


export type QueryGetRecordsByPersonArgs = {
  input?: InputMaybe<SearchIntegrationInput>;
};


export type QueryGetReembedKnowledgeSourcesToContextualRagJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryGetReportArgs = {
  input: GetReportInput;
};


export type QueryGetReportWidgetDataArgs = {
  input: GetReportWidgetDataInput;
};


export type QueryGetReportWidgetMetricTemplatesArgs = {
  input?: InputMaybe<GetReportWidgetMetricTemplatesInput>;
};


export type QueryGetReportWidgetTemplatesArgs = {
  input?: InputMaybe<GetReportWidgetTemplatesInput>;
};


export type QueryGetReportWidgetsArgs = {
  input?: InputMaybe<GetReportWidgetsInput>;
};


export type QueryGetReportsArgs = {
  input: GetReportsInput;
};


export type QueryGetSelectableFieldsArgs = {
  input?: InputMaybe<GetIntegrationFieldsInput>;
};


export type QueryGetSimilarContactsArgs = {
  input: GetSimilarContactsInput;
};


export type QueryGetSingleActionArgs = {
  input?: InputMaybe<GetActionInput>;
};


export type QueryGetSingleAuthenticationArgs = {
  input?: InputMaybe<GetAuthenticationInput>;
};


export type QueryGetSingleCollageFolderArgs = {
  input?: InputMaybe<GetCollageFolderInput>;
};


export type QueryGetSingleCollageProductArgs = {
  input?: InputMaybe<GetCollageProductInput>;
};


export type QueryGetSingleCollageSharingArgs = {
  input?: InputMaybe<GetCollageSharingInput>;
};


export type QueryGetSingleCollageTemplateArgs = {
  input?: InputMaybe<GetCollageTemplateInput>;
};


export type QueryGetSingleCustomerPersonActivityLogArgs = {
  input?: InputMaybe<GetCustomerPersonActivityLogInput>;
};


export type QueryGetSingleExternalApiArgs = {
  input?: InputMaybe<GetExternalApiInput>;
};


export type QueryGetSingleInboundWebhookArgs = {
  input: GetInboundWebhookInput;
};


export type QueryGetSingleTeamArgs = {
  input?: InputMaybe<GetSingleTeamInput>;
};


export type QueryGetSingleWebhookArgs = {
  input?: InputMaybe<GetWebhookInput>;
};


export type QueryGetSkillArgs = {
  data: SkillScopedIdInput;
};


export type QueryGetSkillRunArgs = {
  data: GetSkillRunInput;
};


export type QueryGetSkillRunViewArgs = {
  data: SkillRunViewInput;
};


export type QueryGetSlaHistoryArgs = {
  input: GetSlaHistoryInput;
};


export type QueryGetSlaInstanceArgs = {
  input: GetSlaInstanceInput;
};


export type QueryGetSlaPoliciesArgs = {
  input: GetSlaPoliciesInput;
};


export type QueryGetSlaPolicyArgs = {
  input: GetSlaPolicyInput;
};


export type QueryGetSlaReportArgs = {
  input: GetSlaReportInput;
};


export type QueryGetSlaStageTimeStatisticsArgs = {
  input: GetSlaStageTimeStatisticsInput;
};


export type QueryGetSlaStatisticsArgs = {
  input: GetSlaStatisticsInput;
};


export type QueryGetSlaStatusStatisticsArgs = {
  input: GetSlaStatusStatisticsInput;
};


export type QueryGetSurveyArgs = {
  input?: InputMaybe<GetSurveyInput>;
};


export type QueryGetSurveyCrossSnapshotStatisticsArgs = {
  data: GetSurveyCrossSnapshotStatisticsInput;
};


export type QueryGetSurveyHistoryPersonStatisticArgs = {
  input?: InputMaybe<GetSurveyHistoryStatisticPersonInput>;
};


export type QueryGetSurveyHistoryStatisticArgs = {
  input?: InputMaybe<GetSurveyHistoryStatisticInput>;
};


export type QueryGetSurveySnapshotStatisticsArgs = {
  data: GetSurveySnapshotStatisticsInput;
};


export type QueryGetSurveysArgs = {
  input?: InputMaybe<GetSurveysInput>;
};


export type QueryGetTableFieldsArgs = {
  input: GetTableFieldsInput;
};


export type QueryGetTableFoldersArgs = {
  input: GetTableFoldersInput;
};


export type QueryGetTableRecordArgs = {
  input: GetTableRecordInput;
};


export type QueryGetTableRecordActivitiesArgs = {
  input: GetTableRecordActivitiesInput;
};


export type QueryGetTableRecordsArgs = {
  input: GetTableRecordsInput;
};


export type QueryGetTableViewsArgs = {
  input: GetTableViewsInput;
};


export type QueryGetTablesArgs = {
  input: GetTablesInput;
};


export type QueryGetTagArgs = {
  input?: InputMaybe<GetTagInput>;
};


export type QueryGetTagsListArgs = {
  input?: InputMaybe<GetTagsInput>;
};


export type QueryGetTaskByIdArgs = {
  input: GetTaskByIdInput;
};


export type QueryGetTaskBySourceIdArgs = {
  input: GetTaskBySourceIdInput;
};


export type QueryGetTaskCommentsArgs = {
  input: GetTaskCommentsInput;
};


export type QueryGetTaskLogsArgs = {
  input: GetTaskLogsInput;
};


export type QueryGetTasksListArgs = {
  input: GetTasksInput;
};


export type QueryGetTeamChatArgs = {
  customerId: Scalars['ID']['input'];
  teamConversationId: Scalars['ID']['input'];
};


export type QueryGetTeamChatsArgs = {
  data: GetTeamChatsInput;
};


export type QueryGetTeamConvMembersArgs = {
  data: GetTeamConvMembersInput;
};


export type QueryGetTeamMessagesArgs = {
  data: GetTeamMessagesInput;
};


export type QueryGetTeamOpenConversationCountsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetTeamsArgs = {
  data: TeamsQuery;
};


export type QueryGetTemplateArgs = {
  input: GetTemplateInput;
};


export type QueryGetTicketPriorityStatisticsArgs = {
  data: GetTicketPriorityStatisticsInput;
};


export type QueryGetTicketStateStatisticsArgs = {
  data: GetTicketStateStatisticsInput;
};


export type QueryGetTicketStatesArgs = {
  input?: InputMaybe<GetTicketStatesInput>;
};


export type QueryGetTicketStatisticsArgs = {
  data: GetTicketStatisticsInput;
};


export type QueryGetTicketTypeArgs = {
  input?: InputMaybe<GetTicketTypeInput>;
};


export type QueryGetTicketTypeStatisticsArgs = {
  data: GetTicketTypeStatisticsInput;
};


export type QueryGetTicketTypesArgs = {
  input?: InputMaybe<GetTicketTypesInput>;
};


export type QueryGetTimeBasedAudienceCountArgs = {
  input: GetTimeBasedAudienceCountInput;
};


export type QueryGetTopicComparisonStatisticsArgs = {
  input: GetTopicComparisonStatisticsInput;
};


export type QueryGetTopicCustomFieldsComparisonStatisticsArgs = {
  input: GetTopicCustomFieldsComparisonStatisticsInput;
};


export type QueryGetTopicCustomFieldsStatisticsArgs = {
  input: GetTopicStatisticsInput;
};


export type QueryGetTopicStatisticsArgs = {
  input: GetTopicStatisticsInput;
};


export type QueryGetTopicsArgs = {
  input: GetTopicsInput;
};


export type QueryGetTrackingDomainSettingsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetTrackingDomainUsageArgs = {
  input: TrackingDomainIdInput;
};


export type QueryGetTrackingDomainsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetTranscriptDetailsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  transcriptId: Scalars['ID']['input'];
};


export type QueryGetTranscriptsByCallSidArgs = {
  callSid: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTranslateLanguageArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUrlInfoArgs = {
  url: Scalars['String']['input'];
};


export type QueryGetWabaTemplateArgs = {
  input: GetWabaTemplateInput;
};


export type QueryGetWebhooksArgs = {
  input?: InputMaybe<GetWebhooksInput>;
};


export type QueryGetWorkflowStatusCountsArgs = {
  input: GetWorkflowStatusCountsInput;
};


export type QueryGetWorkflowsPaginatedArgs = {
  input: GetWorkflowsPaginatedInput;
};


export type QueryGetZohoBlueprintTransitionsArgs = {
  input: GetZohoBlueprintTransitionsInput;
};


export type QueryGetZohoModuleFieldsArgs = {
  input: GetZohoModuleFieldsInput;
};


export type QueryGetZohoModuleTagsArgs = {
  input: GetZohoModuleFieldsInput;
};


export type QueryGetZohoModulesArgs = {
  input: GetZohoUsersInput;
};


export type QueryGetZohoTestRecordArgs = {
  input: GetZohoTestRecordInput;
};


export type QueryGetZohoUsersArgs = {
  input: GetZohoUsersInput;
};


export type QueryHttpTestArgs = {
  input: HttpTestInput;
};


export type QueryInspectCollectionArgs = {
  data: InspectCollectionInput;
};


export type QueryListAiConversationsArgs = {
  data: ListInfiniteParams;
};


export type QueryListAiMessageSourcesArgs = {
  aiMessageId: Scalars['ID']['input'];
  answerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListAiMessageStepsArgs = {
  aiMessageId: Scalars['ID']['input'];
  answerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListAiMessagesArgs = {
  data: ListInfiniteParams;
};


export type QueryListAskQuestionEvalMocksArgs = {
  data?: InputMaybe<AskQuestionEvalMockListInput>;
};


export type QueryListAskQuestionEvalRunsArgs = {
  data?: InputMaybe<AskQuestionEvalRunListInput>;
};


export type QueryListBlockTemplatesArgs = {
  input: ListBlockTemplatesInput;
};


export type QueryListCampaignsArgs = {
  input: ListCampaignsInput;
};


export type QueryListFlowNodeArgs = {
  input: ListFlowNodeInput;
};


export type QueryListReusableFlowsArgs = {
  input: ListReusableFlowsInput;
};


export type QueryListSkillRunsArgs = {
  data: ListSkillRunsInput;
};


export type QueryListSkillVersionsArgs = {
  data: ListSkillVersionsInput;
};


export type QueryListSkillsArgs = {
  data: ListSkillsInput;
};


export type QueryPersonActivitiesArgs = {
  customer: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPersonCustomFieldsArgs = {
  input: PartialPersonCustomFieldsInput;
};


export type QueryPersonGroupListArgs = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchKey?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PersonSortField>;
  sortDirection?: InputMaybe<PersonSortDirection>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<PersonPlatformtype>;
};


export type QueryPreviewAiAnalysisMessagesArgs = {
  data: PreviewAiAnalysisMessagesInput;
};


export type QueryPreviewAiSizeChartGroupArgs = {
  customerId: Scalars['ID']['input'];
  data: AiSizeChartGroupPreviewInput;
};


export type QueryProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuickAnswersArgs = {
  customerId: Scalars['ID']['input'];
  filter?: InputMaybe<QuickAnswerListFilter>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRefreshWhatsAppBusinessTemplatesArgs = {
  data: AppId;
};


export type QueryResolveCampaignTrackingLinkArgs = {
  url: Scalars['String']['input'];
};


export type QueryRunCustomECommerceIntegrationArgs = {
  input: RunCustomECommerceIntegrationInput;
};


export type QueryRunCustomIntegrationQueryArgs = {
  input: RunCustomIntegrationInput;
};


export type QueryRunCustomPlatformQueryArgs = {
  input: CustomPlatformInput;
};


export type QuerySearchAiHelpArgs = {
  data: AiHelpSearchInput;
};


export type QuerySearchAiSizeChartProductsArgs = {
  customerId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchMetaAdsArgs = {
  input: SearchMetaAdsInput;
};


export type QueryTranslateMessageTextArgs = {
  lang: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QueryUserArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryValidateCampaignArgs = {
  input: ValidateCampaignInput;
};

export type QuestionDataInput = {
  productImageUrl?: InputMaybe<Scalars['String']['input']>;
  productLink?: InputMaybe<Scalars['String']['input']>;
  productMainId?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionDataType = {
  __typename?: 'QuestionDataType';
  aiNotResponseReason?: Maybe<Scalars['String']['output']>;
  isRepliedOnPlatform?: Maybe<Scalars['Boolean']['output']>;
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productMainId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  repliedCPerson?: Maybe<Scalars['ID']['output']>;
  replies?: Maybe<Array<Maybe<QuestionReply>>>;
  reply?: Maybe<Scalars['String']['output']>;
  replyDate?: Maybe<Scalars['Date']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temporaryReply?: Maybe<Scalars['String']['output']>;
};

export type QuestionReply = {
  __typename?: 'QuestionReply';
  content?: Maybe<Scalars['String']['output']>;
  failedReason?: Maybe<FailedReasonType>;
  isRobot?: Maybe<Scalars['Boolean']['output']>;
  repliedCPerson?: Maybe<Scalars['ID']['output']>;
  replyDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type QuickAnswer = {
  __typename?: 'QuickAnswer';
  _id?: Maybe<Scalars['ID']['output']>;
  actions?: Maybe<Array<Maybe<QuickAnswerAction>>>;
  answer?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  customerPersons?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Array<Maybe<UploadedQuickAnswerPayload>>>;
  rag?: Maybe<RagInfo>;
  teams?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type QuickAnswerAction = {
  __typename?: 'QuickAnswerAction';
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type QuickAnswerActionInput = {
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QuickAnswerListFilter = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  customerPersonId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuickAnswerPayload = {
  file?: InputMaybe<Scalars['Media']['input']>;
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export enum QuickAnswerRagStatus {
  Failed = 'FAILED',
  Outdated = 'OUTDATED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type QuickAnswerResponse = {
  __typename?: 'QuickAnswerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: QuickAnswer;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QuickAnswerSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type QuickAnswersCountResponse = {
  __typename?: 'QuickAnswersCountResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QuickAnswersResponse = {
  __typename?: 'QuickAnswersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: QuickAnswerPaginateResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QuotedMessageType = {
  __typename?: 'QuotedMessageType';
  _id?: Maybe<Scalars['ID']['output']>;
  callData?: Maybe<CallDataType>;
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  flowBotQuickReply?: Maybe<Array<Maybe<FlowBotQuickReplyType>>>;
  informativeButtons?: Maybe<InformativeButtonsType>;
  media?: Maybe<Array<Maybe<Scalars['Media']['output']>>>;
  product_cards?: Maybe<Scalars['Object']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  template_cards?: Maybe<Scalars['Object']['output']>;
};

export type RagInfo = {
  __typename?: 'RagInfo';
  failedReason?: Maybe<Scalars['String']['output']>;
  ragIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<QuickAnswerRagStatus>;
};

/**
 * Bulk inbound traffic generator (development only).
 *
 * `conversationCount` distinct fake contacts are spread round-robin over `targets`,
 * and each receives `messagesPerConversation` messages. Dispatch is interleaved —
 * one round across every conversation, then the next — because that is what
 * re-ranks the inbox list continuously.
 */
export type RandomMessageBulkInput = {
  /** Contact id prefix — reusing it targets the SAME conversations again. */
  contactPrefix?: InputMaybe<Scalars['String']['input']>;
  conversationCount: Scalars['Int']['input'];
  /** Pause between two dispatches, ms. Defaults to 300. */
  delayMs?: InputMaybe<Scalars['Int']['input']>;
  /** Message bodies to cycle through. Defaults to a built-in sample set. */
  messages?: InputMaybe<Array<Scalars['String']['input']>>;
  messagesPerConversation: Scalars['Int']['input'];
  targets: Array<RandomMessageBulkTargetInput>;
};

/** One selected platform plus the connected channel its fake traffic arrives on. */
export type RandomMessageBulkTargetInput = {
  /** Platform-side account id (page id / phone / mailbox). */
  channelId?: InputMaybe<Scalars['String']['input']>;
  /** `Platforms._id` of a connected channel in this tenant. */
  dbDriverId: Scalars['String']['input'];
  platformType: PlatformType;
};

export enum RatingType {
  AllRatings = 'All_Ratings',
  Dissatisfied = 'Dissatisfied',
  Neutral = 'Neutral',
  PlatformConnectionError = 'PlatformConnectionError',
  Satisfied = 'Satisfied'
}

export type ReSendMessageInput = {
  customerId: Scalars['ID']['input'];
  msgId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReactTeamMessageInput = {
  customerId: Scalars['ID']['input'];
  emoji: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};

export type ReactToChangelogInput = {
  announcementId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Scalars['Int']['input']>;
};

export enum ReactionEnum {
  Angry = 'ANGRY',
  Haha = 'HAHA',
  Like = 'LIKE',
  Love = 'LOVE',
  Sad = 'SAD',
  Wow = 'WOW'
}

export type ReactionPlatformType = {
  channelType?: InputMaybe<PlatformType>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<MsgTypeForReaction>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<ReactionEnum>;
};

export type ReactionResponse = {
  __typename?: 'ReactionResponse';
  data?: Maybe<ChangelogReaction>;
  error?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Recipients = {
  __typename?: 'Recipients';
  groups: Array<Maybe<PersonGroup>>;
  isGroupResponse: Scalars['Boolean']['output'];
  users: Array<Maybe<User>>;
};

export type RecipientsInput = {
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type RecordAttachment = {
  __typename?: 'RecordAttachment';
  attachmentId?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['Object']['output']>;
};

export type RecordAttachmentsList = {
  __typename?: 'RecordAttachmentsList';
  Created_By?: Maybe<CreatedByPerson>;
  Created_Time?: Maybe<Scalars['String']['output']>;
  File_Name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type RecordData = {
  email?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['Object']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RecordNote = {
  __typename?: 'RecordNote';
  Created_By?: Maybe<CreatedByPerson>;
  Created_Time?: Maybe<Scalars['String']['output']>;
  Note_Content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ReembedKnowledgeSourcesFailure = {
  __typename?: 'ReembedKnowledgeSourcesFailure';
  aiKnowledgeSourceContentId?: Maybe<Scalars['ID']['output']>;
  aiKnowledgeSourceId?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum ReembedKnowledgeSourcesJobStatus {
  Completed = 'completed',
  Failed = 'failed',
  Queued = 'queued',
  Running = 'running'
}

export type ReembedKnowledgeSourcesToContextualRagInput = {
  allCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ReembedKnowledgeSourcesToContextualRagJob = {
  __typename?: 'ReembedKnowledgeSourcesToContextualRagJob';
  allCustomers: Scalars['Boolean']['output'];
  completedCustomerIds?: Maybe<Array<Scalars['ID']['output']>>;
  completedCustomers: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  currentCustomerId?: Maybe<Scalars['ID']['output']>;
  failedContents: Scalars['Int']['output'];
  failedCustomerIds?: Maybe<Array<Scalars['ID']['output']>>;
  failedCustomers: Scalars['Int']['output'];
  failures?: Maybe<Array<ReembedKnowledgeSourcesFailure>>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  processedContents: Scalars['Int']['output'];
  processedKnowledgeSources: Scalars['Int']['output'];
  reembeddedContents: Scalars['Int']['output'];
  remainingCustomers: Scalars['Int']['output'];
  skippedContents: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  status: ReembedKnowledgeSourcesJobStatus;
  targetCustomerIds?: Maybe<Array<Scalars['ID']['output']>>;
  totalCustomers: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ReembedKnowledgeSourcesToContextualRagJobResponse = {
  __typename?: 'ReembedKnowledgeSourcesToContextualRagJobResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ReembedKnowledgeSourcesToContextualRagJob>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReembedKnowledgeSourcesToContextualRagResponse = {
  __typename?: 'ReembedKnowledgeSourcesToContextualRagResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RefreshWabaTemplatesInput = {
  appId: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
};

export type RegenerateFlowWebhookUrlInput = {
  flowId: Scalars['ID']['input'];
};

export type RemoveBlockFromNodeInput = {
  block: Scalars['String']['input'];
  node: Scalars['String']['input'];
};

export type RemoveBlockFromNodeResponse = {
  __typename?: 'RemoveBlockFromNodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveBlocksFromNodeInput = {
  blocks: Array<InputMaybe<Scalars['ID']['input']>>;
  node: Scalars['ID']['input'];
};

export type RemoveCampaignInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type RemoveCouponCodeFromCustomerInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type RemoveCustomerBillingContactsInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['String']['input'];
};

export type RemoveDomainFromEmailInput = {
  _id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
};

export type RemoveDomainResponse = {
  __typename?: 'RemoveDomainResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Domain;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemovePersonGroupInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type RenameOperatorReportInput = {
  customerId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type ReorderReportInput = {
  reportId: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type ReorderReportWidgetMetricInput = {
  metricId: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type ReorderTableFieldsInput = {
  customerId: Scalars['ID']['input'];
  orderedIds: Array<Scalars['ID']['input']>;
  tableId: Scalars['ID']['input'];
};

export type ReorderTableFoldersInput = {
  customerId: Scalars['ID']['input'];
  orderedIds: Array<Scalars['ID']['input']>;
};

export type ReorderTablesInput = {
  customerId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  orderedIds: Array<Scalars['ID']['input']>;
};

export type Repeat = {
  __typename?: 'Repeat';
  frequency: Scalars['String']['output'];
  frequencyAt?: Maybe<Scalars['String']['output']>;
  /** Weekly repeat days, 1=Monday..7=Sunday. Overrides frequencyAt when non-empty. */
  frequencyDays?: Maybe<Array<Scalars['Int']['output']>>;
  frequencyType: RepeatFrequencyType;
};

export enum RepeatFrequencyType {
  Days = 'DAYS',
  Hours = 'HOURS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

export type RepeatInput = {
  frequency: Scalars['String']['input'];
  frequencyAt?: InputMaybe<Scalars['String']['input']>;
  /** Weekly repeat days, 1=Monday..7=Sunday. Overrides frequencyAt when non-empty. */
  frequencyDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  frequencyType: RepeatFrequencyType;
};

export type Report = {
  __typename?: 'Report';
  _id: Scalars['ID']['output'];
  category: ReportCategory;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['ID']['output'];
  customerId: Scalars['ID']['output'];
  dateRange?: Maybe<ReportDateRange>;
  description: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  filters: Array<ReportFilter>;
  hasAccess: ReportAccess;
  name: Scalars['String']['output'];
  refreshInterval?: Maybe<Scalars['Int']['output']>;
  selectedCPersons: Array<Scalars['ID']['output']>;
  selectedTeams: Array<Scalars['ID']['output']>;
  sortOrder: Scalars['Int']['output'];
  systemReportKey?: Maybe<Scalars['String']['output']>;
  type: ReportType;
  updatedAt: Scalars['Date']['output'];
  updatedBy: Scalars['ID']['output'];
};

export enum ReportAccess {
  Everyone = 'everyone',
  Me = 'me',
  SelectedCPersons = 'selectedCPersons',
  SelectedTeams = 'selectedTeams'
}

export type ReportBooleanResponse = {
  __typename?: 'ReportBooleanResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ReportCategory {
  Ads = 'ads',
  Ai = 'ai',
  Calls = 'calls',
  Conversations = 'conversations',
  Custom = 'custom',
  General = 'general',
  Overview = 'overview',
  Tickets = 'tickets',
  Users = 'users'
}

export type ReportDateRange = {
  __typename?: 'ReportDateRange';
  field?: Maybe<ReportDateRangeField>;
  from?: Maybe<Scalars['String']['output']>;
  preset?: Maybe<ReportDateRangePreset>;
  to?: Maybe<Scalars['String']['output']>;
};

export enum ReportDateRangeField {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type ReportDateRangeInput = {
  field?: InputMaybe<ReportDateRangeField>;
  from?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<ReportDateRangePreset>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportDateRangePreset {
  Last7days = 'last7days',
  Last30days = 'last30days',
  Last90days = 'last90days',
  LastMonth = 'lastMonth',
  ThisMonth = 'thisMonth',
  Today = 'today',
  Yesterday = 'yesterday'
}

export type ReportFilter = {
  __typename?: 'ReportFilter';
  dataSource: Scalars['String']['output'];
  displayValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  isDynamic: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  operator: ReportSnapshotFilterOperator;
  options?: Maybe<Array<ReportSnapshotFilterOption>>;
  value?: Maybe<Scalars['Object']['output']>;
  valueType: ReportSnapshotValueType;
};

export type ReportFilterInput = {
  dataSource: Scalars['String']['input'];
  displayValue?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  operator: ReportSnapshotFilterOperator;
  value?: InputMaybe<Scalars['Object']['input']>;
  valueType?: InputMaybe<ReportSnapshotValueType>;
};

export type ReportResponse = {
  __typename?: 'ReportResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Report>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ReportSnapshotAggregation {
  Avg = 'avg',
  AvgPerConversation = 'avgPerConversation',
  AvgPerDay = 'avgPerDay',
  Count = 'count',
  Max = 'max',
  Min = 'min',
  Rate = 'rate',
  Sum = 'sum'
}

export enum ReportSnapshotCountTarget {
  Conversation = 'conversation',
  Snapshot = 'snapshot'
}

export enum ReportSnapshotFilterOperator {
  Eq = 'eq',
  In = 'in'
}

export type ReportSnapshotFilterOption = {
  __typename?: 'ReportSnapshotFilterOption';
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['Object']['output']>;
};

export enum ReportSnapshotGranularity {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week'
}

export enum ReportSnapshotValueType {
  Boolean = 'BOOLEAN',
  /** `value` is an array of `{ id, value, label }` closing-topic custom-field pairs, AND-ed together. */
  CustomFieldPairs = 'CUSTOM_FIELD_PAIRS',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  ObjectId = 'OBJECT_ID',
  ObjectIdArray = 'OBJECT_ID_ARRAY',
  String = 'STRING'
}

export enum ReportType {
  Custom = 'CUSTOM',
  System = 'SYSTEM'
}

export type ReportWidget = {
  __typename?: 'ReportWidget';
  _id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  chartType: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customerId: Scalars['ID']['output'];
  dataSource: Scalars['String']['output'];
  dateRangeOverride?: Maybe<ReportDateRange>;
  displayOptions?: Maybe<Scalars['String']['output']>;
  filters: Array<WidgetFilter>;
  layout: WidgetLayout;
  metrics: Array<ReportWidgetMetric>;
  name: Scalars['String']['output'];
  reportId: Scalars['ID']['output'];
  segmentBy?: Maybe<ReportWidgetSegmentBy>;
  templateId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  widgetType: Scalars['String']['output'];
};

export type ReportWidgetBooleanResponse = {
  __typename?: 'ReportWidgetBooleanResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportWidgetChartEncoding = {
  __typename?: 'ReportWidgetChartEncoding';
  color?: Maybe<Scalars['String']['output']>;
  column?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  y?: Maybe<Array<Scalars['String']['output']>>;
};

export type ReportWidgetDataResultResponse = {
  __typename?: 'ReportWidgetDataResultResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<WidgetDataResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportWidgetDataset = {
  __typename?: 'ReportWidgetDataset';
  /**
   * Mean of the rendered rows per measure key, for measures whose value is a ratio (format
   * `percentage`) and whose `totals` sum is therefore meaningless. Null when no measure qualifies.
   */
  averages?: Maybe<Scalars['Object']['output']>;
  kind: ReportWidgetDatasetKind;
  meta?: Maybe<Scalars['Object']['output']>;
  rows: Array<Scalars['Object']['output']>;
  schema: ReportWidgetDatasetSchema;
  totals?: Maybe<Scalars['Object']['output']>;
  value?: Maybe<Scalars['Object']['output']>;
  version: Scalars['String']['output'];
  view: ReportWidgetDatasetView;
};

export type ReportWidgetDatasetField = {
  __typename?: 'ReportWidgetDatasetField';
  aggregation?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  role: ReportWidgetDatasetFieldRole;
  type: ReportWidgetDatasetFieldType;
  unit?: Maybe<Scalars['String']['output']>;
  valueMax?: Maybe<Scalars['Float']['output']>;
  /** Bounds a gauge draws between. Null on unbounded measures. */
  valueMin?: Maybe<Scalars['Float']['output']>;
};

export enum ReportWidgetDatasetFieldRole {
  Dimension = 'DIMENSION',
  Measure = 'MEASURE'
}

export enum ReportWidgetDatasetFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING'
}

export enum ReportWidgetDatasetKind {
  Categorical = 'CATEGORICAL',
  Matrix = 'MATRIX',
  Metric = 'METRIC',
  Raw = 'RAW',
  Table = 'TABLE',
  Timeseries = 'TIMESERIES'
}

export type ReportWidgetDatasetSchema = {
  __typename?: 'ReportWidgetDatasetSchema';
  dimensions: Array<ReportWidgetDatasetField>;
  measures: Array<ReportWidgetDatasetField>;
};

export type ReportWidgetDatasetView = {
  __typename?: 'ReportWidgetDatasetView';
  chartType: Scalars['String']['output'];
  encoding: ReportWidgetChartEncoding;
};

export type ReportWidgetDrillDownConversation = {
  __typename?: 'ReportWidgetDrillDownConversation';
  conversationId: Scalars['ID']['output'];
  dataSources: Array<Scalars['String']['output']>;
  measureKeys: Array<Scalars['String']['output']>;
  metricIds: Array<Scalars['ID']['output']>;
  metricTemplateIds: Array<Scalars['ID']['output']>;
};

export type ReportWidgetDrillDownPageInfo = {
  __typename?: 'ReportWidgetDrillDownPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

/**
 * A contact behind a `person_live` metric. `fullName` is never empty: it falls back through
 * username/email/phone and finally to "Unknown Person", so it is always safe as link text.
 * Clicking it navigates to SITE_URL/contacts?personId={personId}.
 */
export type ReportWidgetDrillDownPerson = {
  __typename?: 'ReportWidgetDrillDownPerson';
  dataSources: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  measureKeys: Array<Scalars['String']['output']>;
  metricIds: Array<Scalars['ID']['output']>;
  metricTemplateIds: Array<Scalars['ID']['output']>;
  personId: Scalars['ID']['output'];
};

export type ReportWidgetMetric = {
  __typename?: 'ReportWidgetMetric';
  _id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  compatibilityGroup: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customerId: Scalars['ID']['output'];
  dataSource: Scalars['String']['output'];
  descriptionTranslations: ReportWidgetMetricTemplateTranslations;
  filters: Array<WidgetFilter>;
  format?: Maybe<Scalars['String']['output']>;
  measureKey: Scalars['String']['output'];
  metricTemplateId: Scalars['ID']['output'];
  metricType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reportId: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  supportedCharts: Array<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  viewBy: ReportWidgetViewBy;
  widgetId: Scalars['ID']['output'];
};

export type ReportWidgetMetricResponse = {
  __typename?: 'ReportWidgetMetricResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ReportWidgetMetric>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportWidgetMetricTemplate = {
  __typename?: 'ReportWidgetMetricTemplate';
  _id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  compatibilityGroup: Scalars['String']['output'];
  dataSource: Scalars['String']['output'];
  defaultFilters: Array<WidgetFilter>;
  descriptionTranslations: ReportWidgetMetricTemplateTranslations;
  format?: Maybe<Scalars['String']['output']>;
  measureKey: Scalars['String']['output'];
  metricType: Scalars['String']['output'];
  supportedCharts: Array<Scalars['String']['output']>;
  translations: ReportWidgetMetricTemplateTranslations;
  unit?: Maybe<Scalars['String']['output']>;
  viewBy: ReportWidgetViewBy;
};

export type ReportWidgetMetricTemplateTranslations = {
  __typename?: 'ReportWidgetMetricTemplateTranslations';
  ar?: Maybe<Scalars['String']['output']>;
  de?: Maybe<Scalars['String']['output']>;
  en: Scalars['String']['output'];
  fr?: Maybe<Scalars['String']['output']>;
  tr?: Maybe<Scalars['String']['output']>;
};

export type ReportWidgetMetricTemplatesResponse = {
  __typename?: 'ReportWidgetMetricTemplatesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<ReportWidgetMetricTemplate>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Cursor page descriptor. `totalCount` is capped — when the dataset's `meta.countCapped` is true it
 * is a floor rather than the real total.
 */
export type ReportWidgetPageInfo = {
  __typename?: 'ReportWidgetPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

/**
 * One raw column of a record-list widget. `field` is the snapshot field projected into the row;
 * `lookupKey` names the entity whose display label the shared `lookup` map resolves, so rows carry
 * raw ObjectIds and the labels are batch-resolved once per page.
 */
export type ReportWidgetRecordField = {
  __typename?: 'ReportWidgetRecordField';
  field: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lookupKey?: Maybe<Scalars['String']['output']>;
  type: ReportWidgetDatasetFieldType;
};

export type ReportWidgetResponse = {
  __typename?: 'ReportWidgetResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ReportWidget>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportWidgetSegmentBy = {
  __typename?: 'ReportWidgetSegmentBy';
  field: Scalars['String']['output'];
  granularity?: Maybe<ReportSnapshotGranularity>;
};

export type ReportWidgetSegmentByInput = {
  field: Scalars['String']['input'];
  granularity?: InputMaybe<ReportSnapshotGranularity>;
};

export type ReportWidgetSupportedSegment = {
  __typename?: 'ReportWidgetSupportedSegment';
  allowedGranularities?: Maybe<Array<ReportSnapshotGranularity>>;
  defaultGranularity?: Maybe<ReportSnapshotGranularity>;
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  supportedCharts?: Maybe<Array<Scalars['String']['output']>>;
  valueType: ReportSnapshotValueType;
};

export type ReportWidgetTemplate = {
  __typename?: 'ReportWidgetTemplate';
  _id: Scalars['ID']['output'];
  availableMetricTemplateIds: Array<Scalars['ID']['output']>;
  category: Scalars['String']['output'];
  dataSource: Scalars['String']['output'];
  defaultFilters: Array<WidgetFilter>;
  defaultHeight: Scalars['Int']['output'];
  defaultMetricTemplateIds: Array<Scalars['ID']['output']>;
  defaultSegmentBy?: Maybe<ReportWidgetSegmentBy>;
  defaultWidth: Scalars['Int']['output'];
  /**
   * Columns a record-list widget renders. Empty on every aggregate template. Columns live here
   * rather than being modelled as metrics: a metric is an aggregation over a segment bucket, these
   * are per-document fields and several are not numeric.
   */
  recordFields: Array<ReportWidgetRecordField>;
  supportedCharts: Array<Scalars['String']['output']>;
  supportedDisplayOptions: Array<Scalars['String']['output']>;
  supportedSegments: Array<ReportWidgetSupportedSegment>;
  translations: ReportWidgetTemplateTranslations;
  widgetType: Scalars['String']['output'];
};

export type ReportWidgetTemplateTranslations = {
  __typename?: 'ReportWidgetTemplateTranslations';
  ar?: Maybe<Scalars['String']['output']>;
  de?: Maybe<Scalars['String']['output']>;
  en: Scalars['String']['output'];
  fr?: Maybe<Scalars['String']['output']>;
  tr?: Maybe<Scalars['String']['output']>;
};

export type ReportWidgetTemplatesResponse = {
  __typename?: 'ReportWidgetTemplatesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<ReportWidgetTemplate>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportWidgetViewBy = {
  __typename?: 'ReportWidgetViewBy';
  aggregation: ReportSnapshotAggregation;
  countTarget?: Maybe<ReportSnapshotCountTarget>;
  field: Scalars['String']['output'];
};

export type ReportWidgetsResponse = {
  __typename?: 'ReportWidgetsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<ReportWidget>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportsResponse = {
  __typename?: 'ReportsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Report>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendCreatePasswordMailInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type ResendCreatePasswordMailResponse = {
  __typename?: 'ResendCreatePasswordMailResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerPerson>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetMyPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResumeCampaignInput = {
  campaignId: Scalars['ID']['input'];
  confirmLongPause?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
};

export type RetryFailedCampaignRecipientsData = {
  __typename?: 'RetryFailedCampaignRecipientsData';
  requeuedRecipients: Scalars['Int']['output'];
};

export type RetryFailedCampaignRecipientsInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  errorClasses?: InputMaybe<Array<CampaignErrorClass>>;
  errorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RetryFailedCampaignRecipientsResponse = {
  __typename?: 'RetryFailedCampaignRecipientsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<RetryFailedCampaignRecipientsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetryPaymentInput = {
  customerId: Scalars['ID']['input'];
  ipAdress: Scalars['String']['input'];
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
  paymentMethod: PaymentMethodEnum;
  type: PaymentDetailsEnum;
};

export enum RolePermission {
  AiAccess = 'AI_ACCESS',
  AiAccessAgent = 'AI_ACCESS_AGENT',
  AiAccessAssistant = 'AI_ACCESS_ASSISTANT',
  AiAccessKnowledge = 'AI_ACCESS_KNOWLEDGE',
  AiManageAgent = 'AI_MANAGE_AGENT',
  AiManageAssistant = 'AI_MANAGE_ASSISTANT',
  AiManageKnowledge = 'AI_MANAGE_KNOWLEDGE',
  BulksharingsAccess = 'BULKSHARINGS_ACCESS',
  BulksharingsAccessCollage = 'BULKSHARINGS_ACCESS_COLLAGE',
  BulksharingsManage = 'BULKSHARINGS_MANAGE',
  BulksharingsManageCollage = 'BULKSHARINGS_MANAGE_COLLAGE',
  CampaignsAccess = 'CAMPAIGNS_ACCESS',
  CampaignsDelete = 'CAMPAIGNS_DELETE',
  CampaignsManage = 'CAMPAIGNS_MANAGE',
  ChannelsAccess = 'CHANNELS_ACCESS',
  ChannelsAccessIntegrations = 'CHANNELS_ACCESS_INTEGRATIONS',
  ChannelsDelete = 'CHANNELS_DELETE',
  ChannelsDeleteIntegrations = 'CHANNELS_DELETE_INTEGRATIONS',
  ChannelsManage = 'CHANNELS_MANAGE',
  ChannelsManageIntegrations = 'CHANNELS_MANAGE_INTEGRATIONS',
  ContactsAccess = 'CONTACTS_ACCESS',
  ContactsAccessSegments = 'CONTACTS_ACCESS_SEGMENTS',
  ContactsAccessSensitive = 'CONTACTS_ACCESS_SENSITIVE',
  ContactsDelete = 'CONTACTS_DELETE',
  ContactsDeleteSegments = 'CONTACTS_DELETE_SEGMENTS',
  ContactsExport = 'CONTACTS_EXPORT',
  ContactsImport = 'CONTACTS_IMPORT',
  ContactsManage = 'CONTACTS_MANAGE',
  ContactsManageSegments = 'CONTACTS_MANAGE_SEGMENTS',
  ConversationsAccess = 'CONVERSATIONS_ACCESS',
  ConversationsAccessBulkActions = 'CONVERSATIONS_ACCESS_BULK_ACTIONS',
  ConversationsAccessCalls = 'CONVERSATIONS_ACCESS_CALLS',
  ConversationsAccessContact = 'CONVERSATIONS_ACCESS_CONTACT',
  ConversationsAccessContactSensitive = 'CONVERSATIONS_ACCESS_CONTACT_SENSITIVE',
  ConversationsAccessJoinedTeam = 'CONVERSATIONS_ACCESS_JOINED_TEAM',
  ConversationsAccessTasks = 'CONVERSATIONS_ACCESS_TASKS',
  ConversationsAccessTasksTeamMembers = 'CONVERSATIONS_ACCESS_TASKS_TEAM_MEMBERS',
  ConversationsAccessTeamMembers = 'CONVERSATIONS_ACCESS_TEAM_MEMBERS',
  ConversationsAccessUnassigned = 'CONVERSATIONS_ACCESS_UNASSIGNED',
  ConversationsAccessViews = 'CONVERSATIONS_ACCESS_VIEWS',
  ConversationsExportConversation = 'CONVERSATIONS_EXPORT_CONVERSATION',
  ConversationsManageContact = 'CONVERSATIONS_MANAGE_CONTACT',
  ConversationsMerge = 'CONVERSATIONS_MERGE',
  ConversationsMergeContact = 'CONVERSATIONS_MERGE_CONTACT',
  ConversationsNewCall = 'CONVERSATIONS_NEW_CALL',
  ConversationsNewEmail = 'CONVERSATIONS_NEW_EMAIL',
  ConversationsNewTask = 'CONVERSATIONS_NEW_TASK',
  ConversationsNewTicket = 'CONVERSATIONS_NEW_TICKET',
  ConversationsNewWhatsapp = 'CONVERSATIONS_NEW_WHATSAPP',
  ConversationsSearch = 'CONVERSATIONS_SEARCH',
  ConversationsSpam = 'CONVERSATIONS_SPAM',
  ConversationsTransfer = 'CONVERSATIONS_TRANSFER',
  DashboardDashboardStats = 'DASHBOARD_DASHBOARD_STATS',
  DashboardNotifications = 'DASHBOARD_NOTIFICATIONS',
  DashboardTasks = 'DASHBOARD_TASKS',
  DashboardTeamMembers = 'DASHBOARD_TEAM_MEMBERS',
  DashboardWhatsNew = 'DASHBOARD_WHATS_NEW',
  SettingsAccess = 'SETTINGS_ACCESS',
  SettingsAccessActions = 'SETTINGS_ACCESS_ACTIONS',
  SettingsAccessApiKeys = 'SETTINGS_ACCESS_API_KEYS',
  SettingsAccessAuthentications = 'SETTINGS_ACCESS_AUTHENTICATIONS',
  SettingsAccessAutoActions = 'SETTINGS_ACCESS_AUTO_ACTIONS',
  SettingsAccessBilling = 'SETTINGS_ACCESS_BILLING',
  SettingsAccessCompanyBusinessHours = 'SETTINGS_ACCESS_COMPANY_BUSINESS_HOURS',
  SettingsAccessCompanyProfile = 'SETTINGS_ACCESS_COMPANY_PROFILE',
  SettingsAccessCustomFields = 'SETTINGS_ACCESS_CUSTOM_FIELDS',
  SettingsAccessInvoices = 'SETTINGS_ACCESS_INVOICES',
  SettingsAccessQuickReplies = 'SETTINGS_ACCESS_QUICK_REPLIES',
  SettingsAccessSlaPolicies = 'SETTINGS_ACCESS_SLA_POLICIES',
  SettingsAccessSurveys = 'SETTINGS_ACCESS_SURVEYS',
  SettingsAccessTags = 'SETTINGS_ACCESS_TAGS',
  SettingsAccessTeams = 'SETTINGS_ACCESS_TEAMS',
  SettingsAccessTeamGoals = 'SETTINGS_ACCESS_TEAM_GOALS',
  SettingsAccessTicketStates = 'SETTINGS_ACCESS_TICKET_STATES',
  SettingsAccessTicketTypes = 'SETTINGS_ACCESS_TICKET_TYPES',
  SettingsAccessTopics = 'SETTINGS_ACCESS_TOPICS',
  SettingsAccessUsers = 'SETTINGS_ACCESS_USERS',
  SettingsAccessUserActivityLogs = 'SETTINGS_ACCESS_USER_ACTIVITY_LOGS',
  SettingsAccessUserRoles = 'SETTINGS_ACCESS_USER_ROLES',
  SettingsAccessViews = 'SETTINGS_ACCESS_VIEWS',
  SettingsAccessWebhooks = 'SETTINGS_ACCESS_WEBHOOKS',
  SettingsDeleteActions = 'SETTINGS_DELETE_ACTIONS',
  SettingsDeleteApiKeys = 'SETTINGS_DELETE_API_KEYS',
  SettingsDeleteAuthentications = 'SETTINGS_DELETE_AUTHENTICATIONS',
  SettingsDeleteCustomFields = 'SETTINGS_DELETE_CUSTOM_FIELDS',
  SettingsDeleteQuickReplies = 'SETTINGS_DELETE_QUICK_REPLIES',
  SettingsDeleteSlaPolicies = 'SETTINGS_DELETE_SLA_POLICIES',
  SettingsDeleteSurveys = 'SETTINGS_DELETE_SURVEYS',
  SettingsDeleteTags = 'SETTINGS_DELETE_TAGS',
  SettingsDeleteTeams = 'SETTINGS_DELETE_TEAMS',
  SettingsDeleteTicketStates = 'SETTINGS_DELETE_TICKET_STATES',
  SettingsDeleteTicketTypes = 'SETTINGS_DELETE_TICKET_TYPES',
  SettingsDeleteTopics = 'SETTINGS_DELETE_TOPICS',
  SettingsDeleteUsers = 'SETTINGS_DELETE_USERS',
  SettingsDeleteUserRoles = 'SETTINGS_DELETE_USER_ROLES',
  SettingsDeleteViews = 'SETTINGS_DELETE_VIEWS',
  SettingsDeleteWebhooks = 'SETTINGS_DELETE_WEBHOOKS',
  SettingsManageActions = 'SETTINGS_MANAGE_ACTIONS',
  SettingsManageApiKeys = 'SETTINGS_MANAGE_API_KEYS',
  SettingsManageAuthentications = 'SETTINGS_MANAGE_AUTHENTICATIONS',
  SettingsManageAutoActions = 'SETTINGS_MANAGE_AUTO_ACTIONS',
  SettingsManageBilling = 'SETTINGS_MANAGE_BILLING',
  SettingsManageCompanyBusinessHours = 'SETTINGS_MANAGE_COMPANY_BUSINESS_HOURS',
  SettingsManageCompanyProfile = 'SETTINGS_MANAGE_COMPANY_PROFILE',
  SettingsManageCustomFields = 'SETTINGS_MANAGE_CUSTOM_FIELDS',
  SettingsManageInvoices = 'SETTINGS_MANAGE_INVOICES',
  SettingsManageQuickReplies = 'SETTINGS_MANAGE_QUICK_REPLIES',
  SettingsManageSlaPolicies = 'SETTINGS_MANAGE_SLA_POLICIES',
  SettingsManageSurveys = 'SETTINGS_MANAGE_SURVEYS',
  SettingsManageTags = 'SETTINGS_MANAGE_TAGS',
  SettingsManageTeams = 'SETTINGS_MANAGE_TEAMS',
  SettingsManageTeamGoals = 'SETTINGS_MANAGE_TEAM_GOALS',
  SettingsManageTicketStates = 'SETTINGS_MANAGE_TICKET_STATES',
  SettingsManageTicketTypes = 'SETTINGS_MANAGE_TICKET_TYPES',
  SettingsManageTopics = 'SETTINGS_MANAGE_TOPICS',
  SettingsManageUsers = 'SETTINGS_MANAGE_USERS',
  SettingsManageUserRoles = 'SETTINGS_MANAGE_USER_ROLES',
  SettingsManageViews = 'SETTINGS_MANAGE_VIEWS',
  SettingsManageWebhooks = 'SETTINGS_MANAGE_WEBHOOKS',
  StatisticsAccess = 'STATISTICS_ACCESS',
  StatisticsAccessCalls = 'STATISTICS_ACCESS_CALLS',
  StatisticsAccessConversations = 'STATISTICS_ACCESS_CONVERSATIONS',
  StatisticsAccessGeneral = 'STATISTICS_ACCESS_GENERAL',
  StatisticsAccessTickets = 'STATISTICS_ACCESS_TICKETS',
  StatisticsAccessUser = 'STATISTICS_ACCESS_USER',
  StatisticsExport = 'STATISTICS_EXPORT',
  TablesAccess = 'TABLES_ACCESS',
  TablesAccessRecords = 'TABLES_ACCESS_RECORDS',
  TablesAccessTeamMembersRecords = 'TABLES_ACCESS_TEAM_MEMBERS_RECORDS',
  TablesDeleteRecords = 'TABLES_DELETE_RECORDS',
  TablesManage = 'TABLES_MANAGE',
  TablesManageFields = 'TABLES_MANAGE_FIELDS',
  TablesManageFolders = 'TABLES_MANAGE_FOLDERS',
  TablesManageRecords = 'TABLES_MANAGE_RECORDS',
  TablesManageViews = 'TABLES_MANAGE_VIEWS',
  WorkflowsAccess = 'WORKFLOWS_ACCESS',
  WorkflowsDelete = 'WORKFLOWS_DELETE',
  WorkflowsManage = 'WORKFLOWS_MANAGE'
}

export enum RoleStatus {
  Admin = 'ADMIN',
  Custom = 'CUSTOM',
  JrAgent = 'JR_AGENT',
  Owner = 'OWNER',
  Personel = 'PERSONEL'
}

export enum RoleTypes {
  Admin = 'ADMIN',
  User = 'USER'
}

export type RollbackLiveChatWidgetReleaseInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  releaseId: Scalars['ID']['input'];
};

export type RunCustomDataType = {
  data?: InputMaybe<CustomDataType>;
  op?: InputMaybe<CustomQueryOperationsType>;
};

export type RunCustomECommerceIntegrationInput = {
  customerId: Scalars['ID']['input'];
  metaData: RunCustomDataType;
  type: ECommerceIntegrationTypes;
};

export type RunCustomIntegrationInput = {
  customerId: Scalars['ID']['input'];
  metaData: RunCustomDataType;
  type: IntegrationType;
};

export enum Selected_Live_Chat_Icon {
  ChatBubbleIcon = 'CHAT_BUBBLE_ICON',
  ChatIcon = 'CHAT_ICON',
  InsertCommentIcon = 'INSERT_COMMENT_ICON',
  QpienDefaultIcon = 'QPIEN_DEFAULT_ICON',
  SmsIcon = 'SMS_ICON',
  UserUploadedIcon = 'USER_UPLOADED_ICON'
}

export type Satisfaction = {
  __typename?: 'Satisfaction';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  surveyAudioType?: Maybe<PhoneNumberSoundType>;
  surveyAudioUrl?: Maybe<Scalars['String']['output']>;
  thanksAudioType?: Maybe<PhoneNumberSoundType>;
  thanksAudioUrl?: Maybe<Scalars['String']['output']>;
};

export type SatisfactionByAgent = {
  __typename?: 'SatisfactionByAgent';
  cPersonId: Scalars['ID']['output'];
  scores: Array<SatisfactionByAgentScore>;
};

export type SatisfactionByAgentScore = {
  __typename?: 'SatisfactionByAgentScore';
  count: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type SatisfactionByScore = {
  __typename?: 'SatisfactionByScore';
  count: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type SatisfactionByTime = {
  __typename?: 'SatisfactionByTime';
  date: Scalars['String']['output'];
  scores: Array<SatisfactionByScore>;
};

export type SatisfactionChartData = {
  __typename?: 'SatisfactionChartData';
  byAgent: Array<SatisfactionByAgent>;
  byScore: Array<SatisfactionByScore>;
  byTime: Array<SatisfactionByTime>;
};

export type SatisfactionInput = {
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  surveyAudioType?: InputMaybe<PhoneNumberSoundType>;
  surveyAudioUrl?: InputMaybe<Scalars['Object']['input']>;
  thanksAudioType?: InputMaybe<PhoneNumberSoundType>;
  thanksAudioUrl?: InputMaybe<Scalars['Object']['input']>;
};

export type SaveConversationViewPreferenceInput = {
  customerId: Scalars['ID']['input'];
  views: Array<ConversationViewPreferenceItemInput>;
};

export type SaveOperatorReportInput = {
  chatId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type SaveReportWidgetLayoutInput = {
  layout: LayoutInput;
  widgetId: Scalars['ID']['input'];
};

export type ScanModuleForIntegrationInput = {
  customerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IntegrationType>;
};

export type ScheduleCampaignInput = {
  acknowledgeWarnings?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  scheduleDate: Scalars['Date']['input'];
};

export type ScheduleChangelogInput = {
  _id: Scalars['ID']['input'];
  scheduledAt: Scalars['Date']['input'];
};

export type SearchIntegrationInput = {
  customerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IntegrationType>;
};

export type SearchMetaAdsInput = {
  /** Ads already chosen; returned in `selected` whatever the search and filters. */
  adIds?: InputMaybe<Array<Scalars['String']['input']>>;
  channelType?: InputMaybe<ChannelType>;
  customerId: Scalars['ID']['input'];
  onlyMatchingChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skips the 10-minute per-account cache. */
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SectionConfig = {
  __typename?: 'SectionConfig';
  fields?: Maybe<Array<Maybe<SectionField>>>;
  layout?: Maybe<SectionLayout>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

export type SectionConfigInput = {
  fields?: InputMaybe<Array<InputMaybe<SectionFieldInput>>>;
  layout: SectionLayout;
  sectionTitle: Scalars['String']['input'];
};

export type SectionField = {
  __typename?: 'SectionField';
  defaultValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  uiSettings?: Maybe<SectionFieldUiSettings>;
};

export type SectionFieldInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  path: Scalars['String']['input'];
  uiSettings?: InputMaybe<SectionFieldUiSettingsInput>;
};

export type SectionFieldUiSettings = {
  __typename?: 'SectionFieldUISettings';
  color?: Maybe<Scalars['String']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  isVisibleLabel?: Maybe<Scalars['Boolean']['output']>;
  valueSettings?: Maybe<SectionFieldValueSettings>;
};

export type SectionFieldUiSettingsInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isVisibleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  valueSettings?: InputMaybe<SectionFieldValueSettingsInput>;
};

export type SectionFieldValueSettings = {
  __typename?: 'SectionFieldValueSettings';
  formatType?: Maybe<FieldFormatType>;
  valueFormat?: Maybe<Scalars['String']['output']>;
};

export type SectionFieldValueSettingsInput = {
  formatType?: InputMaybe<FieldFormatType>;
  valueFormat?: InputMaybe<Scalars['String']['input']>;
};

export enum SectionLayout {
  Full = 'FULL',
  Half = 'HALF'
}

export type SendCampaignInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  phoneNumberForTest?: InputMaybe<Scalars['String']['input']>;
};

export type SendCampaignResponseStatus = {
  __typename?: 'SendCampaignResponseStatus';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SendCampaignStatusType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendCampaignTestMessageInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
  sampleContactId?: InputMaybe<Scalars['ID']['input']>;
  variationKey?: InputMaybe<Scalars['String']['input']>;
};

export type SendCampaignWinnerInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  variationKey?: InputMaybe<Scalars['String']['input']>;
};

export type SendMetaTestEventInput = {
  assetId: Scalars['String']['input'];
  channelType: ChannelType;
  customerId: Scalars['ID']['input'];
  eventName: Scalars['String']['input'];
  testEventCode: Scalars['String']['input'];
};

export type SendOperatorMessageInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  choice?: InputMaybe<OperatorChoiceInput>;
  context?: InputMaybe<OperatorContextInput>;
  customerId: Scalars['ID']['input'];
  /** At most 4 PNG or JPG images of up to 5 MB each; used in this Operator chat only. */
  images?: InputMaybe<Array<Scalars['FileUpload']['input']>>;
  /** May be empty when the message is images only. */
  text: Scalars['String']['input'];
};

export type SendScheduledMessageInput = {
  _id: Scalars['ID']['input'];
  conversation: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type SendTeamMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  media?: InputMaybe<Array<SendTeamMessageMediaInput>>;
  mentions?: InputMaybe<Array<Scalars['ID']['input']>>;
  replyToMessageId?: InputMaybe<Scalars['ID']['input']>;
  teamConversationId: Scalars['ID']['input'];
  waMentions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendTeamMessageMediaInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type: TeamChatMediaType;
  url: Scalars['String']['input'];
};

export enum SenderType {
  CustomerPersons = 'CustomerPersons',
  Persons = 'Persons'
}

export type SentimentByAgent = {
  __typename?: 'SentimentByAgent';
  cPersonId: Scalars['ID']['output'];
  negative: Scalars['Int']['output'];
  neutral: Scalars['Int']['output'];
  positive: Scalars['Int']['output'];
};

export type SentimentByTime = {
  __typename?: 'SentimentByTime';
  date: Scalars['String']['output'];
  negative: Scalars['Int']['output'];
  neutral: Scalars['Int']['output'];
  positive: Scalars['Int']['output'];
};

export type SentimentByTopic = {
  __typename?: 'SentimentByTopic';
  name: Scalars['String']['output'];
  negative: Scalars['Int']['output'];
  neutral: Scalars['Int']['output'];
  positive: Scalars['Int']['output'];
  topicId: Scalars['ID']['output'];
};

export type SentimentStats = {
  __typename?: 'SentimentStats';
  negative: Scalars['Int']['output'];
  neutral: Scalars['Int']['output'];
  positive: Scalars['Int']['output'];
};

export type SetCampaignLinksDisabledInput = {
  campaignId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SetConversationTypingInput = {
  conversationId: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  isTyping: Scalars['Boolean']['input'];
  typingUserId: Scalars['ID']['input'];
};

export type SetCustomerLinksDisabledInput = {
  customerId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerPaymentCardAsDefaultInput = {
  customerId: Scalars['ID']['input'];
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
};

export type SetDefaultTrackingDomainInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
};

export type SetMetaDatasetEnabledInput = {
  assetId: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export type SetOperatorAccessInput = {
  cPersonIds: Array<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  hasOperator: Scalars['Boolean']['input'];
};

export type SetSkillStatusInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  status: SkillStatus;
};

export enum SharingStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Shared = 'SHARED'
}

export enum SharingType {
  List = 'LIST',
  Request = 'REQUEST'
}

export type SidebarView = {
  __typename?: 'SidebarView';
  isPinned: Scalars['Boolean']['output'];
  view: ConversationView;
};

export type SignInAdminInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignInUserInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  deviceType: CustomerPersonDeviceType;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum SignUpMethod {
  Email = 'EMAIL',
  Google = 'GOOGLE'
}

export type SimilarContactsResponse = {
  __typename?: 'SimilarContactsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Person>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SimulateMetaAdClickInput = {
  adId?: InputMaybe<Scalars['String']['input']>;
  adName?: InputMaybe<Scalars['String']['input']>;
  adsetName?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['ID']['input'];
  channelType: ChannelType;
  conversionCurrency?: InputMaybe<Scalars['String']['input']>;
  conversionEventName?: InputMaybe<Scalars['String']['input']>;
  conversionValue?: InputMaybe<Scalars['Float']['input']>;
  customerId: Scalars['ID']['input'];
  headline?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SimulateSkillInput = {
  attributes?: InputMaybe<Scalars['Object']['input']>;
  customerId: Scalars['ID']['input'];
  memory?: InputMaybe<Scalars['Object']['input']>;
  message: Scalars['String']['input'];
  skillId: Scalars['ID']['input'];
};

export type SimulatedMetaAdClick = {
  __typename?: 'SimulatedMetaAdClick';
  adId?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<ChannelType>;
  senderId?: Maybe<Scalars['String']['output']>;
};

export type SimulatedMetaAdClickResponse = {
  __typename?: 'SimulatedMetaAdClickResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SimulatedMetaAdClick>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SingleConversation = {
  __typename?: 'SingleConversation';
  _id?: Maybe<Scalars['ID']['output']>;
  activeFlowInstance?: Maybe<Scalars['ID']['output']>;
  aiPersonMemory?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Maybe<ChannelTypes>>>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  isDummy?: Maybe<Scalars['Boolean']['output']>;
  isGroupOrChannel?: Maybe<Scalars['Boolean']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  isStarred?: Maybe<Scalars['Boolean']['output']>;
  joinTime?: Maybe<Scalars['Double']['output']>;
  joinedCPerson?: Maybe<CustomerPerson>;
  joinedPerson?: Maybe<Person>;
  lastJoinedCPerson?: Maybe<Scalars['ID']['output']>;
  lastMessage?: Maybe<LastMessageType>;
  lastReceivedMessageChannel?: Maybe<Scalars['ID']['output']>;
  mergedFrom?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  mergedTo?: Maybe<Scalars['ID']['output']>;
  openTime?: Maybe<Scalars['Double']['output']>;
  priority?: Maybe<TicketPriority>;
  slaInstance?: Maybe<Scalars['ID']['output']>;
  slaInstanceData?: Maybe<SlaInstance>;
  slaPolicy?: Maybe<Scalars['ID']['output']>;
  sourceFormId?: Maybe<Scalars['ID']['output']>;
  sourcePlatformType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConversationStatusEnum>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  ticketCustomFields?: Maybe<Array<Maybe<TicketCustomFieldOutput>>>;
  ticketId?: Maybe<Scalars['Number']['output']>;
  ticketState?: Maybe<Scalars['ID']['output']>;
  ticketStateCategory?: Maybe<TicketStateCategoryType>;
  ticketStateTime?: Maybe<Scalars['Object']['output']>;
  ticketType?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ConversationTypeEnum>;
  unAnsweredMessageCount?: Maybe<Scalars['Int']['output']>;
  waitingSince?: Maybe<Scalars['Date']['output']>;
};

export type SingleTeamsResponse = {
  __typename?: 'SingleTeamsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Teams;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Skill = {
  __typename?: 'Skill';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  draftDefinition: SkillDefinition;
  draftRevision: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedDefinition?: Maybe<SkillDefinition>;
  publishedVersion?: Maybe<Scalars['ID']['output']>;
  publishedVersionNumber?: Maybe<Scalars['Int']['output']>;
  roles?: Maybe<Array<AiRoleEnum>>;
  status: SkillStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SkillAgentCommandType {
  CallAction = 'CALL_ACTION',
  CallWriteAction = 'CALL_WRITE_ACTION',
  Complete = 'COMPLETE',
  DeleteComment = 'DELETE_COMMENT',
  HandoffCperson = 'HANDOFF_CPERSON',
  HandoffTeam = 'HANDOFF_TEAM',
  NoResponse = 'NO_RESPONSE',
  Respond = 'RESPOND',
  ReturnToQpienAi = 'RETURN_TO_QPIEN_AI',
  RunSkill = 'RUN_SKILL',
  SearchKnowledge = 'SEARCH_KNOWLEDGE',
  SwitchSkill = 'SWITCH_SKILL',
  UpdateAttribute = 'UPDATE_ATTRIBUTE'
}

export enum SkillCapabilityKind {
  Action = 'ACTION',
  Attribute = 'ATTRIBUTE',
  DeleteComment = 'DELETE_COMMENT',
  End = 'END',
  HandoffCperson = 'HANDOFF_CPERSON',
  HandoffTeam = 'HANDOFF_TEAM',
  Knowledge = 'KNOWLEDGE',
  NoReply = 'NO_REPLY',
  ReplyViaDm = 'REPLY_VIA_DM',
  ReturnToQpienAi = 'RETURN_TO_QPIEN_AI',
  RunSkill = 'RUN_SKILL',
  SwitchSkill = 'SWITCH_SKILL',
  UpdateAttribute = 'UPDATE_ATTRIBUTE',
  WriteAction = 'WRITE_ACTION'
}

export type SkillDefinition = {
  __typename?: 'SkillDefinition';
  document: Scalars['Object']['output'];
  formatVersion: Scalars['Int']['output'];
  scope: SkillScope;
};

export type SkillDefinitionInput = {
  document: Scalars['Object']['input'];
  formatVersion: Scalars['Int']['input'];
  scope: SkillScopeInput;
};

export enum SkillDraftGenerationMode {
  Draft = 'DRAFT',
  Optimize = 'OPTIMIZE'
}

export type SkillListResponse = {
  __typename?: 'SkillListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SkillListResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillListResult = {
  __typename?: 'SkillListResult';
  docs: Array<Skill>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SkillResponse = {
  __typename?: 'SkillResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Skill>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillRun = {
  __typename?: 'SkillRun';
  _id: Scalars['ID']['output'];
  aiMessageId?: Maybe<Scalars['ID']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  lastResponse?: Maybe<Scalars['String']['output']>;
  memory: Scalars['Object']['output'];
  parentRun?: Maybe<Scalars['ID']['output']>;
  session: Scalars['ID']['output'];
  skill: Scalars['ID']['output'];
  skillVersion: Scalars['ID']['output'];
  skillVersionNumber: Scalars['Int']['output'];
  startedAt: Scalars['Date']['output'];
  status: SkillRunStatus;
  suspendedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
  waitingReason?: Maybe<Scalars['String']['output']>;
};

export type SkillRunDetail = {
  __typename?: 'SkillRunDetail';
  run: SkillRun;
  steps: Array<SkillRunStep>;
};

export type SkillRunDetailResponse = {
  __typename?: 'SkillRunDetailResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SkillRunDetail>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillRunListResponse = {
  __typename?: 'SkillRunListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SkillRunListResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillRunListResult = {
  __typename?: 'SkillRunListResult';
  docs: Array<SkillRun>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SkillRunStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Suspended = 'SUSPENDED',
  WaitingInput = 'WAITING_INPUT'
}

export type SkillRunStep = {
  __typename?: 'SkillRunStep';
  _id: Scalars['ID']['output'];
  commandType: SkillAgentCommandType;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  cycle: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  input?: Maybe<Scalars['Object']['output']>;
  instructionAnchorIds: Array<Scalars['ID']['output']>;
  messageKey: Scalars['String']['output'];
  output?: Maybe<Scalars['Object']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  run: Scalars['ID']['output'];
  skill: Scalars['ID']['output'];
  skillVersion: Scalars['ID']['output'];
  status: SkillRunStepStatus;
};

export enum SkillRunStepStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  WaitingInput = 'WAITING_INPUT'
}

/**
 * A Skill turn as the tenant sees it: the steps it went through and the instructions behind them,
 * without the runtime detail the admin AI log carries.
 */
export type SkillRunView = {
  __typename?: 'SkillRunView';
  outcome: SkillRunViewEventKind;
  skillName: Scalars['String']['output'];
  startedAt: Scalars['Date']['output'];
  steps: Array<SkillRunViewStep>;
  summary?: Maybe<Scalars['String']['output']>;
};

/** One thing the Skill did inside a step, named for an agent reading the conversation panel. */
export type SkillRunViewEvent = {
  __typename?: 'SkillRunViewEvent';
  detail?: Maybe<Scalars['String']['output']>;
  kind: SkillRunViewEventKind;
  label?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export enum SkillRunViewEventKind {
  Action = 'ACTION',
  Answered = 'ANSWERED',
  Attribute = 'ATTRIBUTE',
  Ended = 'ENDED',
  Failed = 'FAILED',
  Handoff = 'HANDOFF',
  Knowledge = 'KNOWLEDGE',
  Returned = 'RETURNED',
  SubSkill = 'SUB_SKILL',
  Switched = 'SWITCHED',
  Thinking = 'THINKING',
  WriteAction = 'WRITE_ACTION'
}

export type SkillRunViewInput = {
  aiMessageId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type SkillRunViewResponse = {
  __typename?: 'SkillRunViewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<SkillRunView>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillRunViewStep = {
  __typename?: 'SkillRunViewStep';
  events: Array<SkillRunViewEvent>;
  instructions: Array<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  state: SkillRunViewStepState;
  title: Scalars['String']['output'];
};

export enum SkillRunViewStepState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Stopped = 'STOPPED',
  Waiting = 'WAITING'
}

export type SkillScope = {
  __typename?: 'SkillScope';
  channelIds: Array<Scalars['ID']['output']>;
  messageTypes: Array<Scalars['String']['output']>;
};

export type SkillScopeInput = {
  channelIds: Array<Scalars['ID']['input']>;
  messageTypes: Array<Scalars['String']['input']>;
};

export type SkillScopedIdInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type SkillSimulationResponse = {
  __typename?: 'SkillSimulationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SkillSimulationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillSimulationResult = {
  __typename?: 'SkillSimulationResult';
  command?: Maybe<SkillAgentCommandType>;
  debug: Scalars['Object']['output'];
  decision: Scalars['String']['output'];
  matched: Scalars['Boolean']['output'];
  memory: Scalars['Object']['output'];
  response?: Maybe<Scalars['String']['output']>;
  selectedSkillId?: Maybe<Scalars['ID']['output']>;
};

export enum SkillStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Paused = 'PAUSED'
}

export type SkillVersion = {
  __typename?: 'SkillVersion';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  definition: SkillDefinition;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publishedAt: Scalars['Date']['output'];
  skill: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type SkillVersionListResponse = {
  __typename?: 'SkillVersionListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SkillVersionListResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillVersionListResult = {
  __typename?: 'SkillVersionListResult';
  docs: Array<SkillVersion>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SlaAgentStatistics = {
  __typename?: 'SlaAgentStatistics';
  averageSeconds: Scalars['Float']['output'];
  bad: Scalars['Int']['output'];
  badPercent: Scalars['Float']['output'];
  breached: Scalars['Int']['output'];
  cPersonId: Scalars['ID']['output'];
  good: Scalars['Int']['output'];
  goodPercent: Scalars['Float']['output'];
  medium: Scalars['Int']['output'];
  mediumPercent: Scalars['Float']['output'];
  met: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SlaConditionField {
  Channel = 'CHANNEL',
  MessageType = 'MESSAGE_TYPE',
  Tag = 'TAG',
  TicketPriority = 'TICKET_PRIORITY',
  TicketState = 'TICKET_STATE',
  TicketType = 'TICKET_TYPE'
}

export enum SlaConditionOperator {
  Contains = 'CONTAINS',
  Equal = 'EQUAL',
  NotContains = 'NOT_CONTAINS',
  NotEqual = 'NOT_EQUAL'
}

export type SlaHistory = {
  __typename?: 'SlaHistory';
  _id: Scalars['ID']['output'];
  cPerson?: Maybe<Scalars['ID']['output']>;
  channelId?: Maybe<Scalars['ID']['output']>;
  channelType?: Maybe<PlatformType>;
  conversation: Scalars['ID']['output'];
  conversationStatus?: Maybe<ConversationStatusEnum>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  historyType: SlaStageName;
  person?: Maybe<Scalars['ID']['output']>;
  slaInstance?: Maybe<Scalars['ID']['output']>;
  slaPolicy?: Maybe<Scalars['ID']['output']>;
  slaStatus?: Maybe<SlaStageStatus>;
  slaTargetTime?: Maybe<Scalars['Int']['output']>;
  slaTime?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SlaHistoryListResponse = {
  __typename?: 'SlaHistoryListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedSlaHistory>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum SlaHistoryType {
  ArchivedPolicyFallback = 'ARCHIVED_POLICY_FALLBACK',
  PolicyChanged = 'POLICY_CHANGED',
  StageAbandoned = 'STAGE_ABANDONED',
  StageBreached = 'STAGE_BREACHED',
  StageCompleted = 'STAGE_COMPLETED',
  StagePaused = 'STAGE_PAUSED',
  StageResumed = 'STAGE_RESUMED',
  StageStarted = 'STAGE_STARTED',
  Started = 'STARTED'
}

export type SlaInput = {
  resolutionTime?: InputMaybe<SlaMetricInput>;
  responseTime?: InputMaybe<SlaMetricInput>;
  rules?: InputMaybe<SlaRulesInput>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SlaInstance = {
  __typename?: 'SlaInstance';
  _id: Scalars['ID']['output'];
  convId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  firstResponse: SlaStage;
  nextResponse?: Maybe<SlaStage>;
  resolution: SlaStage;
  slaPolicyId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SlaInstanceResponse = {
  __typename?: 'SlaInstanceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SlaInstance>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SlaMetricInput = {
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SlaPerformanceStatistics = {
  __typename?: 'SlaPerformanceStatistics';
  byTime: Array<SlaPerformanceStatisticsPoint>;
  summary: SlaPerformanceStatisticsSummary;
};

export type SlaPerformanceStatisticsPoint = {
  __typename?: 'SlaPerformanceStatisticsPoint';
  bad: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  good: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SlaPerformanceStatisticsSummary = {
  __typename?: 'SlaPerformanceStatisticsSummary';
  bad: Scalars['Int']['output'];
  badPercent: Scalars['Float']['output'];
  good: Scalars['Int']['output'];
  goodPercent: Scalars['Float']['output'];
  medium: Scalars['Int']['output'];
  mediumPercent: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
};

export type SlaPolicy = {
  __typename?: 'SlaPolicy';
  _id: Scalars['ID']['output'];
  conditions: Array<SlaPolicyCondition>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customerId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rules: SlaPolicyRules;
  status: SlaPolicyStatus;
  targets: SlaPolicyTargets;
  type: SlaPolicyType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SlaPolicyCondition = {
  __typename?: 'SlaPolicyCondition';
  field: SlaConditionField;
  operator: SlaConditionOperator;
  values: Array<Scalars['String']['output']>;
};

export type SlaPolicyConditionInput = {
  field: SlaConditionField;
  operator: SlaConditionOperator;
  values: Array<Scalars['String']['input']>;
};

export type SlaPolicyListResponse = {
  __typename?: 'SlaPolicyListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginatedSlaPolicy>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SlaPolicyResponse = {
  __typename?: 'SlaPolicyResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SlaPolicy>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SlaPolicyRules = {
  __typename?: 'SlaPolicyRules';
  continueOnReopen: Scalars['Boolean']['output'];
  pauseWhenSnoozed: Scalars['Boolean']['output'];
  pauseWhenWaitingReply: Scalars['Boolean']['output'];
  workingHoursAware: Scalars['Boolean']['output'];
};

export type SlaPolicyRulesInput = {
  continueOnReopen?: InputMaybe<Scalars['Boolean']['input']>;
  pauseWhenSnoozed?: InputMaybe<Scalars['Boolean']['input']>;
  pauseWhenWaitingReply?: InputMaybe<Scalars['Boolean']['input']>;
  workingHoursAware?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SlaPolicyStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type SlaPolicyTargets = {
  __typename?: 'SlaPolicyTargets';
  customerUnresponsive?: Maybe<Scalars['Int']['output']>;
  customerUnresponsiveUnit?: Maybe<Scalars['String']['output']>;
  firstResponse: Scalars['Int']['output'];
  firstResponseUnit?: Maybe<Scalars['String']['output']>;
  nextResponse: Scalars['Int']['output'];
  nextResponseUnit?: Maybe<Scalars['String']['output']>;
  resolution: Scalars['Int']['output'];
  resolutionUnit?: Maybe<Scalars['String']['output']>;
};

export type SlaPolicyTargetsInput = {
  customerUnresponsive?: InputMaybe<Scalars['Int']['input']>;
  customerUnresponsiveUnit?: InputMaybe<Scalars['String']['input']>;
  firstResponse?: InputMaybe<Scalars['Int']['input']>;
  firstResponseUnit?: InputMaybe<Scalars['String']['input']>;
  nextResponse?: InputMaybe<Scalars['Int']['input']>;
  nextResponseUnit?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['Int']['input']>;
  resolutionUnit?: InputMaybe<Scalars['String']['input']>;
};

export enum SlaPolicyType {
  Conversation = 'CONVERSATION',
  Ticket = 'TICKET'
}

export type SlaReportResponse = {
  __typename?: 'SlaReportResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SlaReportSummary>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SlaReportStageMetrics = {
  __typename?: 'SlaReportStageMetrics';
  averageSeconds: Scalars['Float']['output'];
  breachRate: Scalars['Float']['output'];
  breached: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  onTimeRate: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
};

export type SlaReportSummary = {
  __typename?: 'SlaReportSummary';
  firstResponse: SlaReportStageMetrics;
  nextResponse: SlaReportStageMetrics;
  resolution: SlaReportStageMetrics;
  totalHistoryRecords: Scalars['Int']['output'];
  totalInstances: Scalars['Int']['output'];
  totalPolicies: Scalars['Int']['output'];
};

export type SlaRulesInput = {
  abandonedBefore10Seconds?: InputMaybe<Scalars['String']['input']>;
  unansweredCalls?: InputMaybe<Scalars['String']['input']>;
};

export type SlaStage = {
  __typename?: 'SlaStage';
  elapsedSeconds?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  pauseReason?: Maybe<Scalars['String']['output']>;
  pausedAt?: Maybe<Scalars['Date']['output']>;
  pausedSeconds?: Maybe<Scalars['Int']['output']>;
  remainingSeconds?: Maybe<Scalars['Int']['output']>;
  resolutionSeconds?: Maybe<Scalars['Int']['output']>;
  responseSeconds?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<SlaStageStatus>;
  targetSeconds?: Maybe<Scalars['Int']['output']>;
};

export enum SlaStageName {
  SlaFirstResponse = 'SLA_FIRST_RESPONSE',
  SlaNextResponse = 'SLA_NEXT_RESPONSE',
  SlaResolution = 'SLA_RESOLUTION'
}

export enum SlaStageStatus {
  Abandoned = 'abandoned',
  Breached = 'breached',
  Met = 'met',
  Paused = 'paused',
  WaitingAgent = 'waitingAgent',
  WaitingCustomer = 'waitingCustomer'
}

export type SlaStageTimeStatistics = {
  __typename?: 'SlaStageTimeStatistics';
  byTime: Array<SlaStageTimeStatisticsPoint>;
  selectedStage: SlaStageName;
  totals: Array<SlaStageTimeStatisticsTotal>;
};

export type SlaStageTimeStatisticsPoint = {
  __typename?: 'SlaStageTimeStatisticsPoint';
  averageSeconds: Scalars['Float']['output'];
  averageTargetSeconds: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type SlaStageTimeStatisticsResponse = {
  __typename?: 'SlaStageTimeStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SlaStageTimeStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SlaStageTimeStatisticsTotal = {
  __typename?: 'SlaStageTimeStatisticsTotal';
  averageSeconds: Scalars['Float']['output'];
  averageTargetSeconds: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  stage: SlaStageName;
};

export type SlaStatistics = {
  __typename?: 'SlaStatistics';
  agents: Array<SlaAgentStatistics>;
  performance: SlaPerformanceStatistics;
  stageTime: SlaStageTimeStatistics;
  status: SlaStatusStatistics;
};

export type SlaStatisticsResponse = {
  __typename?: 'SlaStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SlaStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SlaStatusStatistics = {
  __typename?: 'SlaStatusStatistics';
  byTime: Array<SlaStatusStatisticsPoint>;
  selectedStatus: SlaStageStatus;
  totals: Array<SlaStatusStatisticsTotal>;
};

export type SlaStatusStatisticsPoint = {
  __typename?: 'SlaStatusStatisticsPoint';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type SlaStatusStatisticsResponse = {
  __typename?: 'SlaStatusStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SlaStatusStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SlaStatusStatisticsTotal = {
  __typename?: 'SlaStatusStatisticsTotal';
  count: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
  status: SlaStageStatus;
};

export type SmtpConfigInput = {
  auth?: InputMaybe<AuthInput>;
  host?: InputMaybe<Scalars['String']['input']>;
  imap?: InputMaybe<ImapServerInput>;
  port?: InputMaybe<Scalars['Int']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpecialOfferPackageInput = {
  cPerson?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  metaWhatsAppBusiness?: InputMaybe<Scalars['Int']['input']>;
  monthlyPrice?: InputMaybe<Scalars['Double']['input']>;
  operatorCredits?: InputMaybe<Scalars['Int']['input']>;
  person?: InputMaybe<Scalars['Int']['input']>;
  whatsAppBusiness?: InputMaybe<Scalars['Int']['input']>;
  yearlyPrice?: InputMaybe<Scalars['Double']['input']>;
};

export type StartCampaignInput = {
  acknowledgeWarnings?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type StartConversationSearchExportData = {
  __typename?: 'StartConversationSearchExportData';
  jobId: Scalars['ID']['output'];
  queuedAt: Scalars['Date']['output'];
  status: ConversationExportJobStatus;
};

export type StartConversationSearchExportInput = {
  data: GetConversationsInput;
  locale?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type StartConversationSearchExportResponse = {
  __typename?: 'StartConversationSearchExportResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<StartConversationSearchExportData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StateProvinceCity = {
  __typename?: 'StateProvinceCity';
  _id?: Maybe<Scalars['ID']['output']>;
  country?: Maybe<Country>;
  name?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<StateProvinceCity2>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StateProvinceCity2 = {
  __typename?: 'StateProvinceCity2';
  _id?: Maybe<Scalars['ID']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StateProvinceCityResponse = {
  __typename?: 'StateProvinceCityResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: StateProvinceCity;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StatesProvincesCitiesResponse = {
  __typename?: 'StatesProvincesCitiesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: PaginatedStateProvinceCity;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum Status {
  Error = 'error',
  Success = 'success'
}

export type StatusDns = {
  __typename?: 'StatusDns';
  dkim1?: Maybe<StatusDnsInfo>;
  dkim2?: Maybe<StatusDnsInfo>;
  mail_cname?: Maybe<StatusDnsInfo>;
};

export type StatusDnsInfo = {
  __typename?: 'StatusDnsInfo';
  data?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export enum StepSourceGroup {
  Comment = 'COMMENT',
  Common = 'COMMON',
  Private = 'PRIVATE'
}

export enum StepType {
  Action = 'ACTION',
  ActionRequest = 'ACTION_REQUEST',
  AiImageRecognition = 'AI_IMAGE_RECOGNITION',
  AiProfile = 'AI_PROFILE',
  CommerceProduct = 'COMMERCE_PRODUCT',
  Guidance = 'GUIDANCE',
  Image = 'IMAGE',
  Instruction = 'INSTRUCTION',
  KnowledgeSource = 'KNOWLEDGE_SOURCE',
  MarketplaceRequest = 'MARKETPLACE_REQUEST',
  PostDetail = 'POST_DETAIL',
  Skill = 'SKILL'
}

export type SubImportedPersonsProgressInfo = {
  __typename?: 'SubImportedPersonsProgressInfo';
  errorsLink?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  percent: Scalars['Int']['output'];
  success?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type SubImportedPersonsResponse = {
  __typename?: 'SubImportedPersonsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: SubImportedPersonsProgressInfo;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscribeNotificationInput = {
  deviceToken: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeResponse = {
  __typename?: 'SubscribeResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  PERSON_SUBS_PROCESS: ProgressUpdatePersonResponse;
  autoLogoutPerson: OCustomerPersonResponse;
  bulkSharingCreate?: Maybe<OBulkSharingResponse>;
  bulkSharingFolderProcess?: Maybe<BulkSharingProcessRes>;
  bulkSharingUpdate?: Maybe<OBulkSharingResponse>;
  buyCustomerProductAddOn: CustomerProductAddOnResponse;
  cPersonNotification: OcPersonNotificationResponse;
  cPersonNotificationReceived: OcPersonNotificationReceivedResponse;
  changeMessageAck: OMessageAckResponse;
  createdAction: OActionResponse;
  createdAiMessage: AiMessageEventResponse;
  createdAuthentication: OAuthenticationResponse;
  createdCollageProduct: OCollageProductResponse;
  createdCollageSharing: OCollageSharingResponse;
  createdCollageTemplate: OCollageTemplateResponse;
  createdCouponCode: CouponCodesResponse;
  createdCustomer: OCustomerResponse;
  createdCustomerPerson: OCustomerPersonResponse;
  createdCustomerPersonActivityLog: OCustomerPersonActivityLogResponse;
  createdCustomerProduct: CustomerProductResponse;
  createdCustomerSpecialPackage?: Maybe<OProductResponse>;
  createdDelayedActions: ODelayedActionResponse;
  createdDomain: DomainResponse;
  createdECommerceCheckouts: OPlatformResponse;
  createdECommerceCustomers: OPlatformResponse;
  createdECommerceOrders: OPlatformResponse;
  createdECommercePlatform: OPlatformResponse;
  createdECommerceProducts: OPlatformResponse;
  createdExternalApi: OExternalApiResponse;
  createdMetaWhatsAppBusinessTemplate: WabaTemplateSubscriptionResponse;
  createdPerson: OPersonResponse;
  createdPlatform: OPlatformResponse;
  createdProduct: OProductResponse;
  createdQuickAnswer: OQuickAnswerResponse;
  createdTags: OTagResponse;
  createdTask: OTaskResponse;
  createdTaskLogs: TaskLogResponse;
  createdUser: OUserResponse;
  createdWebhook: OWebhookResponse;
  createdWhatsAppBusinessTemplate: OWaBaTemplateDataResponse;
  customPlatformSubscribed: OPlatformResponse;
  customerPersonTypingUpdated: OCustomerPersonTypingResponse;
  deleteCollageFolder: CustomerProductAddOnResponse;
  deleteCustomerProductAddOn: CustomerProductAddOnResponse;
  deletedAction: OActionResponse;
  deletedAuthentication: OAuthenticationResponse;
  deletedCollageProduct: OCollageProductResponse;
  deletedCollageSharing: OCollageSharingResponse;
  deletedCollageTemplate: OCollageTemplateResponse;
  deletedCouponCode: OCouponCodeResponse;
  deletedCustomer: OCustomerResponse;
  deletedCustomerPerson: OCustomerPersonResponse;
  deletedCustomerSpecialPackage?: Maybe<OProductResponse>;
  deletedDelayedActions: ODelayedActionResponse;
  deletedDomain: DomainResponse;
  deletedECommerceCheckouts: OPlatformResponse;
  deletedECommerceCustomers: OPlatformResponse;
  deletedECommerceOrders: OPlatformResponse;
  deletedECommercePlatform: OPlatformResponse;
  deletedECommerceProducts: OPlatformResponse;
  deletedExternalApi: OExternalApiResponse;
  deletedMetaWhatsAppBusinessTemplate: WabaTemplateSubscriptionResponse;
  deletedPerson: OPersonResponse;
  deletedPlatform: OPlatformResponse;
  deletedProduct: OProductResponse;
  deletedQuickAnswer: OQuickAnswerResponse;
  deletedTags: OTagResponse;
  deletedTask: OTaskResponse;
  deletedUser: OUserResponse;
  deletedWebhook: OWebhookResponse;
  deletedWhatsAppBusinessTemplate: OWaBaTemplateDataResponse;
  /**
   * Fires when a shared, per-tenant entity (tags, quick answers, custom fields, ...)
   * is created, updated or deleted, so open clients can refetch it without a reload.
   */
  entityChanged: EntityChangedResponse;
  importedPersons: SubImportedPersonsResponse;
  joinedConversation: OConversationResponse;
  leftConversation: OConversationResponse;
  meCreatedConversation: OConversationResponse;
  messageToMe: OMessageToMeResponse;
  messageToMeForLiveChat: OMessageToMeResponse;
  operatorRunProgress?: Maybe<OperatorRunProgressResponse>;
  publishedAnnouncement?: Maybe<PublishedChangelogResponse>;
  readMessage: OMessageResponse;
  resendMailCustomerPerson: OCustomerPersonResponse;
  /** Live create/update/delete of comments on one task. token = customer person JWT. */
  taskCommentChanged: TaskCommentChangedResponse;
  teamChatUnreadCountUpdated: TeamChatUnreadEventResponse;
  teamChatUpdated: TeamChatEventResponse;
  teamMessageUpdated: TeamMessageEventResponse;
  trainedModel: OPlatformResponse;
  transferedConversation: OConversationResponse;
  typingStatusUpdated: OTypingStatusUpdatedResponse;
  updatedAction: OActionResponse;
  updatedAiMessage: AiMessageEventResponse;
  updatedAiProfile: OAiProfileResponse;
  updatedAuthentication: OAuthenticationResponse;
  updatedCampaign?: Maybe<OUpdatedCampaignResponse>;
  updatedCollageProduct: OCollageProductResponse;
  updatedCollageSharing: OCollageSharingResponse;
  updatedCollageTemplate: OCollageTemplateResponse;
  updatedConversationStatus: OConversationResponse;
  updatedCustomer: OCustomerResponse;
  updatedCustomerPerson: OCustomerPersonResponse;
  updatedCustomerProduct: CustomerProductResponse;
  updatedCustomerSpecialPackage?: Maybe<OProductResponse>;
  updatedDelayedActions: ODelayedActionResponse;
  updatedDomain: DomainResponse;
  updatedECommerceCheckouts: OPlatformResponse;
  updatedECommerceCustomers: OPlatformResponse;
  updatedECommerceOrders: OPlatformResponse;
  updatedECommercePlatform: OPlatformResponse;
  updatedECommerceProducts: OPlatformResponse;
  updatedExternalApi: OExternalApiResponse;
  updatedFlowBot: UpdateFlowBotSubResponse;
  updatedGroup: OUpdatedGroupResponse;
  updatedMe: OCustomerPersonResponse;
  updatedMessage: OMessageResponse;
  updatedPerson: OPersonResponse;
  updatedPersonCustomer: CustomerResponse;
  updatedPlatform: OPlatformResponse;
  updatedProduct: OProductResponse;
  updatedQuickAnswer: OQuickAnswerResponse;
  updatedTags: OTagResponse;
  updatedTask: OTaskResponse;
  updatedTrackingDomain?: Maybe<UpdatedTrackingDomainResponse>;
  updatedUser: OUserResponse;
  updatedWebhook: OWebhookResponse;
};


export type SubscriptionPerson_Subs_ProcessArgs = {
  data: PersonSubscriptionInput;
};


export type SubscriptionAutoLogoutPersonArgs = {
  data?: InputMaybe<AutoLogoutSubscriptionInput>;
};


export type SubscriptionBulkSharingCreateArgs = {
  input?: InputMaybe<BulkSharingProcessSubscriptionInput>;
};


export type SubscriptionBulkSharingFolderProcessArgs = {
  input?: InputMaybe<BulkSharingProcessSubscriptionInput>;
};


export type SubscriptionBulkSharingUpdateArgs = {
  input?: InputMaybe<BulkSharingProcessSubscriptionInput>;
};


export type SubscriptionBuyCustomerProductAddOnArgs = {
  data: CustomerProductAddOnSubscriptionInput;
};


export type SubscriptionCPersonNotificationArgs = {
  data?: InputMaybe<CPersonNotificationSubscriptionInput>;
};


export type SubscriptionCPersonNotificationReceivedArgs = {
  data: CPersonNotificationReceivedSubInput;
};


export type SubscriptionChangeMessageAckArgs = {
  data: MessageAckSubscriptionInput;
};


export type SubscriptionCreatedActionArgs = {
  input: ActionSubscriptionInput;
};


export type SubscriptionCreatedAiMessageArgs = {
  data: AiMessageSubscriptionInput;
};


export type SubscriptionCreatedAuthenticationArgs = {
  input: AuthenticationSubscriptionInput;
};


export type SubscriptionCreatedCollageProductArgs = {
  input: CollageProductSubscriptionInput;
};


export type SubscriptionCreatedCollageSharingArgs = {
  input: CollageSharingSubscriptionInput;
};


export type SubscriptionCreatedCollageTemplateArgs = {
  input: CollageTemplateSubscriptionInput;
};


export type SubscriptionCreatedCouponCodeArgs = {
  data: CouponCodeSubscriptionInput;
};


export type SubscriptionCreatedCustomerArgs = {
  data: CustomerSubscriptionInput;
};


export type SubscriptionCreatedCustomerPersonArgs = {
  data: CPersonSubscriptionInput;
};


export type SubscriptionCreatedCustomerPersonActivityLogArgs = {
  input: CustomerPersonActivityLogSubscriptionInput;
};


export type SubscriptionCreatedCustomerProductArgs = {
  data: CustomerProductSubscriptionInput;
};


export type SubscriptionCreatedCustomerSpecialPackageArgs = {
  data: CustomerSpecialPackageSubscriptionInput;
};


export type SubscriptionCreatedDelayedActionsArgs = {
  data: DelayedActionSubscriptionInput;
};


export type SubscriptionCreatedDomainArgs = {
  data: DomainSubscriptionInput;
};


export type SubscriptionCreatedECommerceCheckoutsArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionCreatedECommerceCustomersArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionCreatedECommerceOrdersArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionCreatedECommercePlatformArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionCreatedECommerceProductsArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionCreatedExternalApiArgs = {
  input: ExternalApiSubscriptionInput;
};


export type SubscriptionCreatedMetaWhatsAppBusinessTemplateArgs = {
  data: WabaTemplateSubscriptionInput;
};


export type SubscriptionCreatedPersonArgs = {
  data: PersonSubscriptionInput;
};


export type SubscriptionCreatedPlatformArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionCreatedProductArgs = {
  data: ProductSubscriptionInput;
};


export type SubscriptionCreatedQuickAnswerArgs = {
  data: QuickAnswerSubscriptionInput;
};


export type SubscriptionCreatedTagsArgs = {
  data: TagSubscriptionInput;
};


export type SubscriptionCreatedTaskArgs = {
  data: TaskSubscriptionInput;
};


export type SubscriptionCreatedTaskLogsArgs = {
  data: TaskLogSubscriptionInput;
};


export type SubscriptionCreatedUserArgs = {
  data: UserSubscriptionInput;
};


export type SubscriptionCreatedWebhookArgs = {
  input: WebhookSubscriptionInput;
};


export type SubscriptionCreatedWhatsAppBusinessTemplateArgs = {
  data: TempSubsData;
};


export type SubscriptionCustomPlatformSubscribedArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionCustomerPersonTypingUpdatedArgs = {
  data: CustomerPersonTypingInput;
};


export type SubscriptionDeleteCollageFolderArgs = {
  data: CustomerProductAddOnSubscriptionInput;
};


export type SubscriptionDeleteCustomerProductAddOnArgs = {
  data: CustomerProductAddOnSubscriptionInput;
};


export type SubscriptionDeletedActionArgs = {
  input: ActionSubscriptionInput;
};


export type SubscriptionDeletedAuthenticationArgs = {
  input: AuthenticationSubscriptionInput;
};


export type SubscriptionDeletedCollageProductArgs = {
  input: CollageProductSubscriptionInput;
};


export type SubscriptionDeletedCollageSharingArgs = {
  input: CollageSharingSubscriptionInput;
};


export type SubscriptionDeletedCollageTemplateArgs = {
  input: CollageTemplateSubscriptionInput;
};


export type SubscriptionDeletedCouponCodeArgs = {
  data: CouponCodeSubscriptionInput;
};


export type SubscriptionDeletedCustomerArgs = {
  data: CustomerSubscriptionInput;
};


export type SubscriptionDeletedCustomerPersonArgs = {
  data: CPersonSubscriptionInput;
};


export type SubscriptionDeletedCustomerSpecialPackageArgs = {
  data: CustomerSpecialPackageSubscriptionInput;
};


export type SubscriptionDeletedDelayedActionsArgs = {
  data: DelayedActionSubscriptionInput;
};


export type SubscriptionDeletedDomainArgs = {
  data: DomainSubscriptionInput;
};


export type SubscriptionDeletedECommerceCheckoutsArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionDeletedECommerceCustomersArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionDeletedECommerceOrdersArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionDeletedECommercePlatformArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionDeletedECommerceProductsArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionDeletedExternalApiArgs = {
  input: ExternalApiSubscriptionInput;
};


export type SubscriptionDeletedMetaWhatsAppBusinessTemplateArgs = {
  data: WabaTemplateSubscriptionInput;
};


export type SubscriptionDeletedPersonArgs = {
  data: PersonSubscriptionInput;
};


export type SubscriptionDeletedPlatformArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionDeletedProductArgs = {
  data: ProductSubscriptionInput;
};


export type SubscriptionDeletedQuickAnswerArgs = {
  data: QuickAnswerSubscriptionInput;
};


export type SubscriptionDeletedTagsArgs = {
  data: TagSubscriptionInput;
};


export type SubscriptionDeletedTaskArgs = {
  data: TaskSubscriptionInput;
};


export type SubscriptionDeletedUserArgs = {
  data: UserSubscriptionInput;
};


export type SubscriptionDeletedWebhookArgs = {
  input: WebhookSubscriptionInput;
};


export type SubscriptionDeletedWhatsAppBusinessTemplateArgs = {
  data: TempSubsData;
};


export type SubscriptionEntityChangedArgs = {
  data: EntityChangedSubscriptionInput;
};


export type SubscriptionImportedPersonsArgs = {
  data: PersonSubscriptionInput;
};


export type SubscriptionJoinedConversationArgs = {
  data: ConversationSubscriptionInput;
};


export type SubscriptionLeftConversationArgs = {
  data: ConversationSubscriptionInput;
};


export type SubscriptionMeCreatedConversationArgs = {
  data: ConversationSubscriptionInput;
};


export type SubscriptionMessageToMeArgs = {
  data: MessageToMeSubscriptionInput;
};


export type SubscriptionMessageToMeForLiveChatArgs = {
  data: MessageToMeForLiveChatInputType;
};


export type SubscriptionOperatorRunProgressArgs = {
  data: OperatorRunProgressInput;
};


export type SubscriptionPublishedAnnouncementArgs = {
  input: ChangelogSubscriptionInput;
};


export type SubscriptionReadMessageArgs = {
  data: MessageSubscriptionInput;
};


export type SubscriptionResendMailCustomerPersonArgs = {
  data: CPersonSubscriptionInput;
};


export type SubscriptionTaskCommentChangedArgs = {
  taskId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type SubscriptionTeamChatUnreadCountUpdatedArgs = {
  data: TeamChatSubscriptionInput;
};


export type SubscriptionTeamChatUpdatedArgs = {
  data: TeamChatSubscriptionInput;
};


export type SubscriptionTeamMessageUpdatedArgs = {
  data: TeamChatSubscriptionInput;
};


export type SubscriptionTrainedModelArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionTransferedConversationArgs = {
  data: ConversationSubscriptionInput;
};


export type SubscriptionTypingStatusUpdatedArgs = {
  data: TypingStatusUpdatedInput;
};


export type SubscriptionUpdatedActionArgs = {
  input: ActionSubscriptionInput;
};


export type SubscriptionUpdatedAiMessageArgs = {
  data: AiMessageSubscriptionInput;
};


export type SubscriptionUpdatedAiProfileArgs = {
  data: AiProfileSubscriptionInput;
};


export type SubscriptionUpdatedAuthenticationArgs = {
  input: AuthenticationSubscriptionInput;
};


export type SubscriptionUpdatedCampaignArgs = {
  input?: InputMaybe<UpdateSubscriptionInput>;
};


export type SubscriptionUpdatedCollageProductArgs = {
  input: CollageProductSubscriptionInput;
};


export type SubscriptionUpdatedCollageSharingArgs = {
  input: CollageSharingSubscriptionInput;
};


export type SubscriptionUpdatedCollageTemplateArgs = {
  input: CollageTemplateSubscriptionInput;
};


export type SubscriptionUpdatedConversationStatusArgs = {
  data: ConversationSubscriptionInput;
};


export type SubscriptionUpdatedCustomerArgs = {
  data: CustomerSubscriptionInput;
};


export type SubscriptionUpdatedCustomerPersonArgs = {
  data: CPersonSubscriptionInput;
};


export type SubscriptionUpdatedCustomerProductArgs = {
  data: CustomerProductSubscriptionInput;
};


export type SubscriptionUpdatedCustomerSpecialPackageArgs = {
  data: CustomerSpecialPackageSubscriptionInput;
};


export type SubscriptionUpdatedDelayedActionsArgs = {
  data: DelayedActionSubscriptionInput;
};


export type SubscriptionUpdatedDomainArgs = {
  data: DomainSubscriptionInput;
};


export type SubscriptionUpdatedECommerceCheckoutsArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionUpdatedECommerceCustomersArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionUpdatedECommerceOrdersArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionUpdatedECommercePlatformArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionUpdatedECommerceProductsArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionUpdatedExternalApiArgs = {
  input: ExternalApiSubscriptionInput;
};


export type SubscriptionUpdatedFlowBotArgs = {
  input: UpdateFlowBotSubscriptionInput;
};


export type SubscriptionUpdatedGroupArgs = {
  data?: InputMaybe<UpdateSubscriptionInput>;
};


export type SubscriptionUpdatedMeArgs = {
  data: CPersonSubscriptionInput;
};


export type SubscriptionUpdatedMessageArgs = {
  data: MessageSubscriptionInput;
};


export type SubscriptionUpdatedPersonArgs = {
  data: PersonSubscriptionInput;
};


export type SubscriptionUpdatedPersonCustomerArgs = {
  data: CustomerSubscriptionInput;
};


export type SubscriptionUpdatedPlatformArgs = {
  data: PlatformSubscriptionInput;
};


export type SubscriptionUpdatedProductArgs = {
  data: ProductSubscriptionInput;
};


export type SubscriptionUpdatedQuickAnswerArgs = {
  data: QuickAnswerSubscriptionInput;
};


export type SubscriptionUpdatedTagsArgs = {
  data: TagSubscriptionInput;
};


export type SubscriptionUpdatedTaskArgs = {
  data: TaskSubscriptionInput;
};


export type SubscriptionUpdatedTrackingDomainArgs = {
  input?: InputMaybe<UpdateSubscriptionInput>;
};


export type SubscriptionUpdatedUserArgs = {
  data: UserSubscriptionInput;
};


export type SubscriptionUpdatedWebhookArgs = {
  input: WebhookSubscriptionInput;
};

export type Survey = {
  __typename?: 'Survey';
  _id?: Maybe<Scalars['ID']['output']>;
  commentInputTitle?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  submitButtonText?: Maybe<Scalars['String']['output']>;
  thankYouMessage?: Maybe<Scalars['String']['output']>;
  themeMainColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SurveyDataInputForLivechat = {
  commentInputTitle?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  submitButtonText?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['String']['input']>;
  thanksMessage?: InputMaybe<Scalars['String']['input']>;
  themeMainColor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyFeedback = {
  __typename?: 'SurveyFeedback';
  _id?: Maybe<Scalars['ID']['output']>;
  commentInputTitle?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  isRated?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  submitButtonText?: Maybe<Scalars['String']['output']>;
  thankYouMessage?: Maybe<Scalars['String']['output']>;
  themeMainColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SurveyFeedbackResponse = {
  __typename?: 'SurveyFeedbackResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SurveyFeedback>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyHPersonPaginateType = {
  __typename?: 'SurveyHPersonPaginateType';
  docs?: Maybe<Array<Maybe<PersonSurveyHistory>>>;
  hasNextPage: Scalars['Boolean']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type SurveyHistory = {
  __typename?: 'SurveyHistory';
  _id?: Maybe<Scalars['ID']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['ID']['output']>;
  chat?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  customerPerson?: Maybe<Scalars['ID']['output']>;
  person?: Maybe<Scalars['ID']['output']>;
  rating?: Maybe<RatingType>;
  status?: Maybe<Scalars['Boolean']['output']>;
  survey?: Maybe<Scalars['ID']['output']>;
  surveyName?: Maybe<Scalars['String']['output']>;
  thankYouMessage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SurveyHistoryPersonStatisticsExportData = {
  __typename?: 'SurveyHistoryPersonStatisticsExportData';
  url: Scalars['String']['output'];
};

export type SurveyHistoryPersonStatisticsExportResponse = {
  __typename?: 'SurveyHistoryPersonStatisticsExportResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SurveyHistoryPersonStatisticsExportData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyHistoryResponse = {
  __typename?: 'SurveyHistoryResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<SurveyHistory>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyHistoryStatistic = {
  __typename?: 'SurveyHistoryStatistic';
  chartData: Array<Maybe<ChartSurveyReport>>;
  overallRating?: Maybe<Scalars['Double']['output']>;
  totalDissatisfied?: Maybe<Scalars['Double']['output']>;
  totalNeutral?: Maybe<Scalars['Double']['output']>;
  totalResponded?: Maybe<Scalars['Double']['output']>;
  totalSatisfied?: Maybe<Scalars['Double']['output']>;
  totalSent?: Maybe<Scalars['Double']['output']>;
};

export type SurveyHistoryStatisticPersonResponse = {
  __typename?: 'SurveyHistoryStatisticPersonResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: SurveyHPersonPaginateType;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyHistoryStatisticResponse = {
  __typename?: 'SurveyHistoryStatisticResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: SurveyHistoryStatistic;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Survey;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum SurveySnapshotStatisticsAggregation {
  Avg = 'avg',
  Count = 'count',
  Rate = 'rate'
}

export type SurveySnapshotStatisticsAppliedFilter = {
  __typename?: 'SurveySnapshotStatisticsAppliedFilter';
  field: Scalars['String']['output'];
  operator: SurveySnapshotStatisticsFilterOperator;
  value: Scalars['Object']['output'];
};

export enum SurveySnapshotStatisticsCountTarget {
  Snapshot = 'snapshot'
}

export type SurveySnapshotStatisticsDataPoint = {
  __typename?: 'SurveySnapshotStatisticsDataPoint';
  segment?: Maybe<Scalars['Object']['output']>;
  value: Scalars['Double']['output'];
};

export enum SurveySnapshotStatisticsDateField {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export enum SurveySnapshotStatisticsDatePreset {
  Last7days = 'last7days',
  Last30days = 'last30days',
  Last90days = 'last90days',
  LastMonth = 'lastMonth',
  ThisMonth = 'thisMonth',
  Today = 'today',
  Yesterday = 'yesterday'
}

export type SurveySnapshotStatisticsDateRangeInput = {
  field?: InputMaybe<SurveySnapshotStatisticsDateField>;
  from?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<SurveySnapshotStatisticsDatePreset>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type SurveySnapshotStatisticsFilterInput = {
  field: Scalars['String']['input'];
  operator: SurveySnapshotStatisticsFilterOperator;
  value: Scalars['Object']['input'];
};

export enum SurveySnapshotStatisticsFilterOperator {
  Eq = 'eq',
  In = 'in'
}

export enum SurveySnapshotStatisticsGranularity {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week'
}

export type SurveySnapshotStatisticsMeta = {
  __typename?: 'SurveySnapshotStatisticsMeta';
  appliedFilters: Array<SurveySnapshotStatisticsAppliedFilter>;
  dateRange?: Maybe<SurveySnapshotStatisticsResolvedDateRange>;
  segmentBy?: Maybe<SurveySnapshotStatisticsSegmentByMeta>;
  viewBy: SurveySnapshotStatisticsViewByMeta;
};

export type SurveySnapshotStatisticsResolvedDateRange = {
  __typename?: 'SurveySnapshotStatisticsResolvedDateRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type SurveySnapshotStatisticsResponse = {
  __typename?: 'SurveySnapshotStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: SurveySnapshotStatisticsResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveySnapshotStatisticsResult = {
  __typename?: 'SurveySnapshotStatisticsResult';
  data: Array<SurveySnapshotStatisticsDataPoint>;
  meta: SurveySnapshotStatisticsMeta;
};

export type SurveySnapshotStatisticsSegmentByInput = {
  field: Scalars['String']['input'];
  granularity?: InputMaybe<SurveySnapshotStatisticsGranularity>;
};

export type SurveySnapshotStatisticsSegmentByMeta = {
  __typename?: 'SurveySnapshotStatisticsSegmentByMeta';
  field: Scalars['String']['output'];
  granularity?: Maybe<Scalars['String']['output']>;
};

export type SurveySnapshotStatisticsViewByInput = {
  aggregation: SurveySnapshotStatisticsAggregation;
  countTarget?: InputMaybe<SurveySnapshotStatisticsCountTarget>;
  field: Scalars['String']['input'];
};

export type SurveySnapshotStatisticsViewByMeta = {
  __typename?: 'SurveySnapshotStatisticsViewByMeta';
  aggregation: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export type SurveysAllResponse = {
  __typename?: 'SurveysAllResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginateSurvey>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TabConfig = {
  __typename?: 'TabConfig';
  _id?: Maybe<Scalars['ID']['output']>;
  detailCard?: Maybe<DetailCardConfig>;
  isMain?: Maybe<Scalars['Boolean']['output']>;
  listCard?: Maybe<ListCardConfig>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TabConfigInput = {
  /**
   * Existing tab id (update). Keeps the tab's id so links to it stay valid;
   * omit for a new tab.
   */
  _id?: InputMaybe<Scalars['ID']['input']>;
  detailCard?: InputMaybe<DetailCardConfigInput>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  listCard?: InputMaybe<ListCardConfigInput>;
  title: Scalars['String']['input'];
};

export type Table = {
  __typename?: 'Table';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isRecordNoVisible?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recordCount?: Maybe<Scalars['Int']['output']>;
  rowHeight?: Maybe<TableRowHeight>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  teamIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type TableBooleanResponse = {
  __typename?: 'TableBooleanResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableBooleanResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TableBooleanResult = {
  __typename?: 'TableBooleanResult';
  value?: Maybe<Scalars['Boolean']['output']>;
};

export enum TableExportFormat {
  Csv = 'csv',
  Xlsx = 'xlsx'
}

export type TableField = {
  __typename?: 'TableField';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  listOptions?: Maybe<Array<Maybe<TableListOption>>>;
  name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<TableFieldSettings>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  tableId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TableFieldType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type TableFieldResponse = {
  __typename?: 'TableFieldResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableField>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TableFieldSettings = {
  __typename?: 'TableFieldSettings';
  associatedFieldId?: Maybe<Scalars['ID']['output']>;
  defaultValue?: Maybe<Scalars['Object']['output']>;
  displayFieldId?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isMultiline?: Maybe<Scalars['Boolean']['output']>;
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isUnique?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  linkedTableId?: Maybe<Scalars['ID']['output']>;
  lookupFieldId?: Maybe<Scalars['ID']['output']>;
};

export type TableFieldSettingsInput = {
  associatedFieldId?: InputMaybe<Scalars['ID']['input']>;
  defaultValue?: InputMaybe<Scalars['Object']['input']>;
  displayFieldId?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMultiline?: InputMaybe<Scalars['Boolean']['input']>;
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  linkedTableId?: InputMaybe<Scalars['ID']['input']>;
  lookupFieldId?: InputMaybe<Scalars['ID']['input']>;
};

export enum TableFieldType {
  AssociatedField = 'associated_field',
  Checkbox = 'checkbox',
  Currency = 'currency',
  Date = 'date',
  Dropdown = 'dropdown',
  Email = 'email',
  File = 'file',
  Lookup = 'lookup',
  Multiselect = 'multiselect',
  Number = 'number',
  Persons = 'persons',
  Phone = 'phone',
  Text = 'text',
  Url = 'url',
  Users = 'users'
}

export type TableFieldsResponse = {
  __typename?: 'TableFieldsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<TableField>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TableFilterOperator {
  Contains = 'contains',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  IsEmpty = 'is_empty',
  IsNotEmpty = 'is_not_empty',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne',
  NotContains = 'not_contains',
  NotIn = 'not_in'
}

export type TableFolder = {
  __typename?: 'TableFolder';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type TableFolderResponse = {
  __typename?: 'TableFolderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableFolder>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TableImportDuplicateHandling {
  Create = 'CREATE',
  Skip = 'SKIP',
  Update = 'UPDATE'
}

export enum TableImportSkipReason {
  AssociatedDisplayFieldInvalid = 'ASSOCIATED_DISPLAY_FIELD_INVALID',
  AssociatedRecordNotFound = 'ASSOCIATED_RECORD_NOT_FOUND',
  AssociatedRecordWrongTable = 'ASSOCIATED_RECORD_WRONG_TABLE',
  DefaultValueNotSupported = 'DEFAULT_VALUE_NOT_SUPPORTED',
  DuplicateColumnMapping = 'DUPLICATE_COLUMN_MAPPING',
  DuplicateRecord = 'DUPLICATE_RECORD',
  FilePathAndTypeRequired = 'FILE_PATH_AND_TYPE_REQUIRED',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidCheckbox = 'INVALID_CHECKBOX',
  InvalidCurrencyValue = 'INVALID_CURRENCY_VALUE',
  InvalidDate = 'INVALID_DATE',
  InvalidDropdownOption = 'INVALID_DROPDOWN_OPTION',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidFieldMapping = 'INVALID_FIELD_MAPPING',
  InvalidFileValue = 'INVALID_FILE_VALUE',
  InvalidMultiselectOption = 'INVALID_MULTISELECT_OPTION',
  InvalidNumber = 'INVALID_NUMBER',
  InvalidPersonReference = 'INVALID_PERSON_REFERENCE',
  InvalidUrl = 'INVALID_URL',
  InvalidUserReference = 'INVALID_USER_REFERENCE',
  MissingCurrencyCode = 'MISSING_CURRENCY_CODE',
  ReadOnlyField = 'READ_ONLY_FIELD',
  RequiredField = 'REQUIRED_FIELD',
  RowEmpty = 'ROW_EMPTY',
  RowHasExtraValues = 'ROW_HAS_EXTRA_VALUES',
  UniqueConflict = 'UNIQUE_CONFLICT',
  Unknown = 'UNKNOWN',
  UnknownField = 'UNKNOWN_FIELD',
  UnsupportedFieldType = 'UNSUPPORTED_FIELD_TYPE'
}

export type TableListOption = {
  __typename?: 'TableListOption';
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TableListOptionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TableRecord = {
  __typename?: 'TableRecord';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  kanbanOrder?: Maybe<Scalars['Object']['output']>;
  recordNo?: Maybe<Scalars['Int']['output']>;
  tableId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  values?: Maybe<Scalars['Object']['output']>;
};

export type TableRecordActivitiesConnectionResponse = {
  __typename?: 'TableRecordActivitiesConnectionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableRecordActivityConnection>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TableRecordActivity = {
  __typename?: 'TableRecordActivity';
  _id?: Maybe<Scalars['ID']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  logDetails?: Maybe<TableRecordActivityLogDetails>;
  media?: Maybe<Array<Maybe<TableRecordActivityMedia>>>;
  recordId?: Maybe<Scalars['ID']['output']>;
  tableId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TableRecordActivityType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export enum TableRecordActivityAction {
  Create = 'CREATE',
  Update = 'UPDATE'
}

export type TableRecordActivityConnection = {
  __typename?: 'TableRecordActivityConnection';
  docs?: Maybe<Array<Maybe<TableRecordActivity>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type TableRecordActivityFieldSnapshot = {
  __typename?: 'TableRecordActivityFieldSnapshot';
  display?: Maybe<Scalars['Object']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TableFieldType>;
  value?: Maybe<Scalars['Object']['output']>;
};

export type TableRecordActivityLogChange = {
  __typename?: 'TableRecordActivityLogChange';
  current?: Maybe<TableRecordActivityFieldSnapshot>;
  fieldId?: Maybe<Scalars['ID']['output']>;
  previous?: Maybe<TableRecordActivityFieldSnapshot>;
};

export type TableRecordActivityLogDetails = {
  __typename?: 'TableRecordActivityLogDetails';
  action?: Maybe<TableRecordActivityAction>;
  changes?: Maybe<Array<Maybe<TableRecordActivityLogChange>>>;
};

export type TableRecordActivityMedia = {
  __typename?: 'TableRecordActivityMedia';
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TableRecordActivityResponse = {
  __typename?: 'TableRecordActivityResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableRecordActivity>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TableRecordActivityType {
  Comment = 'COMMENT',
  Log = 'LOG'
}

export type TableRecordConnection = {
  __typename?: 'TableRecordConnection';
  docs?: Maybe<Array<Maybe<TableRecord>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type TableRecordFilterInput = {
  fieldKey: Scalars['String']['input'];
  operator: TableFilterOperator;
  value?: InputMaybe<Scalars['Object']['input']>;
};

export type TableRecordPaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type TableRecordResponse = {
  __typename?: 'TableRecordResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableRecord>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TableRecordsConnectionResponse = {
  __typename?: 'TableRecordsConnectionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableRecordConnection>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TableResponse = {
  __typename?: 'TableResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Table>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TableRowHeight {
  Comfortable = 'comfortable',
  Compact = 'compact',
  Medium = 'medium'
}

export type TableView = {
  __typename?: 'TableView';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  groupByFieldId?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  tableId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TableViewType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type TableViewResponse = {
  __typename?: 'TableViewResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TableView>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TableViewType {
  Grid = 'grid',
  Kanban = 'kanban'
}

export type TableViewsResponse = {
  __typename?: 'TableViewsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<TableView>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TablesResponse = {
  __typename?: 'TablesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<Table>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  _id?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TagType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TagResponse = {
  __typename?: 'TagResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Tag;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TagSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum TagType {
  Contact = 'CONTACT',
  Conversation = 'CONVERSATION',
  Task = 'TASK',
  Ticket = 'TICKET'
}

export type TalkListenByAgent = {
  __typename?: 'TalkListenByAgent';
  cPersonId: Scalars['ID']['output'];
  listen: Scalars['Int']['output'];
  talk: Scalars['Int']['output'];
};

export type TalkListenByTime = {
  __typename?: 'TalkListenByTime';
  date: Scalars['String']['output'];
  listen: Scalars['Int']['output'];
  talk: Scalars['Int']['output'];
};

export type TalkListenByTopic = {
  __typename?: 'TalkListenByTopic';
  listen: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  talk: Scalars['Int']['output'];
  topicId: Scalars['ID']['output'];
};

export type TalkListenRatio = {
  __typename?: 'TalkListenRatio';
  customer?: Maybe<Scalars['Float']['output']>;
  customerPerson?: Maybe<Scalars['Float']['output']>;
};

export type Task = {
  __typename?: 'Task';
  _id: Scalars['ID']['output'];
  cPerson?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy: Scalars['ID']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['Date']['output']>;
  media?: Maybe<Array<TaskMedia>>;
  priority: TaskPriority;
  remindeAt?: Maybe<Scalars['Date']['output']>;
  repeat?: Maybe<Repeat>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType: TaskSourceType;
  status: TaskStatus;
  tag?: Maybe<Array<Tag>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TaskActionOperation {
  CreateTask = 'create_task',
  GetTask = 'get_task',
  UpdateTask = 'update_task'
}

export enum TaskActionSearchBy {
  ConversationPerson = 'conversation_person',
  TaskId = 'task_id'
}

export type TaskComment = {
  __typename?: 'TaskComment';
  _id: Scalars['ID']['output'];
  cPerson: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  mentions?: Maybe<Array<Scalars['ID']['output']>>;
  task: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TaskCommentChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type TaskCommentChanged = {
  __typename?: 'TaskCommentChanged';
  /** For DELETED this is the comment as it was before deletion. */
  comment?: Maybe<TaskComment>;
  commentId: Scalars['ID']['output'];
  taskId: Scalars['ID']['output'];
  type: TaskCommentChangeType;
};

export type TaskCommentChangedResponse = {
  __typename?: 'TaskCommentChangedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TaskCommentChanged>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskCommentResponse = {
  __typename?: 'TaskCommentResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TaskComment>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskCommentsResponse = {
  __typename?: 'TaskCommentsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<TaskComment>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskFields = {
  __typename?: 'TaskFields';
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TaskFilterInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<TaskSortEnum>;
  status?: InputMaybe<TaskStatusFilterEnum>;
};

export type TaskLog = {
  __typename?: 'TaskLog';
  _id?: Maybe<Scalars['ID']['output']>;
  cPerson?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<Task>;
  type?: Maybe<TaskLogType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TaskLogResponse = {
  __typename?: 'TaskLogResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TaskLog;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskLogSubscriptionInput = {
  customerId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum TaskLogType {
  TaskAssigneeUpdated = 'TASK_ASSIGNEE_UPDATED',
  TaskCreated = 'TASK_CREATED',
  TaskDescriptionUpdated = 'TASK_DESCRIPTION_UPDATED',
  TaskDuedateUpdated = 'TASK_DUEDATE_UPDATED',
  TaskPriorityUpdated = 'TASK_PRIORITY_UPDATED',
  TaskStatusUpdated = 'TASK_STATUS_UPDATED',
  TaskTagUpdated = 'TASK_TAG_UPDATED',
  TaskTitleUpdated = 'TASK_TITLE_UPDATED'
}

export type TaskMedia = {
  __typename?: 'TaskMedia';
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum TaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export type TaskResponse = {
  __typename?: 'TaskResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Task;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TaskSortEnum {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  Priority = 'PRIORITY'
}

export enum TaskSourceType {
  Contact = 'CONTACT',
  Conversation = 'CONVERSATION',
  Manual = 'MANUAL',
  Message = 'MESSAGE'
}

export enum TaskStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export enum TaskStatusFilterEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DueToday = 'DUE_TODAY',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Overdue = 'OVERDUE'
}

export type TaskSubscriptionInput = {
  customerId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type TasksResponse = {
  __typename?: 'TasksResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Task>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamChatEvent = {
  __typename?: 'TeamChatEvent';
  kind: TeamChatEventKind;
  teamConversation: TeamConversation;
};

export enum TeamChatEventKind {
  Archived = 'ARCHIVED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  LastMessageRefreshed = 'LAST_MESSAGE_REFRESHED',
  ParticipantsChanged = 'PARTICIPANTS_CHANGED',
  Unarchived = 'UNARCHIVED',
  Updated = 'UPDATED'
}

export type TeamChatEventResponse = {
  __typename?: 'TeamChatEventResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamChatEvent>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamChatGenericResponse = {
  __typename?: 'TeamChatGenericResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamChatLastMessage = {
  __typename?: 'TeamChatLastMessage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  hasMedia?: Maybe<Scalars['Boolean']['output']>;
  messageId: Scalars['ID']['output'];
  senderId?: Maybe<Scalars['ID']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  type: TeamMessageType;
};

export enum TeamChatMediaType {
  File = 'FILE',
  Image = 'IMAGE'
}

export type TeamChatParticipant = {
  __typename?: 'TeamChatParticipant';
  isMuted: Scalars['Boolean']['output'];
  joinedAt: Scalars['Date']['output'];
  lastReadAt?: Maybe<Scalars['Date']['output']>;
  lastReadMessageId?: Maybe<Scalars['ID']['output']>;
  role: TeamChatParticipantRole;
  unreadMessageCount: Scalars['Int']['output'];
  user: Scalars['ID']['output'];
};

export enum TeamChatParticipantRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type TeamChatPermissions = {
  __typename?: 'TeamChatPermissions';
  membersCanEditDeleteOwn: Scalars['Boolean']['output'];
  membersCanSendMessage: Scalars['Boolean']['output'];
};

export type TeamChatPermissionsInput = {
  membersCanEditDeleteOwn?: InputMaybe<Scalars['Boolean']['input']>;
  membersCanSendMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TeamChatState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type TeamChatSubscriptionInput = {
  token: Scalars['String']['input'];
};

export enum TeamChatType {
  Group = 'GROUP',
  Private = 'PRIVATE',
  WhatsappWebGroup = 'WHATSAPP_WEB_GROUP'
}

export type TeamChatUnreadEvent = {
  __typename?: 'TeamChatUnreadEvent';
  teamConversationId: Scalars['ID']['output'];
  unreadMessageCount: Scalars['Int']['output'];
};

export type TeamChatUnreadEventResponse = {
  __typename?: 'TeamChatUnreadEventResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamChatUnreadEvent>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamChatWhatsappMeta = {
  __typename?: 'TeamChatWhatsappMeta';
  announce?: Maybe<Scalars['Boolean']['output']>;
  canSend: Scalars['Boolean']['output'];
  groupJid: Scalars['String']['output'];
  phoneChannelId: Scalars['String']['output'];
  phoneIsMember?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type TeamChatsPage = {
  __typename?: 'TeamChatsPage';
  docs: Array<TeamConversation>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type TeamChatsResponse = {
  __typename?: 'TeamChatsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamChatsPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamConvMember = {
  __typename?: 'TeamConvMember';
  _id: Scalars['ID']['output'];
  cPerson?: Maybe<Scalars['ID']['output']>;
  joinedAt?: Maybe<Scalars['Date']['output']>;
  leftAt?: Maybe<Scalars['Date']['output']>;
  role?: Maybe<TeamChatParticipantRole>;
  source: TeamConvMemberSource;
  status: TeamConvMemberStatus;
  whatsappData?: Maybe<TeamConvMemberWhatsappData>;
};

export enum TeamConvMemberSource {
  Qpien = 'QPIEN',
  WhatsappWeb = 'WHATSAPP_WEB'
}

export enum TeamConvMemberStatus {
  Active = 'ACTIVE',
  Left = 'LEFT'
}

export type TeamConvMemberWhatsappData = {
  __typename?: 'TeamConvMemberWhatsappData';
  displayName?: Maybe<Scalars['String']['output']>;
  jid?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  waIsAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamConvMembersPage = {
  __typename?: 'TeamConvMembersPage';
  docs: Array<TeamConvMember>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page?: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type TeamConvMembersResponse = {
  __typename?: 'TeamConvMembersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamConvMembersPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamConversation = {
  __typename?: 'TeamConversation';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Date']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  customer: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  lastMessage?: Maybe<TeamChatLastMessage>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  mutedBy?: Maybe<Array<Scalars['ID']['output']>>;
  participants?: Maybe<Array<TeamChatParticipant>>;
  permissions: TeamChatPermissions;
  title?: Maybe<Scalars['String']['output']>;
  type: TeamChatType;
  updatedAt: Scalars['Date']['output'];
  whatsapp?: Maybe<TeamChatWhatsappMeta>;
};

export type TeamConversationResponse = {
  __typename?: 'TeamConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamConversation>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamMessage = {
  __typename?: 'TeamMessage';
  _id: Scalars['ID']['output'];
  autoCreate?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  editedAt?: Maybe<Scalars['Date']['output']>;
  logMeta?: Maybe<Scalars['Object']['output']>;
  logType?: Maybe<TeamMessageLogType>;
  media?: Maybe<Array<TeamMessageMedia>>;
  member?: Maybe<TeamConvMember>;
  mentions?: Maybe<Array<Scalars['ID']['output']>>;
  reactions?: Maybe<Array<TeamMessageReaction>>;
  replyTo?: Maybe<TeamMessageReplyTo>;
  teamConversation: Scalars['ID']['output'];
  type: TeamMessageType;
  updatedAt: Scalars['Date']['output'];
  waMentions?: Maybe<Array<TeamMessageMention>>;
  waMessageId?: Maybe<Scalars['String']['output']>;
};

export type TeamMessageEvent = {
  __typename?: 'TeamMessageEvent';
  kind: TeamMessageEventKind;
  message: TeamMessage;
  teamConversationId: Scalars['ID']['output'];
};

export enum TeamMessageEventKind {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Edited = 'EDITED',
  ReactionChanged = 'REACTION_CHANGED'
}

export type TeamMessageEventResponse = {
  __typename?: 'TeamMessageEventResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamMessageEvent>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TeamMessageLogType {
  Archived = 'ARCHIVED',
  AvatarChanged = 'AVATAR_CHANGED',
  Call = 'CALL',
  DescriptionChanged = 'DESCRIPTION_CHANGED',
  GroupCreated = 'GROUP_CREATED',
  MemberAdded = 'MEMBER_ADDED',
  MemberLeft = 'MEMBER_LEFT',
  MemberRemoved = 'MEMBER_REMOVED',
  PermissionsChanged = 'PERMISSIONS_CHANGED',
  Renamed = 'RENAMED',
  RoleChanged = 'ROLE_CHANGED',
  Unarchived = 'UNARCHIVED'
}

export type TeamMessageMedia = {
  __typename?: 'TeamMessageMedia';
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type: TeamChatMediaType;
  url: Scalars['String']['output'];
};

export type TeamMessageMention = {
  __typename?: 'TeamMessageMention';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TeamMessageReaction = {
  __typename?: 'TeamMessageReaction';
  emoji: Scalars['String']['output'];
  user: Scalars['ID']['output'];
};

export type TeamMessageReplyTo = {
  __typename?: 'TeamMessageReplyTo';
  _id: Scalars['ID']['output'];
  autoCreate?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  media?: Maybe<Array<TeamMessageMedia>>;
  member?: Maybe<TeamConvMember>;
  teamConversation: Scalars['ID']['output'];
  type: TeamMessageType;
  updatedAt: Scalars['Date']['output'];
  waMessageId?: Maybe<Scalars['String']['output']>;
};

export type TeamMessageResponse = {
  __typename?: 'TeamMessageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamMessage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TeamMessageType {
  Log = 'LOG',
  Text = 'TEXT'
}

export type TeamMessagesPage = {
  __typename?: 'TeamMessagesPage';
  docs: Array<TeamMessage>;
  hasNextPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type TeamMessagesResponse = {
  __typename?: 'TeamMessagesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TeamMessagesPage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamOpenConversationCount = {
  __typename?: 'TeamOpenConversationCount';
  cPerson: Scalars['ID']['output'];
  count: Scalars['Int']['output'];
};

export type TeamOpenConversationCountsResponse = {
  __typename?: 'TeamOpenConversationCountsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<TeamOpenConversationCount>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Teams = {
  __typename?: 'Teams';
  _id?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customerPersons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  drivers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emoji?: Maybe<Scalars['String']['output']>;
  isMain?: Maybe<Scalars['Boolean']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
};

export type TeamsAndCPersonsType = {
  __typename?: 'TeamsAndCPersonsType';
  cPersons?: Maybe<Array<Maybe<CustomerPerson>>>;
  teams?: Maybe<Array<Maybe<Teams>>>;
};

export type TeamsInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['String']['input'];
  customerPersons: Array<InputMaybe<Scalars['String']['input']>>;
  drivers: Array<InputMaybe<Scalars['String']['input']>>;
  emoji: Scalars['String']['input'];
  teamName: Scalars['String']['input'];
};

export type TeamsPaginateResult = {
  __typename?: 'TeamsPaginateResult';
  docs?: Maybe<Array<Maybe<Teams>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type TeamsQuery = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  driver?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  /** Column sort; fields: name (teamName), createdAt. */
  sort?: InputMaybe<ListSortInput>;
};

export type TeamsResponse = {
  __typename?: 'TeamsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TeamsPaginateResult;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TelegramAccount = {
  __typename?: 'TelegramAccount';
  _id?: Maybe<Scalars['ID']['output']>;
  apiToken?: Maybe<Scalars['String']['output']>;
  botId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  firstName?: Maybe<Scalars['String']['output']>;
  receiveChannelMessages?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type TemplateBlock = {
  __typename?: 'TemplateBlock';
  _id: Scalars['ID']['output'];
  category: FlowNodeType;
  fields: Array<Maybe<BlockFieldType>>;
  title: Scalars['String']['output'];
  type: FlowBlockType;
};

export type TemplateButtonUrlVariable = {
  __typename?: 'TemplateButtonUrlVariable';
  ref: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TemplateButtonUrlVariableInput = {
  ref: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TemplateCardInput = {
  template?: InputMaybe<TemplateCardTemplateId>;
};

export type TemplateCardTemplateId = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateDiscountStyle {
  Corner = 'CORNER',
  Label = 'LABEL'
}

export enum TemplateFooter {
  Footer0 = 'Footer0',
  Footer1 = 'Footer1',
  Footer2 = 'Footer2',
  Footer3 = 'Footer3',
  Footer4 = 'Footer4',
  Footer5 = 'Footer5',
  Footer6 = 'Footer6',
  Footer7 = 'Footer7',
  Footer8 = 'Footer8'
}

export enum TemplateFooterFontWeight {
  Bold = 'BOLD',
  Normal = 'NORMAL'
}

export enum TemplateHeader {
  Header0 = 'Header0',
  Header1 = 'Header1',
  Header2 = 'Header2'
}

export type TemplateIdInput = {
  id: Scalars['ID']['input'];
};

export enum TemplateLayout {
  Collage1 = 'Collage1',
  Collage2 = 'Collage2',
  Collage3 = 'Collage3',
  Collage4 = 'Collage4',
  Collage5 = 'Collage5'
}

export type TemplateNode = {
  __typename?: 'TemplateNode';
  _id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TemplateResponse = {
  __typename?: 'TemplateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: WhatsAppBusinessTemplate;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TestAiAnalysisData = {
  __typename?: 'TestAiAnalysisData';
  channelLabel: Scalars['String']['output'];
  model: Scalars['String']['output'];
  promptName: Scalars['String']['output'];
  reasoning?: Maybe<Scalars['String']['output']>;
  sentiment: IAiAnalysisSentiment;
  summary: Scalars['String']['output'];
  topics: Array<IAiAnalysisTopic>;
};

export type TestAiAnalysisInput = {
  analyseOn: PreviewAiAnalysisAnalysedOn;
  conversationId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type TestAiAnalysisResponse = {
  __typename?: 'TestAiAnalysisResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TestAiAnalysisData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TestAiWithConversationInput = {
  /**
   * When false, actions and commerce tools are NOT executed: the test runs without touching
   * real customer or integration data. Defaults to false — a test must be safe unless the
   * tester deliberately opts in.
   */
  actionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiPersonMemoryId?: InputMaybe<Scalars['ID']['input']>;
  aiProfileId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The approve button the tester tapped on an earlier answer; the query is its title, as a live
   * channel reports a tap.
   */
  approvalButtonId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  commentData?: InputMaybe<CommentDataInput>;
  content?: InputMaybe<Array<InputMaybe<PreviousMessagesType>>>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  dbDriverId?: InputMaybe<Scalars['ID']['input']>;
  /** Email channel only — the subject line the AI should see. */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /**
   * Email is used both as chat and as ticket while messageType stays EMAIL, so the turn has to
   * say which settings block it belongs to — exactly what message.isTicket does on a real inbound.
   */
  isTicket?: InputMaybe<Scalars['Boolean']['input']>;
  /** Images and files attached to this test message, same as a real conversation. */
  medias?: InputMaybe<Array<AiTestMediaInput>>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  /** An existing contact to test against. Omit for a brand-new customer with no history. */
  personId?: InputMaybe<Scalars['ID']['input']>;
  platformType?: InputMaybe<PlatformType>;
  /**
   * Marketplace only: earlier questions of this test, read as the buyer's history. Empty or
   * absent tests the question on its own.
   */
  previousQuestions?: InputMaybe<Array<AiTestPreviousQuestionInput>>;
  query: Scalars['String']['input'];
  questionData?: InputMaybe<QuestionDataInput>;
  /** Which AI role to test. Defaults to the customer's last-used role. */
  role?: InputMaybe<AiRoleEnum>;
  stepTestMsgType?: InputMaybe<MessageType>;
};

export type TestAiWithConversationResponse = {
  __typename?: 'TestAiWithConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: AiAnswerData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TestWebhookInput = {
  customerId: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
};

export type TestWebhookResponse = {
  __typename?: 'TestWebhookResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketCustomFieldInput = {
  customFieldId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type TicketCustomFieldOutput = {
  __typename?: 'TicketCustomFieldOutput';
  customFieldId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TicketDefaultResponse = {
  __typename?: 'TicketDefaultResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum TicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL',
  Urgent = 'URGENT'
}

export type TicketSettings = {
  __typename?: 'TicketSettings';
  aiAgentWorkingHours?: Maybe<AiWorkingHoursEnum>;
  aiAutoClose?: Maybe<AiAutoClose>;
  aiFollowUp?: Maybe<AiFollowUp>;
  aiReplyButtons?: Maybe<AiReplyNonChatButtons>;
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketSettingsInput = {
  aiAgentWorkingHours?: InputMaybe<AiWorkingHoursEnum>;
  aiAutoClose?: InputMaybe<AiAutoCloseInput>;
  aiFollowUp?: InputMaybe<AiFollowUpInput>;
  aiReplyButtons?: InputMaybe<AiReplyNonChatButtonsInput>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TicketState = {
  __typename?: 'TicketState';
  _id: Scalars['ID']['output'];
  category: TicketStateCategoryType;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nameVisibleToCustomers?: Maybe<Scalars['String']['output']>;
  status: TicketStatusType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TicketStateCategoryType {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export type TicketStateListResponse = {
  __typename?: 'TicketStateListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<TicketState>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TicketStateResponse = {
  __typename?: 'TicketStateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TicketState>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum TicketStatusType {
  Active = 'ACTIVE',
  Archive = 'ARCHIVE'
}

export type TicketType = {
  __typename?: 'TicketType';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customFields?: Maybe<Array<Scalars['ID']['output']>>;
  customer: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nameVisibleToCustomers?: Maybe<Scalars['String']['output']>;
  shareStagesWithCustomer?: Maybe<Scalars['Boolean']['output']>;
  states?: Maybe<Array<Scalars['ID']['output']>>;
  status: TicketStatusType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  usage?: Maybe<TicketTypeUsage>;
};

export type TicketTypeListResponse = {
  __typename?: 'TicketTypeListResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<TicketType>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TicketTypePopulated = {
  __typename?: 'TicketTypePopulated';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customFields?: Maybe<Array<Maybe<CustomField>>>;
  customer: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameVisibleToCustomers?: Maybe<Scalars['String']['output']>;
  shareStagesWithCustomer?: Maybe<Scalars['Boolean']['output']>;
  states?: Maybe<Array<Maybe<TicketState>>>;
  status: TicketStatusType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  usage?: Maybe<TicketTypeUsage>;
};

export type TicketTypePopulatedResponse = {
  __typename?: 'TicketTypePopulatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TicketTypePopulated>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TicketTypeResponse = {
  __typename?: 'TicketTypeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TicketType>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum TicketTypeUsage {
  BackOffice = 'BACK_OFFICE',
  Customer = 'CUSTOMER'
}

export type TiktokAccount = {
  __typename?: 'TiktokAccount';
  _id?: Maybe<Scalars['ID']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  tiktokId?: Maybe<Scalars['String']['output']>;
};

export type TiktokPage = {
  __typename?: 'TiktokPage';
  _id?: Maybe<Scalars['ID']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  failedMessage?: Maybe<Scalars['Boolean']['output']>;
  isCommentEnable?: Maybe<Scalars['Boolean']['output']>;
  isMessageEnable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  tiktokAccount?: Maybe<TiktokAccount>;
};

export type TimeBasedAudienceCountResponse = {
  __typename?: 'TimeBasedAudienceCountResponse';
  cap: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  exceedsCap: Scalars['Boolean']['output'];
  mode: FlowTimeTargetMode;
};

export type TimezoneInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  gmtOffset?: InputMaybe<Scalars['Number']['input']>;
  gmtOffsetName?: InputMaybe<Scalars['String']['input']>;
  tzName?: InputMaybe<Scalars['String']['input']>;
  zoneName?: InputMaybe<Scalars['String']['input']>;
};

export type Token = {
  __typename?: 'Token';
  token: PasswordResetResponse;
};

export type TopAgent = {
  __typename?: 'TopAgent';
  _id: Scalars['ID']['output'];
  percent: Scalars['Float']['output'];
};

export type TopTopic = {
  __typename?: 'TopTopic';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
};

export type Topic = {
  __typename?: 'Topic';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TopicComparisonCustomFieldsStatistics = {
  __typename?: 'TopicComparisonCustomFieldsStatistics';
  columnTotals: Scalars['Object']['output'];
  columns: Array<Scalars['String']['output']>;
  grandTotal: Scalars['Number']['output'];
  matrix: Scalars['Object']['output'];
  rowTotals: Scalars['Object']['output'];
  rows: Array<Scalars['String']['output']>;
};

export type TopicComparisonStatistics = {
  __typename?: 'TopicComparisonStatistics';
  columnTotals: Scalars['Object']['output'];
  columns: Array<ComparisonData>;
  grandTotal: Scalars['Number']['output'];
  matrix: Scalars['Object']['output'];
  rowTotals: Scalars['Object']['output'];
  rows: Array<ComparisonData>;
};

export type TopicComparisonStatisticsResponse = {
  __typename?: 'TopicComparisonStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TopicComparisonStatistics;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TopicCustomFieldsComparisonStatisticsResponse = {
  __typename?: 'TopicCustomFieldsComparisonStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TopicComparisonCustomFieldsStatistics;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TopicCustomFieldsStatistics = {
  __typename?: 'TopicCustomFieldsStatistics';
  count?: Maybe<Scalars['Number']['output']>;
  customField?: Maybe<CustomField>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TopicCustomFieldsStatisticsResponse = {
  __typename?: 'TopicCustomFieldsStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<TopicCustomFieldsStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TopicResponse = {
  __typename?: 'TopicResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Topic>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TopicStatistics = {
  __typename?: 'TopicStatistics';
  count?: Maybe<Scalars['Number']['output']>;
  topic?: Maybe<Topic>;
};

export type TopicStatisticsResponse = {
  __typename?: 'TopicStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<TopicStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TopicsResponse = {
  __typename?: 'TopicsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<Topic>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TotalCalls = {
  __typename?: 'TotalCalls';
  inbound: Scalars['Int']['output'];
  outbound: Scalars['Int']['output'];
};

export type TrackingDomain = {
  __typename?: 'TrackingDomain';
  _id: Scalars['ID']['output'];
  baseUrl: Scalars['String']['output'];
  cnameRecord: TrackingDomainDnsRecord;
  createdAt?: Maybe<Scalars['Date']['output']>;
  hostname: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastCheckedAt?: Maybe<Scalars['Date']['output']>;
  ownershipRecord?: Maybe<TrackingDomainDnsRecord>;
  status: TrackingDomainStatus;
  verificationErrors: Array<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackingDomainDnsRecord = {
  __typename?: 'TrackingDomainDnsRecord';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TrackingDomainEvent = {
  __typename?: 'TrackingDomainEvent';
  _id?: Maybe<Scalars['ID']['output']>;
  customer: Scalars['ID']['output'];
  hostname?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TrackingDomainIdInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type TrackingDomainResponse = {
  __typename?: 'TrackingDomainResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TrackingDomain>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TrackingDomainSettings = {
  __typename?: 'TrackingDomainSettings';
  activeBaseUrl: Scalars['String']['output'];
  activeHostname?: Maybe<Scalars['String']['output']>;
  cnameTarget?: Maybe<Scalars['String']['output']>;
  customDomainsEnabled: Scalars['Boolean']['output'];
  defaultHostname?: Maybe<Scalars['String']['output']>;
  linksDisabled: Scalars['Boolean']['output'];
  maxDomains: Scalars['Int']['output'];
  mode: TrackingLinkMode;
};

export type TrackingDomainSettingsResponse = {
  __typename?: 'TrackingDomainSettingsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TrackingDomainSettings>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TrackingDomainStatus {
  Active = 'ACTIVE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Removed = 'REMOVED'
}

export type TrackingDomainUsage = {
  __typename?: 'TrackingDomainUsage';
  activeCampaigns: Array<TrackingDomainUsageCampaign>;
  templates: Scalars['Int']['output'];
};

export type TrackingDomainUsageCampaign = {
  __typename?: 'TrackingDomainUsageCampaign';
  _id: Scalars['ID']['output'];
  status: CampaignStatusEnum;
  title?: Maybe<Scalars['String']['output']>;
};

export type TrackingDomainUsageResponse = {
  __typename?: 'TrackingDomainUsageResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TrackingDomainUsage>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TrackingDomainsResponse = {
  __typename?: 'TrackingDomainsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<TrackingDomain>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TrackingLinkMode {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type TrackingLinksStatus = {
  __typename?: 'TrackingLinksStatus';
  disabled: Scalars['Boolean']['output'];
  disabledAt?: Maybe<Scalars['Date']['output']>;
  disabledBy?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Transcript = {
  __typename?: 'Transcript';
  _id?: Maybe<Scalars['ID']['output']>;
  channelType?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TranscriptDetail = {
  __typename?: 'TranscriptDetail';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  end?: Maybe<Scalars['Float']['output']>;
  speaker?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  transcriptId?: Maybe<Scalars['ID']['output']>;
};

export type TranscriptDetailsData = {
  __typename?: 'TranscriptDetailsData';
  details?: Maybe<Array<Maybe<TranscriptDetail>>>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type TranscriptDetailsResponse = {
  __typename?: 'TranscriptDetailsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TranscriptDetailsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TranscriptPaginatedData = {
  __typename?: 'TranscriptPaginatedData';
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  transcripts?: Maybe<Array<Maybe<Transcript>>>;
};

export type TranscriptPaginatedResponse = {
  __typename?: 'TranscriptPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TranscriptPaginatedData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TransferConversationInput = {
  convWithPerson?: InputMaybe<Array<InputMaybe<ConvsUpdateInput>>>;
  customerId: Scalars['ID']['input'];
  from: Scalars['ID']['input'];
  isAllSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional handover note; saved as an internal note in each transferred conversation (max 5000 chars). */
  note?: InputMaybe<Scalars['String']['input']>;
  selectedFilter?: InputMaybe<GetConversationsInput>;
  to: Scalars['ID']['input'];
};

/** Assign to a team: the server picks one available member per conversation (the flow's AssignToTeam rule). */
export type TransferConversationsToTeamInput = {
  convWithPerson: Array<InputMaybe<ConvsUpdateInput>>;
  customerId: Scalars['ID']['input'];
  from: Scalars['ID']['input'];
  /** Optional handover note, as in TransferConversationInput. */
  note?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

export type TranslateChangelogInput = {
  content: Scalars['String']['input'];
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  targetLanguages: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type TranslateInboxMessageInput = {
  _id: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type TranslateInboxMessages = {
  __typename?: 'TranslateInboxMessages';
  messages: Array<TranslatedInboxMessage>;
  targetLanguage: Scalars['String']['output'];
};

export type TranslateInboxMessagesInput = {
  customerId: Scalars['ID']['input'];
  messages: Array<TranslateInboxMessageInput>;
  targetLanguage: Scalars['String']['input'];
};

export type TranslateInboxMessagesResponse = {
  __typename?: 'TranslateInboxMessagesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<TranslateInboxMessages>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TranslatedInboxMessage = {
  __typename?: 'TranslatedInboxMessage';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  sourceLanguage?: Maybe<Scalars['String']['output']>;
  translated: Scalars['Boolean']['output'];
};

export type Translations = {
  __typename?: 'Translations';
  cn?: Maybe<Scalars['String']['output']>;
  de?: Maybe<Scalars['String']['output']>;
  fa?: Maybe<Scalars['String']['output']>;
  hr?: Maybe<Scalars['String']['output']>;
  it?: Maybe<Scalars['String']['output']>;
  ja?: Maybe<Scalars['String']['output']>;
  kr?: Maybe<Scalars['String']['output']>;
  nl?: Maybe<Scalars['String']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
  pt_BR?: Maybe<Scalars['String']['output']>;
  tr?: Maybe<Scalars['String']['output']>;
};

export type TranslationsInput = {
  cn?: InputMaybe<Scalars['String']['input']>;
  de?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fa?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  hr?: InputMaybe<Scalars['String']['input']>;
  it?: InputMaybe<Scalars['String']['input']>;
  ja?: InputMaybe<Scalars['String']['input']>;
  kr?: InputMaybe<Scalars['String']['input']>;
  nl?: InputMaybe<Scalars['String']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
  pt_BR?: InputMaybe<Scalars['String']['input']>;
  tr?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerFields = {
  __typename?: 'TriggerFields';
  adIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelType?: Maybe<Scalars['String']['output']>;
  keepRunningUntilComplete?: Maybe<Scalars['Boolean']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  onlyFromAds?: Maybe<Scalars['Boolean']['output']>;
  platformIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rule?: Maybe<FlowBlockFieldRules>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  target?: Maybe<Scalars['ID']['output']>;
  targetMode?: Maybe<FlowTimeTargetMode>;
  timeBySecond?: Maybe<Scalars['Number']['output']>;
  timeSchedule?: Maybe<FlowTimeSchedule>;
  type?: Maybe<FlowBlockFieldTypes>;
};

export type TriggerReusableFlowInput = {
  conversationId: Scalars['ID']['input'];
  customer: Scalars['String']['input'];
  flowBotId: Scalars['ID']['input'];
};

export type TriggerReusableFlowResponse = {
  __typename?: 'TriggerReusableFlowResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TwSubAccount = {
  __typename?: 'TwSubAccount';
  apiKeySecret?: Maybe<Scalars['String']['output']>;
  apiKeySid?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type TwoFactorAuthenticationResponse = {
  __typename?: 'TwoFactorAuthenticationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TypedConversationDetailsItemInput = {
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  name: ConversationDetailsName;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type TypedConversationItemInput = {
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  name: ConversationName;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type TypedHomeDashboardStatItemInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name: HomeDashboardStatName;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type TypedHomeWidgetItemInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name: HomeWidgetName;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type TypedViewFoldersItemInput = {
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  name: ViewFoldersName;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type TypingStatusUpdatedInput = {
  conversationId: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
};

export type TypingStatusUpdatedSubscriptionResponse = {
  __typename?: 'TypingStatusUpdatedSubscriptionResponse';
  conversationId: Scalars['ID']['output'];
  customer: Scalars['ID']['output'];
  isTyping: Scalars['Boolean']['output'];
  typingUserId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type UnArchiveTopicInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type UnSnoozeConversationInput = {
  cPerson: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type UnarchiveCustomerPersonInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type UpdateActionInput = {
  _id: Scalars['ID']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collectInfo?: InputMaybe<Array<InputMaybe<ActionCustomField>>>;
  customFieldInfo?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Array<InputMaybe<ActionFormData>>>;
  formDataUrlEncoded?: InputMaybe<Array<InputMaybe<ActionFormData>>>;
  headers?: InputMaybe<Array<InputMaybe<ActionHeader>>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<ActionMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformAction?: InputMaybe<PlatformActionMethod>;
  requiresConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  responseMapping?: InputMaybe<Array<InputMaybe<ActionResponseMapping>>>;
  type?: InputMaybe<ActionTypeEnum>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddOnInput = {
  _id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAiGuidanceInput = {
  _id: Scalars['ID']['input'];
  category?: InputMaybe<AiGuidanceCategoryEnum>;
  channel?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  messageTypes?: InputMaybe<Array<InputMaybe<AiGuidanceMessageTypeEnum>>>;
  /** AI roles this guidance applies to. Empty means every role. */
  roles?: InputMaybe<Array<AiRoleEnum>>;
  status?: InputMaybe<AiGuidanceStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  toneOfVoice?: InputMaybe<AiProfileToneOfVoiceEnum>;
};

export type UpdateAiKnowledgeSourceChannelsInput = {
  _id: Scalars['ID']['input'];
  /** Empty means every channel. */
  channels: Array<Scalars['ID']['input']>;
  customer: Scalars['ID']['input'];
};

export type UpdateAiProfileInput = {
  _id: Scalars['ID']['input'];
  /** Deprecated: image understanding is always on and this field is ignored. */
  aiImageRecognition?: InputMaybe<Scalars['Boolean']['input']>;
  aiReplyButtons?: InputMaybe<AiReplyButtonsInput>;
  answerLength?: InputMaybe<AiAnswerLengthEnum>;
  avatar?: InputMaybe<Scalars['FileUpload']['input']>;
  chatSettings?: InputMaybe<ChatSettingsInput>;
  commentSettings?: InputMaybe<CommentSettingsInput>;
  customer: Scalars['ID']['input'];
  /** Service and E-commerce: non-ticket e-mail, configured apart from chat. */
  emailSettings?: InputMaybe<EmailSettingsInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  learnFromHumanReplies?: InputMaybe<Scalars['Boolean']['input']>;
  marketPlaceSettings?: InputMaybe<MarketPlaceSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<Scalars['String']['input']>;
  ticketSettings?: InputMaybe<TicketSettingsInput>;
  toneOfVoice?: InputMaybe<AiProfileToneOfVoiceEnum>;
  useEmoji?: InputMaybe<Scalars['Boolean']['input']>;
  useMacrosAsKnowledgeSource?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAiStoreProductInfoInput = {
  customAiInfo?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type UpdateAuthenticationInput = {
  _id: Scalars['ID']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Array<InputMaybe<AuthenticationFormData>>>;
  formDataUrlEncoded?: InputMaybe<Array<InputMaybe<AuthenticationFormData>>>;
  headers?: InputMaybe<Array<InputMaybe<AuthenticationHeader>>>;
  method?: InputMaybe<AuthenticationMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  oauthConsumerKey?: InputMaybe<Scalars['String']['input']>;
  oauthConsumerSecret?: InputMaybe<Scalars['String']['input']>;
  oauthRealm?: InputMaybe<Scalars['String']['input']>;
  oauthSignatureMethod?: InputMaybe<Scalars['String']['input']>;
  oauthToken?: InputMaybe<Scalars['String']['input']>;
  oauthTokenSecret?: InputMaybe<Scalars['String']['input']>;
  oauthVersion?: InputMaybe<Scalars['String']['input']>;
  refreshTokenTime?: InputMaybe<Scalars['Int']['input']>;
  responseMapping?: InputMaybe<Array<InputMaybe<AuthenticationResponseMapping>>>;
  tokenKey?: InputMaybe<Scalars['String']['input']>;
  tokenPrefix?: InputMaybe<Scalars['String']['input']>;
  tokenValue?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthenticationType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockFieldInput = {
  _id: Scalars['ID']['input'];
  fieldIndex: Scalars['Int']['input'];
  fieldName: Scalars['String']['input'];
  fieldValue?: InputMaybe<Scalars['Object']['input']>;
};

export type UpdateBlockInput = {
  _id: Scalars['ID']['input'];
  channelType?: InputMaybe<FlowMessageChannel>;
  customerId: Scalars['ID']['input'];
  fields?: InputMaybe<Array<InputMaybe<BlockFieldInput>>>;
  fieldsIndex?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Scalars['FileUpload']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockResponse = {
  __typename?: 'UpdateBlockResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: FlowBlock;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBusinessHoursScheduleInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  days?: InputMaybe<Array<WorkingHourInput>>;
  holidays?: InputMaybe<Array<BusinessHoursHolidayInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCOnboardingInfoInput = {
  aiInterest?: InputMaybe<OnboardingAiInterest>;
  channels?: InputMaybe<Array<OnboardingChannel>>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  favouriteProducts?: InputMaybe<Scalars['String']['input']>;
  howBuiltWebsite?: InputMaybe<Scalars['String']['input']>;
  howYouHearAboutUs?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  monthlyVolume?: InputMaybe<OnboardingMonthlyVolume>;
  ownerRole?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<OnboardingPlatform>;
  platformOther?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<OnboardingSector>;
  sectorOther?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OnboardingSource>;
  sourceOther?: InputMaybe<Scalars['String']['input']>;
  teamSize?: InputMaybe<OnboardingTeamSize>;
};

export type UpdateCPersonRoleInput = {
  _id: Scalars['String']['input'];
  cPersons?: InputMaybe<Array<Scalars['ID']['input']>>;
  customer: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<RolePermission>>>;
};

export type UpdateCProductChargeInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  reChargeSettings?: InputMaybe<NeedChargeLimitInput>;
};

export type UpdateCampaignInput = {
  abTest?: InputMaybe<CampaignAbTestInput>;
  attribution?: InputMaybe<CampaignAttributionInput>;
  campaignId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  dynamicGroupRecipients?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['Media']['input']>>>;
  platformInfo?: InputMaybe<CampaignPlatformInfoInput>;
  scheduleDate?: InputMaybe<Scalars['Date']['input']>;
  sendingPlan?: InputMaybe<CampaignSendingPlanInput>;
  smartSending?: InputMaybe<CampaignSmartSendingInput>;
  status?: InputMaybe<StatusCampaignEnum>;
  survey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  variations?: InputMaybe<Array<CampaignVariationInput>>;
};

export type UpdateChangelogCategoryInput = {
  _id: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['Object']['input']>;
};

export type UpdateChangelogInput = {
  _id: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  channels?: InputMaybe<Array<ChangelogChannel>>;
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Scalars['Object']['input']>;
};

export type UpdateChangelogSettingsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultTimezone?: InputMaybe<Scalars['String']['input']>;
  includeArchivedPersons?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactiveCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  recipientAudience?: InputMaybe<Scalars['String']['input']>;
  senderCustomerId?: InputMaybe<Scalars['String']['input']>;
  senderEmail?: InputMaybe<ChangelogSenderEmailInput>;
  senderWhatsapp?: InputMaybe<ChangelogSenderWhatsappInput>;
  supportedLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCollageBarcodeInput = {
  _id: Scalars['ID']['input'];
  barcode?: InputMaybe<Scalars['FileUpload']['input']>;
  customerId: Scalars['ID']['input'];
  fields?: InputMaybe<Array<BarcodeFieldInput>>;
};

export type UpdateCollageFolderInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentFolder?: InputMaybe<Scalars['ID']['input']>;
  selectedCPersons?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  visibleTo?: InputMaybe<VisibleTo>;
};

export type UpdateCollageProductInput = {
  _id: Scalars['ID']['input'];
  barcode?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  collageImage: Scalars['FileUpload']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  folders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  layoutState?: InputMaybe<CollageLayoutStateInput>;
  modalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Number']['input']>;
  productImages: Array<InputMaybe<Scalars['FileUpload']['input']>>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCollageSettingsInput = {
  _id: Scalars['ID']['input'];
  barcodeCustomExtension?: InputMaybe<Scalars['ID']['input']>;
  bulkSettings?: InputMaybe<CollageBulkSettingsInput>;
  customerId: Scalars['ID']['input'];
  sqlConfig?: InputMaybe<CollageSqlConfigInput>;
};

export type UpdateCollageSharingInput = {
  _id: Scalars['ID']['input'];
  cPerson?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  folderLength?: InputMaybe<Scalars['Int']['input']>;
  folderName?: InputMaybe<Scalars['String']['input']>;
  medias?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<SharingStatus>;
  type?: InputMaybe<SharingType>;
};

export type UpdateCollageTemplateInput = {
  _id: Scalars['ID']['input'];
  applyDiscountToAll?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  collage?: InputMaybe<TemplateLayout>;
  coverImage?: InputMaybe<Scalars['FileUpload']['input']>;
  customerId: Scalars['ID']['input'];
  discountLabel?: InputMaybe<Scalars['String']['input']>;
  discountStyle?: InputMaybe<TemplateDiscountStyle>;
  footer?: InputMaybe<TemplateFooter>;
  footerCodeSizeDelta?: InputMaybe<Scalars['Int']['input']>;
  footerFontWeight?: InputMaybe<TemplateFooterFontWeight>;
  footerPriceSizeDelta?: InputMaybe<Scalars['Int']['input']>;
  frame?: InputMaybe<FrameRatio>;
  header?: InputMaybe<TemplateHeader>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mainColor?: InputMaybe<Scalars['String']['input']>;
  mainLogo?: InputMaybe<Scalars['FileUpload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceTextColor?: InputMaybe<Scalars['String']['input']>;
  productDataSource?: InputMaybe<ProductDataSource>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryLogo?: InputMaybe<Scalars['FileUpload']['input']>;
  selectedCPersons?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  visibleTo?: InputMaybe<VisibleTo>;
};

export type UpdateConvSidebarInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  views?: InputMaybe<Array<InputMaybe<UpdateSidebarViewInput>>>;
};

export type UpdateConvTags = {
  cPersonId: Scalars['ID']['input'];
  convIds: Array<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  isBulkAdd?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type UpdateConvViewInput = {
  _id: Scalars['ID']['input'];
  conditions?: InputMaybe<Array<InputMaybe<ConvViewsConditionsInput>>>;
  customerId: Scalars['ID']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisibleToAllCPerson?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  selectedCPersons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shouldMatchAllConditions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateConversationDetailsSettingsInput = {
  cPerson: Scalars['ID']['input'];
  conversationDetails: Array<TypedConversationDetailsItemInput>;
  customerId: Scalars['ID']['input'];
};

export type UpdateConversationSettingsInput = {
  cPerson: Scalars['ID']['input'];
  conversation: Array<TypedConversationItemInput>;
  customerId: Scalars['ID']['input'];
};

export type UpdateConversationsInput = {
  cPersonId?: InputMaybe<Scalars['ID']['input']>;
  closingNote?: InputMaybe<ConversationClosingNoteInput>;
  convWithPerson?: InputMaybe<Array<InputMaybe<ConvsUpdateInput>>>;
  customerId: Scalars['ID']['input'];
  integrationRecord?: InputMaybe<ConversationIntegrationRecordInput>;
  isAllSelected?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  isStarredSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  previousParticipant?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<TicketPriority>;
  selectedFilter?: InputMaybe<GetConversationsInput>;
  /** Closing only. true: send the configured survey now; false: skip it; omitted: automatic survey rule. */
  sendSatisfactionSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ConversationStatusEnum>;
  ticketCustomFields?: InputMaybe<Array<InputMaybe<CreateTicketCustomFieldInput>>>;
  ticketState?: InputMaybe<Scalars['ID']['input']>;
  ticketType?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCustomExtensionInput = {
  _id: Scalars['ID']['input'];
  connectedAction?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CustomExtensionStatus>;
  tabsConfig?: InputMaybe<CreateCustomExtensionTabsInput>;
};

export type UpdateCustomFieldInput = {
  _id: Scalars['ID']['input'];
  conditions?: InputMaybe<Array<CustomFieldConditionInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  decimal?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  listValues?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<EnumCustomFieldMediaType>;
  multiSelect?: InputMaybe<Scalars['Boolean']['input']>;
  multiline?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameVisibleToCustomers?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<EnumCustomFieldScope>;
  status?: InputMaybe<EnumCustomFieldStatus>;
  type?: InputMaybe<EnumCustomFieldsType>;
  usage?: InputMaybe<EnumCustomFieldUsageField>;
  visibleToCustomers?: InputMaybe<EnumCustomFieldCustomerVisibility>;
  visibleToUsers?: InputMaybe<EnumCustomFieldUserVisibility>;
  withTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomFieldStatusInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  status?: InputMaybe<EnumCustomFieldStatus>;
};

export type UpdateCustomerBillingContactsInput = {
  customer: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  _id: Scalars['ID']['input'];
  accountConfirmation?: InputMaybe<Scalars['String']['input']>;
  accountStatus?: InputMaybe<Scalars['String']['input']>;
  allowConnect?: InputMaybe<Scalars['Boolean']['input']>;
  allowUnassignedTicket?: InputMaybe<Scalars['Boolean']['input']>;
  appStatus?: InputMaybe<Scalars['String']['input']>;
  autoApproveSharingRequests?: InputMaybe<Scalars['Boolean']['input']>;
  autoAssignmentType?: InputMaybe<AutoAssignmentTypeEnum>;
  autoConversationAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  autoConversationAssignmentTime?: InputMaybe<Scalars['Int']['input']>;
  autoConversationAssignmentTimeUnit?: InputMaybe<Scalars['String']['input']>;
  cPersonsAutoAwayTime?: InputMaybe<Scalars['Int']['input']>;
  canManageOtherUserConversation?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closingNote?: InputMaybe<ClosingNoteDetailInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  is2FARequired?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Language>;
  personCount?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendAutoSurvey?: InputMaybe<SendAutoSurveyInput>;
  teamFirstResponseGoalTime?: InputMaybe<Scalars['Int']['input']>;
  teamGoalTime?: InputMaybe<Scalars['Int']['input']>;
  teamOnlineGoalTime?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInvoiceInput = {
  _id: Scalars['ID']['input'];
  amountPaid?: InputMaybe<Scalars['Number']['input']>;
  customerId: Scalars['ID']['input'];
  paymentInvoice?: InputMaybe<Scalars['FileUpload']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
};

export type UpdateCustomerInvoiceResponse = {
  __typename?: 'UpdateCustomerInvoiceResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerInvoice;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCustomerPersonInput = {
  _id: Scalars['ID']['input'];
  canAccessPhoneCalls?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  dateFormat?: InputMaybe<CustomerDateFormat>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasAiAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  is2FAEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAcceptingCalls?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  joinedConvCount?: InputMaybe<Scalars['Int']['input']>;
  joinedConvLimit?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  signedTeams?: InputMaybe<Scalars['Array']['input']>;
  status?: InputMaybe<CPersonStatus>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomerType>;
};

export type UpdateCustomerProductInput = {
  _id: Scalars['ID']['input'];
  accountBalance?: InputMaybe<Scalars['Float']['input']>;
  directAccountBalance?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  features?: InputMaybe<FeaturesInput>;
  freeTrialExpiringDate?: InputMaybe<Scalars['Date']['input']>;
  limits?: InputMaybe<LimitsAndUsagesInput>;
  reChargeSettings?: InputMaybe<NeedChargeLimitInput>;
  usages?: InputMaybe<LimitsAndUsagesInput>;
};

export type UpdateCustomerProductPlanInput = {
  customerId: Scalars['ID']['input'];
  days: Scalars['Int']['input'];
  extendOrReduce: ExtendOrReduce;
};

export type UpdateDelayedActionInput = {
  _id: Scalars['ID']['input'];
  actionDate?: InputMaybe<Scalars['Date']['input']>;
  customerId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDomainInput = {
  _id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  senderEmailAddress: Scalars['String']['input'];
};

export type UpdateECommerceIntegrationCustomerAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityCode?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
  townCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateECommerceIntegrationCustomerAddressOutput = {
  __typename?: 'UpdateECommerceIntegrationCustomerAddressOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<UpdateECommerceIntegrationCustomerAddressOutputData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateECommerceIntegrationCustomerAddressOutputData = {
  __typename?: 'UpdateECommerceIntegrationCustomerAddressOutputData';
  data?: Maybe<EcommerceCustomerAddressData>;
};

export type UpdateECommerceIntegrationCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateECommerceIntegrationCustomerOutput = {
  __typename?: 'UpdateECommerceIntegrationCustomerOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<UpdateECommerceIntegrationCustomerOutputData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateECommerceIntegrationCustomerOutputData = {
  __typename?: 'UpdateECommerceIntegrationCustomerOutputData';
  data?: Maybe<EcommerceCustomerData>;
};

export type UpdateECommerceIntegrationInput = {
  _id: Scalars['String']['input'];
  apiKey?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productCardSettings?: InputMaybe<ProductCardSettingsInput>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  storeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateECommerceIntegrationOutput = {
  __typename?: 'UpdateECommerceIntegrationOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateECommerceRulesInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  message1?: InputMaybe<EcommerceRuleMessageInput>;
  message2?: InputMaybe<EcommerceRuleMessageInput>;
  platforms?: InputMaybe<Array<InputMaybe<ECommercePlatformsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EcommerceRulesEnum>;
};

export type UpdateECommerceRulesStatusInput = {
  _id: Scalars['ID']['input'];
  customer: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};

export type UpdateExternalApiInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<PermissionScopeInput>>>;
};

export type UpdateFlowBotInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFlowBotResponse = {
  __typename?: 'UpdateFlowBotResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowBot>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateFlowBotSubResponse = {
  __typename?: 'UpdateFlowBotSubResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowBotSubResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateFlowBotSubscriptionInput = {
  customer?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type UpdateFlowNodeInput = {
  _id: Scalars['ID']['input'];
  coordinates?: InputMaybe<FlowNodeCoordinateInput>;
  customerId: Scalars['ID']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFlowNodeResponse = {
  __typename?: 'UpdateFlowNodeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNode>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateFlowNodeSubResponse = {
  __typename?: 'UpdateFlowNodeSubResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<FlowNodeSubResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateFlowNodeSubscriptionInput = {
  customer?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type UpdateHomeLayoutSettingsInput = {
  cPerson: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  homeDashboardStats?: InputMaybe<Array<TypedHomeDashboardStatItemInput>>;
  homeWidgets?: InputMaybe<Array<TypedHomeWidgetItemInput>>;
};

export type UpdateInboundWebhookInput = {
  _id: Scalars['ID']['input'];
  defaults?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['ID']['input']>;
  mapping?: InputMaybe<Array<InboundWebhookMappingRuleInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<InboundWebhookProvider>;
  sourceConfig?: InputMaybe<InboundWebhookSourceConfigInput>;
  status?: InputMaybe<InboundWebhookStatus>;
  triggerType?: InputMaybe<InboundWebhookTriggerType>;
};

export type UpdateIntegrationInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  checkPersonOwner?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  fieldMapping?: InputMaybe<Scalars['JSON']['input']>;
  hasSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  modules?: InputMaybe<Array<InputMaybe<IntegrationModuleInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  noPersonOwner?: InputMaybe<Scalars['String']['input']>;
  ownerSource?: InputMaybe<Scalars['String']['input']>;
  sendHistoryToZoho?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIntegrationRecordInput = {
  customerId: Scalars['ID']['input'];
  data: IntegrationRecord;
  type: IntegrationType;
};

export type UpdateMobileAppVersionConfigInput = {
  latestVersion: Scalars['String']['input'];
  minSupportedVersion: Scalars['String']['input'];
  platform: MobilePlatform;
  releaseNotes?: InputMaybe<MobileReleaseNotesInput>;
  storeUrl?: InputMaybe<Scalars['String']['input']>;
  updateType: MobileUpdateType;
};

export type UpdateNotification = {
  __typename?: 'UpdateNotification';
  message?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type UpdateNotificationResponse = {
  __typename?: 'UpdateNotificationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<UpdateNotification>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOperatorJobInput = {
  customerId: Scalars['ID']['input'];
  delivery?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** frequency, time (HH:MM), weekday (1–7), monthDay (0 = last day), date (YYYY-MM-DD) */
  schedule?: InputMaybe<Scalars['JSON']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOperatorPreferencesInput = {
  attributionDays: Scalars['Int']['input'];
  customerId: Scalars['ID']['input'];
};

export type UpdateOperatorQueryInput = {
  chatId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  params: Scalars['JSON']['input'];
  queryId: Scalars['ID']['input'];
};

export type UpdateParticipantEntryInput = {
  role: TeamChatParticipantRole;
  user: Scalars['ID']['input'];
};

export type UpdatePersonGroupInput = {
  _id: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<InputConditions>>>;
  customer: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shouldMatchAllConditions?: InputMaybe<Scalars['Boolean']['input']>;
  whatsAppSenderPlatformId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonInput = {
  _id: Scalars['ID']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  ownerTeam?: InputMaybe<Scalars['ID']['input']>;
  personCustomFields?: InputMaybe<Array<InputMaybe<PersonCustomFieldsInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneUsagePermission?: InputMaybe<Scalars['Boolean']['input']>;
  primaryChannel?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformInput = {
  metaData?: InputMaybe<Scalars['Object']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformInputData = {
  _id: Scalars['ID']['input'];
  acceptCallOutsideWorkHours?: InputMaybe<Scalars['Boolean']['input']>;
  accountSettings?: InputMaybe<WabaBusinessAccountSettingsInput>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appToken?: InputMaybe<Scalars['String']['input']>;
  appearance?: InputMaybe<Scalars['Object']['input']>;
  authenticationUrl?: InputMaybe<Scalars['String']['input']>;
  autoCallRecording?: InputMaybe<Scalars['Boolean']['input']>;
  autoCloseConversationOnCallEnd?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  cPersonId?: InputMaybe<Scalars['String']['input']>;
  callAnswerWaitingTime?: InputMaybe<Scalars['Int']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  clientKey?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  connectedEmailChannel?: InputMaybe<Scalars['String']['input']>;
  consentCheckbox?: InputMaybe<Scalars['Object']['input']>;
  convertAllEmailsToTickets?: InputMaybe<Scalars['Boolean']['input']>;
  convertTicket?: InputMaybe<Scalars['Boolean']['input']>;
  createNewChatPerMessage?: InputMaybe<Scalars['Boolean']['input']>;
  createNewOnReplyToClosed?: InputMaybe<Scalars['Boolean']['input']>;
  createNewOnSubjectChange?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultTicketType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['Object']['input']>>>;
  formStatus?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  getImageFilesFromLinks?: InputMaybe<Scalars['Boolean']['input']>;
  getStartedInfo?: InputMaybe<Scalars['Object']['input']>;
  groupChats?: InputMaybe<Scalars['Boolean']['input']>;
  groupSenderName?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiCallAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  hasCallTranscripts?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ignoredTickets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inboundPhoneCalls?: InputMaybe<Scalars['Boolean']['input']>;
  inboundWebhookId?: InputMaybe<Scalars['String']['input']>;
  includeHistoryInReplies?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddresses?: InputMaybe<Array<InputMaybe<PhoneNumberIpAccessInput>>>;
  isApiConnection?: InputMaybe<Scalars['Boolean']['input']>;
  isCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  isCommentEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isMessageEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewEnable?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastTicketId?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  markOffline?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  outboundPhoneCalls?: InputMaybe<Scalars['Boolean']['input']>;
  outboundWebhookId?: InputMaybe<Scalars['String']['input']>;
  outgoingWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinCode?: InputMaybe<Scalars['String']['input']>;
  playGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  playOutsideWorkHours?: InputMaybe<Scalars['Boolean']['input']>;
  playQueue?: InputMaybe<Scalars['Boolean']['input']>;
  playUnreachable?: InputMaybe<Scalars['Boolean']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryTextColor?: InputMaybe<Scalars['String']['input']>;
  product_template_id?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<WabaBusinessProfileInput>;
  providerType?: InputMaybe<Scalars['String']['input']>;
  reOpenTickets?: InputMaybe<Scalars['Int']['input']>;
  recaptchaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  receiveChannelMessages?: InputMaybe<Scalars['Boolean']['input']>;
  receivePhoneMsg?: InputMaybe<Scalars['Boolean']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  routingType?: InputMaybe<PhoneNumberRoutingType>;
  satisfaction?: InputMaybe<SatisfactionInput>;
  senderFieldsForSignature?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Scalars['Object']['input']>;
  sla?: InputMaybe<SlaInput>;
  smtpConfig?: InputMaybe<SmtpConfigInput>;
  sounds?: InputMaybe<PhoneNumberSoundsInput>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketType?: InputMaybe<Scalars['String']['input']>;
  ticketUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['Object']['input']>;
  useAgentAvatarInReplies?: InputMaybe<Scalars['Boolean']['input']>;
  useAgentFullNameAsSender?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<LiveChatAccountVisibility>;
  websiteDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateProductInput = {
  _id: Scalars['ID']['input'];
  discountRate?: InputMaybe<Scalars['Int']['input']>;
  features?: InputMaybe<ProductFeatureInput>;
  limits?: InputMaybe<ProductLimitsInput>;
  monthlyPrice?: InputMaybe<Scalars['Double']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  yearlyPrice?: InputMaybe<Scalars['Double']['input']>;
};

export type UpdateProductTourInput = {
  boardsCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  completedModule?: InputMaybe<Scalars['String']['input']>;
  mainCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  mainSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeVideoWatched?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateQpienShopCustomerAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  qpienShopCustomerAddressId: Scalars['String']['input'];
  qpienShopCustomerId: Scalars['String']['input'];
};

export type UpdateQpienShopCustomerAddressResponse = {
  __typename?: 'UpdateQpienShopCustomerAddressResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: QpienShopCustomerAddressData;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateQpienShopCustomerData = {
  __typename?: 'UpdateQpienShopCustomerData';
  companyName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type UpdateQpienShopCustomerInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  qpienShopCustomerId: Scalars['String']['input'];
};

export type UpdateQpienShopCustomerResponse = {
  __typename?: 'UpdateQpienShopCustomerResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: UpdateQpienShopCustomerData;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateQpienShopOrderAddressInput = {
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQpienShopOrderInput = {
  addItems?: InputMaybe<Array<InputMaybe<QpienShopOrderItemInput>>>;
  billing_address?: InputMaybe<UpdateQpienShopOrderAddressInput>;
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  removeItem?: InputMaybe<UpdateQpienShopOrderRemoveItemInput>;
  shipping_address?: InputMaybe<UpdateQpienShopOrderAddressInput>;
  updateItem?: InputMaybe<UpdateQpienShopOrderUpdateItemInput>;
};

export type UpdateQpienShopOrderRemoveItemInput = {
  orderId: Scalars['String']['input'];
  orderItemId: Scalars['String']['input'];
};

export type UpdateQpienShopOrderResponse = {
  __typename?: 'UpdateQpienShopOrderResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Object']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateQpienShopOrderUpdateItemInput = {
  orderId: Scalars['String']['input'];
  orderItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpdateQuickAnswerInput = {
  _id: Scalars['ID']['input'];
  actions?: InputMaybe<Array<InputMaybe<QuickAnswerActionInput>>>;
  answer?: InputMaybe<Scalars['String']['input']>;
  channels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerId: Scalars['ID']['input'];
  customerPersons?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  payload: Array<InputMaybe<QuickAnswerPayload>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateReportInput = {
  dateRange?: InputMaybe<ReportDateRangeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  hasAccess?: InputMaybe<ReportAccess>;
  name?: InputMaybe<Scalars['String']['input']>;
  refreshInterval?: InputMaybe<Scalars['Int']['input']>;
  selectedCPersons?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedTeams?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateReportMutationInput = {
  input: UpdateReportInput;
  reportId: Scalars['ID']['input'];
};

export type UpdateReportWidgetInput = {
  chartType?: InputMaybe<Scalars['String']['input']>;
  dateRangeOverride?: InputMaybe<ReportDateRangeInput>;
  displayOptions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  segmentBy?: InputMaybe<ReportWidgetSegmentByInput>;
};

export type UpdateReportWidgetMetricInput = {
  filters?: InputMaybe<Array<WidgetFilterInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportWidgetMetricMutationInput = {
  input: UpdateReportWidgetMetricInput;
  metricId: Scalars['ID']['input'];
};

export type UpdateReportWidgetMutationInput = {
  input: UpdateReportWidgetInput;
  widgetId: Scalars['ID']['input'];
};

export type UpdateSidebarViewInput = {
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  view: Scalars['String']['input'];
};

export type UpdateSkillDraftInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  definition?: InputMaybe<SkillDefinitionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedDraftRevision: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** AI roles this skill belongs to. Empty means every role. */
  roles?: InputMaybe<Array<AiRoleEnum>>;
};

export type UpdateSlaPolicyInput = {
  _id: Scalars['ID']['input'];
  conditions?: InputMaybe<Array<SlaPolicyConditionInput>>;
  customerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<SlaPolicyRulesInput>;
  status?: InputMaybe<SlaPolicyStatus>;
  targets?: InputMaybe<SlaPolicyTargetsInput>;
  type?: InputMaybe<SlaPolicyType>;
};

export type UpdateSubscriptionInput = {
  customer?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type UpdateSurveyHistoryInput = {
  _id: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['String']['input'];
};

export type UpdateSurveysInput = {
  _id: Scalars['ID']['input'];
  commentInputTitle?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['Media']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  submitButtonText?: InputMaybe<Scalars['String']['input']>;
  thankYouMessage?: InputMaybe<Scalars['String']['input']>;
  themeMainColor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTableFieldInput = {
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  listOptions?: InputMaybe<Array<TableListOptionInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<TableFieldSettingsInput>;
  type?: InputMaybe<TableFieldType>;
};

export type UpdateTableFolderInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTableInput = {
  customerId: Scalars['ID']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isRecordNoVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowHeight?: InputMaybe<TableRowHeight>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateTableRecordInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  kanbanOrder?: InputMaybe<Scalars['Object']['input']>;
  values?: InputMaybe<Scalars['Object']['input']>;
};

export type UpdateTableRecordKanbanOrderInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  kanbanOrder: Scalars['Object']['input'];
};

export type UpdateTableViewInput = {
  customerId: Scalars['ID']['input'];
  groupByFieldId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TableViewType>;
};

export type UpdateTagInput = {
  _id: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskCommentInput = {
  _id: Scalars['ID']['input'];
  mentions?: InputMaybe<Array<Scalars['ID']['input']>>;
  text: Scalars['String']['input'];
};

export type UpdateTaskInput = {
  _id: Scalars['ID']['input'];
  cPerson?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['Date']['input']>;
  media?: InputMaybe<Array<MediaInput>>;
  priority?: InputMaybe<TaskPriority>;
  remindeAt?: InputMaybe<Scalars['Date']['input']>;
  repeat?: InputMaybe<RepeatInput>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<TaskSourceType>;
  status?: InputMaybe<TaskStatus>;
  tag?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskResponse = {
  __typename?: 'UpdateTaskResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTasksInput = {
  cPerson?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['Date']['input']>;
  media?: InputMaybe<Array<MediaInput>>;
  priority?: InputMaybe<TaskPriority>;
  remindeAt?: InputMaybe<Scalars['Date']['input']>;
  repeat?: InputMaybe<RepeatInput>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<TaskSourceType>;
  status?: InputMaybe<TaskStatus>;
  tag?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamChatParticipantsInput = {
  customerId: Scalars['ID']['input'];
  participants: Array<UpdateParticipantEntryInput>;
  removedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamConversationId: Scalars['ID']['input'];
};

export type UpdateTeamGroupChatInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<TeamChatPermissionsInput>;
  teamConversationId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTicketStateInput = {
  _id: Scalars['String']['input'];
  category?: InputMaybe<TicketStateCategoryType>;
  customer: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameVisibleToCustomers?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TicketStatusType>;
};

export type UpdateTicketTypeInput = {
  _id: Scalars['String']['input'];
  customFields?: InputMaybe<Array<Scalars['ID']['input']>>;
  customer: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameVisibleToCustomers?: InputMaybe<Scalars['String']['input']>;
  shareStagesWithCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<TicketStatusType>;
  usage?: InputMaybe<TicketTypeUsage>;
};

export type UpdateTopicInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  _id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleTypes>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateViewFoldersSettingsInput = {
  cPerson: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  viewFolders: Array<TypedViewFoldersItemInput>;
};

export type UpdateWabaTemplateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  qpienFields?: InputMaybe<Array<InputMaybe<QpienFields>>>;
};

export type UpdateWebhookInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  endpointUrl?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<WebhookEventType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WebhookStatus>;
};

export type UpdateWorkingHourInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  days: Array<InputMaybe<WorkingHourInput>>;
};

export type UpdateWorkingHourOutput = {
  __typename?: 'UpdateWorkingHourOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CustomerWorkingHours>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdatedConversationsResponse = {
  __typename?: 'UpdatedConversationsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdatedRecord = {
  __typename?: 'UpdatedRecord';
  fields?: Maybe<Scalars['Object']['output']>;
  moduleName?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdatedTrackingDomainResponse = {
  __typename?: 'UpdatedTrackingDomainResponse';
  data?: Maybe<TrackingDomainEvent>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadAttachmentInput = {
  customerId: Scalars['ID']['input'];
  data?: InputMaybe<UploadAttachmentRecord>;
  type?: InputMaybe<IntegrationType>;
};

export type UploadAttachmentRecord = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
};

export type UploadCampaignMediaInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  file: Scalars['Media']['input'];
};

export type UploadChangelogMediaInput = {
  file: Scalars['FileUpload']['input'];
};

export type UploadFileInput = {
  customerId: Scalars['ID']['input'];
  data?: InputMaybe<FileRecord>;
  type?: InputMaybe<IntegrationType>;
};

export type UploadedAiProfilePayload = {
  __typename?: 'UploadedAiProfilePayload';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type UploadedAttachment = {
  __typename?: 'UploadedAttachment';
  Created_By?: Maybe<CreatedByPerson>;
  Created_Time?: Maybe<Scalars['String']['output']>;
  File_Name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type UploadedQuickAnswerPayload = {
  __typename?: 'UploadedQuickAnswerPayload';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type UpsertAppSettingsInput = {
  cPerson: Scalars['ID']['input'];
  conversation?: InputMaybe<Array<AppSettingsItemInput>>;
  conversationDetails?: InputMaybe<Array<AppSettingsItemInput>>;
  customerId: Scalars['ID']['input'];
  viewFolders?: InputMaybe<Array<AppSettingsItemInput>>;
};

export type UpsertFlowWebhookTriggerInput = {
  contactIdentifier: FlowWebhookContactIdentifierInput;
  flowId: Scalars['ID']['input'];
  variables?: InputMaybe<Array<FlowWebhookVariableInput>>;
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleTypes>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: User;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSubscriptionInput = {
  token: Scalars['String']['input'];
};

export type UserTokenData = {
  __typename?: 'UserTokenData';
  token: Scalars['String']['output'];
  user: User;
};

export type UserTokenResponse = {
  __typename?: 'UserTokenResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<UserTokenData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<User>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum Visitor_Contact_Info_Value {
  AlwaysAsk = 'ALWAYS_ASK',
  AskOutsideWorkingHours = 'ASK_OUTSIDE_WORKING_HOURS'
}

export type ValidateCampaignInput = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type ValidateCampaignResponse = {
  __typename?: 'ValidateCampaignResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<CampaignValidationReport>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifiedTwoFactorAuthenticationResponse = {
  __typename?: 'VerifiedTwoFactorAuthenticationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyTwoFactorAuthenticationInput = {
  _id: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
};

export enum ViewFoldersName {
  Tasks = 'tasks',
  TeamChat = 'teamChat',
  TeamMembers = 'teamMembers',
  Teams = 'teams',
  UnansweredMessageCount = 'unansweredMessageCount',
  Views = 'views'
}

export type ViewFoldersSettingsItem = {
  __typename?: 'ViewFoldersSettingsItem';
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  name: ViewFoldersName;
  order?: Maybe<Scalars['Int']['output']>;
};

export enum VisibleTo {
  All = 'ALL',
  Selected = 'SELECTED'
}

export type WaBaTemplateDataResponse = {
  __typename?: 'WaBaTemplateDataResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Object']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WabaBusinessAccountSettingsInput = {
  iceBreakers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isWelcomeMessageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WabaBusinessProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['FileUpload']['input']>;
  websites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WabaTemplateResponse = {
  __typename?: 'WabaTemplateResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: MetaWhatsAppBusinessTemplate;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type WabaTemplateResultResponse = {
  __typename?: 'WabaTemplateResultResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Object']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WabaTemplateSubscriptionInput = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type WabaTemplateSubscriptionResponse = {
  __typename?: 'WabaTemplateSubscriptionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Webhook = {
  __typename?: 'Webhook';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer: Scalars['ID']['output'];
  endpointUrl: Scalars['String']['output'];
  events: Array<WebhookEventType>;
  name?: Maybe<Scalars['String']['output']>;
  status: WebhookStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum WebhookEventType {
  CloseConversation = 'CLOSE_CONVERSATION',
  JoinConversation = 'JOIN_CONVERSATION',
  NewIncomingMessage = 'NEW_INCOMING_MESSAGE',
  NewOutgoingMessage = 'NEW_OUTGOING_MESSAGE',
  ReopenConversation = 'REOPEN_CONVERSATION',
  TransferConversation = 'TRANSFER_CONVERSATION',
  UpdateUser = 'UPDATE_USER'
}

export type WebhookResponse = {
  __typename?: 'WebhookResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Webhook;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum WebhookStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type WebhookSubscriptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type WebhooksPaginatedData = {
  __typename?: 'WebhooksPaginatedData';
  docs: Array<Maybe<Webhook>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type WebhooksPaginatedResponse = {
  __typename?: 'WebhooksPaginatedResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: WebhooksPaginatedData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WhatsAppBusinessTemplate = {
  __typename?: 'WhatsAppBusinessTemplate';
  _id: Scalars['ID']['output'];
  appId: Scalars['String']['output'];
  appToken?: Maybe<Scalars['String']['output']>;
  buttons: Array<WhatsAppBusinessTemplateButton>;
  category: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdAtTemplate: Scalars['Date']['output'];
  customer: Scalars['ID']['output'];
  eCommerceCart?: Maybe<Scalars['Boolean']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  exampleMedia?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  isCreatedOnQpien: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  qpienFields: Array<WhatsAppBusinessTemplateQpienField>;
  reason?: Maybe<Scalars['String']['output']>;
  sampleMedia?: Maybe<WhatsAppBusinessTemplateSampleMedia>;
  status: Scalars['String']['output'];
  survey?: Maybe<Scalars['ID']['output']>;
  templateId: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
  vertical?: Maybe<Scalars['String']['output']>;
};

export type WhatsAppBusinessTemplateButton = {
  __typename?: 'WhatsAppBusinessTemplateButton';
  example?: Maybe<Array<Scalars['String']['output']>>;
  phone_number?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type WhatsAppBusinessTemplateQpienField = {
  __typename?: 'WhatsAppBusinessTemplateQpienField';
  exampleData: Scalars['String']['output'];
  key: Scalars['Int']['output'];
  ref: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WhatsAppBusinessTemplateSampleMedia = {
  __typename?: 'WhatsAppBusinessTemplateSampleMedia';
  file: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WhatsAppPhone = {
  __typename?: 'WhatsAppPhone';
  _id?: Maybe<Scalars['ID']['output']>;
  battery?: Maybe<Scalars['Object']['output']>;
  channelOwner?: Maybe<CustomerPerson>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  loginData?: Maybe<Scalars['Object']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  onlineStatus?: Maybe<Scalars['String']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum WhatsAppTemplateSort {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Newest = 'NEWEST',
  Oldest = 'OLDEST'
}

export type WidgetDataError = {
  __typename?: 'WidgetDataError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type WidgetDataResult = {
  __typename?: 'WidgetDataResult';
  chartType: Scalars['String']['output'];
  data?: Maybe<ReportWidgetDataset>;
  effectiveDateRange: ReportDateRange;
  effectiveFilters: Array<WidgetFilter>;
  error?: Maybe<WidgetDataError>;
  lookup: Scalars['Object']['output'];
  metricResults: Array<WidgetMetricDataResult>;
  /** Populated only for a record-list (`list` chart) widget; null on every aggregate chart. */
  pageInfo?: Maybe<ReportWidgetPageInfo>;
  reportId: Scalars['ID']['output'];
  segmentBy?: Maybe<ReportWidgetSegmentBy>;
  success: Scalars['Boolean']['output'];
  widgetId: Scalars['ID']['output'];
};

export type WidgetFilter = {
  __typename?: 'WidgetFilter';
  displayValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  isDynamic: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  operator: ReportSnapshotFilterOperator;
  options?: Maybe<Array<ReportSnapshotFilterOption>>;
  value?: Maybe<Scalars['Object']['output']>;
  valueType: ReportSnapshotValueType;
};

export type WidgetFilterInput = {
  displayValue?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  isDynamic?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  operator: ReportSnapshotFilterOperator;
  value?: InputMaybe<Scalars['Object']['input']>;
  valueType: ReportSnapshotValueType;
};

export type WidgetLayout = {
  __typename?: 'WidgetLayout';
  h: Scalars['Int']['output'];
  w: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type WidgetMetricDataResult = {
  __typename?: 'WidgetMetricDataResult';
  data?: Maybe<ReportWidgetDataset>;
  effectiveFilters: Array<WidgetFilter>;
  error?: Maybe<WidgetDataError>;
  measureKey: Scalars['String']['output'];
  metricId: Scalars['ID']['output'];
  metricTemplateId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  viewBy: ReportWidgetViewBy;
};

export type WidgetMetricDrillDownResult = {
  __typename?: 'WidgetMetricDrillDownResult';
  /**
   * Both are always present; the one that does not match the metric's entity stays 0.
   * `person_live` metrics fill personCount, every other dataSource fills conversationCount.
   */
  conversationCount: Scalars['Int']['output'];
  dataSource: Scalars['String']['output'];
  effectiveFilters: Array<WidgetFilter>;
  error?: Maybe<WidgetDataError>;
  measureKey: Scalars['String']['output'];
  metricId: Scalars['ID']['output'];
  metricTemplateId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  personCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  viewBy: ReportWidgetViewBy;
};

export type Workflow = {
  __typename?: 'Workflow';
  _id: Scalars['ID']['output'];
  /** FlowMessageChannel values of the triggers. */
  channels: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<WorkflowPerson>;
  kind: WorkflowKind;
  state: WorkflowState;
  stats: WorkflowRunStats;
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  triggerTypes: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<WorkflowPerson>;
};

export enum WorkflowKind {
  Ecommerce = 'ECOMMERCE',
  FlowBot = 'FLOW_BOT'
}

export type WorkflowPaginationData = {
  __typename?: 'WorkflowPaginationData';
  docs: Array<Workflow>;
  hasNextPage: Scalars['Boolean']['output'];
  /** Start of the window the run counts cover. */
  statsSince: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type WorkflowPerson = {
  __typename?: 'WorkflowPerson';
  _id: Scalars['ID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Counted over the last 14 days (run logs expire after that). */
export type WorkflowRunStats = {
  __typename?: 'WorkflowRunStats';
  /** Runs that reached the end (e-commerce: recovered carts). */
  completed: Scalars['Int']['output'];
  /** Runs that performed at least one action (message, assignment, question, AI …). */
  engaged: Scalars['Int']['output'];
  /** Runs that entered the workflow. */
  started: Scalars['Int']['output'];
};

export enum WorkflowSortField {
  Channels = 'CHANNELS',
  Completed = 'COMPLETED',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Engaged = 'ENGAGED',
  Started = 'STARTED',
  State = 'STATE',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export enum WorkflowSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** LIVE = status on; PAUSED = off after having been published once; DRAFT = never published. */
export enum WorkflowState {
  Draft = 'DRAFT',
  Live = 'LIVE',
  Paused = 'PAUSED'
}

export type WorkflowStatusCounts = {
  __typename?: 'WorkflowStatusCounts';
  all: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  /** Flow bots only — the plan limit counts these. */
  flowBots: Scalars['Int']['output'];
  live: Scalars['Int']['output'];
  paused: Scalars['Int']['output'];
};

export type WorkingHour = {
  __typename?: 'WorkingHour';
  closingHour: Scalars['String']['output'];
  dayName: DayNamesEnum;
  isOpen: Scalars['Boolean']['output'];
  openingHour: Scalars['String']['output'];
};

export type WorkingHourInput = {
  closingHour: Scalars['String']['input'];
  dayName: DayNamesEnum;
  isOpen: Scalars['Boolean']['input'];
  openingHour: Scalars['String']['input'];
};

export type WpTemplateParams = {
  key: Scalars['Int']['input'];
  ref: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type WpTemplateType = {
  __typename?: 'WpTemplateType';
  key: Scalars['Int']['output'];
  ref: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export enum ZohoActionOperation {
  AddNote = 'add_note',
  ConvertRecord = 'convert_record',
  CreateRecord = 'create_record',
  GetOwner = 'get_owner',
  GetRecord = 'get_record',
  GetTags = 'get_tags',
  RunBlueprint = 'run_blueprint',
  UpdateDealStage = 'update_deal_stage',
  UpdateOwner = 'update_owner',
  UpdateRecord = 'update_record',
  UpdateTags = 'update_tags'
}

export enum ZohoActionSearchBy {
  Email = 'email',
  Id = 'id',
  Owner = 'owner',
  Phone = 'phone',
  PhoneOrEmail = 'phone_or_email',
  RelatedContact = 'related_contact',
  RelatedLead = 'related_lead'
}

export type ZohoBlueprintTransition = {
  __typename?: 'ZohoBlueprintTransition';
  fields?: Maybe<Array<Maybe<ZohoBlueprintTransitionField>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextFieldValue?: Maybe<Scalars['String']['output']>;
};

export type ZohoBlueprintTransitionField = {
  __typename?: 'ZohoBlueprintTransitionField';
  apiName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoBlueprintTransitionsResponse = {
  __typename?: 'ZohoBlueprintTransitionsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ZohoBlueprintTransition>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoContact = {
  __typename?: 'ZohoContact';
  Account_Name?: Maybe<ZohoPerson>;
  Created_Time?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Full_Name?: Maybe<Scalars['String']['output']>;
  Lead_Source?: Maybe<Scalars['String']['output']>;
  Mailing_Country?: Maybe<Scalars['String']['output']>;
  Owner?: Maybe<ZohoPerson>;
  Phone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ZohoConvertMappingInput = {
  sourceField?: InputMaybe<Scalars['String']['input']>;
  targetField: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ZohoConvertMappingType = {
  __typename?: 'ZohoConvertMappingType';
  sourceField?: Maybe<Scalars['String']['output']>;
  targetField?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ZohoDeal = {
  __typename?: 'ZohoDeal';
  Closing_Date?: Maybe<Scalars['String']['output']>;
  Contact_Name?: Maybe<ZohoPerson>;
  Deal_Name?: Maybe<Scalars['String']['output']>;
  Lead_Source?: Maybe<Scalars['String']['output']>;
  Owner?: Maybe<ZohoPerson>;
  Stage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ZohoFieldMappingInput = {
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  personField?: InputMaybe<Scalars['String']['input']>;
  zohoField: Scalars['String']['input'];
};

export type ZohoFieldMappingType = {
  __typename?: 'ZohoFieldMappingType';
  customFieldId?: Maybe<Scalars['ID']['output']>;
  personField?: Maybe<Scalars['String']['output']>;
  zohoField?: Maybe<Scalars['String']['output']>;
};

export type ZohoFlowTestActionInput = {
  customerId: Scalars['ID']['input'];
  dealStage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  moduleName: Scalars['String']['input'];
  noteContent?: InputMaybe<Scalars['String']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  record?: InputMaybe<Scalars['Object']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  searchOwnerId?: InputMaybe<Scalars['String']['input']>;
  tagsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transitionName?: InputMaybe<Scalars['String']['input']>;
};

export type ZohoLead = {
  __typename?: 'ZohoLead';
  Company?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  Created_Time?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Full_Name?: Maybe<Scalars['String']['output']>;
  Lead_Source?: Maybe<Scalars['String']['output']>;
  Lead_Status?: Maybe<Scalars['String']['output']>;
  Owner?: Maybe<ZohoPerson>;
  Phone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ZohoModule = {
  __typename?: 'ZohoModule';
  apiName?: Maybe<Scalars['String']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ZohoModuleField = {
  __typename?: 'ZohoModuleField';
  apiCreate?: Maybe<Scalars['Boolean']['output']>;
  apiName?: Maybe<Scalars['String']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  jsonType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  pickListValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  systemMandatory?: Maybe<Scalars['Boolean']['output']>;
  virtualField?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoModuleFieldsResponse = {
  __typename?: 'ZohoModuleFieldsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ZohoModuleField>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoModuleRecords = {
  __typename?: 'ZohoModuleRecords';
  contacts?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  customModule1?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  customModule2?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  customModule3?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  deals?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  leads?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  tasks?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
};

export type ZohoModuleRecordsResponse = {
  __typename?: 'ZohoModuleRecordsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ZohoModuleRecords>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoModuleTagsResponse = {
  __typename?: 'ZohoModuleTagsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ZohoTag>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoModulesResponse = {
  __typename?: 'ZohoModulesResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ZohoModule>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoPerson = {
  __typename?: 'ZohoPerson';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ZohoRecordFieldInput = {
  value?: InputMaybe<Scalars['String']['input']>;
  zohoField: Scalars['String']['input'];
};

export type ZohoRecordFieldType = {
  __typename?: 'ZohoRecordFieldType';
  value?: Maybe<Scalars['String']['output']>;
  zohoField?: Maybe<Scalars['String']['output']>;
};

export type ZohoTag = {
  __typename?: 'ZohoTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ZohoTask = {
  __typename?: 'ZohoTask';
  Due_Date?: Maybe<Scalars['String']['output']>;
  Owner?: Maybe<ZohoPerson>;
  Priority?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  Who_Id?: Maybe<ZohoPerson>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ZohoTestCreateInput = {
  customerId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
  record: Scalars['Object']['input'];
};

export type ZohoTestRecord = {
  __typename?: 'ZohoTestRecord';
  found?: Maybe<Scalars['Boolean']['output']>;
  record?: Maybe<Scalars['Object']['output']>;
};

export type ZohoTestRecordResponse = {
  __typename?: 'ZohoTestRecordResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ZohoTestRecord>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZohoUser = {
  __typename?: 'ZohoUser';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ZohoUsersResponse = {
  __typename?: 'ZohoUsersResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<ZohoUser>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AppId = {
  appId: Scalars['String']['input'];
};

export enum AutoAssignmentTypeEnum {
  BalancedAssignment = 'BALANCED_ASSIGNMENT',
  RoundRobinAssignment = 'ROUND_ROBIN_ASSIGNMENT'
}

export type ButtonType = {
  example?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  trackClicks?: InputMaybe<Scalars['Boolean']['input']>;
  type: ButtonTypes;
  url?: InputMaybe<Scalars['String']['input']>;
  urlVariable?: InputMaybe<TemplateButtonUrlVariableInput>;
};

export enum ButtonTypes {
  PhoneNumber = 'PHONE_NUMBER',
  QuickReply = 'QUICK_REPLY',
  Url = 'URL'
}

export type BuyCustomerProductAddOnInput = {
  addOnId: Scalars['ID']['input'];
  bundleId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerProductId: Scalars['ID']['input'];
  ipAdress: Scalars['String']['input'];
  lastFourDigits: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  numberName?: InputMaybe<Scalars['String']['input']>;
  numberType?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type CMsgStatusStatisticRes = {
  __typename?: 'cMsgStatusStatisticRes';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<CMsgStatusStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CPersonData = {
  email: Scalars['String']['input'];
  role: Scalars['ID']['input'];
};

export type CalculateAddOnCostInput = {
  addOnId: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  numberType?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type CampaignPersonInfoType = {
  __typename?: 'campaignPersonInfoType';
  fullName?: Maybe<Scalars['String']['output']>;
  personId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type CampaignStatisticRes = {
  __typename?: 'campaignStatisticRes';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<CampaignStatistics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelCustomerProductAddOnInput = {
  cancel: Scalars['Boolean']['input'];
  customerId: Scalars['ID']['input'];
  customerProductAddOnId: Scalars['ID']['input'];
};

export enum CategoryTypes {
  Authentication = 'AUTHENTICATION',
  Marketing = 'MARKETING',
  Utility = 'UTILITY'
}

export type ChangePOwnerInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};

export type ChannelTypes = {
  __typename?: 'channelTypes';
  isSystemSender?: Maybe<Scalars['Boolean']['output']>;
  lastReceivedMessageTime?: Maybe<Scalars['Date']['output']>;
  pChannelId?: Maybe<Scalars['ID']['output']>;
  platformId?: Maybe<Scalars['ID']['output']>;
  platformType?: Maybe<PlatformType>;
};

export enum CollectionNameEnum {
  ChatTags = 'ChatTags',
  Chats = 'Chats',
  CustomerPersons = 'CustomerPersons',
  CustomerProducts = 'CustomerProducts',
  Customers = 'Customers',
  EbayAccounts = 'EbayAccounts',
  EmailAccounts = 'EmailAccounts',
  FacebookPages = 'FacebookPages',
  HepsiburadaAccounts = 'HepsiburadaAccounts',
  InstagramPages = 'InstagramPages',
  KauflandAccounts = 'KauflandAccounts',
  LiveChatAccounts = 'LiveChatAccounts',
  Messages = 'Messages',
  N11Accounts = 'N11Accounts',
  PazaramaAccounts = 'PazaramaAccounts',
  PersonGroups = 'PersonGroups',
  Persons = 'Persons',
  Teams = 'Teams',
  TelegramAccounts = 'TelegramAccounts',
  TiktokPages = 'TiktokPages',
  TrendyolAccounts = 'TrendyolAccounts',
  WhatsAppBusinessPhones = 'WhatsAppBusinessPhones',
  WhatsAppPhones = 'WhatsAppPhones'
}

export type ConvCounResType = {
  __typename?: 'convCounResType';
  code?: Maybe<Scalars['String']['output']>;
  data: ConvCounType;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvStatisticRes = {
  __typename?: 'convStatisticRes';
  assignNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  avgFirstResponseTime?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  avgResolutionTime?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  closeNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  openAndReOpen?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  openNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  reOpenNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  sentMessageNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  totalClose?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  totalReOpen?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  transferredNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
};

export type ConvTagStatisticRes = {
  __typename?: 'convTagStatisticRes';
  count?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Tag>;
};

export type ConvTagStatisticsResponse = {
  __typename?: 'convTagStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<ConvTagStatisticRes>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationDashboardStatisticsResponse = {
  __typename?: 'conversationDashboardStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationDashboardStatisticsData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationHistorySentimentResponse = {
  __typename?: 'conversationHistorySentimentResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConversationHistorySentimentData;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConversationHistoryTopicsResponse = {
  __typename?: 'conversationHistoryTopicsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<ConversationHistoryTopicData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConvertMediaLinkToLinkInput = {
  customerId: Scalars['String']['input'];
  format: AudioFormat;
  link: Scalars['String']['input'];
};

export type CostDataType = {
  __typename?: 'costDataType';
  discount?: Maybe<Scalars['Double']['output']>;
  finalPrice?: Maybe<Scalars['Double']['output']>;
  remaindDays?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Double']['output']>;
  unitPrice?: Maybe<Scalars['Double']['output']>;
};

export type CreateFreeTrialPackageInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type CreateRandomMessageInput = {
  /** When set, every other field is ignored and the bulk generator runs. */
  bulk?: InputMaybe<RandomMessageBulkInput>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  channelPersonId?: InputMaybe<Scalars['String']['input']>;
  commentData?: InputMaybe<CommentDataInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dbDriverId?: InputMaybe<Scalars['String']['input']>;
  delayInSeconds?: InputMaybe<Scalars['Int']['input']>;
  fromCreateTicket?: InputMaybe<Scalars['Boolean']['input']>;
  isTicket?: InputMaybe<Scalars['Boolean']['input']>;
  medias?: InputMaybe<Array<MediaInput>>;
  messageType?: InputMaybe<MessageType>;
  messages?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<PlatformType>;
  questionData?: InputMaybe<QuestionDataInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketAssigneeId?: InputMaybe<Scalars['String']['input']>;
  ticketCustomFieldInput?: InputMaybe<Array<InputMaybe<TicketCustomFieldInput>>>;
  ticketPriority?: InputMaybe<TicketPriority>;
  ticketStateId?: InputMaybe<Scalars['String']['input']>;
  ticketType?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldsType = {
  columnNum: Scalars['Int']['input'];
  customFieldId: Scalars['ID']['input'];
  listValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: EnumCustomFieldsType;
};

export type DeleteCommentOnPlatformInput = {
  commentId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  platform: ChannelType;
};

export type DeleteCustomerProductAddOnInput = {
  customerId: Scalars['ID']['input'];
  customerProductAddOnId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ExportConversationStatisticsResponse = {
  __typename?: 'exportConversationStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ExportConversationStatisticsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportTopicComparisonStatisticsResponse = {
  __typename?: 'exportTopicComparisonStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ExportTopicComparisonStatisticsData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetAllPlatformType = {
  __typename?: 'getAllPlatformType';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  customer: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  teams: Array<Maybe<Scalars['String']['output']>>;
};

export type GetAllPlatformTypeResponse = {
  __typename?: 'getAllPlatformTypeResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<GetAllPlatformType>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetConversationInput = {
  cPersonId: Scalars['ID']['input'];
  convId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCustomerPersonInput = {
  cPersonId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetCustomerSessionResponse = {
  __typename?: 'getCustomerSessionResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: CustomerPersonTokenForAdmin;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetMsgSDataRes = {
  __typename?: 'getMsgSDataRes';
  receiveMsg?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  sendMsg?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
};

export type GetNewPackageCostInfoResponse = {
  __typename?: 'getNewPackageCostInfoResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: NewPackCostInfoRes;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPChannelInput = {
  customerId: Scalars['ID']['input'];
  pChannelId: Scalars['ID']['input'];
};

export type GetPersonsCHistoryStatisticRes = {
  __typename?: 'getPersonsCHistoryStatisticRes';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PaginateCHistory>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPersonsCHistoryStatisticType = {
  __typename?: 'getPersonsCHistoryStatisticType';
  date?: Maybe<Scalars['String']['output']>;
  statuses?: Maybe<StatusesType>;
};

export type GetSingleStatisticRes = {
  __typename?: 'getSingleStatisticRes';
  cPerson?: Maybe<Scalars['ID']['output']>;
  count?: Maybe<Scalars['Double']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type GetSingleTeamInput = {
  _id: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
};

export type GetTemplateInput = {
  customerId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
};

export enum InteractiveTypeEnum {
  CatalogMessage = 'catalog_message',
  Product = 'product',
  ProductList = 'product_list'
}

export type JoinConversationResponse = {
  __typename?: 'joinConversationResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type JoinedPersonInput = {
  _id: Scalars['ID']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  personCustomFields?: InputMaybe<Array<InputMaybe<CreatePersonCustomFieldInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<PersonPlatformInput>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LanguageData = {
  __typename?: 'languageData';
  from?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type MessageToMeForLiveChatInputType = {
  customer?: InputMaybe<Scalars['ID']['input']>;
  qpUniqId: Scalars['String']['input'];
};

export type MsgDetailsType = {
  __typename?: 'msgDetailsType';
  ackStatus?: Maybe<Scalars['String']['output']>;
  failedReason?: Maybe<FailedReasonType>;
};

export type NewPackCostInfoRes = {
  __typename?: 'newPackCostInfoRes';
  aiAssistantCost?: Maybe<Scalars['Int']['output']>;
  couponDiscount?: Maybe<Scalars['Int']['output']>;
  feeCharge?: Maybe<Scalars['Int']['output']>;
  freeTrialLeftDays?: Maybe<Scalars['Int']['output']>;
  remindCost?: Maybe<Scalars['Int']['output']>;
  totalCost?: Maybe<Scalars['Int']['output']>;
};

export type NewPackCostInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  isYearly: Scalars['Boolean']['input'];
  newPackId: Scalars['ID']['input'];
  userCount: Scalars['Int']['input'];
};

export enum OneTimesType {
  AddTeamsToCustomersAndPackages = 'ADD_TEAMS_TO_CUSTOMERS_AND_PACKAGES',
  AddTextToMessageHistory = 'ADD_TEXT_TO_MESSAGE_HISTORY',
  AddToCustomerProduct = 'ADD_TO_CUSTOMER_PRODUCT',
  BackfillCallSnapshotStartedInWh = 'BACKFILL_CALL_SNAPSHOT_STARTED_IN_WH',
  BackfillCustomFieldDefaults = 'BACKFILL_CUSTOM_FIELD_DEFAULTS',
  ChangePhoneUniqueKey = 'CHANGE_PHONE_UNIQUE_KEY',
  ClearActionLegacyChannelScope = 'CLEAR_ACTION_LEGACY_CHANNEL_SCOPE',
  CloseAllChatsOfACustomer = 'CLOSE_ALL_CHATS_OF_A_CUSTOMER',
  CloseTimeoutChats = 'CLOSE_TIMEOUT_CHATS',
  ControlOldPackages = 'CONTROL_OLD_PACKAGES',
  CreateAiBot = 'CREATE_AI_BOT',
  CreateAiPrompt = 'CREATE_AI_PROMPT',
  CreateDefaultSystemReports = 'CREATE_DEFAULT_SYSTEM_REPORTS',
  CreateTeamForCustomers = 'CREATE_TEAM_FOR_CUSTOMERS',
  CustomerPaymentCardsAndEmails = 'CUSTOMER_PAYMENT_CARDS_AND_EMAILS',
  DeleteAiPrompt = 'DELETE_AI_PROMPT',
  DeleteAllOldCustomersAutoMessageFields = 'DELETE_ALL_OLD_CUSTOMERS_AUTO_MESSAGE_FIELDS',
  DeleteAllRedisData = 'DELETE_ALL_REDIS_DATA',
  DeleteChatLastMessageNull = 'DELETE_CHAT_LAST_MESSAGE_NULL',
  DeleteMailRateLimitKeys = 'DELETE_MAIL_RATE_LIMIT_KEYS',
  DeletePersons = 'DELETE_PERSONS',
  DisableAllWhatsappWeb = 'DISABLE_ALL_WHATSAPP_WEB',
  DropLegacyCampaignFeaturesCustomerProducts = 'DROP_LEGACY_CAMPAIGN_FEATURES_CUSTOMER_PRODUCTS',
  DropLegacyCampaignFeaturesProducts = 'DROP_LEGACY_CAMPAIGN_FEATURES_PRODUCTS',
  DublicateFlow = 'DUBLICATE_FLOW',
  EnableAllActiveWhatsappWeb = 'ENABLE_ALL_ACTIVE_WHATSAPP_WEB',
  EnableAllSessionWhatsappWeb = 'ENABLE_ALL_SESSION_WHATSAPP_WEB',
  EnsurePersonNoteIndexes = 'ENSURE_PERSON_NOTE_INDEXES',
  ForkAiPromptToEngineVersion = 'FORK_AI_PROMPT_TO_ENGINE_VERSION',
  GetAiEngineVersions = 'GET_AI_ENGINE_VERSIONS',
  GetAllAiPrompts = 'GET_ALL_AI_PROMPTS',
  HumanReplyLearning = 'HUMAN_REPLY_LEARNING',
  LiveChatRobot = 'LIVE_CHAT_ROBOT',
  LoadDefaultTickets = 'LOAD_DEFAULT_TICKETS',
  LoadDefaultUserRoles = 'LOAD_DEFAULT_USER_ROLES',
  MessagePlatformGetAllClients = 'MESSAGE_PLATFORM_GET_ALL_CLIENTS',
  MessagePlatformReconnectPhone = 'MESSAGE_PLATFORM_RECONNECT_PHONE',
  MigrateAiAgentSessionDropTtl = 'MIGRATE_AI_AGENT_SESSION_DROP_TTL',
  MigrateAiEmailSettings = 'MIGRATE_AI_EMAIL_SETTINGS',
  MigrateAiEmailSkills = 'MIGRATE_AI_EMAIL_SKILLS',
  MigrateAiMarketplaceGuidance = 'MIGRATE_AI_MARKETPLACE_GUIDANCE',
  MigrateAiMarketplaceProfiles = 'MIGRATE_AI_MARKETPLACE_PROFILES',
  MigrateAiMarketplaceSkills = 'MIGRATE_AI_MARKETPLACE_SKILLS',
  MigrateAiPersonMemoryToSessions = 'MIGRATE_AI_PERSON_MEMORY_TO_SESSIONS',
  MigrateAiProfileChannelScope = 'MIGRATE_AI_PROFILE_CHANNEL_SCOPE',
  MigrateAiProfileRoles = 'MIGRATE_AI_PROFILE_ROLES',
  MigrateAiPromptEngineVersions = 'MIGRATE_AI_PROMPT_ENGINE_VERSIONS',
  MigrateAiPromptRoles = 'MIGRATE_AI_PROMPT_ROLES',
  MigrateAiPromptV1Layer = 'MIGRATE_AI_PROMPT_V1_LAYER',
  MigrateConversationDetails = 'MIGRATE_CONVERSATION_DETAILS',
  MigrateTags = 'MIGRATE_TAGS',
  MigrateViewFolders = 'MIGRATE_VIEW_FOLDERS',
  OperatorIndexCampaignHistory = 'OPERATOR_INDEX_CAMPAIGN_HISTORY',
  OperatorIndexConversationTagHistory = 'OPERATOR_INDEX_CONVERSATION_TAG_HISTORY',
  OperatorIndexCustomerPersonHistories = 'OPERATOR_INDEX_CUSTOMER_PERSON_HISTORIES',
  OperatorIndexMessageHistory = 'OPERATOR_INDEX_MESSAGE_HISTORY',
  OperatorIndexSurveyHistory = 'OPERATOR_INDEX_SURVEY_HISTORY',
  OperatorIndexTasks = 'OPERATOR_INDEX_TASKS',
  OperatorIndexTaskLog = 'OPERATOR_INDEX_TASK_LOG',
  RemoveLiveChatWelcomeMessages = 'REMOVE_LIVE_CHAT_WELCOME_MESSAGES',
  ResyncQuickAnswerRag = 'RESYNC_QUICK_ANSWER_RAG',
  ReverseWhatsappBusinessToMetaBusiness = 'REVERSE_WHATSAPP_BUSINESS_TO_META_BUSINESS',
  ReverseWhatsappBusinessToWeb = 'REVERSE_WHATSAPP_BUSINESS_TO_WEB',
  ReverseWhatsappWebToBusiness = 'REVERSE_WHATSAPP_WEB_TO_BUSINESS',
  RunPromptPlayground = 'RUN_PROMPT_PLAYGROUND',
  SeedCsatReportMetricTemplates = 'SEED_CSAT_REPORT_METRIC_TEMPLATES',
  SeedCsatReportWidgetTemplates = 'SEED_CSAT_REPORT_WIDGET_TEMPLATES',
  SeedExtractContactInfoFlowBlockTemplates = 'SEED_EXTRACT_CONTACT_INFO_FLOW_BLOCK_TEMPLATES',
  SeedExtractContactInfoFlowNodeTemplates = 'SEED_EXTRACT_CONTACT_INFO_FLOW_NODE_TEMPLATES',
  SeedMetaAdsFlowBlockTemplates = 'SEED_META_ADS_FLOW_BLOCK_TEMPLATES',
  SeedMetaAdsFlowNodeTemplates = 'SEED_META_ADS_FLOW_NODE_TEMPLATES',
  SeedMetaAdsReportMetricTemplates = 'SEED_META_ADS_REPORT_METRIC_TEMPLATES',
  SeedMetaAdsReportWidgetTemplates = 'SEED_META_ADS_REPORT_WIDGET_TEMPLATES',
  SetNotVerifiedEmailForAllCustomerPersons = 'SET_NOT_VERIFIED_EMAIL_FOR_ALL_CUSTOMER_PERSONS',
  StandardizeLiveChat = 'STANDARDIZE_LIVE_CHAT',
  UpdateAiPrompt = 'UPDATE_AI_PROMPT',
  UpdateChatsLiveChatId = 'UPDATE_CHATS_LIVE_CHAT_ID',
  UpdateChatUniquekey = 'UPDATE_CHAT_UNIQUEKEY',
  UpdateEmailIfClientEmail = 'UPDATE_EMAIL_IF_CLIENT_EMAIL',
  UpdateInstagramPersons = 'UPDATE_INSTAGRAM_PERSONS',
  UpdateInstagramQnaPersons = 'UPDATE_INSTAGRAM_QNA_PERSONS',
  UpdateManyFields = 'UPDATE_MANY_FIELDS',
  UpdateMessageAck = 'UPDATE_MESSAGE_ACK',
  UpdateOldPersonManuelGroups = 'UPDATE_OLD_PERSON_MANUEL_GROUPS',
  UpdateWhatsappWebForGroups = 'UPDATE_WHATSAPP_WEB_FOR_GROUPS'
}

export type PaginateSurvey = {
  __typename?: 'paginateSurvey';
  docs?: Maybe<Array<Maybe<Survey>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type QuickAnswerPaginateResult = {
  __typename?: 'quickAnswerPaginateResult';
  docs?: Maybe<Array<Maybe<QuickAnswer>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  totalDocs?: Maybe<Scalars['Int']['output']>;
};

export type RemoveCustomerPaymentCardInput = {
  customerId: Scalars['ID']['input'];
  id: Scalars['String']['input'];
};

export type SendAutoSurveyInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  closingMessage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId?: InputMaybe<Scalars['String']['input']>;
  tagRule?: InputMaybe<SurveyTagRuleEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  time?: InputMaybe<Scalars['Int']['input']>;
};

export type SendAutoSurveyType = {
  __typename?: 'sendAutoSurveyType';
  channels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  closingMessage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  surveyId?: Maybe<Scalars['String']['output']>;
  tagRule?: Maybe<SurveyTagRuleEnum>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  time?: Maybe<Scalars['Int']['output']>;
};

export type SendCampaignStatusType = {
  __typename?: 'sendCampaignStatusType';
  _id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CampaignStatusEnum>;
};

export type SenderData = {
  __typename?: 'senderData';
  _id?: Maybe<Scalars['ID']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  eCommerceProfileId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<Maybe<PPlatformsType>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type StatisticsResponse = {
  __typename?: 'statisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: ConvStatisticRes;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum StatusCampaignEnum {
  Draft = 'DRAFT',
  Stopped = 'STOPPED'
}

export type StatusesType = {
  __typename?: 'statusesType';
  ANSWERED?: Maybe<Scalars['Int']['output']>;
  DELETED?: Maybe<Scalars['Int']['output']>;
  DELIVERED?: Maybe<Scalars['Int']['output']>;
  FAILED?: Maybe<Scalars['Int']['output']>;
  PLATFORM_CONNECTION_ERROR?: Maybe<Scalars['Int']['output']>;
  READ?: Maybe<Scalars['Int']['output']>;
  SENDING?: Maybe<Scalars['Int']['output']>;
  SENT?: Maybe<Scalars['Int']['output']>;
  UNREAD?: Maybe<Scalars['Int']['output']>;
};

export type SurveyDataForLivechat = {
  __typename?: 'surveyDataForLivechat';
  comment?: Maybe<Scalars['String']['output']>;
  commentInputTitle?: Maybe<Scalars['String']['output']>;
  isRated?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  submitButtonText?: Maybe<Scalars['String']['output']>;
  surveyId?: Maybe<Scalars['String']['output']>;
  thanksMessage?: Maybe<Scalars['String']['output']>;
  themeMainColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum SurveyTagRuleEnum {
  Included = 'INCLUDED',
  NotIncluded = 'NOT_INCLUDED'
}

export type TempSubsData = {
  customer: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type Template = {
  appId: Scalars['String']['input'];
  buttons?: InputMaybe<Array<InputMaybe<ButtonType>>>;
  category: CategoryTypes;
  customer: Scalars['ID']['input'];
  eCommerceCart?: InputMaybe<Scalars['Boolean']['input']>;
  example?: InputMaybe<Scalars['String']['input']>;
  exampleMedia?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  qpienFields?: InputMaybe<Array<InputMaybe<QpienFields>>>;
  sampleMedia?: InputMaybe<Scalars['Media']['input']>;
  survey?: InputMaybe<Scalars['String']['input']>;
  templateType: TemplateTypes;
  vertical: Scalars['String']['input'];
};

export type TemplateId = {
  customerId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateTypes {
  Carousel = 'CAROUSEL',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  OneTimeCode = 'ONE_TIME_CODE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type TicketPriorityStatisticRes = {
  __typename?: 'ticketPriorityStatisticRes';
  highPriority?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  lowPriority?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  normalPriority?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  urgentPriority?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
};

export type TicketPriorityStatisticsResponse = {
  __typename?: 'ticketPriorityStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TicketPriorityStatisticRes;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketStateStatisticRes = {
  __typename?: 'ticketStateStatisticRes';
  count?: Maybe<Scalars['Number']['output']>;
  ticketState?: Maybe<TicketState>;
};

export type TicketStateStatisticsResponse = {
  __typename?: 'ticketStateStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<TicketStateStatisticRes>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketStatisticRes = {
  __typename?: 'ticketStatisticRes';
  assignNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  avgFirstResponseTime?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  avgResolutionTime?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  closeNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  closedTicketState?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  openAndReOpen?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  openNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  openTicketState?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  pendingTicketState?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  reOpenNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  resolvedNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  totalClose?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  totalReOpen?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
  transferredNumber?: Maybe<Array<Maybe<GetSingleStatisticRes>>>;
};

export type TicketStatisticsResponse = {
  __typename?: 'ticketStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TicketStatisticRes;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketTypeStatisticRes = {
  __typename?: 'ticketTypeStatisticRes';
  count?: Maybe<Scalars['Number']['output']>;
  ticketType?: Maybe<TicketType>;
};

export type TicketTypeStatisticsResponse = {
  __typename?: 'ticketTypeStatisticsResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: Array<TicketTypeStatisticRes>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TranslateMessageTextResponse = {
  __typename?: 'translateMessageTextResponse';
  code?: Maybe<Scalars['String']['output']>;
  data: TranslateTextRes;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TranslateTextRes = {
  __typename?: 'translateTextRes';
  language?: Maybe<LanguageData>;
  text?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  userLang?: Maybe<Scalars['String']['output']>;
};

export type UnSubscribeNotificationInput = {
  cPersonId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemplateFields = {
  _id?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  qpienFields?: InputMaybe<Array<InputMaybe<QpienFields>>>;
};

export type UploadMediasType = {
  customerId: Scalars['ID']['input'];
  folderInfo: Array<InputMaybe<IncomingFolder>>;
  qpienPersonGroups: Array<InputMaybe<Scalars['String']['input']>>;
  telegramChannels: Array<InputMaybe<Scalars['String']['input']>>;
  telegramSendFileNames: Scalars['Boolean']['input'];
  telegramSendFolderNames: Scalars['Boolean']['input'];
  whatsAppGroups: Array<InputMaybe<Scalars['String']['input']>>;
  whatsAppSendFileNames: Scalars['Boolean']['input'];
  whatsAppSendFolderNames: Scalars['Boolean']['input'];
};

export type UrlData = {
  __typename?: 'urlData';
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<OImageType>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  ogType?: Maybe<Scalars['String']['output']>;
  ogUrl?: Maybe<Scalars['String']['output']>;
  ogVideo?: Maybe<OVideoType>;
  requestUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UrlResponse = {
  __typename?: 'urlResponse';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<UrlData>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAddOnInput = {
  customerId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  userAddOnId: Scalars['ID']['input'];
};

export type VerifyEmailInput = {
  code: Scalars['String']['input'];
  deviceType?: InputMaybe<CustomerPersonDeviceType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AddCouponCodeToCustomerMutationVariables = Exact<{
  data: AddCouponCodeToCustomerInput;
}>;


export type AddCouponCodeToCustomerMutation = { __typename?: 'Mutation', addCouponCodeToCustomer: { __typename?: 'CustomerProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } } };

export type AdminSignInMutationVariables = Exact<{
  data: SignInAdminInput;
}>;


export type AdminSignInMutation = { __typename?: 'Mutation', adminSignIn: { __typename?: 'UserTokenResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'UserTokenData', token: string, user: { __typename?: 'User', _id?: string | null, name?: string | null, surname?: string | null, role?: RoleTypes | null, phone?: string | null, email?: string | null, createdAt?: any | null } } | null } };

export type ArchiveAnnouncementMutationVariables = Exact<{
  input: PublishChangelogInput;
}>;


export type ArchiveAnnouncementMutation = { __typename?: 'Mutation', archiveAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type CancelHumanReplyLearningJobMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
}>;


export type CancelHumanReplyLearningJobMutation = { __typename?: 'Mutation', cancelHumanReplyLearningJob: { __typename?: 'HumanReplyLearningJobResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'HumanReplyLearningJob', jobId: string, customerId: string, status: HumanReplyLearningJobStatus, mode: string, totalConversations: number, processedConversations: number, skippedConversations: number, failedConversations: number, remainingConversations: number, progressPercent: number, extractedPairs: number, savedPairs: number, duplicatePairs: number, resolvedConflictPairs: number, totalInputTokens: number, totalOutputTokens: number, totalEstimatedCost: number, modelsUsed: Array<string>, currentConversationId?: string | null, rateLimitedAt?: string | null, rateLimitResumeAt?: string | null, rateLimitRetryCount?: number | null, createdAt: string, startedAt?: string | null, finishedAt?: string | null, cancelRequestedAt?: string | null, cancelledAt?: string | null, countedAt?: string | null, updatedAt: string, usageByModel: Array<{ __typename?: 'HumanReplyLearningModelUsage', model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, costBreakdown: Array<{ __typename?: 'HumanReplyLearningCostBreakdown', stage: string, model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, failures?: Array<{ __typename?: 'HumanReplyLearningFailure', customerId?: string | null, conversationId?: string | null, reason?: string | null }> | null, resolvedConflicts?: Array<{ __typename?: 'HumanReplyLearningResolvedConflict', conversationId: string, existingAiKnowledgeSourceContentId: string, newQuestion: string, newAnswer: string, existingQuestion: string, existingAnswer: string, reason: string }> | null } | null } };

export type CancelSpecialOfferPackageMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type CancelSpecialOfferPackageMutation = { __typename?: 'Mutation', cancelSpecialOfferPackage: { __typename?: 'ProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Product', _id?: string | null, name?: string | null, monthlyPrice?: any | null, yearlyPrice?: any | null, createdAt?: any | null, limits?: { __typename?: 'ProductLimitsType', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, amazon?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, liveChat?: number | null, customChannel?: number | null, message?: string | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, features?: { __typename?: 'ProductFeatureType', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null } } };

export type ChangeAccountStatusMutationVariables = Exact<{
  data: ChangeAccountStatusInput;
}>;


export type ChangeAccountStatusMutation = { __typename?: 'Mutation', changeAccountStatus: { __typename?: 'CustomerResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Customer', _id?: string | null, phone?: string | null, companyName?: string | null, email?: string | null, category?: string | null, autoConversationAssignment?: boolean | null, autoAssignmentType?: AutoAssignmentTypeEnum | null, autoConversationAssignmentTime?: number | null, autoConversationAssignmentTimeUnit?: string | null, photo?: string | null, createdAt?: any | null, customerFromChannel?: string | null, country?: string | null, timeZone?: string | null, currency?: string | null, isANewCustomer?: boolean | null, isDummy?: boolean | null, accountStatus?: string | null, accountConfirmation?: string | null, appStatus?: string | null, language?: Language | null, allowConnect?: boolean | null, is2FARequired?: boolean | null, teamGoalTime?: number | null, teamOnlineGoalTime?: number | null, teamFirstResponseGoalTime?: number | null, cPersonsAutoAwayTime?: number | null, autoApproveSharingRequests?: boolean | null, canManageOtherUserConversation?: boolean | null, allowUnassignedTicket?: boolean | null, partnerCode?: string | null, signUpMethod?: SignUpMethod | null, package?: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } | null, sendAutoSurvey?: { __typename?: 'sendAutoSurveyType', status?: boolean | null, time?: number | null, closingMessage?: string | null, surveyId?: string | null, channels?: Array<string | null> | null, tagRule?: SurveyTagRuleEnum | null, tags?: Array<string | null> | null } | null, closingNote?: { __typename?: 'ClosingNoteDetail', isEnabled?: boolean | null, autoFillWithAi?: boolean | null, isCompletionRequired?: boolean | null, customFields: Array<{ __typename?: 'CustomField', _id?: string | null, name?: string | null, label?: string | null, description?: string | null, type?: string | null, listValues?: Array<string | null> | null, visibleToCustomers?: EnumCustomFieldCustomerVisibility | null, visibleToUsers?: EnumCustomFieldUserVisibility | null, status?: EnumCustomFieldStatus | null, isDefault?: boolean | null, customer?: string | null, createdAt?: any | null, updatedAt?: any | null, mediaType?: EnumCustomFieldMediaType | null, conditions?: Array<{ __typename?: 'CustomFieldCondition', parentField: string, parentValues: Array<string> } | null> | null }> } | null, twSubAccount?: { __typename?: 'TwSubAccount', sid?: string | null, token?: string | null, apiKeySid?: string | null, apiKeySecret?: string | null } | null, onboarding?: { __typename?: 'CustomerOnboarding', channelConnected?: boolean | null, teamInvited?: boolean | null, accountCustomized?: boolean | null, aiAgentTrained?: boolean | null, mobileAppDownloaded?: boolean | null, introVideoWatched?: boolean | null, completedCount?: number | null, totalCount?: number | null, isVisible?: boolean | null } | null } } };

export type ChangeCustomerProductMutationVariables = Exact<{
  data: ChangeCustomerProductInput;
}>;


export type ChangeCustomerProductMutation = { __typename?: 'Mutation', changeCustomerProduct: { __typename?: 'CustomerProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } } };

export type CreateAnnouncementMutationVariables = Exact<{
  input: CreateChangelogInput;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type CreateAnnouncementCategoryMutationVariables = Exact<{
  input: CreateChangelogCategoryInput;
}>;


export type CreateAnnouncementCategoryMutation = { __typename?: 'Mutation', createAnnouncementCategory?: { __typename?: 'ChangelogCategoryResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CreateCollageTemplateSetMutationVariables = Exact<{
  input: CreateCollageTemplateSetInput;
}>;


export type CreateCollageTemplateSetMutation = { __typename?: 'Mutation', createCollageTemplateSet: { __typename?: 'CreateCollageTemplateSetResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CreateCollageTemplateSetData', folder: { __typename?: 'CollageFolder', _id: string, customer: string, parentFolder?: string | null, name?: string | null, visibleTo?: VisibleTo | null, selectedCPersons?: Array<string | null> | null, createdAt?: any | null, updatedAt?: any | null }, templates: Array<{ __typename?: 'CollageTemplate', _id: string, customer: string, name?: string | null, isDefault?: boolean | null, frame?: FrameRatio | null, collage?: TemplateLayout | null, header?: TemplateHeader | null, footer?: TemplateFooter | null, backgroundColor?: string | null, textColor?: string | null, mainColor?: string | null, secondaryColor?: string | null, priceTextColor?: string | null, discountLabel?: string | null, discountStyle?: TemplateDiscountStyle | null, footerFontWeight?: TemplateFooterFontWeight | null, footerPriceSizeDelta?: number | null, footerCodeSizeDelta?: number | null, productDataSource?: ProductDataSource | null, visibleTo?: VisibleTo | null, selectedCPersons?: Array<string | null> | null, createdAt?: any | null, updatedAt?: any | null, mainLogo?: { __typename?: 'ImageMedia', name?: string | null, type?: string | null, path?: string | null } | null, secondaryLogo?: { __typename?: 'ImageMedia', name?: string | null, type?: string | null, path?: string | null } | null, coverImage?: { __typename?: 'ImageMedia', name?: string | null, type?: string | null, path?: string | null } | null } | null> } } };

export type CreateCouponCodeMutationVariables = Exact<{
  data: CreateCouponCodeInput;
}>;


export type CreateCouponCodeMutation = { __typename?: 'Mutation', createCouponCode: { __typename?: 'OCouponCodeResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } };

export type CreateCustomerBillingAddressesMutationVariables = Exact<{
  data: CustomerBillingAddressesInput;
}>;


export type CreateCustomerBillingAddressesMutation = { __typename?: 'Mutation', createCustomerBillingAddresses: { __typename?: 'CustomerBillingAddressesOutput', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CustomerBillingAddresses', _id: string, customer: string, accountingContactId?: string | null, country?: string | null, state?: string | null, city?: string | null, province?: string | null, postCode?: string | null, address1?: string | null, address2?: string | null, isCompany?: boolean | null, legalCompanyName?: string | null, taxOffice?: string | null, taxNumber?: string | null } | null } };

export type CreateRandomMessageMutationVariables = Exact<{
  data?: InputMaybe<CreateRandomMessageInput>;
}>;


export type CreateRandomMessageMutation = { __typename?: 'Mutation', createRandomMessage: { __typename?: 'OCustomerPersonStringResponse', success?: boolean | null, data?: string | null, code?: string | null, message?: string | null } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'User', _id?: string | null, name?: string | null, surname?: string | null, role?: RoleTypes | null, phone?: string | null, email?: string | null, createdAt?: any | null } } };

export type DeleteAiHelpArticleMutationVariables = Exact<{
  data: AiHelpArticleInput;
}>;


export type DeleteAiHelpArticleMutation = { __typename?: 'Mutation', deleteAiHelpArticle: { __typename?: 'AiHelpDeleteResponse', success?: boolean | null, data?: boolean | null, code?: string | null, message?: string | null } };

export type DeleteAiMessagesByDateRangeMutationVariables = Exact<{
  data: DeleteByDateRangeParams;
}>;


export type DeleteAiMessagesByDateRangeMutation = { __typename?: 'Mutation', deleteAiMessagesByDateRange: { __typename?: 'DeleteResultResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'DeleteResult', deletedCount: number, deletedSteps: number } } };

export type DeleteAnnouncementMutationVariables = Exact<{
  input: DeleteChangelogInput;
}>;


export type DeleteAnnouncementMutation = { __typename?: 'Mutation', deleteAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type DeleteAnnouncementCategoryMutationVariables = Exact<{
  input: DeleteChangelogCategoryInput;
}>;


export type DeleteAnnouncementCategoryMutation = { __typename?: 'Mutation', deleteAnnouncementCategory?: { __typename?: 'ChangelogCategoryResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type DeleteCallAdminLogsMutationVariables = Exact<{
  params: DeleteCallAdminLogsInput;
}>;


export type DeleteCallAdminLogsMutation = { __typename?: 'Mutation', deleteCallAdminLogs: { __typename?: 'DeleteCallAdminLogsResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'DeleteCallAdminLogsData', deletedCount: number } | null } };

export type DeleteCouponCodeMutationVariables = Exact<{
  data: DeleteCouponCodeInput;
}>;


export type DeleteCouponCodeMutation = { __typename?: 'Mutation', deleteCouponCode: { __typename?: 'OCouponCodeResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } };

export type DeleteCustomerMutationVariables = Exact<{
  data: DeleteCustomerInput;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: { __typename?: 'DeletedCustomerResponse', success?: boolean | null, data: boolean, code?: string | null, message?: string | null } };

export type DeleteCustomerPersonMutationVariables = Exact<{
  input: DeleteCustomerPersonInput;
}>;


export type DeleteCustomerPersonMutation = { __typename?: 'Mutation', deleteCustomerPerson: { __typename?: 'CustomerPersonResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerPerson', _id: string, customer: string, type: CustomerType, status: CPersonStatus, firstName: string, lastName: string, profilePhoto?: string | null, isEmailVerified: boolean, email: string, phone?: string | null, language?: Language | null, timeZone?: string | null, dateFormat?: CustomerDateFormat | null, joinedConvLimit?: number | null, joinedConvCount?: number | null, signedTeams?: any | null, isAcceptingCalls?: boolean | null, canAccessPhoneCalls?: boolean | null, isInCall?: boolean | null, is2FAEnabled?: boolean | null, hasPassword?: boolean | null, archivedAt?: any | null, hasAiAssistant?: boolean | null, devices?: Array<{ __typename?: 'CustomerPersonDevice', type?: CustomerPersonDeviceType | null, status?: CustomerPersonDeviceStatus | null, lastLoginTime?: any | null, statusAwayTime?: any | null } | null> | null, notificationSettings?: { __typename?: 'NotificationSettings', conversationSound?: string | null, messageSound?: string | null, notificationSoundVolume?: number | null, notificationCardEnabled?: boolean | null, mobilePushNotifications?: MobilePushNotificationsEnum | null, newUnassignedConversation?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newConversationAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInConversationsAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInUnassignedConversations?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskReminder?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTableRecordAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newCommentInAssignedTableRecord?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newPrivateChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTeamChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importRecordsToTable?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportTableRecords?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, noteMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskCommentMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, trackingDomainVerified?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportReport?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, qpienAnnouncements?: { __typename?: 'QpienAnnouncementNotificationType', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, whatsapp?: boolean | null } | null } | null, productTour?: { __typename?: 'ProductTour', mainCompletedAt?: any | null, mainSkippedAt?: any | null, boardsCompletedAt?: any | null, welcomeVideoWatchedAt?: any | null, modules?: Array<string> | null } | null } } };

export type DeleteEmailAdminLogsMutationVariables = Exact<{
  params: DeleteEmailAdminLogsInput;
}>;


export type DeleteEmailAdminLogsMutation = { __typename?: 'Mutation', deleteEmailAdminLogs: { __typename?: 'DeleteEmailAdminLogsResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'DeleteEmailAdminLogsData', deletedCount: number } | null } };

export type DeletePlatformMutationVariables = Exact<{
  type: PlatformType;
  metaData: DeletePlatformTypeInput;
}>;


export type DeletePlatformMutation = { __typename?: 'Mutation', deletePlatform: { __typename?: 'OPlatformResponse', success?: boolean | null, data?: any | null, code?: string | null, message?: string | null } };

export type DeleteTestConversationMutationVariables = Exact<{
  data?: InputMaybe<DeleteTestConversationInput>;
}>;


export type DeleteTestConversationMutation = { __typename?: 'Mutation', deleteTestConversation: { __typename?: 'DeleteTestConversationResponse', success?: boolean | null, data?: boolean | null, code?: string | null, message?: string | null } };

export type DeleteUserMutationVariables = Exact<{
  data: DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'UserResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'User', _id?: string | null, name?: string | null, surname?: string | null, role?: RoleTypes | null, phone?: string | null, email?: string | null, createdAt?: any | null } } };

export type DisableAiEngineMutationVariables = Exact<{
  data: AiEngineVersionInput;
}>;


export type DisableAiEngineMutation = { __typename?: 'Mutation', disableAiEngine: { __typename?: 'AiEngineRoutingResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiEngineRoutingOverview', capabilities: Array<string>, engines: Array<{ __typename?: 'AiEngineSummary', version: string, capabilities: Array<string>, frozen: boolean }>, routing: { __typename?: 'AiEngineRouting', updatedBy: string, updatedAt: string, defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }>, history: Array<{ __typename?: 'AiEngineRoutingHistoryEntry', index: number, at: string, by: string, reason: string, snapshot: { __typename?: 'AiEngineRoutingSnapshot', defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }> } }> } } | null } };

export type EnableAiEngineMutationVariables = Exact<{
  data: AiEngineVersionInput;
}>;


export type EnableAiEngineMutation = { __typename?: 'Mutation', enableAiEngine: { __typename?: 'AiEngineRoutingResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiEngineRoutingOverview', capabilities: Array<string>, engines: Array<{ __typename?: 'AiEngineSummary', version: string, capabilities: Array<string>, frozen: boolean }>, routing: { __typename?: 'AiEngineRouting', updatedBy: string, updatedAt: string, defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }>, history: Array<{ __typename?: 'AiEngineRoutingHistoryEntry', index: number, at: string, by: string, reason: string, snapshot: { __typename?: 'AiEngineRoutingSnapshot', defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }> } }> } } | null } };

export type GetCustomerSessionByAdminMutationVariables = Exact<{
  data?: InputMaybe<CustomerSessionInput>;
}>;


export type GetCustomerSessionByAdminMutation = { __typename?: 'Mutation', getCustomerSessionByAdmin?: { __typename?: 'getCustomerSessionResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerPersonTokenForAdmin', token: string, cPerson: { __typename?: 'CustomerPerson', _id: string, customer: string, type: CustomerType, status: CPersonStatus, firstName: string, lastName: string, profilePhoto?: string | null, isEmailVerified: boolean, email: string, phone?: string | null, language?: Language | null, timeZone?: string | null, dateFormat?: CustomerDateFormat | null, joinedConvLimit?: number | null, joinedConvCount?: number | null, signedTeams?: any | null, isAcceptingCalls?: boolean | null, canAccessPhoneCalls?: boolean | null, isInCall?: boolean | null, is2FAEnabled?: boolean | null, hasPassword?: boolean | null, archivedAt?: any | null, hasAiAssistant?: boolean | null, devices?: Array<{ __typename?: 'CustomerPersonDevice', type?: CustomerPersonDeviceType | null, status?: CustomerPersonDeviceStatus | null, lastLoginTime?: any | null, statusAwayTime?: any | null } | null> | null, notificationSettings?: { __typename?: 'NotificationSettings', conversationSound?: string | null, messageSound?: string | null, notificationSoundVolume?: number | null, notificationCardEnabled?: boolean | null, mobilePushNotifications?: MobilePushNotificationsEnum | null, newUnassignedConversation?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newConversationAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInConversationsAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInUnassignedConversations?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskReminder?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTableRecordAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newCommentInAssignedTableRecord?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newPrivateChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTeamChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importRecordsToTable?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportTableRecords?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, noteMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskCommentMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, trackingDomainVerified?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportReport?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, qpienAnnouncements?: { __typename?: 'QpienAnnouncementNotificationType', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, whatsapp?: boolean | null } | null } | null, productTour?: { __typename?: 'ProductTour', mainCompletedAt?: any | null, mainSkippedAt?: any | null, boardsCompletedAt?: any | null, welcomeVideoWatchedAt?: any | null, modules?: Array<string> | null } | null } } } | null };

export type ImportAiHelpPdfMutationVariables = Exact<{
  data: AiHelpImportPdfInput;
}>;


export type ImportAiHelpPdfMutation = { __typename?: 'Mutation', importAiHelpPdf: { __typename?: 'AiHelpArticleResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiHelpArticle', _id: string, slug: string, title: string, category?: string | null, summary?: string | null, related?: string | null, author?: string | null, sourceDate?: string | null, source: string, fileName?: string | null, panelPath?: string | null, permissions?: Array<string> | null, language: string, status: string, chunkCount: number, indexedAt?: string | null, error?: string | null, useCount?: number | null, lastUsedAt?: string | null, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'AiHelpSection', key: string, heading: string, text: string, images: Array<{ __typename?: 'AiHelpImage', key: string, url: string, caption?: string | null, description?: string | null }> }>, faqs: Array<{ __typename?: 'AiHelpFaq', question: string, answer: string }> } | null } };

export type InvalidateLiveChatWidgetCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type InvalidateLiveChatWidgetCacheMutation = { __typename?: 'Mutation', invalidateLiveChatWidgetCache?: { __typename?: 'LiveChatWidgetInvalidationResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'LiveChatWidgetInvalidation', id?: string | null, status?: string | null, createTime?: any | null } | null } | null };

export type OneTimesUpdateMutationMutationVariables = Exact<{
  type: OneTimesType;
  metaData: Scalars['Object']['input'];
}>;


export type OneTimesUpdateMutationMutation = { __typename?: 'Mutation', oneTimesUpdateMutation?: { __typename?: 'OPlatformResponse', success?: boolean | null, data?: any | null, code?: string | null, message?: string | null } | null };

export type PinAiEngineMutationVariables = Exact<{
  data: AiEnginePinInput;
}>;


export type PinAiEngineMutation = { __typename?: 'Mutation', pinAiEngine: { __typename?: 'AiEngineRoutingResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiEngineRoutingOverview', capabilities: Array<string>, engines: Array<{ __typename?: 'AiEngineSummary', version: string, capabilities: Array<string>, frozen: boolean }>, routing: { __typename?: 'AiEngineRouting', updatedBy: string, updatedAt: string, defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }>, history: Array<{ __typename?: 'AiEngineRoutingHistoryEntry', index: number, at: string, by: string, reason: string, snapshot: { __typename?: 'AiEngineRoutingSnapshot', defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }> } }> } } | null } };

export type PublishAnnouncementMutationVariables = Exact<{
  input: PublishChangelogInput;
}>;


export type PublishAnnouncementMutation = { __typename?: 'Mutation', publishAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type PublishLiveChatWidgetReleaseMutationVariables = Exact<{
  input: PublishLiveChatWidgetReleaseInput;
}>;


export type PublishLiveChatWidgetReleaseMutation = { __typename?: 'Mutation', publishLiveChatWidgetRelease?: { __typename?: 'LiveChatWidgetReleaseResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'LiveChatWidgetRelease', _id?: string | null, version?: string | null, note?: string | null, status?: LiveChatWidgetReleaseStatus | null, source?: LiveChatWidgetReleaseSource | null, restoredFrom?: string | null, bucket?: string | null, prefix?: string | null, archivePrefix?: string | null, distributionId?: string | null, cdnUrl?: string | null, removedKeys?: Array<string | null> | null, invalidationId?: string | null, invalidationStatus?: string | null, healthCheckUrl?: string | null, healthCheckStatus?: number | null, errorMessage?: string | null, publishedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, files?: Array<{ __typename?: 'LiveChatWidgetFile', path?: string | null, size?: number | null, contentType?: string | null } | null> | null } | null } | null };

export type ReindexAiHelpArticleMutationVariables = Exact<{
  data: AiHelpArticleInput;
}>;


export type ReindexAiHelpArticleMutation = { __typename?: 'Mutation', reindexAiHelpArticle: { __typename?: 'AiHelpArticleResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiHelpArticle', _id: string, slug: string, title: string, category?: string | null, summary?: string | null, related?: string | null, author?: string | null, sourceDate?: string | null, source: string, fileName?: string | null, panelPath?: string | null, permissions?: Array<string> | null, language: string, status: string, chunkCount: number, indexedAt?: string | null, error?: string | null, useCount?: number | null, lastUsedAt?: string | null, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'AiHelpSection', key: string, heading: string, text: string, images: Array<{ __typename?: 'AiHelpImage', key: string, url: string, caption?: string | null, description?: string | null }> }>, faqs: Array<{ __typename?: 'AiHelpFaq', question: string, answer: string }> } | null } };

export type RemoveCouponCodeFromCustomerMutationVariables = Exact<{
  data: RemoveCouponCodeFromCustomerInput;
}>;


export type RemoveCouponCodeFromCustomerMutation = { __typename?: 'Mutation', removeCouponCodeFromCustomer: { __typename?: 'CustomerProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } } };

export type RemoveCustomerPaymentCardMutationVariables = Exact<{
  input: RemoveCustomerPaymentCardInput;
}>;


export type RemoveCustomerPaymentCardMutation = { __typename?: 'Mutation', removeCustomerPaymentCard: { __typename?: 'CustomerPaymentCardOutput', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CustomerPaymentCard', _id?: string | null, customer?: string | null, provider?: string | null, requiresAction?: boolean | null, confirmationUrl?: string | null, threeDSHtmlContent?: string | null, threeDSPaymentPageUrl?: string | null, threeDSPaymentId?: string | null, threeDSConversationId?: string | null, actionType?: string | null, createdAt?: any | null, updatedAt?: any | null, cards?: Array<{ __typename?: 'PaymentCardInfo', _id?: string | null, cardAlias?: string | null, cardBankName?: string | null, lastFourDigits?: string | null, cardType?: string | null, cardAssociation?: string | null, expireMonth?: string | null, expireYear?: string | null, cvc?: string | null, locale?: string | null, status?: string | null, default?: boolean | null, systemTime?: any | null } | null> | null } | null } };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: { __typename?: 'EmailResponse', success?: boolean | null, data: string, code?: string | null, message?: string | null } };

export type ResolveAiHelpGapsMutationVariables = Exact<{
  data: AiHelpResolveGapsInput;
}>;


export type ResolveAiHelpGapsMutation = { __typename?: 'Mutation', resolveAiHelpGaps: { __typename?: 'AiHelpResolveGapsResponse', success?: boolean | null, data?: number | null, code?: string | null, message?: string | null } };

export type RetryPaymentMutationVariables = Exact<{
  input: RetryPaymentInput;
}>;


export type RetryPaymentMutation = { __typename?: 'Mutation', retryPayment: { __typename?: 'CustomerProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } } };

export type RollbackAiEngineRoutingMutationVariables = Exact<{
  data: AiEngineRollbackInput;
}>;


export type RollbackAiEngineRoutingMutation = { __typename?: 'Mutation', rollbackAiEngineRouting: { __typename?: 'AiEngineRoutingResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiEngineRoutingOverview', capabilities: Array<string>, engines: Array<{ __typename?: 'AiEngineSummary', version: string, capabilities: Array<string>, frozen: boolean }>, routing: { __typename?: 'AiEngineRouting', updatedBy: string, updatedAt: string, defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }>, history: Array<{ __typename?: 'AiEngineRoutingHistoryEntry', index: number, at: string, by: string, reason: string, snapshot: { __typename?: 'AiEngineRoutingSnapshot', defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }> } }> } } | null } };

export type RollbackLiveChatWidgetReleaseMutationVariables = Exact<{
  input: RollbackLiveChatWidgetReleaseInput;
}>;


export type RollbackLiveChatWidgetReleaseMutation = { __typename?: 'Mutation', rollbackLiveChatWidgetRelease?: { __typename?: 'LiveChatWidgetReleaseResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'LiveChatWidgetRelease', _id?: string | null, version?: string | null, note?: string | null, status?: LiveChatWidgetReleaseStatus | null, source?: LiveChatWidgetReleaseSource | null, restoredFrom?: string | null, bucket?: string | null, prefix?: string | null, archivePrefix?: string | null, distributionId?: string | null, cdnUrl?: string | null, removedKeys?: Array<string | null> | null, invalidationId?: string | null, invalidationStatus?: string | null, healthCheckUrl?: string | null, healthCheckStatus?: number | null, errorMessage?: string | null, publishedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, files?: Array<{ __typename?: 'LiveChatWidgetFile', path?: string | null, size?: number | null, contentType?: string | null } | null> | null } | null } | null };

export type SaveAiHelpArticleMutationVariables = Exact<{
  data: AiHelpSaveArticleInput;
}>;


export type SaveAiHelpArticleMutation = { __typename?: 'Mutation', saveAiHelpArticle: { __typename?: 'AiHelpArticleResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiHelpArticle', _id: string, slug: string, title: string, category?: string | null, summary?: string | null, related?: string | null, author?: string | null, sourceDate?: string | null, source: string, fileName?: string | null, panelPath?: string | null, permissions?: Array<string> | null, language: string, status: string, chunkCount: number, indexedAt?: string | null, error?: string | null, useCount?: number | null, lastUsedAt?: string | null, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'AiHelpSection', key: string, heading: string, text: string, images: Array<{ __typename?: 'AiHelpImage', key: string, url: string, caption?: string | null, description?: string | null }> }>, faqs: Array<{ __typename?: 'AiHelpFaq', question: string, answer: string }> } | null } };

export type ScheduleAnnouncementMutationVariables = Exact<{
  input: ScheduleChangelogInput;
}>;


export type ScheduleAnnouncementMutation = { __typename?: 'Mutation', scheduleAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type SendSpecialOfferPackageMutationVariables = Exact<{
  data: SpecialOfferPackageInput;
}>;


export type SendSpecialOfferPackageMutation = { __typename?: 'Mutation', sendSpecialOfferPackage: { __typename?: 'ProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Product', _id?: string | null, name?: string | null, monthlyPrice?: any | null, yearlyPrice?: any | null, createdAt?: any | null, limits?: { __typename?: 'ProductLimitsType', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, amazon?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, liveChat?: number | null, customChannel?: number | null, message?: string | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, features?: { __typename?: 'ProductFeatureType', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null } } };

export type SetAiEngineDefaultMutationVariables = Exact<{
  data: AiEngineDefaultInput;
}>;


export type SetAiEngineDefaultMutation = { __typename?: 'Mutation', setAiEngineDefault: { __typename?: 'AiEngineRoutingResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiEngineRoutingOverview', capabilities: Array<string>, engines: Array<{ __typename?: 'AiEngineSummary', version: string, capabilities: Array<string>, frozen: boolean }>, routing: { __typename?: 'AiEngineRouting', updatedBy: string, updatedAt: string, defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }>, history: Array<{ __typename?: 'AiEngineRoutingHistoryEntry', index: number, at: string, by: string, reason: string, snapshot: { __typename?: 'AiEngineRoutingSnapshot', defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }> } }> } } | null } };

export type SetUpdateNotificationMutationVariables = Exact<{
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetUpdateNotificationMutation = { __typename?: 'Mutation', setUpdateNotification: { __typename?: 'UpdateNotificationResponse', success: boolean, code?: string | null, message?: string | null, data?: { __typename?: 'UpdateNotification', updatedAt: string, message?: string | null } | null } };

export type StartMigrationMutationVariables = Exact<{
  type: OneTimesType;
  probe?: InputMaybe<InspectCollectionInput>;
}>;


export type StartMigrationMutation = { __typename?: 'Mutation', startMigration: { __typename?: 'MigrationRunStartResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'MigrationRun', _id: string, type: string, status: MigrationRunStatus, succeeded?: boolean | null, startedAt: any, finishedAt?: any | null, durationMs?: number | null, heartbeatAt?: any | null, countsBefore?: string | null, countsAfter?: string | null, result?: string | null, error?: string | null } | null } };

export type StartReembedKnowledgeSourcesToContextualRagMutationVariables = Exact<{
  data: ReembedKnowledgeSourcesToContextualRagInput;
}>;


export type StartReembedKnowledgeSourcesToContextualRagMutation = { __typename?: 'Mutation', startReembedKnowledgeSourcesToContextualRag: { __typename?: 'ReembedKnowledgeSourcesToContextualRagJobResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'ReembedKnowledgeSourcesToContextualRagJob', jobId: string, status: ReembedKnowledgeSourcesJobStatus, allCustomers: boolean, targetCustomerIds?: Array<string> | null, totalCustomers: number, completedCustomers: number, failedCustomers: number, remainingCustomers: number, processedKnowledgeSources: number, processedContents: number, reembeddedContents: number, skippedContents: number, failedContents: number, currentCustomerId?: string | null, completedCustomerIds?: Array<string> | null, failedCustomerIds?: Array<string> | null, createdAt: string, startedAt?: string | null, finishedAt?: string | null, updatedAt: string, failures?: Array<{ __typename?: 'ReembedKnowledgeSourcesFailure', customerId?: string | null, aiKnowledgeSourceId?: string | null, aiKnowledgeSourceContentId?: string | null, reason?: string | null }> | null } | null } };

export type TestAiWithConversationMutationVariables = Exact<{
  data: TestAiWithConversationInput;
}>;


export type TestAiWithConversationMutation = { __typename?: 'Mutation', testAiWithConversation: { __typename?: 'TestAiWithConversationResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'AiAnswerData', conversationId?: string | null, personId?: string | null, aiPersonMemoryId?: string | null, aiProfileId?: string | null, aiMessageId?: string | null, aiRole?: AiRoleEnum | null, content?: string | null, summary?: string | null, tagIds?: Array<string | null> | null, noNeedInfoContent?: string | null, detailedMessage?: string | null, aiAction?: string | null, media?: Array<{ __typename?: 'AiAnswerMedia', path: string, type: string }> | null, commerceProductCards?: Array<{ __typename?: 'AiCommerceProductCard', productId: string, title: string, thumbnailUrl: string, optionsSummary?: string | null, productUrl?: string | null, price?: { __typename?: 'AiCommerceProductPrice', amount: string, currency: string } | null }> | null, actions?: { __typename?: 'AnswerActions', isPositive: boolean, isNegative: boolean, isHumanSupport: boolean } | null, responseExplanation?: { __typename?: 'AiTestResponseExplanation', code: string, stage?: string | null, detail?: string | null } | null, sideEffects?: Array<{ __typename?: 'AiSideEffect', kind: AiSideEffectKind, targetId?: string | null, targetName?: string | null, dryRun?: boolean | null }> | null, skillActions?: Array<{ __typename?: 'AiTestSkillAction', command: string, success: boolean, dryRun?: boolean | null, error?: string | null }> | null, privateReply?: { __typename?: 'AiPrivateReplyAnswer', content?: string | null, aiAction?: string | null, isOnlyReply?: boolean | null } | null, commerceApproval?: { __typename?: 'AiTestCommerceApproval', buttonId: string, title: string, content?: string | null } | null, commerceLinks?: Array<{ __typename?: 'AiTestCommerceLink', url: string, title: string }> | null, dryRunSkipped?: Array<{ __typename?: 'AiTestDryRunSkip', kind: AiTestDryRunSkipKind, name?: string | null }> | null } } };

export type TranslateAnnouncementMutationVariables = Exact<{
  input: TranslateChangelogInput;
}>;


export type TranslateAnnouncementMutation = { __typename?: 'Mutation', translateAnnouncement?: { __typename?: 'ChangelogTranslateResponse', success?: boolean | null, data?: any | null, error?: boolean | null, message?: string | null } | null };

export type UnarchiveAnnouncementMutationVariables = Exact<{
  input: PublishChangelogInput;
}>;


export type UnarchiveAnnouncementMutation = { __typename?: 'Mutation', unarchiveAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type UnpinAiEngineMutationVariables = Exact<{
  data: AiEngineUnpinInput;
}>;


export type UnpinAiEngineMutation = { __typename?: 'Mutation', unpinAiEngine: { __typename?: 'AiEngineRoutingResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiEngineRoutingOverview', capabilities: Array<string>, engines: Array<{ __typename?: 'AiEngineSummary', version: string, capabilities: Array<string>, frozen: boolean }>, routing: { __typename?: 'AiEngineRouting', updatedBy: string, updatedAt: string, defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }>, history: Array<{ __typename?: 'AiEngineRoutingHistoryEntry', index: number, at: string, by: string, reason: string, snapshot: { __typename?: 'AiEngineRoutingSnapshot', defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }> } }> } } | null } };

export type UnpublishAnnouncementMutationVariables = Exact<{
  input: PublishChangelogInput;
}>;


export type UnpublishAnnouncementMutation = { __typename?: 'Mutation', unpublishAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type UpdateAiHelpArticleMutationVariables = Exact<{
  data: AiHelpUpdateArticleInput;
}>;


export type UpdateAiHelpArticleMutation = { __typename?: 'Mutation', updateAiHelpArticle: { __typename?: 'AiHelpArticleResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiHelpArticle', _id: string, slug: string, title: string, category?: string | null, summary?: string | null, related?: string | null, author?: string | null, sourceDate?: string | null, source: string, fileName?: string | null, panelPath?: string | null, permissions?: Array<string> | null, language: string, status: string, chunkCount: number, indexedAt?: string | null, error?: string | null, useCount?: number | null, lastUsedAt?: string | null, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'AiHelpSection', key: string, heading: string, text: string, images: Array<{ __typename?: 'AiHelpImage', key: string, url: string, caption?: string | null, description?: string | null }> }>, faqs: Array<{ __typename?: 'AiHelpFaq', question: string, answer: string }> } | null } };

export type UpdateAnnouncementMutationVariables = Exact<{
  input: UpdateChangelogInput;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement?: { __typename?: 'ChangelogResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type UpdateAnnouncementCategoryMutationVariables = Exact<{
  input: UpdateChangelogCategoryInput;
}>;


export type UpdateAnnouncementCategoryMutation = { __typename?: 'Mutation', updateAnnouncementCategory?: { __typename?: 'ChangelogCategoryResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type UpdateAutoFormalizeInvoicesMutationVariables = Exact<{
  value: AutoFormalizeInvoicesPreference;
}>;


export type UpdateAutoFormalizeInvoicesMutation = { __typename?: 'Mutation', updateAutoFormalizeInvoices: { __typename?: 'PreferenceResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Preference', requireAccountApproval: boolean, autoFormalizeInvoices: AutoFormalizeInvoicesPreference } } };

export type UpdateChangelogSettingsMutationVariables = Exact<{
  input: UpdateChangelogSettingsInput;
}>;


export type UpdateChangelogSettingsMutation = { __typename?: 'Mutation', updateChangelogSettings?: { __typename?: 'ChangelogSettingsResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogSettings', _id?: string | null, defaultLanguage?: string | null, supportedLanguages?: Array<string | null> | null, defaultTimezone?: string | null, dateFormat?: string | null, senderEmail?: any | null, senderWhatsapp?: any | null, senderCustomerId?: string | null, recipientAudience?: string | null, includeInactiveCustomers?: boolean | null, includeArchivedPersons?: boolean | null, updatedAt?: any | null } | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  data: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'CustomerResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Customer', _id?: string | null, phone?: string | null, companyName?: string | null, email?: string | null, category?: string | null, autoConversationAssignment?: boolean | null, autoAssignmentType?: AutoAssignmentTypeEnum | null, autoConversationAssignmentTime?: number | null, autoConversationAssignmentTimeUnit?: string | null, photo?: string | null, createdAt?: any | null, customerFromChannel?: string | null, country?: string | null, timeZone?: string | null, currency?: string | null, isANewCustomer?: boolean | null, isDummy?: boolean | null, accountStatus?: string | null, accountConfirmation?: string | null, appStatus?: string | null, language?: Language | null, allowConnect?: boolean | null, is2FARequired?: boolean | null, teamGoalTime?: number | null, teamOnlineGoalTime?: number | null, teamFirstResponseGoalTime?: number | null, cPersonsAutoAwayTime?: number | null, autoApproveSharingRequests?: boolean | null, canManageOtherUserConversation?: boolean | null, allowUnassignedTicket?: boolean | null, partnerCode?: string | null, signUpMethod?: SignUpMethod | null, package?: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } | null, sendAutoSurvey?: { __typename?: 'sendAutoSurveyType', status?: boolean | null, time?: number | null, closingMessage?: string | null, surveyId?: string | null, channels?: Array<string | null> | null, tagRule?: SurveyTagRuleEnum | null, tags?: Array<string | null> | null } | null, closingNote?: { __typename?: 'ClosingNoteDetail', isEnabled?: boolean | null, autoFillWithAi?: boolean | null, isCompletionRequired?: boolean | null, customFields: Array<{ __typename?: 'CustomField', _id?: string | null, name?: string | null, label?: string | null, description?: string | null, type?: string | null, listValues?: Array<string | null> | null, visibleToCustomers?: EnumCustomFieldCustomerVisibility | null, visibleToUsers?: EnumCustomFieldUserVisibility | null, status?: EnumCustomFieldStatus | null, isDefault?: boolean | null, customer?: string | null, createdAt?: any | null, updatedAt?: any | null, mediaType?: EnumCustomFieldMediaType | null, conditions?: Array<{ __typename?: 'CustomFieldCondition', parentField: string, parentValues: Array<string> } | null> | null }> } | null, twSubAccount?: { __typename?: 'TwSubAccount', sid?: string | null, token?: string | null, apiKeySid?: string | null, apiKeySecret?: string | null } | null, onboarding?: { __typename?: 'CustomerOnboarding', channelConnected?: boolean | null, teamInvited?: boolean | null, accountCustomized?: boolean | null, aiAgentTrained?: boolean | null, mobileAppDownloaded?: boolean | null, introVideoWatched?: boolean | null, completedCount?: number | null, totalCount?: number | null, isVisible?: boolean | null } | null } } };

export type UpdateCustomerInvoiceMutationVariables = Exact<{
  data?: InputMaybe<UpdateCustomerInvoiceInput>;
}>;


export type UpdateCustomerInvoiceMutation = { __typename?: 'Mutation', updateCustomerInvoice?: { __typename?: 'UpdateCustomerInvoiceResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerInvoice', _id: string, amountPaid?: any | null, paymentType: PaymentType, paymentMethod?: string | null, invoiceNo?: string | null, paymentStatus?: PaymentStatus | null, paymentInvoice?: string | null, isDefaultInvoice?: boolean | null, accountingInvoiceId?: string | null, createdAt?: string | null, customer?: { __typename?: 'Customer', _id?: string | null, phone?: string | null, companyName?: string | null, email?: string | null, category?: string | null, autoConversationAssignment?: boolean | null, autoAssignmentType?: AutoAssignmentTypeEnum | null, autoConversationAssignmentTime?: number | null, autoConversationAssignmentTimeUnit?: string | null, photo?: string | null, createdAt?: any | null, customerFromChannel?: string | null, country?: string | null, timeZone?: string | null, currency?: string | null, isANewCustomer?: boolean | null, isDummy?: boolean | null, accountStatus?: string | null, accountConfirmation?: string | null, appStatus?: string | null, language?: Language | null, allowConnect?: boolean | null, is2FARequired?: boolean | null, teamGoalTime?: number | null, teamOnlineGoalTime?: number | null, teamFirstResponseGoalTime?: number | null, cPersonsAutoAwayTime?: number | null, autoApproveSharingRequests?: boolean | null, canManageOtherUserConversation?: boolean | null, allowUnassignedTicket?: boolean | null, partnerCode?: string | null, signUpMethod?: SignUpMethod | null, package?: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } | null, sendAutoSurvey?: { __typename?: 'sendAutoSurveyType', status?: boolean | null, time?: number | null, closingMessage?: string | null, surveyId?: string | null, channels?: Array<string | null> | null, tagRule?: SurveyTagRuleEnum | null, tags?: Array<string | null> | null } | null, closingNote?: { __typename?: 'ClosingNoteDetail', isEnabled?: boolean | null, autoFillWithAi?: boolean | null, isCompletionRequired?: boolean | null, customFields: Array<{ __typename?: 'CustomField', _id?: string | null, name?: string | null, label?: string | null, description?: string | null, type?: string | null, listValues?: Array<string | null> | null, visibleToCustomers?: EnumCustomFieldCustomerVisibility | null, visibleToUsers?: EnumCustomFieldUserVisibility | null, status?: EnumCustomFieldStatus | null, isDefault?: boolean | null, customer?: string | null, createdAt?: any | null, updatedAt?: any | null, mediaType?: EnumCustomFieldMediaType | null, conditions?: Array<{ __typename?: 'CustomFieldCondition', parentField: string, parentValues: Array<string> } | null> | null }> } | null, twSubAccount?: { __typename?: 'TwSubAccount', sid?: string | null, token?: string | null, apiKeySid?: string | null, apiKeySecret?: string | null } | null, onboarding?: { __typename?: 'CustomerOnboarding', channelConnected?: boolean | null, teamInvited?: boolean | null, accountCustomized?: boolean | null, aiAgentTrained?: boolean | null, mobileAppDownloaded?: boolean | null, introVideoWatched?: boolean | null, completedCount?: number | null, totalCount?: number | null, isVisible?: boolean | null } | null } | null, products: Array<{ __typename?: 'Product', _id?: string | null, name?: string | null, monthlyPrice?: any | null, yearlyPrice?: any | null, createdAt?: any | null, limits?: { __typename?: 'ProductLimitsType', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, amazon?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, liveChat?: number | null, customChannel?: number | null, message?: string | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, features?: { __typename?: 'ProductFeatureType', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null } | null>, accountingInfo?: { __typename?: 'CustomerInvoiceAccountingInfo', status?: string | null, errorMessage?: string | null, updatedAt?: string | null } | null } } | null };

export type UpdateCustomerOnboardingInfoMutationVariables = Exact<{
  data: UpdateCOnboardingInfoInput;
}>;


export type UpdateCustomerOnboardingInfoMutation = { __typename?: 'Mutation', updateCustomerOnboardingInfo: { __typename?: 'CustomerOnboardingInfoOutput', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CustomerOnboardingInfo', _id: string, customer: string, companyName?: string | null, companyWebsite?: string | null, howBuiltWebsite?: string | null, companySize?: string | null, companyIndustry?: string | null, ownerRole?: string | null, favouriteProducts?: string | null, howYouHearAboutUs?: string | null, country?: string | null, language?: string | null, sector?: OnboardingSector | null, sectorOther?: string | null, teamSize?: OnboardingTeamSize | null, monthlyVolume?: OnboardingMonthlyVolume | null, channels?: Array<OnboardingChannel> | null, platform?: OnboardingPlatform | null, platformOther?: string | null, source?: OnboardingSource | null, sourceOther?: string | null, aiInterest?: OnboardingAiInterest | null } | null } };

export type UpdateCustomerPersonMutationVariables = Exact<{
  data: UpdateCustomerPersonInput;
}>;


export type UpdateCustomerPersonMutation = { __typename?: 'Mutation', updateCustomerPerson: { __typename?: 'CustomerPersonResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerPerson', _id: string, customer: string, type: CustomerType, status: CPersonStatus, firstName: string, lastName: string, profilePhoto?: string | null, isEmailVerified: boolean, email: string, phone?: string | null, language?: Language | null, timeZone?: string | null, dateFormat?: CustomerDateFormat | null, joinedConvLimit?: number | null, joinedConvCount?: number | null, signedTeams?: any | null, isAcceptingCalls?: boolean | null, canAccessPhoneCalls?: boolean | null, isInCall?: boolean | null, is2FAEnabled?: boolean | null, hasPassword?: boolean | null, archivedAt?: any | null, hasAiAssistant?: boolean | null, devices?: Array<{ __typename?: 'CustomerPersonDevice', type?: CustomerPersonDeviceType | null, status?: CustomerPersonDeviceStatus | null, lastLoginTime?: any | null, statusAwayTime?: any | null } | null> | null, notificationSettings?: { __typename?: 'NotificationSettings', conversationSound?: string | null, messageSound?: string | null, notificationSoundVolume?: number | null, notificationCardEnabled?: boolean | null, mobilePushNotifications?: MobilePushNotificationsEnum | null, newUnassignedConversation?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newConversationAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInConversationsAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInUnassignedConversations?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskReminder?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTableRecordAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newCommentInAssignedTableRecord?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newPrivateChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTeamChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importRecordsToTable?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportTableRecords?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, noteMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskCommentMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, trackingDomainVerified?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportReport?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, qpienAnnouncements?: { __typename?: 'QpienAnnouncementNotificationType', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, whatsapp?: boolean | null } | null } | null, productTour?: { __typename?: 'ProductTour', mainCompletedAt?: any | null, mainSkippedAt?: any | null, boardsCompletedAt?: any | null, welcomeVideoWatchedAt?: any | null, modules?: Array<string> | null } | null } } };

export type UpdateCustomerProductMutationVariables = Exact<{
  data: UpdateCustomerProductInput;
}>;


export type UpdateCustomerProductMutation = { __typename?: 'Mutation', updateCustomerProduct: { __typename?: 'CustomerProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } } };

export type UpdateCustomerProductPlanMutationVariables = Exact<{
  data: UpdateCustomerProductPlanInput;
}>;


export type UpdateCustomerProductPlanMutation = { __typename?: 'Mutation', updateCustomerProductPlan: { __typename?: 'CustomerResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Customer', _id?: string | null, phone?: string | null, companyName?: string | null, email?: string | null, category?: string | null, autoConversationAssignment?: boolean | null, autoAssignmentType?: AutoAssignmentTypeEnum | null, autoConversationAssignmentTime?: number | null, autoConversationAssignmentTimeUnit?: string | null, photo?: string | null, createdAt?: any | null, customerFromChannel?: string | null, country?: string | null, timeZone?: string | null, currency?: string | null, isANewCustomer?: boolean | null, isDummy?: boolean | null, accountStatus?: string | null, accountConfirmation?: string | null, appStatus?: string | null, language?: Language | null, allowConnect?: boolean | null, is2FARequired?: boolean | null, teamGoalTime?: number | null, teamOnlineGoalTime?: number | null, teamFirstResponseGoalTime?: number | null, cPersonsAutoAwayTime?: number | null, autoApproveSharingRequests?: boolean | null, canManageOtherUserConversation?: boolean | null, allowUnassignedTicket?: boolean | null, partnerCode?: string | null, signUpMethod?: SignUpMethod | null, package?: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } | null, sendAutoSurvey?: { __typename?: 'sendAutoSurveyType', status?: boolean | null, time?: number | null, closingMessage?: string | null, surveyId?: string | null, channels?: Array<string | null> | null, tagRule?: SurveyTagRuleEnum | null, tags?: Array<string | null> | null } | null, closingNote?: { __typename?: 'ClosingNoteDetail', isEnabled?: boolean | null, autoFillWithAi?: boolean | null, isCompletionRequired?: boolean | null, customFields: Array<{ __typename?: 'CustomField', _id?: string | null, name?: string | null, label?: string | null, description?: string | null, type?: string | null, listValues?: Array<string | null> | null, visibleToCustomers?: EnumCustomFieldCustomerVisibility | null, visibleToUsers?: EnumCustomFieldUserVisibility | null, status?: EnumCustomFieldStatus | null, isDefault?: boolean | null, customer?: string | null, createdAt?: any | null, updatedAt?: any | null, mediaType?: EnumCustomFieldMediaType | null, conditions?: Array<{ __typename?: 'CustomFieldCondition', parentField: string, parentValues: Array<string> } | null> | null }> } | null, twSubAccount?: { __typename?: 'TwSubAccount', sid?: string | null, token?: string | null, apiKeySid?: string | null, apiKeySecret?: string | null } | null, onboarding?: { __typename?: 'CustomerOnboarding', channelConnected?: boolean | null, teamInvited?: boolean | null, accountCustomized?: boolean | null, aiAgentTrained?: boolean | null, mobileAppDownloaded?: boolean | null, introVideoWatched?: boolean | null, completedCount?: number | null, totalCount?: number | null, isVisible?: boolean | null } | null } } };

export type UpdateMobileAppVersionConfigMutationVariables = Exact<{
  input: UpdateMobileAppVersionConfigInput;
}>;


export type UpdateMobileAppVersionConfigMutation = { __typename?: 'Mutation', updateMobileAppVersionConfig?: { __typename?: 'MobileAppVersionConfigResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'MobileAppVersionConfig', _id?: string | null, platform: MobilePlatform, latestVersion?: string | null, minSupportedVersion?: string | null, updateType?: MobileUpdateType | null, storeUrl?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, releaseNotes?: { __typename?: 'MobileReleaseNotes', tr?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null, en?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null, ar?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null } | null } | null } | null };

export type UpdatePlatformMutationVariables = Exact<{
  type: PlatformType;
  metaData: UpdatePlatformInputData;
}>;


export type UpdatePlatformMutation = { __typename?: 'Mutation', updatePlatform: { __typename?: 'OPlatformResponse', success?: boolean | null, data?: any | null, code?: string | null, message?: string | null } };

export type UpdateRequireAccountApprovalMutationVariables = Exact<{
  approvalRequired: Scalars['Boolean']['input'];
}>;


export type UpdateRequireAccountApprovalMutation = { __typename?: 'Mutation', updateRequireAccountApproval: { __typename?: 'PreferenceResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Preference', requireAccountApproval: boolean, autoFormalizeInvoices: AutoFormalizeInvoicesPreference } } };

export type UpdateSpecialOfferPackageMutationVariables = Exact<{
  data?: InputMaybe<SpecialOfferPackageInput>;
}>;


export type UpdateSpecialOfferPackageMutation = { __typename?: 'Mutation', updateSpecialOfferPackage?: { __typename?: 'ProductResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Product', _id?: string | null, name?: string | null, monthlyPrice?: any | null, yearlyPrice?: any | null, createdAt?: any | null, limits?: { __typename?: 'ProductLimitsType', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, amazon?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, liveChat?: number | null, customChannel?: number | null, message?: string | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, features?: { __typename?: 'ProductFeatureType', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null } } | null };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'User', _id?: string | null, name?: string | null, surname?: string | null, role?: RoleTypes | null, phone?: string | null, email?: string | null, createdAt?: any | null } } };

export type UploadAnnouncementMediaMutationVariables = Exact<{
  input: UploadChangelogMediaInput;
}>;


export type UploadAnnouncementMediaMutation = { __typename?: 'Mutation', uploadAnnouncementMedia?: { __typename?: 'ChangelogMediaResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogMedia', url: string, type?: string | null } | null } | null };

export type VerifyEmailMutationVariables = Exact<{
  data: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: { __typename?: 'EditCPersonResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'EditCPersonData', cPersonId: string, email: string, isEmailVerified: boolean, token?: string | null, customerId?: string | null } } };

export type AnalyzeAiMessageRunQueryVariables = Exact<{
  data: AnalyzeAiMessageRunInput;
}>;


export type AnalyzeAiMessageRunQuery = { __typename?: 'Query', analyzeAiMessageRun: { __typename?: 'AnalyzeAiMessageRunResponse', success?: boolean | null, data?: any | null, code?: string | null, message?: string | null } };

export type CouponCodesQueryVariables = Exact<{
  args?: InputMaybe<GetAllCouponCodesInput>;
}>;


export type CouponCodesQuery = { __typename?: 'Query', couponCodes: { __typename?: 'CouponCodesResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null> | null } };

export type CustomerPersonsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  notSelectBot?: InputMaybe<Scalars['Boolean']['input']>;
  fromLiveChat?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  excludeAi?: InputMaybe<Scalars['Boolean']['input']>;
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sort?: InputMaybe<ListSortInput>;
}>;


export type CustomerPersonsQuery = { __typename?: 'Query', customerPersons: { __typename?: 'CustomerPersonsListResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerPersonsPaginate', totalDocs?: number | null, hasPrevPage?: boolean | null, hasNextPage?: boolean | null, docs?: Array<{ __typename?: 'CustomerPerson', _id: string, customer: string, type: CustomerType, status: CPersonStatus, firstName: string, lastName: string, profilePhoto?: string | null, isEmailVerified: boolean, email: string, phone?: string | null, language?: Language | null, timeZone?: string | null, dateFormat?: CustomerDateFormat | null, joinedConvLimit?: number | null, joinedConvCount?: number | null, signedTeams?: any | null, isAcceptingCalls?: boolean | null, canAccessPhoneCalls?: boolean | null, isInCall?: boolean | null, is2FAEnabled?: boolean | null, hasPassword?: boolean | null, archivedAt?: any | null, hasAiAssistant?: boolean | null, devices?: Array<{ __typename?: 'CustomerPersonDevice', type?: CustomerPersonDeviceType | null, status?: CustomerPersonDeviceStatus | null, lastLoginTime?: any | null, statusAwayTime?: any | null } | null> | null, notificationSettings?: { __typename?: 'NotificationSettings', conversationSound?: string | null, messageSound?: string | null, notificationSoundVolume?: number | null, notificationCardEnabled?: boolean | null, mobilePushNotifications?: MobilePushNotificationsEnum | null, newUnassignedConversation?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newConversationAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInConversationsAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInUnassignedConversations?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskReminder?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTableRecordAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newCommentInAssignedTableRecord?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newPrivateChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTeamChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importRecordsToTable?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportTableRecords?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, noteMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskCommentMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, trackingDomainVerified?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportReport?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, qpienAnnouncements?: { __typename?: 'QpienAnnouncementNotificationType', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, whatsapp?: boolean | null } | null } | null, productTour?: { __typename?: 'ProductTour', mainCompletedAt?: any | null, mainSkippedAt?: any | null, boardsCompletedAt?: any | null, welcomeVideoWatchedAt?: any | null, modules?: Array<string> | null } | null } | null> | null } } };

export type ExplainAiMessageStepQueryVariables = Exact<{
  data: ExplainAiMessageStepInput;
}>;


export type ExplainAiMessageStepQuery = { __typename?: 'Query', explainAiMessageStep: { __typename?: 'ExplainAiMessageStepResponse', success?: boolean | null, data?: any | null, code?: string | null, message?: string | null } };

export type FindAllPlatformQueryQueryVariables = Exact<{
  type: Scalars['String']['input'];
  metaData: Scalars['Object']['input'];
}>;


export type FindAllPlatformQueryQuery = { __typename?: 'Query', findAllPlatformQuery: { __typename?: 'PlatformsResponse', success?: boolean | null, data: Array<any | null>, code?: string | null, message?: string | null } };

export type GetActionsQueryVariables = Exact<{
  input?: InputMaybe<GetActionsInput>;
}>;


export type GetActionsQuery = { __typename?: 'Query', getActions: { __typename?: 'ActionsPaginatedResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'ActionsPaginatedData', totalRecords?: number | null, hasNextPage?: boolean | null, docs: Array<{ __typename?: 'Action', _id: string, channelIds?: Array<string | null> | null, customer: string, type?: ActionTypeEnum | null, name: string, description?: string | null, instructions?: string | null, customFieldInfo?: Array<string | null> | null, url: string, method: ActionMethod, body?: string | null, requiresConfirmation?: boolean | null, createdAt?: any | null, updatedAt?: any | null, collectInfo?: Array<{ __typename?: 'ActionCustomFieldOutput', _id: string, type?: string | null, name?: string | null, description?: string | null } | null> | null, headers: Array<{ __typename?: 'ActionHeaderOutput', key?: string | null, value?: string | null } | null>, formData?: Array<{ __typename?: 'ActionFormDataOutput', key?: string | null, value?: string | null } | null> | null, formDataUrlEncoded?: Array<{ __typename?: 'ActionFormDataOutput', key?: string | null, value?: string | null } | null> | null, responseMapping?: Array<{ __typename?: 'ActionResponseMappingOutput', fieldId: string, value: string } | null> | null, platformAction?: { __typename?: 'PlatformActionMethodOutput', type?: ECommerceIntegrationTypes | null, method?: PlatformActionType | null } | null } | null> } } };

export type GetAdminAnnouncementsQueryVariables = Exact<{
  input?: InputMaybe<ListChangelogInput>;
}>;


export type GetAdminAnnouncementsQuery = { __typename?: 'Query', getAdminAnnouncements?: { __typename?: 'ChangelogListResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogPaginate', hasNextPage?: boolean | null, totalDocs?: number | null, docs?: Array<{ __typename?: 'Changelog', _id: string, categoryId: string, coverImageUrl?: string | null, channels?: Array<ChangelogChannel | null> | null, status: ChangelogStatus, translations?: any | null, scheduledAt?: any | null, publishedAt?: any | null, sendStats?: any | null, reactionCount?: number | null, reactionAvg?: number | null, createdBy?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, myReaction?: number | null, myReactionComment?: string | null, category?: { __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null> | null } | null } | null };

export type GetAiAnswerExplanationQueryVariables = Exact<{
  messageId: Scalars['ID']['input'];
}>;


export type GetAiAnswerExplanationQuery = { __typename?: 'Query', getAiAnswerExplanation: { __typename?: 'AiAnswerExplanationResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiAnswerExplanation', runId?: string | null, groupedIntoRunId?: string | null, engineVersion?: string | null, surface?: string | null, outcome: AiAnswerOutcome, reason?: AiAnswerReason | null, agentAction?: string | null, confidence?: string | null, handoffReason?: string | null, agentNote?: string | null, knowledgeGap?: string | null, roleName?: string | null, role?: string | null, activeSkill?: string | null, handoffDisabled: boolean, handedOff: boolean, dmSent: boolean, hasCitations: boolean, durationMs?: number | null, knowledgeSearches: Array<{ __typename?: 'AiAnswerKnowledgeSearch', query: string, status: string, hits: number }>, complianceViolations: Array<{ __typename?: 'AiAnswerComplianceViolation', code: string, surface?: string | null }>, suggestions: Array<{ __typename?: 'AiAnswerSuggestionEntry', code: AiAnswerSuggestion, targetId?: string | null, question?: string | null }>, sources: Array<{ __typename?: 'AiMessageSource', id: string, knowledgeSourceContentId?: string | null, content?: string | null, subTopic?: string | null, topic?: string | null, request?: any | null, response?: any | null, order?: number | null, type?: StepType | null, group?: StepSourceGroup | null, cited?: boolean | null }> } | null } };

export type GetAiEngineRoutingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiEngineRoutingQuery = { __typename?: 'Query', getAiEngineRouting: { __typename?: 'AiEngineRoutingResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiEngineRoutingOverview', capabilities: Array<string>, engines: Array<{ __typename?: 'AiEngineSummary', version: string, capabilities: Array<string>, frozen: boolean }>, routing: { __typename?: 'AiEngineRouting', updatedBy: string, updatedAt: string, defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }>, history: Array<{ __typename?: 'AiEngineRoutingHistoryEntry', index: number, at: string, by: string, reason: string, snapshot: { __typename?: 'AiEngineRoutingSnapshot', defaults: Array<{ __typename?: 'AiEngineDefault', capability: string, version: string }>, pins: Array<{ __typename?: 'AiEnginePin', customerId: string, capability?: string | null, version: string, note?: string | null, createdBy: string, createdAt: string }>, disabled: Array<{ __typename?: 'AiEngineDisabled', capability: string, version: string, reason: string, createdBy: string, createdAt: string }> } }> } } | null } };

export type GetAiGuidanceListQueryVariables = Exact<{
  data: GetAiGuidanceListInput;
}>;


export type GetAiGuidanceListQuery = { __typename?: 'Query', getAiGuidanceList: { __typename?: 'AiGuidancePaginatedResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiGuidancePaginatedResult', totalDocs?: number | null, hasPrevPage?: boolean | null, hasNextPage?: boolean | null, page?: number | null, totalPages?: number | null, docs?: Array<{ __typename?: 'AiGuidance', _id: string, customer: string, title: string, content: string, category: AiGuidanceCategoryEnum, roles?: Array<AiRoleEnum> | null, channel?: Array<string | null> | null, messageTypes?: Array<AiGuidanceMessageTypeEnum | null> | null, toneOfVoice?: AiProfileToneOfVoiceEnum | null, status: AiGuidanceStatusEnum, createdAt?: any | null, updatedAt?: any | null } | null> | null } | null } };

export type GetAiHelpArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiHelpArticlesQuery = { __typename?: 'Query', getAiHelpArticles: { __typename?: 'AiHelpArticlesResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'AiHelpArticle', _id: string, slug: string, title: string, category?: string | null, summary?: string | null, related?: string | null, author?: string | null, sourceDate?: string | null, source: string, fileName?: string | null, panelPath?: string | null, permissions?: Array<string> | null, language: string, status: string, chunkCount: number, indexedAt?: string | null, error?: string | null, useCount?: number | null, lastUsedAt?: string | null, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'AiHelpSection', key: string, heading: string, text: string, images: Array<{ __typename?: 'AiHelpImage', key: string, url: string, caption?: string | null, description?: string | null }> }>, faqs: Array<{ __typename?: 'AiHelpFaq', question: string, answer: string }> }> | null } };

export type GetAiHelpGapsQueryVariables = Exact<{
  data?: InputMaybe<AiHelpGapsInput>;
}>;


export type GetAiHelpGapsQuery = { __typename?: 'Query', getAiHelpGaps: { __typename?: 'AiHelpGapsResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'AiHelpGap', _id: string, customer: string, cPerson: string, question: string, resolvedAt?: string | null, article?: string | null, createdAt: string }> | null } };

export type GetAiProductImageIndexesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiProductImageIndexesQuery = { __typename?: 'Query', getAiProductImageIndexes: { __typename?: 'AiProductImageIndexesResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'AiProductImageIndexTenant', customerId: string, customerName?: string | null, error?: string | null, index?: { __typename?: 'AiProductImageIndexDetails', enabled: boolean, state: AiProductImageIndexState, progressPercent: number, plannedAt?: string | null, counts: { __typename?: 'AiProductImageIndexCounts', listings: number, products: number, lastIndexedAt?: string | null, images: { __typename?: 'AiProductImageIndexImageCounts', total: number, indexed: number, pending: number, failed: number } }, shops: Array<{ __typename?: 'AiProductImageIndexShop', shopId: string, type: string, connectionStatus: string, listings: number, images: { __typename?: 'AiProductImageIndexImageCounts', total: number, indexed: number, pending: number, failed: number } }>, errors: Array<{ __typename?: 'AiProductImageIndexError', reason?: string | null, images: number }>, usage: { __typename?: 'AiProductImageIndexUsagePeriods', total: { __typename?: 'AiProductImageIndexUsage', indexedImages: number, queryImages: number, estimatedCostUsd: number }, last30Days: { __typename?: 'AiProductImageIndexUsage', indexedImages: number, queryImages: number, estimatedCostUsd: number } } } | null }> | null } };

export type GetAiProfileQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  role?: InputMaybe<AiRoleEnum>;
}>;


export type GetAiProfileQuery = { __typename?: 'Query', getAiProfile: { __typename?: 'AiProfileResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiProfile', _id: string, customer: string, role: AiRoleEnum, lastSelectedAt?: any | null, isActive?: boolean | null, name: string, avatar?: string | null, persona?: string | null, toneOfVoice: AiProfileToneOfVoiceEnum, useEmoji?: boolean | null, aiImageRecognition?: boolean | null, createdAt?: any | null, updatedAt?: any | null, answerLength?: AiAnswerLengthEnum | null, useMacrosAsKnowledgeSource?: boolean | null, learnFromHumanReplies?: boolean | null, humanReplyLearningJobId?: string | null, storeSettings?: { __typename?: 'AiStoreSettings', integrationStore?: string | null, useProductImagesForRag?: boolean | null, shoppingAssistant?: { __typename?: 'AiShoppingAssistantSettings', recommendSimilarProducts?: boolean | null, productFaqs?: boolean | null, promoteProducts?: boolean | null, takeOrders?: boolean | null, collectAddress?: boolean | null, cashOnDelivery?: boolean | null, cardOnDelivery?: boolean | null, bankTransfer?: boolean | null, cancelOrders?: boolean | null, updateOrders?: boolean | null, returnOrders?: boolean | null, addToCart?: boolean | null, bankAccounts?: Array<{ __typename?: 'AiBankAccount', bankName: string, iban: string, accountHolder: string }> | null } | null, productFaqDesign?: { __typename?: 'AiProductFaqDesign', showIcons: boolean, iconColor: string, textColor: string, fontSize: number, fontWeight: AiProductFaqFontWeightEnum, borderColor: string, borderWidth: number, borderRadius: number, fontFamily: AiProductFaqFontFamilyEnum, answerLength?: AiProductFaqAnswerLengthEnum | null } | null } | null, chatSettings?: { __typename?: 'ChatSettings', status?: boolean | null, aiIntroducesItself?: string | null, aiAgentWorkingHours?: AiWorkingHoursEnum | null, channels?: Array<string> | null, aiReplyButtons?: { __typename?: 'AIReplyButtons', aiHelped?: { __typename?: 'AIReplyAiHelpedButton', buttonTitle: string, isButtonEnabled: boolean, action: AiProfileReplyButtonActionEnum, actionValue?: string | null, actionMessage?: string | null, addClosingTag?: boolean | null, addClosingNote?: boolean | null, sendSurvey?: string | null } | null, humanSupport?: { __typename?: 'AIReplyButton', buttonTitle: string, isButtonEnabled: boolean, action: AiProfileReplyButtonActionEnum, actionValue?: string | null, actionMessage?: string | null } | null } | null, aiAutoClose?: { __typename?: 'AIAutoClose', waitTimeInSecond: number, actionMessage?: string | null } | null, aiFollowUp?: { __typename?: 'AIFollowUp', mode?: AiFollowUpModeEnum | null, waitTimeInSecond?: number | null } | null, humanHandoff?: { __typename?: 'HumanHandoff', isDisabled?: boolean | null, channels?: Array<string> | null, message?: string | null } | null } | null, emailSettings?: { __typename?: 'EmailSettings', status?: boolean | null, aiIntroducesItself?: string | null, aiAgentWorkingHours?: AiWorkingHoursEnum | null, channels?: Array<string> | null, aiAutoClose?: { __typename?: 'AIAutoClose', waitTimeInSecond: number, actionMessage?: string | null } | null, aiFollowUp?: { __typename?: 'AIFollowUp', mode?: AiFollowUpModeEnum | null, waitTimeInSecond?: number | null } | null } | null, commentSettings?: { __typename?: 'CommentSettings', status?: boolean | null, replyToComment?: boolean | null, sendPrivateReply?: boolean | null, aiAgentWorkingHours?: AiWorkingHoursEnum | null, channels?: Array<string> | null } | null, ticketSettings?: { __typename?: 'TicketSettings', status?: boolean | null, aiAgentWorkingHours?: AiWorkingHoursEnum | null, channels?: Array<string> | null, aiAutoClose?: { __typename?: 'AIAutoClose', waitTimeInSecond: number, actionMessage?: string | null } | null, aiFollowUp?: { __typename?: 'AIFollowUp', mode?: AiFollowUpModeEnum | null, waitTimeInSecond?: number | null } | null } | null, marketPlaceSettings?: { __typename?: 'MarketPlaceSettings', status?: boolean | null, aiAgentWorkingHours?: AiWorkingHoursEnum | null, channels?: Array<string> | null, replyMode?: AiProfileReplyModeEnum | null } | null } | null } };

export type GetAllAiKnowledgeSourceContentQueryVariables = Exact<{
  data: GetAiKnowledgeSourceContentInput;
}>;


export type GetAllAiKnowledgeSourceContentQuery = { __typename?: 'Query', getAllAiKnowledgeSourceContent: { __typename?: 'AiKnowledgeSourceContentPaginatedResult', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'AiKnowledgeSourceContentsResponse', totalDocs?: number | null, hasPrevPage?: boolean | null, hasNextPage?: boolean | null, docs?: Array<{ __typename?: 'AiKnowledgeSourceContent', _id: string, aiProfile: string, aiKnowledgeSource: string, status?: AiKnowledgeSourcesStatus | null, source?: string | null, language?: string | null, content?: string | null, title?: string | null, chunkNumber?: number | null, sourceType?: AiKnowledgeSourcesSourceTypes | null, knowledgeScope?: AiKnowledgeScopeEnum | null, scopeType?: AiKnowledgeScopeTypeEnum | null, scopeRef?: string | null, questionHash?: string | null, contentHash?: string | null, createdAt?: any | null, updatedAt?: any | null, failedReason?: string | null } | null> | null } } };

export type GetAllAiKnowledgeSourcesQueryVariables = Exact<{
  data: GetAiKnowledgeSourceInput;
}>;


export type GetAllAiKnowledgeSourcesQuery = { __typename?: 'Query', getAllAiKnowledgeSources: { __typename?: 'AiKnowledgeSourcePaginatedResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiKnowledgeSourcePaginatedResult', totalDocs?: number | null, hasPrevPage?: boolean | null, hasNextPage?: boolean | null, docs?: Array<{ __typename?: 'AiKnowledgeSource', _id: string, customer: string, aiProfile: string, title: string, chunkNumber?: number | null, status?: AiKnowledgeSourcesStatus | null, sourceType?: AiKnowledgeSourcesSourceTypes | null, source?: string | null, createdAt?: any | null, updatedAt?: any | null, question?: string | null, answer?: string | null, isSinglePage?: boolean | null, createdBy?: string | null, failedReason?: string | null, channels?: Array<string> | null } | null> | null } | null } };

export type GetAllConnectedPlatformQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetAllConnectedPlatformQuery = { __typename?: 'Query', getAllConnectedPlatform: { __typename?: 'AllChannelTypeResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'ChannelCommonTypes', _id?: string | null, name?: string | null, status?: boolean | null, channelId?: string | null, channelType?: string | null, senderEmailAddress?: string | null, appId?: string | null, channelOwner?: { __typename?: 'CustomerPerson', _id: string, customer: string, type: CustomerType, status: CPersonStatus, firstName: string, lastName: string, profilePhoto?: string | null, isEmailVerified: boolean, email: string, phone?: string | null, language?: Language | null, timeZone?: string | null, dateFormat?: CustomerDateFormat | null, joinedConvLimit?: number | null, joinedConvCount?: number | null, signedTeams?: any | null, isAcceptingCalls?: boolean | null, canAccessPhoneCalls?: boolean | null, isInCall?: boolean | null, is2FAEnabled?: boolean | null, hasPassword?: boolean | null, archivedAt?: any | null, hasAiAssistant?: boolean | null, devices?: Array<{ __typename?: 'CustomerPersonDevice', type?: CustomerPersonDeviceType | null, status?: CustomerPersonDeviceStatus | null, lastLoginTime?: any | null, statusAwayTime?: any | null } | null> | null, notificationSettings?: { __typename?: 'NotificationSettings', conversationSound?: string | null, messageSound?: string | null, notificationSoundVolume?: number | null, notificationCardEnabled?: boolean | null, mobilePushNotifications?: MobilePushNotificationsEnum | null, newUnassignedConversation?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newConversationAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInConversationsAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInUnassignedConversations?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskReminder?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTableRecordAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newCommentInAssignedTableRecord?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newPrivateChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTeamChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importRecordsToTable?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportTableRecords?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, noteMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskCommentMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, trackingDomainVerified?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportReport?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, qpienAnnouncements?: { __typename?: 'QpienAnnouncementNotificationType', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, whatsapp?: boolean | null } | null } | null, productTour?: { __typename?: 'ProductTour', mainCompletedAt?: any | null, mainSkippedAt?: any | null, boardsCompletedAt?: any | null, welcomeVideoWatchedAt?: any | null, modules?: Array<string> | null } | null } | null } | null> | null } };

export type GetAnnouncementCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnnouncementCategoriesQuery = { __typename?: 'Query', getAnnouncementCategories?: { __typename?: 'ChangelogCategoryListResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'ChangelogCategory', _id: string, color: string, translations?: any | null, createdAt?: any | null, updatedAt?: any | null } | null> | null } | null };

export type GetCallAdminLogDetailQueryVariables = Exact<{
  callSid: Scalars['String']['input'];
}>;


export type GetCallAdminLogDetailQuery = { __typename?: 'Query', getCallAdminLogDetail: { __typename?: 'CallAdminLogDetailResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CallAdminLog', _id: string, callSid: string, parentCallSid?: string | null, childCallSids?: Array<string> | null, customer: string, customerName?: string | null, platformId?: string | null, callType?: CallAdminLogType | null, callerCPersonId?: string | null, calleeCPersonId?: string | null, callerName?: string | null, calleeName?: string | null, status?: string | null, direction: string, createdAt: any, updatedAt: any, callerNumber?: string | null, totalDuration?: number | null, totalCost?: number | null, logs: Array<{ __typename?: 'CallAdminLogStep', stepName: string, type: string, status: string, correlationId?: string | null, data?: any | null, duration?: number | null, timestamp: number, message?: string | null, error?: string | null }> } | null } };

export type GetCallAdminLogsQueryVariables = Exact<{
  params: GetCallAdminLogsInput;
}>;


export type GetCallAdminLogsQuery = { __typename?: 'Query', getCallAdminLogs: { __typename?: 'CallAdminLogsResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CallAdminLogsData', total: number, logs: Array<{ __typename?: 'CallAdminLog', _id: string, callSid: string, parentCallSid?: string | null, childCallSids?: Array<string> | null, customer: string, customerName?: string | null, platformId?: string | null, callType?: CallAdminLogType | null, callerCPersonId?: string | null, calleeCPersonId?: string | null, callerName?: string | null, calleeName?: string | null, status?: string | null, direction: string, createdAt: any, updatedAt: any, callerNumber?: string | null, totalDuration?: number | null, totalCost?: number | null, logs: Array<{ __typename?: 'CallAdminLogStep', stepName: string, type: string, status: string, correlationId?: string | null, data?: any | null, duration?: number | null, timestamp: number, message?: string | null, error?: string | null }> }> } | null } };

export type GetChangelogDeliveriesQueryVariables = Exact<{
  input?: InputMaybe<ListDeliveriesInput>;
}>;


export type GetChangelogDeliveriesQuery = { __typename?: 'Query', getChangelogDeliveries?: { __typename?: 'ChangelogDeliveryListResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogDeliveryPaginate', totalDocs?: number | null, page?: number | null, totalPages?: number | null, hasNextPage?: boolean | null, docs?: Array<{ __typename?: 'ChangelogDelivery', _id: string, announcement?: any | null, cPerson?: any | null, customer?: any | null, channels?: Array<any | null> | null, readAt?: any | null, reaction?: number | null, comment?: string | null, createdAt?: any | null } | null> | null } | null } | null };

export type GetChangelogSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChangelogSettingsQuery = { __typename?: 'Query', getChangelogSettings?: { __typename?: 'ChangelogSettingsResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogSettings', _id?: string | null, defaultLanguage?: string | null, supportedLanguages?: Array<string | null> | null, defaultTimezone?: string | null, dateFormat?: string | null, senderEmail?: any | null, senderWhatsapp?: any | null, senderCustomerId?: string | null, recipientAudience?: string | null, includeInactiveCustomers?: boolean | null, includeArchivedPersons?: boolean | null, updatedAt?: any | null } | null } | null };

export type GetChangelogSubscribersQueryVariables = Exact<{
  input?: InputMaybe<ListChangelogSubscribersInput>;
}>;


export type GetChangelogSubscribersQuery = { __typename?: 'Query', getChangelogSubscribers?: { __typename?: 'ChangelogSubscriberListResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'ChangelogSubscriberPaginate', totalDocs?: number | null, hasNextPage?: boolean | null, docs?: Array<{ __typename?: 'ChangelogSubscriber', _id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, language?: string | null, customer?: any | null, createdAt?: any | null, prefs?: { __typename?: 'ChangelogPrefs', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, whatsapp?: boolean | null } | null } | null> | null } | null } | null };

export type GetChangelogWhatsAppAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChangelogWhatsAppAccountsQuery = { __typename?: 'Query', getChangelogWhatsAppAccounts?: { __typename?: 'ChangelogObjectListResponse', success?: boolean | null, data?: Array<any | null> | null, error?: boolean | null, message?: string | null } | null };

export type GetChangelogWhatsAppTemplatesQueryVariables = Exact<{
  input: ChangelogWhatsAppTemplatesInput;
}>;


export type GetChangelogWhatsAppTemplatesQuery = { __typename?: 'Query', getChangelogWhatsAppTemplates?: { __typename?: 'ChangelogObjectListResponse', success?: boolean | null, data?: Array<any | null> | null, error?: boolean | null, message?: string | null } | null };

export type GetCustomerBillingAddressesQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerBillingAddressesQuery = { __typename?: 'Query', getCustomerBillingAddresses?: { __typename?: 'CustomerBillingAddressesOutput', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CustomerBillingAddresses', _id: string, customer: string, accountingContactId?: string | null, country?: string | null, state?: string | null, city?: string | null, province?: string | null, postCode?: string | null, address1?: string | null, address2?: string | null, isCompany?: boolean | null, legalCompanyName?: string | null, taxOffice?: string | null, taxNumber?: string | null } | null } | null };

export type GetCustomerByIdQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerByIdQuery = { __typename?: 'Query', getCustomerById: { __typename?: 'CustomerResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Customer', _id?: string | null, phone?: string | null, companyName?: string | null, email?: string | null, category?: string | null, autoConversationAssignment?: boolean | null, autoAssignmentType?: AutoAssignmentTypeEnum | null, autoConversationAssignmentTime?: number | null, autoConversationAssignmentTimeUnit?: string | null, photo?: string | null, createdAt?: any | null, customerFromChannel?: string | null, country?: string | null, timeZone?: string | null, currency?: string | null, isANewCustomer?: boolean | null, isDummy?: boolean | null, accountStatus?: string | null, accountConfirmation?: string | null, appStatus?: string | null, language?: Language | null, allowConnect?: boolean | null, is2FARequired?: boolean | null, teamGoalTime?: number | null, teamOnlineGoalTime?: number | null, teamFirstResponseGoalTime?: number | null, cPersonsAutoAwayTime?: number | null, autoApproveSharingRequests?: boolean | null, canManageOtherUserConversation?: boolean | null, allowUnassignedTicket?: boolean | null, partnerCode?: string | null, signUpMethod?: SignUpMethod | null, package?: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } | null, sendAutoSurvey?: { __typename?: 'sendAutoSurveyType', status?: boolean | null, time?: number | null, closingMessage?: string | null, surveyId?: string | null, channels?: Array<string | null> | null, tagRule?: SurveyTagRuleEnum | null, tags?: Array<string | null> | null } | null, closingNote?: { __typename?: 'ClosingNoteDetail', isEnabled?: boolean | null, autoFillWithAi?: boolean | null, isCompletionRequired?: boolean | null, customFields: Array<{ __typename?: 'CustomField', _id?: string | null, name?: string | null, label?: string | null, description?: string | null, type?: string | null, listValues?: Array<string | null> | null, visibleToCustomers?: EnumCustomFieldCustomerVisibility | null, visibleToUsers?: EnumCustomFieldUserVisibility | null, status?: EnumCustomFieldStatus | null, isDefault?: boolean | null, customer?: string | null, createdAt?: any | null, updatedAt?: any | null, mediaType?: EnumCustomFieldMediaType | null, conditions?: Array<{ __typename?: 'CustomFieldCondition', parentField: string, parentValues: Array<string> } | null> | null }> } | null, twSubAccount?: { __typename?: 'TwSubAccount', sid?: string | null, token?: string | null, apiKeySid?: string | null, apiKeySecret?: string | null } | null, onboarding?: { __typename?: 'CustomerOnboarding', channelConnected?: boolean | null, teamInvited?: boolean | null, accountCustomized?: boolean | null, aiAgentTrained?: boolean | null, mobileAppDownloaded?: boolean | null, introVideoWatched?: boolean | null, completedCount?: number | null, totalCount?: number | null, isVisible?: boolean | null } | null } } };

export type GetCustomerInvoicesQueryVariables = Exact<{
  input?: InputMaybe<GetCustomerInvoicesInput>;
}>;


export type GetCustomerInvoicesQuery = { __typename?: 'Query', getCustomerInvoices: { __typename?: 'CustomerInvoicePaginatedResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'CustomerInvoicesPaginatedData', totalRecords?: number | null, hasNextPage?: boolean | null, docs: Array<{ __typename?: 'CustomerInvoice', _id: string, amountPaid?: any | null, paymentType: PaymentType, paymentMethod?: string | null, invoiceNo?: string | null, paymentStatus?: PaymentStatus | null, paymentInvoice?: string | null, isDefaultInvoice?: boolean | null, accountingInvoiceId?: string | null, createdAt?: string | null, customer?: { __typename?: 'Customer', _id?: string | null, phone?: string | null, companyName?: string | null, email?: string | null, category?: string | null, autoConversationAssignment?: boolean | null, autoAssignmentType?: AutoAssignmentTypeEnum | null, autoConversationAssignmentTime?: number | null, autoConversationAssignmentTimeUnit?: string | null, photo?: string | null, createdAt?: any | null, customerFromChannel?: string | null, country?: string | null, timeZone?: string | null, currency?: string | null, isANewCustomer?: boolean | null, isDummy?: boolean | null, accountStatus?: string | null, accountConfirmation?: string | null, appStatus?: string | null, language?: Language | null, allowConnect?: boolean | null, is2FARequired?: boolean | null, teamGoalTime?: number | null, teamOnlineGoalTime?: number | null, teamFirstResponseGoalTime?: number | null, cPersonsAutoAwayTime?: number | null, autoApproveSharingRequests?: boolean | null, canManageOtherUserConversation?: boolean | null, allowUnassignedTicket?: boolean | null, partnerCode?: string | null, signUpMethod?: SignUpMethod | null, package?: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } | null, sendAutoSurvey?: { __typename?: 'sendAutoSurveyType', status?: boolean | null, time?: number | null, closingMessage?: string | null, surveyId?: string | null, channels?: Array<string | null> | null, tagRule?: SurveyTagRuleEnum | null, tags?: Array<string | null> | null } | null, closingNote?: { __typename?: 'ClosingNoteDetail', isEnabled?: boolean | null, autoFillWithAi?: boolean | null, isCompletionRequired?: boolean | null, customFields: Array<{ __typename?: 'CustomField', _id?: string | null, name?: string | null, label?: string | null, description?: string | null, type?: string | null, listValues?: Array<string | null> | null, visibleToCustomers?: EnumCustomFieldCustomerVisibility | null, visibleToUsers?: EnumCustomFieldUserVisibility | null, status?: EnumCustomFieldStatus | null, isDefault?: boolean | null, customer?: string | null, createdAt?: any | null, updatedAt?: any | null, mediaType?: EnumCustomFieldMediaType | null, conditions?: Array<{ __typename?: 'CustomFieldCondition', parentField: string, parentValues: Array<string> } | null> | null }> } | null, twSubAccount?: { __typename?: 'TwSubAccount', sid?: string | null, token?: string | null, apiKeySid?: string | null, apiKeySecret?: string | null } | null, onboarding?: { __typename?: 'CustomerOnboarding', channelConnected?: boolean | null, teamInvited?: boolean | null, accountCustomized?: boolean | null, aiAgentTrained?: boolean | null, mobileAppDownloaded?: boolean | null, introVideoWatched?: boolean | null, completedCount?: number | null, totalCount?: number | null, isVisible?: boolean | null } | null } | null, products: Array<{ __typename?: 'Product', _id?: string | null, name?: string | null, monthlyPrice?: any | null, yearlyPrice?: any | null, createdAt?: any | null, limits?: { __typename?: 'ProductLimitsType', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, amazon?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, liveChat?: number | null, customChannel?: number | null, message?: string | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, features?: { __typename?: 'ProductFeatureType', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null } | null>, accountingInfo?: { __typename?: 'CustomerInvoiceAccountingInfo', status?: string | null, errorMessage?: string | null, updatedAt?: string | null } | null } | null> } } };

export type GetCustomerOnboardingInfoQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerOnboardingInfoQuery = { __typename?: 'Query', getCustomerOnboardingInfo: { __typename?: 'CustomerOnboardingInfoOutput', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CustomerOnboardingInfo', _id: string, customer: string, companyName?: string | null, companyWebsite?: string | null, howBuiltWebsite?: string | null, companySize?: string | null, companyIndustry?: string | null, ownerRole?: string | null, favouriteProducts?: string | null, howYouHearAboutUs?: string | null, country?: string | null, language?: string | null, sector?: OnboardingSector | null, sectorOther?: string | null, teamSize?: OnboardingTeamSize | null, monthlyVolume?: OnboardingMonthlyVolume | null, channels?: Array<OnboardingChannel> | null, platform?: OnboardingPlatform | null, platformOther?: string | null, source?: OnboardingSource | null, sourceOther?: string | null, aiInterest?: OnboardingAiInterest | null } | null } };

export type GetCustomerOwnersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  appStatus?: InputMaybe<Scalars['String']['input']>;
  accountStatus?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  periodMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerOwnersQuery = { __typename?: 'Query', getCustomerOwners?: { __typename?: 'GetCustomerOwnersResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'GetCustomerOwnersPaginate', totalDocs?: number | null, hasNextPage?: boolean | null, hasPrevPage?: boolean | null, docs: Array<{ __typename?: 'GetCustomerOwnersData', customerPerson?: { __typename?: 'CustomerPerson', _id: string, customer: string, type: CustomerType, status: CPersonStatus, firstName: string, lastName: string, profilePhoto?: string | null, isEmailVerified: boolean, email: string, phone?: string | null, language?: Language | null, timeZone?: string | null, dateFormat?: CustomerDateFormat | null, joinedConvLimit?: number | null, joinedConvCount?: number | null, signedTeams?: any | null, isAcceptingCalls?: boolean | null, canAccessPhoneCalls?: boolean | null, isInCall?: boolean | null, is2FAEnabled?: boolean | null, hasPassword?: boolean | null, archivedAt?: any | null, hasAiAssistant?: boolean | null, devices?: Array<{ __typename?: 'CustomerPersonDevice', type?: CustomerPersonDeviceType | null, status?: CustomerPersonDeviceStatus | null, lastLoginTime?: any | null, statusAwayTime?: any | null } | null> | null, notificationSettings?: { __typename?: 'NotificationSettings', conversationSound?: string | null, messageSound?: string | null, notificationSoundVolume?: number | null, notificationCardEnabled?: boolean | null, mobilePushNotifications?: MobilePushNotificationsEnum | null, newUnassignedConversation?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newConversationAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInConversationsAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newMessagesInUnassignedConversations?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskReminder?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTableRecordAssignedToMe?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newCommentInAssignedTableRecord?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newPrivateChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, newTeamChatMessage?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importRecordsToTable?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportTableRecords?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, importContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportContacts?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, noteMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, taskCommentMention?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, trackingDomainVerified?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, exportReport?: { __typename?: 'ConvNotificationstype', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, sound?: string | null, loopScope?: string | null } | null, qpienAnnouncements?: { __typename?: 'QpienAnnouncementNotificationType', web?: boolean | null, mobile?: boolean | null, email?: boolean | null, whatsapp?: boolean | null } | null } | null, productTour?: { __typename?: 'ProductTour', mainCompletedAt?: any | null, mainSkippedAt?: any | null, boardsCompletedAt?: any | null, welcomeVideoWatchedAt?: any | null, modules?: Array<string> | null } | null } | null, customer?: { __typename?: 'Customer', _id?: string | null, phone?: string | null, companyName?: string | null, email?: string | null, category?: string | null, autoConversationAssignment?: boolean | null, autoAssignmentType?: AutoAssignmentTypeEnum | null, autoConversationAssignmentTime?: number | null, autoConversationAssignmentTimeUnit?: string | null, photo?: string | null, createdAt?: any | null, customerFromChannel?: string | null, country?: string | null, timeZone?: string | null, currency?: string | null, isANewCustomer?: boolean | null, isDummy?: boolean | null, accountStatus?: string | null, accountConfirmation?: string | null, appStatus?: string | null, language?: Language | null, allowConnect?: boolean | null, is2FARequired?: boolean | null, teamGoalTime?: number | null, teamOnlineGoalTime?: number | null, teamFirstResponseGoalTime?: number | null, cPersonsAutoAwayTime?: number | null, autoApproveSharingRequests?: boolean | null, canManageOtherUserConversation?: boolean | null, allowUnassignedTicket?: boolean | null, partnerCode?: string | null, signUpMethod?: SignUpMethod | null, package?: { __typename?: 'CustomerProduct', _id?: string | null, name?: string | null, type?: number | null, price?: any | null, feeCharged?: any | null, paymentStatus?: boolean | null, periodMode?: string | null, periodCount?: number | null, endDate?: any | null, refreshDate?: any | null, freeTrialExpiringDate?: any | null, customer?: string | null, createdAt?: any | null, ipAddress?: string | null, accountBalance?: number | null, paymentFromOtherChannel?: any | null, couponCode?: { __typename?: 'CouponCode', _id?: string | null, customer?: string | null, name?: string | null, code?: string | null, status?: string | null, valueType?: CouponValueType | null, value?: any | null, maxRedemptions?: any | null, timesRedeemed?: any | null, usageType?: CouponUsageType | null, usageLimit?: any | null, usageCount?: any | null, expiredAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, addOns: Array<{ __typename?: 'CustomerProductAddOn', _id?: string | null, name?: string | null, quantity?: any | null, renewalType?: string | null, price?: number | null, cancelAtPeriodEnd?: boolean | null, credits?: number | null, nextCredits?: number | null }>, features?: { __typename?: 'Features', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsForm?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, aiHumanReplyLearning?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null, limits?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, usages?: { __typename?: 'LimitsAndUsages', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, liveChat?: number | null, customChannel?: number | null, form?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, message?: string | null, amazon?: number | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, reChargeSettings?: { __typename?: 'NeedChargeLimitType', limit?: number | null, chargeAmount?: number | null, isEnabled?: boolean | null } | null } | null, sendAutoSurvey?: { __typename?: 'sendAutoSurveyType', status?: boolean | null, time?: number | null, closingMessage?: string | null, surveyId?: string | null, channels?: Array<string | null> | null, tagRule?: SurveyTagRuleEnum | null, tags?: Array<string | null> | null } | null, closingNote?: { __typename?: 'ClosingNoteDetail', isEnabled?: boolean | null, autoFillWithAi?: boolean | null, isCompletionRequired?: boolean | null, customFields: Array<{ __typename?: 'CustomField', _id?: string | null, name?: string | null, label?: string | null, description?: string | null, type?: string | null, listValues?: Array<string | null> | null, visibleToCustomers?: EnumCustomFieldCustomerVisibility | null, visibleToUsers?: EnumCustomFieldUserVisibility | null, status?: EnumCustomFieldStatus | null, isDefault?: boolean | null, customer?: string | null, createdAt?: any | null, updatedAt?: any | null, mediaType?: EnumCustomFieldMediaType | null, conditions?: Array<{ __typename?: 'CustomFieldCondition', parentField: string, parentValues: Array<string> } | null> | null }> } | null, twSubAccount?: { __typename?: 'TwSubAccount', sid?: string | null, token?: string | null, apiKeySid?: string | null, apiKeySecret?: string | null } | null, onboarding?: { __typename?: 'CustomerOnboarding', channelConnected?: boolean | null, teamInvited?: boolean | null, accountCustomized?: boolean | null, aiAgentTrained?: boolean | null, mobileAppDownloaded?: boolean | null, introVideoWatched?: boolean | null, completedCount?: number | null, totalCount?: number | null, isVisible?: boolean | null } | null } | null }> } } | null };

export type GetCustomerPaymentCardQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerPaymentCardQuery = { __typename?: 'Query', getCustomerPaymentCard: { __typename?: 'CustomerPaymentCardOutput', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'CustomerPaymentCard', _id?: string | null, customer?: string | null, provider?: string | null, requiresAction?: boolean | null, confirmationUrl?: string | null, threeDSHtmlContent?: string | null, threeDSPaymentPageUrl?: string | null, threeDSPaymentId?: string | null, threeDSConversationId?: string | null, actionType?: string | null, createdAt?: any | null, updatedAt?: any | null, cards?: Array<{ __typename?: 'PaymentCardInfo', _id?: string | null, cardAlias?: string | null, cardBankName?: string | null, lastFourDigits?: string | null, cardType?: string | null, cardAssociation?: string | null, expireMonth?: string | null, expireYear?: string | null, cvc?: string | null, locale?: string | null, status?: string | null, default?: boolean | null, systemTime?: any | null } | null> | null } | null } };

export type GetEmailAdminLogsQueryVariables = Exact<{
  params: GetEmailAdminLogsInput;
}>;


export type GetEmailAdminLogsQuery = { __typename?: 'Query', getEmailAdminLogs: { __typename?: 'EmailAdminLogsResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'EmailAdminLogsData', total: number, logs: Array<{ __typename?: 'EmailAdminLog', _id: string, customer: string, customerName?: string | null, provider?: EmailLogProvider | null, status?: EmailLogStatus | null, from: string, subject?: string | null, templateId?: string | null, templateData?: any | null, html?: string | null, text?: string | null, transportMessageId?: string | null, providerStatusCode?: any | null, errorMessage?: string | null, errorStack?: string | null, expiresAt?: any | null, createdAt: any, updatedAt: any, recipients: { __typename?: 'EmailRecipientGroup', to?: Array<string | null> | null, cc?: Array<string | null> | null, bcc?: Array<string | null> | null, replyTo?: Array<string | null> | null }, attachments?: Array<{ __typename?: 'EmailAttachmentLog', filename?: string | null, contentType?: string | null, size?: any | null } | null> | null, metadata?: { __typename?: 'EmailMetadata', mailType?: string | null } | null }> } | null } };

export type GetHumanReplyLearningJobQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
}>;


export type GetHumanReplyLearningJobQuery = { __typename?: 'Query', getHumanReplyLearningJob: { __typename?: 'HumanReplyLearningJobResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'HumanReplyLearningJob', jobId: string, customerId: string, status: HumanReplyLearningJobStatus, mode: string, totalConversations: number, processedConversations: number, skippedConversations: number, failedConversations: number, remainingConversations: number, progressPercent: number, extractedPairs: number, savedPairs: number, duplicatePairs: number, resolvedConflictPairs: number, totalInputTokens: number, totalOutputTokens: number, totalEstimatedCost: number, modelsUsed: Array<string>, currentConversationId?: string | null, rateLimitedAt?: string | null, rateLimitResumeAt?: string | null, rateLimitRetryCount?: number | null, createdAt: string, startedAt?: string | null, finishedAt?: string | null, cancelRequestedAt?: string | null, cancelledAt?: string | null, countedAt?: string | null, updatedAt: string, usageByModel: Array<{ __typename?: 'HumanReplyLearningModelUsage', model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, costBreakdown: Array<{ __typename?: 'HumanReplyLearningCostBreakdown', stage: string, model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, failures?: Array<{ __typename?: 'HumanReplyLearningFailure', customerId?: string | null, conversationId?: string | null, reason?: string | null }> | null, resolvedConflicts?: Array<{ __typename?: 'HumanReplyLearningResolvedConflict', conversationId: string, existingAiKnowledgeSourceContentId: string, newQuestion: string, newAnswer: string, existingQuestion: string, existingAnswer: string, reason: string }> | null } | null } };

export type GetHumanReplyLearningJobsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHumanReplyLearningJobsQuery = { __typename?: 'Query', getHumanReplyLearningJobs: { __typename?: 'HumanReplyLearningJobsResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'HumanReplyLearningJob', jobId: string, customerId: string, status: HumanReplyLearningJobStatus, mode: string, totalConversations: number, processedConversations: number, skippedConversations: number, failedConversations: number, remainingConversations: number, progressPercent: number, extractedPairs: number, savedPairs: number, duplicatePairs: number, resolvedConflictPairs: number, totalInputTokens: number, totalOutputTokens: number, totalEstimatedCost: number, modelsUsed: Array<string>, currentConversationId?: string | null, rateLimitedAt?: string | null, rateLimitResumeAt?: string | null, rateLimitRetryCount?: number | null, createdAt: string, startedAt?: string | null, finishedAt?: string | null, cancelRequestedAt?: string | null, cancelledAt?: string | null, countedAt?: string | null, updatedAt: string, usageByModel: Array<{ __typename?: 'HumanReplyLearningModelUsage', model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, costBreakdown: Array<{ __typename?: 'HumanReplyLearningCostBreakdown', stage: string, model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, failures?: Array<{ __typename?: 'HumanReplyLearningFailure', customerId?: string | null, conversationId?: string | null, reason?: string | null }> | null, resolvedConflicts?: Array<{ __typename?: 'HumanReplyLearningResolvedConflict', conversationId: string, existingAiKnowledgeSourceContentId: string, newQuestion: string, newAnswer: string, existingQuestion: string, existingAnswer: string, reason: string }> | null }> | null } };

export type GetHumanReplyLearningStatusQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetHumanReplyLearningStatusQuery = { __typename?: 'Query', getHumanReplyLearningStatus: { __typename?: 'HumanReplyLearningJobResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'HumanReplyLearningJob', jobId: string, customerId: string, status: HumanReplyLearningJobStatus, mode: string, totalConversations: number, processedConversations: number, skippedConversations: number, failedConversations: number, remainingConversations: number, progressPercent: number, extractedPairs: number, savedPairs: number, duplicatePairs: number, resolvedConflictPairs: number, totalInputTokens: number, totalOutputTokens: number, totalEstimatedCost: number, modelsUsed: Array<string>, currentConversationId?: string | null, rateLimitedAt?: string | null, rateLimitResumeAt?: string | null, rateLimitRetryCount?: number | null, createdAt: string, startedAt?: string | null, finishedAt?: string | null, cancelRequestedAt?: string | null, cancelledAt?: string | null, countedAt?: string | null, updatedAt: string, usageByModel: Array<{ __typename?: 'HumanReplyLearningModelUsage', model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, costBreakdown: Array<{ __typename?: 'HumanReplyLearningCostBreakdown', stage: string, model: string, requests: number, inputTokens: number, outputTokens: number, estimatedCost: number }>, failures?: Array<{ __typename?: 'HumanReplyLearningFailure', customerId?: string | null, conversationId?: string | null, reason?: string | null }> | null, resolvedConflicts?: Array<{ __typename?: 'HumanReplyLearningResolvedConflict', conversationId: string, existingAiKnowledgeSourceContentId: string, newQuestion: string, newAnswer: string, existingQuestion: string, existingAnswer: string, reason: string }> | null } | null } };

export type GetLiveChatWidgetOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveChatWidgetOverviewQuery = { __typename?: 'Query', getLiveChatWidgetOverview?: { __typename?: 'LiveChatWidgetOverviewResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'LiveChatWidgetOverview', liveTotalBytes?: number | null, config?: { __typename?: 'LiveChatWidgetCdnConfig', bucket?: string | null, region?: string | null, prefix?: string | null, distributionId?: string | null, cdnUrl?: string | null, cacheControl?: string | null } | null, liveFiles?: Array<{ __typename?: 'LiveChatWidgetCdnObject', key?: string | null, size?: number | null, lastModified?: any | null, etag?: string | null } | null> | null, activeRelease?: { __typename?: 'LiveChatWidgetRelease', _id?: string | null, version?: string | null, note?: string | null, status?: LiveChatWidgetReleaseStatus | null, source?: LiveChatWidgetReleaseSource | null, restoredFrom?: string | null, bucket?: string | null, prefix?: string | null, archivePrefix?: string | null, distributionId?: string | null, cdnUrl?: string | null, removedKeys?: Array<string | null> | null, invalidationId?: string | null, invalidationStatus?: string | null, healthCheckUrl?: string | null, healthCheckStatus?: number | null, errorMessage?: string | null, publishedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, files?: Array<{ __typename?: 'LiveChatWidgetFile', path?: string | null, size?: number | null, contentType?: string | null } | null> | null } | null } | null } | null };

export type GetLiveChatWidgetReleaseQueryVariables = Exact<{
  releaseId: Scalars['ID']['input'];
}>;


export type GetLiveChatWidgetReleaseQuery = { __typename?: 'Query', getLiveChatWidgetRelease?: { __typename?: 'LiveChatWidgetReleaseResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'LiveChatWidgetRelease', _id?: string | null, version?: string | null, note?: string | null, status?: LiveChatWidgetReleaseStatus | null, source?: LiveChatWidgetReleaseSource | null, restoredFrom?: string | null, bucket?: string | null, prefix?: string | null, archivePrefix?: string | null, distributionId?: string | null, cdnUrl?: string | null, removedKeys?: Array<string | null> | null, invalidationId?: string | null, invalidationStatus?: string | null, healthCheckUrl?: string | null, healthCheckStatus?: number | null, errorMessage?: string | null, publishedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, files?: Array<{ __typename?: 'LiveChatWidgetFile', path?: string | null, size?: number | null, contentType?: string | null } | null> | null } | null } | null };

export type GetLiveChatWidgetReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveChatWidgetReleasesQuery = { __typename?: 'Query', getLiveChatWidgetReleases?: { __typename?: 'LiveChatWidgetReleaseListResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'LiveChatWidgetRelease', _id?: string | null, version?: string | null, note?: string | null, status?: LiveChatWidgetReleaseStatus | null, source?: LiveChatWidgetReleaseSource | null, restoredFrom?: string | null, bucket?: string | null, prefix?: string | null, archivePrefix?: string | null, distributionId?: string | null, cdnUrl?: string | null, removedKeys?: Array<string | null> | null, invalidationId?: string | null, invalidationStatus?: string | null, healthCheckUrl?: string | null, healthCheckStatus?: number | null, errorMessage?: string | null, publishedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, files?: Array<{ __typename?: 'LiveChatWidgetFile', path?: string | null, size?: number | null, contentType?: string | null } | null> | null } | null> | null } | null };

export type GetLocationCountriesQueryVariables = Exact<{
  params: GetCountriesInput;
}>;


export type GetLocationCountriesQuery = { __typename?: 'Query', getLocationCountries?: { __typename?: 'CountryResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'PaginatedCountry', totalDocs?: number | null, hasNextPage?: boolean | null, hasPrevPage?: boolean | null, docs?: Array<{ __typename?: 'Country', _id?: string | null, name?: string | null, iso2?: string | null, native?: string | null, emoji?: string | null, hasState?: boolean | null, hasProvince?: boolean | null, hasCity?: boolean | null, translations?: { __typename?: 'Translations', kr?: string | null, pt_BR?: string | null, pt?: string | null, nl?: string | null, hr?: string | null, fa?: string | null, de?: string | null, ja?: string | null, it?: string | null, cn?: string | null, tr?: string | null } | null } | null> | null } } | null };

export type GetLocationStatesProvincesCitiesQueryVariables = Exact<{
  params?: InputMaybe<GetStatesProvincesCitiesInput>;
}>;


export type GetLocationStatesProvincesCitiesQuery = { __typename?: 'Query', getLocationStatesProvincesCities?: { __typename?: 'StatesProvincesCitiesResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'PaginatedStateProvinceCity', totalDocs?: number | null, hasNextPage?: boolean | null, hasPrevPage?: boolean | null, docs?: Array<{ __typename?: 'StateProvinceCity', _id?: string | null, name?: string | null, type?: string | null, country?: { __typename?: 'Country', _id?: string | null, name?: string | null, iso2?: string | null, native?: string | null, emoji?: string | null, hasState?: boolean | null, hasProvince?: boolean | null, hasCity?: boolean | null, translations?: { __typename?: 'Translations', kr?: string | null, pt_BR?: string | null, pt?: string | null, nl?: string | null, hr?: string | null, fa?: string | null, de?: string | null, ja?: string | null, it?: string | null, cn?: string | null, tr?: string | null } | null } | null, stateProvince?: { __typename?: 'StateProvinceCity2', _id?: string | null, country?: string | null, stateProvince?: string | null, name?: string | null, type?: string | null } | null } | null> | null } } | null };

export type GetMarketplaceOrdersQueryVariables = Exact<{
  input?: InputMaybe<GetMarketplaceOrdersInput>;
}>;


export type GetMarketplaceOrdersQuery = { __typename?: 'Query', getMarketplaceOrders: { __typename?: 'MarketplaceOrdersResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'MarketplaceOrdersPaginated', hasNextPage?: boolean | null, totalDocs?: number | null, orders: Array<{ __typename?: 'MarketplaceOrder', _id: string, customer: string, marketplace: string, type: MarketplaceType, orderId: string, displayOrderId?: string | null, orderStatus: string, amountPaid: string, currency: string, checkoutStatus: string, taxRate: string, isTaxIncluded: boolean, createdTime: any, subTotal: string, total: string, paymentStatus: string, cancelStatus: string, returnStatus: string, refundStatus: string, createdAt?: any | null, updatedAt?: any | null, shippingAddress: { __typename?: 'MarketplaceOrderShippingAdress', name: string, street1: string, street2?: string | null, city: string, stateOrProvince: string, postalCode: string, country: string, phone: string, addressId: string }, shippingService: { __typename?: 'MarketplaceOrderShippingService', name: string, cost: string }, shipmentTracking?: { __typename?: 'MarketplaceOrderShipmentTracking', shippingCareer?: string | null, trackingNumber?: string | null } | null, buyer: { __typename?: 'MarketplaceBuyer', userId: string, email: string, firstName: string, lastName: string }, items: Array<{ __typename?: 'MarketplaceOrderItem', id: string, location: string, site: string, title: string, quantity: number, sku?: string | null }>, seller: { __typename?: 'MarketplaceSeller', userId: string } }> } | null } };

export type GetMessageForAiSimulationQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;


export type GetMessageForAiSimulationQuery = { __typename?: 'Query', getMessageForAiSimulation: { __typename?: 'MessageForAiSimulationResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'MessageForAiSimulationData', _id: string, messageType: MessageType, content?: string | null, channel?: string | null, channelType?: PlatformType | null, commentData?: { __typename?: 'CommentDataType', status?: string | null, reaction?: string | null, reply?: string | null, repliedCPerson?: string | null, replyDate?: any | null, aiNotResponseReason?: string | null, privateReply?: string | null, privateReplyId?: string | null, privateReplyAiNotResponseReason?: string | null, postUrl?: string | null, postImageUrl?: string | null, postDescription?: string | null, parentComment?: string | null, parentCommentId?: string | null, rating?: number | null, replyState?: string | null, policyViolation?: string | null, isAnonymous?: boolean | null, temporaryReply?: string | null, externalStatus?: string | null, reviewUpdateTime?: any | null } | null, questionData?: { __typename?: 'QuestionDataType', status?: string | null, reply?: string | null, repliedCPerson?: string | null, replyDate?: any | null, productUrl?: string | null, productImageUrl?: string | null, productName?: string | null, productMainId?: string | null, sku?: string | null, isRepliedOnPlatform?: boolean | null, temporaryReply?: string | null, aiNotResponseReason?: string | null, replies?: Array<{ __typename?: 'QuestionReply', content?: string | null, repliedCPerson?: string | null, replyDate?: any | null, status?: string | null, isRobot?: boolean | null, failedReason?: { __typename?: 'FailedReasonType', message?: string | null, code?: string | null, attempt?: number | null } | null } | null> | null } | null, previousMessages?: Array<{ __typename?: 'PreviousMessagePreview', _id: string, role: string, content: string, isAiGenerated?: boolean | null } | null> | null } | null } };

export type GetMigrationHistoryQueryVariables = Exact<{
  type: OneTimesType;
}>;


export type GetMigrationHistoryQuery = { __typename?: 'Query', getMigrationHistory: { __typename?: 'MigrationRunListResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'MigrationRun', _id: string, type: string, status: MigrationRunStatus, succeeded?: boolean | null, startedAt: any, finishedAt?: any | null, durationMs?: number | null, heartbeatAt?: any | null, countsBefore?: string | null, countsAfter?: string | null, result?: string | null, error?: string | null }> | null } };

export type GetMigrationLatestRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMigrationLatestRunsQuery = { __typename?: 'Query', getMigrationLatestRuns: { __typename?: 'MigrationRunListResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'MigrationRun', _id: string, type: string, status: MigrationRunStatus, succeeded?: boolean | null, startedAt: any, finishedAt?: any | null, durationMs?: number | null, heartbeatAt?: any | null, countsBefore?: string | null, countsAfter?: string | null, result?: string | null, error?: string | null }> | null } };

export type GetMobileAppVersionQueryVariables = Exact<{
  input: GetMobileAppVersionInput;
}>;


export type GetMobileAppVersionQuery = { __typename?: 'Query', getMobileAppVersion: { __typename?: 'MobileAppVersionCheckResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: { __typename?: 'MobileAppVersionCheck', platform: MobilePlatform, currentVersion?: string | null, latestVersion?: string | null, minSupportedVersion?: string | null, updateType: MobileUpdateType, storeUrl?: string | null, releaseNotes?: { __typename?: 'MobileReleaseNotes', tr?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null, en?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null, ar?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null } | null } | null } };

export type GetMobileAppVersionConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMobileAppVersionConfigsQuery = { __typename?: 'Query', getMobileAppVersionConfigs?: { __typename?: 'MobileAppVersionConfigListResponse', success?: boolean | null, error?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'MobileAppVersionConfig', _id?: string | null, platform: MobilePlatform, latestVersion?: string | null, minSupportedVersion?: string | null, updateType?: MobileUpdateType | null, storeUrl?: string | null, updatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, releaseNotes?: { __typename?: 'MobileReleaseNotes', tr?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null, en?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null, ar?: { __typename?: 'MobileReleaseNote', title?: string | null, body?: string | null } | null } | null } | null> | null } | null };

export type GetNewPackageCostInfoQueryVariables = Exact<{
  data?: InputMaybe<NewPackCostInput>;
}>;


export type GetNewPackageCostInfoQuery = { __typename?: 'Query', getNewPackageCostInfo: { __typename?: 'getNewPackageCostInfoResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'newPackCostInfoRes', feeCharge?: number | null, totalCost?: number | null, remindCost?: number | null, couponDiscount?: number | null, freeTrialLeftDays?: number | null, aiAssistantCost?: number | null } } };

export type GetPreferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferenceQuery = { __typename?: 'Query', getPreference: { __typename?: 'PreferenceResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'Preference', requireAccountApproval: boolean, autoFormalizeInvoices: AutoFormalizeInvoicesPreference } } };

export type GetReembedKnowledgeSourcesToContextualRagJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetReembedKnowledgeSourcesToContextualRagJobQuery = { __typename?: 'Query', getReembedKnowledgeSourcesToContextualRagJob: { __typename?: 'ReembedKnowledgeSourcesToContextualRagJobResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'ReembedKnowledgeSourcesToContextualRagJob', jobId: string, status: ReembedKnowledgeSourcesJobStatus, allCustomers: boolean, targetCustomerIds?: Array<string> | null, totalCustomers: number, completedCustomers: number, failedCustomers: number, remainingCustomers: number, processedKnowledgeSources: number, processedContents: number, reembeddedContents: number, skippedContents: number, failedContents: number, currentCustomerId?: string | null, completedCustomerIds?: Array<string> | null, failedCustomerIds?: Array<string> | null, createdAt: string, startedAt?: string | null, finishedAt?: string | null, updatedAt: string, failures?: Array<{ __typename?: 'ReembedKnowledgeSourcesFailure', customerId?: string | null, aiKnowledgeSourceId?: string | null, aiKnowledgeSourceContentId?: string | null, reason?: string | null }> | null } | null } };

export type GetUpdateNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUpdateNotificationQuery = { __typename?: 'Query', getUpdateNotification: { __typename?: 'UpdateNotificationResponse', success: boolean, code?: string | null, message?: string | null, data?: { __typename?: 'UpdateNotification', updatedAt: string, message?: string | null } | null } };

export type InspectCollectionQueryVariables = Exact<{
  data: InspectCollectionInput;
}>;


export type InspectCollectionQuery = { __typename?: 'Query', inspectCollection: { __typename?: 'InspectCollectionResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'InspectCollectionResult', collection: string, samples: Array<string>, estimatedTotal?: number | null, counts: Array<{ __typename?: 'InspectCount', key: string, count: number }>, indexes: Array<{ __typename?: 'InspectIndex', name: string, keys: string, unique: boolean }> } | null } };

export type ListAiConversationsQueryVariables = Exact<{
  data: ListInfiniteParams;
}>;


export type ListAiConversationsQuery = { __typename?: 'Query', listAiConversations: { __typename?: 'AiMessagesResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'AiMessagesPaginate', hasNextPage?: boolean | null, totalDocs?: number | null, offset?: number | null, limit?: number | null, docs?: Array<{ __typename?: 'AiMessages', _id: string, customerId: string, questionId: string, answerId?: string | null, question?: string | null, answer?: string | null, status?: AiMessageStatusEnum | null, channelType?: ChannelType | null, conversationId?: any | null, error?: string | null, isTest?: boolean | null, kind?: AiRunKindEnum | null, outcome?: string | null, durationMs?: number | null, failedStepCount?: number | null, createdAt: any, updatedAt: any, answers?: Array<{ __typename?: 'AiMessageAnswer', messageType?: MessageType | null, content?: string | null, messageId?: string | null, productCards?: Array<{ __typename?: 'AiMessageAnswerProductCard', productId?: string | null, title?: string | null, thumbnailUrl?: string | null, optionsSummary?: string | null, productUrl?: string | null, price?: { __typename?: 'AiMessageAnswerProductCardPrice', amount?: string | null, currency?: string | null } | null }> | null }> | null, questionMedia?: Array<{ __typename?: 'ImageMedia', name?: string | null, type?: string | null, path?: string | null } | null> | null, questionContext?: { __typename?: 'AiMessageQuestionContext', productName?: string | null, productLink?: string | null, productImageUrl?: string | null, postUrl?: string | null, postImageUrl?: string | null } | null, usage?: { __typename?: 'AiRunUsage', inputToken?: number | null, cachedInputToken?: number | null, outputToken?: number | null, amount?: number | null, llmCalls?: number | null } | null } | null> | null } } };

export type ListAiMessageStepsQueryVariables = Exact<{
  aiMessageId: Scalars['ID']['input'];
  answerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAiMessageStepsQuery = { __typename?: 'Query', listAiMessageSteps: { __typename?: 'AiMessageStepsResponse', success?: boolean | null, code?: string | null, message?: string | null, data: Array<{ __typename?: 'AiMessageSteps', _id: string, aiMessageId: string, step?: AiAskQuestionTypeEnum | null, stepList: number, status: AiMessageStepStatusEnum, durationMs: number, summary?: string | null, reason?: string | null, request?: any | null, response?: any | null, source?: string | null, createdAt: any, updatedAt: any } | null> } };

export type ListAiMessagesQueryVariables = Exact<{
  data: ListInfiniteParams;
}>;


export type ListAiMessagesQuery = { __typename?: 'Query', listAiMessages: { __typename?: 'AiMessagesResponse', success?: boolean | null, code?: string | null, message?: string | null, data: { __typename?: 'AiMessagesPaginate', hasNextPage?: boolean | null, totalDocs?: number | null, offset?: number | null, limit?: number | null, docs?: Array<{ __typename?: 'AiMessages', _id: string, customerId: string, questionId: string, answerId?: string | null, question?: string | null, answer?: string | null, status?: AiMessageStatusEnum | null, channelType?: ChannelType | null, conversationId?: any | null, error?: string | null, isTest?: boolean | null, kind?: AiRunKindEnum | null, outcome?: string | null, durationMs?: number | null, failedStepCount?: number | null, createdAt: any, updatedAt: any, answers?: Array<{ __typename?: 'AiMessageAnswer', messageType?: MessageType | null, content?: string | null, messageId?: string | null, productCards?: Array<{ __typename?: 'AiMessageAnswerProductCard', productId?: string | null, title?: string | null, thumbnailUrl?: string | null, optionsSummary?: string | null, productUrl?: string | null, price?: { __typename?: 'AiMessageAnswerProductCardPrice', amount?: string | null, currency?: string | null } | null }> | null }> | null, questionMedia?: Array<{ __typename?: 'ImageMedia', name?: string | null, type?: string | null, path?: string | null } | null> | null, questionContext?: { __typename?: 'AiMessageQuestionContext', productName?: string | null, productLink?: string | null, productImageUrl?: string | null, postUrl?: string | null, postImageUrl?: string | null } | null, usage?: { __typename?: 'AiRunUsage', inputToken?: number | null, cachedInputToken?: number | null, outputToken?: number | null, amount?: number | null, llmCalls?: number | null } | null } | null> | null } } };

export type ProductsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResponse', success?: boolean | null, code?: string | null, message?: string | null, data: Array<{ __typename?: 'Product', _id?: string | null, name?: string | null, monthlyPrice?: any | null, yearlyPrice?: any | null, createdAt?: any | null, limits?: { __typename?: 'ProductLimitsType', cPerson?: number | null, cPersonRoles?: number | null, person?: number | null, whatsAppWeb?: number | null, whatsAppBusiness?: number | null, metaWhatsAppBusiness?: number | null, facebook?: number | null, email?: number | null, instagram?: number | null, tiktok?: number | null, telegram?: number | null, trendyol?: number | null, amazon?: number | null, hepsiburada?: number | null, ebay?: number | null, kaufland?: number | null, pazarama?: number | null, walmart?: number | null, n11?: number | null, teams?: number | null, apiKeys?: number | null, webhooks?: number | null, inboxRules?: number | null, flowBots?: number | null, survey?: number | null, liveChat?: number | null, customChannel?: number | null, message?: string | null, aiAnswers?: number | null, zoho?: number | null, callMinutes?: number | null, phone?: number | null, aiAssistant?: number | null, ticket?: number | null, qpienShop?: number | null, ikas?: number | null, faprika?: number | null, ticimax?: number | null, tsoft?: number | null, ideasoft?: number | null, shopify?: number | null, googleBusiness?: number | null, slaPolicies?: number | null, tables?: number | null, tableRecords?: number | null, customReports?: number | null, operatorCredits?: number | null } | null, features?: { __typename?: 'ProductFeatureType', dashboard?: boolean | null, inbox?: boolean | null, inboxPrivateMessage?: boolean | null, inboxBulkActions?: boolean | null, inboxCustomViews?: boolean | null, inboxMessageTranslation?: boolean | null, contacts?: boolean | null, contactsDynamicGroups?: boolean | null, contactsMergeContacts?: boolean | null, contactsImport?: boolean | null, contactsExport?: boolean | null, statistics?: boolean | null, statisticsConversations?: boolean | null, statisticsMessages?: boolean | null, statisticsUsers?: boolean | null, statisticsPerformance?: boolean | null, statisticsSatisfactions?: boolean | null, statisticsAbandonedCarts?: boolean | null, statisticsCampaign?: boolean | null, settings?: boolean | null, settingsUsers?: boolean | null, settingsUserRoles?: boolean | null, settingsActions?: boolean | null, settingsAuthentications?: boolean | null, settingsApiKeys?: boolean | null, settingsWebhooks?: boolean | null, settingsTeams?: boolean | null, settingsTags?: boolean | null, settingsQuickAnswers?: boolean | null, settingsAutoAssignment?: boolean | null, settingsTeamGoals?: boolean | null, settingsSlaPolicies?: boolean | null, settingsTopics?: boolean | null, settingsTopicsAutoFill?: boolean | null, settingsCustomFields?: boolean | null, settingsSurveys?: boolean | null, channels?: boolean | null, channelsLiveChat?: boolean | null, channelsCustomChannel?: boolean | null, channelsLiveChatRemoveQpienLogo?: boolean | null, channelsEmail?: boolean | null, channelsSms?: boolean | null, channelsPhone?: boolean | null, channelsWhatsAppWeb?: boolean | null, channelsWhatsAppBusinessApi?: boolean | null, channelsMetaWhatsAppBusinessApi?: boolean | null, channelsTelegram?: boolean | null, channelsFacebookDm?: boolean | null, channelsFacebookComment?: boolean | null, channelsInstagramDm?: boolean | null, channelsInstagramComment?: boolean | null, channelsTiktokDm?: boolean | null, channelsTiktokComment?: boolean | null, channelsMarketplace?: boolean | null, campaignEngineV2?: boolean | null, automation?: boolean | null, automationFlowBots?: boolean | null, teamChat?: boolean | null, automationEcommerce?: boolean | null, automationFlowBotsHttpRequest?: boolean | null, automationFlowBotsStartFlow?: boolean | null, channelsEcommerce?: boolean | null, channelsPhoneCallRecord?: boolean | null, channelsPhoneInboundCalls?: boolean | null, channelsPhoneSurvey?: boolean | null, channelsPhoneOutboundCalls?: boolean | null, channelsPhoneTestToSpeech?: boolean | null, channelsPhonelVR?: boolean | null, statisticsConversationTags?: boolean | null, ai?: boolean | null, aiAnalysis?: boolean | null, AiAgent?: boolean | null, AiAssistant?: boolean | null, AiClosingTag?: boolean | null, AiClosingNote?: boolean | null, AiClosingSurvey?: boolean | null, AiStartFlow?: boolean | null, AiStatistics?: boolean | null, aiImageRecognition?: boolean | null, bulkSharing?: boolean | null, zohoIntegration?: boolean | null, collageSharing?: boolean | null, tasks?: boolean | null, snooze?: boolean | null, messageSchedule?: boolean | null, channelsPhoneCallTranscripts?: boolean | null, channelsPhoneCallAiAnalysis?: boolean | null, removeEmailQpienLogo?: boolean | null, tables?: boolean | null, customReports?: boolean | null, channelOwner?: boolean | null, userActivity?: boolean | null, autoAway?: boolean | null } | null }> } };

export type SearchAiHelpQueryVariables = Exact<{
  data: AiHelpSearchInput;
}>;


export type SearchAiHelpQuery = { __typename?: 'Query', searchAiHelp: { __typename?: 'AiHelpSearchResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: Array<{ __typename?: 'AiHelpSectionHit', articleId: string, slug: string, title: string, panelPath?: string | null, permissions?: Array<string> | null, contentId: string, heading: string, text: string, score: number, images: Array<{ __typename?: 'AiHelpImage', key: string, url: string, caption?: string | null, description?: string | null }> }> | null } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResponse', success?: boolean | null, code?: string | null, message?: string | null, data: Array<{ __typename?: 'User', _id?: string | null, name?: string | null, surname?: string | null, role?: RoleTypes | null, phone?: string | null, email?: string | null, createdAt?: any | null }> } };

export type CreatedAiMessageSubscriptionVariables = Exact<{
  data: AiMessageSubscriptionInput;
}>;


export type CreatedAiMessageSubscription = { __typename?: 'Subscription', createdAiMessage: { __typename?: 'AiMessageEventResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiMessages', _id: string, customerId: string, questionId: string, answerId?: string | null, question?: string | null, answer?: string | null, status?: AiMessageStatusEnum | null, channelType?: ChannelType | null, conversationId?: any | null, error?: string | null, isTest?: boolean | null, kind?: AiRunKindEnum | null, outcome?: string | null, durationMs?: number | null, failedStepCount?: number | null, createdAt: any, updatedAt: any, answers?: Array<{ __typename?: 'AiMessageAnswer', messageType?: MessageType | null, content?: string | null, messageId?: string | null, productCards?: Array<{ __typename?: 'AiMessageAnswerProductCard', productId?: string | null, title?: string | null, thumbnailUrl?: string | null, optionsSummary?: string | null, productUrl?: string | null, price?: { __typename?: 'AiMessageAnswerProductCardPrice', amount?: string | null, currency?: string | null } | null }> | null }> | null, questionMedia?: Array<{ __typename?: 'ImageMedia', name?: string | null, type?: string | null, path?: string | null } | null> | null, questionContext?: { __typename?: 'AiMessageQuestionContext', productName?: string | null, productLink?: string | null, productImageUrl?: string | null, postUrl?: string | null, postImageUrl?: string | null } | null, usage?: { __typename?: 'AiRunUsage', inputToken?: number | null, cachedInputToken?: number | null, outputToken?: number | null, amount?: number | null, llmCalls?: number | null } | null } | null } };

export type UpdatedAiMessageSubscriptionVariables = Exact<{
  data: AiMessageSubscriptionInput;
}>;


export type UpdatedAiMessageSubscription = { __typename?: 'Subscription', updatedAiMessage: { __typename?: 'AiMessageEventResponse', success?: boolean | null, code?: string | null, message?: string | null, data?: { __typename?: 'AiMessages', _id: string, customerId: string, questionId: string, answerId?: string | null, question?: string | null, answer?: string | null, status?: AiMessageStatusEnum | null, channelType?: ChannelType | null, conversationId?: any | null, error?: string | null, isTest?: boolean | null, kind?: AiRunKindEnum | null, outcome?: string | null, durationMs?: number | null, failedStepCount?: number | null, createdAt: any, updatedAt: any, answers?: Array<{ __typename?: 'AiMessageAnswer', messageType?: MessageType | null, content?: string | null, messageId?: string | null, productCards?: Array<{ __typename?: 'AiMessageAnswerProductCard', productId?: string | null, title?: string | null, thumbnailUrl?: string | null, optionsSummary?: string | null, productUrl?: string | null, price?: { __typename?: 'AiMessageAnswerProductCardPrice', amount?: string | null, currency?: string | null } | null }> | null }> | null, questionMedia?: Array<{ __typename?: 'ImageMedia', name?: string | null, type?: string | null, path?: string | null } | null> | null, questionContext?: { __typename?: 'AiMessageQuestionContext', productName?: string | null, productLink?: string | null, productImageUrl?: string | null, postUrl?: string | null, postImageUrl?: string | null } | null, usage?: { __typename?: 'AiRunUsage', inputToken?: number | null, cachedInputToken?: number | null, outputToken?: number | null, amount?: number | null, llmCalls?: number | null } | null } | null } };


export const AddCouponCodeToCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCouponCodeToCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCouponCodeToCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCouponCodeToCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<AddCouponCodeToCustomerMutation, AddCouponCodeToCustomerMutationVariables>;
export const AdminSignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"adminSignIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignInAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSignIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<AdminSignInMutation, AdminSignInMutationVariables>;
export const ArchiveAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ArchiveAnnouncementMutation, ArchiveAnnouncementMutationVariables>;
export const CancelHumanReplyLearningJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelHumanReplyLearningJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelHumanReplyLearningJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"totalConversations"}},{"kind":"Field","name":{"kind":"Name","value":"processedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"skippedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"failedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"remainingConversations"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}},{"kind":"Field","name":{"kind":"Name","value":"extractedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"savedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"duplicatePairs"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflictPairs"}},{"kind":"Field","name":{"kind":"Name","value":"totalInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalOutputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalEstimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"modelsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"usageByModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"failures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflicts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"existingAiKnowledgeSourceContentId"}},{"kind":"Field","name":{"kind":"Name","value":"newQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"newAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"existingQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"existingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitResumeAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitRetryCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"countedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CancelHumanReplyLearningJobMutation, CancelHumanReplyLearningJobMutationVariables>;
export const CancelSpecialOfferPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelSpecialOfferPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelSpecialOfferPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CancelSpecialOfferPackageMutation, CancelSpecialOfferPackageMutationVariables>;
export const ChangeAccountStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeAccountStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeAccountStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeAccountStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"autoAssignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerFromChannel"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isANewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"isDummy"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"appStatus"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"allowConnect"}},{"kind":"Field","name":{"kind":"Name","value":"is2FARequired"}},{"kind":"Field","name":{"kind":"Name","value":"teamGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamOnlineGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamFirstResponseGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"sendAutoSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"closingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"tagRule"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoFillWithAi"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listValues"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentField"}},{"kind":"Field","name":{"kind":"Name","value":"parentValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToUsers"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cPersonsAutoAwayTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoApproveSharingRequests"}},{"kind":"Field","name":{"kind":"Name","value":"canManageOtherUserConversation"}},{"kind":"Field","name":{"kind":"Name","value":"allowUnassignedTicket"}},{"kind":"Field","name":{"kind":"Name","value":"twSubAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySid"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConnected"}},{"kind":"Field","name":{"kind":"Name","value":"teamInvited"}},{"kind":"Field","name":{"kind":"Name","value":"accountCustomized"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentTrained"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"introVideoWatched"}},{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerCode"}},{"kind":"Field","name":{"kind":"Name","value":"signUpMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ChangeAccountStatusMutation, ChangeAccountStatusMutationVariables>;
export const ChangeCustomerProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeCustomerProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeCustomerProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeCustomerProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ChangeCustomerProductMutation, ChangeCustomerProductMutationVariables>;
export const CreateAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const CreateAnnouncementCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAnnouncementCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChangelogCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnnouncementCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateAnnouncementCategoryMutation, CreateAnnouncementCategoryMutationVariables>;
export const CreateCollageTemplateSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCollageTemplateSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCollageTemplateSetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCollageTemplateSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"parentFolder"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"selectedCPersons"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"frame"}},{"kind":"Field","name":{"kind":"Name","value":"collage"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"mainColor"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"priceTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"discountLabel"}},{"kind":"Field","name":{"kind":"Name","value":"discountStyle"}},{"kind":"Field","name":{"kind":"Name","value":"footerFontWeight"}},{"kind":"Field","name":{"kind":"Name","value":"footerPriceSizeDelta"}},{"kind":"Field","name":{"kind":"Name","value":"footerCodeSizeDelta"}},{"kind":"Field","name":{"kind":"Name","value":"mainLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coverImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDataSource"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"selectedCPersons"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateCollageTemplateSetMutation, CreateCollageTemplateSetMutationVariables>;
export const CreateCouponCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCouponCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCouponCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCouponCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateCouponCodeMutation, CreateCouponCodeMutationVariables>;
export const CreateCustomerBillingAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCustomerBillingAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerBillingAddressesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerBillingAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"accountingContactId"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"isCompany"}},{"kind":"Field","name":{"kind":"Name","value":"legalCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"taxOffice"}},{"kind":"Field","name":{"kind":"Name","value":"taxNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateCustomerBillingAddressesMutation, CreateCustomerBillingAddressesMutationVariables>;
export const CreateRandomMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRandomMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"createRandomMessageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRandomMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateRandomMessageMutation, CreateRandomMessageMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteAiHelpArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAiHelpArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpArticleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAiHelpArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteAiHelpArticleMutation, DeleteAiHelpArticleMutationVariables>;
export const DeleteAiMessagesByDateRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAiMessagesByDateRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteByDateRangeParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAiMessagesByDateRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}},{"kind":"Field","name":{"kind":"Name","value":"deletedSteps"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteAiMessagesByDateRangeMutation, DeleteAiMessagesByDateRangeMutationVariables>;
export const DeleteAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const DeleteAnnouncementCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAnnouncementCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteChangelogCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAnnouncementCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteAnnouncementCategoryMutation, DeleteAnnouncementCategoryMutationVariables>;
export const DeleteCallAdminLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCallAdminLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCallAdminLogsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCallAdminLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteCallAdminLogsMutation, DeleteCallAdminLogsMutationVariables>;
export const DeleteCouponCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCouponCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCouponCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCouponCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteCouponCodeMutation, DeleteCouponCodeMutationVariables>;
export const DeleteCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const DeleteCustomerPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCustomerPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCustomerPersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCustomerPerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginTime"}},{"kind":"Field","name":{"kind":"Name","value":"statusAwayTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvLimit"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvCount"}},{"kind":"Field","name":{"kind":"Name","value":"signedTeams"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSound"}},{"kind":"Field","name":{"kind":"Name","value":"messageSound"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSoundVolume"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCardEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePushNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"newUnassignedConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newConversationAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInConversationsAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInUnassignedConversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskReminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTableRecordAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newCommentInAssignedTableRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newPrivateChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTeamChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importRecordsToTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportTableRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskCommentMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingDomainVerified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qpienAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptingCalls"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPhoneCalls"}},{"kind":"Field","name":{"kind":"Name","value":"isInCall"}},{"kind":"Field","name":{"kind":"Name","value":"is2FAEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasAiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"productTour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mainSkippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"boardsCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeVideoWatchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteCustomerPersonMutation, DeleteCustomerPersonMutationVariables>;
export const DeleteEmailAdminLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEmailAdminLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteEmailAdminLogsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEmailAdminLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteEmailAdminLogsMutation, DeleteEmailAdminLogsMutationVariables>;
export const DeletePlatformDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePlatform"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlatformType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeletePlatformTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePlatform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"metaData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeletePlatformMutation, DeletePlatformMutationVariables>;
export const DeleteTestConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTestConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTestConversationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTestConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteTestConversationMutation, DeleteTestConversationMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const DisableAiEngineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"disableAiEngine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiEngineVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableAiEngine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"routing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"by"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DisableAiEngineMutation, DisableAiEngineMutationVariables>;
export const EnableAiEngineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enableAiEngine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiEngineVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableAiEngine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"routing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"by"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<EnableAiEngineMutation, EnableAiEngineMutationVariables>;
export const GetCustomerSessionByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getCustomerSessionByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerSessionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerSessionByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"cPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginTime"}},{"kind":"Field","name":{"kind":"Name","value":"statusAwayTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvLimit"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvCount"}},{"kind":"Field","name":{"kind":"Name","value":"signedTeams"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSound"}},{"kind":"Field","name":{"kind":"Name","value":"messageSound"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSoundVolume"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCardEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePushNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"newUnassignedConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newConversationAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInConversationsAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInUnassignedConversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskReminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTableRecordAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newCommentInAssignedTableRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newPrivateChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTeamChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importRecordsToTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportTableRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskCommentMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingDomainVerified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qpienAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptingCalls"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPhoneCalls"}},{"kind":"Field","name":{"kind":"Name","value":"isInCall"}},{"kind":"Field","name":{"kind":"Name","value":"is2FAEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasAiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"productTour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mainSkippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"boardsCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeVideoWatchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCustomerSessionByAdminMutation, GetCustomerSessionByAdminMutationVariables>;
export const ImportAiHelpPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"importAiHelpPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpImportPdfInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importAiHelpPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"related"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDate"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"panelPath"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"chunkCount"}},{"kind":"Field","name":{"kind":"Name","value":"indexedAt"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"useCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ImportAiHelpPdfMutation, ImportAiHelpPdfMutationVariables>;
export const InvalidateLiveChatWidgetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"invalidateLiveChatWidgetCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invalidateLiveChatWidgetCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InvalidateLiveChatWidgetCacheMutation, InvalidateLiveChatWidgetCacheMutationVariables>;
export const OneTimesUpdateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"oneTimesUpdateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"oneTimesType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oneTimesUpdateMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"metaData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<OneTimesUpdateMutationMutation, OneTimesUpdateMutationMutationVariables>;
export const PinAiEngineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pinAiEngine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiEnginePinInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pinAiEngine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"routing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"by"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<PinAiEngineMutation, PinAiEngineMutationVariables>;
export const PublishAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<PublishAnnouncementMutation, PublishAnnouncementMutationVariables>;
export const PublishLiveChatWidgetReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishLiveChatWidgetRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishLiveChatWidgetReleaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishLiveChatWidgetRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"restoredFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"archivePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"distributionId"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removedKeys"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationId"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckUrl"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckStatus"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<PublishLiveChatWidgetReleaseMutation, PublishLiveChatWidgetReleaseMutationVariables>;
export const ReindexAiHelpArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reindexAiHelpArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpArticleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reindexAiHelpArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"related"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDate"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"panelPath"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"chunkCount"}},{"kind":"Field","name":{"kind":"Name","value":"indexedAt"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"useCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ReindexAiHelpArticleMutation, ReindexAiHelpArticleMutationVariables>;
export const RemoveCouponCodeFromCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCouponCodeFromCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveCouponCodeFromCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCouponCodeFromCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RemoveCouponCodeFromCustomerMutation, RemoveCouponCodeFromCustomerMutationVariables>;
export const RemoveCustomerPaymentCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCustomerPaymentCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeCustomerPaymentCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCustomerPaymentCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"cardAlias"}},{"kind":"Field","name":{"kind":"Name","value":"cardBankName"}},{"kind":"Field","name":{"kind":"Name","value":"lastFourDigits"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"cardAssociation"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"cvc"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"systemTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"requiresAction"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSHtmlContent"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSPaymentPageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RemoveCustomerPaymentCardMutation, RemoveCustomerPaymentCardMutationVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resendVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResolveAiHelpGapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resolveAiHelpGaps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpResolveGapsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveAiHelpGaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ResolveAiHelpGapsMutation, ResolveAiHelpGapsMutationVariables>;
export const RetryPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"retryPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RetryPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retryPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RetryPaymentMutation, RetryPaymentMutationVariables>;
export const RollbackAiEngineRoutingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"rollbackAiEngineRouting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiEngineRollbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rollbackAiEngineRouting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"routing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"by"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RollbackAiEngineRoutingMutation, RollbackAiEngineRoutingMutationVariables>;
export const RollbackLiveChatWidgetReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"rollbackLiveChatWidgetRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RollbackLiveChatWidgetReleaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rollbackLiveChatWidgetRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"restoredFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"archivePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"distributionId"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removedKeys"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationId"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckUrl"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckStatus"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RollbackLiveChatWidgetReleaseMutation, RollbackLiveChatWidgetReleaseMutationVariables>;
export const SaveAiHelpArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveAiHelpArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpSaveArticleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveAiHelpArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"related"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDate"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"panelPath"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"chunkCount"}},{"kind":"Field","name":{"kind":"Name","value":"indexedAt"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"useCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SaveAiHelpArticleMutation, SaveAiHelpArticleMutationVariables>;
export const ScheduleAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"scheduleAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ScheduleAnnouncementMutation, ScheduleAnnouncementMutationVariables>;
export const SendSpecialOfferPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendSpecialOfferPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialOfferPackageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendSpecialOfferPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SendSpecialOfferPackageMutation, SendSpecialOfferPackageMutationVariables>;
export const SetAiEngineDefaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setAiEngineDefault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiEngineDefaultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setAiEngineDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"routing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"by"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SetAiEngineDefaultMutation, SetAiEngineDefaultMutationVariables>;
export const SetUpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setUpdateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUpdateNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SetUpdateNotificationMutation, SetUpdateNotificationMutationVariables>;
export const StartMigrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startMigration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"oneTimesType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"probe"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectCollectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startMigration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"probe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"probe"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"succeeded"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"heartbeatAt"}},{"kind":"Field","name":{"kind":"Name","value":"countsBefore"}},{"kind":"Field","name":{"kind":"Name","value":"countsAfter"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<StartMigrationMutation, StartMigrationMutationVariables>;
export const StartReembedKnowledgeSourcesToContextualRagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startReembedKnowledgeSourcesToContextualRag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReembedKnowledgeSourcesToContextualRagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startReembedKnowledgeSourcesToContextualRag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"allCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"targetCustomerIds"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"completedCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"failedCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"processedKnowledgeSources"}},{"kind":"Field","name":{"kind":"Name","value":"processedContents"}},{"kind":"Field","name":{"kind":"Name","value":"reembeddedContents"}},{"kind":"Field","name":{"kind":"Name","value":"skippedContents"}},{"kind":"Field","name":{"kind":"Name","value":"failedContents"}},{"kind":"Field","name":{"kind":"Name","value":"currentCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"completedCustomerIds"}},{"kind":"Field","name":{"kind":"Name","value":"failedCustomerIds"}},{"kind":"Field","name":{"kind":"Name","value":"failures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"aiKnowledgeSourceId"}},{"kind":"Field","name":{"kind":"Name","value":"aiKnowledgeSourceContentId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<StartReembedKnowledgeSourcesToContextualRagMutation, StartReembedKnowledgeSourcesToContextualRagMutationVariables>;
export const TestAiWithConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"testAiWithConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TestAiWithConversationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testAiWithConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"personId"}},{"kind":"Field","name":{"kind":"Name","value":"aiPersonMemoryId"}},{"kind":"Field","name":{"kind":"Name","value":"aiProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"aiMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"aiRole"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commerceProductCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"optionsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"productUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"noNeedInfoContent"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPositive"}},{"kind":"Field","name":{"kind":"Name","value":"isNegative"}},{"kind":"Field","name":{"kind":"Name","value":"isHumanSupport"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiAction"}},{"kind":"Field","name":{"kind":"Name","value":"responseExplanation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sideEffects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetName"}},{"kind":"Field","name":{"kind":"Name","value":"dryRun"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skillActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"command"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"dryRun"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"privateReply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"aiAction"}},{"kind":"Field","name":{"kind":"Name","value":"isOnlyReply"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commerceApproval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commerceLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dryRunSkipped"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<TestAiWithConversationMutation, TestAiWithConversationMutationVariables>;
export const TranslateAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"translateAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TranslateChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translateAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<TranslateAnnouncementMutation, TranslateAnnouncementMutationVariables>;
export const UnarchiveAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unarchiveAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unarchiveAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UnarchiveAnnouncementMutation, UnarchiveAnnouncementMutationVariables>;
export const UnpinAiEngineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unpinAiEngine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiEngineUnpinInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpinAiEngine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"routing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"by"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UnpinAiEngineMutation, UnpinAiEngineMutationVariables>;
export const UnpublishAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unpublishAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpublishAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UnpublishAnnouncementMutation, UnpublishAnnouncementMutationVariables>;
export const UpdateAiHelpArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAiHelpArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpUpdateArticleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAiHelpArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"related"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDate"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"panelPath"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"chunkCount"}},{"kind":"Field","name":{"kind":"Name","value":"indexedAt"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"useCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateAiHelpArticleMutation, UpdateAiHelpArticleMutationVariables>;
export const UpdateAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChangelogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const UpdateAnnouncementCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAnnouncementCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChangelogCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnnouncementCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateAnnouncementCategoryMutation, UpdateAnnouncementCategoryMutationVariables>;
export const UpdateAutoFormalizeInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAutoFormalizeInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutoFormalizeInvoicesPreference"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAutoFormalizeInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireAccountApproval"}},{"kind":"Field","name":{"kind":"Name","value":"autoFormalizeInvoices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateAutoFormalizeInvoicesMutation, UpdateAutoFormalizeInvoicesMutationVariables>;
export const UpdateChangelogSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateChangelogSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChangelogSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChangelogSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"supportedLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTimezone"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmail"}},{"kind":"Field","name":{"kind":"Name","value":"senderWhatsapp"}},{"kind":"Field","name":{"kind":"Name","value":"senderCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAudience"}},{"kind":"Field","name":{"kind":"Name","value":"includeInactiveCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"includeArchivedPersons"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateChangelogSettingsMutation, UpdateChangelogSettingsMutationVariables>;
export const UpdateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"autoAssignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerFromChannel"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isANewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"isDummy"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"appStatus"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"allowConnect"}},{"kind":"Field","name":{"kind":"Name","value":"is2FARequired"}},{"kind":"Field","name":{"kind":"Name","value":"teamGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamOnlineGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamFirstResponseGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"sendAutoSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"closingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"tagRule"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoFillWithAi"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listValues"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentField"}},{"kind":"Field","name":{"kind":"Name","value":"parentValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToUsers"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cPersonsAutoAwayTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoApproveSharingRequests"}},{"kind":"Field","name":{"kind":"Name","value":"canManageOtherUserConversation"}},{"kind":"Field","name":{"kind":"Name","value":"allowUnassignedTicket"}},{"kind":"Field","name":{"kind":"Name","value":"twSubAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySid"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConnected"}},{"kind":"Field","name":{"kind":"Name","value":"teamInvited"}},{"kind":"Field","name":{"kind":"Name","value":"accountCustomized"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentTrained"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"introVideoWatched"}},{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerCode"}},{"kind":"Field","name":{"kind":"Name","value":"signUpMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const UpdateCustomerInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerInvoiceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"autoAssignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerFromChannel"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isANewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"isDummy"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"appStatus"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"allowConnect"}},{"kind":"Field","name":{"kind":"Name","value":"is2FARequired"}},{"kind":"Field","name":{"kind":"Name","value":"teamGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamOnlineGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamFirstResponseGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"sendAutoSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"closingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"tagRule"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoFillWithAi"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listValues"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentField"}},{"kind":"Field","name":{"kind":"Name","value":"parentValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToUsers"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cPersonsAutoAwayTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoApproveSharingRequests"}},{"kind":"Field","name":{"kind":"Name","value":"canManageOtherUserConversation"}},{"kind":"Field","name":{"kind":"Name","value":"allowUnassignedTicket"}},{"kind":"Field","name":{"kind":"Name","value":"twSubAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySid"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConnected"}},{"kind":"Field","name":{"kind":"Name","value":"teamInvited"}},{"kind":"Field","name":{"kind":"Name","value":"accountCustomized"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentTrained"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"introVideoWatched"}},{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerCode"}},{"kind":"Field","name":{"kind":"Name","value":"signUpMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"accountingInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"accountingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerInvoiceMutation, UpdateCustomerInvoiceMutationVariables>;
export const UpdateCustomerOnboardingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerOnboardingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCOnboardingInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerOnboardingInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyWebsite"}},{"kind":"Field","name":{"kind":"Name","value":"howBuiltWebsite"}},{"kind":"Field","name":{"kind":"Name","value":"companySize"}},{"kind":"Field","name":{"kind":"Name","value":"companyIndustry"}},{"kind":"Field","name":{"kind":"Name","value":"ownerRole"}},{"kind":"Field","name":{"kind":"Name","value":"favouriteProducts"}},{"kind":"Field","name":{"kind":"Name","value":"howYouHearAboutUs"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"sectorOther"}},{"kind":"Field","name":{"kind":"Name","value":"teamSize"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"platformOther"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceOther"}},{"kind":"Field","name":{"kind":"Name","value":"aiInterest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerOnboardingInfoMutation, UpdateCustomerOnboardingInfoMutationVariables>;
export const UpdateCustomerPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerPersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerPerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginTime"}},{"kind":"Field","name":{"kind":"Name","value":"statusAwayTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvLimit"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvCount"}},{"kind":"Field","name":{"kind":"Name","value":"signedTeams"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSound"}},{"kind":"Field","name":{"kind":"Name","value":"messageSound"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSoundVolume"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCardEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePushNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"newUnassignedConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newConversationAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInConversationsAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInUnassignedConversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskReminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTableRecordAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newCommentInAssignedTableRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newPrivateChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTeamChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importRecordsToTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportTableRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskCommentMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingDomainVerified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qpienAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptingCalls"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPhoneCalls"}},{"kind":"Field","name":{"kind":"Name","value":"isInCall"}},{"kind":"Field","name":{"kind":"Name","value":"is2FAEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasAiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"productTour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mainSkippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"boardsCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeVideoWatchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerPersonMutation, UpdateCustomerPersonMutationVariables>;
export const UpdateCustomerProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerProductMutation, UpdateCustomerProductMutationVariables>;
export const UpdateCustomerProductPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerProductPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerProductPlanInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerProductPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"autoAssignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerFromChannel"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isANewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"isDummy"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"appStatus"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"allowConnect"}},{"kind":"Field","name":{"kind":"Name","value":"is2FARequired"}},{"kind":"Field","name":{"kind":"Name","value":"teamGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamOnlineGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamFirstResponseGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"sendAutoSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"closingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"tagRule"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoFillWithAi"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listValues"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentField"}},{"kind":"Field","name":{"kind":"Name","value":"parentValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToUsers"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cPersonsAutoAwayTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoApproveSharingRequests"}},{"kind":"Field","name":{"kind":"Name","value":"canManageOtherUserConversation"}},{"kind":"Field","name":{"kind":"Name","value":"allowUnassignedTicket"}},{"kind":"Field","name":{"kind":"Name","value":"twSubAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySid"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConnected"}},{"kind":"Field","name":{"kind":"Name","value":"teamInvited"}},{"kind":"Field","name":{"kind":"Name","value":"accountCustomized"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentTrained"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"introVideoWatched"}},{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerCode"}},{"kind":"Field","name":{"kind":"Name","value":"signUpMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerProductPlanMutation, UpdateCustomerProductPlanMutationVariables>;
export const UpdateMobileAppVersionConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMobileAppVersionConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMobileAppVersionConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMobileAppVersionConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"latestVersion"}},{"kind":"Field","name":{"kind":"Name","value":"minSupportedVersion"}},{"kind":"Field","name":{"kind":"Name","value":"updateType"}},{"kind":"Field","name":{"kind":"Name","value":"storeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"releaseNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateMobileAppVersionConfigMutation, UpdateMobileAppVersionConfigMutationVariables>;
export const UpdatePlatformDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePlatform"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlatformType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePlatformInputData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlatform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"metaData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdatePlatformMutation, UpdatePlatformMutationVariables>;
export const UpdateRequireAccountApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRequireAccountApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvalRequired"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRequireAccountApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"approvalRequired"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvalRequired"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireAccountApproval"}},{"kind":"Field","name":{"kind":"Name","value":"autoFormalizeInvoices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateRequireAccountApprovalMutation, UpdateRequireAccountApprovalMutationVariables>;
export const UpdateSpecialOfferPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSpecialOfferPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialOfferPackageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSpecialOfferPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateSpecialOfferPackageMutation, UpdateSpecialOfferPackageMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UploadAnnouncementMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadAnnouncementMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadChangelogMediaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAnnouncementMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UploadAnnouncementMediaMutation, UploadAnnouncementMediaMutationVariables>;
export const VerifyEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"verifyEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPersonId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const AnalyzeAiMessageRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"analyzeAiMessageRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyzeAiMessageRunInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyzeAiMessageRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<AnalyzeAiMessageRunQuery, AnalyzeAiMessageRunQueryVariables>;
export const CouponCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"couponCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAllCouponCodesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"couponCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CouponCodesQuery, CouponCodesQueryVariables>;
export const CustomerPersonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerPersons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notSelectBot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromLiveChat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeAi"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeArchived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEmailVerified"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSortInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"notSelectBot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notSelectBot"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromLiveChat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLiveChat"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeAi"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeAi"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeArchived"}}},{"kind":"Argument","name":{"kind":"Name","value":"isEmailVerified"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEmailVerified"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginTime"}},{"kind":"Field","name":{"kind":"Name","value":"statusAwayTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvLimit"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvCount"}},{"kind":"Field","name":{"kind":"Name","value":"signedTeams"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSound"}},{"kind":"Field","name":{"kind":"Name","value":"messageSound"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSoundVolume"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCardEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePushNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"newUnassignedConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newConversationAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInConversationsAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInUnassignedConversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskReminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTableRecordAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newCommentInAssignedTableRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newPrivateChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTeamChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importRecordsToTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportTableRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskCommentMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingDomainVerified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qpienAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptingCalls"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPhoneCalls"}},{"kind":"Field","name":{"kind":"Name","value":"isInCall"}},{"kind":"Field","name":{"kind":"Name","value":"is2FAEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasAiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"productTour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mainSkippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"boardsCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeVideoWatchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CustomerPersonsQuery, CustomerPersonsQueryVariables>;
export const ExplainAiMessageStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"explainAiMessageStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExplainAiMessageStepInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"explainAiMessageStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ExplainAiMessageStepQuery, ExplainAiMessageStepQueryVariables>;
export const FindAllPlatformQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAllPlatformQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllPlatformQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"metaData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metaData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<FindAllPlatformQueryQuery, FindAllPlatformQueryQueryVariables>;
export const GetActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetActionsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"channelIds"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"collectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFieldInfo"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"requiresConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"formData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formDataUrlEncoded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseMapping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"platformAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"method"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRecords"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetActionsQuery, GetActionsQueryVariables>;
export const GetAdminAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdminAnnouncements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListChangelogInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAdminAnnouncements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendStats"}},{"kind":"Field","name":{"kind":"Name","value":"reactionCount"}},{"kind":"Field","name":{"kind":"Name","value":"reactionAvg"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"myReactionComment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAdminAnnouncementsQuery, GetAdminAnnouncementsQueryVariables>;
export const GetAiAnswerExplanationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAiAnswerExplanation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAiAnswerExplanation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"groupedIntoRunId"}},{"kind":"Field","name":{"kind":"Name","value":"engineVersion"}},{"kind":"Field","name":{"kind":"Name","value":"surface"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"agentAction"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"handoffReason"}},{"kind":"Field","name":{"kind":"Name","value":"agentNote"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGap"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeSearches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roleName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"activeSkill"}},{"kind":"Field","name":{"kind":"Name","value":"handoffDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"handedOff"}},{"kind":"Field","name":{"kind":"Name","value":"dmSent"}},{"kind":"Field","name":{"kind":"Name","value":"hasCitations"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeSourceContentId"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"subTopic"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"request"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"cited"}}]}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAiAnswerExplanationQuery, GetAiAnswerExplanationQueryVariables>;
export const GetAiEngineRoutingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAiEngineRouting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAiEngineRouting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}},{"kind":"Field","name":{"kind":"Name","value":"routing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"by"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capability"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAiEngineRoutingQuery, GetAiEngineRoutingQueryVariables>;
export const GetAiGuidanceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAiGuidanceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAiGuidanceListInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAiGuidanceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"messageTypes"}},{"kind":"Field","name":{"kind":"Name","value":"toneOfVoice"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAiGuidanceListQuery, GetAiGuidanceListQueryVariables>;
export const GetAiHelpArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAiHelpArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAiHelpArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"related"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDate"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"panelPath"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"chunkCount"}},{"kind":"Field","name":{"kind":"Name","value":"indexedAt"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"useCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAiHelpArticlesQuery, GetAiHelpArticlesQueryVariables>;
export const GetAiHelpGapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAiHelpGaps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpGapsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAiHelpGaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"article"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAiHelpGapsQuery, GetAiHelpGapsQueryVariables>;
export const GetAiProductImageIndexesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAiProductImageIndexes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAiProductImageIndexes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"index"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}},{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"indexed"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"failed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listings"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"lastIndexedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedAt"}},{"kind":"Field","name":{"kind":"Name","value":"shops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"indexed"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"failed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"images"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexedImages"}},{"kind":"Field","name":{"kind":"Name","value":"queryImages"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCostUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last30Days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexedImages"}},{"kind":"Field","name":{"kind":"Name","value":"queryImages"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCostUsd"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAiProductImageIndexesQuery, GetAiProductImageIndexesQueryVariables>;
export const GetAiProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAiProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AiRoleEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAiProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"storeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationStore"}},{"kind":"Field","name":{"kind":"Name","value":"shoppingAssistant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendSimilarProducts"}},{"kind":"Field","name":{"kind":"Name","value":"productFaqs"}},{"kind":"Field","name":{"kind":"Name","value":"promoteProducts"}},{"kind":"Field","name":{"kind":"Name","value":"takeOrders"}},{"kind":"Field","name":{"kind":"Name","value":"collectAddress"}},{"kind":"Field","name":{"kind":"Name","value":"cashOnDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"cardOnDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"bankTransfer"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"accountHolder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancelOrders"}},{"kind":"Field","name":{"kind":"Name","value":"updateOrders"}},{"kind":"Field","name":{"kind":"Name","value":"returnOrders"}},{"kind":"Field","name":{"kind":"Name","value":"addToCart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productFaqDesign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showIcons"}},{"kind":"Field","name":{"kind":"Name","value":"iconColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"fontWeight"}},{"kind":"Field","name":{"kind":"Name","value":"borderColor"}},{"kind":"Field","name":{"kind":"Name","value":"borderWidth"}},{"kind":"Field","name":{"kind":"Name","value":"borderRadius"}},{"kind":"Field","name":{"kind":"Name","value":"fontFamily"}},{"kind":"Field","name":{"kind":"Name","value":"answerLength"}}]}},{"kind":"Field","name":{"kind":"Name","value":"useProductImagesForRag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSelectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"persona"}},{"kind":"Field","name":{"kind":"Name","value":"toneOfVoice"}},{"kind":"Field","name":{"kind":"Name","value":"useEmoji"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"chatSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"aiIntroducesItself"}},{"kind":"Field","name":{"kind":"Name","value":"aiReplyButtons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiHelped"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isButtonEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionValue"}},{"kind":"Field","name":{"kind":"Name","value":"actionMessage"}},{"kind":"Field","name":{"kind":"Name","value":"addClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"addClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"sendSurvey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"humanSupport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isButtonEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionValue"}},{"kind":"Field","name":{"kind":"Name","value":"actionMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiAutoClose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitTimeInSecond"}},{"kind":"Field","name":{"kind":"Name","value":"actionMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiFollowUp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"waitTimeInSecond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"humanHandoff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"aiIntroducesItself"}},{"kind":"Field","name":{"kind":"Name","value":"aiAutoClose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitTimeInSecond"}},{"kind":"Field","name":{"kind":"Name","value":"actionMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiFollowUp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"waitTimeInSecond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commentSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"replyToComment"}},{"kind":"Field","name":{"kind":"Name","value":"sendPrivateReply"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"aiAutoClose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitTimeInSecond"}},{"kind":"Field","name":{"kind":"Name","value":"actionMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiFollowUp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"waitTimeInSecond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketPlaceSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"replyMode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"answerLength"}},{"kind":"Field","name":{"kind":"Name","value":"useMacrosAsKnowledgeSource"}},{"kind":"Field","name":{"kind":"Name","value":"learnFromHumanReplies"}},{"kind":"Field","name":{"kind":"Name","value":"humanReplyLearningJobId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAiProfileQuery, GetAiProfileQueryVariables>;
export const GetAllAiKnowledgeSourceContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllAiKnowledgeSourceContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAiKnowledgeSourceContentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllAiKnowledgeSourceContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"aiProfile"}},{"kind":"Field","name":{"kind":"Name","value":"aiKnowledgeSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"chunkNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeScope"}},{"kind":"Field","name":{"kind":"Name","value":"scopeType"}},{"kind":"Field","name":{"kind":"Name","value":"scopeRef"}},{"kind":"Field","name":{"kind":"Name","value":"questionHash"}},{"kind":"Field","name":{"kind":"Name","value":"contentHash"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"failedReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAllAiKnowledgeSourceContentQuery, GetAllAiKnowledgeSourceContentQueryVariables>;
export const GetAllAiKnowledgeSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllAiKnowledgeSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAiKnowledgeSourceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllAiKnowledgeSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"aiProfile"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"chunkNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"isSinglePage"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"failedReason"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAllAiKnowledgeSourcesQuery, GetAllAiKnowledgeSourcesQueryVariables>;
export const GetAllConnectedPlatformDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllConnectedPlatform"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllConnectedPlatform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginTime"}},{"kind":"Field","name":{"kind":"Name","value":"statusAwayTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvLimit"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvCount"}},{"kind":"Field","name":{"kind":"Name","value":"signedTeams"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSound"}},{"kind":"Field","name":{"kind":"Name","value":"messageSound"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSoundVolume"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCardEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePushNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"newUnassignedConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newConversationAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInConversationsAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInUnassignedConversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskReminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTableRecordAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newCommentInAssignedTableRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newPrivateChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTeamChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importRecordsToTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportTableRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskCommentMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingDomainVerified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qpienAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptingCalls"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPhoneCalls"}},{"kind":"Field","name":{"kind":"Name","value":"isInCall"}},{"kind":"Field","name":{"kind":"Name","value":"is2FAEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasAiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"productTour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mainSkippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"boardsCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeVideoWatchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAllConnectedPlatformQuery, GetAllConnectedPlatformQueryVariables>;
export const GetAnnouncementCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAnnouncementCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAnnouncementCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetAnnouncementCategoriesQuery, GetAnnouncementCategoriesQueryVariables>;
export const GetCallAdminLogDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCallAdminLogDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callSid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCallAdminLogDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callSid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callSid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"callSid"}},{"kind":"Field","name":{"kind":"Name","value":"parentCallSid"}},{"kind":"Field","name":{"kind":"Name","value":"childCallSids"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"platformId"}},{"kind":"Field","name":{"kind":"Name","value":"callType"}},{"kind":"Field","name":{"kind":"Name","value":"callerCPersonId"}},{"kind":"Field","name":{"kind":"Name","value":"calleeCPersonId"}},{"kind":"Field","name":{"kind":"Name","value":"callerName"}},{"kind":"Field","name":{"kind":"Name","value":"calleeName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"callerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"totalDuration"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCallAdminLogDetailQuery, GetCallAdminLogDetailQueryVariables>;
export const GetCallAdminLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCallAdminLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCallAdminLogsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCallAdminLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"callSid"}},{"kind":"Field","name":{"kind":"Name","value":"parentCallSid"}},{"kind":"Field","name":{"kind":"Name","value":"childCallSids"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"platformId"}},{"kind":"Field","name":{"kind":"Name","value":"callType"}},{"kind":"Field","name":{"kind":"Name","value":"callerCPersonId"}},{"kind":"Field","name":{"kind":"Name","value":"calleeCPersonId"}},{"kind":"Field","name":{"kind":"Name","value":"callerName"}},{"kind":"Field","name":{"kind":"Name","value":"calleeName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"callerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"totalDuration"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCallAdminLogsQuery, GetCallAdminLogsQueryVariables>;
export const GetChangelogDeliveriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangelogDeliveries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListDeliveriesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChangelogDeliveries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"announcement"}},{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"readAt"}},{"kind":"Field","name":{"kind":"Name","value":"reaction"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetChangelogDeliveriesQuery, GetChangelogDeliveriesQueryVariables>;
export const GetChangelogSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangelogSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChangelogSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"supportedLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTimezone"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmail"}},{"kind":"Field","name":{"kind":"Name","value":"senderWhatsapp"}},{"kind":"Field","name":{"kind":"Name","value":"senderCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAudience"}},{"kind":"Field","name":{"kind":"Name","value":"includeInactiveCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"includeArchivedPersons"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetChangelogSettingsQuery, GetChangelogSettingsQueryVariables>;
export const GetChangelogSubscribersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangelogSubscribers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListChangelogSubscribersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChangelogSubscribers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetChangelogSubscribersQuery, GetChangelogSubscribersQueryVariables>;
export const GetChangelogWhatsAppAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangelogWhatsAppAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChangelogWhatsAppAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetChangelogWhatsAppAccountsQuery, GetChangelogWhatsAppAccountsQueryVariables>;
export const GetChangelogWhatsAppTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangelogWhatsAppTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangelogWhatsAppTemplatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChangelogWhatsAppTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetChangelogWhatsAppTemplatesQuery, GetChangelogWhatsAppTemplatesQueryVariables>;
export const GetCustomerBillingAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerBillingAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerBillingAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"accountingContactId"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"isCompany"}},{"kind":"Field","name":{"kind":"Name","value":"legalCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"taxOffice"}},{"kind":"Field","name":{"kind":"Name","value":"taxNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCustomerBillingAddressesQuery, GetCustomerBillingAddressesQueryVariables>;
export const GetCustomerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"autoAssignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerFromChannel"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isANewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"isDummy"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"appStatus"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"allowConnect"}},{"kind":"Field","name":{"kind":"Name","value":"is2FARequired"}},{"kind":"Field","name":{"kind":"Name","value":"teamGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamOnlineGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamFirstResponseGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"sendAutoSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"closingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"tagRule"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoFillWithAi"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listValues"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentField"}},{"kind":"Field","name":{"kind":"Name","value":"parentValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToUsers"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cPersonsAutoAwayTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoApproveSharingRequests"}},{"kind":"Field","name":{"kind":"Name","value":"canManageOtherUserConversation"}},{"kind":"Field","name":{"kind":"Name","value":"allowUnassignedTicket"}},{"kind":"Field","name":{"kind":"Name","value":"twSubAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySid"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConnected"}},{"kind":"Field","name":{"kind":"Name","value":"teamInvited"}},{"kind":"Field","name":{"kind":"Name","value":"accountCustomized"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentTrained"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"introVideoWatched"}},{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerCode"}},{"kind":"Field","name":{"kind":"Name","value":"signUpMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>;
export const GetCustomerInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCustomerInvoicesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"autoAssignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerFromChannel"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isANewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"isDummy"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"appStatus"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"allowConnect"}},{"kind":"Field","name":{"kind":"Name","value":"is2FARequired"}},{"kind":"Field","name":{"kind":"Name","value":"teamGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamOnlineGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamFirstResponseGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"sendAutoSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"closingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"tagRule"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoFillWithAi"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listValues"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentField"}},{"kind":"Field","name":{"kind":"Name","value":"parentValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToUsers"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cPersonsAutoAwayTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoApproveSharingRequests"}},{"kind":"Field","name":{"kind":"Name","value":"canManageOtherUserConversation"}},{"kind":"Field","name":{"kind":"Name","value":"allowUnassignedTicket"}},{"kind":"Field","name":{"kind":"Name","value":"twSubAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySid"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConnected"}},{"kind":"Field","name":{"kind":"Name","value":"teamInvited"}},{"kind":"Field","name":{"kind":"Name","value":"accountCustomized"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentTrained"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"introVideoWatched"}},{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerCode"}},{"kind":"Field","name":{"kind":"Name","value":"signUpMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"accountingInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"accountingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRecords"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCustomerInvoicesQuery, GetCustomerInvoicesQueryVariables>;
export const GetCustomerOnboardingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerOnboardingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerOnboardingInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyWebsite"}},{"kind":"Field","name":{"kind":"Name","value":"howBuiltWebsite"}},{"kind":"Field","name":{"kind":"Name","value":"companySize"}},{"kind":"Field","name":{"kind":"Name","value":"companyIndustry"}},{"kind":"Field","name":{"kind":"Name","value":"ownerRole"}},{"kind":"Field","name":{"kind":"Name","value":"favouriteProducts"}},{"kind":"Field","name":{"kind":"Name","value":"howYouHearAboutUs"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"sectorOther"}},{"kind":"Field","name":{"kind":"Name","value":"teamSize"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"platformOther"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceOther"}},{"kind":"Field","name":{"kind":"Name","value":"aiInterest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCustomerOnboardingInfoQuery, GetCustomerOnboardingInfoQueryVariables>;
export const GetCustomerOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEmailVerified"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"appStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"isEmailVerified"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEmailVerified"}}},{"kind":"Argument","name":{"kind":"Name","value":"packageName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageName"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginTime"}},{"kind":"Field","name":{"kind":"Name","value":"statusAwayTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvLimit"}},{"kind":"Field","name":{"kind":"Name","value":"joinedConvCount"}},{"kind":"Field","name":{"kind":"Name","value":"signedTeams"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSound"}},{"kind":"Field","name":{"kind":"Name","value":"messageSound"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSoundVolume"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCardEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePushNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"newUnassignedConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newConversationAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInConversationsAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newMessagesInUnassignedConversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskReminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTableRecordAssignedToMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newCommentInAssignedTableRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newPrivateChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTeamChatMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importRecordsToTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportTableRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"importContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskCommentMention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingDomainVerified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exportReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sound"}},{"kind":"Field","name":{"kind":"Name","value":"loopScope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qpienAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptingCalls"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPhoneCalls"}},{"kind":"Field","name":{"kind":"Name","value":"isInCall"}},{"kind":"Field","name":{"kind":"Name","value":"is2FAEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasAiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"productTour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mainSkippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"boardsCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeVideoWatchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"autoAssignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoConversationAssignmentTimeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerFromChannel"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"feeCharged"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"periodMode"}},{"kind":"Field","name":{"kind":"Name","value":"periodCount"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"refreshDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialExpiringDate"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"maxRedemptions"}},{"kind":"Field","name":{"kind":"Name","value":"timesRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"usageType"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBalance"}},{"kind":"Field","name":{"kind":"Name","value":"addOns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"renewalType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"nextCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentFromOtherChannel"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsForm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"aiHumanReplyLearning"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reChargeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isANewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"isDummy"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountConfirmation"}},{"kind":"Field","name":{"kind":"Name","value":"appStatus"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"allowConnect"}},{"kind":"Field","name":{"kind":"Name","value":"is2FARequired"}},{"kind":"Field","name":{"kind":"Name","value":"teamGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamOnlineGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"teamFirstResponseGoalTime"}},{"kind":"Field","name":{"kind":"Name","value":"sendAutoSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"closingMessage"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"tagRule"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoFillWithAi"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listValues"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentField"}},{"kind":"Field","name":{"kind":"Name","value":"parentValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToUsers"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cPersonsAutoAwayTime"}},{"kind":"Field","name":{"kind":"Name","value":"autoApproveSharingRequests"}},{"kind":"Field","name":{"kind":"Name","value":"canManageOtherUserConversation"}},{"kind":"Field","name":{"kind":"Name","value":"allowUnassignedTicket"}},{"kind":"Field","name":{"kind":"Name","value":"twSubAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySid"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeySecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelConnected"}},{"kind":"Field","name":{"kind":"Name","value":"teamInvited"}},{"kind":"Field","name":{"kind":"Name","value":"accountCustomized"}},{"kind":"Field","name":{"kind":"Name","value":"aiAgentTrained"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"introVideoWatched"}},{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerCode"}},{"kind":"Field","name":{"kind":"Name","value":"signUpMethod"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCustomerOwnersQuery, GetCustomerOwnersQueryVariables>;
export const GetCustomerPaymentCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerPaymentCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerPaymentCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"cardAlias"}},{"kind":"Field","name":{"kind":"Name","value":"cardBankName"}},{"kind":"Field","name":{"kind":"Name","value":"lastFourDigits"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"cardAssociation"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"cvc"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"systemTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"requiresAction"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSHtmlContent"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSPaymentPageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"threeDSConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetCustomerPaymentCardQuery, GetCustomerPaymentCardQueryVariables>;
export const GetEmailAdminLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmailAdminLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailAdminLogsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmailAdminLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"replyTo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"templateData"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transportMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"providerStatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorStack"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetEmailAdminLogsQuery, GetEmailAdminLogsQueryVariables>;
export const GetHumanReplyLearningJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHumanReplyLearningJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHumanReplyLearningJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"totalConversations"}},{"kind":"Field","name":{"kind":"Name","value":"processedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"skippedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"failedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"remainingConversations"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}},{"kind":"Field","name":{"kind":"Name","value":"extractedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"savedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"duplicatePairs"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflictPairs"}},{"kind":"Field","name":{"kind":"Name","value":"totalInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalOutputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalEstimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"modelsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"usageByModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"failures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflicts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"existingAiKnowledgeSourceContentId"}},{"kind":"Field","name":{"kind":"Name","value":"newQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"newAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"existingQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"existingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitResumeAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitRetryCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"countedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetHumanReplyLearningJobQuery, GetHumanReplyLearningJobQueryVariables>;
export const GetHumanReplyLearningJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHumanReplyLearningJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHumanReplyLearningJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"totalConversations"}},{"kind":"Field","name":{"kind":"Name","value":"processedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"skippedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"failedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"remainingConversations"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}},{"kind":"Field","name":{"kind":"Name","value":"extractedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"savedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"duplicatePairs"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflictPairs"}},{"kind":"Field","name":{"kind":"Name","value":"totalInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalOutputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalEstimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"modelsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"usageByModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"failures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflicts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"existingAiKnowledgeSourceContentId"}},{"kind":"Field","name":{"kind":"Name","value":"newQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"newAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"existingQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"existingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitResumeAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitRetryCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"countedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetHumanReplyLearningJobsQuery, GetHumanReplyLearningJobsQueryVariables>;
export const GetHumanReplyLearningStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHumanReplyLearningStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHumanReplyLearningStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"totalConversations"}},{"kind":"Field","name":{"kind":"Name","value":"processedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"skippedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"failedConversations"}},{"kind":"Field","name":{"kind":"Name","value":"remainingConversations"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}},{"kind":"Field","name":{"kind":"Name","value":"extractedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"savedPairs"}},{"kind":"Field","name":{"kind":"Name","value":"duplicatePairs"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflictPairs"}},{"kind":"Field","name":{"kind":"Name","value":"totalInputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalOutputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalEstimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"modelsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"usageByModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"requests"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"failures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedConflicts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"existingAiKnowledgeSourceContentId"}},{"kind":"Field","name":{"kind":"Name","value":"newQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"newAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"existingQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"existingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitResumeAt"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimitRetryCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"countedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetHumanReplyLearningStatusQuery, GetHumanReplyLearningStatusQueryVariables>;
export const GetLiveChatWidgetOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLiveChatWidgetOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLiveChatWidgetOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"distributionId"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"cacheControl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"lastModified"}},{"kind":"Field","name":{"kind":"Name","value":"etag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveTotalBytes"}},{"kind":"Field","name":{"kind":"Name","value":"activeRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"restoredFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"archivePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"distributionId"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removedKeys"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationId"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckUrl"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckStatus"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetLiveChatWidgetOverviewQuery, GetLiveChatWidgetOverviewQueryVariables>;
export const GetLiveChatWidgetReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLiveChatWidgetRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLiveChatWidgetRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"releaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"restoredFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"archivePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"distributionId"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removedKeys"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationId"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckUrl"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckStatus"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetLiveChatWidgetReleaseQuery, GetLiveChatWidgetReleaseQueryVariables>;
export const GetLiveChatWidgetReleasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLiveChatWidgetReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLiveChatWidgetReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"restoredFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"archivePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"distributionId"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removedKeys"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationId"}},{"kind":"Field","name":{"kind":"Name","value":"invalidationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckUrl"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckStatus"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetLiveChatWidgetReleasesQuery, GetLiveChatWidgetReleasesQueryVariables>;
export const GetLocationCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLocationCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCountriesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationCountries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iso2"}},{"kind":"Field","name":{"kind":"Name","value":"native"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kr"}},{"kind":"Field","name":{"kind":"Name","value":"pt_BR"}},{"kind":"Field","name":{"kind":"Name","value":"pt"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"hr"}},{"kind":"Field","name":{"kind":"Name","value":"fa"}},{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"ja"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"tr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"hasState"}},{"kind":"Field","name":{"kind":"Name","value":"hasProvince"}},{"kind":"Field","name":{"kind":"Name","value":"hasCity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetLocationCountriesQuery, GetLocationCountriesQueryVariables>;
export const GetLocationStatesProvincesCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLocationStatesProvincesCities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetStatesProvincesCitiesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationStatesProvincesCities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iso2"}},{"kind":"Field","name":{"kind":"Name","value":"native"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kr"}},{"kind":"Field","name":{"kind":"Name","value":"pt_BR"}},{"kind":"Field","name":{"kind":"Name","value":"pt"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"hr"}},{"kind":"Field","name":{"kind":"Name","value":"fa"}},{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"ja"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"tr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"hasState"}},{"kind":"Field","name":{"kind":"Name","value":"hasProvince"}},{"kind":"Field","name":{"kind":"Name","value":"hasCity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetLocationStatesProvincesCitiesQuery, GetLocationStatesProvincesCitiesQueryVariables>;
export const GetMarketplaceOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMarketplaceOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetMarketplaceOrdersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMarketplaceOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"marketplace"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"checkoutStatus"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"createdTime"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street1"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateOrProvince"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingCareer"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTotal"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"site"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancelStatus"}},{"kind":"Field","name":{"kind":"Name","value":"returnStatus"}},{"kind":"Field","name":{"kind":"Name","value":"refundStatus"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMarketplaceOrdersQuery, GetMarketplaceOrdersQueryVariables>;
export const GetMessageForAiSimulationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMessageForAiSimulation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMessageForAiSimulation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"commentData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reaction"}},{"kind":"Field","name":{"kind":"Name","value":"reply"}},{"kind":"Field","name":{"kind":"Name","value":"repliedCPerson"}},{"kind":"Field","name":{"kind":"Name","value":"replyDate"}},{"kind":"Field","name":{"kind":"Name","value":"aiNotResponseReason"}},{"kind":"Field","name":{"kind":"Name","value":"privateReply"}},{"kind":"Field","name":{"kind":"Name","value":"privateReplyId"}},{"kind":"Field","name":{"kind":"Name","value":"privateReplyAiNotResponseReason"}},{"kind":"Field","name":{"kind":"Name","value":"postUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postDescription"}},{"kind":"Field","name":{"kind":"Name","value":"parentComment"}},{"kind":"Field","name":{"kind":"Name","value":"parentCommentId"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"replyState"}},{"kind":"Field","name":{"kind":"Name","value":"policyViolation"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"temporaryReply"}},{"kind":"Field","name":{"kind":"Name","value":"externalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"reviewUpdateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reply"}},{"kind":"Field","name":{"kind":"Name","value":"repliedCPerson"}},{"kind":"Field","name":{"kind":"Name","value":"replyDate"}},{"kind":"Field","name":{"kind":"Name","value":"productUrl"}},{"kind":"Field","name":{"kind":"Name","value":"productImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productMainId"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"isRepliedOnPlatform"}},{"kind":"Field","name":{"kind":"Name","value":"temporaryReply"}},{"kind":"Field","name":{"kind":"Name","value":"aiNotResponseReason"}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"repliedCPerson"}},{"kind":"Field","name":{"kind":"Name","value":"replyDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"failedReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"attempt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRobot"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"previousMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"isAiGenerated"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMessageForAiSimulationQuery, GetMessageForAiSimulationQueryVariables>;
export const GetMigrationHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMigrationHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"oneTimesType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMigrationHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"succeeded"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"heartbeatAt"}},{"kind":"Field","name":{"kind":"Name","value":"countsBefore"}},{"kind":"Field","name":{"kind":"Name","value":"countsAfter"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMigrationHistoryQuery, GetMigrationHistoryQueryVariables>;
export const GetMigrationLatestRunsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMigrationLatestRuns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMigrationLatestRuns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"succeeded"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"heartbeatAt"}},{"kind":"Field","name":{"kind":"Name","value":"countsBefore"}},{"kind":"Field","name":{"kind":"Name","value":"countsAfter"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMigrationLatestRunsQuery, GetMigrationLatestRunsQueryVariables>;
export const GetMobileAppVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMobileAppVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetMobileAppVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMobileAppVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"latestVersion"}},{"kind":"Field","name":{"kind":"Name","value":"minSupportedVersion"}},{"kind":"Field","name":{"kind":"Name","value":"updateType"}},{"kind":"Field","name":{"kind":"Name","value":"storeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"releaseNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMobileAppVersionQuery, GetMobileAppVersionQueryVariables>;
export const GetMobileAppVersionConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMobileAppVersionConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMobileAppVersionConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"latestVersion"}},{"kind":"Field","name":{"kind":"Name","value":"minSupportedVersion"}},{"kind":"Field","name":{"kind":"Name","value":"updateType"}},{"kind":"Field","name":{"kind":"Name","value":"storeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"releaseNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMobileAppVersionConfigsQuery, GetMobileAppVersionConfigsQueryVariables>;
export const GetNewPackageCostInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNewPackageCostInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"newPackCostInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNewPackageCostInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeCharge"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"remindCost"}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialLeftDays"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistantCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetNewPackageCostInfoQuery, GetNewPackageCostInfoQueryVariables>;
export const GetPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireAccountApproval"}},{"kind":"Field","name":{"kind":"Name","value":"autoFormalizeInvoices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetPreferenceQuery, GetPreferenceQueryVariables>;
export const GetReembedKnowledgeSourcesToContextualRagJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReembedKnowledgeSourcesToContextualRagJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReembedKnowledgeSourcesToContextualRagJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"allCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"targetCustomerIds"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"completedCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"failedCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"processedKnowledgeSources"}},{"kind":"Field","name":{"kind":"Name","value":"processedContents"}},{"kind":"Field","name":{"kind":"Name","value":"reembeddedContents"}},{"kind":"Field","name":{"kind":"Name","value":"skippedContents"}},{"kind":"Field","name":{"kind":"Name","value":"failedContents"}},{"kind":"Field","name":{"kind":"Name","value":"currentCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"completedCustomerIds"}},{"kind":"Field","name":{"kind":"Name","value":"failedCustomerIds"}},{"kind":"Field","name":{"kind":"Name","value":"failures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"aiKnowledgeSourceId"}},{"kind":"Field","name":{"kind":"Name","value":"aiKnowledgeSourceContentId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetReembedKnowledgeSourcesToContextualRagJobQuery, GetReembedKnowledgeSourcesToContextualRagJobQueryVariables>;
export const GetUpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUpdateNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUpdateNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetUpdateNotificationQuery, GetUpdateNotificationQueryVariables>;
export const InspectCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inspectCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inspectCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"}},{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indexes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"unique"}}]}},{"kind":"Field","name":{"kind":"Name","value":"samples"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InspectCollectionQuery, InspectCollectionQueryVariables>;
export const ListAiConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAiConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListInfiniteParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAiConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"answerId"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"productCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"optionsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"productUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productLink"}},{"kind":"Field","name":{"kind":"Name","value":"productImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"isTest"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputToken"}},{"kind":"Field","name":{"kind":"Name","value":"cachedInputToken"}},{"kind":"Field","name":{"kind":"Name","value":"outputToken"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"llmCalls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failedStepCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ListAiConversationsQuery, ListAiConversationsQueryVariables>;
export const ListAiMessageStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAiMessageSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aiMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAiMessageSteps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aiMessageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aiMessageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"answerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"aiMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"stepList"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"request"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ListAiMessageStepsQuery, ListAiMessageStepsQueryVariables>;
export const ListAiMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAiMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListInfiniteParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAiMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"answerId"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"productCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"optionsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"productUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productLink"}},{"kind":"Field","name":{"kind":"Name","value":"productImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"isTest"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputToken"}},{"kind":"Field","name":{"kind":"Name","value":"cachedInputToken"}},{"kind":"Field","name":{"kind":"Name","value":"outputToken"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"llmCalls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failedStepCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalDocs"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ListAiMessagesQuery, ListAiMessagesQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cPerson"}},{"kind":"Field","name":{"kind":"Name","value":"cPersonRoles"}},{"kind":"Field","name":{"kind":"Name","value":"person"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"whatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"metaWhatsAppBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"trendyol"}},{"kind":"Field","name":{"kind":"Name","value":"amazon"}},{"kind":"Field","name":{"kind":"Name","value":"hepsiburada"}},{"kind":"Field","name":{"kind":"Name","value":"ebay"}},{"kind":"Field","name":{"kind":"Name","value":"kaufland"}},{"kind":"Field","name":{"kind":"Name","value":"pazarama"}},{"kind":"Field","name":{"kind":"Name","value":"walmart"}},{"kind":"Field","name":{"kind":"Name","value":"n11"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"webhooks"}},{"kind":"Field","name":{"kind":"Name","value":"inboxRules"}},{"kind":"Field","name":{"kind":"Name","value":"flowBots"}},{"kind":"Field","name":{"kind":"Name","value":"survey"}},{"kind":"Field","name":{"kind":"Name","value":"liveChat"}},{"kind":"Field","name":{"kind":"Name","value":"customChannel"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"zoho"}},{"kind":"Field","name":{"kind":"Name","value":"callMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}},{"kind":"Field","name":{"kind":"Name","value":"qpienShop"}},{"kind":"Field","name":{"kind":"Name","value":"ikas"}},{"kind":"Field","name":{"kind":"Name","value":"faprika"}},{"kind":"Field","name":{"kind":"Name","value":"ticimax"}},{"kind":"Field","name":{"kind":"Name","value":"tsoft"}},{"kind":"Field","name":{"kind":"Name","value":"ideasoft"}},{"kind":"Field","name":{"kind":"Name","value":"shopify"}},{"kind":"Field","name":{"kind":"Name","value":"googleBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"slaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"tableRecords"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"operatorCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"inbox"}},{"kind":"Field","name":{"kind":"Name","value":"inboxPrivateMessage"}},{"kind":"Field","name":{"kind":"Name","value":"inboxBulkActions"}},{"kind":"Field","name":{"kind":"Name","value":"inboxCustomViews"}},{"kind":"Field","name":{"kind":"Name","value":"inboxMessageTranslation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsDynamicGroups"}},{"kind":"Field","name":{"kind":"Name","value":"contactsMergeContacts"}},{"kind":"Field","name":{"kind":"Name","value":"contactsImport"}},{"kind":"Field","name":{"kind":"Name","value":"contactsExport"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversations"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsMessages"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsSatisfactions"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsAbandonedCarts"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsCampaign"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUsers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUserRoles"}},{"kind":"Field","name":{"kind":"Name","value":"settingsActions"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAuthentications"}},{"kind":"Field","name":{"kind":"Name","value":"settingsApiKeys"}},{"kind":"Field","name":{"kind":"Name","value":"settingsWebhooks"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeams"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTags"}},{"kind":"Field","name":{"kind":"Name","value":"settingsQuickAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"settingsAutoAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTeamGoals"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSlaPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopics"}},{"kind":"Field","name":{"kind":"Name","value":"settingsTopicsAutoFill"}},{"kind":"Field","name":{"kind":"Name","value":"settingsCustomFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingsSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChat"}},{"kind":"Field","name":{"kind":"Name","value":"channelsCustomChannel"}},{"kind":"Field","name":{"kind":"Name","value":"channelsLiveChatRemoveQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channelsSms"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhone"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppWeb"}},{"kind":"Field","name":{"kind":"Name","value":"channelsWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMetaWhatsAppBusinessApi"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTelegram"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsFacebookComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInstagramComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokDm"}},{"kind":"Field","name":{"kind":"Name","value":"channelsTiktokComment"}},{"kind":"Field","name":{"kind":"Name","value":"channelsMarketplace"}},{"kind":"Field","name":{"kind":"Name","value":"campaignEngineV2"}},{"kind":"Field","name":{"kind":"Name","value":"automation"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBots"}},{"kind":"Field","name":{"kind":"Name","value":"teamChat"}},{"kind":"Field","name":{"kind":"Name","value":"automationEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsHttpRequest"}},{"kind":"Field","name":{"kind":"Name","value":"automationFlowBotsStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEcommerce"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallRecord"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneInboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneOutboundCalls"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneTestToSpeech"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhonelVR"}},{"kind":"Field","name":{"kind":"Name","value":"statisticsConversationTags"}},{"kind":"Field","name":{"kind":"Name","value":"ai"}},{"kind":"Field","name":{"kind":"Name","value":"aiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"AiAgent"}},{"kind":"Field","name":{"kind":"Name","value":"AiAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingTag"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingNote"}},{"kind":"Field","name":{"kind":"Name","value":"AiClosingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"AiStartFlow"}},{"kind":"Field","name":{"kind":"Name","value":"AiStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"aiImageRecognition"}},{"kind":"Field","name":{"kind":"Name","value":"bulkSharing"}},{"kind":"Field","name":{"kind":"Name","value":"zohoIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"collageSharing"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"snooze"}},{"kind":"Field","name":{"kind":"Name","value":"messageSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallTranscripts"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPhoneCallAiAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"removeEmailQpienLogo"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"customReports"}},{"kind":"Field","name":{"kind":"Name","value":"channelOwner"}},{"kind":"Field","name":{"kind":"Name","value":"userActivity"}},{"kind":"Field","name":{"kind":"Name","value":"autoAway"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const SearchAiHelpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchAiHelp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiHelpSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAiHelp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"panelPath"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"contentId"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SearchAiHelpQuery, SearchAiHelpQueryVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const CreatedAiMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"createdAiMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiMessageSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAiMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"answerId"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"productCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"optionsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"productUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productLink"}},{"kind":"Field","name":{"kind":"Name","value":"productImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"isTest"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputToken"}},{"kind":"Field","name":{"kind":"Name","value":"cachedInputToken"}},{"kind":"Field","name":{"kind":"Name","value":"outputToken"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"llmCalls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failedStepCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreatedAiMessageSubscription, CreatedAiMessageSubscriptionVariables>;
export const UpdatedAiMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"updatedAiMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiMessageSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedAiMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"answerId"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"productCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"optionsSummary"}},{"kind":"Field","name":{"kind":"Name","value":"productUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productLink"}},{"kind":"Field","name":{"kind":"Name","value":"productImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postUrl"}},{"kind":"Field","name":{"kind":"Name","value":"postImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"isTest"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputToken"}},{"kind":"Field","name":{"kind":"Name","value":"cachedInputToken"}},{"kind":"Field","name":{"kind":"Name","value":"outputToken"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"llmCalls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failedStepCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdatedAiMessageSubscription, UpdatedAiMessageSubscriptionVariables>;